import { toSvg } from 'jdenticon';
import { markRaw, resolveComponent, openBlock, createElementBlock, createVNode, normalizeClass, withCtx, createBlock, createCommentVNode, createTextVNode, toDisplayString, createElementVNode, Fragment, renderList, resolveDirective, mergeProps, withDirectives, withModifiers, vShow, resolveDynamicComponent, renderSlot, normalizeStyle, watch, onScopeDispose, effectScope, reactive, computed, watchEffect, toRefs, capitalize, isVNode, Comment, shallowRef, unref, warn, getCurrentInstance as getCurrentInstance$1, ref, provide, inject as inject$2, defineComponent as defineComponent$1, camelize, h, toRaw, onBeforeUnmount, readonly, onDeactivated, onActivated, onMounted, nextTick, createSlots, toHandlers, createApp, TransitionGroup, Transition, isRef, toRef, onBeforeMount, onUpdated, Text as Text$1, Teleport, cloneVNode, onBeforeUpdate, vModelText, render as render$1c, defineAsyncComponent, onUnmounted, withKeys, normalizeProps } from 'vue';
import { mdiHelp, mdiFileExcelOutline, mdiFileWordOutline, mdiFilePdfBox, mdiVideoOutline, mdiMusic, mdiImageOutline, mdiFileDocumentOutline, mdiImageBroken, mdiPencil, mdiCheck, mdiMagnifyPlus, mdiOpenInNew, mdiDotsHorizontal, mdiCloudUploadOutline, mdiImageSearch, mdiDatabaseSearch, mdiDatabaseOff, mdiWeb, mdiDelete, mdiClose, mdiAlphabetical, mdiViewHeadline, mdiDrag, mdiMagnify, mdiMapMarkerRadius, mdiChevronUp, mdiChevronDown, mdiRadioboxBlank, mdiRadioboxMarked, mdiPlus, mdiContentDuplicate, mdiPlaylistEdit, mdiArrowLeft, mdiCalendar, mdiClockOutline, mdiMapClock, mdiHistory, mdiMinus, mdiAvTimer, mdiCloudDownloadOutline, mdiMultimedia, mdiFormatBold, mdiFormatItalic, mdiFormatSubscript, mdiFormatSuperscript, mdiFormatSize, mdiLink, mdiLinkOff, mdiFormatListBulleted, mdiFormatListNumbered, mdiCommentQuote, mdiTablePlus, mdiImagePlus, mdiMapPlus, mdiMenuDown, mdiCodeTags, mdiFormatAlignLeft, mdiFormatAlignCenter, mdiFormatAlignRight, mdiTableColumn, mdiTableColumnPlusAfter, mdiTableColumnPlusBefore, mdiTableColumnRemove, mdiTableRowPlusAfter, mdiTableRowPlusBefore, mdiTableRowRemove, mdiTableRow, mdiTableRemove, mdiButtonCursor, mdiImage, mdiCrop, mdiImageFilterCenterFocus, mdiTarget, mdiCheckBold, mdiCloudUpload, mdiMenuRight, mdiHome, mdiFileLink, mdiFileOutline, mdiGhostOutline, mdiCursorDefaultClick, mdiTextBoxPlusOutline, mdiTextBoxMultiple, mdiFilterRemove, mdiTextBoxSearch, mdiAlert, mdiUndo, mdiRedo, mdiContentSave, mdiStopCircle, mdiCloudCheck, mdiTagMultiple, mdiSelectAll, mdiSelectOff, mdiFileImageOutline, mdiViewGrid, mdiViewList, mdiCropFree, mdiCloudDownload, mdiShieldPlus, mdiAlertCircleOutline, mdiShieldCheck, mdiCancel, mdiEyeOutline, mdiPlusCircleOutline, mdiFolderImage, mdiFileTree, mdiShieldAccount, mdiShieldOutline, mdiAccountMinus, mdiAccountPlus, mdiAccountPlusOutline, mdiAccountOutline, mdiFileTreeOutline, mdiCog, mdiMenu, mdiFolderMultipleImage, mdiPoll, mdiLogout } from '@mdi/js';
import queryString from 'query-string';
import slugify from 'slugify';
import { _ } from '@swc/helpers/_/_ts_decorate';
import { _ as _$1 } from '@swc/helpers/_/_ts_metadata';
import { Prop, Component, Vue, Watch, Model, Setup, Hook, Ref } from '@wagich/vue-facing-decorator-metadata';
import debounce$1 from 'lodash/debounce';
import ky, { HTTPError } from 'ky';
import { _ as _$2 } from '@swc/helpers/_/_ts_param';
import urljoin from 'url-join';
import { Container, injectable, inject as inject$1 } from 'inversify';
import { Log, UserManager } from 'oidc-client-ts';
import { Store, Pinia } from 'pinia-class-component';
import isError$1 from 'lodash/isError';
import mitt from 'mitt';
import { TaskQueue } from 'cwait';
import { BlockBlobClient, AnonymousCredential } from '@azure/storage-blob';
import Autolinker from 'autolinker';
import groupBy from 'lodash/groupBy';
import { VueDraggable } from 'vue-draggable-plus';
import sortBy from 'lodash/sortBy';
import isEqual$1 from 'lodash/isEqual';
import mapboxgl from 'mapbox-gl';
import jsonSchemaDefaults from '@wagich/json-schema-defaults';
import JsonSchemaParser from '@wagich/json-schema-ref-parser';
import { nanoid } from 'nanoid';
import * as Enumerable from 'linq-es2015';
import { JsonPointer } from 'json-ptr';
import * as jsonpatch from 'fast-json-patch';
import { deepClone } from 'fast-json-patch';
import truncate from 'lodash/truncate';
import Ajv from 'ajv';
import Ajv_localize_de from 'ajv-i18n/localize/de';
import scrollToWithAnimation from 'scrollto-with-animation';
import { Key } from 'ts-key-enum';
import { debounce as debounce$2, orderBy } from 'lodash';
import { DateTime, Duration } from 'luxon';
import countries from 'i18n-iso-countries';
import germanCountryNames from 'i18n-iso-countries/langs/de.json';
import { PluginKey } from '@tiptap/pm/state';
import { Editor, Node as Node$2, NodeViewWrapper, VueNodeViewRenderer, EditorContent } from '@tiptap/vue-3';
export { NodeViewWrapper, VueNodeViewRenderer } from '@tiptap/vue-3';
import History from '@tiptap/extension-history';
import BubbleMenu from '@tiptap/extension-bubble-menu';
import Document from '@tiptap/extension-document';
import Text from '@tiptap/extension-text';
import Paragraph from '@tiptap/extension-paragraph';
import Blockquote from '@tiptap/extension-blockquote';
import Bold from '@tiptap/extension-bold';
import BulletList from '@tiptap/extension-bullet-list';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import Italic from '@tiptap/extension-italic';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';
import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import Dropcursor from '@tiptap/extension-dropcursor';
import Gapcursor from '@tiptap/extension-gapcursor';
import TextAlign from '@tiptap/extension-text-align';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import { Mark, mergeAttributes, Node as Node$3 } from '@tiptap/core';
export { Extension, Mark, Node } from '@tiptap/core';
import deepequals from 'fast-deep-equal';
import { Node as Node$1 } from '@tiptap/pm/model';
import { FocusPicker } from 'image-focus';
import 'reflect-metadata';
import PortalVue from 'portal-vue';
import { RouterView, createRouter, createWebHistory } from 'vue-router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createReusableTemplate } from '@vueuse/core';
import { create, only as only$1, test, enforce } from 'vest';
import prettyBytes from 'pretty-bytes';

class IconRegistry {
    static{
        this.icons = {};
    }
    static add(icons) {
        Object.assign(this.icons, icons);
    }
    static createPlugin() {
        return {
            install: (app)=>{
                app.config.globalProperties.$icons = IconRegistry.icons;
            }
        };
    }
}

IconRegistry.add({
    mdiHelp,
    mdiFileExcelOutline,
    mdiFileWordOutline,
    mdiFilePdfBox,
    mdiVideoOutline,
    mdiMusic,
    mdiImageOutline,
    mdiFileDocumentOutline
});
const browserSupportedContentTypes = [
    "image/apng",
    "image/avif",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "video/3gpp",
    "video/3gpp2",
    "video/3gp2",
    "video/mpeg",
    "video/mp4",
    "video/ogg",
    "video/webm",
    "audio/3gpp",
    "audio/3gpp2",
    "audio/3gp2",
    "audio/aac",
    "audio/flac",
    "audio/mpeg",
    "audio/mp4",
    "audio/ogg",
    "audio/wave",
    "audio/wav",
    "audio/webm"
];
function isSchema(definition) {
    return typeof definition !== "undefined" && typeof definition !== "boolean" && !Array.isArray(definition);
}
function isSchemaArray(definition) {
    return typeof definition !== "undefined" && typeof definition !== "boolean" && Array.isArray(definition);
}
function toDictionary(source, keySelector, elementSelector) {
    const dictionary = {};
    for(let i = 0; i < source.length; i++){
        const key = keySelector(source[i], i);
        dictionary[key] = elementSelector ? elementSelector(source[i]) : source[i];
    }
    return dictionary;
}
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function notEmpty$1(value) {
    return value !== null && value !== undefined;
}
function isNullOrEmpty(value) {
    return value === null || value === undefined || value === "";
}
function nullWhenEmpty(value) {
    return isNullOrEmpty(value) ? null : value;
}
function nullWhenEmptyOrWhitespace(value) {
    return isNullOrEmpty(value?.trim()) ? null : value;
}
function selectFile() {
    return new Promise((resolve)=>{
        let input = document.createElement("input");
        input.type = "file";
        input.multiple = false;
        input.onchange = (_)=>resolve(input.files ? input.files[0] : null);
        input.click();
    });
}
function selectFiles() {
    return new Promise((resolve)=>{
        let input = document.createElement("input");
        input.type = "file";
        input.multiple = true;
        input.onchange = (_)=>resolve(input.files ? Array.from(input.files) : []);
        input.click();
    });
}
function getHeadersFromXhr(xhr) {
    if (xhr.readyState !== xhr.HEADERS_RECEIVED) {
        return new Headers();
    }
    var headerLines = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);
    var headerMap = {};
    headerLines.forEach(function(line) {
        var parts = line.split(': ');
        var header = parts.shift();
        var value = parts.join(': ');
        headerMap[header] = value;
    });
    return new Headers(headerMap);
}
function isEntityKind(str) {
    return str === EntityKind.Asset || str === EntityKind.Document;
}
function getEntityKindDisplayName(kind) {
    switch(kind){
        case EntityKind.Document:
            return "Dokument";
        case EntityKind.Asset:
            return "Asset";
        default:
            return "";
    }
}
function delay(milliseconds) {
    return new Promise((resolve)=>setTimeout(resolve, milliseconds));
}
function isImageContentType(contentType) {
    if (isNullOrEmpty(contentType)) {
        return false;
    }
    return contentType.startsWith("image/");
}
function sortByOrderedIds(items, orderedIds, idAccessor) {
    let idIndexMap = new Map(orderedIds.map((id, i)=>[
            id,
            i
        ]));
    let ordered = new Array();
    let unordered = new Array();
    items.forEach((item)=>{
        let id = idAccessor(item);
        let index = idIndexMap.get(id);
        if (index !== undefined) {
            ordered[index] = item;
        } else {
            unordered.push(item);
        }
    });
    return ordered.filter(notEmpty$1).concat(unordered);
}
function getContentTypeIcon(contentType) {
    if (contentType == null) {
        return mdiHelp;
    }
    switch(contentType){
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return mdiFileExcelOutline;
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return mdiFileWordOutline;
        case "application/pdf":
            return mdiFilePdfBox;
    }
    if (contentType.startsWith("video/")) {
        return mdiVideoOutline;
    }
    if (contentType.startsWith("audio/")) {
        return mdiMusic;
    }
    if (contentType.startsWith("image/")) {
        return mdiImageOutline;
    }
    return mdiFileDocumentOutline;
}
function getDocumentTypeIconSvg(documentType, size) {
    var svg = toSvg(documentType, size);
    return `data:image/svg+xml;base64,${window.btoa(svg)}`;
}
function getMenuIconSvg(name, size) {
    var svg = toSvg(name, size);
    return `data:image/svg+xml;base64,${window.btoa(svg)}`;
}
function parseArrayFromQuery(queryValue) {
    if (queryValue == null) {
        return [];
    }
    return Array.isArray(queryValue) ? queryValue.filter(notEmpty$1) : [
        queryValue
    ];
}
function* flattenNodes(node) {
    if (node.children != null) {
        for (let child of Object.values(node.children)){
            yield* flattenNodes(child);
        }
    }
    if (node.items != null) {
        for (let item of node.items){
            yield* flattenNodes(item);
        }
    }
    yield node;
}
function* chunk$1(items, chunkSize) {
    for(let i = 0; i < items.length; i += chunkSize){
        yield items.slice(i, i + chunkSize);
    }
}
function getSchemaTitle(schema) {
    schema = Array.isArray(schema) ? schema[0] : schema;
    return schema.title || "";
}
function getSchemaDescription(schema) {
    schema = Array.isArray(schema) ? schema[0] : schema;
    return schema.description || "";
}
function isError(maybeError) {
    return maybeError instanceof Error;
}
function isXhrSuccessStatus(httpStatusCode) {
    if (httpStatusCode == null) {
        return false;
    }
    return httpStatusCode >= 200 && httpStatusCode < 300;
}
function CreateCustomRichtextNode(type) {
    return (attrs)=>(state, dispatch)=>{
            let position = state.selection.$to.pos;
            if (state.selection.$cursor != null) {
                position = state.selection.$cursor.pos;
            }
            let node = type.create(attrs);
            let transaction = state.tr.insert(position, node);
            dispatch(transaction);
        };
}
function isObjectEditorChildExpanded(child) {
    return child.schema.format == null && child.children != null && Object.keys(child.children).length === 1;
}
function nameof(key1, key2) {
    return key2 ?? key1;
}
function NonReactive(target, propName) {
    let original = target[propName];
    Reflect.deleteProperty(target, propName);
    Reflect.defineProperty(target, propName, {
        get: ()=>original,
        set: (value)=>original = markRaw(value)
    });
}
async function sha256(text) {
    const msgUint8 = new TextEncoder().encode(text); // encode as (utf-8) Uint8Array
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join(""); // convert bytes to hex string
    return hashHex;
}

function isDocumentListItem(value) {
    return !isNullOrEmpty(value) && value.hasOwnProperty(nameof("name")) && !value.hasOwnProperty(nameof("fileName"));
}
function isDocument(value) {
    return !isNullOrEmpty(value) && value.hasOwnProperty(nameof("displayName")) && !value.hasOwnProperty(nameof("extension")) && !value.hasOwnProperty(nameof("length"));
}
/*
 * VIEWMODELS
 */ var DocumentListView = /*#__PURE__*/ function(DocumentListView) {
    DocumentListView["Search"] = "search";
    DocumentListView["Drafts"] = "drafts";
    DocumentListView["RecentlyChanged"] = "recently-changed";
    return DocumentListView;
}({});

var UploadState = /*#__PURE__*/ function(UploadState) {
    UploadState["Queued"] = "queued";
    UploadState["Uploading"] = "uploading";
    UploadState["Finished"] = "finished";
    return UploadState;
}({});
function isAsset(value) {
    return !isNullOrEmpty(value) && value.hasOwnProperty(nameof("displayName")) && value.hasOwnProperty(nameof("extension")) && value.hasOwnProperty(nameof("length"));
}
function isAssetListItem(value) {
    return !isNullOrEmpty(value) && value.hasOwnProperty(nameof("name")) && value.hasOwnProperty(nameof("fileName"));
}
/*
 * VIEWMODELS
 */ var AssetDisplayMode = /*#__PURE__*/ function(AssetDisplayMode) {
    AssetDisplayMode["Thumbnails"] = "thumbnails";
    AssetDisplayMode["Details"] = "details";
    return AssetDisplayMode;
}({});
var ThumbnailResizeMode = /*#__PURE__*/ function(ThumbnailResizeMode) {
    ThumbnailResizeMode["Crop"] = "crop";
    ThumbnailResizeMode["Max"] = "max";
    return ThumbnailResizeMode;
}({});
var AssetListView = /*#__PURE__*/ function(AssetListView) {
    AssetListView["Search"] = "search";
    AssetListView["Drafts"] = "drafts";
    AssetListView["RecentlyChanged"] = "recently-changed";
    AssetListView["Uploads"] = "uploads";
    return AssetListView;
}({});

const Models$2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	AssetDisplayMode,
	AssetListView,
	ThumbnailResizeMode,
	UploadState,
	isAsset,
	isAssetListItem
}, Symbol.toStringTag, { value: 'Module' }));

class Multilingual {
    static{
        this.ValidLanguageCodes = [
            "ab",
            "aa",
            "af",
            "ak",
            "sq",
            "am",
            "ar",
            "an",
            "hy",
            "as",
            "av",
            "ae",
            "ay",
            "az",
            "bm",
            "ba",
            "eu",
            "be",
            "bn",
            "bh",
            "bi",
            "bs",
            "br",
            "bg",
            "my",
            "ca",
            "ch",
            "ce",
            "ny",
            "zh",
            "cv",
            "kw",
            "co",
            "cr",
            "hr",
            "cs",
            "da",
            "dv",
            "nl",
            "dz",
            "en",
            "eo",
            "et",
            "ee",
            "fo",
            "fj",
            "fi",
            "fr",
            "ff",
            "gl",
            "ka",
            "de",
            "el",
            "gn",
            "gu",
            "ht",
            "ha",
            "he",
            "hz",
            "hi",
            "ho",
            "hu",
            "ia",
            "id",
            "ie",
            "ga",
            "ig",
            "ik",
            "io",
            "is",
            "it",
            "iu",
            "ja",
            "jv",
            "kl",
            "kn",
            "kr",
            "ks",
            "kk",
            "km",
            "ki",
            "rw",
            "ky",
            "kv",
            "kg",
            "ko",
            "ku",
            "kj",
            "la",
            "lb",
            "lg",
            "li",
            "ln",
            "lo",
            "lt",
            "lu",
            "lv",
            "gv",
            "mk",
            "mg",
            "ms",
            "ml",
            "mt",
            "mi",
            "mr",
            "mh",
            "mn",
            "na",
            "nv",
            "nd",
            "ne",
            "ng",
            "nb",
            "nn",
            "no",
            "ii",
            "nr",
            "oc",
            "oj",
            "cu",
            "om",
            "or",
            "os",
            "pa",
            "pi",
            "fa",
            "pl",
            "ps",
            "pt",
            "qu",
            "rm",
            "rn",
            "ro",
            "ru",
            "sa",
            "sc",
            "sd",
            "se",
            "sm",
            "sg",
            "sr",
            "gd",
            "sn",
            "si",
            "sk",
            "sl",
            "so",
            "st",
            "es",
            "su",
            "sw",
            "ss",
            "sv",
            "ta",
            "te",
            "tg",
            "th",
            "ti",
            "bo",
            "tk",
            "tl",
            "tn",
            "to",
            "tr",
            "ts",
            "tt",
            "tw",
            "ty",
            "ug",
            "uk",
            "ur",
            "uz",
            "ve",
            "vi",
            "vo",
            "wa",
            "cy",
            "wo",
            "fy",
            "xh",
            "yi",
            "yo",
            "za",
            "zu",
            "iv"
        ];
    }
    static{
        this.LanguageCascade = [
            "de",
            "en",
            "fr",
            "it",
            "iv"
        ];
    }
    static is(value) {
        return typeof value === "object" && Object.keys(value).every((key)=>key.length === 2) && Object.keys(value).every((key)=>Multilingual.ValidLanguageCodes.includes(key));
    }
    static getValue(multilingual) {
        if (multilingual == null) {
            return null;
        }
        for (let langCode of Multilingual.LanguageCascade){
            if (multilingual.hasOwnProperty(langCode)) {
                return multilingual[langCode];
            }
        }
        return null;
    }
    static *enumerate(multilingual) {
        return Object.entries(multilingual);
    }
}
class IdSelector {
    static{
        this.FileNameParameter = "filename";
    }
    static{
        this.DisplayNameParameter = "displayname";
    }
    static{
        this.emptyId = "AAAAAAAAAAAAAAAAAAAAAA";
    }
    static empty(kind) {
        return {
            id: IdSelector.emptyId,
            kind: kind,
            displayName: {},
            displayDescription: {},
            fileName: kind === "asset" ? "" : undefined
        };
    }
    static isEmptyOrNull(selector) {
        if (selector == null) {
            return true;
        }
        if (selector.id === this.emptyId) {
            return true;
        }
        return false;
    }
    static create(target) {
        if (target == null) {
            return null;
        }
        if (isDocument(target)) {
            return {
                id: target.id,
                kind: "document",
                displayName: target.displayName,
                displayDescription: target.displayDescription
            };
        }
        if (isDocumentListItem(target)) {
            return {
                id: target.id,
                kind: "document",
                displayName: target.name,
                displayDescription: target.description
            };
        }
        if (isAsset(target)) {
            return {
                id: target.id,
                kind: "asset",
                displayName: target.displayName,
                displayDescription: target.displayDescription,
                fileName: slugify(Multilingual.getValue(target.displayName)) + target.extension
            };
        }
        if (isAssetListItem(target)) {
            return {
                id: target.id,
                kind: "asset",
                displayName: target.name,
                displayDescription: target.description,
                fileName: target.fileName
            };
        }
        throw new Error("Shouldn't be reachable");
    }
    static toUrl(selector) {
        if (selector == null) {
            return "";
        }
        let kind = "";
        let query = {};
        if (selector.kind === "asset") {
            kind = "Asset";
            query[IdSelector.FileNameParameter] = selector.fileName ?? "asset.bin";
        } else {
            kind = "Document";
        }
        for (let [lang, value] of Object.entries(selector.displayName)){
            query[`${IdSelector.DisplayNameParameter}[${lang}]`] = value;
        }
        return `bluc:${kind}/${selector.id}?${queryString.stringify(query)}`;
    }
    static fromUrl(url) {
        if (isNullOrEmpty(url) || !url.startsWith("bluc:")) {
            return null;
        }
        // bluc urls have the format "bluc:<entitykind>/<id>?filename=&displayname[lang]="
        // (f.ex. "bluc:Asset:PefyF_sLSEy4sYahOd5LCw?filename=file.jpg&displayname[de]=Datei&displayname[en]=File")
        let parsedUrl = queryString.parseUrl(url);
        let segments = parsedUrl.url.substring(5).split("/");
        let displayName = {};
        for (let [key, value] of Object.entries(parsedUrl.query).filter(([key, _])=>key.startsWith(IdSelector.DisplayNameParameter))){
            let lang = key.substr(IdSelector.DisplayNameParameter.length + 1, 2);
            displayName[lang] = value;
        }
        if (segments[0] === "Document") {
            return {
                kind: "document",
                id: segments[1],
                displayName
            };
        } else if (segments[0] === "Asset") {
            return {
                kind: "asset",
                id: segments[1],
                displayName,
                [IdSelector.FileNameParameter]: parsedUrl.query.filename ?? "asset.bin"
            };
        } else {
            throw new Error("Entity kind must be 'Asset' or 'Document'.");
        }
    }
}
var EntityKind = /*#__PURE__*/ function(EntityKind) {
    EntityKind["Document"] = "document";
    EntityKind["Asset"] = "asset";
    return EntityKind;
}({});
var DataType = /*#__PURE__*/ function(DataType) {
    DataType["AssetIdSelector"] = "asset-id-selector";
    DataType["DocumentIdSelector"] = "document-id-selector";
    DataType["AssetTagSelector"] = "asset-tag-selector";
    DataType["DocumentTagSelector"] = "document-tag-selector";
    DataType["AssetTagEditor"] = "asset-tag-editor";
    DataType["ValuePool"] = "valuepool";
    DataType["DocumentTagEditor"] = "document-tag-editor";
    DataType["Richtext"] = "richtext";
    DataType["Multilingual"] = "multilingual";
    DataType["Text"] = "text";
    DataType["ImageCrop"] = "image-crop";
    DataType["ReadOnly"] = "readonly";
    DataType["GeoPosition"] = "geo-position";
    DataType["MenuNodeControllerData"] = "menu-node-controller-data";
    return DataType;
}({});
var BatchUpdateAction = /*#__PURE__*/ function(BatchUpdateAction) {
    BatchUpdateAction["Publish"] = "publish";
    BatchUpdateAction["Delete"] = "delete";
    BatchUpdateAction["UpdateTags"] = "updateTags";
    return BatchUpdateAction;
}({});

const Models$1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	BatchUpdateAction,
	DataType,
	EntityKind,
	IdSelector,
	Multilingual
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$W = { class: "text-left pl-2" };
const _hoisted_2$I = { class: "text-left pl-2" };
const _hoisted_3$B = { class: "text-left pl-2" };
const _hoisted_4$f = { class: "text-left pl-2" };
const _hoisted_5$c = { class: "text-left pl-2" };
const _hoisted_6$a = { class: "text-left pl-2" };

function render$1b(_ctx, _cache) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_document_list_item = resolveComponent("document-list-item");
  const _component_asset_list_item_detail = resolveComponent("asset-list-item-detail");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_list = resolveComponent("v-list");
  const _component_asset_grid_item = resolveComponent("asset-grid-item");
  const _component_v_item = resolveComponent("v-item");
  const _component_v_item_group = resolveComponent("v-item-group");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");

  return (openBlock(), createElementBlock("div", {
    onDrop: _cache[2] || (_cache[2] = (...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
    onDragover: _cache[3] || (_cache[3] = (...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
    onDragleave: _cache[4] || (_cache[4] = (...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
    class: "id-selector"
  }, [
    createVNode(_component_v_overlay, {
      absolute: "",
      contained: "",
      persistent: "",
      "no-click-animation": "",
      class: normalizeClass(["align-center justify-center", "id-selector__drop-overlay"]),
      attach: true,
      modelValue: _ctx.isDragging || _ctx.state === 'uploading'
    }, {
      default: withCtx(() => [
        (_ctx.upload != null)
          ? (openBlock(), createBlock(_component_v_progress_circular, {
              key: 0,
              color: "primary",
              rotate: -90,
              size: 64,
              width: 6
            }))
          : createCommentVNode("", true),
        (_ctx.isDragging)
          ? (openBlock(), createBlock(_component_v_row, {
              key: 1,
              align: "center"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_col, { cols: "auto" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, { size: "64" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiCloudUploadOutline), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_col, { cols: "auto" }, {
                  default: withCtx(() => _cache[5] || (_cache[5] = [
                    createElementVNode("div", { class: "text--white text-h6" }, "Asset hochladen", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.mode === 'edit' && !_ctx.disabled)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(_component_v_card, {
            variant: "flat",
            class: normalizeClass({'border': _ctx.state === 'selected'})
          }, {
            default: withCtx(() => [
              (_ctx.state === 'empty')
                ? (openBlock(), createBlock(_component_v_empty_state, {
                    key: 0,
                    class: "v-empty-state--horizontal",
                    size: 64,
                    color: "surfaceDim",
                    title: `Kein ${_ctx.$formatters.entityNameSingular(_ctx.kind)} ausgewählt.`,
                    icon: _ctx.emptyIcon
                  }, null, 8, ["title", "icon"]))
                : createCommentVNode("", true),
              (_ctx.state === 'notFound')
                ? (openBlock(), createBlock(_component_v_empty_state, {
                    key: 1,
                    class: "v-empty-state--horizontal",
                    size: 64,
                    color: "error",
                    title: `${_ctx.$formatters.entityNameSingular(_ctx.kind)} nicht gefunden.`,
                    icon: _ctx.notFoundIcon
                  }, {
                    text: withCtx(() => [
                      createElementVNode("table", null, [
                        createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = createElementVNode("th", { class: "text-right" }, "ID", -1)),
                          createElementVNode("td", _hoisted_1$W, toDisplayString(_ctx.modelValue.id), 1)
                        ]),
                        createElementVNode("tr", null, [
                          _cache[7] || (_cache[7] = createElementVNode("th", { class: "text-right" }, "Titel", -1)),
                          createElementVNode("td", _hoisted_2$I, toDisplayString(_ctx.$formatters.multilingual(_ctx.modelValue.displayName)), 1)
                        ]),
                        createElementVNode("tr", null, [
                          _cache[8] || (_cache[8] = createElementVNode("th", { class: "text-right" }, "Beschreibung", -1)),
                          createElementVNode("td", _hoisted_3$B, toDisplayString(_ctx.$formatters.multilingual(_ctx.modelValue.description)), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title", "icon"]))
                : createCommentVNode("", true),
              (_ctx.state === 'selected')
                ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                    (_ctx.kind === 'document')
                      ? (openBlock(), createBlock(_component_document_list_item, {
                          key: 0,
                          "is-passive": "",
                          unselectable: "",
                          document: _ctx.selectedEntity
                        }, null, 8, ["document"]))
                      : createCommentVNode("", true),
                    (_ctx.kind === 'asset')
                      ? (openBlock(), createBlock(_component_asset_list_item_detail, {
                          key: 1,
                          "is-passive": "",
                          unselectable: "",
                          "hide-metadata": "",
                          thumbnailHeight: _ctx.isImageAsset ? 160 : undefined,
                          asset: _ctx.selectedEntity
                        }, null, 8, ["thumbnailHeight", "asset"]))
                      : createCommentVNode("", true)
                  ], 64))
                : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          createVNode(_component_v_card, {
            variant: "flat",
            class: "mt-4 border"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_text_field, {
                autofocus: "",
                clearable: "",
                "hide-details": "",
                class: "id-selector__search flex-grow-0",
                placeholder: `${_ctx.$formatters.entityNameSingular(_ctx.kind)} nach Name, Beschreibung oder Tag suchen…`,
                modelValue: _ctx.query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.query) = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              createVNode(_component_loader_wrapper, { state: _ctx.listState }, {
                empty: withCtx(() => [
                  createVNode(_component_v_empty_state, {
                    class: "v-empty-state--horizontal",
                    size: 64,
                    icon: _ctx.$icons.mdiMagnify,
                    title: `${_ctx.$formatters.entityNameSingular(_ctx.kind)} auswählen`,
                    text: `Gib einen Suchbegriff ein um passende ${_ctx.$formatters.entityNamePlural(_ctx.kind)} zu finden.`
                  }, null, 8, ["icon", "title", "text"])
                ]),
                noresults: withCtx(() => [
                  createVNode(_component_v_empty_state, {
                    class: "v-empty-state--horizontal",
                    size: 64,
                    icon: _ctx.$icons.mdiDatabaseSearch,
                    title: "Keine Resultate"
                  }, {
                    text: withCtx(() => [
                      createTextVNode(" Keine " + toDisplayString(_ctx.$formatters.entityNamePlural(_ctx.kind)) + " gefunden, die die Suchbegriffe ", 1),
                      createElementVNode("strong", null, toDisplayString(_ctx.query), 1),
                      _cache[9] || (_cache[9] = createTextVNode(" enthalten. "))
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                default: withCtx(() => [
                  (_ctx.kind === 'document')
                    ? (openBlock(), createBlock(_component_v_list, {
                        key: 0,
                        selectable: "",
                        "return-object": "",
                        "bg-color": "transparent",
                        class: "id-selector__document-list",
                        "onUpdate:selected": _ctx.onDocumentListSelectionChanged
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.queryResults, (item) => {
                            return (openBlock(), createBlock(_component_document_list_item, {
                              "is-passive": "",
                              document: item
                            }, null, 8, ["document"]))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["onUpdate:selected"]))
                    : createCommentVNode("", true),
                  (_ctx.kind === 'asset')
                    ? (openBlock(), createBlock(_component_v_card_text, { key: 1 }, {
                        default: withCtx(() => [
                          createVNode(_component_v_item_group, {
                            modelValue: _ctx.listSelectionState,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.listSelectionState) = $event))
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_v_row, { dense: "" }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.queryResults, (item) => {
                                    return (openBlock(), createBlock(_component_v_col, { cols: _ctx.thumbnailCols }, {
                                      default: withCtx(() => [
                                        createVNode(_component_v_item, { value: item }, {
                                          default: withCtx(({ isSelected, select }) => [
                                            createVNode(_component_asset_grid_item, {
                                              selected: isSelected,
                                              modelValue: item,
                                              onClick: select
                                            }, null, 8, ["selected", "modelValue", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["value"])
                                      ]),
                                      _: 2
                                    }, 1032, ["cols"]))
                                  }), 256))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["state"])
            ]),
            _: 1
          })
        ], 64))
      : createCommentVNode("", true),
    (_ctx.mode === 'view')
      ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createVNode(_component_v_overlay, {
            contained: "",
            persistent: "",
            "no-click-animation": "",
            class: "align-center justify-center",
            attach: true,
            modelValue: _ctx.state === 'loading'
          }, {
            default: withCtx(() => [
              createVNode(_component_v_progress_circular, {
                color: "primary",
                size: 64,
                width: 6,
                indeterminate: ""
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.state === 'empty')
            ? (openBlock(), createBlock(_component_v_empty_state, {
                key: 0,
                class: "v-empty-state--horizontal",
                size: 64,
                color: "surfaceDim",
                title: `Kein ${_ctx.$formatters.entityNameSingular(_ctx.kind)} ausgewählt.`,
                icon: _ctx.emptyIcon
              }, null, 8, ["title", "icon"]))
            : createCommentVNode("", true),
          (_ctx.state === 'notFound')
            ? (openBlock(), createBlock(_component_v_empty_state, {
                key: 1,
                class: "v-empty-state--horizontal",
                size: 64,
                color: "error",
                title: `${_ctx.$formatters.entityNameSingular(_ctx.kind)} nicht gefunden.`,
                icon: _ctx.notFoundIcon
              }, {
                text: withCtx(() => [
                  createElementVNode("table", null, [
                    createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = createElementVNode("th", { class: "text-right" }, "ID", -1)),
                      createElementVNode("td", _hoisted_4$f, toDisplayString(_ctx.modelValue.id), 1)
                    ]),
                    createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = createElementVNode("th", { class: "text-right" }, "Titel", -1)),
                      createElementVNode("td", _hoisted_5$c, toDisplayString(_ctx.$formatters.multilingual(_ctx.modelValue.displayName)), 1)
                    ]),
                    createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = createElementVNode("th", { class: "text-right" }, "Beschreibung", -1)),
                      createElementVNode("td", _hoisted_6$a, toDisplayString(_ctx.$formatters.multilingual(_ctx.modelValue.description)), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title", "icon"]))
            : createCommentVNode("", true),
          (_ctx.state === 'selected')
            ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                (_ctx.kind === 'document')
                  ? (openBlock(), createBlock(_component_document_list_item, {
                      key: 0,
                      "is-passive": "",
                      unselectable: "",
                      "hide-metadata": "",
                      document: _ctx.selectedEntity
                    }, null, 8, ["document"]))
                  : createCommentVNode("", true),
                (_ctx.kind === 'asset')
                  ? (openBlock(), createBlock(_component_asset_list_item_detail, {
                      key: 1,
                      "is-passive": "",
                      unselectable: "",
                      "hide-metadata": "",
                      asset: _ctx.selectedEntity
                    }, null, 8, ["asset"]))
                  : createCommentVNode("", true)
              ], 64))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true)
  ], 32))
}

const container = new Container({
    skipBaseClassChecks: true
});

function AutoInject(target, propertyName) {
    let type = Reflect.getMetadata("design:type", target, propertyName);
    function getter() {
        let value = container.get(type);
        return value;
    }
    Reflect.defineProperty(target, propertyName, {
        get: getter
    });
}

class EntityServiceBase {
    constructor(baseUrl, middlewareFactory, notificationService){
        this.baseUrl = baseUrl;
        this.notificationService = notificationService;
        this.client = ky.create({
            prefixUrl: baseUrl,
            retry: 0,
            hooks: {
                beforeRequest: [
                    middlewareFactory.createAuthMiddleware()
                ]
            }
        });
    }
}

class ExtendedError extends Error {
    constructor(message, customData){
        super(message);
        this.customData = customData;
    }
}
const ShowSnackbarEvent = "notification-queue/show-snackbar";

const eventBus = mitt();
window.eventBus = eventBus;

let NotificationService$1 = class NotificationService {
    showSuccess(message, details) {
        this.show(message, "success", details);
    }
    showError(message, errorOrDetails) {
        if (errorOrDetails instanceof Error) {
            this.show(message, "error", errorOrDetails.message);
        } else {
            this.show(message, "error", errorOrDetails);
        }
    }
    show(message, type, details) {
        let args = {
            type,
            message,
            details
        };
        eventBus.emit(ShowSnackbarEvent, args);
    }
};
NotificationService$1 = _([
    injectable()
], NotificationService$1);

Log.setLogger(console);
class AuthenticationModule extends Pinia {
    get isSignedin() {
        return this.currentUser != null;
    }
    get accessToken() {
        if (this.currentUser == null) {
            return null;
        }
        return this.currentUser.access_token;
    }
    setCurrentUser(user) {
        this.currentUser = user;
    }
    async getUser() {
        if (this.currentUser != null && !this.currentUser.expired) {
            return this.currentUser;
        }
        this.currentUser = await this.userManager.getUser();
        return this.currentUser;
    }
    async getGravatarUrl() {
        let user = await this.getUser();
        let email = user?.profile.email?.toLowerCase();
        if (email == null) {
            return null;
        }
        return `https://www.gravatar.com/avatar/${sha256(email)}?d=retro`;
    }
    async signin() {
        try {
            await this.userManager.signinRedirect();
            return true;
        } catch (e) {
            if (isError$1(e)) {
                this.notificationService.showError(e.message);
                return false;
            } else {
                throw e;
            }
        }
    }
    async signinSilent() {
        try {
            this.currentUser = await this.userManager.signinSilent();
            return this.currentUser;
        } catch (e) {
            return null;
        }
    }
    async signout() {
        return await this.userManager.signoutRedirect();
    }
    constructor(...args){
        super(...args), this.currentUser = null;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof UserManager === "undefined" ? Object : UserManager)
], AuthenticationModule.prototype, "userManager", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AuthenticationModule.prototype, "notificationService", void 0);
AuthenticationModule = _([
    Store
], AuthenticationModule);

class MiddlewareFactory {
    constructor(authStore){
        this.authStore = authStore;
    }
    createAuthMiddleware() {
        let authStore = this.authStore; // capture authstore
        return (request, options)=>{
            request.headers.set("Authorization", `Bearer ${authStore.accessToken}`);
        };
    }
}
MiddlewareFactory = _([
    injectable(),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof AuthenticationModule === "undefined" ? Object : AuthenticationModule
    ])
], MiddlewareFactory);

class DocumentService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "documents"), middlewareFactory, snackbarService);
    }
    async loadTags() {
        let data = await this.client.get("tags").json();
        return data.tags;
    }
    async search(params) {
        if (isNullOrEmpty(params.query) && (params.tags?.length ?? 0) === 0 && isNullOrEmpty(params.type)) {
            return [];
        }
        let data = await this.client.get("", {
            searchParams: queryString.stringify(params)
        }).json();
        return data.documents;
    }
    async getRecent(cutoff, count) {
        let data = await this.client.get("recent", {
            searchParams: {
                cutoff: cutoff.toISODate(),
                count: count
            }
        }).json();
        return data.documents;
    }
    async getDrafts(count) {
        let data = await this.client.get("drafts", {
            searchParams: {
                count: count
            }
        }).json();
        return data.documents;
    }
    async discardDraft(id) {
        await this.client.delete(urljoin(id, "draft"));
    }
    async delete(id) {
        await this.client.delete(id);
    }
    async getHeaders(id) {
        let data = await this.client.get(urljoin(id, "headers")).json();
        return data;
    }
    async getReferences(id) {
        let data = await this.client.get(urljoin(id, "references")).json();
        return data.references;
    }
    async get(id) {
        let data = await this.client.get(id).json();
        return data;
    }
    async getDraft(id) {
        let data = await this.client.get(urljoin(id, "draft")).json();
        return data;
    }
    async getDraftOrPublished(id) {
        let response = await this.client.get(urljoin(id, "draft"), {
            throwHttpErrors: false
        });
        if (response == null) {
            throw new Error("Failed to fetch");
        }
        if (!response.ok) {
            response = await this.client.get(id);
        }
        let data = await response.json();
        return data;
    }
    async createDuplicate(id) {
        let data = await this.client.post(urljoin(id, "duplicate")).json();
        return data;
    }
    async createDraft(id) {
        let data = await this.client.post(urljoin(id, "draft")).json();
        return data;
    }
    async saveDraft(id, document) {
        return await this.client.put(urljoin(id, "draft"), {
            json: document
        }).json();
    }
    async publish(id) {
        await this.client.post(urljoin(id, "draft", "publish"));
    }
    async unpublish(id) {
        await this.client.post(urljoin(id, "unpublish"));
    }
    async create(type) {
        let createRequest = {
            type
        };
        let data = await this.client.post("", {
            json: createRequest
        }).json();
        return data;
    }
    async loadTypes() {
        let data = await this.client.get("types").json();
        return data.types;
    }
    async batchPublish(entities) {
        let request = {
            action: BatchUpdateAction.Publish,
            entities: entities
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
    async batchDelete(entities) {
        let request = {
            action: BatchUpdateAction.Delete,
            entities: entities
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
    async batchUpdateTags(entities, tagsToAdd, tagsToRemove) {
        let request = {
            action: BatchUpdateAction.UpdateTags,
            entities: entities,
            tagsToAdd: tagsToAdd,
            tagsToRemove: tagsToRemove
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
}
DocumentService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], DocumentService);

const UploadProgressEvent = "asset-service/upload-progress";
class AssetService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "assets"), middlewareFactory, snackbarService);
    }
    async loadTags() {
        let data = await this.client.get("tags").json();
        return data.tags;
    }
    async search(params) {
        let data = await this.client.get("", {
            searchParams: queryString.stringify(params)
        }).json();
        return data.assets;
    }
    async getRecent(cutoff, count) {
        let data = await this.client.get("recent", {
            searchParams: {
                cutoff: cutoff.toISODate(),
                count: count
            }
        }).json();
        return data.assets;
    }
    async getDrafts(count) {
        let data = await this.client.get("drafts", {
            searchParams: {
                count: count
            }
        }).json();
        return data.assets;
    }
    async discardDraft(id) {
        await this.client.delete(urljoin(id, "draft"));
    }
    async delete(id) {
        await this.client.delete(id);
    }
    async getHeaders(id) {
        let data = await this.client.get(urljoin(id, "headers")).json();
        return data;
    }
    async getReferences(id) {
        let data = await this.client.get(urljoin(id, "references")).json();
        return data.references;
    }
    async get(id) {
        let data = await this.client.get(id).json();
        return data;
    }
    async getDraft(id) {
        let data = await this.client.get(urljoin(id, "draft")).json();
        return data;
    }
    async getDraftOrPublished(id) {
        let response = await this.client.get(urljoin(id, "draft"), {
            throwHttpErrors: false
        });
        if (response == null) {
            throw new TypeError("Failed to fetch");
        }
        if (!response.ok) {
            response = await this.client.get(id);
        }
        let data = await response.json();
        return data;
    }
    async createDuplicate(id) {
        let data = await this.client.post(urljoin(id, "duplicate")).json();
        return data;
    }
    async createDraft(id) {
        let data = await this.client.post(urljoin(id, "draft")).json();
        return data;
    }
    async saveDraft(id, asset) {
        return await this.client.put(urljoin(id, "draft"), {
            json: asset
        }).json();
    }
    async publish(id) {
        await this.client.post(urljoin(id, "draft", "publish"));
    }
    async unpublish(id) {
        await this.client.post(urljoin(id, "unpublish"));
    }
    async create(contentType, fileName) {
        let request = {
            contentType,
            fileName
        };
        let data = await this.client.post("", {
            json: request
        }).json();
        return data;
    }
    async replaceBlob(id, isDraft, contentType, fileName) {
        let request = {
            contentType,
            fileName
        };
        let url = isDraft ? urljoin(id, "draft", "blob") : urljoin(id, "blob");
        let data = await this.client.post(url, {
            json: request
        }).json();
        return data;
    }
    async commitBlob(id, isDraft) {
        let url = isDraft ? urljoin(id, "draft", "blob") : urljoin(id, "blob");
        await this.client.put(url);
    }
    async getBlobUrl(id, isDraft) {
        let url = isDraft ? urljoin(id, "draft", "blob") : urljoin(id, "blob");
        let response = await this.client.get(url).json();
        return response.blobUrl;
    }
    async batchPublish(entities) {
        let request = {
            action: BatchUpdateAction.Publish,
            entities: entities
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
    async batchDelete(entities) {
        let request = {
            action: BatchUpdateAction.Delete,
            entities: entities
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
    async batchUpdateTags(entities, tagsToAdd, tagsToRemove) {
        let request = {
            action: BatchUpdateAction.UpdateTags,
            entities: entities,
            tagsToAdd: tagsToAdd,
            tagsToRemove: tagsToRemove
        };
        let response = await this.client.post("batch", {
            json: request
        }).json();
        return response;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof AuthenticationModule === "undefined" ? Object : AuthenticationModule)
], AssetService.prototype, "authStore", void 0);
AssetService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], AssetService);

const _hoisted_1$V = { class: "d-flex fill-height align-center justify-center" };

function render$1a(_ctx, _cache) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_publish_status_icon = resolveComponent("publish-status-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_fade_transition = resolveComponent("v-fade-transition");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _component_v_hover = resolveComponent("v-hover");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _directive_tooltip = resolveDirective("tooltip");

  return (_ctx.isImage)
    ? (openBlock(), createBlock(_component_v_hover, {
        key: 0,
        disabled: _ctx.isPassive
      }, {
        default: withCtx(({ isHovering, props }) => [
          createVNode(_component_v_img, mergeProps({
            class: "asset-thumbnail__thumbnail-image",
            width: _ctx.width,
            src: _ctx.thumbnailUrl,
            contain: true,
            "aspect-ratio": 3 / 2,
            onLoad: _cache[1] || (_cache[1] = $event => (_ctx.isImageBroken = false)),
            onError: _cache[2] || (_cache[2] = $event => (_ctx.isImageBroken = true))
          }, props), {
            placeholder: withCtx(() => [
              (!_ctx.isImageBroken)
                ? (openBlock(), createBlock(_component_v_row, {
                    key: 0,
                    class: "fill-height ma-0",
                    align: "center",
                    justify: "center"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_progress_circular, { indeterminate: "" })
                    ]),
                    _: 1
                  }))
                : createCommentVNode("", true)
            ]),
            default: withCtx(() => [
              (_ctx.isImageBroken)
                ? (openBlock(), createBlock(_component_v_row, {
                    key: 0,
                    class: "fill-height ma-0",
                    align: "center",
                    justify: "center"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, { size: "48" }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$icons.mdiImageBroken), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : createCommentVNode("", true),
              (_ctx.showPublishStatus)
                ? (openBlock(), createBlock(_component_publish_status_icon, {
                    key: 1,
                    class: "asset-thumbnail__publish-status",
                    modelValue: !_ctx.asset.isDraft
                  }, null, 8, ["modelValue"]))
                : createCommentVNode("", true),
              createVNode(_component_v_fade_transition, null, {
                default: withCtx(() => [
                  withDirectives(createVNode(_component_v_btn, {
                    class: "asset-thumbnail__zoom",
                    size: "x-small",
                    icon: _ctx.$icons.mdiMagnifyPlus,
                    onClick: _cache[0] || (_cache[0] = withModifiers($event => (_ctx.isLightboxOpen = true), ["stop"]))
                  }, null, 8, ["icon"]), [
                    [_directive_tooltip, 'Vergrössern', "bottom"],
                    [vShow, isHovering && !_ctx.isImageBroken]
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040, ["width", "src"]),
          createVNode(_component_v_dialog, {
            "max-width": "80vw",
            "max-height": "80vh",
            modelValue: _ctx.isLightboxOpen,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.isLightboxOpen) = $event))
          }, {
            default: withCtx(() => [
              createVNode(_component_v_card, {
                flat: "",
                class: "asset-thumbnail__lightbox-surface"
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_img, {
                    src: _ctx.largeUrl,
                    "max-width": "80vw",
                    "max-height": "80vh",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.isLightboxOpen = false))
                  }, {
                    placeholder: withCtx(() => [
                      createElementVNode("div", _hoisted_1$V, [
                        createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          size: "64",
                          color: "primary"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["disabled"]))
    : (openBlock(), createBlock(_component_v_responsive, {
        key: 1,
        "content-class": "d-flex align-center justify-center",
        width: _ctx.width,
        "aspect-ratio": 3 / 2
      }, {
        default: withCtx(() => [
          (_ctx.showPublishStatus)
            ? (openBlock(), createBlock(_component_publish_status_icon, {
                key: 0,
                class: "asset-thumbnail__publish-status",
                modelValue: !_ctx.asset.isDraft
              }, null, 8, ["modelValue"]))
            : createCommentVNode("", true),
          createVNode(_component_v_icon, { size: _ctx.iconSize }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.contentTypeIcon), 1)
            ]),
            _: 1
          }, 8, ["size"])
        ]),
        _: 1
      }, 8, ["width"]))
}

class AssetModule extends Pinia {
    get activeUploadCount() {
        return Object.values(this.uploads).filter((u)=>u.progressPercentage > 0 && u.progressPercentage < 1).length;
    }
    get uploadCount() {
        return Object.values(this.uploads).length;
    }
    get pendingUploadCount() {
        return Object.values(this.uploads).filter((u)=>u.progressPercentage === 0).length;
    }
    removeUpload(id) {
        delete this.uploads[id];
    }
    cancelUpload(id) {
        this.uploads[id]?.abortController.abort();
    }
    async prepareNewUpload(file) {
        let response = await this.assetService.create(file.type, file.name);
        let upload = {
            id: response.id,
            blob: new BlockBlobClient(response.uploadUrl, new AnonymousCredential()),
            abortController: new AbortController(),
            contentType: file.type,
            fileName: file.name,
            progressPercentage: 0,
            state: UploadState.Queued
        };
        if (browserSupportedContentTypes.includes(file.type)) {
            upload.objectUrl = URL.createObjectURL(file);
        }
        this.addUpload(upload);
        return upload;
    }
    async prepareReplaceUpload(payload) {
        let response = await this.assetService.replaceBlob(payload.id, payload.isDraft, payload.file.type, payload.file.name);
        let upload = {
            id: payload.id,
            blob: new BlockBlobClient(response.uploadUrl, new AnonymousCredential()),
            abortController: new AbortController(),
            contentType: payload.file.type,
            fileName: payload.file.name,
            progressPercentage: 0,
            state: UploadState.Queued
        };
        if (browserSupportedContentTypes.includes(payload.file.type)) {
            upload.objectUrl = URL.createObjectURL(payload.file);
        }
        this.addUpload(upload);
        return upload;
    }
    async createAndUpload(file) {
        let upload = await this.uploadQueue.add(()=>this.prepareNewUpload(file));
        try {
            await this.uploadQueue.add(()=>{
                upload.promise = upload.blob?.uploadData(file, {
                    blobHTTPHeaders: {
                        blobContentType: upload.contentType
                    },
                    abortSignal: upload.abortController?.signal,
                    onProgress: (e)=>{
                        let progressPercentage = e.loadedBytes / file.size;
                        this.setUploadPercentage(upload.id, progressPercentage);
                    }
                });
                //upload.promise = new Promise((resolve, reject) => {
                //	let progressPercentage = 0;
                //	setInterval(() => {
                //		progressPercentage += 0.005;
                //		this.setUploadPercentage(upload.id, progressPercentage);
                //		if (progressPercentage >= 1) {
                //			resolve(null!);
                //		}
                //	}, 500);
                //});
                this.setUploadState(upload.id, UploadState.Uploading);
                return upload.promise;
            });
            this.setUploadState(upload.id, UploadState.Finished);
            await this.assetService.commitBlob(upload.id, true);
        } catch (e) {
            await this.assetService.discardDraft(upload.id);
            this.removeUpload(upload.id);
            // cancelling the upload will throw an AbortError, only show the error message if there was another error
            if (e instanceof Error && e.name !== "AbortError") {
                this.notificationService.showError(`Das Asset konnte nicht erstellt werden. Beim Upload der Datei '${upload.fileName}' ist ein Fehler aufgetreten.`);
            }
        }
        return upload;
    }
    async replace(payload) {
        let upload = await this.uploadQueue.add(()=>this.prepareReplaceUpload(payload));
        try {
            await this.uploadQueue.add(()=>{
                upload.promise = upload.blob?.uploadData(payload.file, {
                    blobHTTPHeaders: {
                        blobContentType: upload.contentType
                    },
                    abortSignal: upload.abortController?.signal,
                    onProgress: (e)=>{
                        let progressPercentage = e.loadedBytes / payload.file.size;
                        this.setUploadPercentage(upload.id, progressPercentage);
                    }
                });
                this.setUploadState(upload.id, UploadState.Uploading);
                return upload.promise;
            });
            this.setUploadState(upload.id, UploadState.Finished);
            await this.assetService.commitBlob(payload.id, payload.isDraft);
            this.removeUpload(upload.id);
        } catch (e) {
            this.removeUpload(upload.id);
            // cancelling the upload will throw an AbortError, only show the error message if there was another error
            if (e instanceof Error && e.name !== "AbortError") {
                this.notificationService.showError(`Das Asset konnte nicht ausgetauscht werden. Beim Upload der Datei '${upload.fileName}' ist ein Fehler aufgetreten.`);
            }
        }
    }
    addUpload(upload) {
        this.uploads[upload.id] = upload;
    }
    setUploadPercentage(id, progressPercentage) {
        let upload = this.uploads[id];
        if (upload != null) {
            upload.progressPercentage = progressPercentage;
        }
    }
    setUploadState(id, state) {
        let upload = this.uploads[id];
        if (upload != null) {
            upload.state = state;
        }
    }
    get tags() {
        this._tags.sort((a, b)=>a.localeCompare(b));
        return this._tags;
    }
    addTags(tags) {
        this._tags.push(...tags);
    }
    removeTags(tags) {
        this._tags = this.tags.filter((t)=>!tags.includes(t));
    }
    setTags(tags) {
        this._tags = tags;
    }
    async loadTags() {
        try {
            this._tags = await this.assetService.loadTags();
            return this._tags;
        } catch (e) {
            this.notificationService.showError("Die Tags konnten nicht geladen werden.", e);
            return [];
        }
    }
    constructor(...args){
        super(...args), this.uploadQueue = new TaskQueue(Promise, 3), this.uploads = {}, this.listDisplayMode = AssetDisplayMode.Thumbnails, this.thumbnailResizeMode = ThumbnailResizeMode.Crop, this._tags = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetModule.prototype, "assetService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetModule.prototype, "notificationService", void 0);
AssetModule = _([
    Store
], AssetModule);

IconRegistry.add({
    mdiImageBroken,
    mdiPencil,
    mdiCheck,
    mdiMagnifyPlus
});
class AssetThumbnail extends Vue {
    get thumbnailUrl() {
        var url = new URL(this.asset.url);
        url.searchParams.set("width", this.width.toFixed(0));
        url.searchParams.set("height", this.height.toFixed(0));
        url.searchParams.set("rmode", this.assetStore.thumbnailResizeMode);
        return url.href;
    }
    get largeUrl() {
        var url = new URL(this.asset.url);
        url.searchParams.set("width", "1200");
        url.searchParams.set("height", "900");
        url.searchParams.set("rmode", "max");
        return url.href;
    }
    get isImage() {
        return isImageContentType(this.asset.contentType);
    }
    get isSvgImage() {
        return this.asset.contentType == "image/svg+xml";
    }
    get contentTypeIcon() {
        return getContentTypeIcon(this.asset.contentType);
    }
    constructor(...args){
        super(...args), this.assetStore = new AssetModule(), this.isImageBroken = false, this.isLightboxOpen = false;
    }
}
_([
    Prop({
        required: true
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.AssetListItem === "undefined" ? Object : Models.AssetListItem)
], AssetThumbnail.prototype, "asset", void 0);
_([
    Prop({
        required: false,
        default: false
    }),
    _$1("design:type", Boolean)
], AssetThumbnail.prototype, "isPassive", void 0);
_([
    Prop({
        default: false,
        type: Boolean
    }),
    _$1("design:type", Boolean)
], AssetThumbnail.prototype, "showPublishStatus", void 0);
_([
    Prop({
        default: 48
    }),
    _$1("design:type", Number)
], AssetThumbnail.prototype, "iconSize", void 0);
_([
    Prop({
        default: 300
    }),
    _$1("design:type", Number)
], AssetThumbnail.prototype, "width", void 0);
_([
    Prop({
        default: 200
    }),
    _$1("design:type", Number)
], AssetThumbnail.prototype, "height", void 0);
AssetThumbnail = _([
    Component({
        render: render$1a
    })
], AssetThumbnail);

const _hoisted_1$U = { class: "d-flex flex-column align-end" };
const _hoisted_2$H = {
  key: 0,
  class: "text-caption"
};
const _hoisted_3$A = { key: 0 };
const _hoisted_4$e = { key: 1 };
const _hoisted_5$b = { class: "d-flex" };
const _hoisted_6$9 = { class: "flex-grow-1" };
const _hoisted_7$8 = { class: "mb-1" };
const _hoisted_8$6 = { class: "entity-properties" };

function render$19(_ctx, _cache) {
  const _component_v_checkbox_btn = resolveComponent("v-checkbox-btn");
  const _component_publish_status_icon = resolveComponent("publish-status-icon");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_data_table = resolveComponent("v-data-table");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_entity_references = resolveComponent("entity-references");

  return (openBlock(), createBlock(_component_v_list_item, {
    lines: "three",
    class: normalizeClass(["document-list-item", { 'document-list-item--unselectable': _ctx.unselectable }]),
    title: _ctx.name,
    subtitle: _ctx.description,
    ripple: !_ctx.unselectable,
    value: _ctx.document,
    onClick: _ctx.open,
    onContextmenu: _ctx.onContextMenu
  }, {
    prepend: withCtx(() => [
      (!_ctx.isPassive)
        ? (openBlock(), createBlock(_component_v_checkbox_btn, {
            key: 0,
            class: "document-list-item__checkbox",
            "hide-details": "",
            onClick: withModifiers(_ctx.toggleSelection, ["stop"]),
            modelValue: _ctx.isSelected
          }, null, 8, ["onClick", "modelValue"]))
        : createCommentVNode("", true),
      createVNode(_component_v_tooltip, {
        location: "bottom",
        text: _ctx.type?.title
      }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_img, mergeProps({
            src: _ctx.iconUrl,
            width: "48",
            class: "mr-5 overflow-visible"
          }, props), {
            default: withCtx(() => [
              (_ctx.showPublishStatus)
                ? (openBlock(), createBlock(_component_publish_status_icon, {
                    key: 0,
                    class: "document-list-item__publish-status",
                    modelValue: !_ctx.document.isDraft
                  }, null, 8, ["modelValue"]))
                : createCommentVNode("", true)
            ]),
            _: 2
          }, 1040, ["src"])
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    append: withCtx(() => [
      createElementVNode("div", _hoisted_1$U, [
        (!_ctx.hideMetadata)
          ? (openBlock(), createElementBlock("div", _hoisted_2$H, "Geändert: " + toDisplayString(_ctx.$formatters.date(_ctx.document.lastModified, 'd.M.y HH:mm')), 1))
          : createCommentVNode("", true),
        (!_ctx.isPassive)
          ? (openBlock(), createBlock(_component_v_menu, {
              key: 1,
              absolute: "",
              target: _ctx.contextMenuX ? [_ctx.contextMenuX, _ctx.contextMenuY] : null,
              modelValue: _ctx.isContextMenuOpen,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.isContextMenuOpen) = $event))
            }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_btn, mergeProps({
                  variant: "text",
                  icon: _ctx.$icons.mdiDotsHorizontal
                }, props, {
                  onClick: withModifiers(_ctx.openContextMenu, ["stop","prevent"])
                }), null, 16, ["icon", "onClick"])
              ]),
              default: withCtx(() => [
                createVNode(_component_v_list, null, {
                  default: withCtx(() => [
                    (_ctx.canDelete)
                      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                          (_ctx.document.hasDraft || _ctx.document.isDraft)
                            ? (openBlock(), createBlock(_component_inline_confirm, {
                                key: 0,
                                component: "v-list-item",
                                onConfirmed: _cache[0] || (_cache[0] = $event => (_ctx.discardDraft())),
                                ref: "discardDraftConfirm"
                              }, {
                                confirm: withCtx(() => [
                                  createVNode(_component_v_btn, {
                                    depressed: "",
                                    color: "warning"
                                  }, {
                                    default: withCtx(() => _cache[10] || (_cache[10] = [
                                      createTextVNode("Bestätigen")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: withCtx(() => [
                                  (_ctx.document.hasPublished)
                                    ? (openBlock(), createElementBlock("span", _hoisted_3$A, "Entwurf verwerfen"))
                                    : (openBlock(), createElementBlock("span", _hoisted_4$e, "Löschen"))
                                ]),
                                _: 1
                              }, 512))
                            : createCommentVNode("", true),
                          (_ctx.document.hasPublished)
                            ? (openBlock(), createBlock(_component_inline_confirm, {
                                key: 1,
                                component: "v-list-item",
                                onConfirmed: _cache[1] || (_cache[1] = $event => (_ctx.deleteDocument())),
                                ref: "deleteConfirm"
                              }, {
                                confirm: withCtx(() => [
                                  createVNode(_component_v_btn, {
                                    depressed: "",
                                    color: "warning"
                                  }, {
                                    default: withCtx(() => _cache[11] || (_cache[11] = [
                                      createTextVNode("Bestätigen")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: withCtx(() => [
                                  _cache[12] || (_cache[12] = createElementVNode("span", null, "Löschen", -1))
                                ]),
                                _: 1
                              }, 512))
                            : createCommentVNode("", true)
                        ], 64))
                      : createCommentVNode("", true),
                    (_ctx.canUpdate)
                      ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          (_ctx.document.isDraft)
                            ? (openBlock(), createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = $event => (_ctx.publish()))
                              }, {
                                default: withCtx(() => _cache[13] || (_cache[13] = [
                                  createTextVNode("Publizieren")
                                ])),
                                _: 1
                              }))
                            : createCommentVNode("", true),
                          (!_ctx.document.isDraft)
                            ? (openBlock(), createBlock(_component_v_list_item, {
                                key: 1,
                                onClick: _cache[3] || (_cache[3] = $event => (_ctx.unpublish()))
                              }, {
                                default: withCtx(() => _cache[14] || (_cache[14] = [
                                  createTextVNode("Unpublizieren")
                                ])),
                                _: 1
                              }))
                            : createCommentVNode("", true)
                        ], 64))
                      : createCommentVNode("", true),
                    (!_ctx.document.isDraft && _ctx.canDuplicate)
                      ? (openBlock(), createBlock(_component_v_list_item, {
                          key: 2,
                          onClick: _cache[4] || (_cache[4] = $event => (_ctx.duplicate()))
                        }, {
                          default: withCtx(() => _cache[15] || (_cache[15] = [
                            createTextVNode("Duplizieren")
                          ])),
                          _: 1
                        }))
                      : createCommentVNode("", true),
                    createVNode(_component_v_list_item, {
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.showReferences()))
                    }, {
                      default: withCtx(() => _cache[16] || (_cache[16] = [
                        createTextVNode("Referenzen anzeigen")
                      ])),
                      _: 1
                    }),
                    createVNode(_component_v_list_item, {
                      onClick: _cache[6] || (_cache[6] = $event => (_ctx.showProperties()))
                    }, {
                      default: withCtx(() => _cache[17] || (_cache[17] = [
                        createTextVNode("Eigenschaften")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["target", "modelValue"]))
          : createCommentVNode("", true)
      ])
    ]),
    title: withCtx(({ title }) => [
      createElementVNode("div", _hoisted_5$b, [
        createElementVNode("div", _hoisted_6$9, toDisplayString(title), 1)
      ])
    ]),
    subtitle: withCtx(({ subtitle }) => [
      createElementVNode("div", _hoisted_7$8, toDisplayString(subtitle), 1),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tags, (tag) => {
        return (openBlock(), createBlock(_component_v_chip, {
          label: "",
          size: "x-small",
          variant: "flat",
          class: "mr-1",
          color: "#e4e6eb"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(tag), 1)
          ]),
          _: 2
        }, 1024))
      }), 256))
    ]),
    default: withCtx(() => [
      (_ctx.isPropertiesPanelOpen)
        ? (openBlock(), createBlock(_component_property_pane, {
            key: 0,
            title: "Eigenschaften",
            "is-active": "",
            onCancel: _cache[8] || (_cache[8] = $event => (_ctx.isPropertiesPanelOpen = false))
          }, {
            default: withCtx(({ value, setValue, ok, cancel }) => [
              createElementVNode("div", _hoisted_8$6, [
                createVNode(_component_v_data_table, {
                  "hide-default-header": "",
                  "hide-default-footer": "",
                  "disable-pagination": "",
                  headers: _ctx.propertyHeaders,
                  items: _ctx.properties
                }, null, 8, ["headers", "items"])
              ])
            ]),
            actions: withCtx(({ cancel }) => [
              createVNode(_component_v_btn, {
                variant: "elevated",
                color: "primary",
                onClick: cancel
              }, {
                default: withCtx(() => _cache[18] || (_cache[18] = [
                  createTextVNode("Schliessen")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }))
        : createCommentVNode("", true),
      (_ctx.isReferencesPanelOpen)
        ? (openBlock(), createBlock(_component_property_pane, {
            key: 1,
            title: "Verweise",
            "is-active": "",
            onCancel: _cache[9] || (_cache[9] = $event => (_ctx.isReferencesPanelOpen = false))
          }, {
            default: withCtx(({ value, setValue, ok, cancel }) => [
              createVNode(_component_entity_references, {
                entityId: _ctx.document.id,
                kind: "document"
              }, null, 8, ["entityId"])
            ]),
            actions: withCtx(({ cancel }) => [
              createVNode(_component_v_btn, {
                variant: "elevated",
                color: "primary",
                onClick: cancel
              }, {
                default: withCtx(() => _cache[19] || (_cache[19] = [
                  createTextVNode("Schliessen")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }))
        : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "title", "subtitle", "ripple", "value", "onClick", "onContextmenu"]))
}

const DeleteEvent = "delete";
const DiscardDraftEvent = "discardDraft";
const OpenEditorEvent = "openEditor";
const DuplicateEvent = "duplicate";
const PublishEvent = "publish";
const UnpublishEvent = "unpublish";
const ToggleSelectionEvent = "toggleSelection";
const OpenContextMenuEvent = "openContextMenu";

class DocumentModule extends Pinia {
    get tags() {
        this._tags.sort((a, b)=>a.localeCompare(b));
        return this._tags;
    }
    get types() {
        return this._types;
    }
    addTags(tags) {
        this._tags.push(...tags);
    }
    removeTags(tags) {
        this._tags = this.tags.filter((t)=>!tags.includes(t));
    }
    async loadTags() {
        try {
            this._tags = await this.documentService.loadTags();
            return this._tags;
        } catch (e) {
            this.notificationService.showError("Die Tags konnten nicht geladen werden.", e);
            return [];
        }
    }
    async loadTypes() {
        try {
            this._types = await this.documentService.loadTypes();
            return this._types;
        } catch (e) {
            this.notificationService.showError("Die Dokument-Typen konnten nicht geladen werden.", e);
            return [];
        }
    }
    constructor(...args){
        super(...args), this._tags = [], this._types = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], DocumentModule.prototype, "documentService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], DocumentModule.prototype, "notificationService", void 0);
DocumentModule = _([
    Store
], DocumentModule);

const RouteNames = {
    Root: "root",
    Documents: {
        Root: "documents",
        ListRedirect: "documents/list-redirect",
        List: "documents/list",
        Edit: "documents/edit",
        Create: "documents/create"
    },
    Assets: {
        Root: "assets",
        ListRedirect: "assets/list-redirect",
        List: "assets/list",
        Edit: "assets/edit",
        Create: "assets/create"
    },
    Menus: {
        Root: "menus",
        List: "menus/list",
        Edit: "menus/edit"
    },
    Roles: {
        Root: "roles",
        List: "roles/list",
        Edit: "roles/edit"
    },
    Config: {
        Root: "config",
        Edit: "config/edit"
    },
    Analytics: {
        Root: "analytics"
    }
};
const AppRoute = Symbol.for("RouteConfigAppRoutes");

function render$18(_ctx, _cache) {
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, { loading: _ctx.isLoading }, {
    default: withCtx(() => [
      (_ctx.references.length > 0)
        ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(_component_v_card_text, null, {
              default: withCtx(() => [
                createElementVNode("p", null, "Folgende Objekte enthalten einen direkten Verweis auf dieses " + toDisplayString(_ctx.$formatters.entityNameSingular(_ctx.kind)) + ".", 1),
                _cache[0] || (_cache[0] = createElementVNode("p", null, [
                  createElementVNode("strong", null, "Wichtig:"),
                  createTextVNode(" Verweise über Tags wurden nicht berücksichtigt.")
                ], -1))
              ]),
              _: 1
            }),
            createVNode(_component_v_list, null, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.references, (item) => {
                  return (openBlock(), createBlock(_component_v_list_item, {
                    title: _ctx.$formatters.multilingual(item.displayName)
                  }, {
                    append: withCtx(() => [
                      createVNode(_component_v_btn, {
                        variant: "text",
                        icon: _ctx.$icons.mdiOpenInNew,
                        onClick: $event => (_ctx.openReference(item)),
                        "v:tooltip:bottom": "'In neuem Tab öffnen'"
                      }, null, 8, ["icon", "onClick"])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 256))
              ]),
              _: 1
            })
          ], 64))
        : (openBlock(), createBlock(_component_v_card_text, { key: 1 }, {
            default: withCtx(() => [
              createElementVNode("p", null, "Es bestehen keine direkten Verweise auf dieses " + toDisplayString(_ctx.$formatters.entityNameSingular(_ctx.kind)) + ".", 1),
              _cache[1] || (_cache[1] = createElementVNode("p", null, [
                createElementVNode("strong", null, "Wichtig:"),
                createTextVNode(" Verweise über Tags wurden nicht berücksichtigt.")
              ], -1))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["loading"]))
}

IconRegistry.add({
    mdiOpenInNew
});
class EntityReferences extends Vue {
    get service() {
        switch(this.kind){
            case EntityKind.Document:
                return this.documentService;
            case EntityKind.Asset:
                return this.assetService;
        }
    }
    async mounted() {
        try {
            this.isLoading = true;
            this.references = await this.service.getReferences(this.entityId);
        } catch (e) {
            this.notificationService.showError("Die Daten konnten nicht geladen werden.");
        } finally{
            this.isLoading = false;
        }
    }
    openReference(selector) {
        let path = this.$router.resolve({
            name: getRouteName(selector.kind),
            params: {
                id: selector.id
            }
        });
        window.open(path.href, "_blank");
        function getRouteName(kind) {
            switch(kind){
                case EntityKind.Document:
                    return RouteNames.Documents.Edit;
                case EntityKind.Asset:
                    return RouteNames.Assets.Edit;
            }
        }
    }
    constructor(...args){
        super(...args), this.references = [], this.isLoading = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], EntityReferences.prototype, "documentService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], EntityReferences.prototype, "assetService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], EntityReferences.prototype, "notificationService", void 0);
_([
    Prop({
        type: String
    }),
    _$1("design:type", typeof EntityKind === "undefined" ? Object : EntityKind)
], EntityReferences.prototype, "kind", void 0);
_([
    Prop(),
    _$1("design:type", typeof Id === "undefined" ? Object : Id)
], EntityReferences.prototype, "entityId", void 0);
EntityReferences = _([
    Component({
        render: render$18
    })
], EntityReferences);

const __vite_glob_0_2 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get EntityReferences () { return EntityReferences; }
}, Symbol.toStringTag, { value: 'Module' }));

IconRegistry.add({
    mdiPencil,
    mdiCheck,
    mdiDotsHorizontal
});
const propertyHeaders$1 = [
    {
        text: "Key",
        value: "key",
        width: "9em"
    },
    {
        text: "Value",
        value: "value"
    }
];
class DocumentListItem extends Vue {
    get routeNames() {
        return RouteNames;
    }
    get name() {
        return Multilingual.getValue(this.document.name) || "Ohne Titel";
    }
    get description() {
        return Multilingual.getValue(this.document.description) || "";
    }
    get tags() {
        return this.document && this.document.tags || [];
    }
    get iconUrl() {
        return getDocumentTypeIconSvg(this.document.modelType, 64);
    }
    get type() {
        return this.store.types?.find((t)=>t.type === this.document.modelType) ?? null;
    }
    get canDelete() {
        return this.document.canDelete;
    }
    get canUpdate() {
        return this.document.canUpdate;
    }
    get canDuplicate() {
        return this.document.canDuplicate;
    }
    get propertyHeaders() {
        return propertyHeaders$1;
    }
    get properties() {
        return Object.entries(this.document).map(([key, value])=>{
            let formattedValue = value?.toString();
            if (Array.isArray(value)) {
                formattedValue = value.join(", ");
            } else if (Multilingual.is(value)) {
                formattedValue = Multilingual.getValue(value);
            }
            return {
                key,
                value: formattedValue
            };
        });
    }
    onIsContextMenuOpenChanged() {
        if (!this.isContextMenuOpen) {
            let deleteConfirm = this.$refs.deleteConfirm;
            deleteConfirm?.reset();
            let discardDraftConfirm = this.$refs.discardDraftConfirm;
            discardDraftConfirm?.reset();
        }
    }
    mounted() {
        eventBus.on(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    beforeDestroy() {
        eventBus.off(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    onEventBusContextMenuOpen(e) {
        if (e.sender !== this) {
            this.isContextMenuOpen = false;
        }
    }
    open() {
        if (this.isPassive) {
            return;
        }
        this.openEditor();
    }
    deleteDocument() {
        let args = {
            id: this.document.id,
            name: Multilingual.getValue(this.document.name)
        };
        this.$emit(DeleteEvent, args);
    }
    discardDraft() {
        let args = {
            id: this.document.id,
            name: Multilingual.getValue(this.document.name)
        };
        this.$emit(DiscardDraftEvent, args);
    }
    openEditor() {
        let args = {
            id: this.document.id,
            openDraft: this.document.isDraft
        };
        this.$emit(OpenEditorEvent, args);
    }
    showProperties() {
        this.isPropertiesPanelOpen = true;
    }
    showReferences() {
        this.isReferencesPanelOpen = true;
    }
    duplicate() {
        let args = {
            id: this.document.id,
            name: Multilingual.getValue(this.document.name)
        };
        this.$emit(DuplicateEvent, args);
    }
    publish() {
        let args = {
            id: this.document.id,
            name: Multilingual.getValue(this.document.name)
        };
        this.$emit(PublishEvent, args);
    }
    unpublish() {
        let args = {
            id: this.document.id,
            name: Multilingual.getValue(this.document.name)
        };
        this.$emit(UnpublishEvent, args);
    }
    toggleSelection() {
        let args = {
            id: this.document.id,
            isDraft: this.document.isDraft
        };
        this.$emit(ToggleSelectionEvent, args);
    }
    onContextMenu(e) {
        e.preventDefault();
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.isContextMenuOpen = false;
        this.contextMenuX = e.clientX;
        this.contextMenuY = e.clientY;
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    openContextMenu() {
        this.closeContextMenu();
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    closeContextMenu() {
        this.isContextMenuOpen = false;
        this.contextMenuX = null;
        this.contextMenuY = null;
    }
    constructor(...args){
        super(...args), this.store = new DocumentModule(), this.isContextMenuOpen = false, this.contextMenuY = null, this.contextMenuX = null, this.isPropertiesPanelOpen = false, this.isReferencesPanelOpen = false, this.references = [], this.isLoading = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], DocumentListItem.prototype, "documentService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], DocumentListItem.prototype, "notificationService", void 0);
_([
    Prop(),
    _$1("design:type", typeof Models === "undefined" || typeof Models.DocumentListItem === "undefined" ? Object : Models.DocumentListItem)
], DocumentListItem.prototype, "document", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], DocumentListItem.prototype, "unselectable", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], DocumentListItem.prototype, "isPassive", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], DocumentListItem.prototype, "isSelected", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], DocumentListItem.prototype, "hideMetadata", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], DocumentListItem.prototype, "showPublishStatus", void 0);
_([
    Watch(nameof("isContextMenuOpen")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], DocumentListItem.prototype, "onIsContextMenuOpenChanged", null);
DocumentListItem = _([
    Component({
        render: render$19,
        emits: [
            DeleteEvent,
            DiscardDraftEvent,
            OpenEditorEvent,
            DuplicateEvent,
            PublishEvent,
            ToggleSelectionEvent,
            UnpublishEvent,
            OpenContextMenuEvent
        ],
        components: {
            EntityReferences
        }
    })
], DocumentListItem);

const _hoisted_1$T = { class: "text-body-2" };

function render$17(_ctx, _cache) {
  const _component_asset_thumbnail = resolveComponent("asset-thumbnail");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_chip_group = resolveComponent("v-chip-group");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, {
    variant: "flat",
    color: "surfaceContainerHigh"
  }, {
    default: withCtx(() => [
      (_ctx.value != null)
        ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(_component_asset_thumbnail, {
              asset: _ctx.value,
              showPublishStatus: false
            }, null, 8, ["asset"]),
            createVNode(_component_v_card_text, null, {
              default: withCtx(() => [
                createVNode(_component_v_tooltip, { location: "bottom" }, {
                  activator: withCtx(({ props }) => [
                    createElementVNode("div", mergeProps({ class: "text-truncate body-2" }, props), toDisplayString(_ctx.$formatters.multilingual(_ctx.value.name)), 17)
                  ]),
                  default: withCtx(() => [
                    createElementVNode("p", null, toDisplayString(_ctx.$formatters.multilingual(_ctx.value.name)), 1),
                    createElementVNode("p", _hoisted_1$T, toDisplayString(_ctx.$formatters.multilingual(_ctx.value.description)), 1),
                    createVNode(_component_v_chip_group, {
                      column: "",
                      label: "",
                      density: "compact"
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.value.tags, (tag) => {
                          return (openBlock(), createBlock(_component_v_chip, { size: "x-small" }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(tag), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 256))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : createCommentVNode("", true)
    ]),
    _: 1
  }))
}

class AssetGridItem extends Vue {
}
_([
    Model(),
    _$1("design:type", typeof Models === "undefined" || typeof Models.EntityListItem === "undefined" ? Object : Models.EntityListItem)
], AssetGridItem.prototype, "value", void 0);
_([
    Prop(),
    _$1("design:type", Boolean)
], AssetGridItem.prototype, "selected", void 0);
AssetGridItem = _([
    Component({
        render: render$17,
        components: {
            AssetThumbnail
        }
    })
], AssetGridItem);

function render$16(_ctx, _cache) {
  const _component_v_window_item = resolveComponent("v-window-item");
  const _component_v_window = resolveComponent("v-window");

  return (openBlock(), createBlock(_component_v_window, {
    modelValue: _ctx.state,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.state) = $event))
  }, {
    default: withCtx(() => [
      createVNode(_component_v_window_item, { value: "normal" }, {
        default: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.component), mergeProps({
            onClick: _cache[0] || (_cache[0] = withModifiers($event => (_ctx.confirm()), ["stop"]))
          }, _ctx.$attrs), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16))
        ]),
        _: 3
      }),
      createVNode(_component_v_window_item, { value: "confirm" }, {
        default: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.component), mergeProps({
            color: "warning",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.execute()))
          }, _ctx.$attrs), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "confirm")
            ]),
            _: 3
          }, 16))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}

let InlineConfirm$1 = class InlineConfirm extends Vue {
    confirm() {
        this.state = "confirm";
        this.resetHandle = window.setTimeout(this.reset, 3000);
    }
    execute() {
        this.$emit("confirmed");
        this.reset();
    }
    reset() {
        this.state = "normal";
        if (this.resetHandle != null) {
            window.clearTimeout(this.resetHandle);
        }
    }
    constructor(...args){
        super(...args), this.state = "normal", this.resetHandle = null;
    }
};
_([
    Prop({
        required: true
    }),
    _$1("design:type", String)
], InlineConfirm$1.prototype, "component", void 0);
InlineConfirm$1 = _([
    Component({
        render: render$16,
        emits: [
            "confirmed"
        ]
    })
], InlineConfirm$1);

const __vite_glob_0_6 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get InlineConfirm () { return InlineConfirm$1; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$S = { class: "mr-4" };
const _hoisted_2$G = { class: "d-flex flex-column align-end" };
const _hoisted_3$z = {
  key: 0,
  class: "text-caption"
};
const _hoisted_4$d = { key: 0 };
const _hoisted_5$a = { key: 1 };
const _hoisted_6$8 = { class: "d-flex" };
const _hoisted_7$7 = { class: "flex-grow-1" };
const _hoisted_8$5 = { class: "mb-1" };
const _hoisted_9$3 = { class: "entity-properties" };

function render$15(_ctx, _cache) {
  const _component_v_checkbox_btn = resolveComponent("v-checkbox-btn");
  const _component_asset_thumbnail = resolveComponent("asset-thumbnail");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_data_table = resolveComponent("v-data-table");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_entity_references = resolveComponent("entity-references");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_list_item, {
      lines: "three",
      class: normalizeClass(["asset-list-item", { 'asset-list-item--unselectable': _ctx.unselectable }]),
      title: _ctx.name,
      subtitle: _ctx.description,
      ripple: !_ctx.unselectable,
      onClick: _ctx.open,
      onContextmenu: _ctx.onContextMenu,
      onDrop: _ctx.onDrop,
      onDragover: _ctx.onDragOver,
      onDragleave: _ctx.onDragLeave
    }, {
      prepend: withCtx(() => [
        (!_ctx.isPassive)
          ? (openBlock(), createBlock(_component_v_checkbox_btn, {
              key: 0,
              "hide-details": "",
              class: "asset-list-item__checkbox",
              onClick: withModifiers(_ctx.toggleSelection, ["stop"]),
              modelValue: _ctx.isSelected
            }, null, 8, ["onClick", "modelValue"]))
          : createCommentVNode("", true),
        createElementVNode("div", _hoisted_1$S, [
          createVNode(_component_asset_thumbnail, {
            asset: _ctx.asset,
            width: _ctx.thumbnailHeight / 2 * 3,
            height: _ctx.thumbnailHeight,
            "show-publish-status": _ctx.showPublishStatus
          }, null, 8, ["asset", "width", "height", "show-publish-status"])
        ])
      ]),
      append: withCtx(() => [
        createElementVNode("div", _hoisted_2$G, [
          (!_ctx.hideMetadata)
            ? (openBlock(), createElementBlock("div", _hoisted_3$z, "Geändert: " + toDisplayString(_ctx.$formatters.date(_ctx.asset.lastModified, 'd.M.y HH:mm')), 1))
            : createCommentVNode("", true),
          (!_ctx.isPassive)
            ? (openBlock(), createBlock(_component_v_menu, {
                key: 1,
                absolute: "",
                target: _ctx.contextMenuX ? [_ctx.contextMenuX, _ctx.contextMenuY] : null,
                modelValue: _ctx.isContextMenuOpen,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.isContextMenuOpen) = $event))
              }, {
                activator: withCtx(({ props }) => [
                  createVNode(_component_v_btn, mergeProps({
                    variant: "text",
                    icon: _ctx.$icons.mdiDotsHorizontal
                  }, props, {
                    onClick: withModifiers(_ctx.openContextMenu, ["stop","prevent"])
                  }), null, 16, ["icon", "onClick"])
                ]),
                default: withCtx(() => [
                  createVNode(_component_v_list, null, {
                    default: withCtx(() => [
                      (_ctx.canDelete)
                        ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            (_ctx.asset.hasDraft || _ctx.asset.isDraft)
                              ? (openBlock(), createBlock(_component_inline_confirm, {
                                  key: 0,
                                  component: "v-list-item",
                                  onConfirmed: _cache[0] || (_cache[0] = $event => (_ctx.discardDraft())),
                                  ref: "discardDraftConfirm"
                                }, {
                                  confirm: withCtx(() => [
                                    createVNode(_component_v_btn, {
                                      depressed: "",
                                      color: "warning"
                                    }, {
                                      default: withCtx(() => _cache[12] || (_cache[12] = [
                                        createTextVNode("Bestätigen")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: withCtx(() => [
                                    (_ctx.asset.hasPublished)
                                      ? (openBlock(), createElementBlock("span", _hoisted_4$d, "Entwurf verwerfen"))
                                      : (openBlock(), createElementBlock("span", _hoisted_5$a, "Löschen"))
                                  ]),
                                  _: 1
                                }, 512))
                              : createCommentVNode("", true),
                            (_ctx.asset.hasPublished)
                              ? (openBlock(), createBlock(_component_inline_confirm, {
                                  key: 1,
                                  component: "v-list-item",
                                  onConfirmed: _cache[1] || (_cache[1] = $event => (_ctx.deleteAsset())),
                                  ref: "deleteConfirm"
                                }, {
                                  confirm: withCtx(() => [
                                    createVNode(_component_v_btn, {
                                      depressed: "",
                                      color: "warning"
                                    }, {
                                      default: withCtx(() => _cache[13] || (_cache[13] = [
                                        createTextVNode("Bestätigen")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  default: withCtx(() => [
                                    _cache[14] || (_cache[14] = createElementVNode("span", null, "Löschen", -1))
                                  ]),
                                  _: 1
                                }, 512))
                              : createCommentVNode("", true)
                          ], 64))
                        : createCommentVNode("", true),
                      (_ctx.canUpdate)
                        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            (_ctx.asset.isDraft)
                              ? (openBlock(), createBlock(_component_v_list_item, {
                                  key: 0,
                                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.publish()))
                                }, {
                                  default: withCtx(() => _cache[15] || (_cache[15] = [
                                    createTextVNode("Publizieren")
                                  ])),
                                  _: 1
                                }))
                              : createCommentVNode("", true),
                            (!_ctx.asset.isDraft)
                              ? (openBlock(), createBlock(_component_v_list_item, {
                                  key: 1,
                                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.unpublish()))
                                }, {
                                  default: withCtx(() => _cache[16] || (_cache[16] = [
                                    createTextVNode("Unpublizieren")
                                  ])),
                                  _: 1
                                }))
                              : createCommentVNode("", true)
                          ], 64))
                        : createCommentVNode("", true),
                      (!_ctx.asset.isDraft && _ctx.canDuplicate)
                        ? (openBlock(), createBlock(_component_v_list_item, {
                            key: 2,
                            onClick: _cache[4] || (_cache[4] = $event => (_ctx.duplicate()))
                          }, {
                            default: withCtx(() => _cache[17] || (_cache[17] = [
                              createTextVNode("Duplizieren")
                            ])),
                            _: 1
                          }))
                        : createCommentVNode("", true),
                      (_ctx.canUpdate)
                        ? (openBlock(), createBlock(_component_v_list_item, {
                            key: 3,
                            onClick: _cache[5] || (_cache[5] = $event => (_ctx.replace()))
                          }, {
                            default: withCtx(() => _cache[18] || (_cache[18] = [
                              createTextVNode("Ersetzen")
                            ])),
                            _: 1
                          }))
                        : createCommentVNode("", true),
                      createVNode(_component_v_list_item, {
                        onClick: _cache[6] || (_cache[6] = $event => (_ctx.download()))
                      }, {
                        default: withCtx(() => _cache[19] || (_cache[19] = [
                          createTextVNode("Herunterladen")
                        ])),
                        _: 1
                      }),
                      createVNode(_component_v_list_item, {
                        onClick: _cache[7] || (_cache[7] = $event => (_ctx.showReferences()))
                      }, {
                        default: withCtx(() => _cache[20] || (_cache[20] = [
                          createTextVNode("Referenzen anzeigen")
                        ])),
                        _: 1
                      }),
                      createVNode(_component_v_list_item, {
                        onClick: _cache[8] || (_cache[8] = $event => (_ctx.showProperties()))
                      }, {
                        default: withCtx(() => _cache[21] || (_cache[21] = [
                          createTextVNode("Eigenschaften")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["target", "modelValue"]))
            : createCommentVNode("", true)
        ])
      ]),
      title: withCtx(({ title }) => [
        createElementVNode("div", _hoisted_6$8, [
          createElementVNode("div", _hoisted_7$7, toDisplayString(title), 1)
        ])
      ]),
      subtitle: withCtx(({ subtitle }) => [
        createElementVNode("div", _hoisted_8$5, toDisplayString(subtitle), 1),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tags, (tag) => {
          return (openBlock(), createBlock(_component_v_chip, {
            label: "",
            size: "x-small",
            class: "mr-1",
            variant: "flat",
            color: "#e4e6eb"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(tag), 1)
            ]),
            _: 2
          }, 1024))
        }), 256))
      ]),
      default: withCtx(() => [
        createVNode(_component_v_overlay, {
          contained: "",
          class: "asset-list-item__drop-overlay align-center justify-center",
          scrim: "primary",
          opacity: 0.85,
          modelValue: _ctx.isDragging
        }, {
          default: withCtx(() => [
            createVNode(_component_v_row, { align: "center" }, {
              default: withCtx(() => [
                createVNode(_component_v_col, { cols: "auto" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, {
                      class: "text-onPrimary",
                      size: "64"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiCloudUploadOutline), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_col, { cols: "auto" }, {
                  default: withCtx(() => _cache[22] || (_cache[22] = [
                    createElementVNode("div", { class: "text-onPrimary text-h6" }, "Asset ersetzen", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["class", "title", "subtitle", "ripple", "onClick", "onContextmenu", "onDrop", "onDragover", "onDragleave"]),
    (_ctx.isPropertiesPanelOpen)
      ? (openBlock(), createBlock(_component_property_pane, {
          key: 0,
          title: "Eigenschaften",
          "is-active": "",
          onCancel: _cache[10] || (_cache[10] = $event => (_ctx.isPropertiesPanelOpen = false))
        }, {
          default: withCtx(({ value, setValue, ok, cancel }) => [
            createElementVNode("div", _hoisted_9$3, [
              createVNode(_component_v_data_table, {
                "hide-default-header": "",
                "hide-default-footer": "",
                "disable-pagination": "",
                headers: _ctx.propertyHeaders,
                items: _ctx.properties
              }, null, 8, ["headers", "items"])
            ])
          ]),
          actions: withCtx(({ cancel }) => [
            createVNode(_component_v_btn, {
              variant: "elevated",
              color: "primary",
              onClick: cancel
            }, {
              default: withCtx(() => _cache[23] || (_cache[23] = [
                createTextVNode("Schliessen")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }))
      : createCommentVNode("", true),
    (_ctx.isReferencesPanelOpen)
      ? (openBlock(), createBlock(_component_property_pane, {
          key: 1,
          title: "Verweise",
          "is-active": "",
          onCancel: _cache[11] || (_cache[11] = $event => (_ctx.isReferencesPanelOpen = false))
        }, {
          default: withCtx(({ value, setValue, ok, cancel }) => [
            createVNode(_component_entity_references, {
              kind: "asset",
              "entity-id": _ctx.asset.id
            }, null, 8, ["entity-id"])
          ]),
          actions: withCtx(({ cancel }) => [
            createVNode(_component_v_btn, {
              variant: "elevated",
              color: "primary",
              onClick: cancel
            }, {
              default: withCtx(() => _cache[24] || (_cache[24] = [
                createTextVNode("Schliessen")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }))
      : createCommentVNode("", true)
  ], 64))
}

const ReplaceAssetEvent = "replace";
const propertyHeaders = [
    {
        text: "Key",
        value: "key",
        width: "9em"
    },
    {
        text: "Value",
        value: "value"
    }
];
class AssetListItem extends Vue {
    get routeNames() {
        return RouteNames;
    }
    get id() {
        return `assetListItem-${this.asset.id}-${this.asset.isDraft ? "draft" : ""}`;
    }
    get name() {
        return Multilingual.getValue(this.asset.name) || "Ohne Titel";
    }
    get description() {
        return Multilingual.getValue(this.asset.description) || "";
    }
    get tags() {
        return this.asset && this.asset.tags || [];
    }
    get canDelete() {
        return this.asset.canDelete;
    }
    get canUpdate() {
        return this.asset.canUpdate;
    }
    get canDuplicate() {
        return this.asset.canDuplicate;
    }
    get propertyHeaders() {
        return propertyHeaders;
    }
    get properties() {
        return Object.entries(this.asset).map(([key, value])=>{
            let formattedValue = value?.toString();
            if (Array.isArray(value)) {
                formattedValue = value.join(", ");
            } else if (Multilingual.is(value)) {
                formattedValue = Multilingual.getValue(value);
            }
            return {
                key,
                value: formattedValue
            };
        });
    }
    onIsContextMenuOpenChanged() {
        if (!this.isContextMenuOpen) {
            let deleteConfirm = this.$refs.deleteConfirm;
            deleteConfirm?.reset();
            let discardDraftConfirm = this.$refs.discardDraftConfirm;
            discardDraftConfirm?.reset();
        }
    }
    mounted() {
        eventBus.on(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    beforeDestroy() {
        eventBus.off(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    onEventBusContextMenuOpen(e) {
        if (e.sender !== this) {
            this.isContextMenuOpen = false;
        }
    }
    open() {
        if (this.isPassive) {
            return;
        }
        this.openEditor();
    }
    openEditor() {
        let args = {
            id: this.asset.id,
            openDraft: this.asset.isDraft
        };
        this.$emit(OpenEditorEvent, args);
    }
    discardDraft() {
        let args = {
            id: this.asset.id,
            name: Multilingual.getValue(this.asset.name)
        };
        this.$emit(DiscardDraftEvent, args);
    }
    deleteAsset() {
        let args = {
            id: this.asset.id,
            name: Multilingual.getValue(this.asset.name)
        };
        this.$emit(DeleteEvent, args);
    }
    showProperties() {
        this.isPropertiesPanelOpen = true;
    }
    duplicate() {
        let args = {
            id: this.asset.id,
            name: Multilingual.getValue(this.asset.name)
        };
        this.$emit(DuplicateEvent, args);
    }
    publish() {
        let args = {
            id: this.asset.id,
            name: Multilingual.getValue(this.asset.name)
        };
        this.$emit(PublishEvent, args);
    }
    async showReferences() {
        this.isReferencesPanelOpen = true;
        try {
            this.isLoading = true;
            this.references = await this.assetService.getReferences(this.asset.id);
        } catch (e) {
            this.notificationService.showError("Die Daten konnten nicht geladen werden.");
        } finally{
            this.isLoading = false;
        }
    }
    unpublish() {
        let args = {
            id: this.asset.id,
            name: Multilingual.getValue(this.asset.name)
        };
        this.$emit(UnpublishEvent, args);
    }
    async download() {
        let anchor = document.createElement("a");
        anchor.href = await this.assetService.getBlobUrl(this.asset.id, this.asset.isDraft);
        anchor.download = this.asset.fileName;
        anchor.target = "_blank";
        anchor.click();
    }
    toggleSelection() {
        let args = {
            id: this.asset.id,
            isDraft: this.asset.isDraft
        };
        this.$emit(ToggleSelectionEvent, args);
    }
    async replace() {
        let file = await selectFile();
        if (file != null) {
            let args = {
                id: this.asset.id,
                isDraft: this.asset.isDraft,
                name: this.name,
                file
            };
            this.$emit(ReplaceAssetEvent, args);
        } else {
            this.notificationService.showError("Keine Datei ausgewählt.");
        }
    }
    async onDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        if (event.dataTransfer?.items != null) {
            let files = Array.from(event.dataTransfer.items).filter((x)=>x.kind === "file").map((x)=>x.getAsFile()).filter(notEmpty$1);
            if (files.length === 1) {
                let args = {
                    id: this.asset.id,
                    isDraft: this.asset.isDraft,
                    name: this.name,
                    file: files[0]
                };
                this.$emit(ReplaceAssetEvent, args);
            }
        }
    }
    onDragOver(event) {
        window.clearTimeout(this.resetDraggingStateHandle);
        this.isDragging = true;
        if (event.dataTransfer != null) {
            event.dataTransfer.dropEffect = "copy";
        }
        event.stopPropagation();
        event.preventDefault();
    }
    onDragLeave(event) {
        this.resetDraggingStateHandle = window.setTimeout(()=>this.isDragging = false, 100);
    }
    onContextMenu(e) {
        e.preventDefault();
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.isContextMenuOpen = false;
        this.contextMenuX = e.clientX;
        this.contextMenuY = e.clientY;
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    openContextMenu() {
        this.closeContextMenu();
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    closeContextMenu() {
        this.isContextMenuOpen = false;
        this.contextMenuX = null;
        this.contextMenuY = null;
    }
    transformIconName(iconName) {
        return iconName.replace(/(-.)/g, (match)=>match.substring(1).toUpperCase());
    }
    constructor(...args){
        super(...args), this.assetStore = new AssetModule(), this.isContextMenuOpen = false, this.contextMenuY = null, this.contextMenuX = null, this.isPropertiesPanelOpen = false, this.isDragging = false, this.resetDraggingStateHandle = null, this.isReferencesPanelOpen = false, this.references = [], this.isLoading = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetListItem.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetListItem.prototype, "assetService", void 0);
_([
    Prop({
        required: true
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.AssetListItem === "undefined" ? Object : Models.AssetListItem)
], AssetListItem.prototype, "asset", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetListItem.prototype, "unselectable", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetListItem.prototype, "isPassive", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetListItem.prototype, "showPublishStatus", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetListItem.prototype, "isSelected", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetListItem.prototype, "hideMetadata", void 0);
_([
    Watch(nameof("isContextMenuOpen")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], AssetListItem.prototype, "onIsContextMenuOpenChanged", null);
AssetListItem = _([
    Component({
        emits: [
            DiscardDraftEvent,
            DeleteEvent,
            OpenEditorEvent,
            DuplicateEvent,
            PublishEvent,
            ToggleSelectionEvent,
            UnpublishEvent,
            OpenContextMenuEvent,
            ReplaceAssetEvent
        ]
    })
], AssetListItem);

IconRegistry.add({
    mdiCloudUploadOutline,
    mdiPencil,
    mdiCheck,
    mdiDotsHorizontal
});
class AssetListItemDetail extends AssetListItem {
}
_([
    Prop({
        required: false,
        default: 64
    }),
    _$1("design:type", Number)
], AssetListItemDetail.prototype, "thumbnailHeight", void 0);
AssetListItemDetail = _([
    Component({
        render: render$15,
        components: {
            AssetThumbnail,
            InlineConfirm: InlineConfirm$1
        }
    })
], AssetListItemDetail);

var LoadingState = /*#__PURE__*/ function(LoadingState) {
    LoadingState["Empty"] = "empty";
    LoadingState["Loading"] = "loading";
    LoadingState["Results"] = "results";
    LoadingState["NoResults"] = "no-results";
    LoadingState["Error"] = "error";
    return LoadingState;
}({});
var HttpMethod = /*#__PURE__*/ function(HttpMethod) {
    HttpMethod["Get"] = "GET";
    HttpMethod["Post"] = "POST";
    HttpMethod["Put"] = "PUT";
    HttpMethod["Delete"] = "DELETE";
    HttpMethod["Patch"] = "PATCH";
    HttpMethod["Options"] = "OPTIONS";
    return HttpMethod;
}({});
var HttpHeader = /*#__PURE__*/ function(HttpHeader) {
    HttpHeader["Accept"] = "Accept";
    HttpHeader["ContentType"] = "Content-Type";
    HttpHeader["Location"] = "Location";
    return HttpHeader;
}({});

IconRegistry.add({
    mdiCloudUploadOutline,
    mdiImageSearch,
    mdiDatabaseSearch,
    mdiImageBroken,
    mdiDatabaseOff
});
class IdSelectorComponent extends Vue {
    get thumbnailCols() {
        switch(this.thumbnailColumns){
            case 2:
                return 6;
            case 3:
                return 4;
            case 4:
                return 3;
            default:
                return 2;
        }
    }
    get isImageAsset() {
        if (this.kind === EntityKind.Document || this.selectedEntity == null) {
            return false;
        }
        let asset = this.selectedEntity;
        return asset.contentType.startsWith("image/");
    }
    get emptyIcon() {
        switch(this.kind){
            case EntityKind.Asset:
                return mdiImageSearch;
            case EntityKind.Document:
                return mdiDatabaseSearch;
        }
    }
    get notFoundIcon() {
        switch(this.kind){
            case EntityKind.Asset:
                return mdiImageBroken;
            case EntityKind.Document:
                return mdiDatabaseOff;
        }
    }
    get entityService() {
        // TODO: refactor to take advantage of DI
        switch(this.kind){
            case EntityKind.Document:
                return this.documentService;
            case EntityKind.Asset:
                return this.assetService;
        }
    }
    get selectedEntityDisplayName() {
        return Multilingual.getValue(this.selectedEntity?.name) ?? `Kein ${this.$formatters.entityNameSingular(this.kind)} ausgewählt.`;
    }
    onQueryChanged() {
        if (this.query != null && this.query.length >= 1) {
            this.searchDebounced();
        } else {
            this.queryResults = [];
            this.listState = LoadingState.Empty;
        }
    }
    onTypeChanged() {
        this.listState = LoadingState.Empty;
        this.state = "empty";
        this.selectedEntity = null;
        this.onQueryChanged();
    }
    async onValueChanged(current, previous) {
        if (current?.id === previous?.id) {
            return;
        }
        if (IdSelector.isEmptyOrNull(this.value)) {
            this.state = "empty";
            return;
        }
        try {
            this.state = "loading";
            this.selectedEntity = await this.entityService.getHeaders(this.value.id);
            this.state = this.selectedEntity !== null ? "selected" : "notFound";
            this.$emit("selected", this.selectedEntity);
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError(`Beim Laden des ${this.$formatters.entityNameSingular(this.kind)}s ist ein Fehler aufgetreten.`, e);
                this.state = "notFound";
            } else {
                throw e;
            }
        }
    }
    onListSelectionStateChanged() {
        if (isNullOrEmpty(this.query)) {
            // don't clear the model if the query is cleared (and the results disappear)
            return;
        }
        this.select(this.listSelectionState);
        if (this.clearOnSelect) {
            this.query = "";
        }
    }
    onDocumentListSelectionChanged(selected) {
        if (isNullOrEmpty(this.query)) {
            // don't clear the model if the query is cleared (and the results disappear)
            return;
        }
        this.select(selected[0]);
        if (this.clearOnSelect) {
            this.query = "";
        }
    }
    select(entity) {
        this.$emit("selected", entity);
        if (entity == null) {
            this.$emit("update:modelValue", null);
        } else {
            let args = {
                id: entity.id,
                kind: this.kind,
                displayName: entity.name,
                displayDescription: entity.description
            };
            if (this.kind === EntityKind.Asset) {
                args.fileName = entity.fileName;
            }
            this.$emit("update:modelValue", args);
        }
    }
    async created() {
        await this.documentStore.loadTypes();
        this.onValueChanged(this.value, null);
    }
    async search() {
        try {
            this.listState = LoadingState.Loading;
            this.queryResults = await this.entityService.search({
                query: this.query,
                type: this.assemblyType
            });
            this.listState = this.queryResults.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError("Beim Suchen ist ein Fehler aufgetreten.", e);
                this.listState = LoadingState.NoResults;
            } else {
                throw e;
            }
        }
    }
    showLargeImage() {}
    async onDrop(event) {
        if (this.disabled || this.kind != EntityKind.Asset) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        if (event.dataTransfer?.items == null) {
            return;
        }
        var files = Array.from(event.dataTransfer.items).filter((x)=>x.kind === "file").map((x)=>x.getAsFile()).filter(notEmpty$1);
        // only allow a single file to be dropped/uploaded
        if (files.length !== 1) {
            return;
        }
        try {
            this.state = "uploading";
            this.upload = await this.assetStore.createAndUpload(files[0]);
            let newAssetId = this.upload.id;
            await this.assetService.publish(newAssetId);
            this.assetStore.removeUpload(newAssetId);
            this.upload = null;
            let entity = await this.assetService.getHeaders(newAssetId);
            this.select(entity);
        } catch (e) {
            this.notificationService.showError("Das Asset konnte nicht hochgeladen werden.", e);
            this.state == "empty";
        }
    }
    onDragOver(event) {
        if (this.disabled || this.kind != EntityKind.Asset) {
            return;
        }
        this.isDragging = true;
        if (event.dataTransfer != null) {
            event.dataTransfer.dropEffect = "copy";
        }
        event.stopPropagation();
        event.preventDefault();
    }
    onDragLeave(event) {
        if (this.disabled || this.kind != EntityKind.Asset) {
            return;
        }
        if (event.target?.classList.contains("id-selector__drop-overlay")) {
            this.isDragging = false;
        }
    }
    constructor(...args){
        super(...args), this.assetStore = new AssetModule(), this.documentStore = new DocumentModule(), this.state = "empty", this.listState = LoadingState.Empty, this.query = "", this.queryResults = [], this.selectedEntity = null, this.listSelectionState = null, this.isDragging = false, this.upload = null, this.searchDebounced = debounce$1(this.search, 350);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], IdSelectorComponent.prototype, "documentService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], IdSelectorComponent.prototype, "assetService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], IdSelectorComponent.prototype, "notificationService", void 0);
_([
    Model({
        type: Object
    }),
    _$1("design:type", typeof Models$1 === "undefined" || typeof IdSelector === "undefined" ? Object : IdSelector)
], IdSelectorComponent.prototype, "value", void 0);
_([
    Prop({
        required: true,
        type: String
    }),
    _$1("design:type", typeof Models$1 === "undefined" || typeof EntityKind === "undefined" ? Object : EntityKind)
], IdSelectorComponent.prototype, "kind", void 0);
_([
    Prop({
        default: "view"
    }),
    _$1("design:type", String)
], IdSelectorComponent.prototype, "mode", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], IdSelectorComponent.prototype, "showEditButton", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], IdSelectorComponent.prototype, "disabled", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], IdSelectorComponent.prototype, "clearOnSelect", void 0);
_([
    Prop(),
    _$1("design:type", Object)
], IdSelectorComponent.prototype, "assemblyType", void 0);
_([
    Prop({
        default: 6
    }),
    _$1("design:type", Number)
], IdSelectorComponent.prototype, "thumbnailColumns", void 0);
_([
    Watch(nameof("query")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], IdSelectorComponent.prototype, "onQueryChanged", null);
_([
    Watch(nameof("kind")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], IdSelectorComponent.prototype, "onTypeChanged", null);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        Object,
        Object
    ]),
    _$1("design:returntype", Promise)
], IdSelectorComponent.prototype, "onValueChanged", null);
_([
    Watch(nameof("listSelectionState")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], IdSelectorComponent.prototype, "onListSelectionStateChanged", null);
IdSelectorComponent = _([
    Component({
        render: render$1b,
        emits: [
            "selected",
            "update:modelValue"
        ],
        components: {
            AssetThumbnail,
            AssetGridItem,
            DocumentListItem,
            AssetListItemDetail
        }
    })
], IdSelectorComponent);

const __vite_glob_0_4 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get IdSelectorComponent () { return IdSelectorComponent; }
}, Symbol.toStringTag, { value: 'Module' }));

function render$14(_ctx, _cache) {
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_id_selector_component = resolveComponent("id-selector-component");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, null, {
    default: withCtx(() => [
      createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTabIndex,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.activeTabIndex) = $event))
      }, {
        default: withCtx(() => [
          createVNode(_component_v_tab, { disabled: _ctx.disabled }, {
            default: withCtx(() => _cache[2] || (_cache[2] = [
              createTextVNode("URL")
            ])),
            _: 1
          }, 8, ["disabled"]),
          createVNode(_component_v_tab, { disabled: _ctx.disabled }, {
            default: withCtx(() => _cache[3] || (_cache[3] = [
              createTextVNode("Dokument")
            ])),
            _: 1
          }, 8, ["disabled"]),
          createVNode(_component_v_tab, { disabled: _ctx.disabled }, {
            default: withCtx(() => _cache[4] || (_cache[4] = [
              createTextVNode("Asset")
            ])),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      createVNode(_component_v_tabs_window, {
        modelValue: _ctx.activeTabIndex,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.activeTabIndex) = $event))
      }, {
        default: withCtx(() => [
          createVNode(_component_v_tabs_window_item, { disabled: _ctx.disabled }, {
            default: withCtx(() => [
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_v_text_field, {
                    label: "Internetadresse (URL)",
                    autocomplete: "off",
                    "prepend-inner-icon": _ctx.$icons.mdiWeb,
                    type: "url",
                    disabled: _ctx.disabled,
                    modelValue: _ctx.url,
                    "onUpdate:modelValue": _ctx.onUrlChanged
                  }, null, 8, ["prepend-inner-icon", "disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          createVNode(_component_v_tabs_window_item, { disabled: _ctx.disabled }, {
            default: withCtx(() => [
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_id_selector_component, {
                    kind: "document",
                    mode: "edit",
                    disabled: _ctx.disabled,
                    modelValue: _ctx.documentSelector,
                    "is-frameless": "",
                    "onUpdate:modelValue": _ctx.onDocumentSelected
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"]),
          createVNode(_component_v_tabs_window_item, { disabled: _ctx.disabled }, {
            default: withCtx(() => [
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_id_selector_component, {
                    kind: "asset",
                    mode: "edit",
                    disabled: _ctx.disabled,
                    modelValue: _ctx.assetSelector,
                    "is-frameless": "",
                    "onUpdate:modelValue": _ctx.onAssetSelected
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiWeb
});
class UrlPicker extends Vue {
    get selector() {
        switch(this.activeTabIndex){
            case 1:
                return this.documentSelector;
            case 2:
                return this.assetSelector;
            default:
                return null;
        }
    }
    created() {
        this.onValueChanged();
    }
    onValueChanged() {
        if (isNullOrEmpty(this.value)) {
            this.assetSelector = null;
            this.documentSelector = null;
            this.url = null;
        }
        let selector = IdSelector.fromUrl(this.value);
        if (selector != null) {
            if (selector.kind === EntityKind.Document) {
                this.url = null;
                this.documentSelector = selector;
                this.assetSelector = null;
                this.activeTabIndex = 1;
            } else if (selector.kind === EntityKind.Asset) {
                this.url = null;
                this.documentSelector = null;
                this.assetSelector = selector;
                this.activeTabIndex = 2;
            }
        } else {
            this.url = this.value;
            this.documentSelector = null;
            this.assetSelector = null;
            this.activeTabIndex = 0;
        }
    }
    onUrlChanged(value) {
        if (value.startsWith("/")) {
            // local path
            this.url = value;
        } else {
            let matches = Autolinker.parse(value, {});
            if (matches?.length > 0) {
                this.url = matches[0].getAnchorHref();
            } else {
                this.url = value;
            }
        }
        this.documentSelector = null;
        this.assetSelector = null;
        this.patch();
    }
    onDocumentSelected(selector) {
        this.url = null;
        this.documentSelector = selector;
        this.assetSelector = null;
        this.patch();
    }
    onAssetSelected(selector) {
        this.url = null;
        this.documentSelector = null;
        this.assetSelector = selector;
        this.patch();
    }
    patch() {
        if (this.selector != null) {
            this.$emit("update:modelValue", IdSelector.toUrl(this.selector));
        } else if (this.url != null) {
            this.$emit("update:modelValue", this.url);
        }
    }
    constructor(...args){
        super(...args), this.activeTabIndex = 0, this.assetSelector = null, this.documentSelector = null, this.url = null;
    }
}
_([
    Model(),
    _$1("design:type", String)
], UrlPicker.prototype, "value", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], UrlPicker.prototype, "disabled", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], UrlPicker.prototype, "onValueChanged", null);
UrlPicker = _([
    Component({
        render: render$14,
        components: {
            IdSelectorComponent
        }
    })
], UrlPicker);

const __vite_glob_0_13 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get UrlPicker () { return UrlPicker; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$R = { class: "loader-wrapper" };

function render$13(_ctx, _cache) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_overlay = resolveComponent("v-overlay");

  return (openBlock(), createElementBlock("div", _hoisted_1$R, [
    createVNode(_component_v_overlay, {
      contained: "",
      persistent: "",
      "no-click-animation": "",
      class: "align-center justify-center",
      attach: true,
      scrim: false,
      modelValue: _ctx.state !== 'results'
    }, {
      default: withCtx(() => [
        createVNode(_component_v_container, { class: "fill-height" }, {
          default: withCtx(() => [
            createVNode(_component_v_row, {
              align: "center",
              justify: "center"
            }, {
              default: withCtx(() => [
                (_ctx.state === 'empty')
                  ? renderSlot(_ctx.$slots, "empty", { key: 0 })
                  : createCommentVNode("", true),
                (_ctx.state === 'loading')
                  ? (openBlock(), createBlock(_component_v_col, {
                      key: 1,
                      cols: "auto",
                      class: "d-flex flex-column align-center"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_progress_circular, {
                          color: "primary",
                          size: 64,
                          width: 6,
                          indeterminate: ""
                        }),
                        _cache[0] || (_cache[0] = createElementVNode("p", { class: "body-2 mt-2" }, "Daten werden geladen …", -1))
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                (_ctx.state === 'no-results')
                  ? renderSlot(_ctx.$slots, "noresults", { key: 2 })
                  : createCommentVNode("", true),
                (_ctx.state === 'error')
                  ? renderSlot(_ctx.$slots, "error", { key: 3 })
                  : createCommentVNode("", true)
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue"]),
    (_ctx.state === 'results')
      ? renderSlot(_ctx.$slots, "default", { key: 0 })
      : createCommentVNode("", true)
  ]))
}

class LoaderWrapper extends Vue {
}
_([
    Prop({
        type: String,
        required: true
    }),
    _$1("design:type", typeof LoadingState === "undefined" ? Object : LoadingState)
], LoaderWrapper.prototype, "state", void 0);
LoaderWrapper = _([
    Component({
        render: render$13
    })
], LoaderWrapper);

const __vite_glob_0_7 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get LoaderWrapper () { return LoaderWrapper; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$Q = { class: "d-flex flex-column fill-height" };

function render$12(_ctx, _cache) {
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_navigation_drawer = resolveComponent("v-navigation-drawer");
  const _component_portal = resolveComponent("portal");
  const _directive_tooltip = resolveDirective("tooltip");
  const _directive_click_outside = resolveDirective("click-outside");

  return (openBlock(), createBlock(_component_portal, { to: "property-pane" }, {
    default: withCtx(() => [
      withDirectives((openBlock(), createBlock(_component_v_navigation_drawer, {
        order: -1,
        temporary: "",
        location: "right",
        width: _ctx.width,
        modelValue: _ctx.isPaneOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.isPaneOpen) = $event))
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$Q, [
            createVNode(_component_v_toolbar, { color: "background" }, {
              default: withCtx(() => [
                createVNode(_component_v_toolbar_title, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.title), 1)
                  ]),
                  _: 1
                }),
                createVNode(_component_v_spacer),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiClose,
                  onClick: _ctx.cancel
                }, null, 8, ["icon", "onClick"]), [
                  [_directive_tooltip, 'Schliessen', "bottom"]
                ])
              ]),
              _: 1
            }),
            createVNode(_component_v_sheet, {
              color: "background",
              class: "flex-grow-1 scroll-panel px-4 pb-4"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {
                  ok: _ctx.ok,
                  cancel: _ctx.cancel,
                  setValue: _ctx.setValue,
                  value: _ctx.value
                })
              ]),
              _: 3
            }),
            createVNode(_component_v_toolbar, {
              color: "background",
              class: "px-4"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "actions", {
                  ok: _ctx.ok,
                  cancel: _ctx.cancel,
                  clear: _ctx.clear
                }, () => [
                  createVNode(_component_v_btn, {
                    variant: "elevated",
                    color: "primary",
                    "prepend-icon": _ctx.$icons.mdiCheck,
                    onClick: _ctx.ok
                  }, {
                    default: withCtx(() => _cache[1] || (_cache[1] = [
                      createTextVNode("OK")
                    ])),
                    _: 1
                  }, 8, ["prepend-icon", "onClick"]),
                  createVNode(_component_v_btn, { onClick: _ctx.cancel }, {
                    default: withCtx(() => _cache[2] || (_cache[2] = [
                      createTextVNode("Abbrechen")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  createVNode(_component_v_spacer),
                  (_ctx.isClearable)
                    ? (openBlock(), createBlock(_component_v_btn, {
                        key: 0,
                        variant: "tonal",
                        color: "warning",
                        onClick: _ctx.clear,
                        "prepend-icon": _ctx.$icons.mdiDelete
                      }, {
                        default: withCtx(() => _cache[3] || (_cache[3] = [
                          createTextVNode("Entfernen")
                        ])),
                        _: 1
                      }, 8, ["onClick", "prepend-icon"]))
                    : createCommentVNode("", true)
                ])
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["width", "modelValue"])), [
        [_directive_click_outside, _ctx.onClickOutside]
      ])
    ]),
    _: 3
  }))
}

IconRegistry.add({
    mdiDelete,
    mdiCheck,
    mdiClose
});
class PropertyPane extends Vue {
    get isPaneOpen() {
        return this.isActive;
    }
    set isPaneOpen(isOpen) {
        if (!isOpen) {
            this.cancel();
        }
    }
    onInitialValueChanged() {
        if (this.initialValue != null) {
            this.value = this.initialValue;
        }
    }
    mounted() {
        this.onInitialValueChanged();
        window.addEventListener("keyup", this.onKeyUp);
    }
    beforeDestroy() {
        window.removeEventListener("keyup", this.onKeyUp);
    }
    onKeyUp(e) {
        if (e.key === "Esc" || e.key === "Escape") {
            this.cancel();
        }
    }
    onClickOutside(e) {
        let targetElement = e.target;
        if (targetElement.closest(".v-overlay") != null) {
            this.cancel();
        }
    }
    setValue(value) {
        this.value = value;
    }
    ok() {
        this.$emit("ok", this.value);
    }
    clear() {
        this.$emit("clear");
    }
    cancel() {
        this.$emit("cancel");
    }
    constructor(...args){
        super(...args), this.value = null;
    }
}
_([
    Prop({
        required: true
    }),
    _$1("design:type", String)
], PropertyPane.prototype, "title", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], PropertyPane.prototype, "isActive", void 0);
_([
    Prop({
        type: [
            Object,
            String,
            Number,
            Boolean
        ]
    }),
    _$1("design:type", Object)
], PropertyPane.prototype, "initialValue", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], PropertyPane.prototype, "isClearable", void 0);
_([
    Prop({
        required: false,
        default: 600
    }),
    _$1("design:type", Number)
], PropertyPane.prototype, "width", void 0);
_([
    Watch(nameof("initialValue")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], PropertyPane.prototype, "onInitialValueChanged", null);
PropertyPane = _([
    Component({
        render: render$12,
        emits: [
            "ok",
            "clear",
            "cancel"
        ]
    })
], PropertyPane);

const __vite_glob_0_8 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get PropertyPane () { return PropertyPane; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$P = { class: "tag-list__letter-container" };
const _hoisted_2$F = { class: "text-caption tag-list__index-letter" };

function render$11(_ctx, _cache) {
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_item_group = resolveComponent("v-item-group");

  return (openBlock(), createBlock(_component_v_item_group, { class: "tag-list" }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groupedSelectableTags, (tags, firstLetter) => {
        return (openBlock(), createElementBlock("div", _hoisted_1$P, [
          createElementVNode("span", _hoisted_2$F, toDisplayString(firstLetter), 1),
          (openBlock(true), createElementBlock(Fragment, null, renderList(tags, (tag) => {
            return (openBlock(), createBlock(_component_v_chip, {
              label: "",
              class: "mb-1 mr-1",
              variant: "flat",
              color: tag.isSelected ? 'primary' : '#e4e6eb',
              onClick: $event => (tag.isSelected = !tag.isSelected)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(tag.value), 1)
              ]),
              _: 2
            }, 1032, ["color", "onClick"]))
          }), 256)),
          _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1))
        ]))
      }), 256))
    ]),
    _: 1
  }))
}

class TagList extends Vue {
    get groupedSelectableTags() {
        return groupBy(this.selectableTags, (t)=>t.value[0]);
    }
    get selectedTags() {
        return this.selectableTags.filter((s)=>s.isSelected).map((s)=>s.value);
    }
    mounted() {
        this.onTagsChanged();
    }
    // externally-triggered selection change
    onValueChanged() {
        this.selectableTags.forEach((s)=>s.isSelected = this.value.includes(s.value));
    }
    // self-triggered selection change
    onQueryChanged() {
        if (!this.suspendEvents) {
            this.$emit("update:modelValue", this.selectedTags);
        }
    }
    // tag list changed
    onTagsChanged() {
        this.suspendEvents = true;
        this.selectableTags = this.tags.map((t)=>({
                isSelected: this.value.includes(t),
                value: t
            }));
        this.$nextTick(()=>this.suspendEvents = false);
    }
    constructor(...args){
        super(...args), this.suspendEvents = true, this.selectableTags = [];
    }
}
_([
    Prop({
        required: true,
        type: Array
    }),
    _$1("design:type", Array)
], TagList.prototype, "tags", void 0);
_([
    Model(),
    _$1("design:type", Array)
], TagList.prototype, "value", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagList.prototype, "onValueChanged", null);
_([
    Watch(nameof("selectedTags")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagList.prototype, "onQueryChanged", null);
_([
    Watch(nameof("tags")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagList.prototype, "onTagsChanged", null);
TagList = _([
    Component({
        render: render$11
    })
], TagList);

const __vite_glob_0_11 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get TagList () { return TagList; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$O = { class: "mb-2" };
const _hoisted_2$E = { class: "mb-2" };
const _hoisted_3$y = {
  key: 1,
  class: "pl-4 pt-2"
};

function render$10(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_tag_editor_component = resolveComponent("tag-editor-component");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_asset_grid_item = resolveComponent("asset-grid-item");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_document_list_item = resolveComponent("document-list-item");
  const _component_v_slide_y_transition = resolveComponent("v-slide-y-transition");
  const _component_v_list = resolveComponent("v-list");
  const _component_vue_draggable = resolveComponent("vue-draggable");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_tag_list = resolveComponent("tag-list");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_chip_group = resolveComponent("v-chip-group");

  return (openBlock(), createElementBlock(Fragment, null, [
    (_ctx.mode === 'edit')
      ? (openBlock(), createBlock(_component_v_card, { key: 0 }, {
          default: withCtx(() => [
            createVNode(_component_v_tabs, {
              modelValue: _ctx.viewMode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.viewMode) = $event))
            }, {
              default: withCtx(() => [
                createVNode(_component_v_tab, { value: "compact" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, { left: "" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiViewHeadline), 1)
                      ]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = createElementVNode("span", null, "Kompakt", -1))
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tab, { value: "list" }, {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, { left: "" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiAlphabetical), 1)
                      ]),
                      _: 1
                    }),
                    _cache[7] || (_cache[7] = createElementVNode("span", null, "Liste", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            createVNode(_component_v_tabs_window, {
              modelValue: _ctx.viewMode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.viewMode) = $event))
            }, {
              default: withCtx(() => [
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_tabs_window_item, { value: "compact" }, {
                      default: withCtx(() => [
                        createVNode(_component_tag_editor_component, {
                          frameless: "",
                          kind: _ctx.kind,
                          modelValue: _ctx.selectedTags,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedTags) = $event))
                        }, null, 8, ["kind", "modelValue"]),
                        createVNode(_component_loader_wrapper, { state: _ctx.state }, {
                          empty: withCtx(() => [
                            createVNode(_component_v_empty_state, {
                              icon: _ctx.$icons.mdiMagnify,
                              title: "Keine Tags ausgewählt",
                              text: "Wähle ein oder mehrere Tags aus"
                            }, null, 8, ["icon"])
                          ]),
                          noresults: withCtx(() => [
                            createVNode(_component_v_empty_state, {
                              icon: _ctx.$icons.mdiDatabaseSearch,
                              title: "Keine Resultate"
                            }, {
                              text: withCtx(() => [
                                createTextVNode(" Keine " + toDisplayString(_ctx.entityName) + " gefunden, die alle ausgewählten Tags enthalten. ", 1)
                              ]),
                              _: 1
                            }, 8, ["icon"])
                          ]),
                          default: withCtx(() => [
                            createElementVNode("p", _hoisted_1$O, toDisplayString(_ctx.selectedEntities.length) + " ausgewählte " + toDisplayString(_ctx.entityName) + ":", 1),
                            createVNode(_component_vue_draggable, {
                              target: ".tag-selector-component__results--edit",
                              onEnd: _ctx.onDraggableChanged,
                              modelValue: _ctx.selectedEntities,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.selectedEntities) = $event))
                            }, {
                              default: withCtx(() => [
                                (_ctx.kind === 'asset')
                                  ? (openBlock(), createBlock(_component_v_row, {
                                      key: 0,
                                      dense: "",
                                      class: "tag-selector-component__results tag-selector-component__results--edit"
                                    }, {
                                      default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                                          return (openBlock(), createBlock(_component_v_col, {
                                            class: "tag-selector-component__result-item",
                                            cols: _ctx.thumbnailCols,
                                            key: entity.id
                                          }, {
                                            default: withCtx(() => [
                                              createVNode(_component_asset_grid_item, { modelValue: entity }, null, 8, ["modelValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["cols"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }))
                                  : createCommentVNode("", true),
                                (_ctx.kind === 'document')
                                  ? (openBlock(), createBlock(_component_v_list, {
                                      key: 1,
                                      class: "px-0 tag-selector-component__results tag-selector-component__results--edit"
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_v_slide_y_transition, { group: "" }, {
                                          default: withCtx(() => [
                                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                                              return (openBlock(), createBlock(_component_document_list_item, {
                                                class: "tag-selector-component__result-item",
                                                "is-passive": "",
                                                unselectable: "",
                                                document: entity,
                                                key: entity.id
                                              }, null, 8, ["document"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["onEnd", "modelValue"])
                          ]),
                          _: 1
                        }, 8, ["state"])
                      ]),
                      _: 1
                    }),
                    createVNode(_component_v_tabs_window_item, { value: "list" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { cols: "7" }, {
                              default: withCtx(() => [
                                createVNode(_component_tag_list, {
                                  tags: _ctx.store.tags,
                                  modelValue: _ctx.selectedTags,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.selectedTags) = $event))
                                }, null, 8, ["tags", "modelValue"])
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_col, { cols: "5" }, {
                              default: withCtx(() => [
                                createElementVNode("p", _hoisted_2$E, toDisplayString(_ctx.selectedEntities.length) + " ausgewählte " + toDisplayString(_ctx.entityName) + ":", 1),
                                createVNode(_component_vue_draggable, {
                                  target: ".tag-selector-component__results--edit",
                                  onEnd: _ctx.onDraggableChanged,
                                  modelValue: _ctx.selectedEntities,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.selectedEntities) = $event))
                                }, {
                                  default: withCtx(() => [
                                    (_ctx.kind === 'asset')
                                      ? (openBlock(), createBlock(_component_v_row, {
                                          key: 0,
                                          dense: "",
                                          class: "tag-selector-component__results tag-selector-component__results--edit"
                                        }, {
                                          default: withCtx(() => [
                                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                                              return (openBlock(), createBlock(_component_v_col, {
                                                class: "tag-selector-component__result-item",
                                                cols: 4,
                                                key: entity.id
                                              }, {
                                                default: withCtx(() => [
                                                  createVNode(_component_asset_grid_item, { modelValue: entity }, null, 8, ["modelValue"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }))
                                      : createCommentVNode("", true),
                                    (_ctx.kind === 'document')
                                      ? (openBlock(), createBlock(_component_v_list, {
                                          key: 1,
                                          class: "tag-selector-component__results tag-selector-component__results--edit"
                                        }, {
                                          default: withCtx(() => [
                                            createVNode(_component_v_slide_y_transition, { group: "" }, {
                                              default: withCtx(() => [
                                                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                                                  return (openBlock(), createBlock(_component_document_list_item, {
                                                    class: "tag-selector-component__result-item",
                                                    "is-passive": "",
                                                    "hide-metadata": "",
                                                    document: entity,
                                                    key: entity.id
                                                  }, null, 8, ["document"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["onEnd", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : createCommentVNode("", true),
    (_ctx.mode === 'view')
      ? (openBlock(), createElementBlock("div", _hoisted_3$y, [
          createVNode(_component_v_row, {
            class: "pr-4",
            "no-gutters": "",
            align: "center"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_col, { cols: "auto" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.selectedEntities.length) + " ausgewählte " + toDisplayString(_ctx.entityName) + " mit den Tags ", 1)
                ]),
                _: 1
              }),
              createVNode(_component_v_col, null, {
                default: withCtx(() => [
                  createVNode(_component_v_chip_group, {
                    column: "",
                    class: "ml-2"
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedTags, (tag) => {
                        return (openBlock(), createBlock(_component_v_chip, {
                          label: "",
                          size: "small"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 256))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.kind === 'asset')
            ? (openBlock(), createBlock(_component_v_row, {
                key: 0,
                class: "tag-selector-component__results tag-selector-component__results--view mr-0",
                dense: ""
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                    return (openBlock(), createBlock(_component_v_col, {
                      class: "tag-selector-component__result-item",
                      cols: 2,
                      key: entity.id
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_asset_grid_item, { modelValue: entity }, null, 8, ["modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : createCommentVNode("", true),
          (_ctx.kind === 'document')
            ? (openBlock(), createBlock(_component_v_list, {
                key: 1,
                class: "tag-selector-component__results tag-selector-component__results--view",
                dense: ""
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedEntities, (entity) => {
                    return (openBlock(), createBlock(_component_document_list_item, {
                      "is-passive": "",
                      unselectable: "",
                      class: "tag-selector-component__result-item",
                      document: entity,
                      key: entity.id
                    }, null, 8, ["document"]))
                  }), 128))
                ]),
                _: 1
              }))
            : createCommentVNode("", true)
        ]))
      : createCommentVNode("", true)
  ], 64))
}

IconRegistry.add({
    mdiAlphabetical,
    mdiViewHeadline,
    mdiPencil,
    mdiDrag,
    mdiMagnify,
    mdiDatabaseSearch
});
class TagSelectorComponent extends Vue {
    get entityName() {
        switch(this.kind){
            case EntityKind.Document:
                return "Dokumente";
            case EntityKind.Asset:
                return "Assets";
            default:
                return "";
        }
    }
    get thumbnailCols() {
        switch(this.thumbnailColumns){
            case 2:
                return 6;
            case 3:
                return 4;
            case 4:
                return 3;
            default:
                return 2;
        }
    }
    created() {
        this.initialize();
    }
    mounted() {
        this.onValueChanged();
    }
    onValueChanged() {
        this.suspendEvents = true;
        this.selectedTags = this.value.tags;
        this.orderedIds = this.value.orderedIds || [];
        this.$nextTick(()=>this.suspendEvents = false);
    }
    onValueOrderedIdsChanged(newOrderedIds, oldOrderedIds) {
        this.suspendEvents = true;
        if (!isEqual$1(newOrderedIds, oldOrderedIds)) {
            this.selectedEntities = sortByOrderedIds(this.selectedEntities, newOrderedIds, (entity)=>entity.id);
        }
        this.$nextTick(()=>this.suspendEvents = false);
    }
    onSelectedTagsChanged(newTags, oldTags) {
        // only trigger if the tags really are different
        if (!isEqual$1(sortBy(newTags), sortBy(oldTags))) {
            this.loadEntities();
            if (!this.suspendEvents) {
                this.raiseInput();
            }
        }
    }
    onKindChanged() {
        this.initialize();
    }
    async initialize() {
        // TODO: refactor to take advantage of DI
        switch(this.kind){
            case EntityKind.Document:
                this.store = new DocumentModule();
                this.entityService = this.documentService;
                break;
            case EntityKind.Asset:
                this.store = new AssetModule();
                this.entityService = this.assetService;
                break;
        }
        await this.store.loadTags();
    }
    async loadEntities() {
        this.state = LoadingState.Loading;
        if (this.selectedTags.length > 0) {
            let entities = await this.entityService.search({
                tags: this.selectedTags,
                type: this.assemblyType ?? undefined
            });
            this.orderedIds = this.orderedIds.filter((id)=>entities.find((e)=>e.id === id) != null);
            if (this.orderedIds == null || this.orderedIds.length === 0) {
                this.orderedIds = entities.map((e)=>e.id);
            }
            this.selectedEntities = sortByOrderedIds(entities, this.orderedIds, (entity)=>entity.id);
            this.state = this.selectedEntities.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } else {
            this.orderedIds = [];
            this.selectedEntities = [];
            this.state = LoadingState.Empty;
        }
    }
    getTagsFiltered(item, queryText, itemText) {
        return item.toUpperCase().startsWith(queryText.toUpperCase());
    }
    onDraggableChanged(e) {
        this.orderedIds = this.selectedEntities.map((e)=>e.id);
        this.raiseInput();
    }
    raiseInput() {
        let args = {
            kind: this.kind,
            tags: this.selectedTags,
            orderedIds: this.orderedIds
        };
        this.$emit("update:modelValue", args);
    }
    constructor(...args){
        super(...args), this.viewMode = "compact", this.selectedEntities = [], this.orderedIds = [], this.selectedTags = [], this.state = LoadingState.Empty;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], TagSelectorComponent.prototype, "documentService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], TagSelectorComponent.prototype, "assetService", void 0);
_([
    Model({
        type: Object
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.TagSelector === "undefined" ? Object : Models.TagSelector)
], TagSelectorComponent.prototype, "value", void 0);
_([
    Prop({
        required: true,
        type: String
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.EntityKind === "undefined" ? Object : Models.EntityKind)
], TagSelectorComponent.prototype, "kind", void 0);
_([
    Prop({
        default: "view"
    }),
    _$1("design:type", String)
], TagSelectorComponent.prototype, "mode", void 0);
_([
    Prop(),
    _$1("design:type", Object)
], TagSelectorComponent.prototype, "assemblyType", void 0);
_([
    Prop({
        default: 6
    }),
    _$1("design:type", Number)
], TagSelectorComponent.prototype, "thumbnailColumns", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagSelectorComponent.prototype, "onValueChanged", null);
_([
    Watch("value.orderedIds"),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        Array,
        Array
    ]),
    _$1("design:returntype", void 0)
], TagSelectorComponent.prototype, "onValueOrderedIdsChanged", null);
_([
    Watch(nameof("selectedTags")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        Array,
        Array
    ]),
    _$1("design:returntype", void 0)
], TagSelectorComponent.prototype, "onSelectedTagsChanged", null);
_([
    Watch("kind"),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagSelectorComponent.prototype, "onKindChanged", null);
TagSelectorComponent = _([
    Component({
        render: render$10,
        components: {
            TagList,
            AssetGridItem,
            DocumentListItem,
            VueDraggable
        }
    })
], TagSelectorComponent);

const __vite_glob_0_12 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get TagSelectorComponent () { return TagSelectorComponent; }
}, Symbol.toStringTag, { value: 'Module' }));

function render$$(_ctx, _cache) {
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_combobox = resolveComponent("v-combobox");

  return (openBlock(), createBlock(_component_v_combobox, mergeProps({
    multiple: "",
    chips: "",
    "hide-selected": "",
    "hide-details": _ctx.hideDetails,
    variant: _ctx.frameless ? 'filled' : 'solo',
    label: _ctx.comboboxLabel,
    items: _ctx.tags,
    filter: _ctx.getTagsFiltered,
    loading: _ctx.isLoading,
    "search-input": _ctx.searchText,
    disabled: _ctx.disabled,
    onChange: _cache[0] || (_cache[0] = $event => (_ctx.searchText = '')),
    modelValue: _ctx.selectedTags,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedTags) = $event))
  }, _ctx.$attrs), {
    chip: withCtx((data) => [
      (openBlock(), createBlock(_component_v_chip, mergeProps({
        label: "",
        closable: ""
      }, data.attrs, {
        disabled: data.disabled,
        "model-value": data.selected,
        "onClick:close": $event => (_ctx.unselect(data.item.title)),
        key: data.item.title
      }), {
        default: withCtx(() => [
          createTextVNode(toDisplayString(data.item.title), 1)
        ]),
        _: 2
      }, 1040, ["disabled", "model-value", "onClick:close"]))
    ]),
    _: 1
  }, 16, ["hide-details", "variant", "label", "items", "filter", "loading", "search-input", "disabled", "modelValue"]))
}

class TagEditorComponent extends Vue {
    get selectedTags() {
        return this.value ?? [];
    }
    set selectedTags(values) {
        let sanitizedTags = values.map((t)=>t.trim()).filter((t)=>!isNullOrEmpty(t));
        this.$emit("update:modelValue", sanitizedTags);
    }
    get tags() {
        return this.store?.tags ?? [];
    }
    get comboboxLabel() {
        return this.label ?? "Tags auswählen/erstellen";
    }
    created() {
        this.initialize();
    }
    onKindChanged() {
        this.initialize();
    }
    async initialize() {
        switch(this.kind){
            case EntityKind.Document:
                this.store = new DocumentModule();
                break;
            case EntityKind.Asset:
                this.store = new AssetModule();
                break;
            default:
                throw new ExtendedError(`TagEditorComponent can only handle document or asset tags.`);
        }
        this.isLoading = true;
        await this.store.loadTags();
        this.isLoading = false;
    }
    getTagsFiltered(item, queryText, itemText) {
        return item.toUpperCase().startsWith(queryText.toUpperCase());
    }
    unselect(tag) {
        this.selectedTags = this.selectedTags.filter((t)=>t !== tag);
    }
    constructor(...args){
        super(...args), this.store = null, this.isLoading = false, this.searchText = "";
    }
}
_([
    Prop({
        required: true,
        type: String
    }),
    _$1("design:type", typeof Models$1 === "undefined" || typeof EntityKind === "undefined" ? Object : EntityKind)
], TagEditorComponent.prototype, "kind", void 0);
_([
    Model(),
    _$1("design:type", Array)
], TagEditorComponent.prototype, "value", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], TagEditorComponent.prototype, "disabled", void 0);
_([
    Prop(),
    _$1("design:type", Object)
], TagEditorComponent.prototype, "label", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], TagEditorComponent.prototype, "frameless", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], TagEditorComponent.prototype, "hideDetails", void 0);
_([
    Watch("kind"),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TagEditorComponent.prototype, "onKindChanged", null);
TagEditorComponent = _([
    Component({
        render: render$$
    })
], TagEditorComponent);

const __vite_glob_0_10 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get TagEditorComponent () { return TagEditorComponent; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$N = { class: "position-relative" };
const _hoisted_2$D = { class: "geojson-point-picker__geocode-control" };
const _hoisted_3$x = {
  class: "geojson-point-picker__map",
  ref: "map"
};

function render$_(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_autocomplete = resolveComponent("v-autocomplete");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, null, {
    default: withCtx(() => [
      createVNode(_component_v_row, { class: "pa-4" }, {
        default: withCtx(() => [
          createVNode(_component_v_col, { cols: "6" }, {
            default: withCtx(() => [
              createVNode(_component_v_text_field, {
                "hide-details": "auto",
                type: "number",
                label: "Breitengrad (Latitude)",
                "onUpdate:modelValue": [
                  _ctx.onChange,
                  _cache[0] || (_cache[0] = $event => ((_ctx.latitude) = $event))
                ],
                modelValue: _ctx.latitude
              }, null, 8, ["onUpdate:modelValue", "modelValue"])
            ]),
            _: 1
          }),
          createVNode(_component_v_col, { cols: "6" }, {
            default: withCtx(() => [
              createVNode(_component_v_text_field, {
                "hide-details": "auto",
                type: "number",
                label: "Längengrad (Longitude)",
                "onUpdate:modelValue": [
                  _ctx.onChange,
                  _cache[1] || (_cache[1] = $event => ((_ctx.longitude) = $event))
                ],
                modelValue: _ctx.longitude
              }, null, 8, ["onUpdate:modelValue", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createElementVNode("div", _hoisted_1$N, [
        createElementVNode("div", _hoisted_2$D, [
          createVNode(_component_v_autocomplete, {
            "hide-no-data": "",
            "hide-selected": "",
            "return-object": "",
            "no-filter": "",
            "auto-select-first": "",
            clearable: "",
            "hide-details": "auto",
            variant: "solo",
            "item-title": "text",
            label: "Adresse suchen …",
            placeholder: "Musterstrasse 1, Musterort",
            "prepend-inner-icon": _ctx.$icons.mdiMapMarkerRadius,
            items: _ctx.suggestions,
            loading: _ctx.isBusy,
            search: _ctx.geolocationQuery,
            "onUpdate:search": _cache[2] || (_cache[2] = $event => ((_ctx.geolocationQuery) = $event)),
            onFocus: _cache[3] || (_cache[3] = $event => (_ctx.isMapVisible = true)),
            modelValue: _ctx.selectedSuggestion,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.selectedSuggestion) = $event))
          }, null, 8, ["prepend-inner-icon", "items", "loading", "search", "modelValue"])
        ]),
        createElementVNode("div", _hoisted_3$x, null, 512)
      ])
    ]),
    _: 1
  }))
}

class GeocodeService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "geocode"), middlewareFactory, snackbarService);
    }
    async suggest(text) {
        let response = await this.client.post("suggest", {
            searchParams: {
                text: text
            }
        });
        let result = await response.json();
        return result.suggestions;
    }
    async geocode(address, magicKey) {
        let request = {
            address: address,
            magicKey: magicKey,
            permanent: false
        };
        let response = await this.client.post("search", {
            json: request
        });
        let result = await response.json();
        return result.results;
    }
    async geocodePermanent(address, magicKey) {
        let request = {
            address: address,
            magicKey: magicKey,
            permanent: true
        };
        let response = await this.client.post("search", {
            json: request
        });
        let result = await response.json();
        return result.results;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof AuthenticationModule === "undefined" ? Object : AuthenticationModule)
], GeocodeService.prototype, "authStore", void 0);
GeocodeService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], GeocodeService);

class Configuration {
    static{
        this.Empty = {
            clientVersion: "N/A",
            serverVersion: "N/A",
            appSettings: {},
            permissions: {
                assets: {
                    canCreateAny: false,
                    canReadSome: false
                },
                documents: {
                    canCreateAny: false,
                    canReadSome: false
                },
                menus: {
                    canCreateAny: false,
                    canReadSome: false
                },
                roles: {
                    canCreateAny: false,
                    canReadSome: false
                }
            }
        };
    }
}

class ConfigurationService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "configuration"), middlewareFactory, snackbarService);
    }
    async loadConfiguration() {
        return await this.client.get("").json();
    }
}
ConfigurationService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], ConfigurationService);

class ConfigurationModule extends Pinia {
  async loadConfiguration() {
    try {
      let config = await this.service.loadConfiguration();
      config.clientVersion = "0.16.2";
      this.configuration = config;
      return config;
    } catch (e) {
      this.notificationService.showError("Die Konfiguration konnte nicht geladen werden.", e);
      return Configuration.Empty;
    }
  }
  constructor(...args) {
    super(...args), this.configuration = Configuration.Empty;
  }
}
_([
  AutoInject,
  _$1("design:type", typeof ConfigurationService === "undefined" ? Object : ConfigurationService)
], ConfigurationModule.prototype, "service", void 0);
_([
  AutoInject,
  _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], ConfigurationModule.prototype, "notificationService", void 0);
ConfigurationModule = _([
  Store
], ConfigurationModule);

IconRegistry.add({
    mdiMapMarkerRadius,
    mdiChevronUp,
    mdiChevronDown
});
class GeoJsonPointPicker extends Vue {
    created() {
        this.marker = new mapboxgl.Marker({
            draggable: true
        });
        this.marker.on("dragend", ()=>this.onMarkerDragEnd());
        this.onModelChanged();
    }
    mounted() {
        this.map = new mapboxgl.Map({
            accessToken: this.configStore.configuration.appSettings["MapboxAccessToken"],
            container: this.$refs.map,
            center: [
                this.longitude,
                this.latitude
            ],
            zoom: this.mapZoom
        });
        this.marker.setLngLat([
            this.longitude,
            this.latitude
        ]);
        this.marker.addTo(this.map);
        this.map.on("zoomend", (e)=>{
            this.$emit("zoom", Math.round(this.map.getZoom() * 100) / 100);
        });
        this.$nextTick(()=>this.map.resize());
    }
    onMarkerDragEnd() {
        let lngLat = this.marker.getLngLat();
        this.longitude = Math.round(lngLat.lng * 100000) / 100000;
        this.latitude = Math.round(lngLat.lat * 100000) / 100000;
        this.geolocationQuery = null;
        this.onChange();
    }
    onChange() {
        let point = {
            type: "Point",
            coordinates: [
                this.longitude,
                this.latitude
            ]
        };
        if (this.map != null) {
            this.map.flyTo({
                center: point.coordinates
            });
        }
        this.marker.setLngLat(point.coordinates);
        this.$emit("update:modelValue", point);
    }
    onModelChanged() {
        if (this.latitude === this.value.coordinates[1] && this.longitude === this.value.coordinates[0]) {
            return;
        }
        if (this.value != null) {
            this.latitude = this.value.coordinates[1];
            this.longitude = this.value.coordinates[0];
            this.marker.setLngLat(this.value.coordinates);
            if (this.map != null) {
                this.map.setCenter(this.value.coordinates);
            }
        } else {
            this.latitude = 0;
            this.longitude = 0;
        }
    }
    async onGeolocationQueryChanged() {
        if (!isNullOrEmpty(this.geolocationQuery)) {
            this.isBusy = true;
            this.suggestions = await this.geocodeService.suggest(this.geolocationQuery);
            this.isBusy = false;
        } else {
            this.selectedSuggestion = null;
        }
    }
    async onSuggestionSelected(currentValue, previousValue) {
        if (this.selectedSuggestion == null) {
            return;
        }
        if ((currentValue != null || previousValue != null) && currentValue?.text === previousValue?.text) {
            return;
        }
        let result = await this.geocodeService.geocodePermanent(this.selectedSuggestion.text, this.selectedSuggestion.magicKey);
        this.longitude = Math.round(result[0].position.coordinates[0] * 100000) / 100000;
        this.latitude = Math.round(result[0].position.coordinates[1] * 100000) / 100000;
        this.onChange();
    }
    constructor(...args){
        super(...args), this.configStore = new ConfigurationModule(), this.latitude = 0, this.longitude = 0, this.mapZoom = 11, this.isBusy = false, this.geolocationQuery = null, this.suggestions = [], this.selectedSuggestion = null;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof GeocodeService === "undefined" ? Object : GeocodeService)
], GeoJsonPointPicker.prototype, "geocodeService", void 0);
_([
    Model(),
    _$1("design:type", typeof GeoJSON === "undefined" || typeof GeoJSON.Point === "undefined" ? Object : GeoJSON.Point)
], GeoJsonPointPicker.prototype, "value", void 0);
_([
    Prop({
        required: false
    }),
    _$1("design:type", Object)
], GeoJsonPointPicker.prototype, "zoom", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], GeoJsonPointPicker.prototype, "onModelChanged", null);
_([
    Watch(nameof("geolocationQuery"), {
        debounce: 600
    }),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", Promise)
], GeoJsonPointPicker.prototype, "onGeolocationQueryChanged", null);
_([
    Watch(nameof("selectedSuggestion")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof GeocodeSuggestResponseItem === "undefined" ? Object : GeocodeSuggestResponseItem,
        typeof GeocodeSuggestResponseItem === "undefined" ? Object : GeocodeSuggestResponseItem
    ]),
    _$1("design:returntype", Promise)
], GeoJsonPointPicker.prototype, "onSuggestionSelected", null);
GeoJsonPointPicker = _([
    Component({
        render: render$_
    })
], GeoJsonPointPicker);

const __vite_glob_0_3 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get GeoJsonPointPicker () { return GeoJsonPointPicker; }
}, Symbol.toStringTag, { value: 'Module' }));

const _hoisted_1$M = { class: "color-picker__item-label" };

function render$Z(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_item = resolveComponent("v-item");
  const _component_v_item_group = resolveComponent("v-item-group");

  return (openBlock(), createBlock(_component_v_item_group, {
    mandatory: "",
    class: "color-picker",
    modelValue: _ctx.selectedColorIndex,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedColorIndex) = $event))
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.colors, (color, i) => {
        return (openBlock(), createBlock(_component_v_item, { key: i }, {
          default: withCtx(({ isSelected, toggle }) => [
            createVNode(_component_v_card, {
              class: "transition-fast-in-fast-out text-button color-picker__item",
              variant: isSelected ? 'elevated' : 'flat',
              style: normalizeStyle({ 'background-color': color.value, color: color.invertValue }),
              onClick: toggle
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_1$M, toDisplayString(color.displayName), 1),
                isSelected
                  ? (openBlock(), createBlock(_component_v_icon, {
                      key: 0,
                      class: "color-picker__item-icon",
                      color: color.invertValue
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiRadioboxMarked), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"]))
                  : createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["variant", "style", "onClick"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}

IconRegistry.add({
    mdiRadioboxBlank,
    mdiRadioboxMarked
});
class ColorPicker extends Vue {
    get selectedColorIndex() {
        return this.colors.findIndex((c)=>c.name == this.value?.name) || 0;
    }
    set selectedColorIndex(value) {
        this.$emit("update:modelValue", this.colors[value]);
    }
}
_([
    Model(),
    _$1("design:type", Object)
], ColorPicker.prototype, "value", void 0);
_([
    Prop(),
    _$1("design:type", Array)
], ColorPicker.prototype, "colors", void 0);
ColorPicker = _([
    Component({
        render: render$Z,
        components: {}
    })
], ColorPicker);

const __vite_glob_0_0 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get ColorPicker () { return ColorPicker; }
}, Symbol.toStringTag, { value: 'Module' }));

const __vite_glob_0_5 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get ColorPicker () { return ColorPicker; },
	get GeoJsonPointPicker () { return GeoJsonPointPicker; },
	get IdSelectorComponent () { return IdSelectorComponent; },
	get InlineConfirm () { return InlineConfirm$1; },
	get LoaderWrapper () { return LoaderWrapper; },
	get PropertyPane () { return PropertyPane; },
	get TagEditorComponent () { return TagEditorComponent; },
	get TagList () { return TagList; },
	get TagSelectorComponent () { return TagSelectorComponent; },
	get UrlPicker () { return UrlPicker; }
}, Symbol.toStringTag, { value: 'Module' }));

var EditorType = /*#__PURE__*/ function(EditorType) {
    EditorType["Primitive"] = "primitive";
    EditorType["Complex"] = "complex";
    EditorType["Array"] = "array";
    EditorType["Object"] = "object";
    return EditorType;
}({});

class EditorFactory {
    static{
        this.editors = [];
    }
    static registerEditor(registration) {
        if (registration.priority == null) {
            registration.priority = 1;
        }
        let customization = (node, factory)=>{
            node.componentName = registration.type.name;
            if (registration.customization) {
                registration.customization(node, factory);
            }
        };
        EditorFactory.editors.push({
            type: registration.type,
            editorType: registration.editorType ?? EditorType.Primitive,
            predicate: registration.predicate,
            customization: customization,
            priority: registration.priority,
            handleNull: registration.handleNull ?? false
        });
    }
    static registerEditorsAsComponents(app) {
        for (let editor of EditorFactory.editors){
            app.component(editor.type.name, editor.type);
        }
    }
    static getEditorType(schema) {
        let typeName = EditorFactory.getTypeName(schema.type);
        let matchingSelectors = Enumerable.From(EditorFactory.editors).Where((s)=>s.predicate(schema, typeName)).OrderByDescending((s)=>s.priority).ToArray();
        let selector = matchingSelectors[0];
        if (selector != null) {
            return selector.editorType;
        }
        return EditorType.Primitive;
    }
    async createRoot(schema, model, context) {
        let schemaParser = new JsonSchemaParser();
        let dereferencedSchema = await schemaParser.dereference(schema, {
            dereference: {
                circular: "ignore"
            }
        });
        return this.create({
            rootId: nanoid(),
            schema: dereferencedSchema,
            model: model,
            metadataPath: "",
            contextType: EditorType.Object,
            path: "",
            nestingLevel: 0,
            parent: null,
            getRoot: function() {
                return model;
            },
            getContext: function() {
                return context;
            },
            resolveSchemaRef: this.resolveSchemaRef.bind(this, schemaParser)
        });
    }
    create(options) {
        if (!options.schema.type) {
            throw new ExtendedError("Cannot generate EditorMetadata when type is undefined.", {
                path: options.path,
                schema: options.schema
            });
        }
        if (options.schema.oneOf || options.schema.anyOf) {
            throw new ExtendedError("Cannot generate EditorMetadata for multiple schemas.", {
                path: options.path,
                schema: options.schema
            });
        }
        let typeName = EditorFactory.getTypeName(options.schema.type);
        let self = this;
        let editorData = {
            rootId: options.rootId,
            model: options.model,
            schema: options.schema,
            uid: nanoid(),
            path: options.path,
            metadataPath: options.metadataPath,
            nestingLevel: options.nestingLevel,
            contextType: options.contextType,
            editorType: EditorType.Primitive,
            errors: [],
            getDisplayValue: function() {
                return self.defaultCreateDisplayValue(this);
            },
            getRoot: options.getRoot,
            getContext: options.getContext,
            getParent: function() {
                return options.parent;
            },
            resolveSchemaRef: options.resolveSchemaRef
        };
        let matchingSelectors = Enumerable.From(EditorFactory.editors).Where((s)=>s.predicate(options.schema, typeName)).OrderByDescending((s)=>s.priority).ToArray();
        let selector = matchingSelectors[0];
        if (selector != null) {
            editorData.editorType = selector.editorType;
            if (options.model == null) {
                editorData.model = null; // force "null" (instead of maybe undefined) because fast-json-patch errors on undefined
            }
            if (options.model == null && !selector.handleNull) {
                editorData.componentName = "object-null-editor";
            } else {
                selector.customization(editorData, this);
            }
        }
        return editorData;
    }
    createArrayItems(node) {
        if (!isSchema(node.schema.items)) {
            throw new ExtendedError("Schema has to have an `items` property.", {
                path: node.path,
                schema: node.schema
            });
        }
        if (node.model == null) {
            return [];
        }
        let items = node.model.map((itemModel, index)=>{
            let itemSchema = this.getSchemaForAssemblyType(itemModel, node.schema.items, node.resolveSchemaRef);
            let itemPath = `${node.path}/${index}`;
            let itemMetadataPath = `${node.metadataPath}/items/${index}`;
            return this.create({
                rootId: node.rootId,
                model: itemModel,
                schema: itemSchema,
                path: itemPath,
                metadataPath: itemMetadataPath,
                nestingLevel: node.nestingLevel + 1,
                contextType: EditorType.Array,
                parent: node,
                getRoot: node.getRoot,
                getContext: node.getContext,
                resolveSchemaRef: node.resolveSchemaRef
            });
        });
        return items;
    }
    createObjectChildren(node) {
        let modelSchema = this.getSchemaForAssemblyType(node.model, node.schema, node.resolveSchemaRef);
        if (modelSchema.properties == null) {
            return {};
        }
        let schemaProperties = Enumerable.From(Object.entries(modelSchema.properties)).Where(([_, itemSchema])=>!itemSchema.ignoreInEditor) // filter out properties that should be ignored
        .OrderBy(([_, itemSchema])=>itemSchema.editorOrder || 0) // order by custom metadata
        .ToArray();
        let children = schemaProperties.map(([propName, propSchema])=>{
            var propertyName = propName;
            if (isSchema(propSchema)) {
                let childPath = `${node.path}/${propName}`;
                let childMetadataPath = `${node.metadataPath}/children/${propName}`;
                let childModel = node.model[propertyName];
                let childSchema = this.getSchemaForAssemblyType(childModel, propSchema, node.resolveSchemaRef);
                // handle complex (object) properties with null-values
                if (childModel == null && (!childSchema.type || Array.isArray(childSchema.type) && childSchema.type.includes("null") && childSchema.type.includes("object"))) {
                    let metadata = {
                        rootId: node.rootId,
                        uid: nanoid(),
                        schema: childSchema,
                        componentName: "object-null-editor",
                        editorType: EditorType.Primitive,
                        contextType: EditorType.Object,
                        nestingLevel: node.nestingLevel + 1,
                        path: childPath,
                        metadataPath: childMetadataPath,
                        model: null,
                        errors: [],
                        getParent: function() {
                            return node;
                        },
                        getDisplayValue: function() {
                            return null;
                        },
                        getRoot: node.getRoot,
                        getContext: node.getContext,
                        resolveSchemaRef: node.resolveSchemaRef
                    };
                    return {
                        propertyName,
                        metadata
                    };
                }
                return {
                    propertyName: propertyName,
                    metadata: this.create({
                        rootId: node.rootId,
                        schema: childSchema,
                        model: childModel,
                        path: childPath,
                        metadataPath: childMetadataPath,
                        nestingLevel: node.nestingLevel + 1,
                        contextType: EditorType.Object,
                        parent: node,
                        getRoot: node.getRoot,
                        getContext: node.getContext,
                        resolveSchemaRef: node.resolveSchemaRef
                    })
                };
            }
            throw new Error(`Schema for property '${propName}' not found.`);
        });
        return toDictionary(children, (i)=>i.propertyName, (i)=>i.metadata);
    }
    createReplacementNull(node) {
        let parent = node.getParent();
        let nodePointer = JsonPointer.create(node.path);
        let nodePropName = nodePointer.path[nodePointer.path.length - 1];
        let nodeNullSchema = parent?.schema.properties?.[nodePropName];
        if (nodeNullSchema.$ref) {
            nodeNullSchema = node.resolveSchemaRef(nodeNullSchema.$ref);
        }
        return {
            rootId: node.rootId,
            uid: nanoid(),
            schema: nodeNullSchema,
            componentName: "object-null-editor",
            editorType: EditorType.Primitive,
            contextType: EditorType.Object,
            nestingLevel: node.nestingLevel,
            path: node.path,
            metadataPath: node.metadataPath,
            model: null,
            errors: [],
            getParent: node.getParent,
            getRoot: node.getRoot,
            getContext: node.getContext,
            getDisplayValue: function() {
                return null;
            },
            resolveSchemaRef: node.resolveSchemaRef
        };
    }
    getSchemaForAssemblyType(model, schema, schemaRefResolver) {
        // resolve remaining (circular) reference if needed
        if (schema.$ref) {
            schema = schemaRefResolver(schema.$ref);
        }
        if (!isSchema(schema)) {
            throw new Error("'schema' is not a JSONSchema6");
        }
        if (model == null) {
            return schema;
        }
        let schemas = null;
        if (schema.oneOf && isSchemaArray(schema.oneOf)) {
            schemas = schema.oneOf;
        }
        if (schema.anyOf && isSchemaArray(schema.anyOf)) {
            schemas = schema.anyOf;
        }
        if (schemas != null && schemas.length > 0) {
            if (!model.$type) {
                throw new ExtendedError("Cannot choose a schema (from oneOf/anyOf) for this model (maybe $type is missing).", {
                    model,
                    schema
                });
            }
            var matchingSchemas = schemas.filter((s)=>s.assemblyType === model.$type);
            if (matchingSchemas.length) {
                var matchingSchema = {
                    ...matchingSchemas[0]
                };
                // use data from base schema if the other schemas don't define a value
                if (!isNullOrEmpty(schema.title) && isNullOrEmpty(matchingSchema.title)) {
                    matchingSchema.title = schema.title;
                }
                if (!isNullOrEmpty(schema.description) && isNullOrEmpty(matchingSchema.description)) {
                    matchingSchema.description = schema.description;
                }
                if (!isNullOrEmpty(schema.format) && isNullOrEmpty(matchingSchema.format)) {
                    matchingSchema.format = schema.format;
                }
                // preserve documentation from member schema (if defined)
                if (!isNullOrEmpty(schema.title)) {
                    matchingSchema.title = `${schema.title}: ${matchingSchema.title}`;
                }
                if (!isNullOrEmpty(schema.description)) {
                    matchingSchema.description = schema.description;
                }
                return matchingSchema;
            }
        }
        return schema;
    }
    createInstance(schema) {
        let instance = jsonSchemaDefaults(schema, {
            scaffold: true
        });
        if (schema.assemblyType) {
            // $type needs to be the first property because of deserialization on the server
            instance = {
                $type: schema.assemblyType,
                ...instance
            };
        }
        return instance;
    }
    defaultCreateDisplayValue(node) {
        if (node.model == null) {
            return null;
        }
        // array
        if (node.items && node.items.length) {
            let values = node.items.map((node)=>node.getDisplayValue()).filter(notEmpty$1);
            return {
                children: values
            };
        //return `<span class="text-caption">${node.schema.title || ""}</span> ${humanizeList(values, { skipConjunction: true })}`;
        }
        // object
        if (node.children) {
            var childValues = Object.entries(node.children).map(([prop, node])=>{
                let displayValue = node.getDisplayValue();
                if (displayValue == null) {
                    return {
                        title: node.schema.title
                    };
                }
                return {
                    ...displayValue,
                    title: node.schema.title
                };
            //return `<div class="display-value__item row row--dense flex-nowrap">
            //			<div class="text-caption col-auto text-truncate" style="width: 10em;">${node.schema.title || ""}</div>
            //			<div class="col-auto">${node.getDisplayValue()}</div>
            //		</div>`;
            }).filter(notEmpty$1);
            // shorten output if we only have one member
            if (childValues.length > 1) {
                return {
                    children: childValues
                };
            } else {
                return childValues[0];
            }
        }
        // primitive
        return {
            value: String(node.model)
        };
    }
    resolveSchemaRef(parser, $ref) {
        if (!parser.$refs.exists($ref, undefined)) {
            return null;
        }
        let schema = parser.$refs.get($ref);
        if (schema.oneOf) {
            for (let [i, item] of schema.oneOf.entries()){
                if (isSchema(item) && item.$ref) {
                    schema.oneOf[i] = parser.$refs.get(item.$ref);
                }
            }
        }
        if (schema.anyOf) {
            for (let [i, item] of schema.anyOf.entries()){
                if (isSchema(item) && item.$ref) {
                    schema.anyOf[i] = parser.$refs.get(item.$ref);
                }
            }
        }
        return schema;
    }
    static getTypeName(typeValue) {
        if (typeValue === undefined) {
            throw new Error("Cannot generate EditorMetadata when schema type is undefined.");
        }
        let typeName;
        if (Array.isArray(typeValue)) {
            let typesWithoutNull = typeValue.filter((x)=>x !== "null");
            if (typesWithoutNull.length > 1) {
                throw new ExtendedError("Cannot generate EditorMetadata for multiple types.", {
                    types: typeValue
                });
            }
            typeName = typesWithoutNull[0];
        } else {
            typeName = typeValue;
        }
        return typeName;
    }
}
EditorFactory = _([
    injectable()
], EditorFactory);

// Utilities

// Types

function useToggleScope(source, fn) {
  let scope;
  function start() {
    scope = effectScope();
    scope.run(() => fn.length ? fn(() => {
      scope?.stop();
      start();
    }) : fn());
  }
  watch(source, active => {
    if (active && !scope) {
      start();
    } else if (!active) {
      scope?.stop();
      scope = undefined;
    }
  }, {
    immediate: true
  });
  onScopeDispose(() => {
    scope?.stop();
  });
}

const IN_BROWSER = typeof window !== 'undefined';
const SUPPORTS_INTERSECTION = IN_BROWSER && 'IntersectionObserver' in window;
const SUPPORTS_TOUCH = IN_BROWSER && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0);

function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function getNestedValue(obj, path, fallback) {
  const last = path.length - 1;
  if (last < 0) return obj === undefined ? fallback : obj;
  for (let i = 0; i < last; i++) {
    if (obj == null) {
      return fallback;
    }
    obj = obj[path[i]];
  }
  if (obj == null) return fallback;
  return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function deepEqual(a, b) {
  if (a === b) return true;
  if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) {
    // If the values are Date, compare them as timestamps
    return false;
  }
  if (a !== Object(a) || b !== Object(b)) {
    // If the values aren't objects, they were already checked for equality
    return false;
  }
  const props = Object.keys(a);
  if (props.length !== Object.keys(b).length) {
    // Different number of props, don't bother to check
    return false;
  }
  return props.every(p => deepEqual(a[p], b[p]));
}
function getObjectValueByPath(obj, path, fallback) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (obj == null || !path || typeof path !== 'string') return fallback;
  if (obj[path] !== undefined) return obj[path];
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  return getNestedValue(obj, path.split('.'), fallback);
}
function getPropertyFromItem(item, property, fallback) {
  if (property === true) return item === undefined ? fallback : item;
  if (property == null || typeof property === 'boolean') return fallback;
  if (item !== Object(item)) {
    if (typeof property !== 'function') return fallback;
    const value = property(item, fallback);
    return typeof value === 'undefined' ? fallback : value;
  }
  if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
  if (Array.isArray(property)) return getNestedValue(item, property, fallback);
  if (typeof property !== 'function') return fallback;
  const value = property(item, fallback);
  return typeof value === 'undefined' ? fallback : value;
}
function createRange(length) {
  let start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Array.from({
    length
  }, (v, k) => start + k);
}
function convertToUnit(str) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  if (str == null || str === '') {
    return undefined;
  } else if (isNaN(+str)) {
    return String(str);
  } else if (!isFinite(+str)) {
    return undefined;
  } else {
    return `${Number(str)}${unit}`;
  }
}
function isObject$1(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}
function isPlainObject(obj) {
  let proto;
  return obj !== null && typeof obj === 'object' && ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto === null);
}
function refElement(obj) {
  if (obj && '$el' in obj) {
    const el = obj.$el;
    if (el?.nodeType === Node.TEXT_NODE) {
      // Multi-root component, use the first element
      return el.nextElementSibling;
    }
    return el;
  }
  return obj;
}

// KeyboardEvent.keyCode aliases
const keyCodes = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
const keyValues = Object.freeze({
  enter: 'Enter',
  tab: 'Tab',
  delete: 'Delete',
  esc: 'Escape',
  space: 'Space',
  up: 'ArrowUp',
  down: 'ArrowDown',
  left: 'ArrowLeft',
  right: 'ArrowRight',
  end: 'End',
  home: 'Home',
  del: 'Delete',
  backspace: 'Backspace',
  insert: 'Insert',
  pageup: 'PageUp',
  pagedown: 'PageDown',
  shift: 'Shift'
});
function keys(o) {
  return Object.keys(o);
}
function has(obj, key) {
  return key.every(k => obj.hasOwnProperty(k));
}
// Array of keys
function pick(obj, paths) {
  const found = {};
  const keys = new Set(Object.keys(obj));
  for (const path of paths) {
    if (keys.has(path)) {
      found[path] = obj[path];
    }
  }
  return found;
}

// Array of keys

// Array of keys or RegExp to test keys against

function pickWithRest(obj, paths, exclude) {
  const found = Object.create(null);
  const rest = Object.create(null);
  for (const key in obj) {
    if (paths.some(path => path instanceof RegExp ? path.test(key) : path === key) && !exclude?.some(path => path === key)) {
      found[key] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  }
  return [found, rest];
}
function omit(obj, exclude) {
  const clone = {
    ...obj
  };
  exclude.forEach(prop => delete clone[prop]);
  return clone;
}
function only(obj, include) {
  const clone = {};
  include.forEach(prop => clone[prop] = obj[prop]);
  return clone;
}
const onRE = /^on[^a-z]/;
const isOn = key => onRE.test(key);
const bubblingEvents = ['onAfterscriptexecute', 'onAnimationcancel', 'onAnimationend', 'onAnimationiteration', 'onAnimationstart', 'onAuxclick', 'onBeforeinput', 'onBeforescriptexecute', 'onChange', 'onClick', 'onCompositionend', 'onCompositionstart', 'onCompositionupdate', 'onContextmenu', 'onCopy', 'onCut', 'onDblclick', 'onFocusin', 'onFocusout', 'onFullscreenchange', 'onFullscreenerror', 'onGesturechange', 'onGestureend', 'onGesturestart', 'onGotpointercapture', 'onInput', 'onKeydown', 'onKeypress', 'onKeyup', 'onLostpointercapture', 'onMousedown', 'onMousemove', 'onMouseout', 'onMouseover', 'onMouseup', 'onMousewheel', 'onPaste', 'onPointercancel', 'onPointerdown', 'onPointerenter', 'onPointerleave', 'onPointermove', 'onPointerout', 'onPointerover', 'onPointerup', 'onReset', 'onSelect', 'onSubmit', 'onTouchcancel', 'onTouchend', 'onTouchmove', 'onTouchstart', 'onTransitioncancel', 'onTransitionend', 'onTransitionrun', 'onTransitionstart', 'onWheel'];
const compositionIgnoreKeys = ['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft', 'Enter', 'Escape', 'Tab', ' '];
function isComposingIgnoreKey(e) {
  return e.isComposing && compositionIgnoreKeys.includes(e.key);
}

/**
 * Filter attributes that should be applied to
 * the root element of an input component. Remaining
 * attributes should be passed to the <input> element inside.
 */
function filterInputAttrs(attrs) {
  const [events, props] = pickWithRest(attrs, [onRE]);
  const inputEvents = omit(events, bubblingEvents);
  const [rootAttrs, inputAttrs] = pickWithRest(props, ['class', 'style', 'id', /^data-/]);
  Object.assign(rootAttrs, events);
  Object.assign(inputAttrs, inputEvents);
  return [rootAttrs, inputAttrs];
}
function wrapInArray(v) {
  return v == null ? [] : Array.isArray(v) ? v : [v];
}
function debounce(fn, delay) {
  let timeoutId = 0;
  const wrap = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), unref(delay));
  };
  wrap.clear = () => {
    clearTimeout(timeoutId);
  };
  wrap.immediate = fn;
  return wrap;
}
function clamp(value) {
  let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Math.max(min, Math.min(max, value));
}
function getDecimals(value) {
  const trimmedStr = value.toString().trim();
  return trimmedStr.includes('.') ? trimmedStr.length - trimmedStr.indexOf('.') - 1 : 0;
}
function padEnd(str, length) {
  let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return str + char.repeat(Math.max(0, length - str.length));
}
function padStart(str, length) {
  let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  return char.repeat(Math.max(0, length - str.length)) + str;
}
function chunk(str) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const chunked = [];
  let index = 0;
  while (index < str.length) {
    chunked.push(str.substr(index, size));
    index += size;
  }
  return chunked;
}
function mergeDeep() {
  let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let arrayFn = arguments.length > 2 ? arguments[2] : undefined;
  const out = {};
  for (const key in source) {
    out[key] = source[key];
  }
  for (const key in target) {
    const sourceProperty = source[key];
    const targetProperty = target[key];

    // Only continue deep merging if
    // both properties are plain objects
    if (isPlainObject(sourceProperty) && isPlainObject(targetProperty)) {
      out[key] = mergeDeep(sourceProperty, targetProperty, arrayFn);
      continue;
    }
    if (arrayFn && Array.isArray(sourceProperty) && Array.isArray(targetProperty)) {
      out[key] = arrayFn(sourceProperty, targetProperty);
      continue;
    }
    out[key] = targetProperty;
  }
  return out;
}
function flattenFragments(nodes) {
  return nodes.map(node => {
    if (node.type === Fragment) {
      return flattenFragments(node.children);
    } else {
      return node;
    }
  }).flat();
}
function toKebabCase() {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (toKebabCase.cache.has(str)) return toKebabCase.cache.get(str);
  const kebab = str.replace(/[^a-z]/gi, '-').replace(/\B([A-Z])/g, '-$1').toLowerCase();
  toKebabCase.cache.set(str, kebab);
  return kebab;
}
toKebabCase.cache = new Map();
function findChildrenWithProvide(key, vnode) {
  if (!vnode || typeof vnode !== 'object') return [];
  if (Array.isArray(vnode)) {
    return vnode.map(child => findChildrenWithProvide(key, child)).flat(1);
  } else if (vnode.suspense) {
    return findChildrenWithProvide(key, vnode.ssContent);
  } else if (Array.isArray(vnode.children)) {
    return vnode.children.map(child => findChildrenWithProvide(key, child)).flat(1);
  } else if (vnode.component) {
    if (Object.getOwnPropertySymbols(vnode.component.provides).includes(key)) {
      return [vnode.component];
    } else if (vnode.component.subTree) {
      return findChildrenWithProvide(key, vnode.component.subTree).flat(1);
    }
  }
  return [];
}
var _arr = /*#__PURE__*/new WeakMap();
var _pointer = /*#__PURE__*/new WeakMap();
class CircularBuffer {
  constructor(size) {
    _classPrivateFieldInitSpec(this, _arr, []);
    _classPrivateFieldInitSpec(this, _pointer, 0);
    this.size = size;
  }
  push(val) {
    _classPrivateFieldGet(_arr, this)[_classPrivateFieldGet(_pointer, this)] = val;
    _classPrivateFieldSet(_pointer, this, (_classPrivateFieldGet(_pointer, this) + 1) % this.size);
  }
  values() {
    return _classPrivateFieldGet(_arr, this).slice(_classPrivateFieldGet(_pointer, this)).concat(_classPrivateFieldGet(_arr, this).slice(0, _classPrivateFieldGet(_pointer, this)));
  }
}

// Only allow a single return type

/**
 * Convert a computed ref to a record of refs.
 * The getter function must always return an object with the same keys.
 */

function destructComputed(getter) {
  const refs = reactive({});
  const base = computed(getter);
  watchEffect(() => {
    for (const key in base.value) {
      refs[key] = base.value[key];
    }
  }, {
    flush: 'sync'
  });
  return toRefs(refs);
}

/** Array.includes but value can be any type */
function includes(arr, val) {
  return arr.includes(val);
}
function eventName(propName) {
  return propName[2].toLowerCase() + propName.slice(3);
}
const EventProp = () => [Function, Array];
function hasEvent(props, name) {
  name = 'on' + capitalize(name);
  return !!(props[name] || props[`${name}Once`] || props[`${name}Capture`] || props[`${name}OnceCapture`] || props[`${name}CaptureOnce`]);
}
function callEvent(handler) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  if (Array.isArray(handler)) {
    for (const h of handler) {
      h(...args);
    }
  } else if (typeof handler === 'function') {
    handler(...args);
  }
}
function focusableChildren(el) {
  let filterByTabIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const targets = ['button', '[href]', 'input:not([type="hidden"])', 'select', 'textarea', '[tabindex]'].map(s => `${s}${filterByTabIndex ? ':not([tabindex="-1"])' : ''}:not([disabled])`).join(', ');
  return [...el.querySelectorAll(targets)];
}
function getNextElement(elements, location, condition) {
  let _el;
  let idx = elements.indexOf(document.activeElement);
  const inc = location === 'next' ? 1 : -1;
  do {
    idx += inc;
    _el = elements[idx];
  } while ((!_el || _el.offsetParent == null || !(condition?.(_el) ?? true)) && idx < elements.length && idx >= 0);
  return _el;
}
function focusChild(el, location) {
  const focusable = focusableChildren(el);
  if (!location) {
    if (el === document.activeElement || !el.contains(document.activeElement)) {
      focusable[0]?.focus();
    }
  } else if (location === 'first') {
    focusable[0]?.focus();
  } else if (location === 'last') {
    focusable.at(-1)?.focus();
  } else if (typeof location === 'number') {
    focusable[location]?.focus();
  } else {
    const _el = getNextElement(focusable, location);
    if (_el) _el.focus();else focusChild(el, location === 'next' ? 'first' : 'last');
  }
}
function isEmpty(val) {
  return val === null || val === undefined || typeof val === 'string' && val.trim() === '';
}
function noop() {}

/** Returns null if the selector is not supported or we can't check */
function matchesSelector(el, selector) {
  const supportsSelector = IN_BROWSER && typeof CSS !== 'undefined' && typeof CSS.supports !== 'undefined' && CSS.supports(`selector(${selector})`);
  if (!supportsSelector) return null;
  try {
    return !!el && el.matches(selector);
  } catch (err) {
    return null;
  }
}
function ensureValidVNode(vnodes) {
  return vnodes.some(child => {
    if (!isVNode(child)) return true;
    if (child.type === Comment) return false;
    return child.type !== Fragment || ensureValidVNode(child.children);
  }) ? vnodes : null;
}
function defer(timeout, cb) {
  if (!IN_BROWSER || timeout === 0) {
    cb();
    return () => {};
  }
  const timeoutId = window.setTimeout(cb, timeout);
  return () => window.clearTimeout(timeoutId);
}
function isClickInsideElement(event, targetDiv) {
  const mouseX = event.clientX;
  const mouseY = event.clientY;
  const divRect = targetDiv.getBoundingClientRect();
  const divLeft = divRect.left;
  const divTop = divRect.top;
  const divRight = divRect.right;
  const divBottom = divRect.bottom;
  return mouseX >= divLeft && mouseX <= divRight && mouseY >= divTop && mouseY <= divBottom;
}
function templateRef() {
  const el = shallowRef();
  const fn = target => {
    el.value = target;
  };
  Object.defineProperty(fn, 'value', {
    enumerable: true,
    get: () => el.value,
    set: val => el.value = val
  });
  Object.defineProperty(fn, 'el', {
    enumerable: true,
    get: () => refElement(el.value)
  });
  return fn;
}
function checkPrintable(e) {
  const isPrintableChar = e.key.length === 1;
  const noModifier = !e.ctrlKey && !e.metaKey && !e.altKey;
  return isPrintableChar && noModifier;
}

// Utilities
const block = ['top', 'bottom'];
const inline = ['start', 'end', 'left', 'right'];
/** Parse a raw anchor string into an object */
function parseAnchor(anchor, isRtl) {
  let [side, align] = anchor.split(' ');
  if (!align) {
    align = includes(block, side) ? 'start' : includes(inline, side) ? 'top' : 'center';
  }
  return {
    side: toPhysical(side, isRtl),
    align: toPhysical(align, isRtl)
  };
}
function toPhysical(str, isRtl) {
  if (str === 'start') return isRtl ? 'right' : 'left';
  if (str === 'end') return isRtl ? 'left' : 'right';
  return str;
}
function flipSide(anchor) {
  return {
    side: {
      center: 'center',
      top: 'bottom',
      bottom: 'top',
      left: 'right',
      right: 'left'
    }[anchor.side],
    align: anchor.align
  };
}
function flipAlign(anchor) {
  return {
    side: anchor.side,
    align: {
      center: 'center',
      top: 'bottom',
      bottom: 'top',
      left: 'right',
      right: 'left'
    }[anchor.align]
  };
}
function flipCorner(anchor) {
  return {
    side: anchor.align,
    align: anchor.side
  };
}
function getAxis(anchor) {
  return includes(block, anchor.side) ? 'y' : 'x';
}

class Box {
  constructor(_ref) {
    let {
      x,
      y,
      width,
      height
    } = _ref;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function getOverflow(a, b) {
  return {
    x: {
      before: Math.max(0, b.left - a.left),
      after: Math.max(0, a.right - b.right)
    },
    y: {
      before: Math.max(0, b.top - a.top),
      after: Math.max(0, a.bottom - b.bottom)
    }
  };
}
function getTargetBox(target) {
  if (Array.isArray(target)) {
    return new Box({
      x: target[0],
      y: target[1],
      width: 0,
      height: 0
    });
  } else {
    return target.getBoundingClientRect();
  }
}

// Utilities
/** @see https://stackoverflow.com/a/57876601/2074736 */
function nullifyTransforms(el) {
  const rect = el.getBoundingClientRect();
  const style = getComputedStyle(el);
  const tx = style.transform;
  if (tx) {
    let ta, sx, sy, dx, dy;
    if (tx.startsWith('matrix3d(')) {
      ta = tx.slice(9, -1).split(/, /);
      sx = +ta[0];
      sy = +ta[5];
      dx = +ta[12];
      dy = +ta[13];
    } else if (tx.startsWith('matrix(')) {
      ta = tx.slice(7, -1).split(/, /);
      sx = +ta[0];
      sy = +ta[3];
      dx = +ta[4];
      dy = +ta[5];
    } else {
      return new Box(rect);
    }
    const to = style.transformOrigin;
    const x = rect.x - dx - (1 - sx) * parseFloat(to);
    const y = rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(' ') + 1));
    const w = sx ? rect.width / sx : el.offsetWidth + 1;
    const h = sy ? rect.height / sy : el.offsetHeight + 1;
    return new Box({
      x,
      y,
      width: w,
      height: h
    });
  } else {
    return new Box(rect);
  }
}
function animate(el, keyframes, options) {
  if (typeof el.animate === 'undefined') return {
    finished: Promise.resolve()
  };
  let animation;
  try {
    animation = el.animate(keyframes, options);
  } catch (err) {
    return {
      finished: Promise.resolve()
    };
  }
  if (typeof animation.finished === 'undefined') {
    animation.finished = new Promise(resolve => {
      animation.onfinish = () => {
        resolve(animation);
      };
    });
  }
  return animation;
}

// Utilities
const handlers = new WeakMap();
function bindProps(el, props) {
  Object.keys(props).forEach(k => {
    if (isOn(k)) {
      const name = eventName(k);
      const handler = handlers.get(el);
      if (props[k] == null) {
        handler?.forEach(v => {
          const [n, fn] = v;
          if (n === name) {
            el.removeEventListener(name, fn);
            handler.delete(v);
          }
        });
      } else if (!handler || ![...handler]?.some(v => v[0] === name && v[1] === props[k])) {
        el.addEventListener(name, props[k]);
        const _handler = handler || new Set();
        _handler.add([name, props[k]]);
        if (!handlers.has(el)) handlers.set(el, _handler);
      }
    } else {
      if (props[k] == null) {
        el.removeAttribute(k);
      } else {
        el.setAttribute(k, props[k]);
      }
    }
  });
}
function unbindProps(el, props) {
  Object.keys(props).forEach(k => {
    if (isOn(k)) {
      const name = eventName(k);
      const handler = handlers.get(el);
      handler?.forEach(v => {
        const [n, fn] = v;
        if (n === name) {
          el.removeEventListener(name, fn);
          handler.delete(v);
        }
      });
    } else {
      el.removeAttribute(k);
    }
  });
}

/**
 * WCAG 3.0 APCA perceptual contrast algorithm from https://github.com/Myndex/SAPC-APCA
 * @licence https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 * @see https://www.w3.org/WAI/GL/task-forces/silver/wiki/Visual_Contrast_of_Text_Subgroup
 */
// Types

// MAGICAL NUMBERS

// sRGB Conversion to Relative Luminance (Y)

// Transfer Curve (aka "Gamma") for sRGB linearization
// Simple power curve vs piecewise described in docs
// Essentially, 2.4 best models actual display
// characteristics in combination with the total method
const mainTRC = 2.4;
const Rco = 0.2126729; // sRGB Red Coefficient (from matrix)
const Gco = 0.7151522; // sRGB Green Coefficient (from matrix)
const Bco = 0.0721750; // sRGB Blue Coefficient (from matrix)

// For Finding Raw SAPC Contrast from Relative Luminance (Y)

// Constants for SAPC Power Curve Exponents
// One pair for normal text, and one for reverse
// These are the "beating heart" of SAPC
const normBG = 0.55;
const normTXT = 0.58;
const revTXT = 0.57;
const revBG = 0.62;

// For Clamping and Scaling Values

const blkThrs = 0.03; // Level that triggers the soft black clamp
const blkClmp = 1.45; // Exponent for the soft black clamp curve
const deltaYmin = 0.0005; // Lint trap
const scaleBoW = 1.25; // Scaling for dark text on light
const scaleWoB = 1.25; // Scaling for light text on dark
const loConThresh = 0.078; // Threshold for new simple offset scale
const loConFactor = 12.82051282051282; // = 1/0.078,
const loConOffset = 0.06; // The simple offset
const loClip = 0.001; // Output clip (lint trap #2)

function APCAcontrast(text, background) {
  // Linearize sRGB
  const Rtxt = (text.r / 255) ** mainTRC;
  const Gtxt = (text.g / 255) ** mainTRC;
  const Btxt = (text.b / 255) ** mainTRC;
  const Rbg = (background.r / 255) ** mainTRC;
  const Gbg = (background.g / 255) ** mainTRC;
  const Bbg = (background.b / 255) ** mainTRC;

  // Apply the standard coefficients and sum to Y
  let Ytxt = Rtxt * Rco + Gtxt * Gco + Btxt * Bco;
  let Ybg = Rbg * Rco + Gbg * Gco + Bbg * Bco;

  // Soft clamp Y when near black.
  // Now clamping all colors to prevent crossover errors
  if (Ytxt <= blkThrs) Ytxt += (blkThrs - Ytxt) ** blkClmp;
  if (Ybg <= blkThrs) Ybg += (blkThrs - Ybg) ** blkClmp;

  // Return 0 Early for extremely low ∆Y (lint trap #1)
  if (Math.abs(Ybg - Ytxt) < deltaYmin) return 0.0;

  // SAPC CONTRAST

  let outputContrast; // For weighted final values
  if (Ybg > Ytxt) {
    // For normal polarity, black text on white
    // Calculate the SAPC contrast value and scale

    const SAPC = (Ybg ** normBG - Ytxt ** normTXT) * scaleBoW;

    // NEW! SAPC SmoothScale™
    // Low Contrast Smooth Scale Rollout to prevent polarity reversal
    // and also a low clip for very low contrasts (lint trap #2)
    // much of this is for very low contrasts, less than 10
    // therefore for most reversing needs, only loConOffset is important
    outputContrast = SAPC < loClip ? 0.0 : SAPC < loConThresh ? SAPC - SAPC * loConFactor * loConOffset : SAPC - loConOffset;
  } else {
    // For reverse polarity, light text on dark
    // WoB should always return negative value.

    const SAPC = (Ybg ** revBG - Ytxt ** revTXT) * scaleWoB;
    outputContrast = SAPC > -loClip ? 0.0 : SAPC > -loConThresh ? SAPC - SAPC * loConFactor * loConOffset : SAPC + loConOffset;
  }
  return outputContrast * 100;
}

/* eslint-disable no-console */

function consoleWarn(message) {
  warn(`Vuetify: ${message}`);
}
function consoleError(message) {
  warn(`Vuetify error: ${message}`);
}
function deprecate(original, replacement) {
  replacement = Array.isArray(replacement) ? replacement.slice(0, -1).map(s => `'${s}'`).join(', ') + ` or '${replacement.at(-1)}'` : `'${replacement}'`;
  warn(`[Vuetify UPGRADE] '${original}' is deprecated, use ${replacement} instead.`);
}

// Types

const delta = 0.20689655172413793; // 6÷29

const cielabForwardTransform = t => t > delta ** 3 ? Math.cbrt(t) : t / (3 * delta ** 2) + 4 / 29;
const cielabReverseTransform = t => t > delta ? t ** 3 : 3 * delta ** 2 * (t - 4 / 29);
function fromXYZ$1(xyz) {
  const transform = cielabForwardTransform;
  const transformedY = transform(xyz[1]);
  return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
}
function toXYZ$1(lab) {
  const transform = cielabReverseTransform;
  const Ln = (lab[0] + 16) / 116;
  return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
}

// Utilities
// For converting XYZ to sRGB
const srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]];

// Forward gamma adjust
const srgbForwardTransform = C => C <= 0.0031308 ? C * 12.92 : 1.055 * C ** (1 / 2.4) - 0.055;

// For converting sRGB to XYZ
const srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];

// Reverse gamma adjust
const srgbReverseTransform = C => C <= 0.04045 ? C / 12.92 : ((C + 0.055) / 1.055) ** 2.4;
function fromXYZ(xyz) {
  const rgb = Array(3);
  const transform = srgbForwardTransform;
  const matrix = srgbForwardMatrix;

  // Matrix transform, then gamma adjustment
  for (let i = 0; i < 3; ++i) {
    // Rescale back to [0, 255]
    rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
  }
  return {
    r: rgb[0],
    g: rgb[1],
    b: rgb[2]
  };
}
function toXYZ(_ref) {
  let {
    r,
    g,
    b
  } = _ref;
  const xyz = [0, 0, 0];
  const transform = srgbReverseTransform;
  const matrix = srgbReverseMatrix;

  // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
  r = transform(r / 255);
  g = transform(g / 255);
  b = transform(b / 255);

  // Matrix color space transform
  for (let i = 0; i < 3; ++i) {
    xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
  }
  return xyz;
}

// Utilities
function isCssColor(color) {
  return !!color && /^(#|var\(--|(rgb|hsl)a?\()/.test(color);
}
function isParsableColor(color) {
  return isCssColor(color) && !/^((rgb|hsl)a?\()?var\(--/.test(color);
}
const cssColorRe = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/;
const mappers = {
  rgb: (r, g, b, a) => ({
    r,
    g,
    b,
    a
  }),
  rgba: (r, g, b, a) => ({
    r,
    g,
    b,
    a
  }),
  hsl: (h, s, l, a) => HSLtoRGB({
    h,
    s,
    l,
    a
  }),
  hsla: (h, s, l, a) => HSLtoRGB({
    h,
    s,
    l,
    a
  }),
  hsv: (h, s, v, a) => HSVtoRGB({
    h,
    s,
    v,
    a
  }),
  hsva: (h, s, v, a) => HSVtoRGB({
    h,
    s,
    v,
    a
  })
};
function parseColor(color) {
  if (typeof color === 'number') {
    if (isNaN(color) || color < 0 || color > 0xFFFFFF) {
      // int can't have opacity
      consoleWarn(`'${color}' is not a valid hex color`);
    }
    return {
      r: (color & 0xFF0000) >> 16,
      g: (color & 0xFF00) >> 8,
      b: color & 0xFF
    };
  } else if (typeof color === 'string' && cssColorRe.test(color)) {
    const {
      groups
    } = color.match(cssColorRe);
    const {
      fn,
      values
    } = groups;
    const realValues = values.split(/,\s*/).map(v => {
      if (v.endsWith('%') && ['hsl', 'hsla', 'hsv', 'hsva'].includes(fn)) {
        return parseFloat(v) / 100;
      } else {
        return parseFloat(v);
      }
    });
    return mappers[fn](...realValues);
  } else if (typeof color === 'string') {
    let hex = color.startsWith('#') ? color.slice(1) : color;
    if ([3, 4].includes(hex.length)) {
      hex = hex.split('').map(char => char + char).join('');
    } else if (![6, 8].includes(hex.length)) {
      consoleWarn(`'${color}' is not a valid hex(a) color`);
    }
    const int = parseInt(hex, 16);
    if (isNaN(int) || int < 0 || int > 0xFFFFFFFF) {
      consoleWarn(`'${color}' is not a valid hex(a) color`);
    }
    return HexToRGB(hex);
  } else if (typeof color === 'object') {
    if (has(color, ['r', 'g', 'b'])) {
      return color;
    } else if (has(color, ['h', 's', 'l'])) {
      return HSVtoRGB(HSLtoHSV(color));
    } else if (has(color, ['h', 's', 'v'])) {
      return HSVtoRGB(color);
    }
  }
  throw new TypeError(`Invalid color: ${color == null ? color : String(color) || color.constructor.name}\nExpected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}

/** Converts HSVA to RGBA. Based on formula from https://en.wikipedia.org/wiki/HSL_and_HSV */
function HSVtoRGB(hsva) {
  const {
    h,
    s,
    v,
    a
  } = hsva;
  const f = n => {
    const k = (n + h / 60) % 6;
    return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  };
  const rgb = [f(5), f(3), f(1)].map(v => Math.round(v * 255));
  return {
    r: rgb[0],
    g: rgb[1],
    b: rgb[2],
    a
  };
}
function HSLtoRGB(hsla) {
  return HSVtoRGB(HSLtoHSV(hsla));
}
function HSLtoHSV(hsl) {
  const {
    h,
    s,
    l,
    a
  } = hsl;
  const v = l + s * Math.min(l, 1 - l);
  const sprime = v === 0 ? 0 : 2 - 2 * l / v;
  return {
    h,
    s: sprime,
    v,
    a
  };
}
function toHex(v) {
  const h = Math.round(v).toString(16);
  return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
}
function RGBtoHex(_ref2) {
  let {
    r,
    g,
    b,
    a
  } = _ref2;
  return `#${[toHex(r), toHex(g), toHex(b), a !== undefined ? toHex(Math.round(a * 255)) : ''].join('')}`;
}
function HexToRGB(hex) {
  hex = parseHex(hex);
  let [r, g, b, a] = chunk(hex, 2).map(c => parseInt(c, 16));
  a = a === undefined ? a : a / 255;
  return {
    r,
    g,
    b,
    a
  };
}
function parseHex(hex) {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }
  hex = hex.replace(/([^0-9a-f])/gi, 'F');
  if (hex.length === 3 || hex.length === 4) {
    hex = hex.split('').map(x => x + x).join('');
  }
  if (hex.length !== 6) {
    hex = padEnd(padEnd(hex, 6), 8, 'F');
  }
  return hex;
}
function lighten(value, amount) {
  const lab = fromXYZ$1(toXYZ(value));
  lab[0] = lab[0] + amount * 10;
  return fromXYZ(toXYZ$1(lab));
}
function darken(value, amount) {
  const lab = fromXYZ$1(toXYZ(value));
  lab[0] = lab[0] - amount * 10;
  return fromXYZ(toXYZ$1(lab));
}

/**
 * Calculate the relative luminance of a given color
 * @see https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */
function getLuma(color) {
  const rgb = parseColor(color);
  return toXYZ(rgb)[1];
}
function getForeground(color) {
  const blackContrast = Math.abs(APCAcontrast(parseColor(0), parseColor(color)));
  const whiteContrast = Math.abs(APCAcontrast(parseColor(0xffffff), parseColor(color)));

  // TODO: warn about poor color selections
  // const contrastAsText = Math.abs(APCAcontrast(colorVal, colorToInt(theme.colors.background)))
  // const minContrast = Math.max(blackContrast, whiteContrast)
  // if (minContrast < 60) {
  //   consoleInfo(`${key} theme color ${color} has poor contrast (${minContrast.toFixed()}%)`)
  // } else if (contrastAsText < 60 && !['background', 'surface'].includes(color)) {
  //   consoleInfo(`${key} theme color ${color} has poor contrast as text (${contrastAsText.toFixed()}%)`)
  // }

  // Prefer white text if both have an acceptable contrast ratio
  return whiteContrast > Math.min(blackContrast, 50) ? '#fff' : '#000';
}

// Types
// eslint-disable-line vue/prefer-import-from-vue

/**
 * Creates a factory function for props definitions.
 * This is used to define props in a composable then override
 * default values in an implementing component.
 *
 * @example Simplified signature
 * (props: Props) => (defaults?: Record<keyof props, any>) => Props
 *
 * @example Usage
 * const makeProps = propsFactory({
 *   foo: String,
 * })
 *
 * defineComponent({
 *   props: {
 *     ...makeProps({
 *       foo: 'a',
 *     }),
 *   },
 *   setup (props) {
 *     // would be "string | undefined", now "string" because a default has been provided
 *     props.foo
 *   },
 * }
 */

function propsFactory(props, source) {
  return defaults => {
    return Object.keys(props).reduce((obj, prop) => {
      const isObjectDefinition = typeof props[prop] === 'object' && props[prop] != null && !Array.isArray(props[prop]);
      const definition = isObjectDefinition ? props[prop] : {
        type: props[prop]
      };
      if (defaults && prop in defaults) {
        obj[prop] = {
          ...definition,
          default: defaults[prop]
        };
      } else {
        obj[prop] = definition;
      }
      if (source && !obj[prop].source) {
        obj[prop].source = source;
      }
      return obj;
    }, {});
  };
}

/**
 * Like `Partial<T>` but doesn't care what the value is
 */

// Copied from Vue

// Utilities
// Composables
const makeComponentProps = propsFactory({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, 'component');

// Utilities
function getCurrentInstance(name, message) {
  const vm = getCurrentInstance$1();
  if (!vm) {
    throw new Error(`[Vuetify] ${name} ${'must be called from inside a setup function'}`);
  }
  return vm;
}
function getCurrentInstanceName() {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'composables';
  const vm = getCurrentInstance(name).type;
  return toKebabCase(vm?.aliasName || vm?.name);
}
let _uid = 0;
let _map = new WeakMap();
function getUid() {
  const vm = getCurrentInstance('getUid');
  if (_map.has(vm)) return _map.get(vm);else {
    const uid = _uid++;
    _map.set(vm, uid);
    return uid;
  }
}
getUid.reset = () => {
  _uid = 0;
  _map = new WeakMap();
};

// Utilities
function injectSelf(key) {
  let vm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstance('injectSelf');
  const {
    provides
  } = vm;
  if (provides && key in provides) {
    // TS doesn't allow symbol as index type
    return provides[key];
  }
  return undefined;
}

// Utilities
const DefaultsSymbol = Symbol.for('vuetify:defaults');
function createDefaults(options) {
  return ref(options);
}
function injectDefaults() {
  const defaults = inject$2(DefaultsSymbol);
  if (!defaults) throw new Error('[Vuetify] Could not find defaults instance');
  return defaults;
}
function provideDefaults(defaults, options) {
  const injectedDefaults = injectDefaults();
  const providedDefaults = ref(defaults);
  const newDefaults = computed(() => {
    const disabled = unref(options?.disabled);
    if (disabled) return injectedDefaults.value;
    const scoped = unref(options?.scoped);
    const reset = unref(options?.reset);
    const root = unref(options?.root);
    if (providedDefaults.value == null && !(scoped || reset || root)) return injectedDefaults.value;
    let properties = mergeDeep(providedDefaults.value, {
      prev: injectedDefaults.value
    });
    if (scoped) return properties;
    if (reset || root) {
      const len = Number(reset || Infinity);
      for (let i = 0; i <= len; i++) {
        if (!properties || !('prev' in properties)) {
          break;
        }
        properties = properties.prev;
      }
      if (properties && typeof root === 'string' && root in properties) {
        properties = mergeDeep(mergeDeep(properties, {
          prev: properties
        }), properties[root]);
      }
      return properties;
    }
    return properties.prev ? mergeDeep(properties.prev, properties) : properties;
  });
  provide(DefaultsSymbol, newDefaults);
  return newDefaults;
}
function propIsDefined(vnode, prop) {
  return typeof vnode.props?.[prop] !== 'undefined' || typeof vnode.props?.[toKebabCase(prop)] !== 'undefined';
}
function internalUseDefaults() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let name = arguments.length > 1 ? arguments[1] : undefined;
  let defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : injectDefaults();
  const vm = getCurrentInstance('useDefaults');
  name = name ?? vm.type.name ?? vm.type.__name;
  if (!name) {
    throw new Error('[Vuetify] Could not determine component name');
  }
  const componentDefaults = computed(() => defaults.value?.[props._as ?? name]);
  const _props = new Proxy(props, {
    get(target, prop) {
      const propValue = Reflect.get(target, prop);
      if (prop === 'class' || prop === 'style') {
        return [componentDefaults.value?.[prop], propValue].filter(v => v != null);
      } else if (typeof prop === 'string' && !propIsDefined(vm.vnode, prop)) {
        return componentDefaults.value?.[prop] !== undefined ? componentDefaults.value?.[prop] : defaults.value?.global?.[prop] !== undefined ? defaults.value?.global?.[prop] : propValue;
      }
      return propValue;
    }
  });
  const _subcomponentDefaults = shallowRef();
  watchEffect(() => {
    if (componentDefaults.value) {
      const subComponents = Object.entries(componentDefaults.value).filter(_ref => {
        let [key] = _ref;
        return key.startsWith(key[0].toUpperCase());
      });
      _subcomponentDefaults.value = subComponents.length ? Object.fromEntries(subComponents) : undefined;
    } else {
      _subcomponentDefaults.value = undefined;
    }
  });
  function provideSubDefaults() {
    const injected = injectSelf(DefaultsSymbol, vm);
    provide(DefaultsSymbol, computed(() => {
      return _subcomponentDefaults.value ? mergeDeep(injected?.value ?? {}, _subcomponentDefaults.value) : injected?.value;
    }));
  }
  return {
    props: _props,
    provideSubDefaults
  };
}

// Composables
// No props
// Object Props
// Implementation
function defineComponent(options) {
  options._setup = options._setup ?? options.setup;
  if (!options.name) {
    consoleWarn('The component is missing an explicit name, unable to generate default prop value');
    return options;
  }
  if (options._setup) {
    options.props = propsFactory(options.props ?? {}, options.name)();
    const propKeys = Object.keys(options.props).filter(key => key !== 'class' && key !== 'style');
    options.filterProps = function filterProps(props) {
      return pick(props, propKeys);
    };
    options.props._as = String;
    options.setup = function setup(props, ctx) {
      const defaults = injectDefaults();

      // Skip props proxy if defaults are not provided
      if (!defaults.value) return options._setup(props, ctx);
      const {
        props: _props,
        provideSubDefaults
      } = internalUseDefaults(props, props._as ?? options.name, defaults);
      const setupBindings = options._setup(_props, ctx);
      provideSubDefaults();
      return setupBindings;
    };
  }
  return options;
}

// No argument - simple default slot

// Generic constructor argument - generic props and slots

// Slots argument - simple slots

// Implementation
function genericComponent() {
  let exposeDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return options => (exposeDefaults ? defineComponent : defineComponent$1)(options);
}
function defineFunctionalComponent(props, render) {
  render.props = props;
  return render;
}

// Adds a filterProps method to the component options

// https://github.com/vuejs/core/pull/10557

// not a vue Component

// Composables
function createSimpleFunctional(klass) {
  let tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  let name = arguments.length > 2 ? arguments[2] : undefined;
  return genericComponent()({
    name: name ?? capitalize(camelize(klass.replace(/__/g, '-'))),
    props: {
      tag: {
        type: String,
        default: tag
      },
      ...makeComponentProps()
    },
    setup(props, _ref) {
      let {
        slots
      } = _ref;
      return () => {
        return h(props.tag, {
          class: [klass, props.class],
          style: props.style
        }, slots.default?.());
      };
    }
  });
}

/**
 * Returns:
 *  - 'null' if the node is not attached to the DOM
 *  - the root node (HTMLDocument | ShadowRoot) otherwise
 */
function attachedRoot(node) {
  /* istanbul ignore next */
  if (typeof node.getRootNode !== 'function') {
    // Shadow DOM not supported (IE11), lets find the root of this node
    while (node.parentNode) node = node.parentNode;

    // The root parent is the document if the node is attached to the DOM
    if (node !== document) return null;
    return document;
  }
  const root = node.getRootNode();

  // The composed root node is the document if the node is attached to the DOM
  if (root !== document && root.getRootNode({
    composed: true
  }) !== document) return null;
  return root;
}

const standardEasing = 'cubic-bezier(0.4, 0, 0.2, 1)';
const deceleratedEasing = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Entering
const acceleratedEasing = 'cubic-bezier(0.4, 0, 1, 1)'; // Leaving

// Utilities
function getPrefixedEventHandlers(attrs, suffix, getData) {
  return Object.keys(attrs).filter(key => isOn(key) && key.endsWith(suffix)).reduce((acc, key) => {
    acc[key.slice(0, -suffix.length)] = event => attrs[key](event, getData(event));
    return acc;
  }, {});
}

function getScrollParent(el) {
  let includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  while (el) {
    if (includeHidden ? isPotentiallyScrollable(el) : hasScrollbar(el)) return el;
    el = el.parentElement;
  }
  return document.scrollingElement;
}
function getScrollParents(el, stopAt) {
  const elements = [];
  if (stopAt && el && !stopAt.contains(el)) return elements;
  while (el) {
    if (hasScrollbar(el)) elements.push(el);
    if (el === stopAt) break;
    el = el.parentElement;
  }
  return elements;
}
function hasScrollbar(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
  const style = window.getComputedStyle(el);
  return style.overflowY === 'scroll' || style.overflowY === 'auto' && el.scrollHeight > el.clientHeight;
}
function isPotentiallyScrollable(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
  const style = window.getComputedStyle(el);
  return ['scroll', 'auto'].includes(style.overflowY);
}

function isFixedPosition(el) {
  while (el) {
    if (window.getComputedStyle(el).position === 'fixed') {
      return true;
    }
    el = el.offsetParent;
  }
  return false;
}

// Utilities
function useRender(render) {
  const vm = getCurrentInstance('useRender');
  vm.render = render;
}

// Composables
// Composables
function useProxiedModel(props, prop, defaultValue) {
  let transformIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : v => v;
  let transformOut = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : v => v;
  const vm = getCurrentInstance('useProxiedModel');
  const internal = ref(props[prop] !== undefined ? props[prop] : defaultValue);
  const kebabProp = toKebabCase(prop);
  const checkKebab = kebabProp !== prop;
  const isControlled = checkKebab ? computed(() => {
    void props[prop];
    return !!((vm.vnode.props?.hasOwnProperty(prop) || vm.vnode.props?.hasOwnProperty(kebabProp)) && (vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`) || vm.vnode.props?.hasOwnProperty(`onUpdate:${kebabProp}`)));
  }) : computed(() => {
    void props[prop];
    return !!(vm.vnode.props?.hasOwnProperty(prop) && vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`));
  });
  useToggleScope(() => !isControlled.value, () => {
    watch(() => props[prop], val => {
      internal.value = val;
    });
  });
  const model = computed({
    get() {
      const externalValue = props[prop];
      return transformIn(isControlled.value ? externalValue : internal.value);
    },
    set(internalValue) {
      const newValue = transformOut(internalValue);
      const value = toRaw(isControlled.value ? props[prop] : internal.value);
      if (value === newValue || transformIn(value) === internalValue) {
        return;
      }
      internal.value = newValue;
      vm?.emit(`update:${prop}`, newValue);
    }
  });
  Object.defineProperty(model, 'externalValue', {
    get: () => isControlled.value ? props[prop] : internal.value
  });
  return model;
}

const en = {
  badge: 'Badge',
  open: 'Open',
  close: 'Close',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancel'
  },
  dataIterator: {
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: 'Sorted descending.',
      sortAscending: 'Sorted ascending.',
      sortNone: 'Not sorted.',
      activateNone: 'Activate to remove sorting.',
      activateDescending: 'Activate to sort descending.',
      activateAscending: 'Activate to sort ascending.'
    },
    sortBy: 'Sort by'
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },
  dateRangeInput: {
    divider: 'to'
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Select dates',
      header: 'Enter dates'
    },
    title: 'Select date',
    header: 'Enter date',
    input: {
      placeholder: 'Enter date'
    }
  },
  noDataText: 'No data available',
  carousel: {
    prev: 'Previous visual',
    next: 'Next visual',
    ariaLabel: {
      delimiter: 'Carousel slide {0} of {1}'
    }
  },
  calendar: {
    moreEvents: '{0} more',
    today: 'Today'
  },
  input: {
    clear: 'Clear {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'Please enter OTP character {0}'
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)'
  },
  fileUpload: {
    title: 'Drag and drop files here',
    divider: 'or',
    browse: 'Browse Files'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time'
  },
  pagination: {
    ariaLabel: {
      root: 'Pagination Navigation',
      next: 'Next page',
      previous: 'Previous page',
      page: 'Go to page {0}',
      currentPage: 'Page {0}, Current page',
      first: 'First page',
      last: 'Last page'
    }
  },
  stepper: {
    next: 'Next',
    prev: 'Previous'
  },
  rating: {
    ariaLabel: {
      item: 'Rating {0} of {1}'
    }
  },
  loading: 'Loading...',
  infiniteScroll: {
    loadMore: 'Load more',
    empty: 'No more'
  }
};

// Composables
const LANG_PREFIX = '$vuetify.';
const replace = (str, params) => {
  return str.replace(/\{(\d+)\}/g, (match, index) => {
    return String(params[+index]);
  });
};
const createTranslateFunction = (current, fallback, messages) => {
  return function (key) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    if (!key.startsWith(LANG_PREFIX)) {
      return replace(key, params);
    }
    const shortKey = key.replace(LANG_PREFIX, '');
    const currentLocale = current.value && messages.value[current.value];
    const fallbackLocale = fallback.value && messages.value[fallback.value];
    let str = getObjectValueByPath(currentLocale, shortKey, null);
    if (!str) {
      consoleWarn(`Translation key "${key}" not found in "${current.value}", trying fallback locale`);
      str = getObjectValueByPath(fallbackLocale, shortKey, null);
    }
    if (!str) {
      consoleError(`Translation key "${key}" not found in fallback`);
      str = key;
    }
    if (typeof str !== 'string') {
      consoleError(`Translation key "${key}" has a non-string value`);
      str = key;
    }
    return replace(str, params);
  };
};
function createNumberFunction(current, fallback) {
  return (value, options) => {
    const numberFormat = new Intl.NumberFormat([current.value, fallback.value], options);
    return numberFormat.format(value);
  };
}
function useProvided(props, prop, provided) {
  const internal = useProxiedModel(props, prop, props[prop] ?? provided.value);

  // TODO: Remove when defaultValue works
  internal.value = props[prop] ?? provided.value;
  watch(provided, v => {
    if (props[prop] == null) {
      internal.value = provided.value;
    }
  });
  return internal;
}
function createProvideFunction(state) {
  return props => {
    const current = useProvided(props, 'locale', state.current);
    const fallback = useProvided(props, 'fallback', state.fallback);
    const messages = useProvided(props, 'messages', state.messages);
    return {
      name: 'vuetify',
      current,
      fallback,
      messages,
      t: createTranslateFunction(current, fallback, messages),
      n: createNumberFunction(current, fallback),
      provide: createProvideFunction({
        current,
        fallback,
        messages
      })
    };
  };
}
function createVuetifyAdapter(options) {
  const current = shallowRef(options?.locale ?? 'en');
  const fallback = shallowRef(options?.fallback ?? 'en');
  const messages = ref({
    en,
    ...options?.messages
  });
  return {
    name: 'vuetify',
    current,
    fallback,
    messages,
    t: createTranslateFunction(current, fallback, messages),
    n: createNumberFunction(current, fallback),
    provide: createProvideFunction({
      current,
      fallback,
      messages
    })
  };
}

// Utilities
const LocaleSymbol = Symbol.for('vuetify:locale');
function isLocaleInstance(obj) {
  return obj.name != null;
}
function createLocale(options) {
  const i18n = options?.adapter && isLocaleInstance(options?.adapter) ? options?.adapter : createVuetifyAdapter(options);
  const rtl = createRtl(i18n, options);
  return {
    ...i18n,
    ...rtl
  };
}
function useLocale() {
  const locale = inject$2(LocaleSymbol);
  if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
  return locale;
}
function genDefaults$3() {
  return {
    af: false,
    ar: true,
    bg: false,
    ca: false,
    ckb: false,
    cs: false,
    de: false,
    el: false,
    en: false,
    es: false,
    et: false,
    fa: true,
    fi: false,
    fr: false,
    hr: false,
    hu: false,
    he: true,
    id: false,
    it: false,
    ja: false,
    km: false,
    ko: false,
    lv: false,
    lt: false,
    nl: false,
    no: false,
    pl: false,
    pt: false,
    ro: false,
    ru: false,
    sk: false,
    sl: false,
    srCyrl: false,
    srLatn: false,
    sv: false,
    th: false,
    tr: false,
    az: false,
    uk: false,
    vi: false,
    zhHans: false,
    zhHant: false
  };
}
function createRtl(i18n, options) {
  const rtl = ref(options?.rtl ?? genDefaults$3());
  const isRtl = computed(() => rtl.value[i18n.current.value] ?? false);
  return {
    isRtl,
    rtl,
    rtlClasses: computed(() => `v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
  };
}
function useRtl() {
  const locale = inject$2(LocaleSymbol);
  if (!locale) throw new Error('[Vuetify] Could not find injected rtl instance');
  return {
    isRtl: locale.isRtl,
    rtlClasses: locale.rtlClasses
  };
}

// Utilities
const firstDay = {
  '001': 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AG: 0,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AS: 0,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BD: 0,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BR: 0,
  BS: 0,
  BT: 0,
  BW: 0,
  BY: 1,
  BZ: 0,
  CA: 0,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CO: 0,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DM: 0,
  DO: 0,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  ET: 0,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  'GB-alt-variant': 0,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  GT: 0,
  GU: 0,
  HK: 0,
  HN: 0,
  HR: 1,
  HU: 1,
  ID: 0,
  IE: 1,
  IL: 0,
  IN: 0,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JM: 0,
  JO: 6,
  JP: 0,
  KE: 0,
  KG: 1,
  KH: 0,
  KR: 0,
  KW: 6,
  KZ: 1,
  LA: 0,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MH: 0,
  MK: 1,
  MM: 0,
  MN: 1,
  MO: 0,
  MQ: 1,
  MT: 0,
  MV: 5,
  MX: 0,
  MY: 1,
  MZ: 0,
  NI: 0,
  NL: 1,
  NO: 1,
  NP: 0,
  NZ: 1,
  OM: 6,
  PA: 0,
  PE: 0,
  PH: 0,
  PK: 0,
  PL: 1,
  PR: 0,
  PT: 0,
  PY: 0,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SA: 0,
  SD: 6,
  SE: 1,
  SG: 0,
  SI: 1,
  SK: 1,
  SM: 1,
  SV: 0,
  SY: 6,
  TH: 0,
  TJ: 1,
  TM: 1,
  TR: 1,
  TT: 0,
  TW: 0,
  UA: 1,
  UM: 0,
  US: 0,
  UY: 1,
  UZ: 1,
  VA: 1,
  VE: 0,
  VI: 0,
  VN: 1,
  WS: 0,
  XK: 1,
  YE: 0,
  ZA: 0,
  ZW: 0
};
function getWeekArray(date, locale, firstDayOfWeek) {
  const weeks = [];
  let currentWeek = [];
  const firstDayOfMonth = startOfMonth(date);
  const lastDayOfMonth = endOfMonth(date);
  const first = firstDayOfWeek ?? firstDay[locale.slice(-2).toUpperCase()] ?? 0;
  const firstDayWeekIndex = (firstDayOfMonth.getDay() - first + 7) % 7;
  const lastDayWeekIndex = (lastDayOfMonth.getDay() - first + 7) % 7;
  for (let i = 0; i < firstDayWeekIndex; i++) {
    const adjacentDay = new Date(firstDayOfMonth);
    adjacentDay.setDate(adjacentDay.getDate() - (firstDayWeekIndex - i));
    currentWeek.push(adjacentDay);
  }
  for (let i = 1; i <= lastDayOfMonth.getDate(); i++) {
    const day = new Date(date.getFullYear(), date.getMonth(), i);

    // Add the day to the current week
    currentWeek.push(day);

    // If the current week has 7 days, add it to the weeks array and start a new week
    if (currentWeek.length === 7) {
      weeks.push(currentWeek);
      currentWeek = [];
    }
  }
  for (let i = 1; i < 7 - lastDayWeekIndex; i++) {
    const adjacentDay = new Date(lastDayOfMonth);
    adjacentDay.setDate(adjacentDay.getDate() + i);
    currentWeek.push(adjacentDay);
  }
  if (currentWeek.length > 0) {
    weeks.push(currentWeek);
  }
  return weeks;
}
function startOfWeek(date, locale, firstDayOfWeek) {
  const day = firstDayOfWeek ?? firstDay[locale.slice(-2).toUpperCase()] ?? 0;
  const d = new Date(date);
  while (d.getDay() !== day) {
    d.setDate(d.getDate() - 1);
  }
  return d;
}
function endOfWeek(date, locale) {
  const d = new Date(date);
  const lastDay = ((firstDay[locale.slice(-2).toUpperCase()] ?? 0) + 6) % 7;
  while (d.getDay() !== lastDay) {
    d.setDate(d.getDate() + 1);
  }
  return d;
}
function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}
function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
function parseLocalDate(value) {
  const parts = value.split('-').map(Number);

  // new Date() uses local time zone when passing individual date component values
  return new Date(parts[0], parts[1] - 1, parts[2]);
}
const _YYYMMDD = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function date(value) {
  if (value == null) return new Date();
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    let parsed;
    if (_YYYMMDD.test(value)) {
      return parseLocalDate(value);
    } else {
      parsed = Date.parse(value);
    }
    if (!isNaN(parsed)) return new Date(parsed);
  }
  return null;
}
const sundayJanuarySecond2000 = new Date(2000, 0, 2);
function getWeekdays(locale, firstDayOfWeek) {
  const daysFromSunday = firstDayOfWeek ?? firstDay[locale.slice(-2).toUpperCase()] ?? 0;
  return createRange(7).map(i => {
    const weekday = new Date(sundayJanuarySecond2000);
    weekday.setDate(sundayJanuarySecond2000.getDate() + daysFromSunday + i);
    return new Intl.DateTimeFormat(locale, {
      weekday: 'narrow'
    }).format(weekday);
  });
}
function format(value, formatString, locale, formats) {
  const newDate = date(value) ?? new Date();
  const customFormat = formats?.[formatString];
  if (typeof customFormat === 'function') {
    return customFormat(newDate, formatString, locale);
  }
  let options = {};
  switch (formatString) {
    case 'fullDate':
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      break;
    case 'fullDateWithWeekday':
      options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      break;
    case 'normalDate':
      const day = newDate.getDate();
      const month = new Intl.DateTimeFormat(locale, {
        month: 'long'
      }).format(newDate);
      return `${day} ${month}`;
    case 'normalDateWithWeekday':
      options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      };
      break;
    case 'shortDate':
      options = {
        month: 'short',
        day: 'numeric'
      };
      break;
    case 'year':
      options = {
        year: 'numeric'
      };
      break;
    case 'month':
      options = {
        month: 'long'
      };
      break;
    case 'monthShort':
      options = {
        month: 'short'
      };
      break;
    case 'monthAndYear':
      options = {
        month: 'long',
        year: 'numeric'
      };
      break;
    case 'monthAndDate':
      options = {
        month: 'long',
        day: 'numeric'
      };
      break;
    case 'weekday':
      options = {
        weekday: 'long'
      };
      break;
    case 'weekdayShort':
      options = {
        weekday: 'short'
      };
      break;
    case 'dayOfMonth':
      return new Intl.NumberFormat(locale).format(newDate.getDate());
    case 'hours12h':
      options = {
        hour: 'numeric',
        hour12: true
      };
      break;
    case 'hours24h':
      options = {
        hour: 'numeric',
        hour12: false
      };
      break;
    case 'minutes':
      options = {
        minute: 'numeric'
      };
      break;
    case 'seconds':
      options = {
        second: 'numeric'
      };
      break;
    case 'fullTime':
      options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      };
      break;
    case 'fullTime12h':
      options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      };
      break;
    case 'fullTime24h':
      options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      };
      break;
    case 'fullDateTime':
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      };
      break;
    case 'fullDateTime12h':
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      };
      break;
    case 'fullDateTime24h':
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      };
      break;
    case 'keyboardDate':
      options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
      break;
    case 'keyboardDateTime':
      options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      };
      break;
    case 'keyboardDateTime12h':
      options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      };
      break;
    case 'keyboardDateTime24h':
      options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
      };
      break;
    default:
      options = customFormat ?? {
        timeZone: 'UTC',
        timeZoneName: 'short'
      };
  }
  return new Intl.DateTimeFormat(locale, options).format(newDate);
}
function toISO(adapter, value) {
  const date = adapter.toJsDate(value);
  const year = date.getFullYear();
  const month = padStart(String(date.getMonth() + 1), 2, '0');
  const day = padStart(String(date.getDate()), 2, '0');
  return `${year}-${month}-${day}`;
}
function parseISO(value) {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
}
function addMinutes(date, amount) {
  const d = new Date(date);
  d.setMinutes(d.getMinutes() + amount);
  return d;
}
function addHours(date, amount) {
  const d = new Date(date);
  d.setHours(d.getHours() + amount);
  return d;
}
function addDays(date, amount) {
  const d = new Date(date);
  d.setDate(d.getDate() + amount);
  return d;
}
function addWeeks(date, amount) {
  const d = new Date(date);
  d.setDate(d.getDate() + amount * 7);
  return d;
}
function addMonths(date, amount) {
  const d = new Date(date);
  d.setDate(1);
  d.setMonth(d.getMonth() + amount);
  return d;
}
function getYear(date) {
  return date.getFullYear();
}
function getMonth(date) {
  return date.getMonth();
}
function getDate(date) {
  return date.getDate();
}
function getNextMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}
function getPreviousMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}
function getHours(date) {
  return date.getHours();
}
function getMinutes(date) {
  return date.getMinutes();
}
function startOfYear(date) {
  return new Date(date.getFullYear(), 0, 1);
}
function endOfYear(date) {
  return new Date(date.getFullYear(), 11, 31);
}
function isWithinRange(date, range) {
  return isAfter(date, range[0]) && isBefore(date, range[1]);
}
function isValid(date) {
  const d = new Date(date);
  return d instanceof Date && !isNaN(d.getTime());
}
function isAfter(date, comparing) {
  return date.getTime() > comparing.getTime();
}
function isAfterDay(date, comparing) {
  return isAfter(startOfDay(date), startOfDay(comparing));
}
function isBefore(date, comparing) {
  return date.getTime() < comparing.getTime();
}
function isEqual(date, comparing) {
  return date.getTime() === comparing.getTime();
}
function isSameDay(date, comparing) {
  return date.getDate() === comparing.getDate() && date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function isSameMonth(date, comparing) {
  return date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function isSameYear(date, comparing) {
  return date.getFullYear() === comparing.getFullYear();
}
function getDiff(date, comparing, unit) {
  const d = new Date(date);
  const c = new Date(comparing);
  switch (unit) {
    case 'years':
      return d.getFullYear() - c.getFullYear();
    case 'quarters':
      return Math.floor((d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12) / 4);
    case 'months':
      return d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12;
    case 'weeks':
      return Math.floor((d.getTime() - c.getTime()) / (1000 * 60 * 60 * 24 * 7));
    case 'days':
      return Math.floor((d.getTime() - c.getTime()) / (1000 * 60 * 60 * 24));
    case 'hours':
      return Math.floor((d.getTime() - c.getTime()) / (1000 * 60 * 60));
    case 'minutes':
      return Math.floor((d.getTime() - c.getTime()) / (1000 * 60));
    case 'seconds':
      return Math.floor((d.getTime() - c.getTime()) / 1000);
    default:
      {
        return d.getTime() - c.getTime();
      }
  }
}
function setHours(date, count) {
  const d = new Date(date);
  d.setHours(count);
  return d;
}
function setMinutes(date, count) {
  const d = new Date(date);
  d.setMinutes(count);
  return d;
}
function setMonth(date, count) {
  const d = new Date(date);
  d.setMonth(count);
  return d;
}
function setDate(date, day) {
  const d = new Date(date);
  d.setDate(day);
  return d;
}
function setYear(date, year) {
  const d = new Date(date);
  d.setFullYear(year);
  return d;
}
function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}
function endOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}
class VuetifyDateAdapter {
  constructor(options) {
    this.locale = options.locale;
    this.formats = options.formats;
  }
  date(value) {
    return date(value);
  }
  toJsDate(date) {
    return date;
  }
  toISO(date) {
    return toISO(this, date);
  }
  parseISO(date) {
    return parseISO(date);
  }
  addMinutes(date, amount) {
    return addMinutes(date, amount);
  }
  addHours(date, amount) {
    return addHours(date, amount);
  }
  addDays(date, amount) {
    return addDays(date, amount);
  }
  addWeeks(date, amount) {
    return addWeeks(date, amount);
  }
  addMonths(date, amount) {
    return addMonths(date, amount);
  }
  getWeekArray(date, firstDayOfWeek) {
    return getWeekArray(date, this.locale, firstDayOfWeek ? Number(firstDayOfWeek) : undefined);
  }
  startOfWeek(date, firstDayOfWeek) {
    return startOfWeek(date, this.locale, firstDayOfWeek ? Number(firstDayOfWeek) : undefined);
  }
  endOfWeek(date) {
    return endOfWeek(date, this.locale);
  }
  startOfMonth(date) {
    return startOfMonth(date);
  }
  endOfMonth(date) {
    return endOfMonth(date);
  }
  format(date, formatString) {
    return format(date, formatString, this.locale, this.formats);
  }
  isEqual(date, comparing) {
    return isEqual(date, comparing);
  }
  isValid(date) {
    return isValid(date);
  }
  isWithinRange(date, range) {
    return isWithinRange(date, range);
  }
  isAfter(date, comparing) {
    return isAfter(date, comparing);
  }
  isAfterDay(date, comparing) {
    return isAfterDay(date, comparing);
  }
  isBefore(date, comparing) {
    return !isAfter(date, comparing) && !isEqual(date, comparing);
  }
  isSameDay(date, comparing) {
    return isSameDay(date, comparing);
  }
  isSameMonth(date, comparing) {
    return isSameMonth(date, comparing);
  }
  isSameYear(date, comparing) {
    return isSameYear(date, comparing);
  }
  setMinutes(date, count) {
    return setMinutes(date, count);
  }
  setHours(date, count) {
    return setHours(date, count);
  }
  setMonth(date, count) {
    return setMonth(date, count);
  }
  setDate(date, day) {
    return setDate(date, day);
  }
  setYear(date, year) {
    return setYear(date, year);
  }
  getDiff(date, comparing, unit) {
    return getDiff(date, comparing, unit);
  }
  getWeekdays(firstDayOfWeek) {
    return getWeekdays(this.locale, firstDayOfWeek ? Number(firstDayOfWeek) : undefined);
  }
  getYear(date) {
    return getYear(date);
  }
  getMonth(date) {
    return getMonth(date);
  }
  getDate(date) {
    return getDate(date);
  }
  getNextMonth(date) {
    return getNextMonth(date);
  }
  getPreviousMonth(date) {
    return getPreviousMonth(date);
  }
  getHours(date) {
    return getHours(date);
  }
  getMinutes(date) {
    return getMinutes(date);
  }
  startOfDay(date) {
    return startOfDay(date);
  }
  endOfDay(date) {
    return endOfDay(date);
  }
  startOfYear(date) {
    return startOfYear(date);
  }
  endOfYear(date) {
    return endOfYear(date);
  }
}

// Composables
const DateOptionsSymbol = Symbol.for('vuetify:date-options');
const DateAdapterSymbol = Symbol.for('vuetify:date-adapter');
function createDate(options, locale) {
  const _options = mergeDeep({
    adapter: VuetifyDateAdapter,
    locale: {
      af: 'af-ZA',
      // ar: '', # not the same value for all variants
      bg: 'bg-BG',
      ca: 'ca-ES',
      ckb: '',
      cs: 'cs-CZ',
      de: 'de-DE',
      el: 'el-GR',
      en: 'en-US',
      // es: '', # not the same value for all variants
      et: 'et-EE',
      fa: 'fa-IR',
      fi: 'fi-FI',
      // fr: '', #not the same value for all variants
      hr: 'hr-HR',
      hu: 'hu-HU',
      he: 'he-IL',
      id: 'id-ID',
      it: 'it-IT',
      ja: 'ja-JP',
      ko: 'ko-KR',
      lv: 'lv-LV',
      lt: 'lt-LT',
      nl: 'nl-NL',
      no: 'no-NO',
      pl: 'pl-PL',
      pt: 'pt-PT',
      ro: 'ro-RO',
      ru: 'ru-RU',
      sk: 'sk-SK',
      sl: 'sl-SI',
      srCyrl: 'sr-SP',
      srLatn: 'sr-SP',
      sv: 'sv-SE',
      th: 'th-TH',
      tr: 'tr-TR',
      az: 'az-AZ',
      uk: 'uk-UA',
      vi: 'vi-VN',
      zhHans: 'zh-CN',
      zhHant: 'zh-TW'
    }
  }, options);
  return {
    options: _options,
    instance: createInstance(_options, locale)
  };
}
function createInstance(options, locale) {
  const instance = reactive(typeof options.adapter === 'function'
  // eslint-disable-next-line new-cap
  ? new options.adapter({
    locale: options.locale[locale.current.value] ?? locale.current.value,
    formats: options.formats
  }) : options.adapter);
  watch(locale.current, value => {
    instance.locale = options.locale[value] ?? value ?? instance.locale;
  });
  return instance;
}
function useDate() {
  const options = inject$2(DateOptionsSymbol);
  if (!options) throw new Error('[Vuetify] Could not find injected date options');
  const locale = useLocale();
  return createInstance(options, locale);
}

// https://stackoverflow.com/questions/274861/how-do-i-calculate-the-week-number-given-a-date/275024#275024
function getWeek(adapter, value) {
  const date = adapter.toJsDate(value);
  let year = date.getFullYear();
  let d1w1 = new Date(year, 0, 1);
  if (date < d1w1) {
    year = year - 1;
    d1w1 = new Date(year, 0, 1);
  } else {
    const tv = new Date(year + 1, 0, 1);
    if (date >= tv) {
      year = year + 1;
      d1w1 = tv;
    }
  }
  const diffTime = Math.abs(date.getTime() - d1w1.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.floor(diffDays / 7) + 1;
}

// Utilities
const breakpoints = ['sm', 'md', 'lg', 'xl', 'xxl']; // no xs

const DisplaySymbol = Symbol.for('vuetify:display');
const defaultDisplayOptions = {
  mobileBreakpoint: 'lg',
  thresholds: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
};
const parseDisplayOptions = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultDisplayOptions;
  return mergeDeep(defaultDisplayOptions, options);
};
function getClientWidth(ssr) {
  return IN_BROWSER && !ssr ? window.innerWidth : typeof ssr === 'object' && ssr.clientWidth || 0;
}
function getClientHeight(ssr) {
  return IN_BROWSER && !ssr ? window.innerHeight : typeof ssr === 'object' && ssr.clientHeight || 0;
}
function getPlatform(ssr) {
  const userAgent = IN_BROWSER && !ssr ? window.navigator.userAgent : 'ssr';
  function match(regexp) {
    return Boolean(userAgent.match(regexp));
  }
  const android = match(/android/i);
  const ios = match(/iphone|ipad|ipod/i);
  const cordova = match(/cordova/i);
  const electron = match(/electron/i);
  const chrome = match(/chrome/i);
  const edge = match(/edge/i);
  const firefox = match(/firefox/i);
  const opera = match(/opera/i);
  const win = match(/win/i);
  const mac = match(/mac/i);
  const linux = match(/linux/i);
  return {
    android,
    ios,
    cordova,
    electron,
    chrome,
    edge,
    firefox,
    opera,
    win,
    mac,
    linux,
    touch: SUPPORTS_TOUCH,
    ssr: userAgent === 'ssr'
  };
}
function createDisplay(options, ssr) {
  const {
    thresholds,
    mobileBreakpoint
  } = parseDisplayOptions(options);
  const height = shallowRef(getClientHeight(ssr));
  const platform = shallowRef(getPlatform(ssr));
  const state = reactive({});
  const width = shallowRef(getClientWidth(ssr));
  function updateSize() {
    height.value = getClientHeight();
    width.value = getClientWidth();
  }
  function update() {
    updateSize();
    platform.value = getPlatform();
  }

  // eslint-disable-next-line max-statements
  watchEffect(() => {
    const xs = width.value < thresholds.sm;
    const sm = width.value < thresholds.md && !xs;
    const md = width.value < thresholds.lg && !(sm || xs);
    const lg = width.value < thresholds.xl && !(md || sm || xs);
    const xl = width.value < thresholds.xxl && !(lg || md || sm || xs);
    const xxl = width.value >= thresholds.xxl;
    const name = xs ? 'xs' : sm ? 'sm' : md ? 'md' : lg ? 'lg' : xl ? 'xl' : 'xxl';
    const breakpointValue = typeof mobileBreakpoint === 'number' ? mobileBreakpoint : thresholds[mobileBreakpoint];
    const mobile = width.value < breakpointValue;
    state.xs = xs;
    state.sm = sm;
    state.md = md;
    state.lg = lg;
    state.xl = xl;
    state.xxl = xxl;
    state.smAndUp = !xs;
    state.mdAndUp = !(xs || sm);
    state.lgAndUp = !(xs || sm || md);
    state.xlAndUp = !(xs || sm || md || lg);
    state.smAndDown = !(md || lg || xl || xxl);
    state.mdAndDown = !(lg || xl || xxl);
    state.lgAndDown = !(xl || xxl);
    state.xlAndDown = !xxl;
    state.name = name;
    state.height = height.value;
    state.width = width.value;
    state.mobile = mobile;
    state.mobileBreakpoint = mobileBreakpoint;
    state.platform = platform.value;
    state.thresholds = thresholds;
  });
  if (IN_BROWSER) {
    window.addEventListener('resize', updateSize, {
      passive: true
    });
  }
  return {
    ...toRefs(state),
    update,
    ssr: !!ssr
  };
}
const makeDisplayProps = propsFactory({
  mobile: {
    type: Boolean,
    default: false
  },
  mobileBreakpoint: [Number, String]
}, 'display');
function useDisplay() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const display = inject$2(DisplaySymbol);
  if (!display) throw new Error('Could not find Vuetify display injection');
  const mobile = computed(() => {
    if (props.mobile != null) return props.mobile;
    if (!props.mobileBreakpoint) return display.mobile.value;
    const breakpointValue = typeof props.mobileBreakpoint === 'number' ? props.mobileBreakpoint : display.thresholds.value[props.mobileBreakpoint];
    return display.width.value < breakpointValue;
  });
  const displayClasses = computed(() => {
    if (!name) return {};
    return {
      [`${name}--mobile`]: mobile.value
    };
  });
  return {
    ...display,
    displayClasses,
    mobile
  };
}

// Utilities
const GoToSymbol = Symbol.for('vuetify:goto');
function genDefaults$2() {
  return {
    container: undefined,
    duration: 300,
    layout: false,
    offset: 0,
    easing: 'easeInOutCubic',
    patterns: {
      linear: t => t,
      easeInQuad: t => t ** 2,
      easeOutQuad: t => t * (2 - t),
      easeInOutQuad: t => t < 0.5 ? 2 * t ** 2 : -1 + (4 - 2 * t) * t,
      easeInCubic: t => t ** 3,
      easeOutCubic: t => --t ** 3 + 1,
      easeInOutCubic: t => t < 0.5 ? 4 * t ** 3 : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
      easeInQuart: t => t ** 4,
      easeOutQuart: t => 1 - --t ** 4,
      easeInOutQuart: t => t < 0.5 ? 8 * t ** 4 : 1 - 8 * --t ** 4,
      easeInQuint: t => t ** 5,
      easeOutQuint: t => 1 + --t ** 5,
      easeInOutQuint: t => t < 0.5 ? 16 * t ** 5 : 1 + 16 * --t ** 5
    }
  };
}
function getContainer(el) {
  return getTarget$1(el) ?? (document.scrollingElement || document.body);
}
function getTarget$1(el) {
  return typeof el === 'string' ? document.querySelector(el) : refElement(el);
}
function getOffset$1(target, horizontal, rtl) {
  if (typeof target === 'number') return horizontal && rtl ? -target : target;
  let el = getTarget$1(target);
  let totalOffset = 0;
  while (el) {
    totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
    el = el.offsetParent;
  }
  return totalOffset;
}
function createGoTo(options, locale) {
  return {
    rtl: locale.isRtl,
    options: mergeDeep(genDefaults$2(), options)
  };
}
async function scrollTo(_target, _options, horizontal, goTo) {
  const property = horizontal ? 'scrollLeft' : 'scrollTop';
  const options = mergeDeep(goTo?.options ?? genDefaults$2(), _options);
  const rtl = goTo?.rtl.value;
  const target = (typeof _target === 'number' ? _target : getTarget$1(_target)) ?? 0;
  const container = options.container === 'parent' && target instanceof HTMLElement ? target.parentElement : getContainer(options.container);
  const ease = typeof options.easing === 'function' ? options.easing : options.patterns[options.easing];
  if (!ease) throw new TypeError(`Easing function "${options.easing}" not found.`);
  let targetLocation;
  if (typeof target === 'number') {
    targetLocation = getOffset$1(target, horizontal, rtl);
  } else {
    targetLocation = getOffset$1(target, horizontal, rtl) - getOffset$1(container, horizontal, rtl);
    if (options.layout) {
      const styles = window.getComputedStyle(target);
      const layoutOffset = styles.getPropertyValue('--v-layout-top');
      if (layoutOffset) targetLocation -= parseInt(layoutOffset, 10);
    }
  }
  targetLocation += options.offset;
  targetLocation = clampTarget(container, targetLocation, !!rtl, !!horizontal);
  const startLocation = container[property] ?? 0;
  if (targetLocation === startLocation) return Promise.resolve(targetLocation);
  const startTime = performance.now();
  return new Promise(resolve => requestAnimationFrame(function step(currentTime) {
    const timeElapsed = currentTime - startTime;
    const progress = timeElapsed / options.duration;
    const location = Math.floor(startLocation + (targetLocation - startLocation) * ease(clamp(progress, 0, 1)));
    container[property] = location;

    // Allow for some jitter if target time has elapsed
    if (progress >= 1 && Math.abs(location - container[property]) < 10) {
      return resolve(targetLocation);
    } else if (progress > 2) {
      // The target might not be reachable
      consoleWarn('Scroll target is not reachable');
      return resolve(container[property]);
    }
    requestAnimationFrame(step);
  }));
}
function useGoTo() {
  let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const goToInstance = inject$2(GoToSymbol);
  const {
    isRtl
  } = useRtl();
  if (!goToInstance) throw new Error('[Vuetify] Could not find injected goto instance');
  const goTo = {
    ...goToInstance,
    // can be set via VLocaleProvider
    rtl: computed(() => goToInstance.rtl.value || isRtl.value)
  };
  async function go(target, options) {
    return scrollTo(target, mergeDeep(_options, options), false, goTo);
  }
  go.horizontal = async (target, options) => {
    return scrollTo(target, mergeDeep(_options, options), true, goTo);
  };
  return go;
}

/**
 * Clamp target value to achieve a smooth scroll animation
 * when the value goes outside the scroll container size
 */
function clampTarget(container, value, rtl, horizontal) {
  const {
    scrollWidth,
    scrollHeight
  } = container;
  const [containerWidth, containerHeight] = container === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [container.offsetWidth, container.offsetHeight];
  let min;
  let max;
  if (horizontal) {
    if (rtl) {
      min = -(scrollWidth - containerWidth);
      max = 0;
    } else {
      min = 0;
      max = scrollWidth - containerWidth;
    }
  } else {
    min = 0;
    max = scrollHeight + -containerHeight;
  }
  return Math.max(Math.min(value, max), min);
}

// Composables

// Types

const aliases$1 = {
  collapse: 'mdi-chevron-up',
  complete: 'mdi-check',
  cancel: 'mdi-close-circle',
  close: 'mdi-close',
  delete: 'mdi-close-circle',
  // delete (e.g. v-chip close)
  clear: 'mdi-close-circle',
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-alert-circle',
  error: 'mdi-close-circle',
  prev: 'mdi-chevron-left',
  next: 'mdi-chevron-right',
  checkboxOn: 'mdi-checkbox-marked',
  checkboxOff: 'mdi-checkbox-blank-outline',
  checkboxIndeterminate: 'mdi-minus-box',
  delimiter: 'mdi-circle',
  // for carousel
  sortAsc: 'mdi-arrow-up',
  sortDesc: 'mdi-arrow-down',
  expand: 'mdi-chevron-down',
  menu: 'mdi-menu',
  subgroup: 'mdi-menu-down',
  dropdown: 'mdi-menu-down',
  radioOn: 'mdi-radiobox-marked',
  radioOff: 'mdi-radiobox-blank',
  edit: 'mdi-pencil',
  ratingEmpty: 'mdi-star-outline',
  ratingFull: 'mdi-star',
  ratingHalf: 'mdi-star-half-full',
  loading: 'mdi-cached',
  first: 'mdi-page-first',
  last: 'mdi-page-last',
  unfold: 'mdi-unfold-more-horizontal',
  file: 'mdi-paperclip',
  plus: 'mdi-plus',
  minus: 'mdi-minus',
  calendar: 'mdi-calendar',
  treeviewCollapse: 'mdi-menu-down',
  treeviewExpand: 'mdi-menu-right',
  eyeDropper: 'mdi-eyedropper',
  upload: 'mdi-cloud-upload'
};
const mdi$1 = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: props => h(VClassIcon, {
    ...props,
    class: 'mdi'
  })
};

const IconValue = [String, Function, Object, Array];
const IconSymbol = Symbol.for('vuetify:icons');
const makeIconProps = propsFactory({
  icon: {
    type: IconValue
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: true
  }
}, 'icon');
const VComponentIcon = genericComponent()({
  name: 'VComponentIcon',
  props: makeIconProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    return () => {
      const Icon = props.icon;
      return createVNode(props.tag, null, {
        default: () => [props.icon ? createVNode(Icon, null, null) : slots.default?.()]
      });
    };
  }
});
const VSvgIcon = defineComponent({
  name: 'VSvgIcon',
  inheritAttrs: false,
  props: makeIconProps(),
  setup(props, _ref2) {
    let {
      attrs
    } = _ref2;
    return () => {
      return createVNode(props.tag, mergeProps(attrs, {
        "style": null
      }), {
        default: () => [createVNode("svg", {
          "class": "v-icon__svg",
          "xmlns": "http://www.w3.org/2000/svg",
          "viewBox": "0 0 24 24",
          "role": "img",
          "aria-hidden": "true"
        }, [Array.isArray(props.icon) ? props.icon.map(path => Array.isArray(path) ? createVNode("path", {
          "d": path[0],
          "fill-opacity": path[1]
        }, null) : createVNode("path", {
          "d": path
        }, null)) : createVNode("path", {
          "d": props.icon
        }, null)])]
      });
    };
  }
});
defineComponent({
  name: 'VLigatureIcon',
  props: makeIconProps(),
  setup(props) {
    return () => {
      return createVNode(props.tag, null, {
        default: () => [props.icon]
      });
    };
  }
});
const VClassIcon = defineComponent({
  name: 'VClassIcon',
  props: makeIconProps(),
  setup(props) {
    return () => {
      return createVNode(props.tag, {
        "class": props.icon
      }, null);
    };
  }
});
function genDefaults$1() {
  return {
    svg: {
      component: VSvgIcon
    },
    class: {
      component: VClassIcon
    }
  };
}

// Composables
function createIcons(options) {
  const sets = genDefaults$1();
  const defaultSet = options?.defaultSet ?? 'mdi';
  if (defaultSet === 'mdi' && !sets.mdi) {
    sets.mdi = mdi$1;
  }
  return mergeDeep({
    defaultSet,
    sets,
    aliases: {
      ...aliases$1,
      /* eslint-disable max-len */
      vuetify: ['M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z', ['M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z', 0.6]],
      'vuetify-outline': 'svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z',
      'vuetify-play': ['m6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z', ['M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z', 0.6]]
      /* eslint-enable max-len */
    }
  }, options);
}
const useIcon$1 = props => {
  const icons = inject$2(IconSymbol);
  if (!icons) throw new Error('Missing Vuetify Icons provide!');
  const iconData = computed(() => {
    const iconAlias = unref(props);
    if (!iconAlias) return {
      component: VComponentIcon
    };
    let icon = iconAlias;
    if (typeof icon === 'string') {
      icon = icon.trim();
      if (icon.startsWith('$')) {
        icon = icons.aliases?.[icon.slice(1)];
      }
    }
    if (!icon) consoleWarn(`Could not find aliased icon "${iconAlias}"`);
    if (Array.isArray(icon)) {
      return {
        component: VSvgIcon,
        icon
      };
    } else if (typeof icon !== 'string') {
      return {
        component: VComponentIcon,
        icon
      };
    }
    const iconSetName = Object.keys(icons.sets).find(setName => typeof icon === 'string' && icon.startsWith(`${setName}:`));
    const iconName = iconSetName ? icon.slice(iconSetName.length + 1) : icon;
    const iconSet = icons.sets[iconSetName ?? icons.defaultSet];
    return {
      component: iconSet.component,
      icon: iconName
    };
  });
  return {
    iconData
  };
};

// Utilities
const ThemeSymbol = Symbol.for('vuetify:theme');
const makeThemeProps = propsFactory({
  theme: String
}, 'theme');
function genDefaults() {
  return {
    defaultTheme: 'light',
    variations: {
      colors: [],
      lighten: 0,
      darken: 0
    },
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#FFFFFF',
          surface: '#FFFFFF',
          'surface-bright': '#FFFFFF',
          'surface-light': '#EEEEEE',
          'surface-variant': '#424242',
          'on-surface-variant': '#EEEEEE',
          primary: '#1867C0',
          'primary-darken-1': '#1F5592',
          secondary: '#48A9A6',
          'secondary-darken-1': '#018786',
          error: '#B00020',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00'
        },
        variables: {
          'border-color': '#000000',
          'border-opacity': 0.12,
          'high-emphasis-opacity': 0.87,
          'medium-emphasis-opacity': 0.60,
          'disabled-opacity': 0.38,
          'idle-opacity': 0.04,
          'hover-opacity': 0.04,
          'focus-opacity': 0.12,
          'selected-opacity': 0.08,
          'activated-opacity': 0.12,
          'pressed-opacity': 0.12,
          'dragged-opacity': 0.08,
          'theme-kbd': '#212529',
          'theme-on-kbd': '#FFFFFF',
          'theme-code': '#F5F5F5',
          'theme-on-code': '#000000'
        }
      },
      dark: {
        dark: true,
        colors: {
          background: '#121212',
          surface: '#212121',
          'surface-bright': '#ccbfd6',
          'surface-light': '#424242',
          'surface-variant': '#a3a3a3',
          'on-surface-variant': '#424242',
          primary: '#2196F3',
          'primary-darken-1': '#277CC1',
          secondary: '#54B6B2',
          'secondary-darken-1': '#48A9A6',
          error: '#CF6679',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00'
        },
        variables: {
          'border-color': '#FFFFFF',
          'border-opacity': 0.12,
          'high-emphasis-opacity': 1,
          'medium-emphasis-opacity': 0.70,
          'disabled-opacity': 0.50,
          'idle-opacity': 0.10,
          'hover-opacity': 0.04,
          'focus-opacity': 0.12,
          'selected-opacity': 0.08,
          'activated-opacity': 0.12,
          'pressed-opacity': 0.16,
          'dragged-opacity': 0.08,
          'theme-kbd': '#212529',
          'theme-on-kbd': '#FFFFFF',
          'theme-code': '#343434',
          'theme-on-code': '#CCCCCC'
        }
      }
    }
  };
}
function parseThemeOptions() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : genDefaults();
  const defaults = genDefaults();
  if (!options) return {
    ...defaults,
    isDisabled: true
  };
  const themes = {};
  for (const [key, theme] of Object.entries(options.themes ?? {})) {
    const defaultTheme = theme.dark || key === 'dark' ? defaults.themes?.dark : defaults.themes?.light;
    themes[key] = mergeDeep(defaultTheme, theme);
  }
  return mergeDeep(defaults, {
    ...options,
    themes
  });
}

// Composables
function createTheme(options) {
  const parsedOptions = parseThemeOptions(options);
  const name = ref(parsedOptions.defaultTheme);
  const themes = ref(parsedOptions.themes);
  const computedThemes = computed(() => {
    const acc = {};
    for (const [name, original] of Object.entries(themes.value)) {
      const theme = acc[name] = {
        ...original,
        colors: {
          ...original.colors
        }
      };
      if (parsedOptions.variations) {
        for (const name of parsedOptions.variations.colors) {
          const color = theme.colors[name];
          if (!color) continue;
          for (const variation of ['lighten', 'darken']) {
            const fn = variation === 'lighten' ? lighten : darken;
            for (const amount of createRange(parsedOptions.variations[variation], 1)) {
              theme.colors[`${name}-${variation}-${amount}`] = RGBtoHex(fn(parseColor(color), amount));
            }
          }
        }
      }
      for (const color of Object.keys(theme.colors)) {
        if (/^on-[a-z]/.test(color) || theme.colors[`on-${color}`]) continue;
        const onColor = `on-${color}`;
        const colorVal = parseColor(theme.colors[color]);
        theme.colors[onColor] = getForeground(colorVal);
      }
    }
    return acc;
  });
  const current = computed(() => computedThemes.value[name.value]);
  const styles = computed(() => {
    const lines = [];
    if (current.value?.dark) {
      createCssClass(lines, ':root', ['color-scheme: dark']);
    }
    createCssClass(lines, ':root', genCssVariables(current.value));
    for (const [themeName, theme] of Object.entries(computedThemes.value)) {
      createCssClass(lines, `.v-theme--${themeName}`, [`color-scheme: ${theme.dark ? 'dark' : 'normal'}`, ...genCssVariables(theme)]);
    }
    const bgLines = [];
    const fgLines = [];
    const colors = new Set(Object.values(computedThemes.value).flatMap(theme => Object.keys(theme.colors)));
    for (const key of colors) {
      if (/^on-[a-z]/.test(key)) {
        createCssClass(fgLines, `.${key}`, [`color: rgb(var(--v-theme-${key})) !important`]);
      } else {
        createCssClass(bgLines, `.bg-${key}`, [`--v-theme-overlay-multiplier: var(--v-theme-${key}-overlay-multiplier)`, `background-color: rgb(var(--v-theme-${key})) !important`, `color: rgb(var(--v-theme-on-${key})) !important`]);
        createCssClass(fgLines, `.text-${key}`, [`color: rgb(var(--v-theme-${key})) !important`]);
        createCssClass(fgLines, `.border-${key}`, [`--v-border-color: var(--v-theme-${key})`]);
      }
    }
    lines.push(...bgLines, ...fgLines);
    return lines.map((str, i) => i === 0 ? str : `    ${str}`).join('');
  });
  function getHead() {
    return {
      style: [{
        children: styles.value,
        id: 'vuetify-theme-stylesheet',
        nonce: parsedOptions.cspNonce || false
      }]
    };
  }
  function install(app) {
    if (parsedOptions.isDisabled) return;
    const head = app._context.provides.usehead;
    if (head) {
      if (head.push) {
        const entry = head.push(getHead);
        if (IN_BROWSER) {
          watch(styles, () => {
            entry.patch(getHead);
          });
        }
      } else {
        if (IN_BROWSER) {
          head.addHeadObjs(computed(getHead));
          watchEffect(() => head.updateDOM());
        } else {
          head.addHeadObjs(getHead());
        }
      }
    } else {
      let styleEl = IN_BROWSER ? document.getElementById('vuetify-theme-stylesheet') : null;
      if (IN_BROWSER) {
        watch(styles, updateStyles, {
          immediate: true
        });
      } else {
        updateStyles();
      }
      function updateStyles() {
        if (typeof document !== 'undefined' && !styleEl) {
          const el = document.createElement('style');
          el.type = 'text/css';
          el.id = 'vuetify-theme-stylesheet';
          if (parsedOptions.cspNonce) el.setAttribute('nonce', parsedOptions.cspNonce);
          styleEl = el;
          document.head.appendChild(styleEl);
        }
        if (styleEl) styleEl.innerHTML = styles.value;
      }
    }
  }
  const themeClasses = computed(() => parsedOptions.isDisabled ? undefined : `v-theme--${name.value}`);
  return {
    install,
    isDisabled: parsedOptions.isDisabled,
    name,
    themes,
    current,
    computedThemes,
    themeClasses,
    styles,
    global: {
      name,
      current
    }
  };
}
function provideTheme(props) {
  getCurrentInstance('provideTheme');
  const theme = inject$2(ThemeSymbol, null);
  if (!theme) throw new Error('Could not find Vuetify theme injection');
  const name = computed(() => {
    return props.theme ?? theme.name.value;
  });
  const current = computed(() => theme.themes.value[name.value]);
  const themeClasses = computed(() => theme.isDisabled ? undefined : `v-theme--${name.value}`);
  const newTheme = {
    ...theme,
    name,
    current,
    themeClasses
  };
  provide(ThemeSymbol, newTheme);
  return newTheme;
}
function useTheme() {
  getCurrentInstance('useTheme');
  const theme = inject$2(ThemeSymbol, null);
  if (!theme) throw new Error('Could not find Vuetify theme injection');
  return theme;
}
function createCssClass(lines, selector, content) {
  lines.push(`${selector} {\n`, ...content.map(line => `  ${line};\n`), '}\n');
}
function genCssVariables(theme) {
  const lightOverlay = theme.dark ? 2 : 1;
  const darkOverlay = theme.dark ? 1 : 2;
  const variables = [];
  for (const [key, value] of Object.entries(theme.colors)) {
    const rgb = parseColor(value);
    variables.push(`--v-theme-${key}: ${rgb.r},${rgb.g},${rgb.b}`);
    if (!key.startsWith('on-')) {
      variables.push(`--v-theme-${key}-overlay-multiplier: ${getLuma(value) > 0.18 ? lightOverlay : darkOverlay}`);
    }
  }
  for (const [key, value] of Object.entries(theme.variables)) {
    const color = typeof value === 'string' && value.startsWith('#') ? parseColor(value) : undefined;
    const rgb = color ? `${color.r}, ${color.g}, ${color.b}` : undefined;
    variables.push(`--v-${key}: ${rgb ?? value}`);
  }
  return variables;
}

// Utilities
function useResizeObserver(callback) {
  let box = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'content';
  const resizeRef = templateRef();
  const contentRect = ref();
  if (IN_BROWSER) {
    const observer = new ResizeObserver(entries => {
      callback?.(entries, observer);
      if (!entries.length) return;
      if (box === 'content') {
        contentRect.value = entries[0].contentRect;
      } else {
        contentRect.value = entries[0].target.getBoundingClientRect();
      }
    });
    onBeforeUnmount(() => {
      observer.disconnect();
    });
    watch(() => resizeRef.el, (newValue, oldValue) => {
      if (oldValue) {
        observer.unobserve(oldValue);
        contentRect.value = undefined;
      }
      if (newValue) observer.observe(newValue);
    }, {
      flush: 'post'
    });
  }
  return {
    resizeRef,
    contentRect: readonly(contentRect)
  };
}

// Composables
const VuetifyLayoutKey = Symbol.for('vuetify:layout');
const VuetifyLayoutItemKey = Symbol.for('vuetify:layout-item');
const ROOT_ZINDEX = 1000;
const makeLayoutProps = propsFactory({
  overlaps: {
    type: Array,
    default: () => []
  },
  fullHeight: Boolean
}, 'layout');

// Composables
const makeLayoutItemProps = propsFactory({
  name: {
    type: String
  },
  order: {
    type: [Number, String],
    default: 0
  },
  absolute: Boolean
}, 'layout-item');
function useLayout() {
  const layout = inject$2(VuetifyLayoutKey);
  if (!layout) throw new Error('[Vuetify] Could not find injected layout');
  return {
    getLayoutItem: layout.getLayoutItem,
    mainRect: layout.mainRect,
    mainStyles: layout.mainStyles
  };
}
function useLayoutItem(options) {
  const layout = inject$2(VuetifyLayoutKey);
  if (!layout) throw new Error('[Vuetify] Could not find injected layout');
  const id = options.id ?? `layout-item-${getUid()}`;
  const vm = getCurrentInstance('useLayoutItem');
  provide(VuetifyLayoutItemKey, {
    id
  });
  const isKeptAlive = shallowRef(false);
  onDeactivated(() => isKeptAlive.value = true);
  onActivated(() => isKeptAlive.value = false);
  const {
    layoutItemStyles,
    layoutItemScrimStyles
  } = layout.register(vm, {
    ...options,
    active: computed(() => isKeptAlive.value ? false : options.active.value),
    id
  });
  onBeforeUnmount(() => layout.unregister(id));
  return {
    layoutItemStyles,
    layoutRect: layout.layoutRect,
    layoutItemScrimStyles
  };
}
const generateLayers = (layout, positions, layoutSizes, activeItems) => {
  let previousLayer = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };
  const layers = [{
    id: '',
    layer: {
      ...previousLayer
    }
  }];
  for (const id of layout) {
    const position = positions.get(id);
    const amount = layoutSizes.get(id);
    const active = activeItems.get(id);
    if (!position || !amount || !active) continue;
    const layer = {
      ...previousLayer,
      [position.value]: parseInt(previousLayer[position.value], 10) + (active.value ? parseInt(amount.value, 10) : 0)
    };
    layers.push({
      id,
      layer
    });
    previousLayer = layer;
  }
  return layers;
};
function createLayout(props) {
  const parentLayout = inject$2(VuetifyLayoutKey, null);
  const rootZIndex = computed(() => parentLayout ? parentLayout.rootZIndex.value - 100 : ROOT_ZINDEX);
  const registered = ref([]);
  const positions = reactive(new Map());
  const layoutSizes = reactive(new Map());
  const priorities = reactive(new Map());
  const activeItems = reactive(new Map());
  const disabledTransitions = reactive(new Map());
  const {
    resizeRef,
    contentRect: layoutRect
  } = useResizeObserver();
  const computedOverlaps = computed(() => {
    const map = new Map();
    const overlaps = props.overlaps ?? [];
    for (const overlap of overlaps.filter(item => item.includes(':'))) {
      const [top, bottom] = overlap.split(':');
      if (!registered.value.includes(top) || !registered.value.includes(bottom)) continue;
      const topPosition = positions.get(top);
      const bottomPosition = positions.get(bottom);
      const topAmount = layoutSizes.get(top);
      const bottomAmount = layoutSizes.get(bottom);
      if (!topPosition || !bottomPosition || !topAmount || !bottomAmount) continue;
      map.set(bottom, {
        position: topPosition.value,
        amount: parseInt(topAmount.value, 10)
      });
      map.set(top, {
        position: bottomPosition.value,
        amount: -parseInt(bottomAmount.value, 10)
      });
    }
    return map;
  });
  const layers = computed(() => {
    const uniquePriorities = [...new Set([...priorities.values()].map(p => p.value))].sort((a, b) => a - b);
    const layout = [];
    for (const p of uniquePriorities) {
      const items = registered.value.filter(id => priorities.get(id)?.value === p);
      layout.push(...items);
    }
    return generateLayers(layout, positions, layoutSizes, activeItems);
  });
  const transitionsEnabled = computed(() => {
    return !Array.from(disabledTransitions.values()).some(ref => ref.value);
  });
  const mainRect = computed(() => {
    return layers.value[layers.value.length - 1].layer;
  });
  const mainStyles = computed(() => {
    return {
      '--v-layout-left': convertToUnit(mainRect.value.left),
      '--v-layout-right': convertToUnit(mainRect.value.right),
      '--v-layout-top': convertToUnit(mainRect.value.top),
      '--v-layout-bottom': convertToUnit(mainRect.value.bottom),
      ...(transitionsEnabled.value ? undefined : {
        transition: 'none'
      })
    };
  });
  const items = computed(() => {
    return layers.value.slice(1).map((_ref, index) => {
      let {
        id
      } = _ref;
      const {
        layer
      } = layers.value[index];
      const size = layoutSizes.get(id);
      const position = positions.get(id);
      return {
        id,
        ...layer,
        size: Number(size.value),
        position: position.value
      };
    });
  });
  const getLayoutItem = id => {
    return items.value.find(item => item.id === id);
  };
  const rootVm = getCurrentInstance('createLayout');
  const isMounted = shallowRef(false);
  onMounted(() => {
    isMounted.value = true;
  });
  provide(VuetifyLayoutKey, {
    register: (vm, _ref2) => {
      let {
        id,
        order,
        position,
        layoutSize,
        elementSize,
        active,
        disableTransitions,
        absolute
      } = _ref2;
      priorities.set(id, order);
      positions.set(id, position);
      layoutSizes.set(id, layoutSize);
      activeItems.set(id, active);
      disableTransitions && disabledTransitions.set(id, disableTransitions);
      const instances = findChildrenWithProvide(VuetifyLayoutItemKey, rootVm?.vnode);
      const instanceIndex = instances.indexOf(vm);
      if (instanceIndex > -1) registered.value.splice(instanceIndex, 0, id);else registered.value.push(id);
      const index = computed(() => items.value.findIndex(i => i.id === id));
      const zIndex = computed(() => rootZIndex.value + layers.value.length * 2 - index.value * 2);
      const layoutItemStyles = computed(() => {
        const isHorizontal = position.value === 'left' || position.value === 'right';
        const isOppositeHorizontal = position.value === 'right';
        const isOppositeVertical = position.value === 'bottom';
        const size = elementSize.value ?? layoutSize.value;
        const unit = size === 0 ? '%' : 'px';
        const styles = {
          [position.value]: 0,
          zIndex: zIndex.value,
          transform: `translate${isHorizontal ? 'X' : 'Y'}(${(active.value ? 0 : -(size === 0 ? 100 : size)) * (isOppositeHorizontal || isOppositeVertical ? -1 : 1)}${unit})`,
          position: absolute.value || rootZIndex.value !== ROOT_ZINDEX ? 'absolute' : 'fixed',
          ...(transitionsEnabled.value ? undefined : {
            transition: 'none'
          })
        };
        if (!isMounted.value) return styles;
        const item = items.value[index.value];
        if (!item) throw new Error(`[Vuetify] Could not find layout item "${id}"`);
        const overlap = computedOverlaps.value.get(id);
        if (overlap) {
          item[overlap.position] += overlap.amount;
        }
        return {
          ...styles,
          height: isHorizontal ? `calc(100% - ${item.top}px - ${item.bottom}px)` : elementSize.value ? `${elementSize.value}px` : undefined,
          left: isOppositeHorizontal ? undefined : `${item.left}px`,
          right: isOppositeHorizontal ? `${item.right}px` : undefined,
          top: position.value !== 'bottom' ? `${item.top}px` : undefined,
          bottom: position.value !== 'top' ? `${item.bottom}px` : undefined,
          width: !isHorizontal ? `calc(100% - ${item.left}px - ${item.right}px)` : elementSize.value ? `${elementSize.value}px` : undefined
        };
      });
      const layoutItemScrimStyles = computed(() => ({
        zIndex: zIndex.value - 1
      }));
      return {
        layoutItemStyles,
        layoutItemScrimStyles,
        zIndex
      };
    },
    unregister: id => {
      priorities.delete(id);
      positions.delete(id);
      layoutSizes.delete(id);
      activeItems.delete(id);
      disabledTransitions.delete(id);
      registered.value = registered.value.filter(v => v !== id);
    },
    mainRect,
    mainStyles,
    getLayoutItem,
    items,
    layoutRect,
    rootZIndex
  });
  const layoutClasses = computed(() => ['v-layout', {
    'v-layout--full-height': props.fullHeight
  }]);
  const layoutStyles = computed(() => ({
    zIndex: parentLayout ? rootZIndex.value : undefined,
    position: parentLayout ? 'relative' : undefined,
    overflow: parentLayout ? 'hidden' : undefined
  }));
  return {
    layoutClasses,
    layoutStyles,
    getLayoutItem,
    items,
    layoutRect,
    layoutRef: resizeRef
  };
}

function createVuetify() {
  let vuetify = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    blueprint,
    ...rest
  } = vuetify;
  const options = mergeDeep(blueprint, rest);
  const {
    aliases = {},
    components = {},
    directives = {}
  } = options;
  const defaults = createDefaults(options.defaults);
  const display = createDisplay(options.display, options.ssr);
  const theme = createTheme(options.theme);
  const icons = createIcons(options.icons);
  const locale = createLocale(options.locale);
  const date = createDate(options.date, locale);
  const goTo = createGoTo(options.goTo, locale);
  const install = (app) => {
    for (const key in directives) {
      app.directive(key, directives[key]);
    }
    for (const key in components) {
      app.component(key, components[key]);
    }
    for (const key in aliases) {
      app.component(key, defineComponent({
        ...aliases[key],
        name: key,
        aliasName: aliases[key].name
      }));
    }
    theme.install(app);
    app.provide(DefaultsSymbol, defaults);
    app.provide(DisplaySymbol, display);
    app.provide(ThemeSymbol, theme);
    app.provide(IconSymbol, icons);
    app.provide(LocaleSymbol, locale);
    app.provide(DateOptionsSymbol, date.options);
    app.provide(DateAdapterSymbol, date.instance);
    app.provide(GoToSymbol, goTo);
    if (IN_BROWSER && options.ssr) {
      if (app.$nuxt) {
        app.$nuxt.hook("app:suspense:resolve", () => {
          display.update();
        });
      } else {
        const {
          mount
        } = app;
        app.mount = function() {
          const vm = mount(...arguments);
          nextTick(() => display.update());
          app.mount = mount;
          return vm;
        };
      }
    }
    getUid.reset();
    {
      app.mixin({
        computed: {
          $vuetify() {
            return reactive({
              defaults: inject.call(this, DefaultsSymbol),
              display: inject.call(this, DisplaySymbol),
              theme: inject.call(this, ThemeSymbol),
              icons: inject.call(this, IconSymbol),
              locale: inject.call(this, LocaleSymbol),
              date: inject.call(this, DateAdapterSymbol)
            });
          }
        }
      });
    }
  };
  return {
    install,
    defaults,
    display,
    theme,
    icons,
    locale,
    date,
    goTo
  };
}
const version = "3.7.6";
createVuetify.version = version;
function inject(key) {
  const vm = this.$;
  const provides = vm.parent?.provides ?? vm.vnode.appContext?.provides;
  if (provides && key in provides) {
    return provides[key];
  }
}

const PatchEvent = "entity-editor/patch";
const UpdatedEvent = "entity-editor/updated";
const GroupChangedEvent = "entity-editor/group-changed";
const OpenPaneEvent = "entity-editor-panes/open-pane";
const SetFocusEvent = "entity-editor/set-focus";

class EditorBase extends Vue {
    get title() {
        return getSchemaTitle(this.data.schema);
    }
    get description() {
        return getSchemaDescription(this.data.schema);
    }
    get model() {
        return this.data.model;
    }
    get hasErrors() {
        return this.data.errors != null && this.data.errors.length > 0;
    }
    get errorMessages() {
        if (this.data.errors == null) {
            return [];
        }
        return this.data.errors.map((e)=>e.message);
    }
    get isDeletable() {
        return Array.isArray(this.data.schema.type) && this.data.schema.type.includes("null");
    }
    get isReadOnly() {
        return this.data.schema.readOnly == true;
    }
    get inputVariant() {
        if (!this.isFrameless) {
            return "solo";
        }
        return "filled";
    }
    mounted() {
        eventBus.on(UpdatedEvent, this.onModelUpdated);
        eventBus.on(SetFocusEvent, this.onRequestFocus);
    }
    beforeDestroy() {
        eventBus.off(UpdatedEvent, this.onModelUpdated);
        eventBus.off(SetFocusEvent, this.onRequestFocus);
    }
    onModelUpdated(e) {
        if (e.metadataPath === this.data.metadataPath) {
            this.data.model = e.model;
        }
    }
    onRequestFocus(path) {
        if (this.data.path === path) {
            this.goTo(this);
        }
    }
    commitPatch(op, metadataOp) {
        let args = {
            rootId: this.data.rootId,
            sender: this.data.metadataPath,
            op: op,
            metadataOp: metadataOp
        };
        eventBus.emit(PatchEvent, args);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], EditorBase.prototype, "notificationService", void 0);
_([
    Setup((props, ctx)=>useGoTo()),
    _$1("design:type", Function)
], EditorBase.prototype, "goTo", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], EditorBase.prototype, "hideTitle", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], EditorBase.prototype, "isExpanded", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], EditorBase.prototype, "isFrameless", void 0);
_([
    Prop(),
    _$1("design:type", typeof EditorNode === "undefined" ? Object : EditorNode)
], EditorBase.prototype, "data", void 0);
EditorBase = _([
    Component
], EditorBase);

const _hoisted_1$L = { class: "editor-base editor-base--complex" };
const _hoisted_2$C = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$w = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_4$c = { class: "error--text" };
const _hoisted_5$9 = { class: "array-editor__item-action" };
const _hoisted_6$7 = { class: "text-h6 mb-1" };
const _hoisted_7$6 = { class: "array-editor__item-inline-editor" };

function render$Y(_ctx, _cache) {
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_slide_y_transition = resolveComponent("v-slide-y-transition");
  const _component_vue_draggable = resolveComponent("vue-draggable");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$L, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$C, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$w, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_card, {
      variant: _ctx.isFrameless ? 'text' : 'elevated'
    }, {
      default: withCtx(() => [
        (_ctx.errorMessages.length > 0)
          ? (openBlock(), createBlock(_component_v_card_text, {
              key: 0,
              class: normalizeClass({ 'pa-0': _ctx.isFrameless })
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4$c, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.errorMessages, (message) => {
                    return (openBlock(), createElementBlock("span", null, toDisplayString(message), 1))
                  }), 256))
                ])
              ]),
              _: 1
            }, 8, ["class"]))
          : createCommentVNode("", true),
        (_ctx.items.length > 0)
          ? (openBlock(), createBlock(_component_vue_draggable, {
              key: 1,
              target: ".v-list",
              handle: ".array-editor__item-handle",
              onEnd: _ctx.onSortEnd,
              modelValue: _ctx.items,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.items) = $event))
            }, {
              default: withCtx(() => [
                createVNode(_component_v_list, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_slide_y_transition, { group: "" }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
                          return (openBlock(), createBlock(_component_v_list_item, {
                            "disable-keyboard-selection": "",
                            class: normalizeClass({ 'mb-2 pb-2': !_ctx.isItemPrimitive }),
                            ripple: !_ctx.isItemPrimitive,
                            inactive: _ctx.isItemPrimitive,
                            key: item.uid,
                            onClick: $event => (_ctx.openItem(item)),
                            onContextmenu: $event => (_ctx.onContextMenu(item, $event))
                          }, {
                            prepend: withCtx(() => [
                              createVNode(_component_v_icon, { class: "array-editor__item-handle" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            append: withCtx(() => [
                              createElementVNode("div", _hoisted_5$9, [
                                createVNode(_component_v_tooltip, { location: "bottom" }, {
                                  activator: withCtx(({ props }) => [
                                    createVNode(_component_v_btn, mergeProps({
                                      icon: _ctx.$icons.mdiDelete,
                                      variant: "tonal",
                                      color: "warning",
                                      class: "array-editor__remove-item",
                                      onClick: $event => (_ctx.removeItem(item)),
                                      ref_for: true
                                    }, props), null, 16, ["icon", "onClick"])
                                  ]),
                                  default: withCtx(() => [
                                    _cache[2] || (_cache[2] = createElementVNode("span", null, "Eintrag löschen", -1))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              createVNode(_component_v_menu, {
                                absolute: "",
                                target: [_ctx.contextMenuX, _ctx.contextMenuY],
                                modelValue: _ctx.openContextMenuNodeUid === item.uid
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_v_list, null, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_list_item, {
                                        onClick: $event => (_ctx.removeItem(item))
                                      }, {
                                        default: withCtx(() => _cache[3] || (_cache[3] = [
                                          createTextVNode("Löschen")
                                        ])),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      createVNode(_component_v_list_item, {
                                        onClick: $event => (_ctx.duplicateItem(item))
                                      }, {
                                        default: withCtx(() => _cache[4] || (_cache[4] = [
                                          createTextVNode("Duplizieren")
                                        ])),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["target", "modelValue"])
                            ]),
                            default: withCtx(() => [
                              (_ctx.hasMultipleItemSchemas)
                                ? (openBlock(), createBlock(_component_v_list_item_title, { key: 0 }, {
                                    default: withCtx(() => [
                                      createElementVNode("div", _hoisted_6$7, toDisplayString(item.schema.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : createCommentVNode("", true),
                              createElementVNode("div", _hoisted_7$6, [
                                (openBlock(), createBlock(resolveDynamicComponent(item.componentName), {
                                  ref_for: true,
                                  ref: "itemComponents",
                                  data: item,
                                  "hide-title": "",
                                  "is-frameless": ""
                                }, null, 8, ["data"]))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "ripple", "inactive", "onClick", "onContextmenu"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onEnd", "modelValue"]))
          : (openBlock(), createBlock(_component_v_empty_state, {
              key: 2,
              class: "v-empty-state--horizontal",
              size: 64,
              icon: _ctx.$icons.mdiPlaylistEdit,
              title: "Diese Liste ist leer"
            }, null, 8, ["icon"])),
        createVNode(_component_v_card_actions, null, {
          default: withCtx(() => [
            (_ctx.hasMultipleItemSchemas)
              ? (openBlock(), createBlock(_component_v_menu, {
                  key: 0,
                  "offset-y": ""
                }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_btn, mergeProps({
                      variant: "tonal",
                      color: "success",
                      "prepend-icon": _ctx.$icons.mdiPlus
                    }, props), {
                      default: withCtx(() => _cache[5] || (_cache[5] = [
                        createTextVNode("Eintrag hinzufügen")
                      ])),
                      _: 2
                    }, 1040, ["prepend-icon"])
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_list, null, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemSchemas, (schema, index) => {
                          return (openBlock(), createBlock(_component_v_list_item, {
                            onClick: $event => (_ctx.addItem(schema)),
                            key: index
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_v_list_item_title, null, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(schema.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : createCommentVNode("", true),
            (!_ctx.hasMultipleItemSchemas)
              ? (openBlock(), createBlock(_component_v_btn, {
                  key: 1,
                  variant: "tonal",
                  color: "success",
                  "prepend-icon": _ctx.$icons.mdiPlus,
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.addItem(_ctx.firstItemSchema)))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.itemTitle ? _ctx.itemTitle : 'Eintrag') + " hinzufügen ", 1)
                  ]),
                  _: 1
                }, 8, ["prepend-icon"]))
              : createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["variant"])
  ]))
}

IconRegistry.add({
    mdiDrag,
    mdiDelete,
    mdiPlus,
    mdiContentDuplicate,
    mdiPlaylistEdit
});
class ArrayEditor extends EditorBase {
    getModel(index) {
        return this.model[index];
    }
    get itemSchemas() {
        let items = this.data.schema.items;
        if (isSchema(items)) {
            // resolve any remaining (circular) references
            if (items.$ref) {
                let resolvedSchema = this.data.resolveSchemaRef(items.$ref);
                if (resolvedSchema == null) {
                    throw new Error(`Unable to resolve circular schema reference '${items.$ref}'.`);
                }
                items = resolvedSchema;
            }
            if (items.anyOf && isSchemaArray(items.anyOf)) {
                return items.anyOf.filter((s)=>s.type !== "null");
            }
            if (items.oneOf && isSchemaArray(items.oneOf)) {
                return items.oneOf.filter((s)=>s.type !== "null");
            }
            return [
                items
            ];
        }
        throw new Error("ArrayEditor only works on arrays (schema has to have an `items` property).");
    }
    get hasMultipleItemSchemas() {
        return this.itemSchemas.length > 1;
    }
    get firstItemSchema() {
        return this.itemSchemas[0];
    }
    get itemTitle() {
        if (!this.firstItemSchema) {
            return "";
        }
        return this.firstItemSchema.title || "";
    }
    get isItemPrimitive() {
        return EditorFactory.getEditorType(this.firstItemSchema) === EditorType.Primitive;
    }
    created() {
        this.onMetadataChanged();
    }
    onMetadataChanged() {
        this.items = this.data.items || [];
    }
    openItem(node) {
        if (this.isItemPrimitive) {
            return;
        }
        let args = {
            node: node,
            props: {
                editMode: true
            }
        };
        eventBus.emit(OpenPaneEvent, args);
    }
    addItem(schema) {
        let item = this.editorFactory.createInstance(schema);
        let op = {
            op: "add",
            path: `${this.data.path}/-`,
            value: item
        };
        let resolvedItemPath = `${this.data.path}/${this.model.length}`;
        let resolvedMetadataPath = `${this.data.metadataPath}/items/${this.model.length}`;
        let metadataOp = {
            op: "add",
            path: `${this.data.metadataPath}/items/-`,
            value: this.editorFactory.create({
                rootId: this.data.rootId,
                schema: schema,
                model: item,
                path: resolvedItemPath,
                metadataPath: resolvedMetadataPath,
                nestingLevel: this.data.nestingLevel + 1,
                contextType: EditorType.Array,
                parent: this.data,
                getRoot: this.data.getRoot,
                getContext: this.data.getContext,
                resolveSchemaRef: this.data.resolveSchemaRef
            })
        };
        this.commitPatch(op, metadataOp);
        if (!this.isItemPrimitive) {
            // open the new object
            this.$nextTick(()=>{
                let itemComponents = this.$refs.itemComponents;
                itemComponents[this.items.length - 1].open();
            });
        }
    }
    removeItem(item) {
        let op = {
            op: "remove",
            path: item.path
        };
        let metadataOp = {
            op: "remove",
            path: item.metadataPath
        };
        this.commitPatch(op, metadataOp);
    }
    duplicateItem(item) {
        let itemPathSegments = JsonPointer.decode(item.path);
        let itemIndex = parseInt(itemPathSegments[itemPathSegments.length - 1].toString(), 10);
        let duplicateItemIndex = itemIndex + 1;
        let duplicate = deepClone(item.model);
        let duplicatePath = JsonPointer.create([
            ...itemPathSegments.slice(0, -1),
            duplicateItemIndex
        ]).pointer;
        let op = {
            op: "add",
            path: duplicatePath,
            value: duplicate
        };
        let metadataPathSegments = JsonPointer.decode(item.metadataPath);
        let metadataPath = JsonPointer.create([
            ...metadataPathSegments.slice(0, -1),
            duplicateItemIndex
        ]).pointer;
        let metadataOp = {
            op: "add",
            path: metadataPath,
            value: this.editorFactory.create({
                rootId: this.data.rootId,
                schema: item.schema,
                model: duplicate,
                path: duplicatePath,
                metadataPath: metadataPath,
                nestingLevel: this.data.nestingLevel + 1,
                contextType: EditorType.Array,
                parent: this.data,
                getRoot: this.data.getRoot,
                getContext: this.data.getContext,
                resolveSchemaRef: this.data.resolveSchemaRef
            })
        };
        this.commitPatch(op, metadataOp);
    }
    onSortEnd(e) {
        if (e.newIndex == null || e.oldIndex == null || e.newIndex === e.oldIndex) {
            return;
        }
        let op = {
            op: "move",
            from: `${this.data.path}/${e.oldIndex}`,
            path: `${this.data.path}/${e.newIndex}`
        };
        let metadataOp = {
            op: "move",
            from: `${this.data.metadataPath}/items/${e.oldIndex}`,
            path: `${this.data.metadataPath}/items/${e.newIndex}`
        };
        this.commitPatch(op, metadataOp);
    }
    onContextMenu(item, e) {
        e.preventDefault();
        this.openContextMenuNodeUid = null;
        this.contextMenuX = e.clientX;
        this.contextMenuY = e.clientY;
        this.$nextTick(()=>this.openContextMenuNodeUid = item.uid);
    }
    openContextMenu(item) {
        this.openContextMenuNodeUid = null;
        this.contextMenuX = null;
        this.contextMenuY = null;
        this.$nextTick(()=>this.openContextMenuNodeUid = item.uid);
    }
    constructor(...args){
        super(...args), this.items = [], this.openContextMenuNodeUid = null, this.contextMenuY = null, this.contextMenuX = null;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], ArrayEditor.prototype, "editorFactory", void 0);
_([
    Watch("data.items"),
    Watch(nameof("model"), {
        deep: true
    }),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], ArrayEditor.prototype, "onMetadataChanged", null);
ArrayEditor = _([
    Component({
        render: render$Y,
        components: {
            VueDraggable
        }
    })
], ArrayEditor);
EditorFactory.registerEditor({
    type: ArrayEditor,
    predicate: (schema, typeName)=>typeName === "array",
    customization: (node, factory)=>{
        node.items = factory.createArrayItems(node);
    },
    editorType: EditorType.Array,
    priority: -1
});

const _hoisted_1$K = {
  key: 0,
  class: "object-editor__header mb-4"
};
const _hoisted_2$B = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$v = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_4$b = {
  key: 0,
  class: "editor-base__title-description"
};
const _hoisted_5$8 = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_6$6 = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_7$5 = { key: 0 };
const _hoisted_8$4 = { class: "text-caption text-truncate" };
const _hoisted_9$2 = ["innerHTML"];
const _hoisted_10$2 = { class: "text-caption text-truncate" };
const _hoisted_11$2 = ["innerHTML"];
const _hoisted_12$2 = { class: "text-caption text-truncate" };
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = { class: "text-caption text-truncate" };
const _hoisted_15 = ["innerHTML"];

function render$X(_ctx, _cache) {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (_ctx.isExpanded)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["editor-base editor-base--complex object-editor object-editor--expanded", {'object-editor--frameless': _ctx.isFrameless}])
      }, [
        (!_ctx.isFrameless && (_ctx.title?.length > 0 || _ctx.description?.length > 0))
          ? (openBlock(), createElementBlock("div", _hoisted_1$K, [
              (_ctx.title)
                ? (openBlock(), createElementBlock("h2", _hoisted_2$B, toDisplayString(_ctx.title), 1))
                : createCommentVNode("", true),
              (_ctx.description)
                ? (openBlock(), createElementBlock("p", _hoisted_3$v, toDisplayString(_ctx.description), 1))
                : createCommentVNode("", true)
            ]))
          : createCommentVNode("", true),
        createVNode(_component_v_sheet, {
          rounded: "lg",
          color: "surface-light",
          class: normalizeClass(["object-editor__items", { border: !_ctx.isFrameless }])
        }, {
          default: withCtx(() => [
            (!_ctx.isNull)
              ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.children, (child, index) => {
                  return (openBlock(), createBlock(_component_v_row, {
                    align: "center",
                    "no-gutters": "",
                    class: "object-editor__item flex-nowrap"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_col, { class: "w-min-0" }, {
                        default: withCtx(() => [
                          (openBlock(), createBlock(resolveDynamicComponent(child.componentName), {
                            data: child,
                            "is-expanded": _ctx.isChildExpanded(child),
                            "hide-title": _ctx.isSingleChild
                          }, null, 8, ["data", "is-expanded", "hide-title"]))
                        ]),
                        _: 2
                      }, 1024),
                      createVNode(_component_v_col, {
                        cols: "auto",
                        class: "object-editor__item-action-col"
                      }, {
                        default: withCtx(() => [
                          (_ctx.isRemovable(child))
                            ? (openBlock(), createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: withCtx(({ props }) => [
                                  createVNode(_component_v_btn, mergeProps({
                                    icon: _ctx.$icons.mdiDelete,
                                    class: "ml-4",
                                    variant: "tonal",
                                    color: "warning",
                                    ref_for: true
                                  }, props, {
                                    onClick: $event => (_ctx.removeNode(child))
                                  }), null, 16, ["icon", "onClick"])
                                ]),
                                default: withCtx(() => [
                                  createElementVNode("span", null, toDisplayString(child.schema.title) + " löschen", 1)
                                ]),
                                _: 2
                              }, 1024))
                            : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  (_ctx.hasMultipleSchemas)
                    ? (openBlock(), createBlock(_component_v_menu, {
                        key: 0,
                        "offset-y": ""
                      }, {
                        activator: withCtx(({ props }) => [
                          createVNode(_component_v_btn, mergeProps(props, {
                            fab: "",
                            small: "",
                            color: "primary"
                          }), {
                            default: withCtx(() => [
                              createVNode(_component_v_icon, null, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(_ctx.$icons.mdiPlus), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        default: withCtx(() => [
                          createVNode(_component_v_list, null, {
                            default: withCtx(() => [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.schemas, (schema, index) => {
                                return (openBlock(), createBlock(_component_v_list_item, {
                                  key: index,
                                  onClick: $event => (_ctx.createModel(schema))
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_list_item_title, null, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(schema.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : createCommentVNode("", true),
                  (!_ctx.hasMultipleSchemas)
                    ? (openBlock(), createBlock(_component_v_fab, {
                        key: 1,
                        color: "primary",
                        class: "mr-4 flex-grow-0",
                        icon: _ctx.$icons.mdiPlus,
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.createModel(_ctx.firstSchema)))
                      }, null, 8, ["icon"]))
                    : createCommentVNode("", true)
                ], 64))
          ]),
          _: 1
        }, 8, ["class"])
      ], 2))
    : (openBlock(), createElementBlock("div", {
        key: 1,
        class: "object-editor object-editor--collapsed editor-base--complex editor-base",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.isFrameless && _ctx.open()))
      }, [
        (!_ctx.hideTitle)
          ? (openBlock(), createElementBlock("div", _hoisted_4$b, [
              (_ctx.title)
                ? (openBlock(), createElementBlock("h2", _hoisted_5$8, toDisplayString(_ctx.title), 1))
                : createCommentVNode("", true),
              (_ctx.description)
                ? (openBlock(), createElementBlock("p", _hoisted_6$6, toDisplayString(_ctx.description), 1))
                : createCommentVNode("", true)
            ]))
          : createCommentVNode("", true),
        (_ctx.displayValue != null)
          ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              (_ctx.isFrameless)
                ? (openBlock(), createElementBlock("div", _hoisted_7$5, [
                    (_ctx.displayValue.value)
                      ? (openBlock(), createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "flex-nowrap object-editor__summary-item"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, {
                              cols: "2",
                              class: "w-min-0 pr-1"
                            }, {
                              default: withCtx(() => [
                                createElementVNode("div", _hoisted_8$4, toDisplayString(_ctx.displayValue.title), 1)
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_col, { class: "w-min-0" }, {
                              default: withCtx(() => [
                                (_ctx.displayValue.value != null)
                                  ? (openBlock(), createElementBlock("div", {
                                      key: 0,
                                      class: "text-truncate text-body-2",
                                      innerHTML: _ctx.displayValue.value
                                    }, null, 8, _hoisted_9$2))
                                  : createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.displayValue.children, (childValue) => {
                          return (openBlock(), createBlock(_component_v_row, {
                            "no-gutters": "",
                            class: "flex-nowrap object-editor__summary-item"
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_v_col, {
                                cols: "2",
                                class: "w-min-0 pr-1"
                              }, {
                                default: withCtx(() => [
                                  createElementVNode("div", _hoisted_10$2, toDisplayString(childValue.title), 1)
                                ]),
                                _: 2
                              }, 1024),
                              createVNode(_component_v_col, { class: "w-min-0" }, {
                                default: withCtx(() => [
                                  createElementVNode("div", {
                                    class: "text-body-2",
                                    innerHTML: _ctx.formatNestedDisplayValue(childValue)
                                  }, null, 8, _hoisted_11$2)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 256))
                  ]))
                : (openBlock(), createBlock(_component_v_card, { key: 1 }, {
                    default: withCtx(() => [
                      createVNode(_component_v_card_text, null, {
                        default: withCtx(() => [
                          (_ctx.displayValue.value)
                            ? (openBlock(), createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "flex-nowrap object-editor__summary-item"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "w-min-0 pr-1"
                                  }, {
                                    default: withCtx(() => [
                                      createElementVNode("div", _hoisted_12$2, toDisplayString(_ctx.displayValue.title), 1)
                                    ]),
                                    _: 1
                                  }),
                                  createVNode(_component_v_col, { class: "w-min-0" }, {
                                    default: withCtx(() => [
                                      (_ctx.displayValue.value != null)
                                        ? (openBlock(), createElementBlock("div", {
                                            key: 0,
                                            class: "text-truncate text-body-2",
                                            innerHTML: _ctx.displayValue.value
                                          }, null, 8, _hoisted_13))
                                        : createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.displayValue.children, (childValue) => {
                                return (openBlock(), createBlock(_component_v_row, {
                                  "no-gutters": "",
                                  class: "flex-nowrap object-editor__summary-item"
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "w-min-0 pr-1"
                                    }, {
                                      default: withCtx(() => [
                                        createElementVNode("div", _hoisted_14, toDisplayString(childValue.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    createVNode(_component_v_col, { class: "w-min-0" }, {
                                      default: withCtx(() => [
                                        createElementVNode("div", {
                                          class: "text-body-2",
                                          innerHTML: _ctx.formatNestedDisplayValue(childValue)
                                        }, null, 8, _hoisted_15)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                        ]),
                        _: 1
                      }),
                      createVNode(_component_v_card_actions, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_btn, {
                            variant: "tonal",
                            color: "primary",
                            "prepend-icon": _ctx.$icons.mdiPencil,
                            onClick: _ctx.open
                          }, {
                            default: withCtx(() => _cache[2] || (_cache[2] = [
                              createTextVNode("Bearbeiten")
                            ])),
                            _: 1
                          }, 8, ["prepend-icon", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ], 64))
          : createCommentVNode("", true)
      ]))
}

IconRegistry.add({
    mdiDelete,
    mdiPlus,
    mdiPencil
});
class ObjectEditor extends EditorBase {
    get children() {
        if (this.model == null || this.data == null || this.data.children == null) {
            return [];
        }
        return Object.entries(this.data.children).map(([_, data])=>data);
    }
    get isSingleChild() {
        return this.children.length === 1;
    }
    get isNull() {
        return this.model == null;
    }
    get displayValue() {
        this._version;
        return this.data.getDisplayValue() || {
            title: "",
            value: ""
        };
    }
    mounted() {
        eventBus.on(PatchEvent, (e)=>{
            if (e.sender.startsWith(this.data.metadataPath)) {
                this._version++;
            }
        });
    }
    open() {
        let args = {
            node: this.data
        };
        eventBus.emit(OpenPaneEvent, args);
    }
    isRemovable(node) {
        if (this.model == null || this.data == null || this.data.children == null) {
            return false;
        }
        if (node.model == null) {
            return false;
        }
        let propSchema = this.getPropSchemaForChildNode(node);
        if (propSchema != null) {
            if (propSchema.readOnly === true) {
                return false;
            }
            let possibleValueSchemas = propSchema.anyOf || propSchema.oneOf;
            if (possibleValueSchemas && isSchemaArray(possibleValueSchemas)) {
                return true;
            }
        }
        return Array.isArray(node.schema.type) && node.schema.type.includes("null") && node.schema.readOnly !== true;
    }
    removeNode(node) {
        let replacementMetadata = this.editorFactory.createReplacementNull(node);
        let args = {
            rootId: node.rootId,
            sender: node.metadataPath,
            metadataOp: {
                op: "replace",
                path: node.metadataPath,
                value: replacementMetadata
            },
            op: {
                op: "replace",
                path: node.path,
                value: null
            }
        };
        eventBus.emit(PatchEvent, args);
    }
    isChildExpanded(child) {
        return isObjectEditorChildExpanded(child);
    }
    formatNestedDisplayValue(data, nestingLevel = 0) {
        let output = "";
        if (data.children != null) {
            if (data.children.length === 0) {
                output += "<em>Leer</em>";
            } else {
                for(var i = 0; i < data.children.length; i++){
                    let childOutput = this.formatNestedDisplayValue(data.children[i], nestingLevel + 1);
                    if (childOutput.length > 0) {
                        if (i > 0 && !output.endsWith(". ")) {
                            output += ", ";
                        }
                        output += childOutput;
                    }
                }
                if (!output.endsWith(". ")) {
                    output += ". ";
                }
            }
        } else {
            if (nestingLevel > 0 && data.title != null) {
                output += `<span class="object-editor__summary-item-title">${data.title}</span>: `;
            }
            if (data.value == null || data.value === "") {
                output += "<em>Leer</em>";
            } else if (data.isValueHtml === true) {
                output += data.value;
            } else {
                output += truncate(data.value, {
                    length: Math.floor(160 / (nestingLevel + 1))
                });
            }
        }
        return output;
    }
    getPropSchemaForChildNode(node) {
        if (this.data.children == null || this.data.schema == null || this.data.schema.properties == null) {
            return null;
        }
        let propName = Object.keys(this.data.children)[this.children.indexOf(node)];
        return this.data.schema.properties[propName] || null;
    }
    constructor(...args){
        super(...args), this._version = 0;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], ObjectEditor.prototype, "editorFactory", void 0);
ObjectEditor = _([
    Component({
        render: render$X
    })
], ObjectEditor);
EditorFactory.registerEditor({
    type: ObjectEditor,
    predicate: (schema, typeName)=>typeName === "object",
    customization: (node, factory)=>{
        node.children = factory.createObjectChildren(node);
    },
    editorType: EditorType.Object,
    priority: -1
});

const _hoisted_1$J = { class: "editor-base editor-base--complex" };
const _hoisted_2$A = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$u = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_4$a = {
  key: 2,
  class: "v-messages theme--light error--text"
};
const _hoisted_5$7 = { class: "v-messages__wrapper" };
const _hoisted_6$5 = { class: "v-messages__message" };

function render$W(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");

  return (openBlock(), createElementBlock("div", _hoisted_1$J, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$A, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$u, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true),
          (_ctx.hasErrors)
            ? (openBlock(), createElementBlock("div", _hoisted_4$a, [
                createElementVNode("div", _hoisted_5$7, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.errorMessages, (message) => {
                    return (openBlock(), createElementBlock("div", _hoisted_6$5, toDisplayString(message), 1))
                  }), 256))
                ])
              ]))
            : createCommentVNode("", true),
          _cache[1] || (_cache[1] = createElementVNode("div", { class: "error-text caption" }, null, -1))
        ], 64))
      : createCommentVNode("", true),
    (_ctx.hasMultipleSchemas)
      ? (openBlock(), createBlock(_component_v_menu, {
          key: 1,
          "offset-y": ""
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_btn, mergeProps({
              variant: "tonal",
              color: "success",
              "prepend-icon": _ctx.$icons.mdiPlus
            }, props), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.title) + " hinzufügen", 1)
              ]),
              _: 2
            }, 1040, ["prepend-icon"])
          ]),
          default: withCtx(() => [
            createVNode(_component_v_list, null, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.schemas, (schema, index) => {
                  return (openBlock(), createBlock(_component_v_list_item, {
                    key: index,
                    onClick: $event => (_ctx.createModel(schema))
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_list_item_title, null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(schema.title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (openBlock(), createBlock(_component_v_btn, {
          key: 2,
          variant: "tonal",
          color: "success",
          "prepend-icon": _ctx.$icons.mdiPlus,
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.createModel(_ctx.firstSchema)))
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.title) + " hinzufügen", 1)
          ]),
          _: 1
        }, 8, ["prepend-icon"]))
  ]))
}

IconRegistry.add({
    mdiPlus
});
class ObjectNullEditor extends EditorBase {
    get schemas() {
        let children = this.data.schema.anyOf || this.data.schema.oneOf;
        if (children && isSchemaArray(children)) {
            for (let [i, child] of children.entries()){
                if (child.$ref) {
                    children[i] = this.data.resolveSchemaRef(child.$ref);
                }
            }
            return children.filter((s)=>s.type != "null");
        }
        return [
            this.data.schema
        ];
    }
    get hasMultipleSchemas() {
        return this.schemas.length > 1;
    }
    get firstSchema() {
        return this.schemas[0];
    }
    createModel(schema) {
        let model = this.editorFactory.createInstance(schema);
        let op = {
            op: "add",
            path: this.data.path,
            value: model
        };
        // preserve documentation from member
        let title = this.data.schema.title && this.data.schema.title !== schema.title ? `${this.data.schema.title}: ${schema.title}` : schema.title;
        let newSchema = {
            ...schema,
            title
        };
        if (!isNullOrEmpty(this.data.schema.description)) {
            newSchema.description = this.data.schema.description;
        }
        let parent = this.data.getParent();
        let metadataOp = {
            op: "add",
            path: this.data.metadataPath,
            value: this.editorFactory.create({
                rootId: this.data.rootId,
                schema: newSchema,
                model: model,
                path: this.data.path,
                metadataPath: this.data.metadataPath,
                nestingLevel: this.data.nestingLevel,
                contextType: this.data.contextType,
                parent: parent,
                getRoot: this.data.getRoot,
                getContext: this.data.getContext,
                resolveSchemaRef: this.data.resolveSchemaRef
            })
        };
        this.commitPatch(op, metadataOp);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], ObjectNullEditor.prototype, "editorFactory", void 0);
ObjectNullEditor = _([
    Component({
        render: render$W
    })
], ObjectNullEditor);

const _hoisted_1$I = { class: "entity-editor__pane-content" };
const _hoisted_2$z = { class: "entity-editor__content" };
const _hoisted_3$t = { class: "entity-editor__pane-content" };
const _hoisted_4$9 = { class: "scroll-panel fill-height" };

function render$V(_ctx, _cache) {
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_slide_x_reverse_transition = resolveComponent("v-slide-x-reverse-transition");

  return (openBlock(), createBlock(_component_v_sheet, {
    class: "entity-editor__panes",
    color: "surface-light"
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: "entity-editor__pane entity-editor__pane--primary",
        style: normalizeStyle({ '--pane-height': _ctx.paneHeight + 'px' })
      }, [
        createVNode(_component_v_overlay, {
          absolute: "",
          contained: "",
          persistent: "",
          "no-click-animation": "",
          attach: true,
          class: "entity-editor__primary-pane-overlay",
          opacity: "0",
          modelValue: _ctx.panes.length > 0,
          onClick: _ctx.closePanes
        }, null, 8, ["modelValue", "onClick"]),
        createElementVNode("div", _hoisted_1$I, [
          createElementVNode("div", _hoisted_2$z, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.nodes, (node) => {
              return (openBlock(), createBlock(_component_v_row, {
                "no-gutters": "",
                class: normalizeClass(["object-editor__item flex-nowrap", { 'is-removable': _ctx.isRemovable(node) }])
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_col, { class: "w-min-0" }, {
                    default: withCtx(() => [
                      (openBlock(), createBlock(resolveDynamicComponent(node.componentName), {
                        data: node,
                        "is-expanded": true
                      }, null, 8, ["data"]))
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(_component_v_col, {
                    cols: "auto",
                    class: "object-editor__item-action-col"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_container, {
                        align: "center",
                        class: "pr-0 fill-height"
                      }, {
                        default: withCtx(() => [
                          (_ctx.isRemovable(node))
                            ? (openBlock(), createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: withCtx(({ props }) => [
                                  createVNode(_component_v_btn, mergeProps({
                                    icon: _ctx.$icons.mdiDelete,
                                    variant: "tonal",
                                    color: "warning",
                                    onClick: $event => (_ctx.removeNode(node)),
                                    ref_for: true
                                  }, props), null, 16, ["icon", "onClick"])
                                ]),
                                default: withCtx(() => [
                                  createElementVNode("span", null, toDisplayString(node.schema.title) + " löschen", 1)
                                ]),
                                _: 2
                              }, 1024))
                            : createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 256))
          ])
        ])
      ], 4),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.panes, (pane, index) => {
        return (openBlock(), createBlock(_component_v_slide_x_reverse_transition, null, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: "entity-editor__pane entity-editor__pane--additional elevation-4",
              style: normalizeStyle({ left: pane.offset + 'px', width: pane.width + 'px', '--pane-height': _ctx.paneHeight + 'px' })
            }, [
              createElementVNode("div", _hoisted_3$t, [
                createVNode(_component_v_sheet, {
                  color: "surface-light",
                  class: "fill-height d-flex flex-column"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_toolbar, { class: "entity-editor__pane-toolbar" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: withCtx(({ props }) => [
                            createVNode(_component_v_btn, mergeProps({
                              icon: _ctx.$icons.mdiArrowLeft,
                              onClick: $event => (_ctx.closePane(pane)),
                              ref_for: true
                            }, props), null, 16, ["icon", "onClick"])
                          ]),
                          default: withCtx(() => [
                            _cache[0] || (_cache[0] = createElementVNode("span", null, "Zurück", -1))
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(_component_v_toolbar_title, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(_ctx.getNodeTitle(pane.node)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    createElementVNode("div", _hoisted_4$9, [
                      createVNode(_component_v_container, { class: "entity-editor__content" }, {
                        default: withCtx(() => [
                          (openBlock(), createBlock(resolveDynamicComponent(pane.node.componentName), mergeProps({
                            data: pane.node,
                            "is-expanded": true,
                            "is-frameless": true,
                            "hide-title": true,
                            ref_for: true
                          }, pane.props), null, 16, ["data"]))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ])
            ], 4)
          ]),
          _: 2
        }, 1024))
      }), 256))
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiDelete,
    mdiArrowLeft
});
class EntityEditorPanes extends Vue {
    get paneContainer() {
        return this.$el;
    }
    mounted() {
        eventBus.on(OpenPaneEvent, this.onOpenPane);
        eventBus.on(GroupChangedEvent, this.closePanes);
        document.addEventListener("keyup", this.onGlobalKeyUp);
        this.updatePaneDimensions();
        window.addEventListener("resize", this.updatePaneDimensionsDebounced);
    }
    beforeDestroy() {
        eventBus.off(OpenPaneEvent, this.onOpenPane);
        eventBus.off(GroupChangedEvent, this.closePanes);
        document.removeEventListener("keyup", this.onGlobalKeyUp);
        window.removeEventListener("resize", this.updatePaneDimensionsDebounced);
    }
    updatePaneDimensions() {
        this.paneWidth = Math.max(Math.min(this.$el.clientWidth, 1152), 576);
        this.paneHeight = this.$el.clientHeight - 64 - 16; // subtract toolbar height and bottom padding
        for (let [index, pane] of this.panes.entries()){
            pane.offset = this.getPaneOffset(index);
        }
    }
    onGlobalKeyUp(e) {
        if (e.key === Key.Escape && this.panes.length > 0) {
            this.closePane(this.panes.at(-1));
        }
    }
    onOpenPane(e) {
        let indexDelta = 0;
        if (this.panes.length === 0) {
            indexDelta = 1;
        } else {
            let lastPaneDepth = JsonPointer.decode(this.panes[this.panes.length - 1].node.metadataPath).filter((p)=>p === "children").length;
            let newPaneDepth = JsonPointer.decode(e.node.metadataPath).filter((p)=>p === "children").length;
            if (lastPaneDepth === newPaneDepth) {
                indexDelta = 0;
            } else {
                indexDelta = lastPaneDepth < newPaneDepth ? 1 : -1;
            }
        }
        let index = this.panes.length - 1 + indexDelta;
        let pane = {
            node: e.node,
            props: e.props,
            offset: this.getPaneOffset(index)
        };
        let scrollLeft = this.paneContainer.scrollLeft;
        this.panes = this.panes.slice(0, index);
        // wait for ui update before creating new pane, we ABSOLUTELY can't re-use the editors
        this.$nextTick(()=>{
            this.panes.push(pane);
            this.$nextTick(()=>{
                // restore scroll position from before gui update because autofocus could have changed the scrollpos
                this.paneContainer.scrollLeft = scrollLeft;
                let scrollOffset = this.paneContainer.scrollWidth - this.paneContainer.clientWidth;
                scrollToWithAnimation(this.paneContainer, "scrollLeft", scrollOffset, 300, "easeInOutQuad");
            });
        });
    }
    closePane(pane) {
        let index = this.panes.indexOf(pane);
        let scrollOffset = 0;
        if (index > 0) {
            let lastOpenPane = this.panes[index - 1];
            scrollOffset = lastOpenPane.offset + this.paneWidth - this.paneContainer.clientWidth;
        }
        scrollToWithAnimation(this.paneContainer, "scrollLeft", scrollOffset, 200, "easeInOutQuad", ()=>{
            this.panes.splice(index);
        });
    }
    closePanes() {
        if (this.panes.length > 0) {
            this.panes = [];
        }
    }
    getNodeTitle(node) {
        let nodeTitle = getSchemaTitle(node.schema);
        if (!isNullOrEmpty(nodeTitle)) {
            return nodeTitle;
        }
        let parent = node.getParent();
        if (parent != null) {
            return getSchemaTitle(parent.schema);
        }
        return "";
    }
    isRemovable(node) {
        return Array.isArray(node.schema.type) && node.schema.type.includes("null") && node.model != null;
    }
    removeNode(node) {
        let replacementMetadata = this.editorFactory.createReplacementNull(node);
        let args = {
            rootId: node.rootId,
            sender: node.metadataPath,
            metadataOp: {
                op: "replace",
                path: node.metadataPath,
                value: replacementMetadata
            },
            op: {
                op: "replace",
                path: node.path,
                value: null
            }
        };
        eventBus.emit(PatchEvent, args);
    }
    getPaneOffset(index) {
        return this.paneContainer.clientWidth - this.paneWidth * 0.68 + index * (this.paneWidth * 0.68);
    }
    constructor(...args){
        super(...args), this.panes = [], this.paneWidth = 0, this.paneHeight = 0, this.updatePaneDimensionsDebounced = debounce$2(this.updatePaneDimensions, 200);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], EntityEditorPanes.prototype, "editorFactory", void 0);
_([
    Prop({
        required: true
    }),
    _$1("design:type", Array)
], EntityEditorPanes.prototype, "nodes", void 0);
EntityEditorPanes = _([
    Component({
        render: render$V
    })
], EntityEditorPanes);

const _hoisted_1$H = { class: "text-overline text-dense mb-0" };
const _hoisted_2$y = { class: "flex-grow-1" };

function render$U(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_entity_editor_panes = resolveComponent("entity-editor-panes");
  const _component_v_window_item = resolveComponent("v-window-item");
  const _component_v_window = resolveComponent("v-window");
  const _component_v_container = resolveComponent("v-container");

  return (openBlock(), createElementBlock(Fragment, null, [
    (!_ctx.hideAppbar)
      ? (openBlock(), createBlock(_component_v_app_bar, {
          key: 0,
          color: "background"
        }, createSlots({
          default: withCtx(() => [
            createVNode(_component_v_toolbar_items, { class: "v-toolbar__items--back" }, {
              default: withCtx(() => [
                createVNode(_component_v_tooltip, { location: "bottom" }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_btn, mergeProps(props, {
                      icon: "",
                      onClick: _ctx.goBack
                    }), {
                      default: withCtx(() => [
                        createVNode(_component_v_icon, null, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(_ctx.$icons.mdiArrowLeft), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040, ["onClick"])
                  ]),
                  default: withCtx(() => [
                    _cache[1] || (_cache[1] = createElementVNode("span", null, "Zurück", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_toolbar_title, null, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_1$H, toDisplayString(this.value?.schema.title), 1),
                createTextVNode(" " + toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            }),
            createVNode(_component_v_spacer),
            createVNode(_component_v_toolbar_items, {
              class: normalizeClass(_ctx.disableGrouping ? 'mr-16' : null)
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "toolbar", { editor: this })
              ]),
              _: 3
            }, 8, ["class"]),
            (_ctx.disableGrouping)
              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createVNode(_component_v_spacer),
                  renderSlot(_ctx.$slots, "fab", { editor: this })
                ], 64))
              : createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (!_ctx.disableGrouping)
            ? {
                name: "extension",
                fn: withCtx(() => [
                  createElementVNode("div", _hoisted_2$y, [
                    createVNode(_component_v_tabs, {
                      "align-tabs": "center",
                      class: "entity-editor__tabs"
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
                          return (openBlock(), createBlock(_component_v_tab, {
                            replace: "",
                            exact: "",
                            to: group.route,
                            key: group.name
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(group.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    createVNode(_component_v_divider)
                  ]),
                  renderSlot(_ctx.$slots, "fab", { editor: this })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024))
      : createCommentVNode("", true),
    createVNode(_component_v_container, {
      fluid: "",
      class: "pa-0 h-100"
    }, {
      default: withCtx(() => [
        (!_ctx.disableGrouping)
          ? (openBlock(), createBlock(_component_v_window, {
              key: 0,
              class: "transparent h-100",
              modelValue: _ctx.activeGroup,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.activeGroup) = $event))
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
                  return (openBlock(), createBlock(_component_v_window_item, {
                    class: "h-100",
                    key: group.name,
                    value: group.name
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_entity_editor_panes, {
                        nodes: group.nodes
                      }, null, 8, ["nodes"])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (openBlock(), createBlock(_component_entity_editor_panes, {
              key: 1,
              nodes: _ctx.children
            }, null, 8, ["nodes"]))
      ]),
      _: 1
    })
  ], 64))
}

IconRegistry.add({
    mdiArrowLeft
});
const UnknownGroupName = "Weitere Felder";
const notEmptyKeyword = "notEmpty";
const notEmpty = {
    keyword: notEmptyKeyword,
    validate: (schema, data)=>{
        let isValid = null;
        if (data == null) {
            isValid = false;
        } else if (typeof data === "object") {
            isValid = data != null;
        } else if (Array.isArray(data)) {
            isValid = data.length > 0;
        } else if (typeof data === "string") {
            isValid = data.length > 0;
        } else if (isValid == null) {
            throw new Error("Keyword 'notEmpty' is only applicable to objects, arrays and strings.");
        }
        if (!isValid) {
            notEmpty.validate.errors = [
                {
                    keyword: notEmptyKeyword,
                    message: "Muss ausgefüllt werden",
                    params: {
                        "notEmpty": true
                    }
                }
            ];
        }
        return isValid;
    },
    errors: true
};
class EntityEditor extends Vue {
    get groups() {
        let childrenByGroup = Enumerable.from(this.children).Select((node, index)=>{
            return {
                index,
                node
            };
        }).GroupBy((x)=>x.node.schema.editorGroup ?? UnknownGroupName).Select((g)=>{
            return {
                groupName: g.key,
                nodes: Enumerable.from(g).OrderBy((x)=>x.node.schema.editorOrder ?? x.index).Select((x)=>x.node).ToArray()
            };
        }).ToMap((g)=>g.groupName, (g)=>g.nodes);
        let editorGroups = this.value?.schema.editorGroups ?? [];
        let implicitGroups = Enumerable.from(childrenByGroup.keys()).Select((groupName, index)=>{
            return {
                name: groupName,
                order: index
            };
        });
        return Enumerable.from(editorGroups).Union(implicitGroups, (g)=>g.name).OrderBy((g)=>g.order).Select((g)=>{
            return {
                name: g.name,
                route: {
                    query: {
                        group: g.name
                    }
                },
                nodes: childrenByGroup.get(g.name) ?? []
            };
        }).ToArray();
    }
    get children() {
        if (!this.value || !this.value.children) {
            return [];
        }
        return Object.entries(this.value.children).map(([_, data])=>data);
    }
    get hasErrors() {
        return this.errors.length > 0;
    }
    created() {
        eventBus.on(PatchEvent, this.onPatch);
        this.schemaValidator.addKeyword(notEmpty);
    }
    beforeDestroy() {
        eventBus.off(PatchEvent, this.onPatch);
    }
    onRootNodeChanged() {
        if (this.value == null) {
            return;
        }
        // activate first group when we're activated without any group info
        // need to do it here (instead of in mounted()) because the schema needs to be loaded
        if (this.activeGroup == null) {
            this.$router.replace({
                query: {
                    group: this.groups[0].name
                }
            });
        }
        let schema = this.validationSchema || this.value.schema;
        this.compiledValidator = this.schemaValidator.compile(schema);
        // do initial validation
        this.errors = [];
        this.validate();
    }
    onActiveGroupChanged() {
        eventBus.emit(GroupChangedEvent, {
            groupName: this.activeGroup
        });
    }
    onPatch(e) {
        if (this.value == null || this.value.rootId !== e.rootId) {
            return;
        }
        this.redoPatches = [];
        if (e.metadataOp != null) {
            let reverseMetadataPatch = this.applyPatch(this.value, e.metadataOp);
            let reversePatch = this.applyPatch(this.value.model, e.op);
            this.updateMetadataPaths(e.sender, e.metadataOp);
            this.undoPatches.push({
                modelPatch: reversePatch,
                metadataPatch: reverseMetadataPatch,
                senderMetadataPath: e.sender
            });
        } else {
            let reversePatch = this.applyPatch(this.value.model, e.op);
            this.undoPatches.push({
                modelPatch: reversePatch,
                senderMetadataPath: e.sender
            });
        }
        this.emitChangedEvent(e.sender);
        this.$emit("update:modelValue", this.value);
    }
    goBack() {
        this.$router.back();
    }
    async activateNode(node) {
        if (this.value == null) {
            return;
        }
        let nodePointerSegments = JsonPointer.decode(node.metadataPath);
        let groupName = this.value.children[nodePointerSegments[1]].schema?.editorGroup ?? UnknownGroupName;
        if (this.activeGroup !== groupName) {
            try {
                await this.$router.replace({
                    query: {
                        group: groupName
                    }
                });
                eventBus.emit(SetFocusEvent, node.path);
            } catch (e) {}
        } else {
            eventBus.emit(SetFocusEvent, node.path);
        }
    }
    getNodeTitle(node) {
        return node.path;
    }
    get canUndo() {
        return this.undoPatches.length > 0;
    }
    undo() {
        if (!this.canUndo) {
            return;
        }
        if (this.value == null) {
            return;
        }
        let undoPatch = this.undoPatches.pop();
        let modelRedoPatch = this.applyPatch(this.value.model, undoPatch.modelPatch);
        let metadataRedoPatch;
        if (undoPatch.metadataPatch) {
            metadataRedoPatch = this.applyPatch(this.value, undoPatch.metadataPatch);
            this.updateMetadataPaths(undoPatch.senderMetadataPath, undoPatch.metadataPatch);
        }
        this.redoPatches.push({
            modelPatch: modelRedoPatch,
            metadataPatch: metadataRedoPatch,
            senderMetadataPath: undoPatch.senderMetadataPath
        });
        this.emitChangedEvent(undoPatch.senderMetadataPath);
        eventBus.emit(SetFocusEvent, undoPatch.modelPatch.path);
    }
    get canRedo() {
        return this.redoPatches.length > 0;
    }
    redo() {
        if (!this.canRedo) {
            return;
        }
        if (this.value == null) {
            return;
        }
        let redoPatch = this.redoPatches.pop();
        let modelUndoPatch = this.applyPatch(this.value.model, redoPatch.modelPatch);
        let metadataUndoPatch;
        if (redoPatch.metadataPatch) {
            metadataUndoPatch = this.applyPatch(this.value, redoPatch.metadataPatch);
            this.updateMetadataPaths(redoPatch.senderMetadataPath, redoPatch.metadataPatch);
        }
        this.undoPatches.push({
            modelPatch: modelUndoPatch,
            metadataPatch: metadataUndoPatch,
            senderMetadataPath: redoPatch.senderMetadataPath
        });
        this.emitChangedEvent(redoPatch.senderMetadataPath);
        eventBus.emit(SetFocusEvent, redoPatch.modelPatch.path);
    }
    applyPatch(target, op) {
        let reversePatch = this.buildReversePatch(target, op);
        jsonpatch.applyOperation(target, op, true);
        return reversePatch;
    }
    buildReversePatch(original, op) {
        let originalValue = JsonPointer.get(original, op.path);
        switch(op.op){
            case "add":
                // need to screen out "-" for insert-at-end and resolve it to the index
                let path = op.path;
                let segments = Array.from(JsonPointer.decode(op.path));
                let maybeIndexer = segments.pop();
                if (maybeIndexer === "-") {
                    let array = JsonPointer.get(original, JsonPointer.create(segments));
                    path = JsonPointer.create(segments.concat(array.length)).toString();
                }
                return {
                    op: "remove",
                    path: path
                };
            case "move":
                return {
                    op: "move",
                    from: op.path,
                    path: op.from
                };
            case "remove":
                return {
                    op: "add",
                    path: op.path,
                    value: jsonpatch.deepClone(originalValue)
                };
            case "replace":
                return {
                    op: "replace",
                    path: op.path,
                    value: jsonpatch.deepClone(originalValue)
                };
            default:
                throw new ExtendedError(`Cannot generate reverse patch for op '${op.op}'.`, {
                    op
                });
        }
    }
    updateMetadataPaths(senderMetadataPath, op) {
        if (this.value == null) {
            throw new Error("this.metadata is null");
        }
        if (op.op === "add" || op.op === "remove" || op.op === "move") {
            let senderNode = JsonPointer.get(this.value, senderMetadataPath);
            if (senderNode.items != null) {
                senderNode.items.forEach(this.updateSelfAndNestedPaths);
            }
        }
    }
    updateSelfAndNestedPaths(node, index) {
        // model
        var segments = Array.from(JsonPointer.decode(node.path));
        segments[segments.length - 1] = index.toString();
        node.path = JsonPointer.create(segments).toString();
        // metadata
        var metadataSegments = Array.from(JsonPointer.decode(node.metadataPath));
        metadataSegments[metadataSegments.length - 1] = index.toString();
        node.metadataPath = JsonPointer.create(metadataSegments).toString();
        if (node.children != null) {
            Object.values(node.children).forEach((c)=>updateNestedPaths(c, segments, metadataSegments));
        }
        if (node.items != null) {
            node.items.forEach((i)=>updateNestedPaths(i, segments, metadataSegments));
        }
        function updateNestedPaths(node, parentSegments, parentMetadataSegments) {
            // model
            let segments = JsonPointer.decode(node.path);
            segments = parentSegments.concat(segments.slice(parentSegments.length));
            node.path = JsonPointer.create(segments).toString();
            // metadata
            let metadataSegments = JsonPointer.decode(node.metadataPath);
            metadataSegments = parentMetadataSegments.concat(metadataSegments.slice(parentMetadataSegments.length));
            node.metadataPath = JsonPointer.create(metadataSegments).toString();
            if (node.children != null) {
                Object.values(node.children).forEach((c)=>updateNestedPaths(c, segments, metadataSegments));
            }
            if (node.items != null) {
                node.items.forEach((i)=>updateNestedPaths(i, segments, metadataSegments));
            }
        }
    }
    emitChangedEvent(metadataPath) {
        if (this.value == null) {
            return;
        }
        let changedNode = JsonPointer.get(this.value, metadataPath);
        this.validate(changedNode);
        let args = {
            metadataPath: metadataPath,
            model: JsonPointer.get(this.value.model, changedNode.path)
        };
        eventBus.emit(UpdatedEvent, args);
    }
    validate(node) {
        if (this.value == null) {
            return;
        }
        this.compiledValidator(this.value.model);
        Ajv_localize_de(this.compiledValidator.errors);
        if (node != null) {
            // errors for single node
            let errors = (this.compiledValidator.errors || []).filter((error)=>error.instancePath === node.path);
            this.errors = this.errors.filter((x)=>x.node.path !== node.path).concat(errors.map((error)=>{
                return {
                    node,
                    error
                };
            }));
            node.errors = errors;
        } else {
            // errors for whole document
            let errorMap = Enumerable.from(this.compiledValidator.errors || []).GroupBy((err)=>err.instancePath).ToMap((g)=>g.key, (g)=>Array.from(g));
            for (let node of flattenNodes(this.value)){
                let errors = errorMap.get(node.path);
                if (errors != null) {
                    this.errors.push(...errors.map((error)=>{
                        return {
                            node,
                            error
                        };
                    }));
                }
                node.errors = errors || [];
            }
        }
    }
    constructor(...args){
        super(...args), this.schemaValidator = new Ajv({
            allErrors: true,
            validateFormats: false,
            strict: false
        }), this.isErrorsMenuOpen = false, this.undoPatches = [], this.redoPatches = [], this.errors = [], this.value = null, this.validationSchema = null;
    }
}
_([
    NonReactive
], EntityEditor.prototype, "schemaValidator", void 0);
_([
    NonReactive,
    _$1("design:type", typeof ValidateFunction === "undefined" ? Object : ValidateFunction)
], EntityEditor.prototype, "compiledValidator", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], EntityEditor.prototype, "disableGrouping", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], EntityEditor.prototype, "hideAppbar", void 0);
_([
    Prop({
        default: ""
    }),
    _$1("design:type", String)
], EntityEditor.prototype, "title", void 0);
_([
    Model({
        default: null
    }),
    _$1("design:type", Object)
], EntityEditor.prototype, "value", void 0);
_([
    Prop({
        default: null
    }),
    _$1("design:type", Object)
], EntityEditor.prototype, "validationSchema", void 0);
_([
    Prop(),
    _$1("design:type", String)
], EntityEditor.prototype, "activeGroup", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], EntityEditor.prototype, "onRootNodeChanged", null);
_([
    Watch(nameof("activeGroup")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], EntityEditor.prototype, "onActiveGroupChanged", null);
EntityEditor = _([
    Component({
        render: render$U,
        components: {
            EntityEditorPanes
        }
    })
], EntityEditor);

const _hoisted_1$G = { class: "boolean-editor editor-base editor-base--primitive" };
const _hoisted_2$x = { class: "boolean-editor__label" };
const _hoisted_3$s = {
  key: 0,
  class: "text-h6 editor-base__title"
};
const _hoisted_4$8 = {
  key: 1,
  class: "editor-base__description"
};

function render$T(_ctx, _cache) {
  const _component_v_switch = resolveComponent("v-switch");

  return (openBlock(), createElementBlock("div", _hoisted_1$G, [
    createVNode(_component_v_switch, {
      inset: "",
      color: "primary",
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event))
    }, {
      label: withCtx(() => [
        createElementVNode("div", _hoisted_2$x, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_3$s, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_4$8, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["error-messages", "disabled", "modelValue"])
  ]))
}

class BooleanEditor extends EditorBase {
    get value() {
        return this.model ?? false;
    }
    set value(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
}
BooleanEditor = _([
    Component({
        render: render$T
    })
], BooleanEditor);
EditorFactory.registerEditor({
    type: BooleanEditor,
    predicate: (schema, typeName)=>typeName === "boolean",
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            return {
                value: node.model ? "Ja" : "Nein"
            };
        };
    }
});

const _hoisted_1$F = { class: "editor-base editor-base--primitive" };
const _hoisted_2$w = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$r = {
  key: 1,
  class: "editor-base__description"
};

function render$S(_ctx, _cache) {
  const _component_v_date_input = resolveComponent("v-date-input");

  return (openBlock(), createElementBlock("div", _hoisted_1$F, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$w, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$r, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_date_input, {
      variant: _ctx.inputVariant,
      color: "primary",
      "error-messages": _ctx.error,
      modelValue: _ctx.pickerValue,
      "onUpdate:modelValue": _ctx.onPickerUpdate,
      onChange: _cache[0] || (_cache[0] = e => _ctx.onTextboxChange(e.target.value))
    }, null, 8, ["variant", "error-messages", "modelValue", "onUpdate:modelValue"])
  ]))
}

IconRegistry.add({
    mdiCalendar
});
class DateEditor extends EditorBase {
    get error() {
        return this.dateTime.invalidExplanation;
    }
    get pickerValue() {
        return this.dateTime.toJSDate();
    }
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        if (isNullOrEmpty(this.model)) {
            return;
        }
        this.dateTime = DateEditor.parse(this.model);
    }
    onTextboxChange(text) {
        this.dateTime = DateTime.fromFormat(text, "d.M.yy", {
            locale: "de"
        });
        if (this.dateTime.isValid) {
            return;
        }
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: this.dateTime.toISODate()
        });
    }
    onPickerUpdate(date) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: DateTime.fromJSDate(date).toISODate()
        });
    }
    static parse(value) {
        if (isNullOrEmpty(value)) {
            return DateTime.invalid("null");
        }
        let [datetime, zone] = value.split(" ");
        if (!isNullOrEmpty(zone)) {
            return DateTime.fromISO(datetime, {
                locale: "de",
                zone: zone
            });
        } else {
            return DateTime.fromISO(datetime, {
                locale: "de"
            });
        }
    }
    constructor(...args){
        super(...args), this.dateTime = DateTime.now();
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], DateEditor.prototype, "onModelChanged", null);
DateEditor = _([
    Component({
        render: render$S
    })
], DateEditor);
EditorFactory.registerEditor({
    type: DateEditor,
    predicate: (schema, typeName)=>typeName === "string" && schema.format === "date",
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            var dateTime = DateEditor.parse(node.model);
            return {
                value: dateTime?.toLocaleString(DateTime.DATE_SHORT)
            };
        };
    }
});

const _hoisted_1$E = { class: "editor-base editor-base--primitive" };
const _hoisted_2$v = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$q = {
  key: 1,
  class: "editor-base__description"
};

function render$R(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_time_picker = resolveComponent("v-time-picker");
  const _component_v_menu = resolveComponent("v-menu");

  return (openBlock(), createElementBlock("div", _hoisted_1$E, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$v, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$q, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_menu, {
      "close-on-content-click": false,
      modelValue: _ctx.isOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isOpen) = $event)),
      "nudge-right": 40,
      transition: "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    }, {
      activator: withCtx(({ props }) => [
        createVNode(_component_v_text_field, mergeProps(props, {
          variant: _ctx.inputVariant,
          "error-messages": _ctx.error,
          modelValue: _ctx.pickerValue,
          onChange: _cache[0] || (_cache[0] = e => _ctx.setTime(e.target.value)),
          "prepend-icon": _ctx.$icons.mdiClockOutline
        }), null, 16, ["variant", "error-messages", "modelValue", "prepend-icon"])
      ]),
      default: withCtx(() => [
        createVNode(_component_v_time_picker, {
          format: "24hr",
          color: "primary",
          "header-color": "primary",
          disabled: _ctx.isReadOnly,
          modelValue: _ctx.pickerValue,
          "onUpdate:modelValue": _ctx.setTime
        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}

IconRegistry.add({
    mdiClockOutline
});
class TimeEditor extends EditorBase {
    get pickerValue() {
        return this.dateTime.toLocaleString(DateTime.TIME_24_SIMPLE) ?? "00:00";
    }
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        if (isNullOrEmpty(this.model)) {
            return;
        }
        this.dateTime = TimeEditor.parse(this.model);
    }
    setTime(text) {
        let time = DateTime.fromFormat(text, "H:m", {
            locale: "de"
        });
        if (!time.isValid) {
            this.error = time.invalidExplanation;
            return;
        }
        this.error = null;
        let newDateTime = this.dateTime.set({
            hour: time.hour,
            minute: time.minute,
            second: 0,
            millisecond: 0
        });
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: newDateTime.toISOTime({
                includeOffset: false
            })
        });
        this.isOpen = false;
    }
    static parse(value) {
        if (isNullOrEmpty(value)) {
            return null;
        }
        return DateTime.fromISO(value, {
            locale: "de"
        });
    }
    constructor(...args){
        super(...args), this.isOpen = false, this.dateTime = DateTime.local(), this.error = null;
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TimeEditor.prototype, "onModelChanged", null);
TimeEditor = _([
    Component({
        render: render$R
    })
], TimeEditor);
EditorFactory.registerEditor({
    type: TimeEditor,
    predicate: (schema, typeName)=>typeName === "string" && schema.format === "time",
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            var dateTime = TimeEditor.parse(node.model);
            return {
                value: dateTime?.toLocaleString(DateTime.TIME_SIMPLE)
            };
        };
    }
});

const _hoisted_1$D = { class: "editor-base editor-base--primitive" };
const _hoisted_2$u = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$p = {
  key: 1,
  class: "editor-base__description"
};

function render$Q(_ctx, _cache) {
  const _component_v_date_input = resolveComponent("v-date-input");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_time_picker = resolveComponent("v-time-picker");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createElementBlock("div", _hoisted_1$D, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$u, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$p, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_row, { align: "center" }, {
      default: withCtx(() => [
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            createVNode(_component_v_date_input, {
              variant: _ctx.inputVariant,
              color: "primary",
              "error-messages": _ctx.dateError,
              modelValue: _ctx.datePickerValue,
              "onUpdate:modelValue": _ctx.onDatePickerUpdate,
              onChange: _cache[0] || (_cache[0] = e => _ctx.onDateTextboxChange(e.target.value))
            }, null, 8, ["variant", "error-messages", "modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            createVNode(_component_v_menu, {
              "close-on-content-click": false,
              modelValue: _ctx.isTimeOpen,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.isTimeOpen) = $event)),
              "nudge-right": 40,
              transition: "scale-transition",
              "offset-y": "",
              "min-width": "290px"
            }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_text_field, mergeProps(props, {
                  variant: _ctx.inputVariant,
                  "error-messages": _ctx.timeError,
                  modelValue: _ctx.timePickerValue,
                  onChange: _cache[1] || (_cache[1] = e => _ctx.setTime(e.target.value)),
                  "prepend-icon": _ctx.$icons.mdiClockOutline,
                  append: _ctx.zoneOffsetShort
                }), createSlots({ _: 2 }, [
                  (_ctx.isTimeZoneAware)
                    ? {
                        name: "append-inner",
                        fn: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.zoneOffsetShort), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1040, ["variant", "error-messages", "modelValue", "prepend-icon", "append"])
              ]),
              default: withCtx(() => [
                createVNode(_component_v_time_picker, {
                  format: "24hr",
                  color: "primary",
                  "header-color": "primary",
                  disabled: _ctx.isReadOnly,
                  modelValue: _ctx.timePickerValue,
                  "onUpdate:modelValue": _ctx.setTime
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}

IconRegistry.add({
    mdiCalendar,
    mdiClockOutline,
    mdiMapClock
});
class DateTimeEditor extends EditorBase {
    get datePickerValue() {
        return this.dateTime.toJSDate();
    }
    get timePickerValue() {
        return this.dateTime.toLocaleString(DateTime.TIME_24_SIMPLE) ?? "00:00";
    }
    get zoneOffsetShort() {
        return this.dateTime.offsetNameShort ?? this.dateTime.offset.toString();
    }
    get isTimeZoneAware() {
        return this.data.schema.format === "date-time-zoned";
    }
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        if (isNullOrEmpty(this.model)) {
            return;
        }
        this.dateError = null;
        this.timeError = null;
        this.dateTime = DateTimeEditor.parse(this.model);
        if (!this.dateTime.isValid) {
            this.dateError = this.dateTime.invalidExplanation;
        }
    }
    onDateTextboxChange(text) {
        let date = DateTime.fromFormat(text, "d.M.yy", {
            locale: "de"
        });
        if (!date.isValid) {
            this.dateError = date.invalidExplanation;
            return;
        }
        let dateTime = this.dateTime.set({
            year: date.year,
            month: date.month,
            day: date.day
        });
        this.dateError = null;
        this.emitPatch(dateTime);
    }
    onDatePickerUpdate(value) {
        let date = DateTime.fromJSDate(value);
        let dateTime = this.dateTime.set({
            year: date.year,
            month: date.month,
            day: date.day
        });
        this.dateError = null;
        this.emitPatch(dateTime);
    }
    setTime(text) {
        let time = DateTime.fromFormat(text, "H:m", {
            locale: "de"
        });
        if (!time.isValid) {
            this.timeError = time.invalidExplanation;
            return;
        }
        this.timeError = null;
        let dateTime = this.dateTime.set({
            hour: time.hour,
            minute: time.minute,
            second: 0,
            millisecond: 0
        });
        this.emitPatch(dateTime);
        this.isTimeOpen = false;
    }
    emitPatch(value) {
        let output = "";
        if (this.isTimeZoneAware) {
            output = `${value.toISO()} ${value.toFormat("z")}`;
        } else {
            output = value.toISO({
                includeOffset: false
            }) ?? "";
        }
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: output
        });
    }
    static parse(value) {
        if (isNullOrEmpty(value)) {
            return DateTime.invalid("null");
        }
        let [datetime, zone] = value.split(" ");
        if (!isNullOrEmpty(zone)) {
            return DateTime.fromISO(datetime, {
                locale: "de",
                zone: zone
            });
        } else {
            return DateTime.fromISO(datetime, {
                locale: "de"
            });
        }
    }
    constructor(...args){
        super(...args), this.isTimeOpen = false, this.dateTime = DateTime.local(), this.dateError = null, this.timeError = null;
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], DateTimeEditor.prototype, "onModelChanged", null);
DateTimeEditor = _([
    Component({
        render: render$Q
    })
], DateTimeEditor);
EditorFactory.registerEditor({
    type: DateTimeEditor,
    predicate: (schema, typeName)=>schema.format === "date-time" || schema.format === "date-time-zoned",
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            let dateTime = DateTimeEditor.parse(node.model);
            return {
                value: dateTime?.toLocaleString(DateTime.DATETIME_SHORT)
            };
        };
    }
});

const _hoisted_1$C = { class: "editor-base editor-base--primitive" };
const _hoisted_2$t = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$o = {
  key: 1,
  class: "editor-base__description"
};

function render$P(_ctx, _cache) {
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_select = resolveComponent("v-select");

  return (openBlock(), createElementBlock("div", _hoisted_1$C, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$t, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$o, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_select, {
      variant: _ctx.inputVariant,
      items: _ctx.values,
      "item-props": true,
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      "append-outer-icon": _ctx.hasObsolete ? _ctx.$icons.mdiHistory : null,
      "onClick:appendOuter": _cache[1] || (_cache[1] = $event => (_ctx.showObsolete = !_ctx.showObsolete))
    }, {
      item: withCtx(({ item, props }) => [
        createVNode(_component_v_list_item, mergeProps(props, {
          class: { 'is-obsolete': item.isObsolete }
        }), null, 16, ["class"])
      ]),
      _: 1
    }, 8, ["variant", "items", "error-messages", "disabled", "modelValue", "append-outer-icon"])
  ]))
}

IconRegistry.add({
    mdiHistory
});
class EnumEditor extends EditorBase {
    get value() {
        return this.model ?? this.values[0].value;
    }
    set value(value) {
        this.commitPatch({
            op: this.model == null ? "add" : "replace",
            path: this.data.path,
            value: value
        });
    }
    get values() {
        return this.createSelectItems().filter((x)=>!x.isObsolete || this.showObsolete);
    }
    get hasObsolete() {
        return this.createSelectItems().some((x)=>x.isObsolete && x.value !== undefined);
    }
    mounted() {
        let items = this.createSelectItems();
        this.showObsolete = items.find((x)=>x.value === this.value)?.isObsolete ?? false;
    }
    createSelectItems() {
        if (Array.isArray(this.data.schema)) {
            throw new Error("EnumEditor only works with a single schema.");
        }
        let values = this.data.schema.enum;
        let names = this.data.schema.enumNames;
        let groups = groupBy(values.map((value, i)=>{
            return {
                value: value,
                title: value === null ? "Keine Auswahl" : names[i].description ?? value ?? "(null)",
                isObsolete: names[i].isObsolete
            };
        }), (x)=>x.isObsolete);
        return [
            ...groups["false"] ?? [],
            {
                type: "divider",
                "title": "",
                value: "",
                isObsolete: true
            },
            {
                type: "subheader",
                title: "Veraltete Werte",
                value: "",
                isObsolete: true
            },
            ...groups["true"] ?? []
        ];
    }
    constructor(...args){
        super(...args), this.showObsolete = false;
    }
}
EnumEditor = _([
    Component({
        render: render$P
    })
], EnumEditor);
EditorFactory.registerEditor({
    type: EnumEditor,
    predicate: (schema, typeName)=>typeName === "string" && schema.enum != null,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            let index = node.schema.enum?.indexOf(node.model) ?? -1;
            if (index === -1) {
                return {
                    value: node.model
                };
            }
            return {
                value: node.schema.enumNames?.[index].description ?? node.model
            };
        };
    },
    handleNull: true,
    priority: 0
});

const _hoisted_1$B = { class: "editor-base editor-base--primitive" };
const _hoisted_2$s = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$n = {
  key: 1,
  class: "editor-base__description"
};

function render$O(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");

  return (openBlock(), createElementBlock("div", _hoisted_1$B, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$s, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$n, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_text_field, {
      width: "16em",
      variant: _ctx.inputVariant,
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      onChange: _cache[0] || (_cache[0] = e => _ctx.value = e.target.value)
    }, null, 8, ["variant", "error-messages", "disabled", "modelValue"])
  ]))
}

class NumberEditor extends EditorBase {
    get value() {
        return this.model?.toString() ?? "0";
    }
    set value(value) {
        let numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            numberValue = 0;
        }
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: numberValue
        });
    }
}
NumberEditor = _([
    Component({
        render: render$O
    })
], NumberEditor);
EditorFactory.registerEditor({
    type: NumberEditor,
    predicate: (schema, typeName)=>typeName === "number",
    priority: 0
});

const _hoisted_1$A = { class: "editor-base editor-base--primitive" };
const _hoisted_2$r = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$m = {
  key: 1,
  class: "editor-base__description"
};

function render$N(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_number_input = resolveComponent("v-number-input");

  return (openBlock(), createElementBlock("div", _hoisted_1$A, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$r, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$m, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_number_input, {
      width: "16em",
      variant: _ctx.inputVariant,
      controlVariant: "stacked",
      step: 1,
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event))
    }, {
      increment: withCtx(({ click }) => [
        createVNode(_component_v_btn, {
          variant: "tonal",
          rounded: "sm",
          icon: _ctx.$icons.mdiPlus,
          onClick: click
        }, null, 8, ["icon", "onClick"])
      ]),
      decrement: withCtx(({ click }) => [
        createVNode(_component_v_btn, {
          variant: "tonal",
          rounded: "sm",
          icon: _ctx.$icons.mdiMinus,
          onClick: click
        }, null, 8, ["icon", "onClick"])
      ]),
      _: 1
    }, 8, ["variant", "error-messages", "disabled", "modelValue"])
  ]))
}

IconRegistry.add({
    mdiPlus,
    mdiMinus
});
class IntegerEditor extends EditorBase {
    get value() {
        return this.model ?? 0;
    }
    set value(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
}
IntegerEditor = _([
    Component({
        render: render$N
    })
], IntegerEditor);
EditorFactory.registerEditor({
    type: IntegerEditor,
    predicate: (schema, typeName)=>typeName === "integer",
    priority: 0
});

const _hoisted_1$z = { class: "editor-base editor-base--primitive" };
const _hoisted_2$q = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$l = {
  key: 1,
  class: "editor-base__description"
};

function render$M(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");

  return (openBlock(), createElementBlock("div", _hoisted_1$z, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$q, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$l, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_text_field, {
      variant: _ctx.inputVariant,
      counter: "",
      autocomplete: "off",
      placeholder: "Text eingeben …",
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      onChange: _ctx.onChange
    }, null, 8, ["variant", "error-messages", "disabled", "modelValue", "onChange"])
  ]))
}

class StringEditor extends EditorBase {
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        this.value = this.model ?? "";
    }
    onChange() {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: this.value
        });
    }
    constructor(...args){
        super(...args), this.value = "";
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], StringEditor.prototype, "onModelChanged", null);
StringEditor = _([
    Component({
        render: render$M
    })
], StringEditor);
EditorFactory.registerEditor({
    type: StringEditor,
    predicate: (schema, typeName)=>typeName === "string",
    priority: -1
});

const _hoisted_1$y = { class: "editor-base editor-base--primitive" };
const _hoisted_2$p = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$k = {
  key: 1,
  class: "editor-base__description"
};

function render$L(_ctx, _cache) {
  const _component_v_textarea = resolveComponent("v-textarea");

  return (openBlock(), createElementBlock("div", _hoisted_1$y, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$p, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$k, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_textarea, {
      counter: "",
      variant: _ctx.inputVariant,
      placeholder: "Text eingeben …",
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      onChange: _ctx.onChange
    }, null, 8, ["variant", "error-messages", "disabled", "modelValue", "onChange"])
  ]))
}

class TextEditor extends EditorBase {
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        this.value = this.model ?? "";
    }
    onChange() {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: this.value
        });
    }
    constructor(...args){
        super(...args), this.value = "";
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TextEditor.prototype, "onModelChanged", null);
TextEditor = _([
    Component({
        render: render$L
    })
], TextEditor);
EditorFactory.registerEditor({
    type: TextEditor,
    predicate: (schema, typeName)=>typeName === "string" && (schema.format === "Text" || schema.format === "MultilineText"),
    priority: 0
});

const _hoisted_1$x = { class: "editor-base editor-base--primitive" };
const _hoisted_2$o = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$j = {
  key: 1,
  class: "editor-base__description"
};

function render$K(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createElementBlock("div", _hoisted_1$x, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$o, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$j, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_row, { class: "mt-1" }, {
      default: withCtx(() => [
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_text_field, {
              variant: _ctx.inputVariant,
              type: "number",
              label: "Tage",
              disabled: _ctx.isReadOnly,
              modelValue: _ctx.days,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.setValue('days', $event)))
            }, null, 8, ["variant", "disabled", "modelValue"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_text_field, {
              variant: _ctx.inputVariant,
              type: "number",
              label: "Stunden",
              disabled: _ctx.isReadOnly,
              modelValue: _ctx.hours,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.setValue('hours', $event)))
            }, null, 8, ["variant", "disabled", "modelValue"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_text_field, {
              variant: _ctx.inputVariant,
              type: "number",
              label: "Minuten",
              disabled: _ctx.isReadOnly,
              modelValue: _ctx.minutes,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.setValue('minutes', $event)))
            }, null, 8, ["variant", "disabled", "modelValue"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_text_field, {
              variant: _ctx.inputVariant,
              type: "number",
              label: "Sekunden",
              disabled: _ctx.isReadOnly,
              modelValue: _ctx.seconds,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.setValue('seconds', $event)))
            }, null, 8, ["variant", "disabled", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}

IconRegistry.add({
    mdiAvTimer
});
class TimespanEditor extends EditorBase {
    get days() {
        return this.duration.days;
    }
    get hours() {
        return this.duration.hours;
    }
    get minutes() {
        return this.duration.minutes;
    }
    get seconds() {
        return this.duration.seconds;
    }
    created() {
        this.onModelChanged();
    }
    onModelChanged() {
        if (isNullOrEmpty(this.model)) {
            return;
        }
        this.duration = TimespanEditor.parse(this.model);
    }
    setValue(component, value) {
        let newDuration = this.duration.set({
            [component]: parseInt(value, 10)
        });
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: newDuration.toFormat("d.hh:mm:ss")
        });
    }
    static parse(value) {
        if (isNullOrEmpty(value)) {
            return Duration.invalid("null");
        }
        let valueParts = value.split(".");
        if (valueParts.length === 1) {
            return Duration.fromISOTime(value, {
                locale: "de"
            });
        } else {
            let duration = Duration.fromISOTime(valueParts[1]);
            return duration.set({
                days: parseInt(valueParts[0], 10)
            });
        }
    }
    constructor(...args){
        super(...args), this.duration = Duration.fromMillis(0);
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], TimespanEditor.prototype, "onModelChanged", null);
TimespanEditor = _([
    Component({
        render: render$K
    })
], TimespanEditor);
EditorFactory.registerEditor({
    type: TimespanEditor,
    predicate: (schema, typeName)=>typeName === "string" && schema.format === "duration",
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            var duration = TimespanEditor.parse(node.model);
            return {
                value: duration?.toHuman()
            };
        };
    }
});

const _hoisted_1$w = { class: "editor-base editor-base--primitive" };
const _hoisted_2$n = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$i = {
  key: 1,
  class: "editor-base__description"
};

function render$J(_ctx, _cache) {
  const _component_v_autocomplete = resolveComponent("v-autocomplete");

  return (openBlock(), createElementBlock("div", _hoisted_1$w, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$n, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$i, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_autocomplete, {
      variant: _ctx.inputVariant,
      items: _ctx.countries,
      "error-messages": _ctx.errorMessages,
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.pickerValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.pickerValue) = $event))
    }, null, 8, ["variant", "items", "error-messages", "disabled", "modelValue"])
  ]))
}

countries.registerLocale(germanCountryNames);
class CountryEditor extends EditorBase {
    get countries() {
        return Object.entries(countries.getNames("de")).map(([code, name])=>{
            return {
                title: name,
                value: code
            };
        });
    }
    get pickerValue() {
        return this.model ?? "";
    }
    set pickerValue(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
}
CountryEditor = _([
    Component({
        render: render$J
    })
], CountryEditor);
EditorFactory.registerEditor({
    type: CountryEditor,
    predicate: (schema, typeName)=>schema.format === "iso3166-country",
    priority: 0
});

const CustomElementChangedEvent = "richtext-editor/custom-element-changed";

const CustomTableCell = TableCell.extend({
    addAttributes () {
        return {
            colspan: {
                default: 1,
                renderHTML: (attributes)=>{
                    if (attributes.colspan > 1) {
                        return {
                            rowspan: attributes.colspan
                        };
                    }
                }
            },
            rowspan: {
                default: 1,
                renderHTML: (attributes)=>{
                    if (attributes.rowspan > 1) {
                        return {
                            rowspan: attributes.rowspan
                        };
                    }
                }
            },
            colwidth: {
                default: null,
                parseHTML: (element)=>{
                    const colwidth = element.getAttribute("colwidth");
                    const value = colwidth ? [
                        parseInt(colwidth, 10)
                    ] : null;
                    return value;
                }
            },
            align: {
                default: null,
                parseHTML: (element)=>element.getAttribute("align"),
                renderHTML: (attributes)=>{
                    return {
                        align: attributes.align
                    };
                }
            }
        };
    }
});

const CustomTableHeader = TableHeader.extend({
    addAttributes () {
        return {
            colspan: {
                default: 1,
                renderHTML: (attributes)=>{
                    if (attributes.colspan > 1) {
                        return {
                            rowspan: attributes.colspan
                        };
                    }
                }
            },
            rowspan: {
                default: 1,
                renderHTML: (attributes)=>{
                    if (attributes.rowspan > 1) {
                        return {
                            rowspan: attributes.rowspan
                        };
                    }
                }
            },
            colwidth: {
                default: null,
                parseHTML: (element)=>{
                    const colwidth = element.getAttribute("colwidth");
                    const value = colwidth ? [
                        parseInt(colwidth, 10)
                    ] : null;
                    return value;
                }
            },
            align: {
                default: null,
                parseHTML: (element)=>element.getAttribute("align"),
                renderHTML: (attributes)=>{
                    return {
                        align: attributes.align
                    };
                }
            }
        };
    }
});

const Small = Mark.create({
    name: "small",
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: "small"
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            "small",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setSmall: ()=>({ commands })=>{
                    return commands.setMark(this.name);
                },
            toggleSmall: ()=>({ commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetSmall: ()=>({ commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    }
});

const _hoisted_1$v = {
  key: 0,
  class: "text-caption text-truncate mr-2"
};
const _hoisted_2$m = ["href"];

function render$I(_ctx, _cache) {
  const _component_v_skeleton_loader = resolveComponent("v-skeleton-loader");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_asset_thumbnail = resolveComponent("asset-thumbnail");
  const _component_v_layout = resolveComponent("v-layout");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_fade_transition = resolveComponent("v-fade-transition");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_asset_node_editor = resolveComponent("asset-node-editor");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_card = resolveComponent("v-card");
  const _component_node_view_wrapper = resolveComponent("node-view-wrapper");

  return (openBlock(), createBlock(_component_node_view_wrapper, null, {
    default: withCtx(() => [
      createVNode(_component_v_card, {
        variant: "flat",
        color: "surfaceContainer",
        class: "richtext-asset richtext-widget richtext-widget--block",
        "is-loading": _ctx.state === 'loading'
      }, {
        default: withCtx(() => [
          createVNode(_component_v_fade_transition, null, {
            default: withCtx(() => [
              createElementVNode("div", null, [
                (_ctx.state === 'loading')
                  ? (openBlock(), createBlock(_component_v_responsive, {
                      key: 0,
                      "aspect-ratio": 3 / 2
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_skeleton_loader, {
                          type: "image",
                          height: "100%"
                        })
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                (_ctx.state === 'results' && _ctx.isImage)
                  ? (openBlock(), createBlock(_component_asset_thumbnail, {
                      key: 1,
                      width: 500,
                      height: 333,
                      asset: _ctx.asset
                    }, null, 8, ["asset"]))
                  : createCommentVNode("", true),
                (_ctx.state === 'no-results')
                  ? (openBlock(), createBlock(_component_v_sheet, { key: 2 }, {
                      default: withCtx(() => [
                        createVNode(_component_v_responsive, { "aspect-ratio": 3 / 2 }, {
                          default: withCtx(() => [
                            createVNode(_component_v_layout, {
                              "justify-center": "",
                              "align-center": "",
                              "fill-height": ""
                            }, {
                              default: withCtx(() => _cache[2] || (_cache[2] = [
                                createElementVNode("div", null, "Asset nicht gefunden", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                "data-drag-handle": "",
                class: "drag-handle mr-2"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                ]),
                _: 1
              }),
              (_ctx.state === 'results')
                ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    (_ctx.isImage)
                      ? (openBlock(), createElementBlock("div", _hoisted_1$v, [
                          createTextVNode(toDisplayString(_ctx.displayName), 1),
                          _cache[3] || (_cache[3] = createElementVNode("br", null, null, -1)),
                          _cache[4] || (_cache[4] = createElementVNode("strong", null, "Grösse", -1)),
                          createTextVNode(": " + toDisplayString(_ctx.sizeDisplayName), 1)
                        ]))
                      : (openBlock(), createBlock(_component_v_row, {
                          key: 1,
                          align: "center"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { cols: "auto" }, {
                              default: withCtx(() => [
                                createVNode(_component_asset_thumbnail, {
                                  width: 32,
                                  height: 32,
                                  asset: _ctx.asset,
                                  "is-passive": ""
                                }, null, 8, ["asset"])
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_col, { class: "text-body-2" }, {
                              default: withCtx(() => [
                                createElementVNode("a", {
                                  href: _ctx.asset.url,
                                  target: "_blank"
                                }, toDisplayString(_ctx.displayName) + " (" + toDisplayString(_ctx.friendlyFileType) + ", " + toDisplayString(_ctx.$formatters.bytes(_ctx.asset.length)) + ")", 9, _hoisted_2$m)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ], 64))
                : createCommentVNode("", true),
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                color: "primary",
                "prepend-icon": _ctx.$icons.mdiPencil,
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.isEditPaneOpen = true))
              }, {
                default: withCtx(() => _cache[5] || (_cache[5] = [
                  createTextVNode("Bearbeiten")
                ])),
                _: 1
              }, 8, ["prepend-icon"]),
              createVNode(_component_v_btn, {
                variant: "tonal",
                icon: _ctx.$icons.mdiDelete,
                color: "warning",
                onClick: _ctx.deleteNode
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          }),
          (_ctx.isEditPaneOpen)
            ? (openBlock(), createBlock(_component_property_pane, {
                key: 0,
                title: "Asset",
                "is-active": "",
                "is-clearable": "",
                "initial-value": _ctx.attributes,
                onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isEditPaneOpen = false)),
                onOk: _ctx.onEditPaneOk,
                onClear: _ctx.onEditPaneClear
              }, {
                default: withCtx(({ value, setValue, ok, cancel }) => [
                  createVNode(_component_asset_node_editor, {
                    modelValue: value,
                    "onUpdate:modelValue": setValue
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["initial-value", "onOk", "onClear"]))
            : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ]),
    _: 1
  }))
}

const _hoisted_1$u = { class: "mb-4" };

function render$H(_ctx, _cache) {
  const _component_id_selector_component = resolveComponent("id-selector-component");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_select = resolveComponent("v-select");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_textarea = resolveComponent("v-textarea");
  const _component_v_switch = resolveComponent("v-switch");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_url_picker = resolveComponent("url-picker");

  return (openBlock(), createElementBlock("div", null, [
    createElementVNode("div", _hoisted_1$u, [
      createVNode(_component_id_selector_component, {
        "clear-on-select": "",
        kind: "asset",
        mode: "edit",
        "thumbnail-columns": 4,
        onSelected: _ctx.onAssetSelected,
        modelValue: _ctx.selector,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selector) = $event))
      }, null, 8, ["onSelected", "modelValue"])
    ]),
    (_ctx.isImage)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createVNode(_component_v_card, { class: "mb-4" }, {
            default: withCtx(() => [
              createVNode(_component_v_card_title, null, {
                default: withCtx(() => _cache[8] || (_cache[8] = [
                  createTextVNode("Bildeinstellungen")
                ])),
                _: 1
              }),
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_v_row, null, {
                    default: withCtx(() => [
                      createVNode(_component_v_col, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_select, {
                            items: _ctx.sizes,
                            "item-title": "displayName",
                            "item-value": "name",
                            label: "Bildgrösse",
                            modelValue: _ctx.size,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.size) = $event))
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      }),
                      createVNode(_component_v_col, null, {
                        default: withCtx(() => [
                          createVNode(_component_v_select, {
                            items: _ctx.textWrapOptions,
                            label: "Textumfluss",
                            modelValue: _ctx.textWrap,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.textWrap) = $event))
                          }, null, 8, ["items", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_text_field, {
                    class: "mb-4",
                    "persistent-hint": "",
                    label: "Alt-Text",
                    hint: "Eine kurze Bildbeschreibung, wichtig für blinde Benutzer und Suchmaschinen.",
                    modelValue: _ctx.alt,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.alt) = $event))
                  }, null, 8, ["modelValue"]),
                  createVNode(_component_v_textarea, {
                    class: "mb-2",
                    "hide-details": "",
                    label: "Bildunterschrift",
                    modelValue: _ctx.caption,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.caption) = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.isSvg)
                    ? (openBlock(), createBlock(_component_v_switch, {
                        key: 0,
                        "hide-details": "",
                        inset: "",
                        color: "primary",
                        label: "Als interaktives Objekt einbinden (für SVG)",
                        modelValue: _ctx.interactive,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.interactive) = $event))
                      }, null, 8, ["modelValue"]))
                    : createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_v_switch, {
            "hide-details": "",
            inset: "",
            color: "primary",
            label: "Asset verlinken",
            onChange: _ctx.onIsLinkedChanged,
            modelValue: _ctx.isLinked,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.isLinked) = $event))
          }, null, 8, ["onChange", "modelValue"]),
          (_ctx.isLinked)
            ? (openBlock(), createBlock(_component_url_picker, {
                key: 0,
                modelValue: _ctx.link,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.link) = $event))
              }, null, 8, ["modelValue"]))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true)
  ]))
}

const textWrapOptions = [
    {
        title: "Automatisch",
        value: "auto"
    },
    {
        title: "Rechts",
        value: "right"
    },
    {
        title: "Links",
        value: "left"
    },
    {
        title: "Kein Umfluss",
        value: "none"
    }
];
class AssetNodeEditor extends Vue {
    get isImage() {
        if (this.asset == null) {
            return false;
        }
        return isImageContentType(this.asset.contentType);
    }
    get isSvg() {
        return this.asset?.contentType === "image/svg+xml";
    }
    get textWrapOptions() {
        return textWrapOptions;
    }
    get sizes() {
        return container.get("RichtextOptions").assetSizes;
    }
    get selector() {
        if (isNullOrEmpty(this.value?.url)) {
            return null;
        }
        return IdSelector.fromUrl(this.value.url);
    }
    set selector(value) {
        if (value != null) {
            this.emitInput({
                url: IdSelector.toUrl(value)
            });
        } else {
            this.emitInput({
                url: ""
            });
        }
    }
    get size() {
        return this.value?.size;
    }
    set size(value) {
        this.emitInput({
            size: value ?? this.sizes[0].name
        });
    }
    get textWrap() {
        return this.value?.textWrap ?? "auto";
    }
    set textWrap(value) {
        this.emitInput({
            textWrap: value
        });
    }
    get alt() {
        return this.value?.alt ?? null;
    }
    set alt(value) {
        this.emitInput({
            alt: value
        });
    }
    get caption() {
        return this.value?.caption ?? null;
    }
    set caption(value) {
        if (isNullOrEmpty(value)) {
            this.emitInput({
                caption: null
            });
        } else {
            this.emitInput({
                caption: value
            });
        }
    }
    get class() {
        return this.value?.class ?? null;
    }
    set class(value) {
        this.emitInput({
            class: value
        });
    }
    get link() {
        return this.value?.link ?? null;
    }
    set link(value) {
        this.emitInput({
            link: value
        });
    }
    get interactive() {
        return this.value?.interactive ?? false;
    }
    set interactive(value) {
        if (value) {
            this.isLinked = false;
            this.emitInput({
                link: null,
                interactive: true
            });
        } else {
            this.emitInput({
                interactive: false
            });
        }
    }
    onValueHrefChanged() {
        if (!isNullOrEmpty(this.value?.link)) {
            this.isLinked = true;
        }
    }
    onIsLinkedChanged() {
        if (this.isLinked) {
            this.interactive = false;
        } else {
            this.link = null;
        }
    }
    onAssetSelected(asset) {
        this.asset = asset;
        this.emitInput({
            size: this.size ?? this.sizes[0].name,
            // TODO: base on richtext language
            alt: Multilingual.getValue(asset?.description)
        });
    }
    emitInput(attrs) {
        let args = Object.assign({}, this.value, attrs);
        if (!deepequals(args, this.value)) {
            this.$emit("update:modelValue", args);
        }
    }
    constructor(...args){
        super(...args), this.isLinked = false, this.asset = null;
    }
}
_([
    Model(),
    _$1("design:type", typeof AssetAttrs === "undefined" ? Object : AssetAttrs)
], AssetNodeEditor.prototype, "value", void 0);
_([
    Watch("value.link"),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], AssetNodeEditor.prototype, "onValueHrefChanged", null);
AssetNodeEditor = _([
    Component({
        render: render$H
    })
], AssetNodeEditor);

class CustomNodeViewBase extends Vue {
    get attributes() {
        return this.node.attrs;
    }
    update(attrs) {
        this.updateAttributes(attrs);
        eventBus.emit(CustomElementChangedEvent);
    }
}
_([
    Prop(),
    _$1("design:type", typeof Editor === "undefined" ? Object : Editor)
], CustomNodeViewBase.prototype, "editor", void 0);
_([
    Prop(),
    _$1("design:type", typeof Node$1 === "undefined" ? Object : Node$1)
], CustomNodeViewBase.prototype, "node", void 0);
_([
    Prop(),
    _$1("design:type", Array)
], CustomNodeViewBase.prototype, "decorations", void 0);
_([
    Prop(),
    _$1("design:type", Boolean)
], CustomNodeViewBase.prototype, "selected", void 0);
_([
    Prop(),
    _$1("design:type", typeof Node$2 === "undefined" ? Object : Node$2)
], CustomNodeViewBase.prototype, "extension", void 0);
_([
    Prop(),
    _$1("design:type", Function)
], CustomNodeViewBase.prototype, "getPos", void 0);
_([
    Prop(),
    _$1("design:type", Function)
], CustomNodeViewBase.prototype, "updateAttributes", void 0);
_([
    Prop(),
    _$1("design:type", Function)
], CustomNodeViewBase.prototype, "deleteNode", void 0);
CustomNodeViewBase = _([
    Component
], CustomNodeViewBase);

IconRegistry.add({
    mdiDrag,
    mdiPencil,
    mdiDelete
});
class AssetNodeView extends CustomNodeViewBase {
    get friendlyFileType() {
        if (this.asset == null || isNullOrEmpty(this.asset.extension)) {
            return "";
        }
        return this.asset.extension.substring(1).toUpperCase();
    }
    get isImage() {
        if (this.asset == null) {
            return false;
        }
        return isImageContentType(this.asset.contentType);
    }
    get url() {
        return this.attributes.url;
    }
    get sizeDisplayName() {
        let sizes = container.get("RichtextOptions").assetSizes;
        return sizes.find((s)=>s.name == this.attributes.size)?.displayName ?? "N/A";
    }
    get displayName() {
        return Multilingual.getValue(this.asset?.name) ?? "";
    }
    mounted() {
        this.onUrlChanged();
    }
    async onUrlChanged() {
        try {
            this.state = LoadingState.Loading;
            let selector = IdSelector.fromUrl(this.url);
            if (selector == null || isNullOrEmpty(selector.id)) {
                this.state = LoadingState.NoResults;
                return;
            }
            this.asset = await this.assetService.getHeaders(selector.id);
            this.state = LoadingState.Results;
        } catch (e) {
            this.notificationService.showError("Das Asset konnte nicht geladen werden.", e);
            this.state = LoadingState.Error;
        }
    }
    onEditPaneOk(attrs) {
        this.update(attrs);
        this.isEditPaneOpen = false;
    }
    onEditPaneClear() {
        this.deleteNode();
        this.isEditPaneOpen = false;
    }
    constructor(...args){
        super(...args), this.asset = null, this.isEditPaneOpen = false, this.state = LoadingState.Empty;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetNodeView.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetNodeView.prototype, "assetService", void 0);
_([
    Watch(nameof("url")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", Promise)
], AssetNodeView.prototype, "onUrlChanged", null);
AssetNodeView = _([
    Component({
        render: render$I,
        components: {
            NodeViewWrapper,
            AssetThumbnail,
            AssetNodeEditor
        }
    })
], AssetNodeView);

const TagName$4 = "bluc-asset";
const BlucAsset = Node$3.create({
    name: "blucAsset",
    group: "inline",
    inline: true,
    selectable: true,
    draggable: true,
    addNodeView () {
        return VueNodeViewRenderer(AssetNodeView);
    },
    addAttributes () {
        return {
            url: {
                default: ""
            },
            size: {
                default: null
            },
            textWrap: {
                default: "auto"
            },
            alt: {
                default: null
            },
            caption: {
                default: null
            },
            class: {
                default: null
            },
            interactive: {
                parseHTML: (el)=>el.hasAttribute(nameof("interactive")),
                renderHTML: (attrs)=>{
                    if (attrs.interactive) {
                        return {
                            "interactive": "interactive"
                        };
                    } else {
                        return {};
                    }
                },
                default: false
            },
            link: {
                default: null
            }
        };
    },
    addCommands () {
        return {
            insertAsset: (attrs)=>({ commands, chain })=>{
                    return commands.insertContent({
                        type: this.name,
                        attrs
                    });
                }
        };
    },
    parseHTML () {
        return [
            {
                tag: TagName$4
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            TagName$4,
            HTMLAttributes
        ];
    }
});

const _hoisted_1$t = { class: "ml-2 py-3" };
const _hoisted_2$l = ["href"];

function render$G(_ctx, _cache) {
  const _component_asset_thumbnail = resolveComponent("asset-thumbnail");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_layout = resolveComponent("v-layout");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_chip_group = resolveComponent("v-chip-group");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_asset_list_node_editor = resolveComponent("asset-list-node-editor");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_card = resolveComponent("v-card");
  const _component_node_view_wrapper = resolveComponent("node-view-wrapper");

  return (openBlock(), createBlock(_component_node_view_wrapper, null, {
    default: withCtx(() => [
      createVNode(_component_v_card, {
        variant: "flat",
        color: "surfaceContainer",
        class: "richtext-asset-list richtext-widget richtext-widget--block"
      }, {
        default: withCtx(() => [
          (_ctx.assets.length)
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                (_ctx.containsOnlyImageAssets)
                  ? (openBlock(), createBlock(_component_v_container, {
                      key: 0,
                      fluid: ""
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.assets, (asset) => {
                              return (openBlock(), createBlock(_component_v_col, { cols: "2" }, {
                                default: withCtx(() => [
                                  createVNode(_component_asset_thumbnail, {
                                    asset: asset,
                                    "is-passive": ""
                                  }, null, 8, ["asset"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 256))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (openBlock(), createBlock(_component_v_container, {
                      key: 1,
                      fluid: "",
                      class: "pa-0"
                    }, {
                      default: withCtx(() => [
                        createElementVNode("ul", _hoisted_1$t, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.assets, (asset) => {
                            return (openBlock(), createElementBlock("li", null, [
                              createElementVNode("a", {
                                href: asset.url,
                                target: "_blank"
                              }, toDisplayString(_ctx.$formatters.multilingual(asset.name)) + " (" + toDisplayString(_ctx.getFriendlyFileType(asset)) + ", " + toDisplayString(_ctx.$formatters.bytes(asset.length)) + ")", 9, _hoisted_2$l)
                            ]))
                          }), 256))
                        ])
                      ]),
                      _: 1
                    }))
              ], 64))
            : (openBlock(), createBlock(_component_v_responsive, {
                key: 1,
                "aspect-ratio": 3 / 2,
                color: "gray-lighten-4"
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_layout, {
                    "justify-center": "",
                    "align-center": "",
                    "fill-height": ""
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_progress_circular, { indeterminate: "" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                "data-drag-handle": "",
                class: "drag-handle mr-2"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                ]),
                _: 1
              }),
              createVNode(_component_v_chip_group, null, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.attrs.tags, (tag) => {
                    return (openBlock(), createBlock(_component_v_chip, {
                      label: "",
                      "x-small": ""
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 256))
                ]),
                _: 1
              }),
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                "prepend-icon": _ctx.$icons.mdiPencil,
                color: "primary",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.isEditPaneOpen = true))
              }, {
                default: withCtx(() => _cache[2] || (_cache[2] = [
                  createTextVNode("Bearbeiten")
                ])),
                _: 1
              }, 8, ["prepend-icon"]),
              createVNode(_component_v_btn, {
                variant: "tonal",
                color: "warning",
                icon: _ctx.$icons.mdiDelete,
                onClick: _ctx.deleteNode
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          }),
          (_ctx.isEditPaneOpen)
            ? (openBlock(), createBlock(_component_property_pane, {
                key: 2,
                title: "Asset-Liste",
                "is-active": "",
                "is-clearable": "",
                "initial-value": _ctx.attrs,
                onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isEditPaneOpen = false)),
                onOk: _ctx.onEditPaneOk,
                onClear: _ctx.onEditPaneClear
              }, {
                default: withCtx(({ value, setValue, ok, cancel }) => [
                  createVNode(_component_asset_list_node_editor, {
                    modelValue: value,
                    "onUpdate:modelValue": setValue
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["initial-value", "onOk", "onClear"]))
            : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

function render$F(_ctx, _cache) {
  const _component_v_select = resolveComponent("v-select");
  const _component_v_switch = resolveComponent("v-switch");
  const _component_tag_selector_component = resolveComponent("tag-selector-component");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_v_select, {
      variant: "solo",
      items: _ctx.sizes,
      "item-title": "displayName",
      "item-value": "name",
      label: "Bildgrösse",
      modelValue: _ctx.size,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.size) = $event))
    }, null, 8, ["items", "modelValue"]),
    createVNode(_component_v_switch, {
      inset: "",
      color: "primary",
      label: "Bildunterschriften anzeigen",
      modelValue: _ctx.showCaption,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showCaption) = $event))
    }, null, 8, ["modelValue"]),
    createVNode(_component_tag_selector_component, {
      kind: "asset",
      mode: "edit",
      "thumbnail-columns": 4,
      modelValue: _ctx.selector,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.selector) = $event))
    }, null, 8, ["modelValue"])
  ]))
}

class AssetListNodeEditor extends Vue {
    get sizes() {
        return container.get("RichtextOptions").assetSizes;
    }
    get size() {
        return this.value?.size;
    }
    set size(value) {
        this.emitInput({
            size: value ?? this.sizes[0].name
        });
    }
    get showCaption() {
        return this.value?.showCaption;
    }
    set showCaption(value) {
        this.emitInput({
            showCaption: value ?? false
        });
    }
    get selector() {
        return {
            tags: this.value?.tags ?? [],
            orderedIds: this.value?.orderedIds ?? [],
            kind: EntityKind.Asset
        };
    }
    set selector(value) {
        this.emitInput({
            tags: value.tags,
            orderedIds: value.orderedIds
        });
    }
    emitInput(attrs) {
        let args = Object.assign({}, this.value, attrs);
        this.$emit("update:modelValue", args);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetListNodeEditor.prototype, "notificationService", void 0);
_([
    Model(),
    _$1("design:type", typeof AssetListAttrs === "undefined" ? Object : AssetListAttrs)
], AssetListNodeEditor.prototype, "value", void 0);
AssetListNodeEditor = _([
    Component({
        render: render$F
    })
], AssetListNodeEditor);

IconRegistry.add({
    mdiDrag,
    mdiPencil,
    mdiDelete
});
class AssetListNodeView extends CustomNodeViewBase {
    get containsOnlyImageAssets() {
        return this.assets.length > 0 && this.assets.every((a)=>isImageContentType(a.contentType));
    }
    get attrs() {
        return this.node.attrs;
    }
    mounted() {
        this.onAttrsTagsChanged();
    }
    async onAttrsTagsChanged() {
        try {
            let assets = await this.assetService.search({
                tags: this.attrs.tags
            });
            this.assets = sortByOrderedIds(assets, this.attrs.orderedIds, (asset)=>asset.id);
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError("Die Assets konnten nicht geladen werden.", e);
            } else {
                throw e;
            }
        }
    }
    getFriendlyFileType(asset) {
        if (asset == null || isNullOrEmpty(asset.extension)) {
            return "";
        }
        return asset.extension.substring(1).toUpperCase();
    }
    onEditPaneOk(attrs) {
        this.update(attrs);
        this.isEditPaneOpen = false;
    }
    onEditPaneClear() {
        this.deleteNode();
        this.isEditPaneOpen = false;
    }
    constructor(...args){
        super(...args), this.assets = [], this.isEditPaneOpen = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetListNodeView.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetListNodeView.prototype, "assetService", void 0);
_([
    Watch("attrs.tags"),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", Promise)
], AssetListNodeView.prototype, "onAttrsTagsChanged", null);
AssetListNodeView = _([
    Component({
        render: render$G,
        components: {
            NodeViewWrapper,
            AssetThumbnail,
            AssetListNodeEditor
        }
    })
], AssetListNodeView);

const TagName$3 = "bluc-asset-list";
const BlucAssetList = Node$3.create({
    name: "blucAssetList",
    group: "block",
    selectable: true,
    draggable: true,
    addNodeView () {
        return VueNodeViewRenderer(AssetListNodeView);
    },
    addAttributes () {
        return {
            tags: {
                default: [],
                parseHTML: (element)=>{
                    // parse tags from space-separated, url-encoded values
                    let rawValue = element.getAttribute("tags");
                    if (isNullOrEmpty(rawValue)) {
                        return [];
                    }
                    return rawValue.split(" ").map((s)=>s.trim()).map(decodeURIComponent);
                },
                renderHTML: (attrs)=>{
                    return {
                        tags: attrs.tags.map(encodeURIComponent).join(" ")
                    };
                }
            },
            orderedIds: {
                default: [],
                parseHTML: (element)=>{
                    let rawValue = element.getAttribute("ordered-ids");
                    if (isNullOrEmpty(rawValue)) {
                        return [];
                    }
                    return rawValue.split(" ").map((s)=>s.trim());
                },
                renderHTML: (attrs)=>{
                    return {
                        "ordered-ids": attrs.orderedIds.join(" ")
                    };
                }
            },
            showCaption: {
                default: false
            },
            size: {
                default: null
            }
        };
    },
    addCommands () {
        return {
            insertAssetList: (attrs)=>({ commands, chain })=>{
                    return commands.insertContent({
                        type: this.name,
                        attrs
                    });
                }
        };
    },
    parseHTML () {
        return [
            {
                tag: TagName$3
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            TagName$3,
            HTMLAttributes
        ];
    }
});

const _hoisted_1$s = ["innerHTML"];
const _hoisted_2$k = { class: "text-caption text-truncate mr-2" };

function render$E(_ctx, _cache) {
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_embed_node_editor = resolveComponent("embed-node-editor");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_card = resolveComponent("v-card");
  const _component_node_view_wrapper = resolveComponent("node-view-wrapper");

  return (openBlock(), createBlock(_component_node_view_wrapper, null, {
    default: withCtx(() => [
      createVNode(_component_v_card, {
        variant: "flat",
        color: "surfaceContainer",
        class: "richtext-embed richtext-widget richtext-widget--block",
        "max-width": 500
      }, {
        default: withCtx(() => [
          createVNode(_component_v_responsive, { "aspect-ratio": _ctx.aspectRatio }, {
            default: withCtx(() => [
              createElementVNode("div", { innerHTML: _ctx.embedHtml }, null, 8, _hoisted_1$s)
            ]),
            _: 1
          }, 8, ["aspect-ratio"]),
          createVNode(_component_v_divider),
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                "data-drag-handle": "",
                class: "drag-handle mr-2"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                ]),
                _: 1
              }),
              createElementVNode("div", _hoisted_2$k, toDisplayString(_ctx.attributes.url), 1),
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                "prepend-icon": _ctx.$icons.mdiPencil,
                color: "primary",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.isEditPaneOpen = true))
              }, {
                default: withCtx(() => _cache[2] || (_cache[2] = [
                  createTextVNode("Bearbeiten")
                ])),
                _: 1
              }, 8, ["prepend-icon"]),
              createVNode(_component_v_btn, {
                variant: "tonal",
                color: "warning",
                icon: _ctx.$icons.mdiDelete,
                onClick: _ctx.deleteNode
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          }),
          (_ctx.isEditPaneOpen)
            ? (openBlock(), createBlock(_component_property_pane, {
                key: 0,
                title: "Embed",
                "is-active": "",
                "is-clearable": "",
                "initial-value": {..._ctx.attributes, embedHtml: _ctx.embedHtml},
                onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isEditPaneOpen = false)),
                onOk: _ctx.onEditPaneOk,
                onClear: _ctx.onEditPaneClear
              }, {
                default: withCtx(({ value, setValue, ok, cancel }) => [
                  createVNode(_component_embed_node_editor, {
                    modelValue: value,
                    "onUpdate:modelValue": setValue
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["initial-value", "onOk", "onClear"]))
            : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

const _hoisted_1$r = ["innerHTML"];

function render$D(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_card = resolveComponent("v-card");
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createBlock(_component_v_card, null, {
    default: withCtx(() => [
      createVNode(_component_v_card_text, null, {
        default: withCtx(() => [
          (_ctx.hasValue)
            ? (openBlock(), createBlock(_component_v_text_field, {
                key: 0,
                label: "Adresse (URL)",
                onBlur: _ctx.loadEmbed,
                loading: _ctx.isLoading,
                modelValue: _ctx.url,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.url) = $event))
              }, {
                "append-inner": withCtx(() => [
                  withDirectives(createVNode(_component_v_btn, {
                    color: "primary",
                    size: "small",
                    variant: "tonal",
                    icon: _ctx.$icons.mdiCloudDownloadOutline,
                    onClick: _ctx.loadEmbed
                  }, null, 8, ["icon", "onClick"]), [
                    [_directive_tooltip, 'Embed abrufen', "bottom"]
                  ])
                ]),
                _: 1
              }, 8, ["onBlur", "loading", "modelValue"]))
            : createCommentVNode("", true)
        ]),
        _: 1
      }),
      createVNode(_component_v_responsive, { "aspect-ratio": 16/9 }, {
        default: withCtx(() => [
          createVNode(_component_v_overlay, {
            contained: "",
            class: "align-center justify-center",
            modelValue: _ctx.isLoading
          }, {
            default: withCtx(() => [
              createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: "64"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (!_ctx.hasValue)
            ? (openBlock(), createBlock(_component_v_empty_state, {
                key: 0,
                class: "v-empty-state--actions-stretched",
                icon: _ctx.$icons.mdiMultimedia,
                color: "outlineVariant",
                loading: _ctx.isLoading
              }, {
                actions: withCtx(() => [
                  createVNode(_component_v_text_field, {
                    label: "Adresse (URL)",
                    modelValue: _ctx.url,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.url) = $event))
                  }, {
                    "append-inner": withCtx(() => [
                      createVNode(_component_v_btn, {
                        color: "primary",
                        size: "small",
                        variant: "tonal",
                        "icon-prepend": _ctx.$icons.mdiCloudDownloadOutline,
                        loading: _ctx.isLoading,
                        onClick: _ctx.loadEmbed
                      }, {
                        default: withCtx(() => _cache[2] || (_cache[2] = [
                          createTextVNode("Embed abrufen")
                        ])),
                        _: 1
                      }, 8, ["icon-prepend", "loading", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["icon", "loading"]))
            : (openBlock(), createElementBlock("div", {
                key: 1,
                innerHTML: _ctx.embedHtml
              }, null, 8, _hoisted_1$r))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

class EmbedService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "embeds"), middlewareFactory, snackbarService);
    }
    async getEmbed(url) {
        let params = {
            url
        };
        let data = await this.client.get("", {
            searchParams: queryString.stringify(params)
        }).json();
        return data;
    }
}
EmbedService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], EmbedService);

IconRegistry.add({
    mdiCloudDownloadOutline,
    mdiMultimedia
});
class EmbedNodeEditor extends Vue {
    get hasValue() {
        return !isNullOrEmpty(this.embedHtml);
    }
    onValueUpdated() {
        if (this.value == null) {
            return;
        }
        this.url = this.value.url;
        this.embedHtml = this.value.embedHtml;
    }
    mounted() {
        this.onValueUpdated();
    }
    async loadEmbed() {
        if (isNullOrEmpty(this.url) || this.isLoading) {
            return;
        }
        try {
            this.isLoading = true;
            let response = await this.embedService.getEmbed(this.url);
            // just try to access thumbnail and aspect ratio and let the catch block handle any nullrefs
            this.embedHtml = response?.embedHtml;
            let args = {
                url: response.url,
                title: response.title ?? "Video",
                description: response.description,
                thumbnailUrl: response.thumbnailUrl,
                aspectRatio: response.aspectRatio,
                embedHtml: response.embedHtml
            };
            this.$emit("update:modelValue", args);
        } catch (e) {
            this.notificationService.showError("Das Embed konnte nicht geladen werden.", e);
        } finally{
            this.isLoading = false;
        }
    }
    constructor(...args){
        super(...args), this.isLoading = false, this.url = "", this.embedHtml = "";
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], EmbedNodeEditor.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof EmbedService === "undefined" ? Object : EmbedService)
], EmbedNodeEditor.prototype, "embedService", void 0);
_([
    Model(),
    _$1("design:type", typeof EmbedEditModel === "undefined" ? Object : EmbedEditModel)
], EmbedNodeEditor.prototype, "value", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], EmbedNodeEditor.prototype, "onValueUpdated", null);
EmbedNodeEditor = _([
    Component({
        render: render$D,
        components: {}
    })
], EmbedNodeEditor);

IconRegistry.add({
    mdiDrag,
    mdiPencil,
    mdiDelete
});
class EmbedNodeView extends CustomNodeViewBase {
    get aspectRatio() {
        return this.node.attrs.aspectRatio;
    }
    async mounted() {
        let cached = this.extension.storage.embeds.get(this.attributes.url);
        if (cached != null) {
            this.embedHtml = cached.html;
        } else {
            try {
                let response = await this.embedService.getEmbed(this.attributes.url);
                this.embedHtml = response.embedHtml;
                this.extension.storage.embeds.set(this.attributes.url, {
                    html: response.embedHtml
                });
            } catch (e) {
                this.notificationService.showError(`Beim Abrufen der Adresse '${this.attributes.url}' ist ein Fehler aufgetreten.`, e);
            }
        }
    }
    onEditPaneOk(args) {
        this.embedHtml = args.embedHtml;
        this.update(args);
        this.isEditPaneOpen = false;
    }
    onEditPaneClear() {
        this.deleteNode();
        this.isEditPaneOpen = false;
    }
    constructor(...args){
        super(...args), this.isEditPaneOpen = false, this.embedHtml = null;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], EmbedNodeView.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof EmbedService === "undefined" ? Object : EmbedService)
], EmbedNodeView.prototype, "embedService", void 0);
EmbedNodeView = _([
    Component({
        render: render$E,
        components: {
            NodeViewWrapper,
            EmbedNodeEditor
        }
    })
], EmbedNodeView);

const TagName$2 = "bluc-embed";
const BlucEmbed = Node$3.create({
    name: "blucEmbed",
    group: "block",
    selectable: true,
    draggable: true,
    content: "block*",
    atom: true,
    addNodeView () {
        return VueNodeViewRenderer(EmbedNodeView);
    },
    addAttributes () {
        return {
            url: {
                default: ""
            },
            title: {
                default: ""
            },
            description: {
                default: ""
            },
            thumbnailUrl: {
                default: ""
            },
            aspectRatio: {
                default: 1.77,
                parseHTML: (element)=>{
                    try {
                        return parseFloat(element.getAttribute("aspect") || "1.77");
                    } catch (e) {
                        return 1.77;
                    }
                }
            }
        };
    },
    addStorage () {
        return {
            embeds: new Map()
        };
    },
    addCommands () {
        return {
            insertEmbed: (attrs)=>({ commands })=>{
                    return commands.insertContent({
                        type: this.name,
                        attrs
                    });
                }
        };
    },
    parseHTML () {
        return [
            {
                tag: TagName$2
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            TagName$2,
            HTMLAttributes
        ];
    }
});

const _hoisted_1$q = {
  class: "richtext-map__map h-100",
  ref: "map"
};
const _hoisted_2$j = { class: "text-caption text-truncate mr-2" };

function render$C(_ctx, _cache) {
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_map_node_editor = resolveComponent("map-node-editor");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_card = resolveComponent("v-card");
  const _component_node_view_wrapper = resolveComponent("node-view-wrapper");

  return (openBlock(), createBlock(_component_node_view_wrapper, null, {
    default: withCtx(() => [
      createVNode(_component_v_card, {
        variant: "flat",
        color: "surfaceContainer",
        class: "richtext-map richtext-widget richtext-widget--block",
        "max-width": 500
      }, {
        default: withCtx(() => [
          createVNode(_component_v_responsive, { "aspect-ratio": 3 / 2 }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$q, null, 512)
            ]),
            _: 1
          }),
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                "data-drag-handle": "",
                class: "drag-handle mr-2"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                ]),
                _: 1
              }),
              createElementVNode("div", _hoisted_2$j, [
                _cache[2] || (_cache[2] = createElementVNode("em", null, "Koordinaten", -1)),
                createTextVNode(": " + toDisplayString(_ctx.latitude) + ", " + toDisplayString(_ctx.longitude) + ", ", 1),
                _cache[3] || (_cache[3] = createElementVNode("em", null, "Zoom", -1)),
                createTextVNode(": " + toDisplayString(_ctx.zoom), 1)
              ]),
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                "prepend-icon": _ctx.$icons.mdiPencil,
                color: "primary",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.isEditPaneOpen = true))
              }, {
                default: withCtx(() => _cache[4] || (_cache[4] = [
                  createTextVNode("Bearbeiten")
                ])),
                _: 1
              }, 8, ["prepend-icon"]),
              createVNode(_component_v_btn, {
                variant: "tonal",
                color: "warning",
                icon: _ctx.$icons.mdiDelete,
                onClick: _ctx.deleteNode
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          }),
          (_ctx.isEditPaneOpen)
            ? (openBlock(), createBlock(_component_property_pane, {
                key: 0,
                title: "Karte",
                "is-active": "",
                "is-clearable": "",
                "initial-value": _ctx.attributes,
                onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isEditPaneOpen = false)),
                onOk: _ctx.onEditPaneOk,
                onClear: _ctx.onEditPaneClear
              }, {
                default: withCtx(({ value, setValue, ok, cancel }) => [
                  createVNode(_component_map_node_editor, {
                    modelValue: value,
                    "onUpdate:modelValue": setValue
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["initial-value", "onOk", "onClear"]))
            : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

function render$B(_ctx, _cache) {
  const _component_geo_json_point_picker = resolveComponent("geo-json-point-picker");
  const _component_v_switch = resolveComponent("v-switch");

  return (openBlock(), createElementBlock("div", null, [
    createVNode(_component_geo_json_point_picker, {
      "show-map": "",
      zoom: _ctx.zoom,
      onZoom: _ctx.zoomChanged,
      modelValue: _ctx.point,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.point) = $event))
    }, null, 8, ["zoom", "onZoom", "modelValue"]),
    createVNode(_component_v_switch, {
      color: "primary",
      inset: "",
      "persistent-hint": "",
      label: "Marker anzeigen",
      modelValue: _ctx.showMarker,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showMarker) = $event))
    }, null, 8, ["modelValue"])
  ]))
}

class MapNodeEditor extends Vue {
    get showMarker() {
        if (this.value == null) {
            return true;
        }
        return !this.value.hidemarker;
    }
    set showMarker(value) {
        this.emitInput({
            hidemarker: !value
        });
    }
    get point() {
        return {
            type: "Point",
            coordinates: [
                this.value?.longitude ?? 8.4,
                this.value?.latitude ?? 46.8
            ]
        };
    }
    set point(value) {
        this.emitInput({
            address: this.address,
            latitude: value.coordinates[1],
            longitude: value.coordinates[0]
        });
    }
    get address() {
        return this.value?.address;
    }
    set address(value) {
        this.emitInput({
            address: value
        });
    }
    get zoom() {
        return this.value?.zoom || 12;
    }
    zoomChanged(zoom) {
        this.value.zoom = zoom;
        this.emitInput({
            zoom
        });
    }
    emitInput(attrs) {
        let args = Object.assign({}, this.value, attrs);
        this.$emit("update:modelValue", args);
    }
}
_([
    Model(),
    _$1("design:type", typeof MapAttrs === "undefined" ? Object : MapAttrs)
], MapNodeEditor.prototype, "value", void 0);
MapNodeEditor = _([
    Component({
        render: render$B
    })
], MapNodeEditor);

IconRegistry.add({
    mdiDrag,
    mdiPencil,
    mdiDelete
});
class MapNodeView extends CustomNodeViewBase {
    get latitude() {
        return this.attributes.latitude;
    }
    get longitude() {
        return this.attributes.longitude;
    }
    get address() {
        return this.attributes.address;
    }
    get zoom() {
        return this.attributes.zoom;
    }
    mounted() {
        this.marker = new mapboxgl.Marker();
        this.marker.setLngLat([
            this.longitude,
            this.latitude
        ]);
        this.map = new mapboxgl.Map({
            accessToken: this.configStore.configuration.appSettings["MapboxAccessToken"],
            container: this.$refs.map,
            style: "mapbox://styles/mapbox/streets-v12",
            center: [
                this.longitude,
                this.latitude
            ],
            zoom: this.zoom,
            scrollZoom: false,
            touchZoomRotate: false,
            dragPan: false,
            boxZoom: false
        });
        this.marker.addTo(this.map);
        this.$nextTick(()=>this.map.resize());
    }
    onEditPaneOk(attrs) {
        this.update(attrs);
        this.isEditPaneOpen = false;
        if (this.map != null) {
            this.map.setZoom(this.zoom);
            this.map.setCenter([
                this.longitude,
                this.latitude
            ]);
        }
        if (this.marker != null) {
            this.marker.setLngLat([
                this.longitude,
                this.latitude
            ]);
        }
    }
    onEditPaneClear() {
        this.deleteNode();
        this.isEditPaneOpen = false;
    }
    constructor(...args){
        super(...args), this.configStore = new ConfigurationModule(), this.isEditPaneOpen = false;
    }
}
_([
    NonReactive
], MapNodeView.prototype, "configStore", void 0);
_([
    NonReactive,
    _$1("design:type", typeof mapboxgl === "undefined" || typeof mapboxgl.Map === "undefined" ? Object : mapboxgl.Map)
], MapNodeView.prototype, "map", void 0);
_([
    NonReactive,
    _$1("design:type", typeof mapboxgl === "undefined" || typeof mapboxgl.Marker === "undefined" ? Object : mapboxgl.Marker)
], MapNodeView.prototype, "marker", void 0);
MapNodeView = _([
    Component({
        render: render$C,
        components: {
            NodeViewWrapper,
            MapNodeEditor
        }
    })
], MapNodeView);

const TagName$1 = "bluc-map";
const BlucMap = Node$3.create({
    name: "blucMap",
    group: "block",
    selectable: true,
    draggable: true,
    addNodeView () {
        return VueNodeViewRenderer(MapNodeView);
    },
    addAttributes () {
        return {
            latitude: {
                default: 46.8,
                parseHTML: (element)=>{
                    try {
                        return parseFloat(element.getAttribute("latitude"));
                    } catch (e) {
                        return 46.8;
                    }
                }
            },
            longitude: {
                default: 8.4,
                parseHTML: (element)=>{
                    try {
                        return parseFloat(element.getAttribute("longitude"));
                    } catch (e) {
                        return 8.4;
                    }
                }
            },
            zoom: {
                default: 11,
                parseHTML: (element)=>{
                    try {
                        return parseFloat(element.getAttribute("zoom"));
                    } catch (e) {
                        return 11;
                    }
                }
            },
            hidemarker: {
                default: false,
                parseHTML: (element)=>{
                    try {
                        return element.hasAttribute("hidemarker");
                    } catch (e) {
                        return false;
                    }
                },
                renderHTML: (attrs)=>{
                    if (attrs.hidemarker) {
                        return {
                            "hidemarker": "hidemarker"
                        };
                    } else {
                        return {};
                    }
                }
            },
            address: {
                default: null
            }
        };
    },
    addCommands () {
        return {
            insertMap: (attrs)=>({ commands })=>{
                    return commands.insertContent({
                        type: this.name,
                        attrs
                    });
                }
        };
    },
    parseHTML () {
        return [
            {
                tag: TagName$1
            }
        ];
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            TagName$1,
            HTMLAttributes
        ];
    }
});

const _hoisted_1$p = {
  key: 0,
  class: "mb-4"
};

function render$A(_ctx, _cache) {
  const _component_color_picker = resolveComponent("color-picker");
  const _component_url_picker = resolveComponent("url-picker");

  return (openBlock(), createElementBlock("div", null, [
    (_ctx.colors.length > 0)
      ? (openBlock(), createElementBlock("div", _hoisted_1$p, [
          createVNode(_component_color_picker, {
            colors: _ctx.colors,
            modelValue: _ctx.selectedColor,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedColor) = $event))
          }, null, 8, ["colors", "modelValue"])
        ]))
      : createCommentVNode("", true),
    createVNode(_component_url_picker, {
      modelValue: _ctx.url,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.url) = $event))
    }, null, 8, ["modelValue"])
  ]))
}

IconRegistry.add({
    mdiRadioboxBlank,
    mdiRadioboxMarked
});
class ButtonNodeEditor extends Vue {
    get colors() {
        return container.get("RichtextOptions").colors;
    }
    get selectedColor() {
        return this.colors.find((c)=>c.name === this.value?.color) ?? this.colors[0];
    }
    set selectedColor(value) {
        this.emitInput({
            color: value.name
        });
    }
    get url() {
        return this.value?.href;
    }
    set url(value) {
        this.emitInput({
            href: value
        });
    }
    emitInput(attrs) {
        let args = Object.assign({}, this.value, attrs);
        if (!deepequals(args, this.value)) {
            this.$emit("update:modelValue", args);
        }
    }
}
_([
    Model(),
    _$1("design:type", typeof BlucButtonOptions === "undefined" ? Object : BlucButtonOptions)
], ButtonNodeEditor.prototype, "value", void 0);
ButtonNodeEditor = _([
    Component({
        render: render$A,
        components: {
            UrlPicker,
            ColorPicker
        }
    })
], ButtonNodeEditor);

const TagName = "bluc-button";
const BlucButton = Node$3.create({
    name: "blucButton",
    inline: true,
    group: "inline",
    content: "text*",
    addAttributes () {
        return {
            color: {
                default: "primary"
            },
            href: {
                default: "#"
            }
        };
    },
    renderHTML ({ HTMLAttributes }) {
        return [
            TagName,
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    parseHTML () {
        return [
            {
                tag: TagName
            }
        ];
    },
    addCommands () {
        return {
            setBlucButton: (attributes)=>({ commands, state, editor })=>{
                    if (editor.isActive(this.name)) {
                        return commands.updateAttributes(this.name, attributes);
                    } else {
                        let selectedText = state.doc.textBetween(state.selection.from, state.selection.to);
                        return commands.insertContent({
                            type: this.name,
                            attrs: attributes,
                            content: [
                                {
                                    type: "text",
                                    text: selectedText
                                }
                            ]
                        });
                    }
                },
            unsetBlucButton: ()=>({ commands, state, chain })=>{
                    let selectedText = state.doc.textBetween(state.selection.from, state.selection.to);
                    return chain().deleteNode(this.name).insertContent({
                        type: "text",
                        text: selectedText
                    }).run();
                }
        };
    },
    addNodeView () {
        return ({ node })=>{
            let wrapper = document.createElement("a");
            wrapper.className = "v-btn v-btn--density-default v-btn--size-default v-btn--variant-flat";
            wrapper.style.cursor = "text";
            let colors = container.get("RichtextOptions").colors;
            let color = colors.find((c)=>c.name === node.attrs["color"]);
            wrapper.style.backgroundColor = color?.value ?? "";
            wrapper.style.color = color?.invertValue ?? "";
            let content = document.createElement("span");
            content.classList.add("v-btn__content");
            wrapper.appendChild(content);
            return {
                dom: wrapper,
                contentDOM: content
            };
        };
    }
});

const _hoisted_1$o = { class: "richtext-editor" };
const _hoisted_2$i = { class: "richtext-editor__toolbar-wrapper" };
const _hoisted_3$h = { class: "richtext-editor__toolbar" };
const _hoisted_4$7 = { id: "tableToolbar" };
const _hoisted_5$6 = { key: 0 };
const _hoisted_6$4 = { key: 1 };
const _hoisted_7$4 = { key: 0 };
const _hoisted_8$3 = { key: 1 };

function render$z(_ctx, _cache) {
  const _component_v_select = resolveComponent("v-select");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_url_picker = resolveComponent("url-picker");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_button_node_editor = resolveComponent("button-node-editor");
  const _component_asset_node_editor = resolveComponent("asset-node-editor");
  const _component_asset_list_node_editor = resolveComponent("asset-list-node-editor");
  const _component_embed_node_editor = resolveComponent("embed-node-editor");
  const _component_map_node_editor = resolveComponent("map-node-editor");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_editor_content = resolveComponent("editor-content");
  const _component_v_textarea = resolveComponent("v-textarea");
  const _component_v_btn_toggle = resolveComponent("v-btn-toggle");
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createElementBlock("div", _hoisted_1$o, [
    createElementVNode("div", _hoisted_2$i, [
      createElementVNode("div", _hoisted_3$h, [
        (_ctx.isInitialized)
          ? (openBlock(), createBlock(_component_v_toolbar, {
              key: 0,
              density: "compact",
              color: "surface-light"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_select, {
                  "hide-details": "",
                  "return-object": "",
                  density: "comfortable",
                  "bg-color": "transparent",
                  label: "Normaler Text",
                  "single-line": "",
                  items: _ctx.formatItems,
                  disabled: !_ctx.isGraphicalUiEnabled,
                  "onUpdate:modelValue": [
                    _ctx.setParagraphFormat,
                    _cache[0] || (_cache[0] = $event => ((_ctx.selectionFormat) = $event))
                  ],
                  modelValue: _ctx.selectionFormat
                }, null, 8, ["items", "disabled", "onUpdate:modelValue", "modelValue"]),
                createVNode(_component_v_divider, {
                  vertical: "",
                  inset: "",
                  class: "mx-2"
                }),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatBold,
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.editor.chain().focus().toggleBold().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('bold'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Fett', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatItalic,
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.editor.chain().focus().toggleItalic().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('italic'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Kursiv', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatSubscript,
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.editor.chain().focus().toggleSubscript().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('subscript'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Tiefgestellt', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatSuperscript,
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.editor.chain().focus().toggleSuperscript().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('superscript'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Hochgestellt', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.editor.isActive('link') ? _ctx.$icons.mdiLinkOff : _ctx.$icons.mdiLink,
                  value: true,
                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.paneOpenStates['link'] = true)),
                  "input-value": _ctx.editor.isActive('link'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Link', "bottom"]
                ]),
                (_ctx.paneOpenStates['link'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 0,
                      title: `Link ${_ctx.editor.isActive('link') ? 'bearbeiten' : 'einfügen'}`,
                      "is-clearable": _ctx.editor.isActive('link'),
                      "is-active": true,
                      "initial-value": _ctx.editor.getAttributes('link') != null ? _ctx.editor.getAttributes('link').href : null,
                      onCancel: _cache[6] || (_cache[6] = $event => (_ctx.paneOpenStates['link'] = false)),
                      onClear: _cache[7] || (_cache[7] = $event => {_ctx.paneOpenStates['link'] = false; _ctx.editor.chain().focus().extendMarkRange('link').unsetLink().run();}),
                      onOk: _cache[8] || (_cache[8] = $event => {_ctx.paneOpenStates['link'] = false; _ctx.editor.chain().focus().extendMarkRange('link').setLink({ href: $event }).run();}),
                      disabled: !_ctx.isGraphicalUiEnabled
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_url_picker, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["title", "is-clearable", "initial-value", "disabled"]))
                  : createCommentVNode("", true),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.editor.isActive('blucButton') ? _ctx.$icons.customButtonCursorOff : _ctx.$icons.mdiButtonCursor,
                  value: true,
                  onClick: _cache[9] || (_cache[9] = $event => (_ctx.paneOpenStates['button'] = true)),
                  "input-value": _ctx.editor.isActive('blucButton'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Button', "bottom"]
                ]),
                (_ctx.paneOpenStates['button'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 1,
                      title: `Button ${_ctx.editor.isActive('blucButton') ? 'bearbeiten' : 'einfügen'}`,
                      "is-clearable": _ctx.editor.isActive('blucButton'),
                      "is-active": true,
                      "initial-value": _ctx.editor.getAttributes('blucButton') != null ? _ctx.editor.getAttributes('blucButton') : null,
                      onCancel: _cache[10] || (_cache[10] = $event => (_ctx.paneOpenStates['button'] = false)),
                      onClear: _cache[11] || (_cache[11] = $event => {_ctx.paneOpenStates['button'] = false; _ctx.editor.chain().focus().unsetBlucButton().run();}),
                      onOk: _cache[12] || (_cache[12] = $event => {_ctx.paneOpenStates['button'] = false; _ctx.editor.chain().focus().setBlucButton($event).run();}),
                      disabled: !_ctx.isGraphicalUiEnabled
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_button_node_editor, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["title", "is-clearable", "initial-value", "disabled"]))
                  : createCommentVNode("", true),
                createVNode(_component_v_divider, {
                  vertical: "",
                  inset: "",
                  class: "mx-2"
                }),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatListBulleted,
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.editor.chain().focus().toggleBulletList().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('bulletList'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Aufzählung', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiFormatListNumbered,
                  onClick: _cache[14] || (_cache[14] = $event => (_ctx.editor.chain().focus().toggleOrderedList().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('orderedList'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Nummerierte Liste', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiCommentQuote,
                  onClick: _cache[15] || (_cache[15] = $event => (_ctx.editor.chain().focus().toggleBlockquote().run())),
                  value: true,
                  "input-value": _ctx.editor.isActive('blockquote'),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "input-value", "disabled"]), [
                  [_directive_tooltip, 'Zitat', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiTablePlus,
                  onClick: _cache[16] || (_cache[16] = $event => (_ctx.editor.chain().focus().insertTable({rows: 3, cols: 3, withHeaderRow: true }).run())),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "disabled"]), [
                  [_directive_tooltip, 'Tabelle einfügen', "bottom"]
                ]),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiImagePlus,
                  onClick: _cache[17] || (_cache[17] = $event => (_ctx.paneOpenStates['asset'] = true)),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "disabled"]), [
                  [_directive_tooltip, 'Asset einfügen', "bottom"]
                ]),
                (_ctx.paneOpenStates['asset'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 2,
                      title: "Asset",
                      "is-active": "",
                      onCancel: _cache[18] || (_cache[18] = $event => (_ctx.paneOpenStates['asset'] = false)),
                      "initial-value": null,
                      onOk: _cache[19] || (_cache[19] = $event => {_ctx.paneOpenStates['asset'] = false;_ctx.editor.chain().focus().insertAsset($event).run();})
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_asset_node_editor, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.customImageMultiplePlus,
                  onClick: _cache[20] || (_cache[20] = $event => (_ctx.paneOpenStates['assetList'] = true)),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "disabled"]), [
                  [_directive_tooltip, 'Asset-Liste (Galerie) einfügen', "bottom"]
                ]),
                (_ctx.paneOpenStates['assetList'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 3,
                      title: "Asset-Liste (Galerie)",
                      "is-active": "",
                      onCancel: _cache[21] || (_cache[21] = $event => (_ctx.paneOpenStates['assetList'] = false)),
                      "initial-value": null,
                      onOk: _cache[22] || (_cache[22] = $event => {_ctx.paneOpenStates['assetList'] = false;_ctx.editor.chain().focus().insertAssetList($event).run();})
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_asset_list_node_editor, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.customYoutubePlus,
                  onClick: _cache[23] || (_cache[23] = $event => (_ctx.paneOpenStates['embed'] = true)),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "disabled"]), [
                  [_directive_tooltip, 'Embed einfügen (YouTube etc.)', "bottom"]
                ]),
                (_ctx.paneOpenStates['embed'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 4,
                      title: "Embed",
                      "is-active": "",
                      onCancel: _cache[24] || (_cache[24] = $event => (_ctx.paneOpenStates['embed'] = false)),
                      "initial-value": null,
                      onOk: _cache[25] || (_cache[25] = $event => {_ctx.paneOpenStates['embed'] = false;_ctx.editor.chain().focus().insertEmbed($event).run();})
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_embed_node_editor, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiMapPlus,
                  onClick: _cache[26] || (_cache[26] = $event => (_ctx.paneOpenStates['map'] = true)),
                  disabled: !_ctx.isGraphicalUiEnabled
                }, null, 8, ["icon", "disabled"]), [
                  [_directive_tooltip, 'Karte einfügen', "bottom"]
                ]),
                (_ctx.paneOpenStates['map'])
                  ? (openBlock(), createBlock(_component_property_pane, {
                      key: 5,
                      title: "Karte",
                      "is-active": "",
                      onCancel: _cache[27] || (_cache[27] = $event => (_ctx.paneOpenStates['map'] = false)),
                      "initial-value": null,
                      onOk: _cache[28] || (_cache[28] = $event => {_ctx.paneOpenStates['map'] = false;_ctx.editor.chain().focus().insertMap($event).run();})
                    }, {
                      default: withCtx(({ value, setValue, ok, cancel }) => [
                        createVNode(_component_map_node_editor, {
                          modelValue: value,
                          "onUpdate:modelValue": setValue
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                (_ctx.customElements.length > 0)
                  ? (openBlock(), createBlock(_component_v_divider, {
                      key: 6,
                      vertical: "",
                      inset: "",
                      class: "mx-2"
                    }))
                  : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.customElementsForToolbar, (item) => {
                  return withDirectives((openBlock(), createBlock(_component_v_btn, {
                    icon: item.iconSvg,
                    onClick: $event => (_ctx.createCustomElement(item)),
                    disabled: !_ctx.isGraphicalUiEnabled
                  }, null, 8, ["icon", "onClick", "disabled"])), [
                    [_directive_tooltip, item.name, "bottom"]
                  ])
                }), 256)),
                (_ctx.customElementsForMenu.length > 0)
                  ? (openBlock(), createBlock(_component_v_menu, {
                      key: 7,
                      "offset-y": ""
                    }, {
                      activator: withCtx(({ on: menu, attrs }) => [
                        createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: withCtx(({ on: tooltip }) => [
                            createVNode(_component_v_btn, mergeProps({
                              class: "v-btn--icon",
                              depressed: ""
                            }, toHandlers({ ...menu, ...tooltip }), attrs, {
                              disabled: !_ctx.isGraphicalUiEnabled
                            }), {
                              default: withCtx(() => [
                                createVNode(_component_v_icon, null, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(_ctx.$icons.customWidgetsPlus), 1)
                                  ]),
                                  _: 1
                                }),
                                createVNode(_component_v_icon, null, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(_ctx.$icons.mdiMenuDown), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1040, ["disabled"])
                          ]),
                          default: withCtx(() => [
                            _cache[41] || (_cache[41] = createElementVNode("span", null, "Benutzerdefiniertes Element einfügen", -1))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: withCtx(() => [
                        createVNode(_component_v_list, null, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.customElements, (item, index) => {
                              return (openBlock(), createBlock(_component_v_list_item, {
                                key: index,
                                onClick: $event => (_ctx.createCustomElement(item))
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_v_list_item_title, null, {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true)
              ]),
              _: 1
            }))
          : createCommentVNode("", true),
        createVNode(_component_v_divider)
      ])
    ]),
    createElementVNode("div", _hoisted_4$7, [
      (_ctx.isInitialized)
        ? (openBlock(), createBlock(_component_v_toolbar, {
            key: 0,
            density: "compact",
            rounded: "",
            color: "grey-lighten-4",
            class: "floating-toolbar floating-toolbar--table"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_toolbar_items, null, {
                default: withCtx(() => [
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        value: true,
                        "input-value": _ctx.editor.getAttributes('tableCell').align == null || _ctx.editor.getAttributes('tableCell').align === 'left',
                        onClick: _cache[29] || (_cache[29] = $event => (_ctx.editor.chain().focus().setCellAttribute('align', 'left').run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiFormatAlignLeft), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040, ["input-value"])
                    ]),
                    default: withCtx(() => [
                      _cache[42] || (_cache[42] = createElementVNode("span", null, "Links ausrichten", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        value: true,
                        "input-value": _ctx.editor.getAttributes('tableCell').align === 'center',
                        onClick: _cache[30] || (_cache[30] = $event => (_ctx.editor.chain().focus().setCellAttribute('align', 'center').run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiFormatAlignCenter), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040, ["input-value"])
                    ]),
                    default: withCtx(() => [
                      _cache[43] || (_cache[43] = createElementVNode("span", null, "Mittig ausrichten", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        value: true,
                        "input-value": _ctx.editor.getAttributes('tableCell').align === 'right',
                        onClick: _cache[31] || (_cache[31] = $event => (_ctx.editor.chain().focus().setCellAttribute('align', 'right').run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiFormatAlignRight), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040, ["input-value"])
                    ]),
                    default: withCtx(() => [
                      _cache[44] || (_cache[44] = createElementVNode("span", null, "Rechts ausrichten", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_divider, {
                    vertical: "",
                    inset: "",
                    class: "mx-2"
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[32] || (_cache[32] = $event => (_ctx.editor.chain().focus().addColumnBefore().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableColumnPlusBefore), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[45] || (_cache[45] = createElementVNode("span", null, "Links anfügen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[33] || (_cache[33] = $event => (_ctx.editor.chain().focus().addColumnAfter().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableColumnPlusAfter), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[46] || (_cache[46] = createElementVNode("span", null, "Rechts anfügen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[34] || (_cache[34] = $event => (_ctx.editor.chain().focus().deleteColumn().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableColumnRemove), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[47] || (_cache[47] = createElementVNode("span", null, "Spalte löschen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_divider, {
                    vertical: "",
                    inset: "",
                    class: "mx-2"
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[35] || (_cache[35] = $event => (_ctx.editor.chain().focus().addRowBefore().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableRowPlusBefore), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[48] || (_cache[48] = createElementVNode("span", null, "Oben anfügen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[36] || (_cache[36] = $event => (_ctx.editor.chain().focus().addRowAfter().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableRowPlusAfter), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[49] || (_cache[49] = createElementVNode("span", null, "Unten anfügen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[37] || (_cache[37] = $event => (_ctx.editor.chain().focus().deleteRow().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableRowRemove), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[50] || (_cache[50] = createElementVNode("span", null, "Zeile löschen", -1))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_divider, {
                    vertical: "",
                    inset: "",
                    class: "mx-2"
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[38] || (_cache[38] = $event => (_ctx.editor.chain().focus().toggleHeaderRow().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableRow), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      (_ctx.editor.isActive('tableHeader'))
                        ? (openBlock(), createElementBlock("span", _hoisted_5$6, "In Tabellenkörperzeile ändern"))
                        : (openBlock(), createElementBlock("span", _hoisted_6$4, "In Kopfzeile ändern"))
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_btn, mergeProps({
                        icon: "",
                        onClick: _cache[39] || (_cache[39] = $event => (_ctx.editor.chain().focus().deleteTable().run()))
                      }, props), {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.$icons.mdiTableRemove), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: withCtx(() => [
                      _cache[51] || (_cache[51] = createElementVNode("span", null, "Tabelle löschen", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : createCommentVNode("", true)
    ]),
    withDirectives(createVNode(_component_editor_content, {
      class: "richtext-editor__content pa-4",
      editor: _ctx.editor
    }, null, 8, ["editor"]), [
      [vShow, _ctx.isGraphicalUiEnabled]
    ]),
    (_ctx.mode === 'text')
      ? (openBlock(), createBlock(_component_v_textarea, {
          key: 0,
          rows: "16",
          class: "richtext-editor__source",
          "hide-details": "",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _ctx.onSourceChanged
        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
      : createCommentVNode("", true),
    createVNode(_component_v_btn_toggle, {
      class: "richtext-editor__source-toggle",
      variant: "text",
      modelValue: _ctx.mode,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => ((_ctx.mode) = $event))
    }, {
      default: withCtx(() => [
        createVNode(_component_v_tooltip, { location: "bottom" }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_btn, mergeProps({ value: "text" }, props), {
              default: withCtx(() => [
                createVNode(_component_v_icon, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.$icons.mdiCodeTags), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040)
          ]),
          default: withCtx(() => [
            (_ctx.mode === 'graphical')
              ? (openBlock(), createElementBlock("span", _hoisted_7$4, "In Quellcode-Modus wechseln"))
              : createCommentVNode("", true),
            (_ctx.mode === 'text')
              ? (openBlock(), createElementBlock("span", _hoisted_8$3, "In Grafik-Modus wechseln"))
              : createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}

IconRegistry.add({
    mdiFormatBold,
    mdiFormatItalic,
    mdiFormatSubscript,
    mdiFormatSuperscript,
    mdiFormatSize,
    mdiLink,
    mdiLinkOff,
    mdiFormatListBulleted,
    mdiFormatListNumbered,
    mdiCommentQuote,
    mdiTablePlus,
    mdiImagePlus,
    mdiMapPlus,
    mdiMenuDown,
    mdiCodeTags,
    mdiFormatAlignLeft,
    mdiFormatAlignCenter,
    mdiFormatAlignRight,
    mdiTableColumn,
    mdiTableColumnPlusAfter,
    mdiTableColumnPlusBefore,
    mdiTableColumnRemove,
    mdiTableRowPlusAfter,
    mdiTableRowPlusBefore,
    mdiTableRowRemove,
    mdiTableRow,
    mdiTableRemove,
    mdiButtonCursor
});
IconRegistry.add({
    customImageMultiplePlus: "m12 14.7 3-3.7 2.2 2.7A6 6 0 0 1 20 13a6.6 6.6 0 0 1 1 0V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a6 6 0 0 1 .8-2H7l3-4ZM3 20V6H1v14a2 2 0 0 0 2 2h11.8a6 6 0 0 1-.7-2Zm18-2v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
    customYoutubePlus: "M22 13.3v-2.1c0-.6 0-1.3-.2-2.1a10.3 10.3 0 0 0-.2-2 2.3 2.3 0 0 0-1.8-1.7A41 41 0 0 0 12 5h-1.6c-1 0-2.3 0-3.6.2a14.1 14.1 0 0 0-2.6.2 2.3 2.3 0 0 0-1.8 1.8A19.9 19.9 0 0 0 2 12v.8c0 .6 0 1.3.2 2.1a10.3 10.3 0 0 0 .2 2 2.3 2.3 0 0 0 1.8 1.7 41 41 0 0 0 7.8.4h2a6 6 0 0 1 6-6 5.8 5.8 0 0 1 2 .3ZM10 15V9l5.2 3Zm11 3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
    customWidgetsPlus: "M2.3 21.6h8v-8h-8Zm0-18v8h8v-8Zm13.7 10h-3.7v8h1a6 6 0 0 1-.6-2.6 6 6 0 0 1 3.3-5.3Zm0-11.3L10.3 8l5.7 5.7L21.7 8ZM19.7 18v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
    customButtonCursorOff: "m19.9,2.01H7.07l2,2h10.93v8h-1.6l2.2,1.9c.8-.3,1.3-1,1.3-1.9V4.01c0-1.1-.9-2-2-2Zm-1.95,13.41l-7.72-7.72-.04-.03-3.66-3.66h0L3.79,1.27h0s-1.27-1.27-1.27-1.27l-1.27,1.27,1.33,1.33c-.36.36-.59.86-.59,1.41v8c0,1.1.9,2,2,2h2v-2h-2V4.01h0l4,4v10.9c0,.5.4.8.8.8.2,0,.4-.1.5-.2l1.9-1.5,1.6,3.6c.1.2.4.4.7.4.1,0,.2,0,.3-.1l2.8-1.3c.4-.2.6-.6.4-1l-1.7-3.6.61-.1,2.09,2.09,1.26-1.26-1.31-1.31s0,0,0,0Z"
});
const DefaultFormatItems = [
    {
        title: "Kleiner Text",
        isActive: (editor)=>editor.isActive("small"),
        command: (editor)=>editor.chain().focus().setSmall().run()
    },
    {
        title: "Normaler Text",
        isActive: (_)=>false,
        command: (editor)=>editor.chain().focus().setParagraph().unsetMark("small").run()
    },
    {
        title: "Überschrift 2",
        isActive: (editor)=>editor.isActive("heading") && editor.getAttributes("heading")?.level === 2,
        command: (editor)=>editor.chain().focus().setHeading({
                level: 2
            }).run()
    },
    {
        title: "Überschrift 3",
        isActive: (editor)=>editor.isActive("heading") && editor.getAttributes("heading")?.level === 3,
        command: (editor)=>editor.chain().focus().setHeading({
                level: 3
            }).run()
    },
    {
        title: "Überschrift 4",
        isActive: (editor)=>editor.isActive("heading") && editor.getAttributes("heading")?.level === 4,
        command: (editor)=>editor.chain().focus().setHeading({
                level: 4
            }).run()
    }
];
class RichtextEditorComponent extends Vue {
    get options() {
        return container.get("RichtextOptions");
    }
    get formatItems() {
        return this.options.formatItems;
    }
    get mode() {
        return this.modeValue;
    }
    set mode(value) {
        this.modeValue = value ?? "graphical";
    }
    get isGraphicalUiEnabled() {
        return this.mode === "graphical";
    }
    get customElements() {
        return this.options.customElements;
    }
    get customElementsForMenu() {
        return this.customElements.filter((x)=>x.expandOnToolbar == null || x.expandOnToolbar === false);
    }
    get customElementsForToolbar() {
        return this.customElements.filter((x)=>x.expandOnToolbar === true && !isNullOrEmpty(x.iconSvg));
    }
    mounted() {
        let customElements = [
            BlucAsset,
            BlucAssetList,
            BlucEmbed,
            BlucMap,
            BlucButton
        ];
        for (let definition of this.customElements){
            customElements.push(definition.extension);
        }
        let editorOptions = {
            extensions: [
                Document,
                Text,
                History,
                Dropcursor,
                Gapcursor,
                Paragraph,
                BubbleMenu.configure({
                    pluginKey: new PluginKey("tableBubbleMenu"),
                    element: document.getElementById("tableToolbar"),
                    shouldShow: ({ editor, view, state, oldState, from, to })=>{
                        return editor.isActive("table");
                    },
                    tippyOptions: {
                        appendTo: document.body,
                        maxWidth: "none"
                    }
                }),
                TextAlign.configure({
                    types: [
                        "tableCell",
                        "tableHeader"
                    ],
                    alignments: [
                        "left",
                        "center",
                        "right"
                    ]
                }),
                Blockquote,
                BulletList,
                HardBreak,
                Heading,
                ListItem,
                OrderedList,
                Link.configure({
                    HTMLAttributes: {
                        rel: ""
                    },
                    defaultProtocol: "https",
                    protocols: [
                        "bluc",
                        "http",
                        "https",
                        "ftp",
                        "ftps",
                        "mailto",
                        "tel",
                        "callto",
                        "sms",
                        "cid",
                        "xmpp"
                    ],
                    openOnClick: false
                }),
                Bold,
                Italic,
                Subscript,
                Superscript,
                Small,
                Table.configure({
                    allowTableNodeSelection: true
                }),
                TableRow,
                CustomTableHeader,
                CustomTableCell,
                ...customElements
            ],
            content: this.value,
            onSelectionUpdate: this.onSelectionUpdateDebounced,
            onCreate: this.onEditorCreate,
            onUpdate: this.onEditorUpdate
        };
        if (this.options.customizeEditorOptions != null) {
            this.options.customizeEditorOptions(editorOptions);
        }
        this.editor = new Editor(editorOptions);
        this.isInitialized = true;
        eventBus.on(CustomElementChangedEvent, this.onCustomElementChanged);
    }
    beforeUnmount() {
        this.editor.destroy();
        eventBus.off(CustomElementChangedEvent, this.onCustomElementChanged);
    }
    onEditorCreate() {
        // make toolbar sticky
        const scrollWrapper = this.$el.closest(".scroll-panel, .entity-editor__pane-content");
        const toolbarWrapper = this.$el.querySelector(".richtext-editor__toolbar-wrapper");
        const toolbar = this.$el.querySelector(".richtext-editor__toolbar");
        this.scrollWrapperRect = scrollWrapper.getBoundingClientRect();
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.intersectionRatio === 1 || entry.intersectionRatio === 0) {
                scrollWrapper.removeEventListener("scroll", scrollHandler);
                this.editorRect = null;
            } else {
                scrollWrapper.addEventListener("scroll", scrollHandler);
            }
        }, {
            root: scrollWrapper,
            threshold: [
                0,
                1
            ]
        });
        observer.observe(this.$el);
        const scrollHandler = ()=>{
            if (this.editorRect == null) {
                this.editorRect = this.editor.view.dom.getBoundingClientRect();
            }
            const toolbarWrapperRect = toolbarWrapper.getBoundingClientRect();
            const offset = Math.max((toolbarWrapperRect.top - this.scrollWrapperRect.top) * -1, 0);
            if (offset > this.editorRect.height) {
                toolbar.style.opacity = "0";
            } else {
                toolbar.style.opacity = "1";
            }
            toolbar.style.transform = `translateY(${offset}px)`;
        };
    }
    onEditorUpdate() {
        this.editorRect = this.editor.view.dom.getBoundingClientRect();
        this.$emit("update:modelValue", this.editor.getHTML());
    }
    onCustomElementChanged() {
        this.$emit("update:modelValue", this.editor.getHTML());
    }
    onSourceChanged(html) {
        this.editor.commands.setContent(html);
        this.$emit("update:modelValue", html);
    }
    setParagraphFormat(formatItem) {
        formatItem.command(this.editor);
        this.$emit("update:modelValue", this.editor.getHTML());
    }
    createCustomElement(definition) {
        definition.createCommand(this.editor);
    }
    onSelectionUpdate() {
        for (let format of this.formatItems){
            if (format.isActive(this.editor)) {
                this.selectionFormat = format;
                return;
            }
        }
        this.selectionFormat = null;
    }
    constructor(...args){
        super(...args), this.isInitialized = false, this.paneOpenStates = {
            link: false,
            button: false,
            asset: false,
            assetList: false,
            embed: false,
            map: false,
            customElement: false
        }, this.modeValue = "graphical", this.selectedEntityId = "", this.editor = null, this.selectionFormat = null, this.scrollWrapperRect = null, this.editorRect = null, this.onEditorUpdateDebounced = debounce$1(this.onEditorUpdate, 500), this.onSelectionUpdateDebounced = debounce$1(this.onSelectionUpdate.bind(this), 100);
    }
}
_([
    Model(),
    _$1("design:type", String)
], RichtextEditorComponent.prototype, "value", void 0);
RichtextEditorComponent = _([
    Component({
        render: render$z,
        components: {
            EditorContent,
            UrlPicker,
            ButtonNodeEditor,
            AssetNodeEditor,
            AssetListNodeEditor,
            EmbedNodeEditor,
            MapNodeEditor
        }
    })
], RichtextEditorComponent);

const _hoisted_1$n = { class: "editor-base" };
const _hoisted_2$h = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$g = {
  key: 1,
  class: "editor-base__description"
};

function render$y(_ctx, _cache) {
  const _component_richtext_editor_component = resolveComponent("richtext-editor-component");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$n, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$h, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$g, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    (_ctx.isFrameless)
      ? (openBlock(), createBlock(_component_v_sheet, {
          key: 1,
          class: "border"
        }, {
          default: withCtx(() => [
            createVNode(_component_richtext_editor_component, {
              modelValue: _ctx.html,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.html) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : (openBlock(), createBlock(_component_v_card, {
          key: 2,
          class: "richtext-editor__card"
        }, {
          default: withCtx(() => [
            createVNode(_component_richtext_editor_component, {
              modelValue: _ctx.html,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.html) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
  ]))
}

let parser = new DOMParser();
function getPlainTextSnippet(richtext, length) {
    if (richtext == null) {
        return "";
    }
    let text = parser.parseFromString(richtext.html, "text/html").documentElement.textContent;
    if (text == null) {
        return "";
    }
    return text.substring(0, length - 1) + (text.length > length ? "…" : "");
}
class RichtextEditor extends EditorBase {
    get html() {
        return this.model?.html ?? "";
    }
    set html(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: {
                html: value
            }
        });
    }
}
RichtextEditor = _([
    Component({
        render: render$y,
        components: {
            RichtextEditorComponent
        }
    })
], RichtextEditor);
EditorFactory.registerEditor({
    type: RichtextEditor,
    predicate: (schema, typeName)=>schema.format === DataType.Richtext,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            return {
                value: getPlainTextSnippet(node.model, 160)
            };
        };
    },
    priority: 0
});

const _hoisted_1$m = { class: "font-weight-bold text-truncate mr-2" };

function render$x(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _component_node_view_wrapper = resolveComponent("node-view-wrapper");

  return (openBlock(), createBlock(_component_node_view_wrapper, null, {
    default: withCtx(() => [
      createVNode(_component_v_card, {
        outlined: "",
        tile: "",
        class: "richtext-widget richtext-widget--block",
        "max-width": 500
      }, {
        default: withCtx(() => [
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                "data-drag-handle": "",
                class: "drag-handle mr-2"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiDrag), 1)
                ]),
                _: 1
              }),
              createElementVNode("div", null, [
                createElementVNode("div", _hoisted_1$m, toDisplayString(_ctx.text), 1),
                _cache[0] || (_cache[0] = createElementVNode("div", { class: "text-caption text-truncate mr-2" }, "Nicht bearbeitbares Element", -1))
              ]),
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                icon: "",
                color: "primary",
                onClick: _ctx.deleteNode
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_icon, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$icons.mdiDelete), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiDrag,
    mdiDelete
});
class UneditableNodeView extends CustomNodeViewBase {
    get text() {
        return this.extension.options.text;
    }
}
UneditableNodeView = _([
    Component({
        render: render$x,
        components: {
            NodeViewWrapper
        }
    })
], UneditableNodeView);

const _hoisted_1$l = { class: "editor-base editor-base--complex multilingual-editor" };
const _hoisted_2$g = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$f = {
  key: 1,
  class: "editor-base__description"
};

function render$w(_ctx, _cache) {
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");

  return (openBlock(), createElementBlock("div", _hoisted_1$l, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$g, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$f, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_tabs, {
      class: "ml-1",
      modelValue: _ctx.activeLanguage,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.activeLanguage) = $event))
    }, {
      default: withCtx(() => [
        (_ctx.items.length === 0)
          ? (openBlock(), createBlock(_component_v_tab, {
              key: 0,
              disabled: ""
            }, {
              default: withCtx(() => _cache[2] || (_cache[2] = [
                createTextVNode("Leer")
              ])),
              _: 1
            }))
          : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
          return (openBlock(), createBlock(_component_v_tab, {
            value: item.language
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.$formatters.expandIso639(item.language)), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    createVNode(_component_v_tabs_window, {
      class: "px-1 pb-1",
      modelValue: _ctx.activeLanguage,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.activeLanguage) = $event))
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
          return (openBlock(), createBlock(_component_v_tabs_window_item, {
            value: item.language
          }, {
            default: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(item.data.componentName), {
                data: item.data,
                "is-expanded": _ctx.isItemPrimitive,
                "is-frameless": _ctx.isFrameless && _ctx.isItemPrimitive,
                "hide-title": ""
              }, null, 8, ["data", "is-expanded", "is-frameless"]))
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}

const LanguageChangedEvent = "MultilingualEditor/LanguageChanged";
class MultilingualEditor extends EditorBase {
    get items() {
        if (this.data.children == null) {
            return [];
        }
        return Object.entries(this.data.children).map(([language, data])=>{
            return {
                language,
                data
            };
        });
    }
    get isItemPrimitive() {
        let firstItemSchema = this.items[0]?.data.schema;
        if (firstItemSchema == null) {
            return false;
        }
        return EditorFactory.getEditorType(firstItemSchema) === EditorType.Primitive;
    }
    mounted() {
        // listen to other multilingual editors changing language to synchronize
        eventBus.on(LanguageChangedEvent, this.onLanguageChanged);
    }
    beforeDestroy() {
        eventBus.off(LanguageChangedEvent, this.onLanguageChanged);
    }
    onLanguageChanged(args) {
        if (args.sender == this.data.metadataPath) {
            return;
        }
        this.activeLanguage = args.language;
    }
    onActiveLanguageChanged() {
        if (this.activeLanguage == null) {
            return;
        }
        let args = {
            sender: this.data.metadataPath,
            language: this.activeLanguage
        };
        eventBus.emit(LanguageChangedEvent, args);
    }
    constructor(...args){
        super(...args), this.activeLanguage = null;
    }
}
_([
    Watch(nameof("activeLanguage")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], MultilingualEditor.prototype, "onActiveLanguageChanged", null);
MultilingualEditor = _([
    Component({
        render: render$w
    })
], MultilingualEditor);
EditorFactory.registerEditor({
    type: MultilingualEditor,
    predicate: (schema, typeName)=>schema.format === DataType.Multilingual,
    customization: (node, factory)=>{
        let [_, itemSchema] = Object.entries(node.schema.properties)[0];
        if (!isSchema(itemSchema)) {
            throw new ExtendedError("Item schema not found.", {
                path: node.path,
                itemSchema
            });
        }
        let children = Object.keys(node.schema.properties).map((language)=>{
            let childModel = node.model[language];
            let childSchema = factory.getSchemaForAssemblyType(childModel, itemSchema, node.resolveSchemaRef);
            let childPath = `${node.path}/${language}`;
            let childMetadataPath = `${node.metadataPath}/children/${language}`;
            return {
                propertyName: language,
                metadata: factory.create({
                    rootId: node.rootId,
                    schema: childSchema,
                    model: childModel,
                    path: childPath,
                    metadataPath: childMetadataPath,
                    nestingLevel: node.nestingLevel + 1,
                    contextType: EditorType.Primitive,
                    parent: node,
                    getRoot: node.getRoot,
                    getContext: node.getContext,
                    resolveSchemaRef: node.resolveSchemaRef
                })
            };
        });
        node.editorType = EditorType.Primitive;
        node.componentName = "multilingual-editor";
        node.children = toDictionary(children, (c)=>c.propertyName, (c)=>c.metadata);
        node.getDisplayValue = ()=>children[0]?.metadata.getDisplayValue();
    },
    priority: 0
});

const _hoisted_1$k = { class: "editor-base editor-base--primitive" };
const _hoisted_2$f = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$e = {
  key: 1,
  class: "editor-base__description"
};

function render$v(_ctx, _cache) {
  const _component_tag_editor_component = resolveComponent("tag-editor-component");

  return (openBlock(), createElementBlock("div", _hoisted_1$k, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$f, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$e, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_tag_editor_component, {
      kind: _ctx.kind,
      modelValue: _ctx.selectedTags,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedTags) = $event))
    }, null, 8, ["kind", "modelValue"])
  ]))
}

class TagEditor extends EditorBase {
    get selectedTags() {
        return this.model ?? [];
    }
    set selectedTags(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
    get kind() {
        switch(this.data.schema.format){
            case DataType.DocumentTagEditor:
                return EntityKind.Document;
            case DataType.AssetTagEditor:
                return EntityKind.Asset;
            default:
                // if we're here, we screwed up our registration predicate
                throw new ExtendedError(`TagEditor can only handle document or asset tags.`, {
                    schemaFormat: this.data.schema.format
                });
        }
    }
}
TagEditor = _([
    Component({
        render: render$v
    })
], TagEditor);
EditorFactory.registerEditor({
    type: TagEditor,
    predicate: (schema, typeName)=>schema.format === DataType.DocumentTagEditor || schema.format === DataType.AssetTagEditor,
    priority: 0
});

const _hoisted_1$j = { class: "editor-base editor-base--complex" };
const _hoisted_2$e = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$d = {
  key: 1,
  class: "editor-base__description"
};

function render$u(_ctx, _cache) {
  const _component_tag_selector = resolveComponent("tag-selector");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$j, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$e, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$d, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    (_ctx.isFrameless)
      ? (openBlock(), createBlock(_component_tag_selector, {
          key: 1,
          kind: _ctx.entityKind,
          assemblyType: _ctx.assemblyType,
          mode: _ctx.editMode ? 'edit' : 'view',
          modelValue: _ctx.selector,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selector) = $event))
        }, null, 8, ["kind", "assemblyType", "mode", "modelValue"]))
      : (openBlock(), createBlock(_component_v_card, { key: 2 }, {
          default: withCtx(() => [
            createVNode(_component_tag_selector, {
              kind: _ctx.entityKind,
              assemblyType: _ctx.assemblyType,
              mode: _ctx.editMode ? 'edit' : 'view',
              modelValue: _ctx.selector,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selector) = $event))
            }, null, 8, ["kind", "assemblyType", "mode", "modelValue"]),
            createVNode(_component_v_card_actions, null, {
              default: withCtx(() => [
                createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  "prepend-icon": _ctx.$icons.mdiPencil,
                  onClick: _ctx.open
                }, {
                  default: withCtx(() => _cache[2] || (_cache[2] = [
                    createTextVNode("Bearbeiten")
                  ])),
                  _: 1
                }, 8, ["prepend-icon", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}

class TagSelectorEditor extends EditorBase {
    get selector() {
        return this.model ?? {
            kind: this.entityKind,
            orderedIds: [],
            tags: []
        };
    }
    set selector(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
    get entityKind() {
        switch(this.data.schema.format){
            case DataType.DocumentTagSelector:
                return EntityKind.Document;
            case DataType.AssetTagSelector:
                return EntityKind.Asset;
            default:
                // if we're here, we screwed up our registration predicate
                throw new ExtendedError(`TagSelectorEditor can only handle document or asset tags.`, {
                    schemaFormat: this.data.schema.format
                });
        }
    }
    get assemblyType() {
        return this.data.schema.assemblyType;
    }
    open() {
        let args = {
            node: this.data,
            props: {
                editMode: true
            }
        };
        eventBus.emit(OpenPaneEvent, args);
    }
}
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], TagSelectorEditor.prototype, "editMode", void 0);
TagSelectorEditor = _([
    Component({
        render: render$u,
        components: {
            TagSelector: TagSelectorComponent
        }
    })
], TagSelectorEditor);
EditorFactory.registerEditor({
    type: TagSelectorEditor,
    predicate: (schema, typeName)=>schema.format === DataType.DocumentTagSelector || schema.format === DataType.AssetTagSelector,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            let model = node.model;
            if (model?.tags?.length || 0 === 0) {
                return null;
            }
            return {
                value: model.tags.join(", ")
            };
        };
    },
    priority: 0
});

const _hoisted_1$i = { class: "editor-base editor-base--complex image-crop-editor" };
const _hoisted_2$d = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$c = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_4$6 = ["src"];

function render$t(_ctx, _cache) {
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_alert = resolveComponent("v-alert");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$i, [
    createVNode(_component_v_row, { ref: "container" }, {
      default: withCtx(() => [
        createVNode(_component_v_col, null, {
          default: withCtx(() => [
            (!_ctx.hideTitle)
              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  (_ctx.title)
                    ? (openBlock(), createElementBlock("h2", _hoisted_2$d, toDisplayString(_ctx.title), 1))
                    : createCommentVNode("", true),
                  (_ctx.description)
                    ? (openBlock(), createElementBlock("p", _hoisted_3$c, toDisplayString(_ctx.description), 1))
                    : createCommentVNode("", true)
                ], 64))
              : createCommentVNode("", true)
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" })
      ]),
      _: 1
    }, 512),
    createVNode(_component_v_card, { class: "image-crop-editor__card" }, {
      default: withCtx(() => [
        createVNode(_component_loader_wrapper, {
          class: "image-crop-editor__loader",
          state: _ctx.loadingState
        }, {
          error: withCtx(() => [
            createVNode(_component_v_alert, { type: "error" }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.errorMessages, (message) => {
                  return (openBlock(), createElementBlock("div", null, toDisplayString(message), 1))
                }), 256))
              ]),
              _: 1
            })
          ]),
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              class: "image-crop-editor__image-container",
              style: normalizeStyle({ 'aspect-ratio': _ctx.aspectRatio })
            }, [
              createElementVNode("img", {
                class: "image-crop-editor__image",
                ref: "focalPointImage",
                src: _ctx.imageUrl
              }, null, 8, _hoisted_4$6)
            ], 4), [
              [vShow, _ctx.editMode === 'focalPoint']
            ])
          ]),
          _: 1
        }, 8, ["state"])
      ]),
      _: 1
    })
  ]))
}

IconRegistry.add({
    mdiImage,
    mdiCrop,
    mdiImageFilterCenterFocus
});
class ImageCropEditor extends EditorBase {
    get imageUrl() {
        var url = new URL(this.data.getContext().url);
        url.searchParams.set("width", "1400");
        url.searchParams.set("height", "900");
        url.searchParams.set("rmode", "max");
        return url.href;
    }
    created() {
        let image = document.createElement("img");
        image.addEventListener("load", this.onImageLoaded);
        image.addEventListener("error", this.onImageLoadFailed);
        image.src = this.imageUrl;
    }
    mounted() {}
    onImageLoaded(e) {
        let image = e.target;
        this.aspectRatio = image.width / image.height;
        //let cropImage = this.$refs.cropImage as HTMLImageElement;
        //this.croppr = new Croppr(cropImage, {
        //	startPosition: [this.model.region.x, this.model.region.y, "ratio"],
        //	startSize: [this.model.region.width, this.model.region.height, "ratio"],
        //	onCropEnd: this.onCropEnd,
        //	returnMode: "ratio"
        //});
        this.loadingState = LoadingState.Results;
        this.$nextTick(()=>{
            let focalPointImage = this.$refs.focalPointImage;
            this.focusPicker = new FocusPicker(focalPointImage, {
                focus: this.model?.focalPoint ?? {
                    x: 0,
                    y: 0
                },
                onChange: this.onFocusChangeDebounced
            });
        });
    }
    onImageLoadFailed(e) {
        this.loadingState = LoadingState.Error;
        this.errorMessages.push("Das Bild konnte nicht geladen werden.");
    }
    onFocusChange(focalPoint) {
        if (focalPoint.x !== this.model?.focalPoint.x || focalPoint.y !== this.model?.focalPoint.y) {
            this.patch({
                focalPoint
            });
        }
    }
    patch(partialValue) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: Object.assign({}, this.model, partialValue)
        });
    }
    constructor(...args){
        super(...args), this.editMode = "focalPoint", this.loadingState = LoadingState.Loading, this.aspectRatio = 0.666, //onCropEnd(region: Rectangle) {
        //	this.patch({ region });
        //}
        this.onFocusChangeDebounced = debounce$1(this.onFocusChange, 100);
    }
}
_([
    NonReactive,
    _$1("design:type", Object)
], ImageCropEditor.prototype, "croppr", void 0);
_([
    NonReactive,
    _$1("design:type", Object)
], ImageCropEditor.prototype, "focusPicker", void 0);
ImageCropEditor = _([
    Component({
        render: render$t
    })
], ImageCropEditor);
EditorFactory.registerEditor({
    type: ImageCropEditor,
    predicate: (schema, typeName)=>schema.format === DataType.ImageCrop,
    editorType: EditorType.Complex,
    priority: 0
});

const _hoisted_1$h = { class: "editor-base editor-base--complex id-selector-editor" };
const _hoisted_2$c = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$b = {
  key: 1,
  class: "editor-base__description"
};

function render$s(_ctx, _cache) {
  const _component_id_selector = resolveComponent("id-selector");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$h, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$c, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$b, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    (_ctx.isFrameless)
      ? (openBlock(), createBlock(_component_id_selector, {
          key: 1,
          kind: _ctx.entityKind,
          mode: _ctx.editMode ? 'edit' : 'view',
          onSelected: _ctx.onSelected,
          modelValue: _ctx.selector,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selector) = $event))
        }, null, 8, ["kind", "mode", "onSelected", "modelValue"]))
      : (openBlock(), createBlock(_component_v_card, { key: 2 }, {
          default: withCtx(() => [
            createVNode(_component_id_selector, {
              kind: _ctx.entityKind,
              mode: _ctx.editMode ? 'edit' : 'view',
              onSelected: _ctx.onSelected,
              modelValue: _ctx.selector,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selector) = $event))
            }, null, 8, ["kind", "mode", "onSelected", "modelValue"]),
            createVNode(_component_v_card_actions, null, {
              default: withCtx(() => [
                createVNode(_component_v_btn, {
                  variant: "tonal",
                  color: "primary",
                  "prepend-icon": _ctx.$icons.mdiTarget,
                  onClick: _ctx.open
                }, {
                  default: withCtx(() => _cache[2] || (_cache[2] = [
                    createTextVNode("Ziel auswählen")
                  ])),
                  _: 1
                }, 8, ["prepend-icon", "onClick"]),
                (_ctx.showEditButton)
                  ? (openBlock(), createBlock(_component_v_btn, {
                      key: 0,
                      variant: "tonal",
                      color: "primary",
                      "prepend-icon": _ctx.$icons.mdiPencil,
                      onClick: _ctx.editTarget
                    }, {
                      default: withCtx(() => _cache[3] || (_cache[3] = [
                        createTextVNode("Ziel bearbeiten")
                      ])),
                      _: 1
                    }, 8, ["prepend-icon", "onClick"]))
                  : createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}

IconRegistry.add({
    mdiTarget,
    mdiPencil
});
class IdSelectorEditor extends EditorBase {
    get entityKind() {
        switch(this.data.schema.format){
            case DataType.DocumentIdSelector:
                return EntityKind.Document;
            case DataType.AssetIdSelector:
                return EntityKind.Asset;
            default:
                // if we're here, we screwed up our registration predicate
                throw new ExtendedError(`IdSelectorEditor can only handle document or asset id selectors.`, {
                    schemaFormat: this.data.schema.format
                });
        }
    }
    get selector() {
        return this.model;
    }
    set selector(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
    get assemblyType() {
        return this.data.schema.assemblyType;
    }
    open() {
        let args = {
            node: this.data,
            props: {
                editMode: true
            }
        };
        eventBus.emit(OpenPaneEvent, args);
    }
    editTarget() {
        if (this.selector != null) {
            let routeName = null;
            switch(this.selector.kind){
                case EntityKind.Asset:
                    routeName = RouteNames.Assets.Edit;
                    break;
                case EntityKind.Document:
                    routeName = RouteNames.Documents.Edit;
                    break;
                default:
                    throw new Error(`Unknown entity kind ${this.selector.kind}.`);
            }
            this.$router.push({
                name: routeName,
                params: {
                    id: this.selector.id
                }
            });
        }
    }
    onSelected(entity) {
        this.showEditButton = entity != null;
    }
    constructor(...args){
        super(...args), this.showEditButton = false;
    }
}
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], IdSelectorEditor.prototype, "editMode", void 0);
IdSelectorEditor = _([
    Component({
        render: render$s,
        components: {
            IdSelector: IdSelectorComponent
        }
    })
], IdSelectorEditor);
EditorFactory.registerEditor({
    type: IdSelectorEditor,
    predicate: (schema, typeName)=>schema.format === DataType.DocumentIdSelector || schema.format === DataType.AssetIdSelector,
    editorType: EditorType.Complex,
    priority: 0,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            let model = node.model;
            let displayName = Multilingual.getValue(model?.displayName);
            if (isNullOrEmpty(displayName)) {
                return null;
            }
            return {
                value: displayName
            };
        };
    }
});

const _hoisted_1$g = { class: "editor-base editor-base--complex id-selector-editor" };
const _hoisted_2$b = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$a = {
  key: 1,
  class: "editor-base__description"
};

function render$r(_ctx, _cache) {
  const _component_geo_json_point_picker = resolveComponent("geo-json-point-picker");

  return (openBlock(), createElementBlock("div", _hoisted_1$g, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$b, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$a, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_geo_json_point_picker, {
      modelValue: _ctx.point,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.point) = $event))
    }, null, 8, ["modelValue"])
  ]))
}

class GeoJsonPointEditor extends EditorBase {
    get point() {
        return this.model || {
            type: "Point",
            coordinates: [
                0,
                0
            ]
        };
    }
    set point(value) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
}
GeoJsonPointEditor = _([
    Component({
        render: render$r
    })
], GeoJsonPointEditor);
EditorFactory.registerEditor({
    type: GeoJsonPointEditor,
    editorType: EditorType.Complex,
    predicate: (schema, typeName)=>schema.format === "geojson-point",
    priority: 0
});

const _hoisted_1$f = {
  key: 0,
  class: "editor-base editor-base--complex object-editor object-editor--expanded"
};
const _hoisted_2$a = {
  key: 0,
  class: "editor-base__title-description"
};
const _hoisted_3$9 = {
  key: 0,
  class: "display-1 object-editor__title"
};
const _hoisted_4$5 = {
  key: 1,
  class: "body-2 object-editor__description"
};
const _hoisted_5$5 = {
  key: 0,
  class: "editor-base__title-description"
};
const _hoisted_6$3 = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_7$3 = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_8$2 = { key: 1 };
const _hoisted_9$1 = { class: "text-truncate" };
const _hoisted_10$1 = { class: "text-truncate" };
const _hoisted_11$1 = { class: "text-truncate" };
const _hoisted_12$1 = { class: "text-truncate" };

function render$q(_ctx, _cache) {
  const _component_v_combobox = resolveComponent("v-combobox");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (_ctx.isExpanded)
    ? (openBlock(), createElementBlock("div", _hoisted_1$f, [
        (!_ctx.hideTitle)
          ? (openBlock(), createElementBlock("div", _hoisted_2$a, [
              (_ctx.title)
                ? (openBlock(), createElementBlock("h2", _hoisted_3$9, toDisplayString(_ctx.title), 1))
                : createCommentVNode("", true),
              (_ctx.description)
                ? (openBlock(), createElementBlock("p", _hoisted_4$5, toDisplayString(_ctx.description), 1))
                : createCommentVNode("", true)
            ]))
          : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass({ 'pl-8': !_ctx.hideTitle })
        }, [
          createVNode(_component_v_combobox, {
            label: "Controller",
            items: _ctx.controllers,
            "item-title": "displayName",
            modelValue: _ctx.selectedController,
            "onUpdate:modelValue": _ctx.setSelectedController
          }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
          createVNode(_component_v_combobox, {
            label: "Action",
            items: _ctx.actions,
            "item-title": "displayName",
            modelValue: _ctx.selectedAction,
            "onUpdate:modelValue": _ctx.setSelectedAction
          }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
        ], 2)
      ]))
    : (openBlock(), createElementBlock("div", {
        key: 1,
        class: "object-editor object-editor--collapsed editor-base--primitive editor-base",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.isFrameless && _ctx.open()))
      }, [
        (!_ctx.hideTitle)
          ? (openBlock(), createElementBlock("div", _hoisted_5$5, [
              (_ctx.title)
                ? (openBlock(), createElementBlock("h2", _hoisted_6$3, toDisplayString(_ctx.title), 1))
                : createCommentVNode("", true),
              (_ctx.description)
                ? (openBlock(), createElementBlock("p", _hoisted_7$3, toDisplayString(_ctx.description), 1))
                : createCommentVNode("", true)
            ]))
          : createCommentVNode("", true),
        (_ctx.isFrameless)
          ? (openBlock(), createElementBlock("div", _hoisted_8$2, [
              (_ctx.selectedController != null)
                ? (openBlock(), createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "flex-nowrap"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_col, {
                        cols: "1",
                        class: "w-min-0 pr-1"
                      }, {
                        default: withCtx(() => _cache[1] || (_cache[1] = [
                          createElementVNode("div", { class: "text-caption text-truncate" }, "Controller", -1)
                        ])),
                        _: 1
                      }),
                      createVNode(_component_v_col, { class: "w-min-0" }, {
                        default: withCtx(() => [
                          createElementVNode("div", _hoisted_9$1, toDisplayString(_ctx.selectedController.displayName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : createCommentVNode("", true),
              (_ctx.selectedAction != null)
                ? (openBlock(), createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "flex-nowrap"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_col, {
                        cols: "1",
                        class: "w-min-0 pr-1"
                      }, {
                        default: withCtx(() => _cache[2] || (_cache[2] = [
                          createElementVNode("div", { class: "text-caption text-truncate" }, "Action", -1)
                        ])),
                        _: 1
                      }),
                      createVNode(_component_v_col, { class: "w-min-0" }, {
                        default: withCtx(() => [
                          createElementVNode("div", _hoisted_10$1, toDisplayString(_ctx.selectedAction.displayName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : createCommentVNode("", true)
            ]))
          : (openBlock(), createBlock(_component_v_card, {
              key: 2,
              outlined: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    (_ctx.selectedController != null)
                      ? (openBlock(), createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "flex-nowrap"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, {
                              cols: "1",
                              class: "w-min-0 pr-1"
                            }, {
                              default: withCtx(() => _cache[3] || (_cache[3] = [
                                createElementVNode("div", { class: "text-caption text-truncate" }, "Controller", -1)
                              ])),
                              _: 1
                            }),
                            createVNode(_component_v_col, { class: "w-min-0" }, {
                              default: withCtx(() => [
                                createElementVNode("div", _hoisted_11$1, toDisplayString(_ctx.selectedController.displayName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : createCommentVNode("", true),
                    (_ctx.selectedAction != null)
                      ? (openBlock(), createBlock(_component_v_row, {
                          key: 1,
                          "no-gutters": "",
                          class: "flex-nowrap"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, {
                              cols: "1",
                              class: "w-min-0 pr-1"
                            }, {
                              default: withCtx(() => _cache[4] || (_cache[4] = [
                                createElementVNode("div", { class: "text-caption text-truncate" }, "Action", -1)
                              ])),
                              _: 1
                            }),
                            createVNode(_component_v_col, { class: "w-min-0" }, {
                              default: withCtx(() => [
                                createElementVNode("div", _hoisted_12$1, toDisplayString(_ctx.selectedAction.displayName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                createVNode(_component_v_card_actions, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_btn, {
                      text: "",
                      color: "primary",
                      onClick: _ctx.open
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_icon, { left: "" }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(_ctx.$icons.mdiPencil), 1)
                          ]),
                          _: 1
                        }),
                        _cache[5] || (_cache[5] = createTextVNode(" Bearbeiten "))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]))
}

IconRegistry.add({
    mdiPencil
});
const namespaceAction = {
    name: null,
    displayName: "Keine (Namespace Controller)"
};
class MenuNodeControllerDataEditor extends EditorBase {
    get controllers() {
        return container.get("MenuOptions").controllers;
    }
    get actions() {
        return [
            namespaceAction
        ].concat(this.selectedController?.actions ?? []);
    }
    get selectedController() {
        if (this.model?.controller == null) {
            return null;
        }
        let controllerInfo = this.controllers.find((c)=>c.name == this.model?.controller);
        if (controllerInfo != null) {
            return controllerInfo;
        }
        return {
            name: this.model.controller,
            displayName: this.model.controller
        };
    }
    get selectedAction() {
        if (this.model?.action == null) {
            return null;
        }
        let actionInfo = this.actions.find((c)=>c.name == this.model?.action);
        if (actionInfo != null) {
            return actionInfo;
        }
        return {
            name: this.model.action,
            displayName: this.model.action
        };
    }
    setSelectedController(value) {
        if (this.model == null) {
            return;
        }
        let controllerName = null;
        if (typeof value === "string") {
            controllerName = value;
        } else if (typeof value === "object") {
            controllerName = value?.name ?? null;
        }
        let data = {
            $type: this.model.$type,
            controller: controllerName,
            action: null
        };
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: data
        });
    }
    setSelectedAction(value) {
        if (this.model == null || this.selectedController == null) {
            return;
        }
        let actionName = null;
        if (typeof value === "string") {
            actionName = value;
        } else if (typeof value === "object") {
            actionName = value?.name ?? null;
        }
        let data = {
            $type: this.model.$type,
            controller: this.selectedController.name,
            action: actionName
        };
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: data
        });
    }
    open() {
        let args = {
            node: this.data
        };
        eventBus.emit(OpenPaneEvent, args);
    }
}
MenuNodeControllerDataEditor = _([
    Component({
        render: render$q
    })
], MenuNodeControllerDataEditor);
EditorFactory.registerEditor({
    type: MenuNodeControllerDataEditor,
    editorType: EditorType.Complex,
    predicate: (schema, typeName)=>schema.format === DataType.MenuNodeControllerData,
    customization: (node, factory)=>{
    //node.componentName = "menu-node-controller-data-editor";
    },
    priority: 0
});

const _hoisted_1$e = { class: "editor-base editor-base--complex key-value-editor" };
const _hoisted_2$9 = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$8 = {
  key: 1,
  class: "editor-base__description"
};

function render$p(_ctx, _cache) {
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_data_table = resolveComponent("v-data-table");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createElementBlock("div", _hoisted_1$e, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$9, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$8, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_card, null, {
      default: withCtx(() => [
        createVNode(_component_v_data_table, {
          "hide-default-footer": "",
          "disable-filtering": "",
          "disable-pagination": "",
          headers: _ctx.headers,
          items: _ctx.items
        }, {
          "item.key": withCtx(({ item }) => [
            createVNode(_component_v_text_field, {
              density: "compact",
              "hide-details": "",
              modelValue: item.key,
              "onUpdate:modelValue": $event => ((item.key) = $event),
              onChange: _ctx.onItemChange
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          "item.value": withCtx(({ item }) => [
            createVNode(_component_v_text_field, {
              density: "compact",
              "hide-details": "",
              modelValue: item.value,
              "onUpdate:modelValue": $event => ((item.value) = $event),
              onChange: _ctx.onItemChange
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
          ]),
          "item.data-table-delete": withCtx(({ item }) => [
            createVNode(_component_v_btn, {
              variant: "tonal",
              icon: _ctx.$icons.mdiDelete,
              size: "small",
              color: "warning",
              onClick: $event => (_ctx.removeItem(item))
            }, null, 8, ["icon", "onClick"])
          ]),
          _: 1
        }, 8, ["headers", "items"]),
        createVNode(_component_v_card_actions, { class: "mt-2" }, {
          default: withCtx(() => [
            createVNode(_component_v_btn, {
              variant: "tonal",
              color: "success",
              "prepend-icon": _ctx.$icons.mdiPlus,
              onClick: _ctx.addItem
            }, {
              default: withCtx(() => _cache[0] || (_cache[0] = [
                createTextVNode("Schlüssel/Wert-Paar hinzufügen")
              ])),
              _: 1
            }, 8, ["prepend-icon", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}

IconRegistry.add({
    mdiDelete,
    mdiPlus
});
class KeyValueEditor extends EditorBase {
    get headers() {
        return [
            {
                title: "Schlüssel",
                value: "key"
            },
            {
                title: "Wert",
                value: "value"
            },
            {
                value: "data-table-delete",
                width: 48
            }
        ];
    }
    mounted() {
        this.onModelChanged();
    }
    onModelChanged() {
        this.items = Object.entries(this.model ?? {}).map(([k, v])=>{
            return {
                key: k,
                value: v
            };
        });
    }
    addItem() {
        this.items.push({
            key: "Neuer Name",
            value: "Neuer Wert"
        });
        this.onItemChange();
    }
    removeItem(item) {
        let index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
        }
        this.onItemChange();
    }
    onItemChange() {
        let data = {};
        for (let { key, value } of this.items){
            key = key.replace(/[^\w]*/g, ""); // remove all non-word chars from keys
            data[key] = value;
        }
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: data
        });
    }
    constructor(...args){
        super(...args), this.items = [];
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], KeyValueEditor.prototype, "onModelChanged", null);
KeyValueEditor = _([
    Component({
        render: render$p
    })
], KeyValueEditor);
EditorFactory.registerEditor({
    type: KeyValueEditor,
    predicate: (schema, typeName)=>schema.format === "key-value",
    editorType: EditorType.Complex,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            if (node.model == null) {
                return null;
            }
            return {
                children: Object.entries(node.model).map(([k, v])=>{
                    return {
                        title: k,
                        value: v
                    };
                })
            };
        };
    },
    priority: 0
});

const _hoisted_1$d = { class: "editor-base editor-base--complex" };
const _hoisted_2$8 = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$7 = {
  key: 1,
  class: "editor-base__description"
};
const _hoisted_4$4 = { class: "array-editor__item-action" };
const _hoisted_5$4 = { class: "flex-grow-1" };

function render$o(_ctx, _cache) {
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_autocomplete = resolveComponent("v-autocomplete");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_property_pane = resolveComponent("property-pane");

  return (openBlock(), createElementBlock("div", _hoisted_1$d, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$8, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$7, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_v_card, null, {
      default: withCtx(() => [
        createVNode(_component_v_autocomplete, {
          "hide-selected": "",
          "hide-details": "",
          "auto-select-first": "",
          class: "value-pool-editor__autocomplete",
          variant: null,
          multiple: _ctx.allowMultiple,
          clearable: _ctx.allowNull,
          items: _ctx.displayValues,
          loading: _ctx.isLoading,
          search: _ctx.searchText,
          "onUpdate:search": _cache[0] || (_cache[0] = $event => ((_ctx.searchText) = $event)),
          "value-comparator": _ctx.compareValues,
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.value) = $event))
        }, {
          chip: withCtx((data) => [
            createVNode(_component_v_chip, mergeProps({
              label: "",
              closable: _ctx.allowMultiple,
              "onClick:close": $event => (_ctx.parent.selectItem(data))
            }, data.attrs), {
              default: withCtx(() => [
                createTextVNode(toDisplayString(data.item.title), 1)
              ]),
              _: 2
            }, 1040, ["closable", "onClick:close"])
          ]),
          append: withCtx(() => [
            createVNode(_component_v_btn, {
              class: "mr-2",
              variant: "tonal",
              color: "primary",
              "prepend-icon": _ctx.$icons.mdiPencil,
              onClick: _ctx.openCreatePane
            }, {
              default: withCtx(() => _cache[2] || (_cache[2] = [
                createTextVNode("Werte-Pool bearbeiten")
              ])),
              _: 1
            }, 8, ["prepend-icon", "onClick"])
          ]),
          _: 1
        }, 8, ["multiple", "clearable", "items", "loading", "search", "value-comparator", "modelValue"])
      ]),
      _: 1
    }),
    createVNode(_component_property_pane, {
      title: "Werte-Pool bearbeiten",
      "is-active": _ctx.isEditPaneOpen,
      onCancel: _ctx.onEditCancel,
      onOk: _ctx.onEditOk
    }, {
      default: withCtx(() => [
        (_ctx.newValueNode != null)
          ? (openBlock(), createBlock(_component_v_card, {
              key: 0,
              variant: "flat",
              class: "border"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_card_title, null, {
                  default: withCtx(() => _cache[3] || (_cache[3] = [
                    createTextVNode("Werte im Pool")
                  ])),
                  _: 1
                }),
                (_ctx.editableValues.length > 0)
                  ? (openBlock(), createBlock(_component_v_list, {
                      key: 0,
                      activatable: "",
                      class: "mb-2"
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.editableValues, (item) => {
                          return (openBlock(), createBlock(_component_v_list_item, {
                            class: "white mb-1",
                            ripple: false,
                            inactive: true,
                            title: _ctx.getText(item)
                          }, {
                            append: withCtx(() => [
                              createElementVNode("div", _hoisted_4$4, [
                                createVNode(_component_v_tooltip, {
                                  location: "bottom",
                                  text: "Eintrag löschen"
                                }, {
                                  activator: withCtx(({ props }) => [
                                    createVNode(_component_v_btn, mergeProps({
                                      variant: "tonal",
                                      color: "warning",
                                      class: "array-editor__remove-item",
                                      icon: _ctx.$icons.mdiDelete,
                                      onClick: $event => (_ctx.removeValue(item)),
                                      ref_for: true
                                    }, props), null, 16, ["icon", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["title"]))
                        }), 256))
                      ]),
                      _: 1
                    }))
                  : createCommentVNode("", true),
                createVNode(_component_v_card_actions, null, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_5$4, [
                      (openBlock(), createBlock(resolveDynamicComponent(_ctx.newValueNode.componentName), {
                        data: _ctx.newValueNode,
                        "is-expanded": "",
                        "hide-title": "",
                        "is-frameless": ""
                      }, null, 8, ["data"])),
                      createVNode(_component_v_btn, {
                        class: "ml-2 mb-2",
                        variant: "tonal",
                        color: "success",
                        "prepend-icon": _ctx.$icons.mdiPlus,
                        onClick: _ctx.addValue
                      }, {
                        default: withCtx(() => _cache[4] || (_cache[4] = [
                          createTextVNode("Wert hinzufügen")
                        ])),
                        _: 1
                      }, 8, ["prepend-icon", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-active", "onCancel", "onOk"])
  ]))
}

class ValuePoolService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "valuepools"), middlewareFactory, snackbarService);
    }
    async get(name) {
        let response = await this.client.get(name);
        return await response.json();
    }
    async update(name, valueType, values) {
        let request = {
            valueType: valueType,
            values: values
        };
        let response = await this.client.put(name, {
            json: request
        });
        return await response.json();
    }
}
ValuePoolService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], ValuePoolService);

IconRegistry.add({
    mdiPlus,
    mdiPencil
});
class ValuePoolEditor extends EditorBase {
    get poolName() {
        return this.data.schema.valuepoolName;
    }
    get displayValues() {
        return this.values.map((value)=>{
            return {
                title: this.getText(value),
                value: value,
                disabled: false
            };
        });
    }
    get allowMultiple() {
        return this.data.schema.type === "array" || Array.isArray(this.data.schema.type) && this.data.schema.type.includes("array");
    }
    get allowNull() {
        return Array.isArray(this.data.schema.type) && this.data.schema.type.includes("null");
    }
    get value() {
        return this.model;
    }
    set value(value) {
        this.searchText = "";
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: value
        });
    }
    async created() {
        this.isLoading = true;
        try {
            let pool = await this.service.get(this.poolName);
            this.values = pool.values ?? [];
            // set default if we can't be null and we're not a collection
            if ((this.value == null || this.value.length === 0) && !this.allowNull && this.values.length > 0 && !this.allowMultiple) {
                this.value = this.values[0];
            }
        } catch (e) {
            this.notificationService.showError("Werte-Pool konnte nicht geladen werden.", e);
        }
        this.isLoading = false;
    }
    getText(value) {
        if (Multilingual.is(value)) {
            return Multilingual.getValue(value);
        } else if (typeof value === "object") {
            return JSON.stringify(value);
        }
        return value.toString();
    }
    async openCreatePane() {
        // clone the item schema and remove the "format" keyword because we want to edit the underlying data
        let itemSchema = this.allowMultiple ? Object.assign({}, this.data.schema.items) : Object.assign({}, this.data.schema);
        delete itemSchema.valuepoolName;
        delete itemSchema.valuepoolType;
        this.newValueNode = await this.editorFactory.createRoot(itemSchema, this.editorFactory.createInstance(itemSchema));
        this.editableValues = Array.from(this.values);
        this.newValueSchema = itemSchema;
        this.isEditPaneOpen = true;
        eventBus.on(PatchEvent, this.onNewValuePatched);
    }
    onNewValuePatched(e) {
        // re-assign because the root could be a value type (f.ex. string)
        // we're not concerned with keeping the reference
        this.newValueNode.model = jsonpatch.applyOperation(this.newValueNode.model, e.op, false).newDocument;
    }
    async addValue() {
        if (this.newValueSchema == null) {
            return;
        }
        this.editableValues.unshift(this.newValueNode.model);
        this.newValueNode = null;
        await this.$nextTick();
        this.newValueNode = await this.editorFactory.createRoot(this.newValueSchema, this.editorFactory.createInstance(this.newValueSchema));
    }
    removeValue(value) {
        this.editableValues = this.editableValues.filter((v)=>!this.compareValues(v, value));
    }
    async onEditOk(pool) {
        this.isEditPaneOpen = false;
        eventBus.off(PatchEvent, this.onNewValuePatched);
        this.isLoading = true;
        try {
            let pool = await this.service.update(this.poolName, this.data.schema.valuepoolType, this.editableValues);
            this.values = pool.values;
            // make sure we have set an existing value after updating the pool values
            if (this.allowMultiple) {
                this.value = this.value.filter((candidate)=>this.values.some((v)=>this.compareValues(candidate, v)));
            } else {
                if (!this.values.some((v)=>this.compareValues(this.value, v))) {
                    this.value = null;
                }
            }
        } catch (e) {
            this.notificationService.showError("Der Werte-Pool konnte nicht gespeichert werden.", e);
        }
        this.isLoading = false;
    }
    onEditCancel() {
        this.isEditPaneOpen = false;
        eventBus.off(PatchEvent, this.onNewValuePatched);
        this.editableValues = [];
        this.newValueNode = null;
    }
    compareValues(a, b) {
        //console.log({
        //	a: JSON.stringify(a),
        //	b: JSON.stringify(b),
        //	same: JSON.stringify(a) === JSON.stringify(b)
        //});
        return JSON.stringify(a) === JSON.stringify(b);
    }
    constructor(...args){
        super(...args), this.isEditPaneOpen = false, this.newValueSchema = null, this.newValueNode = null, this.editableValues = [], this.searchText = "", this.values = [], this.isLoading = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof ValuePoolService === "undefined" ? Object : ValuePoolService)
], ValuePoolEditor.prototype, "service", void 0);
_([
    AutoInject,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], ValuePoolEditor.prototype, "editorFactory", void 0);
ValuePoolEditor = _([
    Component({
        render: render$o,
        components: {
            TagSelector: TagSelectorComponent
        }
    })
], ValuePoolEditor);
EditorFactory.registerEditor({
    type: ValuePoolEditor,
    predicate: (schema, typeName)=>schema.valuepoolName != null,
    priority: 0
});

const _hoisted_1$c = { class: "editor-base editor-base--complex" };
const _hoisted_2$7 = {
  key: 0,
  class: "editor-base__title"
};
const _hoisted_3$6 = {
  key: 1,
  class: "editor-base__description"
};

function render$n(_ctx, _cache) {
  const _component_url_picker = resolveComponent("url-picker");

  return (openBlock(), createElementBlock("div", _hoisted_1$c, [
    (!_ctx.hideTitle)
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          (_ctx.title)
            ? (openBlock(), createElementBlock("h2", _hoisted_2$7, toDisplayString(_ctx.title), 1))
            : createCommentVNode("", true),
          (_ctx.description)
            ? (openBlock(), createElementBlock("p", _hoisted_3$6, toDisplayString(_ctx.description), 1))
            : createCommentVNode("", true)
        ], 64))
      : createCommentVNode("", true),
    createVNode(_component_url_picker, {
      disabled: _ctx.isReadOnly,
      modelValue: _ctx.model,
      "onUpdate:modelValue": _ctx.onPickerInput
    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
  ]))
}

IconRegistry.add({
    mdiWeb
});
class UrlEditor extends EditorBase {
    get isEmpty() {
        return isNullOrEmpty(this.model);
    }
    mounted() {
        this.onModelChanged();
    }
    onModelChanged() {
        if (isNullOrEmpty(this.model)) {
            this.selector = null;
            return;
        }
        this.selector = IdSelector.fromUrl(this.model);
    }
    onPickerInput(url) {
        this.commitPatch({
            op: "replace",
            path: this.data.path,
            value: url
        });
    }
    constructor(...args){
        super(...args), this.selector = null;
    }
}
_([
    Watch(nameof("model")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], UrlEditor.prototype, "onModelChanged", null);
UrlEditor = _([
    Component({
        render: render$n
    })
], UrlEditor);
EditorFactory.registerEditor({
    type: UrlEditor,
    predicate: (schema, typeName)=>schema.format === "Url",
    priority: 0,
    editorType: EditorType.Complex,
    customization: (node, factory)=>{
        node.getDisplayValue = ()=>{
            let value = node.model;
            let selector = IdSelector.fromUrl(node.model);
            if (selector != null) {
                value = `${Multilingual.getValue(selector.displayName)} <em>(${getEntityKindDisplayName(selector.kind)})</em>`;
            }
            return {
                isValueHtml: true,
                value
            };
        };
    }
});

const _hoisted_1$b = { class: "h-100" };
const _hoisted_2$6 = ["src"];

function render$m(_ctx, _cache) {
  return (openBlock(), createElementBlock("div", _hoisted_1$b, [
    (_ctx.iframeSrc != null)
      ? (openBlock(), createElementBlock("iframe", {
          key: 0,
          class: "plausible-dashboard-embed",
          src: _ctx.iframeSrc,
          frameborder: "0"
        }, null, 8, _hoisted_2$6))
      : createCommentVNode("", true)
  ]))
}

class PlausibleAnalyticsDashboard extends Vue {
    get iframeSrc() {
        let sharedLink = this.sharedLink ?? this.configStore.configuration.appSettings["PlausibleAnalyticsDashboard"];
        if (sharedLink == null) {
            return "";
        }
        let url = new URL(sharedLink);
        url.searchParams.append("embed", "true");
        url.searchParams.append("theme", "light");
        url.searchParams.append("background", "transparent");
        return url.toString();
    }
    constructor(...args){
        super(...args), this.configStore = new ConfigurationModule();
    }
}
_([
    Prop({
        required: false
    }),
    _$1("design:type", Object)
], PlausibleAnalyticsDashboard.prototype, "sharedLink", void 0);
PlausibleAnalyticsDashboard = _([
    Component({
        render: render$m
    })
], PlausibleAnalyticsDashboard);

function render$l(_ctx, _cache) {
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_dialog = resolveComponent("v-dialog");

  return (openBlock(), createBlock(_component_v_dialog, {
    persistent: "",
    "max-width": 450,
    modelValue: _ctx.isOpen
  }, {
    default: withCtx(() => [
      createVNode(_component_v_card, null, {
        default: withCtx(() => [
          createVNode(_component_v_card_title, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ]),
            _: 1
          }),
          createVNode(_component_v_card_text, { innerHTML: _ctx.textHtml }, null, 8, ["innerHTML"]),
          createVNode(_component_v_card_actions, null, {
            default: withCtx(() => [
              createVNode(_component_v_spacer),
              createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.cancel
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.cancelLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              createVNode(_component_v_btn, {
                color: "primary",
                onClick: _ctx.confirm
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.confirmLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}

class ConfirmDialog extends Vue {
    confirm() {
        this.callback(true);
    }
    cancel() {
        this.callback(false);
    }
    static createPlugin() {
        const rootElement = document.body;
        const container = document.createElement("div");
        return {
            install: (app)=>{
                app.config.globalProperties.$confirm = (options)=>{
                    return new Promise((resolve)=>{
                        const componentApp = createApp(ConfirmDialog, {
                            ...options,
                            modelValue: true,
                            callback (result) {
                                resolve(result);
                                setTimeout(()=>{
                                    componentApp.unmount();
                                    container.remove();
                                }, 500);
                            }
                        });
                        Object.assign(componentApp._context, app._context);
                        rootElement.appendChild(container);
                        componentApp.mount(container);
                    });
                };
            }
        };
    }
}
_([
    Prop(),
    _$1("design:type", String)
], ConfirmDialog.prototype, "title", void 0);
_([
    Prop(),
    _$1("design:type", String)
], ConfirmDialog.prototype, "textHtml", void 0);
_([
    Prop(),
    _$1("design:type", String)
], ConfirmDialog.prototype, "cancelLabel", void 0);
_([
    Prop(),
    _$1("design:type", String)
], ConfirmDialog.prototype, "confirmLabel", void 0);
_([
    Prop(),
    _$1("design:type", Function)
], ConfirmDialog.prototype, "callback", void 0);
_([
    Model(),
    _$1("design:type", Boolean)
], ConfirmDialog.prototype, "isOpen", void 0);
ConfirmDialog = _([
    Component({
        render: render$l
    })
], ConfirmDialog);

const __vite_glob_0_1 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get ConfirmDialog () { return ConfirmDialog; }
}, Symbol.toStringTag, { value: 'Module' }));

function render$k(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_sheet = resolveComponent("v-sheet");

  return (openBlock(), createBlock(_component_v_sheet, {
    rounded: "circle",
    color: _ctx.color,
    style: {"line-height":"1"}
  }, {
    default: withCtx(() => [
      createVNode(_component_v_icon, {
        class: "ma-1",
        size: "x-small",
        icon: _ctx.icon
      }, null, 8, ["icon"]),
      createVNode(_component_v_tooltip, {
        activator: "parent",
        text: _ctx.text
      }, null, 8, ["text"])
    ]),
    _: 1
  }, 8, ["color"]))
}

IconRegistry.add({
    mdiPencil,
    mdiCheckBold
});
class PublishStatusIcon extends Vue {
    get icon() {
        return this.value ? mdiCheckBold : mdiPencil;
    }
    get color() {
        return this.value ? "success" : "info";
    }
    get text() {
        return this.value ? "Publiziert" : "Entwurf";
    }
}
_([
    Model(),
    _$1("design:type", Boolean)
], PublishStatusIcon.prototype, "value", void 0);
PublishStatusIcon = _([
    Component({
        render: render$k
    })
], PublishStatusIcon);

const __vite_glob_0_9 = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	get PublishStatusIcon () { return PublishStatusIcon; }
}, Symbol.toStringTag, { value: 'Module' }));

const de = {
  badge: 'Abzeichen',
  open: 'Öffnen',
  close: 'Schließen',
  dismiss: 'Verwerfen',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Abbrechen'
  },
  dataIterator: {
    noResultsText: 'Keine Elemente gefunden',
    loadingText: 'Lade Elemente...'
  },
  dataTable: {
    itemsPerPageText: 'Zeilen pro Seite:',
    ariaLabel: {
      sortDescending: 'Absteigend sortiert.',
      sortAscending: 'Aufsteigend sortiert.',
      sortNone: 'Nicht sortiert.',
      activateNone: 'Aktivieren um Sortierung zu entfernen.',
      activateDescending: 'Aktivieren um absteigend zu sortieren.',
      activateAscending: 'Aktivieren um aufsteigend zu sortieren.'
    },
    sortBy: 'Sortiere nach'
  },
  dataFooter: {
    itemsPerPageText: 'Elemente pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    pageText: '{0}-{1} von {2}'
  },
  dateRangeInput: {
    divider: 'bis'
  },
  datePicker: {
    itemsSelected: '{0} ausgewählt',
    range: {
      title: 'Daten auswählen',
      header: 'Daten eingeben'
    },
    title: 'Datum auswählen',
    header: 'Datum eingeben',
    input: {
      placeholder: 'Datum eingeben'
    }
  },
  noDataText: 'Keine Daten vorhanden',
  carousel: {
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
    ariaLabel: {
      delimiter: 'Element {0} von {1}'
    }
  },
  calendar: {
    moreEvents: '{0} mehr',
    today: 'Heute'
  },
  input: {
    clear: '{0} leeren',
    prependAction: '{0} vorangestellte Aktion',
    appendAction: '{0} angehängte Aktion',
    otp: 'Bitte OTP-Zeichen {0} eingeben'
  },
  fileInput: {
    counter: '{0} Dateien',
    counterSize: '{0} Dateien ({1} gesamt)'
  },
  fileUpload: {
    title: 'Drag and drop files here',
    divider: 'or',
    browse: 'Browse Files'
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Uhrzeit auswählen'
  },
  pagination: {
    ariaLabel: {
      root: 'Seitennavigation',
      next: 'Nächste Seite',
      previous: 'Vorherige Seite',
      page: 'Gehe zu Seite {0}',
      currentPage: 'Aktuelle Seite, Seite {0}',
      first: 'Erste Seite',
      last: 'Letzte Seite'
    }
  },
  stepper: {
    next: 'Weiter',
    prev: 'Zurück'
  },
  rating: {
    ariaLabel: {
      item: 'Bewertung {0} von {1}'
    }
  },
  loading: 'Laden...',
  infiniteScroll: {
    loadMore: 'Mehr laden',
    empty: 'Nichts weiteres'
  }
};

const makeVAppProps = propsFactory({
  ...makeComponentProps(),
  ...makeLayoutProps({
    fullHeight: true
  }),
  ...makeThemeProps()
}, 'VApp');
const VApp = genericComponent()({
  name: 'VApp',
  props: makeVAppProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const theme = provideTheme(props);
    const {
      layoutClasses,
      getLayoutItem,
      items,
      layoutRef
    } = createLayout(props);
    const {
      rtlClasses
    } = useRtl();
    useRender(() => createVNode("div", {
      "ref": layoutRef,
      "class": ['v-application', theme.themeClasses.value, layoutClasses.value, rtlClasses.value, props.class],
      "style": [props.style]
    }, [createVNode("div", {
      "class": "v-application__wrap"
    }, [slots.default?.()])]));
    return {
      getLayoutItem,
      items,
      theme
    };
  }
});

// Utilities
// Composables
const makeTagProps = propsFactory({
  tag: {
    type: String,
    default: 'div'
  }
}, 'tag');

const makeVToolbarTitleProps = propsFactory({
  text: String,
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VToolbarTitle');
const VToolbarTitle = genericComponent()({
  name: 'VToolbarTitle',
  props: makeVToolbarTitleProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => {
      const hasText = !!(slots.default || slots.text || props.text);
      return createVNode(props.tag, {
        "class": ['v-toolbar-title', props.class],
        "style": props.style
      }, {
        default: () => [hasText && createVNode("div", {
          "class": "v-toolbar-title__placeholder"
        }, [slots.text ? slots.text() : props.text, slots.default?.()])]
      });
    });
    return {};
  }
});

// Utilities
const makeTransitionProps$1 = propsFactory({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, 'transition');
function createCssTransition(name, origin, mode) {
  return genericComponent()({
    name,
    props: makeTransitionProps$1({
      mode,
      origin
    }),
    setup(props, _ref) {
      let {
        slots
      } = _ref;
      const functions = {
        onBeforeEnter(el) {
          if (props.origin) {
            el.style.transformOrigin = props.origin;
          }
        },
        onLeave(el) {
          if (props.leaveAbsolute) {
            const {
              offsetTop,
              offsetLeft,
              offsetWidth,
              offsetHeight
            } = el;
            el._transitionInitialStyles = {
              position: el.style.position,
              top: el.style.top,
              left: el.style.left,
              width: el.style.width,
              height: el.style.height
            };
            el.style.position = 'absolute';
            el.style.top = `${offsetTop}px`;
            el.style.left = `${offsetLeft}px`;
            el.style.width = `${offsetWidth}px`;
            el.style.height = `${offsetHeight}px`;
          }
          if (props.hideOnLeave) {
            el.style.setProperty('display', 'none', 'important');
          }
        },
        onAfterLeave(el) {
          if (props.leaveAbsolute && el?._transitionInitialStyles) {
            const {
              position,
              top,
              left,
              width,
              height
            } = el._transitionInitialStyles;
            delete el._transitionInitialStyles;
            el.style.position = position || '';
            el.style.top = top || '';
            el.style.left = left || '';
            el.style.width = width || '';
            el.style.height = height || '';
          }
        }
      };
      return () => {
        const tag = props.group ? TransitionGroup : Transition;
        return h(tag, {
          name: props.disabled ? '' : name,
          css: !props.disabled,
          ...(props.group ? undefined : {
            mode: props.mode
          }),
          ...(props.disabled ? {} : functions)
        }, slots.default);
      };
    }
  });
}
function createJavascriptTransition(name, functions) {
  let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
  return genericComponent()({
    name,
    props: {
      mode: {
        type: String,
        default: mode
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(props, _ref2) {
      let {
        slots
      } = _ref2;
      const tag = props.group ? TransitionGroup : Transition;
      return () => {
        return h(tag, {
          name: props.disabled ? '' : name,
          css: !props.disabled,
          // mode: props.mode, // TODO: vuejs/vue-next#3104
          ...(props.disabled ? {} : functions)
        }, slots.default);
      };
    }
  });
}

// Utilities
function ExpandTransitionGenerator () {
  let expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const sizeProperty = x ? 'width' : 'height';
  const offsetProperty = camelize(`offset-${sizeProperty}`);
  return {
    onBeforeEnter(el) {
      el._parent = el.parentNode;
      el._initialStyle = {
        transition: el.style.transition,
        overflow: el.style.overflow,
        [sizeProperty]: el.style[sizeProperty]
      };
    },
    onEnter(el) {
      const initialStyle = el._initialStyle;
      el.style.setProperty('transition', 'none', 'important');
      // Hide overflow to account for collapsed margins in the calculated height
      el.style.overflow = 'hidden';
      const offset = `${el[offsetProperty]}px`;
      el.style[sizeProperty] = '0';
      void el.offsetHeight; // force reflow

      el.style.transition = initialStyle.transition;
      if (expandedParentClass && el._parent) {
        el._parent.classList.add(expandedParentClass);
      }
      requestAnimationFrame(() => {
        el.style[sizeProperty] = offset;
      });
    },
    onAfterEnter: resetStyles,
    onEnterCancelled: resetStyles,
    onLeave(el) {
      el._initialStyle = {
        transition: '',
        overflow: el.style.overflow,
        [sizeProperty]: el.style[sizeProperty]
      };
      el.style.overflow = 'hidden';
      el.style[sizeProperty] = `${el[offsetProperty]}px`;
      void el.offsetHeight; // force reflow

      requestAnimationFrame(() => el.style[sizeProperty] = '0');
    },
    onAfterLeave,
    onLeaveCancelled: onAfterLeave
  };
  function onAfterLeave(el) {
    if (expandedParentClass && el._parent) {
      el._parent.classList.remove(expandedParentClass);
    }
    resetStyles(el);
  }
  function resetStyles(el) {
    const size = el._initialStyle[sizeProperty];
    el.style.overflow = el._initialStyle.overflow;
    if (size != null) el.style[sizeProperty] = size;
    delete el._initialStyle;
  }
}

const makeVDialogTransitionProps = propsFactory({
  target: [Object, Array]
}, 'v-dialog-transition');
const VDialogTransition = genericComponent()({
  name: 'VDialogTransition',
  props: makeVDialogTransitionProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const functions = {
      onBeforeEnter(el) {
        el.style.pointerEvents = 'none';
        el.style.visibility = 'hidden';
      },
      async onEnter(el, done) {
        await new Promise(resolve => requestAnimationFrame(resolve));
        await new Promise(resolve => requestAnimationFrame(resolve));
        el.style.visibility = '';
        const {
          x,
          y,
          sx,
          sy,
          speed
        } = getDimensions(props.target, el);
        const animation = animate(el, [{
          transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
          opacity: 0
        }, {}], {
          duration: 225 * speed,
          easing: deceleratedEasing
        });
        getChildren(el)?.forEach(el => {
          animate(el, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * speed,
            easing: standardEasing
          });
        });
        animation.finished.then(() => done());
      },
      onAfterEnter(el) {
        el.style.removeProperty('pointer-events');
      },
      onBeforeLeave(el) {
        el.style.pointerEvents = 'none';
      },
      async onLeave(el, done) {
        await new Promise(resolve => requestAnimationFrame(resolve));
        const {
          x,
          y,
          sx,
          sy,
          speed
        } = getDimensions(props.target, el);
        const animation = animate(el, [{}, {
          transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
          opacity: 0
        }], {
          duration: 125 * speed,
          easing: acceleratedEasing
        });
        animation.finished.then(() => done());
        getChildren(el)?.forEach(el => {
          animate(el, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * speed,
            easing: standardEasing
          });
        });
      },
      onAfterLeave(el) {
        el.style.removeProperty('pointer-events');
      }
    };
    return () => {
      return props.target ? createVNode(Transition, mergeProps({
        "name": "dialog-transition"
      }, functions, {
        "css": false
      }), slots) : createVNode(Transition, {
        "name": "dialog-transition"
      }, slots);
    };
  }
});

/** Animatable children (card, sheet, list) */
function getChildren(el) {
  const els = el.querySelector(':scope > .v-card, :scope > .v-sheet, :scope > .v-list')?.children;
  return els && [...els];
}
function getDimensions(target, el) {
  const targetBox = getTargetBox(target);
  const elBox = nullifyTransforms(el);
  const [originX, originY] = getComputedStyle(el).transformOrigin.split(' ').map(v => parseFloat(v));
  const [anchorSide, anchorOffset] = getComputedStyle(el).getPropertyValue('--v-overlay-anchor-origin').split(' ');
  let offsetX = targetBox.left + targetBox.width / 2;
  if (anchorSide === 'left' || anchorOffset === 'left') {
    offsetX -= targetBox.width / 2;
  } else if (anchorSide === 'right' || anchorOffset === 'right') {
    offsetX += targetBox.width / 2;
  }
  let offsetY = targetBox.top + targetBox.height / 2;
  if (anchorSide === 'top' || anchorOffset === 'top') {
    offsetY -= targetBox.height / 2;
  } else if (anchorSide === 'bottom' || anchorOffset === 'bottom') {
    offsetY += targetBox.height / 2;
  }
  const tsx = targetBox.width / elBox.width;
  const tsy = targetBox.height / elBox.height;
  const maxs = Math.max(1, tsx, tsy);
  const sx = tsx / maxs || 0;
  const sy = tsy / maxs || 0;

  // Animate elements larger than 12% of the screen area up to 1.5x slower
  const asa = elBox.width * elBox.height / (window.innerWidth * window.innerHeight);
  const speed = asa > 0.12 ? Math.min(1.5, (asa - 0.12) * 10 + 1) : 1;
  return {
    x: offsetX - (originX + elBox.left),
    y: offsetY - (originY + elBox.top),
    sx,
    sy,
    speed
  };
}

createCssTransition('fab-transition', 'center center', 'out-in');

// Generic transitions
const VDialogBottomTransition = createCssTransition('dialog-bottom-transition');
createCssTransition('dialog-top-transition');
const VFadeTransition = createCssTransition('fade-transition');
const VScaleTransition = createCssTransition('scale-transition');
createCssTransition('scroll-x-transition');
createCssTransition('scroll-x-reverse-transition');
createCssTransition('scroll-y-transition');
createCssTransition('scroll-y-reverse-transition');
createCssTransition('slide-x-transition');
const VSlideXReverseTransition = createCssTransition('slide-x-reverse-transition');
const VSlideYTransition = createCssTransition('slide-y-transition');
createCssTransition('slide-y-reverse-transition');

// Javascript transitions
const VExpandTransition = createJavascriptTransition('expand-transition', ExpandTransitionGenerator());
const VExpandXTransition = createJavascriptTransition('expand-x-transition', ExpandTransitionGenerator('', true));

// Composables
const makeVDefaultsProviderProps = propsFactory({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, 'VDefaultsProvider');
const VDefaultsProvider = genericComponent(false)({
  name: 'VDefaultsProvider',
  props: makeVDefaultsProviderProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      defaults,
      disabled,
      reset,
      root,
      scoped
    } = toRefs(props);
    provideDefaults(defaults, {
      reset,
      root,
      scoped,
      disabled
    });
    return () => slots.default?.();
  }
});

// Utilities
// Composables
const makeDimensionProps = propsFactory({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, 'dimension');
function useDimension(props) {
  const dimensionStyles = computed(() => {
    const styles = {};
    const height = convertToUnit(props.height);
    const maxHeight = convertToUnit(props.maxHeight);
    const maxWidth = convertToUnit(props.maxWidth);
    const minHeight = convertToUnit(props.minHeight);
    const minWidth = convertToUnit(props.minWidth);
    const width = convertToUnit(props.width);
    if (height != null) styles.height = height;
    if (maxHeight != null) styles.maxHeight = maxHeight;
    if (maxWidth != null) styles.maxWidth = maxWidth;
    if (minHeight != null) styles.minHeight = minHeight;
    if (minWidth != null) styles.minWidth = minWidth;
    if (width != null) styles.width = width;
    return styles;
  });
  return {
    dimensionStyles
  };
}

function useAspectStyles(props) {
  return {
    aspectStyles: computed(() => {
      const ratio = Number(props.aspectRatio);
      return ratio ? {
        paddingBottom: String(1 / ratio * 100) + '%'
      } : undefined;
    })
  };
}
const makeVResponsiveProps = propsFactory({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps()
}, 'VResponsive');
const VResponsive = genericComponent()({
  name: 'VResponsive',
  props: makeVResponsiveProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      aspectStyles
    } = useAspectStyles(props);
    const {
      dimensionStyles
    } = useDimension(props);
    useRender(() => createVNode("div", {
      "class": ['v-responsive', {
        'v-responsive--inline': props.inline
      }, props.class],
      "style": [dimensionStyles.value, props.style]
    }, [createVNode("div", {
      "class": "v-responsive__sizer",
      "style": aspectStyles.value
    }, null), slots.additional?.(), slots.default && createVNode("div", {
      "class": ['v-responsive__content', props.contentClass]
    }, [slots.default()])]));
    return {};
  }
});

// Utilities
// Composables
function useColor(colors) {
  return destructComputed(() => {
    const classes = [];
    const styles = {};
    if (colors.value.background) {
      if (isCssColor(colors.value.background)) {
        styles.backgroundColor = colors.value.background;
        if (!colors.value.text && isParsableColor(colors.value.background)) {
          const backgroundColor = parseColor(colors.value.background);
          if (backgroundColor.a == null || backgroundColor.a === 1) {
            const textColor = getForeground(backgroundColor);
            styles.color = textColor;
            styles.caretColor = textColor;
          }
        }
      } else {
        classes.push(`bg-${colors.value.background}`);
      }
    }
    if (colors.value.text) {
      if (isCssColor(colors.value.text)) {
        styles.color = colors.value.text;
        styles.caretColor = colors.value.text;
      } else {
        classes.push(`text-${colors.value.text}`);
      }
    }
    return {
      colorClasses: classes,
      colorStyles: styles
    };
  });
}
function useTextColor(props, name) {
  const colors = computed(() => ({
    text: isRef(props) ? props.value : name ? props[name] : null
  }));
  const {
    colorClasses: textColorClasses,
    colorStyles: textColorStyles
  } = useColor(colors);
  return {
    textColorClasses,
    textColorStyles
  };
}
function useBackgroundColor(props, name) {
  const colors = computed(() => ({
    background: isRef(props) ? props.value : name ? props[name] : null
  }));
  const {
    colorClasses: backgroundColorClasses,
    colorStyles: backgroundColorStyles
  } = useColor(colors);
  return {
    backgroundColorClasses,
    backgroundColorStyles
  };
}

// Utilities
// Composables
const makeRoundedProps = propsFactory({
  rounded: {
    type: [Boolean, Number, String],
    default: undefined
  },
  tile: Boolean
}, 'rounded');
function useRounded(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const roundedClasses = computed(() => {
    const rounded = isRef(props) ? props.value : props.rounded;
    const tile = isRef(props) ? props.value : props.tile;
    const classes = [];
    if (rounded === true || rounded === '') {
      classes.push(`${name}--rounded`);
    } else if (typeof rounded === 'string' || rounded === 0) {
      for (const value of String(rounded).split(' ')) {
        classes.push(`rounded-${value}`);
      }
    } else if (tile || rounded === false) {
      classes.push('rounded-0');
    }
    return classes;
  });
  return {
    roundedClasses
  };
}

// Utilities
const makeTransitionProps = propsFactory({
  transition: {
    type: [Boolean, String, Object],
    default: 'fade-transition',
    validator: val => val !== true
  }
}, 'transition');
const MaybeTransition = (props, _ref) => {
  let {
    slots
  } = _ref;
  const {
    transition,
    disabled,
    group,
    ...rest
  } = props;
  const {
    component = group ? TransitionGroup : Transition,
    ...customProps
  } = typeof transition === 'object' ? transition : {};
  return h(component, mergeProps(typeof transition === 'string' ? {
    name: disabled ? '' : transition
  } : customProps, typeof transition === 'string' ? {} : Object.fromEntries(Object.entries({
    disabled,
    group
  }).filter(_ref2 => {
    let [_, v] = _ref2;
    return v !== undefined;
  })), rest), slots);
};

// Utilities
function mounted$3(el, binding) {
  if (!SUPPORTS_INTERSECTION) return;
  const modifiers = binding.modifiers || {};
  const value = binding.value;
  const {
    handler,
    options
  } = typeof value === 'object' ? value : {
    handler: value,
    options: {}
  };
  const observer = new IntersectionObserver(function () {
    let entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let observer = arguments.length > 1 ? arguments[1] : undefined;
    const _observe = el._observe?.[binding.instance.$.uid];
    if (!_observe) return; // Just in case, should never fire

    const isIntersecting = entries.some(entry => entry.isIntersecting);

    // If is not quiet or has already been
    // initted, invoke the user callback
    if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) {
      handler(isIntersecting, entries, observer);
    }
    if (isIntersecting && modifiers.once) unmounted$3(el, binding);else _observe.init = true;
  }, options);
  el._observe = Object(el._observe);
  el._observe[binding.instance.$.uid] = {
    init: false,
    observer
  };
  observer.observe(el);
}
function unmounted$3(el, binding) {
  const observe = el._observe?.[binding.instance.$.uid];
  if (!observe) return;
  observe.observer.unobserve(el);
  delete el._observe[binding.instance.$.uid];
}
const Intersect = {
  mounted: mounted$3,
  unmounted: unmounted$3
};

// not intended for public use, this is passed in by vuetify-loader
const makeVImgProps = propsFactory({
  absolute: Boolean,
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: undefined
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: undefined,
      rootMargin: undefined,
      threshold: undefined
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ''
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...makeVResponsiveProps(),
  ...makeComponentProps(),
  ...makeRoundedProps(),
  ...makeTransitionProps()
}, 'VImg');
const VImg = genericComponent()({
  name: 'VImg',
  directives: {
    intersect: Intersect
  },
  props: makeVImgProps(),
  emits: {
    loadstart: value => true,
    load: value => true,
    error: value => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      roundedClasses
    } = useRounded(props);
    const vm = getCurrentInstance('VImg');
    const currentSrc = shallowRef(''); // Set from srcset
    const image = ref();
    const state = shallowRef(props.eager ? 'loading' : 'idle');
    const naturalWidth = shallowRef();
    const naturalHeight = shallowRef();
    const normalisedSrc = computed(() => {
      return props.src && typeof props.src === 'object' ? {
        src: props.src.src,
        srcset: props.srcset || props.src.srcset,
        lazySrc: props.lazySrc || props.src.lazySrc,
        aspect: Number(props.aspectRatio || props.src.aspect || 0)
      } : {
        src: props.src,
        srcset: props.srcset,
        lazySrc: props.lazySrc,
        aspect: Number(props.aspectRatio || 0)
      };
    });
    const aspectRatio = computed(() => {
      return normalisedSrc.value.aspect || naturalWidth.value / naturalHeight.value || 0;
    });
    watch(() => props.src, () => {
      init(state.value !== 'idle');
    });
    watch(aspectRatio, (val, oldVal) => {
      if (!val && oldVal && image.value) {
        pollForSize(image.value);
      }
    });

    // TODO: getSrc when window width changes

    onBeforeMount(() => init());
    function init(isIntersecting) {
      if (props.eager && isIntersecting) return;
      if (SUPPORTS_INTERSECTION && !isIntersecting && !props.eager) return;
      state.value = 'loading';
      if (normalisedSrc.value.lazySrc) {
        const lazyImg = new Image();
        lazyImg.src = normalisedSrc.value.lazySrc;
        pollForSize(lazyImg, null);
      }
      if (!normalisedSrc.value.src) return;
      nextTick(() => {
        emit('loadstart', image.value?.currentSrc || normalisedSrc.value.src);
        setTimeout(() => {
          if (vm.isUnmounted) return;
          if (image.value?.complete) {
            if (!image.value.naturalWidth) {
              onError();
            }
            if (state.value === 'error') return;
            if (!aspectRatio.value) pollForSize(image.value, null);
            if (state.value === 'loading') onLoad();
          } else {
            if (!aspectRatio.value) pollForSize(image.value);
            getSrc();
          }
        });
      });
    }
    function onLoad() {
      if (vm.isUnmounted) return;
      getSrc();
      pollForSize(image.value);
      state.value = 'loaded';
      emit('load', image.value?.currentSrc || normalisedSrc.value.src);
    }
    function onError() {
      if (vm.isUnmounted) return;
      state.value = 'error';
      emit('error', image.value?.currentSrc || normalisedSrc.value.src);
    }
    function getSrc() {
      const img = image.value;
      if (img) currentSrc.value = img.currentSrc || img.src;
    }
    let timer = -1;
    onBeforeUnmount(() => {
      clearTimeout(timer);
    });
    function pollForSize(img) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      const poll = () => {
        clearTimeout(timer);
        if (vm.isUnmounted) return;
        const {
          naturalHeight: imgHeight,
          naturalWidth: imgWidth
        } = img;
        if (imgHeight || imgWidth) {
          naturalWidth.value = imgWidth;
          naturalHeight.value = imgHeight;
        } else if (!img.complete && state.value === 'loading' && timeout != null) {
          timer = window.setTimeout(poll, timeout);
        } else if (img.currentSrc.endsWith('.svg') || img.currentSrc.startsWith('data:image/svg+xml')) {
          naturalWidth.value = 1;
          naturalHeight.value = 1;
        }
      };
      poll();
    }
    const containClasses = computed(() => ({
      'v-img__img--cover': props.cover,
      'v-img__img--contain': !props.cover
    }));
    const __image = () => {
      if (!normalisedSrc.value.src || state.value === 'idle') return null;
      const img = createVNode("img", {
        "class": ['v-img__img', containClasses.value],
        "style": {
          objectPosition: props.position
        },
        "src": normalisedSrc.value.src,
        "srcset": normalisedSrc.value.srcset,
        "alt": props.alt,
        "crossorigin": props.crossorigin,
        "referrerpolicy": props.referrerpolicy,
        "draggable": props.draggable,
        "sizes": props.sizes,
        "ref": image,
        "onLoad": onLoad,
        "onError": onError
      }, null);
      const sources = slots.sources?.();
      return createVNode(MaybeTransition, {
        "transition": props.transition,
        "appear": true
      }, {
        default: () => [withDirectives(sources ? createVNode("picture", {
          "class": "v-img__picture"
        }, [sources, img]) : img, [[vShow, state.value === 'loaded']])]
      });
    };
    const __preloadImage = () => createVNode(MaybeTransition, {
      "transition": props.transition
    }, {
      default: () => [normalisedSrc.value.lazySrc && state.value !== 'loaded' && createVNode("img", {
        "class": ['v-img__img', 'v-img__img--preload', containClasses.value],
        "style": {
          objectPosition: props.position
        },
        "src": normalisedSrc.value.lazySrc,
        "alt": props.alt,
        "crossorigin": props.crossorigin,
        "referrerpolicy": props.referrerpolicy,
        "draggable": props.draggable
      }, null)]
    });
    const __placeholder = () => {
      if (!slots.placeholder) return null;
      return createVNode(MaybeTransition, {
        "transition": props.transition,
        "appear": true
      }, {
        default: () => [(state.value === 'loading' || state.value === 'error' && !slots.error) && createVNode("div", {
          "class": "v-img__placeholder"
        }, [slots.placeholder()])]
      });
    };
    const __error = () => {
      if (!slots.error) return null;
      return createVNode(MaybeTransition, {
        "transition": props.transition,
        "appear": true
      }, {
        default: () => [state.value === 'error' && createVNode("div", {
          "class": "v-img__error"
        }, [slots.error()])]
      });
    };
    const __gradient = () => {
      if (!props.gradient) return null;
      return createVNode("div", {
        "class": "v-img__gradient",
        "style": {
          backgroundImage: `linear-gradient(${props.gradient})`
        }
      }, null);
    };
    const isBooted = shallowRef(false);
    {
      const stop = watch(aspectRatio, val => {
        if (val) {
          // Doesn't work with nextTick, idk why
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              isBooted.value = true;
            });
          });
          stop();
        }
      });
    }
    useRender(() => {
      const responsiveProps = VResponsive.filterProps(props);
      return withDirectives(createVNode(VResponsive, mergeProps({
        "class": ['v-img', {
          'v-img--absolute': props.absolute,
          'v-img--booting': !isBooted.value
        }, backgroundColorClasses.value, roundedClasses.value, props.class],
        "style": [{
          width: convertToUnit(props.width === 'auto' ? naturalWidth.value : props.width)
        }, backgroundColorStyles.value, props.style]
      }, responsiveProps, {
        "aspectRatio": aspectRatio.value,
        "aria-label": props.alt,
        "role": props.alt ? 'img' : undefined
      }), {
        additional: () => createVNode(Fragment, null, [createVNode(__image, null, null), createVNode(__preloadImage, null, null), createVNode(__gradient, null, null), createVNode(__placeholder, null, null), createVNode(__error, null, null)]),
        default: slots.default
      }), [[resolveDirective("intersect"), {
        handler: init,
        options: props.options
      }, null, {
        once: true
      }]]);
    });
    return {
      currentSrc,
      image,
      state,
      naturalWidth,
      naturalHeight
    };
  }
});

// Utilities
// Composables
const makeBorderProps = propsFactory({
  border: [Boolean, Number, String]
}, 'border');
function useBorder(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const borderClasses = computed(() => {
    const border = isRef(props) ? props.value : props.border;
    const classes = [];
    if (border === true || border === '') {
      classes.push(`${name}--border`);
    } else if (typeof border === 'string' || border === 0) {
      for (const value of String(border).split(' ')) {
        classes.push(`border-${value}`);
      }
    }
    return classes;
  });
  return {
    borderClasses
  };
}

// Utilities
// Composables
const makeElevationProps = propsFactory({
  elevation: {
    type: [Number, String],
    validator(v) {
      const value = parseInt(v);
      return !isNaN(value) && value >= 0 &&
      // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      value <= 24;
    }
  }
}, 'elevation');
function useElevation(props) {
  const elevationClasses = computed(() => {
    const elevation = isRef(props) ? props.value : props.elevation;
    const classes = [];
    if (elevation == null) return classes;
    classes.push(`elevation-${elevation}`);
    return classes;
  });
  return {
    elevationClasses
  };
}

const allowedDensities$1 = [null, 'prominent', 'default', 'comfortable', 'compact'];
const makeVToolbarProps = propsFactory({
  absolute: Boolean,
  collapse: Boolean,
  color: String,
  density: {
    type: String,
    default: 'default',
    validator: v => allowedDensities$1.includes(v)
  },
  extended: Boolean,
  extensionHeight: {
    type: [Number, String],
    default: 48
  },
  flat: Boolean,
  floating: Boolean,
  height: {
    type: [Number, String],
    default: 64
  },
  image: String,
  title: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: 'header'
  }),
  ...makeThemeProps()
}, 'VToolbar');
const VToolbar = genericComponent()({
  name: 'VToolbar',
  props: makeVToolbarProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      borderClasses
    } = useBorder(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      themeClasses
    } = provideTheme(props);
    const {
      rtlClasses
    } = useRtl();
    const isExtended = shallowRef(!!(props.extended || slots.extension?.()));
    const contentHeight = computed(() => parseInt(Number(props.height) + (props.density === 'prominent' ? Number(props.height) : 0) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0), 10));
    const extensionHeight = computed(() => isExtended.value ? parseInt(Number(props.extensionHeight) + (props.density === 'prominent' ? Number(props.extensionHeight) : 0) - (props.density === 'comfortable' ? 4 : 0) - (props.density === 'compact' ? 8 : 0), 10) : 0);
    provideDefaults({
      VBtn: {
        variant: 'text'
      }
    });
    useRender(() => {
      const hasTitle = !!(props.title || slots.title);
      const hasImage = !!(slots.image || props.image);
      const extension = slots.extension?.();
      isExtended.value = !!(props.extended || extension);
      return createVNode(props.tag, {
        "class": ['v-toolbar', {
          'v-toolbar--absolute': props.absolute,
          'v-toolbar--collapse': props.collapse,
          'v-toolbar--flat': props.flat,
          'v-toolbar--floating': props.floating,
          [`v-toolbar--density-${props.density}`]: true
        }, backgroundColorClasses.value, borderClasses.value, elevationClasses.value, roundedClasses.value, themeClasses.value, rtlClasses.value, props.class],
        "style": [backgroundColorStyles.value, props.style]
      }, {
        default: () => [hasImage && createVNode("div", {
          "key": "image",
          "class": "v-toolbar__image"
        }, [!slots.image ? createVNode(VImg, {
          "key": "image-img",
          "cover": true,
          "src": props.image
        }, null) : createVNode(VDefaultsProvider, {
          "key": "image-defaults",
          "disabled": !props.image,
          "defaults": {
            VImg: {
              cover: true,
              src: props.image
            }
          }
        }, slots.image)]), createVNode(VDefaultsProvider, {
          "defaults": {
            VTabs: {
              height: convertToUnit(contentHeight.value)
            }
          }
        }, {
          default: () => [createVNode("div", {
            "class": "v-toolbar__content",
            "style": {
              height: convertToUnit(contentHeight.value)
            }
          }, [slots.prepend && createVNode("div", {
            "class": "v-toolbar__prepend"
          }, [slots.prepend?.()]), hasTitle && createVNode(VToolbarTitle, {
            "key": "title",
            "text": props.title
          }, {
            text: slots.title
          }), slots.default?.(), slots.append && createVNode("div", {
            "class": "v-toolbar__append"
          }, [slots.append?.()])])]
        }), createVNode(VDefaultsProvider, {
          "defaults": {
            VTabs: {
              height: convertToUnit(extensionHeight.value)
            }
          }
        }, {
          default: () => [createVNode(VExpandTransition, null, {
            default: () => [isExtended.value && createVNode("div", {
              "class": "v-toolbar__extension",
              "style": {
                height: convertToUnit(extensionHeight.value)
              }
            }, [extension])]
          })]
        })]
      });
    });
    return {
      contentHeight,
      extensionHeight
    };
  }
});

// Utilities
// Composables
const makeScrollProps = propsFactory({
  scrollTarget: {
    type: String
  },
  scrollThreshold: {
    type: [String, Number],
    default: 300
  }
}, 'scroll');
function useScroll(props) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    canScroll
  } = args;
  let previousScroll = 0;
  let previousScrollHeight = 0;
  const target = ref(null);
  const currentScroll = shallowRef(0);
  const savedScroll = shallowRef(0);
  const currentThreshold = shallowRef(0);
  const isScrollActive = shallowRef(false);
  const isScrollingUp = shallowRef(false);
  const scrollThreshold = computed(() => {
    return Number(props.scrollThreshold);
  });

  /**
   * 1: at top
   * 0: at threshold
   */
  const scrollRatio = computed(() => {
    return clamp((scrollThreshold.value - currentScroll.value) / scrollThreshold.value || 0);
  });
  const onScroll = () => {
    const targetEl = target.value;
    if (!targetEl || canScroll && !canScroll.value) return;
    previousScroll = currentScroll.value;
    currentScroll.value = 'window' in targetEl ? targetEl.pageYOffset : targetEl.scrollTop;
    const currentScrollHeight = targetEl instanceof Window ? document.documentElement.scrollHeight : targetEl.scrollHeight;
    if (previousScrollHeight !== currentScrollHeight) {
      previousScrollHeight = currentScrollHeight;
      return;
    }
    isScrollingUp.value = currentScroll.value < previousScroll;
    currentThreshold.value = Math.abs(currentScroll.value - scrollThreshold.value);
  };
  watch(isScrollingUp, () => {
    savedScroll.value = savedScroll.value || currentScroll.value;
  });
  watch(isScrollActive, () => {
    savedScroll.value = 0;
  });
  onMounted(() => {
    watch(() => props.scrollTarget, scrollTarget => {
      const newTarget = scrollTarget ? document.querySelector(scrollTarget) : window;
      if (!newTarget) {
        consoleWarn(`Unable to locate element with identifier ${scrollTarget}`);
        return;
      }
      if (newTarget === target.value) return;
      target.value?.removeEventListener('scroll', onScroll);
      target.value = newTarget;
      target.value.addEventListener('scroll', onScroll, {
        passive: true
      });
    }, {
      immediate: true
    });
  });
  onBeforeUnmount(() => {
    target.value?.removeEventListener('scroll', onScroll);
  });

  // Do we need this? If yes - seems that
  // there's no need to expose onScroll
  canScroll && watch(canScroll, onScroll, {
    immediate: true
  });
  return {
    scrollThreshold,
    currentScroll,
    currentThreshold,
    isScrollActive,
    scrollRatio,
    // required only for testing
    // probably can be removed
    // later (2 chars chlng)
    isScrollingUp,
    savedScroll
  };
}

// Utilities

// Composables
function useSsrBoot() {
  const isBooted = shallowRef(false);
  onMounted(() => {
    window.requestAnimationFrame(() => {
      isBooted.value = true;
    });
  });
  const ssrBootStyles = computed(() => !isBooted.value ? {
    transition: 'none !important'
  } : undefined);
  return {
    ssrBootStyles,
    isBooted: readonly(isBooted)
  };
}

const makeVAppBarProps = propsFactory({
  scrollBehavior: String,
  modelValue: {
    type: Boolean,
    default: true
  },
  location: {
    type: String,
    default: 'top',
    validator: value => ['top', 'bottom'].includes(value)
  },
  ...makeVToolbarProps(),
  ...makeLayoutItemProps(),
  ...makeScrollProps(),
  height: {
    type: [Number, String],
    default: 64
  }
}, 'VAppBar');
const VAppBar = genericComponent()({
  name: 'VAppBar',
  props: makeVAppBarProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const vToolbarRef = ref();
    const isActive = useProxiedModel(props, 'modelValue');
    const scrollBehavior = computed(() => {
      const behavior = new Set(props.scrollBehavior?.split(' ') ?? []);
      return {
        hide: behavior.has('hide'),
        fullyHide: behavior.has('fully-hide'),
        inverted: behavior.has('inverted'),
        collapse: behavior.has('collapse'),
        elevate: behavior.has('elevate'),
        fadeImage: behavior.has('fade-image')
        // shrink: behavior.has('shrink'),
      };
    });
    const canScroll = computed(() => {
      const behavior = scrollBehavior.value;
      return behavior.hide || behavior.fullyHide || behavior.inverted || behavior.collapse || behavior.elevate || behavior.fadeImage ||
      // behavior.shrink ||
      !isActive.value;
    });
    const {
      currentScroll,
      scrollThreshold,
      isScrollingUp,
      scrollRatio
    } = useScroll(props, {
      canScroll
    });
    const canHide = computed(() => scrollBehavior.value.hide || scrollBehavior.value.fullyHide);
    const isCollapsed = computed(() => props.collapse || scrollBehavior.value.collapse && (scrollBehavior.value.inverted ? scrollRatio.value > 0 : scrollRatio.value === 0));
    const isFlat = computed(() => props.flat || scrollBehavior.value.fullyHide && !isActive.value || scrollBehavior.value.elevate && (scrollBehavior.value.inverted ? currentScroll.value > 0 : currentScroll.value === 0));
    const opacity = computed(() => scrollBehavior.value.fadeImage ? scrollBehavior.value.inverted ? 1 - scrollRatio.value : scrollRatio.value : undefined);
    const height = computed(() => {
      if (scrollBehavior.value.hide && scrollBehavior.value.inverted) return 0;
      const height = vToolbarRef.value?.contentHeight ?? 0;
      const extensionHeight = vToolbarRef.value?.extensionHeight ?? 0;
      if (!canHide.value) return height + extensionHeight;
      return currentScroll.value < scrollThreshold.value || scrollBehavior.value.fullyHide ? height + extensionHeight : height;
    });
    useToggleScope(computed(() => !!props.scrollBehavior), () => {
      watchEffect(() => {
        if (canHide.value) {
          if (scrollBehavior.value.inverted) {
            isActive.value = currentScroll.value > scrollThreshold.value;
          } else {
            isActive.value = isScrollingUp.value || currentScroll.value < scrollThreshold.value;
          }
        } else {
          isActive.value = true;
        }
      });
    });
    const {
      ssrBootStyles
    } = useSsrBoot();
    const {
      layoutItemStyles
    } = useLayoutItem({
      id: props.name,
      order: computed(() => parseInt(props.order, 10)),
      position: toRef(props, 'location'),
      layoutSize: height,
      elementSize: shallowRef(undefined),
      active: isActive,
      absolute: toRef(props, 'absolute')
    });
    useRender(() => {
      const toolbarProps = VToolbar.filterProps(props);
      return createVNode(VToolbar, mergeProps({
        "ref": vToolbarRef,
        "class": ['v-app-bar', {
          'v-app-bar--bottom': props.location === 'bottom'
        }, props.class],
        "style": [{
          ...layoutItemStyles.value,
          '--v-toolbar-image-opacity': opacity.value,
          height: undefined,
          ...ssrBootStyles.value
        }, props.style]
      }, toolbarProps, {
        "collapse": isCollapsed.value,
        "flat": isFlat.value
      }), slots);
    });
    return {};
  }
});

// Utilities
const allowedDensities = [null, 'default', 'comfortable', 'compact'];

// typeof allowedDensities[number] evalutes to any
// when generating api types for whatever reason.

// Composables
const makeDensityProps = propsFactory({
  density: {
    type: String,
    default: 'default',
    validator: v => allowedDensities.includes(v)
  }
}, 'density');
function useDensity(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const densityClasses = computed(() => {
    return `${name}--density-${props.density}`;
  });
  return {
    densityClasses
  };
}

const allowedVariants$2 = ['elevated', 'flat', 'tonal', 'outlined', 'text', 'plain'];
function genOverlays(isClickable, name) {
  return createVNode(Fragment, null, [isClickable && createVNode("span", {
    "key": "overlay",
    "class": `${name}__overlay`
  }, null), createVNode("span", {
    "key": "underlay",
    "class": `${name}__underlay`
  }, null)]);
}
const makeVariantProps = propsFactory({
  color: String,
  variant: {
    type: String,
    default: 'elevated',
    validator: v => allowedVariants$2.includes(v)
  }
}, 'variant');
function useVariant(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const variantClasses = computed(() => {
    const {
      variant
    } = unref(props);
    return `${name}--variant-${variant}`;
  });
  const {
    colorClasses,
    colorStyles
  } = useColor(computed(() => {
    const {
      variant,
      color
    } = unref(props);
    return {
      [['elevated', 'flat'].includes(variant) ? 'background' : 'text']: color
    };
  }));
  return {
    colorClasses,
    colorStyles,
    variantClasses
  };
}

const makeVBtnGroupProps = propsFactory({
  baseColor: String,
  divided: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps()
}, 'VBtnGroup');
const VBtnGroup = genericComponent()({
  name: 'VBtnGroup',
  props: makeVBtnGroupProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    provideDefaults({
      VBtn: {
        height: 'auto',
        baseColor: toRef(props, 'baseColor'),
        color: toRef(props, 'color'),
        density: toRef(props, 'density'),
        flat: true,
        variant: toRef(props, 'variant')
      }
    });
    useRender(() => {
      return createVNode(props.tag, {
        "class": ['v-btn-group', {
          'v-btn-group--divided': props.divided
        }, themeClasses.value, borderClasses.value, densityClasses.value, elevationClasses.value, roundedClasses.value, props.class],
        "style": props.style
      }, slots);
    });
  }
});

// Composables
const makeGroupProps = propsFactory({
  modelValue: {
    type: null,
    default: undefined
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, 'group');
const makeGroupItemProps = propsFactory({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, 'group-item');

// Composables

function useGroupItem(props, injectKey) {
  let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const vm = getCurrentInstance('useGroupItem');
  if (!vm) {
    throw new Error('[Vuetify] useGroupItem composable must be used inside a component setup function');
  }
  const id = getUid();
  provide(Symbol.for(`${injectKey.description}:id`), id);
  const group = inject$2(injectKey, null);
  if (!group) {
    if (!required) return group;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${injectKey.description}`);
  }
  const value = toRef(props, 'value');
  const disabled = computed(() => !!(group.disabled.value || props.disabled));
  group.register({
    id,
    value,
    disabled
  }, vm);
  onBeforeUnmount(() => {
    group.unregister(id);
  });
  const isSelected = computed(() => {
    return group.isSelected(id);
  });
  const isFirst = computed(() => {
    return group.items.value[0].id === id;
  });
  const isLast = computed(() => {
    return group.items.value[group.items.value.length - 1].id === id;
  });
  const selectedClass = computed(() => isSelected.value && [group.selectedClass.value, props.selectedClass]);
  watch(isSelected, value => {
    vm.emit('group:selected', {
      value
    });
  }, {
    flush: 'sync'
  });
  return {
    id,
    isSelected,
    isFirst,
    isLast,
    toggle: () => group.select(id, !isSelected.value),
    select: value => group.select(id, value),
    selectedClass,
    value,
    disabled,
    group
  };
}
function useGroup(props, injectKey) {
  let isUnmounted = false;
  const items = reactive([]);
  const selected = useProxiedModel(props, 'modelValue', [], v => {
    if (v == null) return [];
    return getIds(items, wrapInArray(v));
  }, v => {
    const arr = getValues(items, v);
    return props.multiple ? arr : arr[0];
  });
  const groupVm = getCurrentInstance('useGroup');
  function register(item, vm) {
    // Is there a better way to fix this typing?
    const unwrapped = item;
    const key = Symbol.for(`${injectKey.description}:id`);
    const children = findChildrenWithProvide(key, groupVm?.vnode);
    const index = children.indexOf(vm);
    if (unref(unwrapped.value) == null) {
      unwrapped.value = index;
      unwrapped.useIndexAsValue = true;
    }
    if (index > -1) {
      items.splice(index, 0, unwrapped);
    } else {
      items.push(unwrapped);
    }
  }
  function unregister(id) {
    if (isUnmounted) return;

    // TODO: re-evaluate this line's importance in the future
    // should we only modify the model if mandatory is set.
    // selected.value = selected.value.filter(v => v !== id)

    forceMandatoryValue();
    const index = items.findIndex(item => item.id === id);
    items.splice(index, 1);
  }

  // If mandatory and nothing is selected, then select first non-disabled item
  function forceMandatoryValue() {
    const item = items.find(item => !item.disabled);
    if (item && props.mandatory === 'force' && !selected.value.length) {
      selected.value = [item.id];
    }
  }
  onMounted(() => {
    forceMandatoryValue();
  });
  onBeforeUnmount(() => {
    isUnmounted = true;
  });
  onUpdated(() => {
    // #19655 update the items that use the index as the value.
    for (let i = 0; i < items.length; i++) {
      if (items[i].useIndexAsValue) {
        items[i].value = i;
      }
    }
  });
  function select(id, value) {
    const item = items.find(item => item.id === id);
    if (value && item?.disabled) return;
    if (props.multiple) {
      const internalValue = selected.value.slice();
      const index = internalValue.findIndex(v => v === id);
      const isSelected = ~index;
      value = value ?? !isSelected;

      // We can't remove value if group is
      // mandatory, value already exists,
      // and it is the only value
      if (isSelected && props.mandatory && internalValue.length <= 1) return;

      // We can't add value if it would
      // cause max limit to be exceeded
      if (!isSelected && props.max != null && internalValue.length + 1 > props.max) return;
      if (index < 0 && value) internalValue.push(id);else if (index >= 0 && !value) internalValue.splice(index, 1);
      selected.value = internalValue;
    } else {
      const isSelected = selected.value.includes(id);
      if (props.mandatory && isSelected) return;
      selected.value = value ?? !isSelected ? [id] : [];
    }
  }
  function step(offset) {
    // getting an offset from selected value obviously won't work with multiple values
    if (props.multiple) consoleWarn('This method is not supported when using "multiple" prop');
    if (!selected.value.length) {
      const item = items.find(item => !item.disabled);
      item && (selected.value = [item.id]);
    } else {
      const currentId = selected.value[0];
      const currentIndex = items.findIndex(i => i.id === currentId);
      let newIndex = (currentIndex + offset) % items.length;
      let newItem = items[newIndex];
      while (newItem.disabled && newIndex !== currentIndex) {
        newIndex = (newIndex + offset) % items.length;
        newItem = items[newIndex];
      }
      if (newItem.disabled) return;
      selected.value = [items[newIndex].id];
    }
  }
  const state = {
    register,
    unregister,
    selected,
    select,
    disabled: toRef(props, 'disabled'),
    prev: () => step(items.length - 1),
    next: () => step(1),
    isSelected: id => selected.value.includes(id),
    selectedClass: computed(() => props.selectedClass),
    items: computed(() => items),
    getItemIndex: value => getItemIndex(items, value)
  };
  provide(injectKey, state);
  return state;
}
function getItemIndex(items, value) {
  const ids = getIds(items, [value]);
  if (!ids.length) return -1;
  return items.findIndex(item => item.id === ids[0]);
}
function getIds(items, modelValue) {
  const ids = [];
  modelValue.forEach(value => {
    const item = items.find(item => deepEqual(value, item.value));
    const itemByIndex = items[value];
    if (item?.value != null) {
      ids.push(item.id);
    } else if (itemByIndex != null) {
      ids.push(itemByIndex.id);
    }
  });
  return ids;
}
function getValues(items, ids) {
  const values = [];
  ids.forEach(id => {
    const itemIndex = items.findIndex(item => item.id === id);
    if (~itemIndex) {
      const item = items[itemIndex];
      values.push(item.value != null ? item.value : itemIndex);
    }
  });
  return values;
}

const VBtnToggleSymbol = Symbol.for('vuetify:v-btn-toggle');
const makeVBtnToggleProps = propsFactory({
  ...makeVBtnGroupProps(),
  ...makeGroupProps()
}, 'VBtnToggle');
const VBtnToggle = genericComponent()({
  name: 'VBtnToggle',
  props: makeVBtnToggleProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      isSelected,
      next,
      prev,
      select,
      selected
    } = useGroup(props, VBtnToggleSymbol);
    useRender(() => {
      const btnGroupProps = VBtnGroup.filterProps(props);
      return createVNode(VBtnGroup, mergeProps({
        "class": ['v-btn-toggle', props.class]
      }, btnGroupProps, {
        "style": props.style
      }), {
        default: () => [slots.default?.({
          isSelected,
          next,
          prev,
          select,
          selected
        })]
      });
    });
    return {
      next,
      prev,
      select
    };
  }
});

// Utilities
const predefinedSizes = ['x-small', 'small', 'default', 'large', 'x-large'];
// Composables
const makeSizeProps = propsFactory({
  size: {
    type: [String, Number],
    default: 'default'
  }
}, 'size');
function useSize(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  return destructComputed(() => {
    let sizeClasses;
    let sizeStyles;
    if (includes(predefinedSizes, props.size)) {
      sizeClasses = `${name}--size-${props.size}`;
    } else if (props.size) {
      sizeStyles = {
        width: convertToUnit(props.size),
        height: convertToUnit(props.size)
      };
    }
    return {
      sizeClasses,
      sizeStyles
    };
  });
}

const makeVIconProps = propsFactory({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: IconValue,
  ...makeComponentProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: 'i'
  }),
  ...makeThemeProps()
}, 'VIcon');
const VIcon = genericComponent()({
  name: 'VIcon',
  props: makeVIconProps(),
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const slotIcon = ref();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      iconData
    } = useIcon$1(computed(() => slotIcon.value || props.icon));
    const {
      sizeClasses
    } = useSize(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'color'));
    useRender(() => {
      const slotValue = slots.default?.();
      if (slotValue) {
        slotIcon.value = flattenFragments(slotValue).filter(node => node.type === Text$1 && node.children && typeof node.children === 'string')[0]?.children;
      }
      const hasClick = !!(attrs.onClick || attrs.onClickOnce);
      return createVNode(iconData.value.component, {
        "tag": props.tag,
        "icon": iconData.value.icon,
        "class": ['v-icon', 'notranslate', themeClasses.value, sizeClasses.value, textColorClasses.value, {
          'v-icon--clickable': hasClick,
          'v-icon--disabled': props.disabled,
          'v-icon--start': props.start,
          'v-icon--end': props.end
        }, props.class],
        "style": [!sizeClasses.value ? {
          fontSize: convertToUnit(props.size),
          height: convertToUnit(props.size),
          width: convertToUnit(props.size)
        } : undefined, textColorStyles.value, props.style],
        "role": hasClick ? 'button' : undefined,
        "aria-hidden": !hasClick,
        "tabindex": hasClick ? props.disabled ? -1 : 0 : undefined
      }, {
        default: () => [slotValue]
      });
    });
    return {};
  }
});

// Utilities
function useIntersectionObserver(callback, options) {
  const intersectionRef = ref();
  const isIntersecting = shallowRef(false);
  if (SUPPORTS_INTERSECTION) {
    const observer = new IntersectionObserver(entries => {
      isIntersecting.value = !!entries.find(entry => entry.isIntersecting);
    }, options);
    onBeforeUnmount(() => {
      observer.disconnect();
    });
    watch(intersectionRef, (newValue, oldValue) => {
      if (oldValue) {
        observer.unobserve(oldValue);
        isIntersecting.value = false;
      }
      if (newValue) observer.observe(newValue);
    }, {
      flush: 'post'
    });
  }
  return {
    intersectionRef,
    isIntersecting
  };
}

const makeVProgressCircularProps = propsFactory({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...makeComponentProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: 'div'
  }),
  ...makeThemeProps()
}, 'VProgressCircular');
const VProgressCircular = genericComponent()({
  name: 'VProgressCircular',
  props: makeVProgressCircularProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const MAGIC_RADIUS_CONSTANT = 20;
    const CIRCUMFERENCE = 2 * Math.PI * MAGIC_RADIUS_CONSTANT;
    const root = ref();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      sizeClasses,
      sizeStyles
    } = useSize(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'color'));
    const {
      textColorClasses: underlayColorClasses,
      textColorStyles: underlayColorStyles
    } = useTextColor(toRef(props, 'bgColor'));
    const {
      intersectionRef,
      isIntersecting
    } = useIntersectionObserver();
    const {
      resizeRef,
      contentRect
    } = useResizeObserver();
    const normalizedValue = computed(() => Math.max(0, Math.min(100, parseFloat(props.modelValue))));
    const width = computed(() => Number(props.width));
    const size = computed(() => {
      // Get size from element if size prop value is small, large etc
      return sizeStyles.value ? Number(props.size) : contentRect.value ? contentRect.value.width : Math.max(width.value, 32);
    });
    const diameter = computed(() => MAGIC_RADIUS_CONSTANT / (1 - width.value / size.value) * 2);
    const strokeWidth = computed(() => width.value / size.value * diameter.value);
    const strokeDashOffset = computed(() => convertToUnit((100 - normalizedValue.value) / 100 * CIRCUMFERENCE));
    watchEffect(() => {
      intersectionRef.value = root.value;
      resizeRef.value = root.value;
    });
    useRender(() => createVNode(props.tag, {
      "ref": root,
      "class": ['v-progress-circular', {
        'v-progress-circular--indeterminate': !!props.indeterminate,
        'v-progress-circular--visible': isIntersecting.value,
        'v-progress-circular--disable-shrink': props.indeterminate === 'disable-shrink'
      }, themeClasses.value, sizeClasses.value, textColorClasses.value, props.class],
      "style": [sizeStyles.value, textColorStyles.value, props.style],
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value
    }, {
      default: () => [createVNode("svg", {
        "style": {
          transform: `rotate(calc(-90deg + ${Number(props.rotate)}deg))`
        },
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": `0 0 ${diameter.value} ${diameter.value}`
      }, [createVNode("circle", {
        "class": ['v-progress-circular__underlay', underlayColorClasses.value],
        "style": underlayColorStyles.value,
        "fill": "transparent",
        "cx": "50%",
        "cy": "50%",
        "r": MAGIC_RADIUS_CONSTANT,
        "stroke-width": strokeWidth.value,
        "stroke-dasharray": CIRCUMFERENCE,
        "stroke-dashoffset": 0
      }, null), createVNode("circle", {
        "class": "v-progress-circular__overlay",
        "fill": "transparent",
        "cx": "50%",
        "cy": "50%",
        "r": MAGIC_RADIUS_CONSTANT,
        "stroke-width": strokeWidth.value,
        "stroke-dasharray": CIRCUMFERENCE,
        "stroke-dashoffset": strokeDashOffset.value
      }, null)]), slots.default && createVNode("div", {
        "class": "v-progress-circular__content"
      }, [slots.default({
        value: normalizedValue.value
      })])]
    }));
    return {};
  }
});

// Composables
const oppositeMap = {
  center: 'center',
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
const makeLocationProps = propsFactory({
  location: String
}, 'location');
function useLocation(props) {
  let opposite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let offset = arguments.length > 2 ? arguments[2] : undefined;
  const {
    isRtl
  } = useRtl();
  const locationStyles = computed(() => {
    if (!props.location) return {};
    const {
      side,
      align
    } = parseAnchor(props.location.split(' ').length > 1 ? props.location : `${props.location} center`, isRtl.value);
    function getOffset(side) {
      return offset ? offset(side) : 0;
    }
    const styles = {};
    if (side !== 'center') {
      if (opposite) styles[oppositeMap[side]] = `calc(100% - ${getOffset(side)}px)`;else styles[side] = 0;
    }
    if (align !== 'center') {
      if (opposite) styles[oppositeMap[align]] = `calc(100% - ${getOffset(align)}px)`;else styles[align] = 0;
    } else {
      if (side === 'center') styles.top = styles.left = '50%';else {
        styles[{
          top: 'left',
          bottom: 'left',
          left: 'top',
          right: 'top'
        }[side]] = '50%';
      }
      styles.transform = {
        top: 'translateX(-50%)',
        bottom: 'translateX(-50%)',
        left: 'translateY(-50%)',
        right: 'translateY(-50%)',
        center: 'translate(-50%, -50%)'
      }[side];
    }
    return styles;
  });
  return {
    locationStyles
  };
}

const makeVProgressLinearProps = propsFactory({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: true
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...makeComponentProps(),
  ...makeLocationProps({
    location: 'top'
  }),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, 'VProgressLinear');
const VProgressLinear = genericComponent()({
  name: 'VProgressLinear',
  props: makeVProgressLinearProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const progress = useProxiedModel(props, 'modelValue');
    const {
      isRtl,
      rtlClasses
    } = useRtl();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      locationStyles
    } = useLocation(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(props, 'color');
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(computed(() => props.bgColor || props.color));
    const {
      backgroundColorClasses: bufferColorClasses,
      backgroundColorStyles: bufferColorStyles
    } = useBackgroundColor(computed(() => props.bufferColor || props.bgColor || props.color));
    const {
      backgroundColorClasses: barColorClasses,
      backgroundColorStyles: barColorStyles
    } = useBackgroundColor(props, 'color');
    const {
      roundedClasses
    } = useRounded(props);
    const {
      intersectionRef,
      isIntersecting
    } = useIntersectionObserver();
    const max = computed(() => parseFloat(props.max));
    const height = computed(() => parseFloat(props.height));
    const normalizedBuffer = computed(() => clamp(parseFloat(props.bufferValue) / max.value * 100, 0, 100));
    const normalizedValue = computed(() => clamp(parseFloat(progress.value) / max.value * 100, 0, 100));
    const isReversed = computed(() => isRtl.value !== props.reverse);
    const transition = computed(() => props.indeterminate ? 'fade-transition' : 'slide-x-transition');
    const isForcedColorsModeActive = IN_BROWSER && window.matchMedia?.('(forced-colors: active)').matches;
    function handleClick(e) {
      if (!intersectionRef.value) return;
      const {
        left,
        right,
        width
      } = intersectionRef.value.getBoundingClientRect();
      const value = isReversed.value ? width - e.clientX + (right - width) : e.clientX - left;
      progress.value = Math.round(value / width * max.value);
    }
    useRender(() => createVNode(props.tag, {
      "ref": intersectionRef,
      "class": ['v-progress-linear', {
        'v-progress-linear--absolute': props.absolute,
        'v-progress-linear--active': props.active && isIntersecting.value,
        'v-progress-linear--reverse': isReversed.value,
        'v-progress-linear--rounded': props.rounded,
        'v-progress-linear--rounded-bar': props.roundedBar,
        'v-progress-linear--striped': props.striped
      }, roundedClasses.value, themeClasses.value, rtlClasses.value, props.class],
      "style": [{
        bottom: props.location === 'bottom' ? 0 : undefined,
        top: props.location === 'top' ? 0 : undefined,
        height: props.active ? convertToUnit(height.value) : 0,
        '--v-progress-linear-height': convertToUnit(height.value),
        ...(props.absolute ? locationStyles.value : {})
      }, props.style],
      "role": "progressbar",
      "aria-hidden": props.active ? 'false' : 'true',
      "aria-valuemin": "0",
      "aria-valuemax": props.max,
      "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value,
      "onClick": props.clickable && handleClick
    }, {
      default: () => [props.stream && createVNode("div", {
        "key": "stream",
        "class": ['v-progress-linear__stream', textColorClasses.value],
        "style": {
          ...textColorStyles.value,
          [isReversed.value ? 'left' : 'right']: convertToUnit(-height.value),
          borderTop: `${convertToUnit(height.value / 2)} dotted`,
          opacity: parseFloat(props.bufferOpacity),
          top: `calc(50% - ${convertToUnit(height.value / 4)})`,
          width: convertToUnit(100 - normalizedBuffer.value, '%'),
          '--v-progress-linear-stream-to': convertToUnit(height.value * (isReversed.value ? 1 : -1))
        }
      }, null), createVNode("div", {
        "class": ['v-progress-linear__background', !isForcedColorsModeActive ? backgroundColorClasses.value : undefined],
        "style": [backgroundColorStyles.value, {
          opacity: parseFloat(props.bgOpacity),
          width: props.stream ? 0 : undefined
        }]
      }, null), createVNode("div", {
        "class": ['v-progress-linear__buffer', !isForcedColorsModeActive ? bufferColorClasses.value : undefined],
        "style": [bufferColorStyles.value, {
          opacity: parseFloat(props.bufferOpacity),
          width: convertToUnit(normalizedBuffer.value, '%')
        }]
      }, null), createVNode(Transition, {
        "name": transition.value
      }, {
        default: () => [!props.indeterminate ? createVNode("div", {
          "class": ['v-progress-linear__determinate', !isForcedColorsModeActive ? barColorClasses.value : undefined],
          "style": [barColorStyles.value, {
            width: convertToUnit(normalizedValue.value, '%')
          }]
        }, null) : createVNode("div", {
          "class": "v-progress-linear__indeterminate"
        }, [['long', 'short'].map(bar => createVNode("div", {
          "key": bar,
          "class": ['v-progress-linear__indeterminate', bar, !isForcedColorsModeActive ? barColorClasses.value : undefined],
          "style": barColorStyles.value
        }, null))])]
      }), slots.default && createVNode("div", {
        "class": "v-progress-linear__content"
      }, [slots.default({
        value: normalizedValue.value,
        buffer: normalizedBuffer.value
      })])]
    }));
    return {};
  }
});

// Composables
const makeLoaderProps = propsFactory({
  loading: [Boolean, String]
}, 'loader');
function useLoader(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const loaderClasses = computed(() => ({
    [`${name}--loading`]: props.loading
  }));
  return {
    loaderClasses
  };
}
function LoaderSlot(props, _ref) {
  let {
    slots
  } = _ref;
  return createVNode("div", {
    "class": `${props.name}__loader`
  }, [slots.default?.({
    color: props.color,
    isActive: props.active
  }) || createVNode(VProgressLinear, {
    "absolute": props.absolute,
    "active": props.active,
    "color": props.color,
    "height": "2",
    "indeterminate": true
  }, null)]);
}

// Utilities
const positionValues = ['static', 'relative', 'fixed', 'absolute', 'sticky'];
// Composables
const makePositionProps = propsFactory({
  position: {
    type: String,
    validator: /* istanbul ignore next */v => positionValues.includes(v)
  }
}, 'position');
function usePosition(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const positionClasses = computed(() => {
    return props.position ? `${name}--${props.position}` : undefined;
  });
  return {
    positionClasses
  };
}

// Utilities
function useRoute() {
  const vm = getCurrentInstance('useRoute');
  return computed(() => vm?.proxy?.$route);
}
function useRouter() {
  return getCurrentInstance('useRouter')?.proxy?.$router;
}
function useLink(props, attrs) {
  const RouterLink = resolveDynamicComponent('RouterLink');
  const isLink = computed(() => !!(props.href || props.to));
  const isClickable = computed(() => {
    return isLink?.value || hasEvent(attrs, 'click') || hasEvent(props, 'click');
  });
  if (typeof RouterLink === 'string' || !('useLink' in RouterLink)) {
    const href = toRef(props, 'href');
    return {
      isLink,
      isClickable,
      href,
      linkProps: reactive({
        href
      })
    };
  }
  // vue-router useLink `to` prop needs to be reactive and useLink will crash if undefined
  const linkProps = computed(() => ({
    ...props,
    to: toRef(() => props.to || '')
  }));
  const routerLink = RouterLink.useLink(linkProps.value);
  // Actual link needs to be undefined when to prop is not used
  const link = computed(() => props.to ? routerLink : undefined);
  const route = useRoute();
  const isActive = computed(() => {
    if (!link.value) return false;
    if (!props.exact) return link.value.isActive?.value ?? false;
    if (!route.value) return link.value.isExactActive?.value ?? false;
    return link.value.isExactActive?.value && deepEqual(link.value.route.value.query, route.value.query);
  });
  const href = computed(() => props.to ? link.value?.route.value.href : props.href);
  return {
    isLink,
    isClickable,
    isActive,
    route: link.value?.route,
    navigate: link.value?.navigate,
    href,
    linkProps: reactive({
      href,
      'aria-current': computed(() => isActive.value ? 'page' : undefined)
    })
  };
}
const makeRouterProps = propsFactory({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, 'router');
let inTransition = false;
function useBackButton(router, cb) {
  let popped = false;
  let removeBefore;
  let removeAfter;
  if (IN_BROWSER) {
    nextTick(() => {
      window.addEventListener('popstate', onPopstate);
      removeBefore = router?.beforeEach((to, from, next) => {
        if (!inTransition) {
          setTimeout(() => popped ? cb(next) : next());
        } else {
          popped ? cb(next) : next();
        }
        inTransition = true;
      });
      removeAfter = router?.afterEach(() => {
        inTransition = false;
      });
    });
    onScopeDispose(() => {
      window.removeEventListener('popstate', onPopstate);
      removeBefore?.();
      removeAfter?.();
    });
  }
  function onPopstate(e) {
    if (e.state?.replaced) return;
    popped = true;
    setTimeout(() => popped = false);
  }
}

// Utilities

// Types

function useSelectLink(link, select) {
  watch(() => link.isActive?.value, isActive => {
    if (link.isLink.value && isActive && select) {
      nextTick(() => {
        select(true);
      });
    }
  }, {
    immediate: true
  });
}

// Styles
const stopSymbol = Symbol('rippleStop');
const DELAY_RIPPLE = 80;
function transform(el, value) {
  el.style.transform = value;
  el.style.webkitTransform = value;
}
function isTouchEvent(e) {
  return e.constructor.name === 'TouchEvent';
}
function isKeyboardEvent(e) {
  return e.constructor.name === 'KeyboardEvent';
}
const calculate = function (e, el) {
  let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let localX = 0;
  let localY = 0;
  if (!isKeyboardEvent(e)) {
    const offset = el.getBoundingClientRect();
    const target = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
    localX = target.clientX - offset.left;
    localY = target.clientY - offset.top;
  }
  let radius = 0;
  let scale = 0.3;
  if (el._ripple?.circle) {
    scale = 0.15;
    radius = el.clientWidth / 2;
    radius = value.center ? radius : radius + Math.sqrt((localX - radius) ** 2 + (localY - radius) ** 2) / 4;
  } else {
    radius = Math.sqrt(el.clientWidth ** 2 + el.clientHeight ** 2) / 2;
  }
  const centerX = `${(el.clientWidth - radius * 2) / 2}px`;
  const centerY = `${(el.clientHeight - radius * 2) / 2}px`;
  const x = value.center ? centerX : `${localX - radius}px`;
  const y = value.center ? centerY : `${localY - radius}px`;
  return {
    radius,
    scale,
    x,
    y,
    centerX,
    centerY
  };
};
const ripples = {
  /* eslint-disable max-statements */
  show(e, el) {
    let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!el?._ripple?.enabled) {
      return;
    }
    const container = document.createElement('span');
    const animation = document.createElement('span');
    container.appendChild(animation);
    container.className = 'v-ripple__container';
    if (value.class) {
      container.className += ` ${value.class}`;
    }
    const {
      radius,
      scale,
      x,
      y,
      centerX,
      centerY
    } = calculate(e, el, value);
    const size = `${radius * 2}px`;
    animation.className = 'v-ripple__animation';
    animation.style.width = size;
    animation.style.height = size;
    el.appendChild(container);
    const computed = window.getComputedStyle(el);
    if (computed && computed.position === 'static') {
      el.style.position = 'relative';
      el.dataset.previousPosition = 'static';
    }
    animation.classList.add('v-ripple__animation--enter');
    animation.classList.add('v-ripple__animation--visible');
    transform(animation, `translate(${x}, ${y}) scale3d(${scale},${scale},${scale})`);
    animation.dataset.activated = String(performance.now());
    setTimeout(() => {
      animation.classList.remove('v-ripple__animation--enter');
      animation.classList.add('v-ripple__animation--in');
      transform(animation, `translate(${centerX}, ${centerY}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(el) {
    if (!el?._ripple?.enabled) return;
    const ripples = el.getElementsByClassName('v-ripple__animation');
    if (ripples.length === 0) return;
    const animation = ripples[ripples.length - 1];
    if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
    const diff = performance.now() - Number(animation.dataset.activated);
    const delay = Math.max(250 - diff, 0);
    setTimeout(() => {
      animation.classList.remove('v-ripple__animation--in');
      animation.classList.add('v-ripple__animation--out');
      setTimeout(() => {
        const ripples = el.getElementsByClassName('v-ripple__animation');
        if (ripples.length === 1 && el.dataset.previousPosition) {
          el.style.position = el.dataset.previousPosition;
          delete el.dataset.previousPosition;
        }
        if (animation.parentNode?.parentNode === el) el.removeChild(animation.parentNode);
      }, 300);
    }, delay);
  }
};
function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}
function rippleShow(e) {
  const value = {};
  const element = e.currentTarget;
  if (!element?._ripple || element._ripple.touched || e[stopSymbol]) return;

  // Don't allow the event to trigger ripples on any other elements
  e[stopSymbol] = true;
  if (isTouchEvent(e)) {
    element._ripple.touched = true;
    element._ripple.isTouch = true;
  } else {
    // It's possible for touch events to fire
    // as mouse events on Android/iOS, this
    // will skip the event call if it has
    // already been registered as touch
    if (element._ripple.isTouch) return;
  }
  value.center = element._ripple.centered || isKeyboardEvent(e);
  if (element._ripple.class) {
    value.class = element._ripple.class;
  }
  if (isTouchEvent(e)) {
    // already queued that shows or hides the ripple
    if (element._ripple.showTimerCommit) return;
    element._ripple.showTimerCommit = () => {
      ripples.show(e, element, value);
    };
    element._ripple.showTimer = window.setTimeout(() => {
      if (element?._ripple?.showTimerCommit) {
        element._ripple.showTimerCommit();
        element._ripple.showTimerCommit = null;
      }
    }, DELAY_RIPPLE);
  } else {
    ripples.show(e, element, value);
  }
}
function rippleStop(e) {
  e[stopSymbol] = true;
}
function rippleHide(e) {
  const element = e.currentTarget;
  if (!element?._ripple) return;
  window.clearTimeout(element._ripple.showTimer);

  // The touch interaction occurs before the show timer is triggered.
  // We still want to show ripple effect.
  if (e.type === 'touchend' && element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit();
    element._ripple.showTimerCommit = null;

    // re-queue ripple hiding
    element._ripple.showTimer = window.setTimeout(() => {
      rippleHide(e);
    });
    return;
  }
  window.setTimeout(() => {
    if (element._ripple) {
      element._ripple.touched = false;
    }
  });
  ripples.hide(element);
}
function rippleCancelShow(e) {
  const element = e.currentTarget;
  if (!element?._ripple) return;
  if (element._ripple.showTimerCommit) {
    element._ripple.showTimerCommit = null;
  }
  window.clearTimeout(element._ripple.showTimer);
}
let keyboardRipple = false;
function keyboardRippleShow(e) {
  if (!keyboardRipple && (e.keyCode === keyCodes.enter || e.keyCode === keyCodes.space)) {
    keyboardRipple = true;
    rippleShow(e);
  }
}
function keyboardRippleHide(e) {
  keyboardRipple = false;
  rippleHide(e);
}
function focusRippleHide(e) {
  if (keyboardRipple) {
    keyboardRipple = false;
    rippleHide(e);
  }
}
function updateRipple(el, binding, wasEnabled) {
  const {
    value,
    modifiers
  } = binding;
  const enabled = isRippleEnabled(value);
  if (!enabled) {
    ripples.hide(el);
  }
  el._ripple = el._ripple ?? {};
  el._ripple.enabled = enabled;
  el._ripple.centered = modifiers.center;
  el._ripple.circle = modifiers.circle;
  if (isObject$1(value) && value.class) {
    el._ripple.class = value.class;
  }
  if (enabled && !wasEnabled) {
    if (modifiers.stop) {
      el.addEventListener('touchstart', rippleStop, {
        passive: true
      });
      el.addEventListener('mousedown', rippleStop);
      return;
    }
    el.addEventListener('touchstart', rippleShow, {
      passive: true
    });
    el.addEventListener('touchend', rippleHide, {
      passive: true
    });
    el.addEventListener('touchmove', rippleCancelShow, {
      passive: true
    });
    el.addEventListener('touchcancel', rippleHide);
    el.addEventListener('mousedown', rippleShow);
    el.addEventListener('mouseup', rippleHide);
    el.addEventListener('mouseleave', rippleHide);
    el.addEventListener('keydown', keyboardRippleShow);
    el.addEventListener('keyup', keyboardRippleHide);
    el.addEventListener('blur', focusRippleHide);

    // Anchor tags can be dragged, causes other hides to fail - #1537
    el.addEventListener('dragstart', rippleHide, {
      passive: true
    });
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}
function removeListeners(el) {
  el.removeEventListener('mousedown', rippleShow);
  el.removeEventListener('touchstart', rippleShow);
  el.removeEventListener('touchend', rippleHide);
  el.removeEventListener('touchmove', rippleCancelShow);
  el.removeEventListener('touchcancel', rippleHide);
  el.removeEventListener('mouseup', rippleHide);
  el.removeEventListener('mouseleave', rippleHide);
  el.removeEventListener('keydown', keyboardRippleShow);
  el.removeEventListener('keyup', keyboardRippleHide);
  el.removeEventListener('dragstart', rippleHide);
  el.removeEventListener('blur', focusRippleHide);
}
function mounted$2(el, binding) {
  updateRipple(el, binding, false);
}
function unmounted$2(el) {
  delete el._ripple;
  removeListeners(el);
}
function updated(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }
  const wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}
const Ripple = {
  mounted: mounted$2,
  unmounted: unmounted$2,
  updated
};

const makeVBtnProps = propsFactory({
  active: {
    type: Boolean,
    default: undefined
  },
  activeColor: String,
  baseColor: String,
  symbol: {
    type: null,
    default: VBtnToggleSymbol
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: IconValue,
  appendIcon: IconValue,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  text: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeLoaderProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: 'button'
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'elevated'
  })
}, 'VBtn');
const VBtn = genericComponent()({
  name: 'VBtn',
  props: makeVBtnProps(),
  emits: {
    'group:selected': val => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      loaderClasses
    } = useLoader(props);
    const {
      locationStyles
    } = useLocation(props);
    const {
      positionClasses
    } = usePosition(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      sizeClasses,
      sizeStyles
    } = useSize(props);
    const group = useGroupItem(props, props.symbol, false);
    const link = useLink(props, attrs);
    const isActive = computed(() => {
      if (props.active !== undefined) {
        return props.active;
      }
      if (link.isLink.value) {
        return link.isActive?.value;
      }
      return group?.isSelected.value;
    });
    const color = computed(() => isActive.value ? props.activeColor ?? props.color : props.color);
    const variantProps = computed(() => {
      const showColor = group?.isSelected.value && (!link.isLink.value || link.isActive?.value) || !group || link.isActive?.value;
      return {
        color: showColor ? color.value ?? props.baseColor : props.baseColor,
        variant: props.variant
      };
    });
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(variantProps);
    const isDisabled = computed(() => group?.disabled.value || props.disabled);
    const isElevated = computed(() => {
      return props.variant === 'elevated' && !(props.disabled || props.flat || props.border);
    });
    const valueAttr = computed(() => {
      if (props.value === undefined || typeof props.value === 'symbol') return undefined;
      return Object(props.value) === props.value ? JSON.stringify(props.value, null, 0) : props.value;
    });
    function onClick(e) {
      if (isDisabled.value || link.isLink.value && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || attrs.target === '_blank')) return;
      link.navigate?.(e);
      group?.toggle();
    }
    useSelectLink(link, group?.select);
    useRender(() => {
      const Tag = link.isLink.value ? 'a' : props.tag;
      const hasPrepend = !!(props.prependIcon || slots.prepend);
      const hasAppend = !!(props.appendIcon || slots.append);
      const hasIcon = !!(props.icon && props.icon !== true);
      return withDirectives(createVNode(Tag, mergeProps({
        "type": Tag === 'a' ? undefined : 'button',
        "class": ['v-btn', group?.selectedClass.value, {
          'v-btn--active': isActive.value,
          'v-btn--block': props.block,
          'v-btn--disabled': isDisabled.value,
          'v-btn--elevated': isElevated.value,
          'v-btn--flat': props.flat,
          'v-btn--icon': !!props.icon,
          'v-btn--loading': props.loading,
          'v-btn--readonly': props.readonly,
          'v-btn--slim': props.slim,
          'v-btn--stacked': props.stacked
        }, themeClasses.value, borderClasses.value, colorClasses.value, densityClasses.value, elevationClasses.value, loaderClasses.value, positionClasses.value, roundedClasses.value, sizeClasses.value, variantClasses.value, props.class],
        "style": [colorStyles.value, dimensionStyles.value, locationStyles.value, sizeStyles.value, props.style],
        "aria-busy": props.loading ? true : undefined,
        "disabled": isDisabled.value || undefined,
        "tabindex": props.loading || props.readonly ? -1 : undefined,
        "onClick": onClick,
        "value": valueAttr.value
      }, link.linkProps), {
        default: () => [genOverlays(true, 'v-btn'), !props.icon && hasPrepend && createVNode("span", {
          "key": "prepend",
          "class": "v-btn__prepend"
        }, [!slots.prepend ? createVNode(VIcon, {
          "key": "prepend-icon",
          "icon": props.prependIcon
        }, null) : createVNode(VDefaultsProvider, {
          "key": "prepend-defaults",
          "disabled": !props.prependIcon,
          "defaults": {
            VIcon: {
              icon: props.prependIcon
            }
          }
        }, slots.prepend)]), createVNode("span", {
          "class": "v-btn__content",
          "data-no-activator": ""
        }, [!slots.default && hasIcon ? createVNode(VIcon, {
          "key": "content-icon",
          "icon": props.icon
        }, null) : createVNode(VDefaultsProvider, {
          "key": "content-defaults",
          "disabled": !hasIcon,
          "defaults": {
            VIcon: {
              icon: props.icon
            }
          }
        }, {
          default: () => [slots.default?.() ?? props.text]
        })]), !props.icon && hasAppend && createVNode("span", {
          "key": "append",
          "class": "v-btn__append"
        }, [!slots.append ? createVNode(VIcon, {
          "key": "append-icon",
          "icon": props.appendIcon
        }, null) : createVNode(VDefaultsProvider, {
          "key": "append-defaults",
          "disabled": !props.appendIcon,
          "defaults": {
            VIcon: {
              icon: props.appendIcon
            }
          }
        }, slots.append)]), !!props.loading && createVNode("span", {
          "key": "loader",
          "class": "v-btn__loader"
        }, [slots.loader?.() ?? createVNode(VProgressCircular, {
          "color": typeof props.loading === 'boolean' ? undefined : props.loading,
          "indeterminate": true,
          "width": "2"
        }, null)])]
      }), [[Ripple, !isDisabled.value && props.ripple, '', {
        center: !!props.icon
      }]]);
    });
    return {
      group
    };
  }
});

const makeVAppBarNavIconProps = propsFactory({
  ...makeVBtnProps({
    icon: '$menu',
    variant: 'text'
  })
}, 'VAppBarNavIcon');
const VAppBarNavIcon = genericComponent()({
  name: 'VAppBarNavIcon',
  props: makeVAppBarNavIconProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(VBtn, mergeProps(props, {
      "class": ['v-app-bar-nav-icon']
    }), slots));
    return {};
  }
});

const VAppBarTitle = genericComponent()({
  name: 'VAppBarTitle',
  props: makeVToolbarTitleProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(VToolbarTitle, mergeProps(props, {
      "class": "v-app-bar-title"
    }), slots));
    return {};
  }
});

// Utilities
const VAlertTitle = createSimpleFunctional('v-alert-title');

const allowedTypes = ['success', 'info', 'warning', 'error'];
const makeVAlertProps = propsFactory({
  border: {
    type: [Boolean, String],
    validator: val => {
      return typeof val === 'boolean' || ['top', 'end', 'bottom', 'start'].includes(val);
    }
  },
  borderColor: String,
  closable: Boolean,
  closeIcon: {
    type: IconValue,
    default: '$close'
  },
  closeLabel: {
    type: String,
    default: '$vuetify.close'
  },
  icon: {
    type: [Boolean, String, Function, Object],
    default: null
  },
  modelValue: {
    type: Boolean,
    default: true
  },
  prominent: Boolean,
  title: String,
  text: String,
  type: {
    type: String,
    validator: val => allowedTypes.includes(val)
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'flat'
  })
}, 'VAlert');
const VAlert = genericComponent()({
  name: 'VAlert',
  props: makeVAlertProps(),
  emits: {
    'click:close': e => true,
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const isActive = useProxiedModel(props, 'modelValue');
    const icon = computed(() => {
      if (props.icon === false) return undefined;
      if (!props.type) return props.icon;
      return props.icon ?? `$${props.type}`;
    });
    const variantProps = computed(() => ({
      color: props.color ?? props.type,
      variant: props.variant
    }));
    const {
      themeClasses
    } = provideTheme(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(variantProps);
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      locationStyles
    } = useLocation(props);
    const {
      positionClasses
    } = usePosition(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'borderColor'));
    const {
      t
    } = useLocale();
    const closeProps = computed(() => ({
      'aria-label': t(props.closeLabel),
      onClick(e) {
        isActive.value = false;
        emit('click:close', e);
      }
    }));
    return () => {
      const hasPrepend = !!(slots.prepend || icon.value);
      const hasTitle = !!(slots.title || props.title);
      const hasClose = !!(slots.close || props.closable);
      return isActive.value && createVNode(props.tag, {
        "class": ['v-alert', props.border && {
          'v-alert--border': !!props.border,
          [`v-alert--border-${props.border === true ? 'start' : props.border}`]: true
        }, {
          'v-alert--prominent': props.prominent
        }, themeClasses.value, colorClasses.value, densityClasses.value, elevationClasses.value, positionClasses.value, roundedClasses.value, variantClasses.value, props.class],
        "style": [colorStyles.value, dimensionStyles.value, locationStyles.value, props.style],
        "role": "alert"
      }, {
        default: () => [genOverlays(false, 'v-alert'), props.border && createVNode("div", {
          "key": "border",
          "class": ['v-alert__border', textColorClasses.value],
          "style": textColorStyles.value
        }, null), hasPrepend && createVNode("div", {
          "key": "prepend",
          "class": "v-alert__prepend"
        }, [!slots.prepend ? createVNode(VIcon, {
          "key": "prepend-icon",
          "density": props.density,
          "icon": icon.value,
          "size": props.prominent ? 44 : 28
        }, null) : createVNode(VDefaultsProvider, {
          "key": "prepend-defaults",
          "disabled": !icon.value,
          "defaults": {
            VIcon: {
              density: props.density,
              icon: icon.value,
              size: props.prominent ? 44 : 28
            }
          }
        }, slots.prepend)]), createVNode("div", {
          "class": "v-alert__content"
        }, [hasTitle && createVNode(VAlertTitle, {
          "key": "title"
        }, {
          default: () => [slots.title?.() ?? props.title]
        }), slots.text?.() ?? props.text, slots.default?.()]), slots.append && createVNode("div", {
          "key": "append",
          "class": "v-alert__append"
        }, [slots.append()]), hasClose && createVNode("div", {
          "key": "close",
          "class": "v-alert__close"
        }, [!slots.close ? createVNode(VBtn, mergeProps({
          "key": "close-btn",
          "icon": props.closeIcon,
          "size": "x-small",
          "variant": "text"
        }, closeProps.value), null) : createVNode(VDefaultsProvider, {
          "key": "close-defaults",
          "defaults": {
            VBtn: {
              icon: props.closeIcon,
              size: 'x-small',
              variant: 'text'
            }
          }
        }, {
          default: () => [slots.close?.({
            props: closeProps.value
          })]
        })])]
      });
    };
  }
});

const makeVAvatarProps = propsFactory({
  start: Boolean,
  end: Boolean,
  icon: IconValue,
  image: String,
  text: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'flat'
  })
}, 'VAvatar');
const VAvatar = genericComponent()({
  name: 'VAvatar',
  props: makeVAvatarProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      sizeClasses,
      sizeStyles
    } = useSize(props);
    useRender(() => createVNode(props.tag, {
      "class": ['v-avatar', {
        'v-avatar--start': props.start,
        'v-avatar--end': props.end
      }, themeClasses.value, borderClasses.value, colorClasses.value, densityClasses.value, roundedClasses.value, sizeClasses.value, variantClasses.value, props.class],
      "style": [colorStyles.value, sizeStyles.value, props.style]
    }, {
      default: () => [!slots.default ? props.image ? createVNode(VImg, {
        "key": "image",
        "src": props.image,
        "alt": "",
        "cover": true
      }, null) : props.icon ? createVNode(VIcon, {
        "key": "icon",
        "icon": props.icon
      }, null) : props.text : createVNode(VDefaultsProvider, {
        "key": "content-defaults",
        "defaults": {
          VImg: {
            cover: true,
            src: props.image
          },
          VIcon: {
            icon: props.icon
          }
        }
      }, {
        default: () => [slots.default()]
      }), genOverlays(false, 'v-avatar')]
    }));
    return {};
  }
});

const makeVLabelProps = propsFactory({
  text: String,
  onClick: EventProp(),
  ...makeComponentProps(),
  ...makeThemeProps()
}, 'VLabel');
const VLabel = genericComponent()({
  name: 'VLabel',
  props: makeVLabelProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode("label", {
      "class": ['v-label', {
        'v-label--clickable': !!props.onClick
      }, props.class],
      "style": props.style,
      "onClick": props.onClick
    }, [props.text, slots.default?.()]));
    return {};
  }
});

const VSelectionControlGroupSymbol = Symbol.for('vuetify:selection-control-group');
const makeSelectionControlGroupProps = propsFactory({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: IconValue,
  trueIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeThemeProps()
}, 'SelectionControlGroup');
const makeVSelectionControlGroupProps = propsFactory({
  ...makeSelectionControlGroupProps({
    defaultsTarget: 'VSelectionControl'
  })
}, 'VSelectionControlGroup');
const VSelectionControlGroup = genericComponent()({
  name: 'VSelectionControlGroup',
  props: makeVSelectionControlGroupProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const modelValue = useProxiedModel(props, 'modelValue');
    const uid = getUid();
    const id = computed(() => props.id || `v-selection-control-group-${uid}`);
    const name = computed(() => props.name || id.value);
    const updateHandlers = new Set();
    provide(VSelectionControlGroupSymbol, {
      modelValue,
      forceUpdate: () => {
        updateHandlers.forEach(fn => fn());
      },
      onForceUpdate: cb => {
        updateHandlers.add(cb);
        onScopeDispose(() => {
          updateHandlers.delete(cb);
        });
      }
    });
    provideDefaults({
      [props.defaultsTarget]: {
        color: toRef(props, 'color'),
        disabled: toRef(props, 'disabled'),
        density: toRef(props, 'density'),
        error: toRef(props, 'error'),
        inline: toRef(props, 'inline'),
        modelValue,
        multiple: computed(() => !!props.multiple || props.multiple == null && Array.isArray(modelValue.value)),
        name,
        falseIcon: toRef(props, 'falseIcon'),
        trueIcon: toRef(props, 'trueIcon'),
        readonly: toRef(props, 'readonly'),
        ripple: toRef(props, 'ripple'),
        type: toRef(props, 'type'),
        valueComparator: toRef(props, 'valueComparator')
      }
    });
    useRender(() => createVNode("div", {
      "class": ['v-selection-control-group', {
        'v-selection-control-group--inline': props.inline
      }, props.class],
      "style": props.style,
      "role": props.type === 'radio' ? 'radiogroup' : undefined
    }, [slots.default?.()]));
    return {};
  }
});

const makeVSelectionControlProps = propsFactory({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...makeComponentProps(),
  ...makeSelectionControlGroupProps()
}, 'VSelectionControl');
function useSelectionControl(props) {
  const group = inject$2(VSelectionControlGroupSymbol, undefined);
  const {
    densityClasses
  } = useDensity(props);
  const modelValue = useProxiedModel(props, 'modelValue');
  const trueValue = computed(() => props.trueValue !== undefined ? props.trueValue : props.value !== undefined ? props.value : true);
  const falseValue = computed(() => props.falseValue !== undefined ? props.falseValue : false);
  const isMultiple = computed(() => !!props.multiple || props.multiple == null && Array.isArray(modelValue.value));
  const model = computed({
    get() {
      const val = group ? group.modelValue.value : modelValue.value;
      return isMultiple.value ? wrapInArray(val).some(v => props.valueComparator(v, trueValue.value)) : props.valueComparator(val, trueValue.value);
    },
    set(val) {
      if (props.readonly) return;
      const currentValue = val ? trueValue.value : falseValue.value;
      let newVal = currentValue;
      if (isMultiple.value) {
        newVal = val ? [...wrapInArray(modelValue.value), currentValue] : wrapInArray(modelValue.value).filter(item => !props.valueComparator(item, trueValue.value));
      }
      if (group) {
        group.modelValue.value = newVal;
      } else {
        modelValue.value = newVal;
      }
    }
  });
  const {
    textColorClasses,
    textColorStyles
  } = useTextColor(computed(() => {
    if (props.error || props.disabled) return undefined;
    return model.value ? props.color : props.baseColor;
  }));
  const {
    backgroundColorClasses,
    backgroundColorStyles
  } = useBackgroundColor(computed(() => {
    return model.value && !props.error && !props.disabled ? props.color : props.baseColor;
  }));
  const icon = computed(() => model.value ? props.trueIcon : props.falseIcon);
  return {
    group,
    densityClasses,
    trueValue,
    falseValue,
    model,
    textColorClasses,
    textColorStyles,
    backgroundColorClasses,
    backgroundColorStyles,
    icon
  };
}
const VSelectionControl = genericComponent()({
  name: 'VSelectionControl',
  directives: {
    Ripple
  },
  inheritAttrs: false,
  props: makeVSelectionControlProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      group,
      densityClasses,
      icon,
      model,
      textColorClasses,
      textColorStyles,
      backgroundColorClasses,
      backgroundColorStyles,
      trueValue
    } = useSelectionControl(props);
    const uid = getUid();
    const isFocused = shallowRef(false);
    const isFocusVisible = shallowRef(false);
    const input = ref();
    const id = computed(() => props.id || `input-${uid}`);
    const isInteractive = computed(() => !props.disabled && !props.readonly);
    group?.onForceUpdate(() => {
      if (input.value) {
        input.value.checked = model.value;
      }
    });
    function onFocus(e) {
      if (!isInteractive.value) return;
      isFocused.value = true;
      if (matchesSelector(e.target, ':focus-visible') !== false) {
        isFocusVisible.value = true;
      }
    }
    function onBlur() {
      isFocused.value = false;
      isFocusVisible.value = false;
    }
    function onClickLabel(e) {
      e.stopPropagation();
    }
    function onInput(e) {
      if (!isInteractive.value) {
        if (input.value) {
          // model value is not updated when input is not interactive
          // but the internal checked state of the input is still updated,
          // so here it's value is restored
          input.value.checked = model.value;
        }
        return;
      }
      if (props.readonly && group) {
        nextTick(() => group.forceUpdate());
      }
      model.value = e.target.checked;
    }
    useRender(() => {
      const label = slots.label ? slots.label({
        label: props.label,
        props: {
          for: id.value
        }
      }) : props.label;
      const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
      const inputNode = createVNode("input", mergeProps({
        "ref": input,
        "checked": model.value,
        "disabled": !!props.disabled,
        "id": id.value,
        "onBlur": onBlur,
        "onFocus": onFocus,
        "onInput": onInput,
        "aria-disabled": !!props.disabled,
        "aria-label": props.label,
        "type": props.type,
        "value": trueValue.value,
        "name": props.name,
        "aria-checked": props.type === 'checkbox' ? model.value : undefined
      }, inputAttrs), null);
      return createVNode("div", mergeProps({
        "class": ['v-selection-control', {
          'v-selection-control--dirty': model.value,
          'v-selection-control--disabled': props.disabled,
          'v-selection-control--error': props.error,
          'v-selection-control--focused': isFocused.value,
          'v-selection-control--focus-visible': isFocusVisible.value,
          'v-selection-control--inline': props.inline
        }, densityClasses.value, props.class]
      }, rootAttrs, {
        "style": props.style
      }), [createVNode("div", {
        "class": ['v-selection-control__wrapper', textColorClasses.value],
        "style": textColorStyles.value
      }, [slots.default?.({
        backgroundColorClasses,
        backgroundColorStyles
      }), withDirectives(createVNode("div", {
        "class": ['v-selection-control__input']
      }, [slots.input?.({
        model,
        textColorClasses,
        textColorStyles,
        backgroundColorClasses,
        backgroundColorStyles,
        inputNode,
        icon: icon.value,
        props: {
          onFocus,
          onBlur,
          id: id.value
        }
      }) ?? createVNode(Fragment, null, [icon.value && createVNode(VIcon, {
        "key": "icon",
        "icon": icon.value
      }, null), inputNode])]), [[resolveDirective("ripple"), props.ripple && [!props.disabled && !props.readonly, null, ['center', 'circle']]]])]), label && createVNode(VLabel, {
        "for": id.value,
        "onClick": onClickLabel
      }, {
        default: () => [label]
      })]);
    });
    return {
      isFocused,
      input
    };
  }
});

const makeVCheckboxBtnProps = propsFactory({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: IconValue,
    default: '$checkboxIndeterminate'
  },
  ...makeVSelectionControlProps({
    falseIcon: '$checkboxOff',
    trueIcon: '$checkboxOn'
  })
}, 'VCheckboxBtn');
const VCheckboxBtn = genericComponent()({
  name: 'VCheckboxBtn',
  props: makeVCheckboxBtnProps(),
  emits: {
    'update:modelValue': value => true,
    'update:indeterminate': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const indeterminate = useProxiedModel(props, 'indeterminate');
    const model = useProxiedModel(props, 'modelValue');
    function onChange(v) {
      if (indeterminate.value) {
        indeterminate.value = false;
      }
    }
    const falseIcon = computed(() => {
      return indeterminate.value ? props.indeterminateIcon : props.falseIcon;
    });
    const trueIcon = computed(() => {
      return indeterminate.value ? props.indeterminateIcon : props.trueIcon;
    });
    useRender(() => {
      const controlProps = omit(VSelectionControl.filterProps(props), ['modelValue']);
      return createVNode(VSelectionControl, mergeProps(controlProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": [$event => model.value = $event, onChange],
        "class": ['v-checkbox-btn', props.class],
        "style": props.style,
        "type": "checkbox",
        "falseIcon": falseIcon.value,
        "trueIcon": trueIcon.value,
        "aria-checked": indeterminate.value ? 'mixed' : undefined
      }), slots);
    });
    return {};
  }
});

function useInputIcon(props) {
  const {
    t
  } = useLocale();
  function InputIcon(_ref) {
    let {
      name
    } = _ref;
    const localeKey = {
      prepend: 'prependAction',
      prependInner: 'prependAction',
      append: 'appendAction',
      appendInner: 'appendAction',
      clear: 'clear'
    }[name];
    const listener = props[`onClick:${name}`];
    const label = listener && localeKey ? t(`$vuetify.input.${localeKey}`, props.label ?? '') : undefined;
    return createVNode(VIcon, {
      "icon": props[`${name}Icon`],
      "aria-label": label,
      "onClick": listener
    }, null);
  }
  return {
    InputIcon
  };
}

const makeVMessagesProps = propsFactory({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...makeComponentProps(),
  ...makeTransitionProps({
    transition: {
      component: VSlideYTransition,
      leaveAbsolute: true,
      group: true
    }
  })
}, 'VMessages');
const VMessages = genericComponent()({
  name: 'VMessages',
  props: makeVMessagesProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const messages = computed(() => wrapInArray(props.messages));
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(computed(() => props.color));
    useRender(() => createVNode(MaybeTransition, {
      "transition": props.transition,
      "tag": "div",
      "class": ['v-messages', textColorClasses.value, props.class],
      "style": [textColorStyles.value, props.style],
      "role": "alert",
      "aria-live": "polite"
    }, {
      default: () => [props.active && messages.value.map((message, i) => createVNode("div", {
        "class": "v-messages__message",
        "key": `${i}-${messages.value}`
      }, [slots.message ? slots.message({
        message
      }) : message]))]
    }));
    return {};
  }
});

// Composables
// Composables
const makeFocusProps = propsFactory({
  focused: Boolean,
  'onUpdate:focused': EventProp()
}, 'focus');
function useFocus(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  const isFocused = useProxiedModel(props, 'focused');
  const focusClasses = computed(() => {
    return {
      [`${name}--focused`]: isFocused.value
    };
  });
  function focus() {
    isFocused.value = true;
  }
  function blur() {
    isFocused.value = false;
  }
  return {
    focusClasses,
    isFocused,
    focus,
    blur
  };
}

// Composables
const FormKey = Symbol.for('vuetify:form');
function useForm(props) {
  const form = inject$2(FormKey, null);
  return {
    ...form,
    isReadonly: computed(() => !!(props?.readonly ?? form?.isReadonly.value)),
    isDisabled: computed(() => !!(props?.disabled ?? form?.isDisabled.value))
  };
}

// Composables
const makeValidationProps = propsFactory({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...makeFocusProps()
}, 'validation');
function useValidation(props) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentInstanceName();
  let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getUid();
  const model = useProxiedModel(props, 'modelValue');
  const validationModel = computed(() => props.validationValue === undefined ? model.value : props.validationValue);
  const form = useForm(props);
  const internalErrorMessages = ref([]);
  const isPristine = shallowRef(true);
  const isDirty = computed(() => !!(wrapInArray(model.value === '' ? null : model.value).length || wrapInArray(validationModel.value === '' ? null : validationModel.value).length));
  const errorMessages = computed(() => {
    return props.errorMessages?.length ? wrapInArray(props.errorMessages).concat(internalErrorMessages.value).slice(0, Math.max(0, +props.maxErrors)) : internalErrorMessages.value;
  });
  const validateOn = computed(() => {
    let value = (props.validateOn ?? form.validateOn?.value) || 'input';
    if (value === 'lazy') value = 'input lazy';
    if (value === 'eager') value = 'input eager';
    const set = new Set(value?.split(' ') ?? []);
    return {
      input: set.has('input'),
      blur: set.has('blur') || set.has('input') || set.has('invalid-input'),
      invalidInput: set.has('invalid-input'),
      lazy: set.has('lazy'),
      eager: set.has('eager')
    };
  });
  const isValid = computed(() => {
    if (props.error || props.errorMessages?.length) return false;
    if (!props.rules.length) return true;
    if (isPristine.value) {
      return internalErrorMessages.value.length || validateOn.value.lazy ? null : true;
    } else {
      return !internalErrorMessages.value.length;
    }
  });
  const isValidating = shallowRef(false);
  const validationClasses = computed(() => {
    return {
      [`${name}--error`]: isValid.value === false,
      [`${name}--dirty`]: isDirty.value,
      [`${name}--disabled`]: form.isDisabled.value,
      [`${name}--readonly`]: form.isReadonly.value
    };
  });
  const vm = getCurrentInstance('validation');
  const uid = computed(() => props.name ?? unref(id));
  onBeforeMount(() => {
    form.register?.({
      id: uid.value,
      vm,
      validate,
      reset,
      resetValidation
    });
  });
  onBeforeUnmount(() => {
    form.unregister?.(uid.value);
  });
  onMounted(async () => {
    if (!validateOn.value.lazy) {
      await validate(!validateOn.value.eager);
    }
    form.update?.(uid.value, isValid.value, errorMessages.value);
  });
  useToggleScope(() => validateOn.value.input || validateOn.value.invalidInput && isValid.value === false, () => {
    watch(validationModel, () => {
      if (validationModel.value != null) {
        validate();
      } else if (props.focused) {
        const unwatch = watch(() => props.focused, val => {
          if (!val) validate();
          unwatch();
        });
      }
    });
  });
  useToggleScope(() => validateOn.value.blur, () => {
    watch(() => props.focused, val => {
      if (!val) validate();
    });
  });
  watch([isValid, errorMessages], () => {
    form.update?.(uid.value, isValid.value, errorMessages.value);
  });
  async function reset() {
    model.value = null;
    await nextTick();
    await resetValidation();
  }
  async function resetValidation() {
    isPristine.value = true;
    if (!validateOn.value.lazy) {
      await validate(!validateOn.value.eager);
    } else {
      internalErrorMessages.value = [];
    }
  }
  async function validate() {
    let silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const results = [];
    isValidating.value = true;
    for (const rule of props.rules) {
      if (results.length >= +(props.maxErrors ?? 1)) {
        break;
      }
      const handler = typeof rule === 'function' ? rule : () => rule;
      const result = await handler(validationModel.value);
      if (result === true) continue;
      if (result !== false && typeof result !== 'string') {
        // eslint-disable-next-line no-console
        console.warn(`${result} is not a valid value. Rule functions must return boolean true or a string.`);
        continue;
      }
      results.push(result || '');
    }
    internalErrorMessages.value = results;
    isValidating.value = false;
    isPristine.value = silent;
    return internalErrorMessages.value;
  }
  return {
    errorMessages,
    isDirty,
    isDisabled: form.isDisabled,
    isReadonly: form.isReadonly,
    isPristine,
    isValid,
    isValidating,
    reset,
    resetValidation,
    validate,
    validationClasses
  };
}

const makeVInputProps = propsFactory({
  id: String,
  appendIcon: IconValue,
  centerAffix: {
    type: Boolean,
    default: true
  },
  prependIcon: IconValue,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: 'horizontal',
    validator: v => ['horizontal', 'vertical'].includes(v)
  },
  'onClick:prepend': EventProp(),
  'onClick:append': EventProp(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...only(makeDimensionProps(), ['maxWidth', 'minWidth', 'width']),
  ...makeThemeProps(),
  ...makeValidationProps()
}, 'VInput');
const VInput = genericComponent()({
  name: 'VInput',
  props: {
    ...makeVInputProps()
  },
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots,
      emit
    } = _ref;
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      themeClasses
    } = provideTheme(props);
    const {
      rtlClasses
    } = useRtl();
    const {
      InputIcon
    } = useInputIcon(props);
    const uid = getUid();
    const id = computed(() => props.id || `input-${uid}`);
    const messagesId = computed(() => `${id.value}-messages`);
    const {
      errorMessages,
      isDirty,
      isDisabled,
      isReadonly,
      isPristine,
      isValid,
      isValidating,
      reset,
      resetValidation,
      validate,
      validationClasses
    } = useValidation(props, 'v-input', id);
    const slotProps = computed(() => ({
      id,
      messagesId,
      isDirty,
      isDisabled,
      isReadonly,
      isPristine,
      isValid,
      isValidating,
      reset,
      resetValidation,
      validate
    }));
    const messages = computed(() => {
      if (props.errorMessages?.length || !isPristine.value && errorMessages.value.length) {
        return errorMessages.value;
      } else if (props.hint && (props.persistentHint || props.focused)) {
        return props.hint;
      } else {
        return props.messages;
      }
    });
    useRender(() => {
      const hasPrepend = !!(slots.prepend || props.prependIcon);
      const hasAppend = !!(slots.append || props.appendIcon);
      const hasMessages = messages.value.length > 0;
      const hasDetails = !props.hideDetails || props.hideDetails === 'auto' && (hasMessages || !!slots.details);
      return createVNode("div", {
        "class": ['v-input', `v-input--${props.direction}`, {
          'v-input--center-affix': props.centerAffix,
          'v-input--hide-spin-buttons': props.hideSpinButtons
        }, densityClasses.value, themeClasses.value, rtlClasses.value, validationClasses.value, props.class],
        "style": [dimensionStyles.value, props.style]
      }, [hasPrepend && createVNode("div", {
        "key": "prepend",
        "class": "v-input__prepend"
      }, [slots.prepend?.(slotProps.value), props.prependIcon && createVNode(InputIcon, {
        "key": "prepend-icon",
        "name": "prepend"
      }, null)]), slots.default && createVNode("div", {
        "class": "v-input__control"
      }, [slots.default?.(slotProps.value)]), hasAppend && createVNode("div", {
        "key": "append",
        "class": "v-input__append"
      }, [props.appendIcon && createVNode(InputIcon, {
        "key": "append-icon",
        "name": "append"
      }, null), slots.append?.(slotProps.value)]), hasDetails && createVNode("div", {
        "class": "v-input__details"
      }, [createVNode(VMessages, {
        "id": messagesId.value,
        "active": hasMessages,
        "messages": messages.value
      }, {
        message: slots.message
      }), slots.details?.(slotProps.value)])]);
    });
    return {
      reset,
      resetValidation,
      validate,
      isValid,
      errorMessages
    };
  }
});

const makeVCheckboxProps = propsFactory({
  ...makeVInputProps(),
  ...omit(makeVCheckboxBtnProps(), ['inline'])
}, 'VCheckbox');
const VCheckbox = genericComponent()({
  name: 'VCheckbox',
  inheritAttrs: false,
  props: makeVCheckboxProps(),
  emits: {
    'update:modelValue': value => true,
    'update:focused': focused => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const {
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const uid = getUid();
    const id = computed(() => props.id || `checkbox-${uid}`);
    useRender(() => {
      const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
      const inputProps = VInput.filterProps(props);
      const checkboxProps = VCheckboxBtn.filterProps(props);
      return createVNode(VInput, mergeProps({
        "class": ['v-checkbox', props.class]
      }, rootAttrs, inputProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "id": id.value,
        "focused": isFocused.value,
        "style": props.style
      }), {
        ...slots,
        default: _ref2 => {
          let {
            id,
            messagesId,
            isDisabled,
            isReadonly,
            isValid
          } = _ref2;
          return createVNode(VCheckboxBtn, mergeProps(checkboxProps, {
            "id": id.value,
            "aria-describedby": messagesId.value,
            "disabled": isDisabled.value,
            "readonly": isReadonly.value
          }, controlAttrs, {
            "error": isValid.value === false,
            "modelValue": model.value,
            "onUpdate:modelValue": $event => model.value = $event,
            "onFocus": focus,
            "onBlur": blur
          }), slots);
        }
      });
    });
    return {};
  }
});

function calculateUpdatedTarget(_ref) {
  let {
    selectedElement,
    containerElement,
    isRtl,
    isHorizontal
  } = _ref;
  const containerSize = getOffsetSize(isHorizontal, containerElement);
  const scrollPosition = getScrollPosition(isHorizontal, isRtl, containerElement);
  const childrenSize = getOffsetSize(isHorizontal, selectedElement);
  const childrenStartPosition = getOffsetPosition(isHorizontal, selectedElement);
  const additionalOffset = childrenSize * 0.4;
  if (scrollPosition > childrenStartPosition) {
    return childrenStartPosition - additionalOffset;
  } else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) {
    return childrenStartPosition - containerSize + childrenSize + additionalOffset;
  }
  return scrollPosition;
}
function calculateCenteredTarget(_ref2) {
  let {
    selectedElement,
    containerElement,
    isHorizontal
  } = _ref2;
  const containerOffsetSize = getOffsetSize(isHorizontal, containerElement);
  const childrenOffsetPosition = getOffsetPosition(isHorizontal, selectedElement);
  const childrenOffsetSize = getOffsetSize(isHorizontal, selectedElement);
  return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
}
function getScrollSize(isHorizontal, element) {
  const key = isHorizontal ? 'scrollWidth' : 'scrollHeight';
  return element?.[key] || 0;
}
function getClientSize(isHorizontal, element) {
  const key = isHorizontal ? 'clientWidth' : 'clientHeight';
  return element?.[key] || 0;
}
function getScrollPosition(isHorizontal, rtl, element) {
  if (!element) {
    return 0;
  }
  const {
    scrollLeft,
    offsetWidth,
    scrollWidth
  } = element;
  if (isHorizontal) {
    return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
  }
  return element.scrollTop;
}
function getOffsetSize(isHorizontal, element) {
  const key = isHorizontal ? 'offsetWidth' : 'offsetHeight';
  return element?.[key] || 0;
}
function getOffsetPosition(isHorizontal, element) {
  const key = isHorizontal ? 'offsetLeft' : 'offsetTop';
  return element?.[key] || 0;
}

const VSlideGroupSymbol = Symbol.for('vuetify:v-slide-group');
const makeVSlideGroupProps = propsFactory({
  centerActive: Boolean,
  direction: {
    type: String,
    default: 'horizontal'
  },
  symbol: {
    type: null,
    default: VSlideGroupSymbol
  },
  nextIcon: {
    type: IconValue,
    default: '$next'
  },
  prevIcon: {
    type: IconValue,
    default: '$prev'
  },
  showArrows: {
    type: [Boolean, String],
    validator: v => typeof v === 'boolean' || ['always', 'desktop', 'mobile'].includes(v)
  },
  ...makeComponentProps(),
  ...makeDisplayProps({
    mobile: null
  }),
  ...makeTagProps(),
  ...makeGroupProps({
    selectedClass: 'v-slide-group-item--active'
  })
}, 'VSlideGroup');
const VSlideGroup = genericComponent()({
  name: 'VSlideGroup',
  props: makeVSlideGroupProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      isRtl
    } = useRtl();
    const {
      displayClasses,
      mobile
    } = useDisplay(props);
    const group = useGroup(props, props.symbol);
    const isOverflowing = shallowRef(false);
    const scrollOffset = shallowRef(0);
    const containerSize = shallowRef(0);
    const contentSize = shallowRef(0);
    const isHorizontal = computed(() => props.direction === 'horizontal');
    const {
      resizeRef: containerRef,
      contentRect: containerRect
    } = useResizeObserver();
    const {
      resizeRef: contentRef,
      contentRect
    } = useResizeObserver();
    const goTo = useGoTo();
    const goToOptions = computed(() => {
      return {
        container: containerRef.el,
        duration: 200,
        easing: 'easeOutQuart'
      };
    });
    const firstSelectedIndex = computed(() => {
      if (!group.selected.value.length) return -1;
      return group.items.value.findIndex(item => item.id === group.selected.value[0]);
    });
    const lastSelectedIndex = computed(() => {
      if (!group.selected.value.length) return -1;
      return group.items.value.findIndex(item => item.id === group.selected.value[group.selected.value.length - 1]);
    });
    if (IN_BROWSER) {
      let frame = -1;
      watch(() => [group.selected.value, containerRect.value, contentRect.value, isHorizontal.value], () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (containerRect.value && contentRect.value) {
            const sizeProperty = isHorizontal.value ? 'width' : 'height';
            containerSize.value = containerRect.value[sizeProperty];
            contentSize.value = contentRect.value[sizeProperty];
            isOverflowing.value = containerSize.value + 1 < contentSize.value;
          }
          if (firstSelectedIndex.value >= 0 && contentRef.el) {
            // TODO: Is this too naive? Should we store element references in group composable?
            const selectedElement = contentRef.el.children[lastSelectedIndex.value];
            scrollToChildren(selectedElement, props.centerActive);
          }
        });
      });
    }
    const isFocused = shallowRef(false);
    function scrollToChildren(children, center) {
      let target = 0;
      if (center) {
        target = calculateCenteredTarget({
          containerElement: containerRef.el,
          isHorizontal: isHorizontal.value,
          selectedElement: children
        });
      } else {
        target = calculateUpdatedTarget({
          containerElement: containerRef.el,
          isHorizontal: isHorizontal.value,
          isRtl: isRtl.value,
          selectedElement: children
        });
      }
      scrollToPosition(target);
    }
    function scrollToPosition(newPosition) {
      if (!IN_BROWSER || !containerRef.el) return;
      const offsetSize = getOffsetSize(isHorizontal.value, containerRef.el);
      const scrollPosition = getScrollPosition(isHorizontal.value, isRtl.value, containerRef.el);
      const scrollSize = getScrollSize(isHorizontal.value, containerRef.el);
      if (scrollSize <= offsetSize ||
      // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(newPosition - scrollPosition) < 16) return;
      if (isHorizontal.value && isRtl.value && containerRef.el) {
        const {
          scrollWidth,
          offsetWidth: containerWidth
        } = containerRef.el;
        newPosition = scrollWidth - containerWidth - newPosition;
      }
      if (isHorizontal.value) {
        goTo.horizontal(newPosition, goToOptions.value);
      } else {
        goTo(newPosition, goToOptions.value);
      }
    }
    function onScroll(e) {
      const {
        scrollTop,
        scrollLeft
      } = e.target;
      scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
    }
    function onFocusin(e) {
      isFocused.value = true;
      if (!isOverflowing.value || !contentRef.el) return;

      // Focused element is likely to be the root of an item, so a
      // breadth-first search will probably find it in the first iteration
      for (const el of e.composedPath()) {
        for (const item of contentRef.el.children) {
          if (item === el) {
            scrollToChildren(item);
            return;
          }
        }
      }
    }
    function onFocusout(e) {
      isFocused.value = false;
    }

    // Affix clicks produce onFocus that we have to ignore to avoid extra scrollToChildren
    let ignoreFocusEvent = false;
    function onFocus(e) {
      if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && contentRef.el?.contains(e.relatedTarget))) focus();
      ignoreFocusEvent = false;
    }
    function onFocusAffixes() {
      ignoreFocusEvent = true;
    }
    function onKeydown(e) {
      if (!contentRef.el) return;
      function toFocus(location) {
        e.preventDefault();
        focus(location);
      }
      if (isHorizontal.value) {
        if (e.key === 'ArrowRight') {
          toFocus(isRtl.value ? 'prev' : 'next');
        } else if (e.key === 'ArrowLeft') {
          toFocus(isRtl.value ? 'next' : 'prev');
        }
      } else {
        if (e.key === 'ArrowDown') {
          toFocus('next');
        } else if (e.key === 'ArrowUp') {
          toFocus('prev');
        }
      }
      if (e.key === 'Home') {
        toFocus('first');
      } else if (e.key === 'End') {
        toFocus('last');
      }
    }
    function focus(location) {
      if (!contentRef.el) return;
      let el;
      if (!location) {
        const focusable = focusableChildren(contentRef.el);
        el = focusable[0];
      } else if (location === 'next') {
        el = contentRef.el.querySelector(':focus')?.nextElementSibling;
        if (!el) return focus('first');
      } else if (location === 'prev') {
        el = contentRef.el.querySelector(':focus')?.previousElementSibling;
        if (!el) return focus('last');
      } else if (location === 'first') {
        el = contentRef.el.firstElementChild;
      } else if (location === 'last') {
        el = contentRef.el.lastElementChild;
      }
      if (el) {
        el.focus({
          preventScroll: true
        });
      }
    }
    function scrollTo(location) {
      const direction = isHorizontal.value && isRtl.value ? -1 : 1;
      const offsetStep = (location === 'prev' ? -direction : direction) * containerSize.value;
      let newPosition = scrollOffset.value + offsetStep;

      // TODO: improve it
      if (isHorizontal.value && isRtl.value && containerRef.el) {
        const {
          scrollWidth,
          offsetWidth: containerWidth
        } = containerRef.el;
        newPosition += scrollWidth - containerWidth;
      }
      scrollToPosition(newPosition);
    }
    const slotProps = computed(() => ({
      next: group.next,
      prev: group.prev,
      select: group.select,
      isSelected: group.isSelected
    }));
    const hasAffixes = computed(() => {
      switch (props.showArrows) {
        // Always show arrows on desktop & mobile
        case 'always':
          return true;

        // Always show arrows on desktop
        case 'desktop':
          return !mobile.value;

        // Show arrows on mobile when overflowing.
        // This matches the default 2.2 behavior
        case true:
          return isOverflowing.value || Math.abs(scrollOffset.value) > 0;

        // Always show on mobile
        case 'mobile':
          return mobile.value || isOverflowing.value || Math.abs(scrollOffset.value) > 0;

        // https://material.io/components/tabs#scrollable-tabs
        // Always show arrows when
        // overflowed on desktop
        default:
          return !mobile.value && (isOverflowing.value || Math.abs(scrollOffset.value) > 0);
      }
    });
    const hasPrev = computed(() => {
      // 1 pixel in reserve, may be lost after rounding
      return Math.abs(scrollOffset.value) > 1;
    });
    const hasNext = computed(() => {
      if (!containerRef.value) return false;
      const scrollSize = getScrollSize(isHorizontal.value, containerRef.el);
      const clientSize = getClientSize(isHorizontal.value, containerRef.el);
      const scrollSizeMax = scrollSize - clientSize;

      // 1 pixel in reserve, may be lost after rounding
      return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
    });
    useRender(() => createVNode(props.tag, {
      "class": ['v-slide-group', {
        'v-slide-group--vertical': !isHorizontal.value,
        'v-slide-group--has-affixes': hasAffixes.value,
        'v-slide-group--is-overflowing': isOverflowing.value
      }, displayClasses.value, props.class],
      "style": props.style,
      "tabindex": isFocused.value || group.selected.value.length ? -1 : 0,
      "onFocus": onFocus
    }, {
      default: () => [hasAffixes.value && createVNode("div", {
        "key": "prev",
        "class": ['v-slide-group__prev', {
          'v-slide-group__prev--disabled': !hasPrev.value
        }],
        "onMousedown": onFocusAffixes,
        "onClick": () => hasPrev.value && scrollTo('prev')
      }, [slots.prev?.(slotProps.value) ?? createVNode(VFadeTransition, null, {
        default: () => [createVNode(VIcon, {
          "icon": isRtl.value ? props.nextIcon : props.prevIcon
        }, null)]
      })]), createVNode("div", {
        "key": "container",
        "ref": containerRef,
        "class": "v-slide-group__container",
        "onScroll": onScroll
      }, [createVNode("div", {
        "ref": contentRef,
        "class": "v-slide-group__content",
        "onFocusin": onFocusin,
        "onFocusout": onFocusout,
        "onKeydown": onKeydown
      }, [slots.default?.(slotProps.value)])]), hasAffixes.value && createVNode("div", {
        "key": "next",
        "class": ['v-slide-group__next', {
          'v-slide-group__next--disabled': !hasNext.value
        }],
        "onMousedown": onFocusAffixes,
        "onClick": () => hasNext.value && scrollTo('next')
      }, [slots.next?.(slotProps.value) ?? createVNode(VFadeTransition, null, {
        default: () => [createVNode(VIcon, {
          "icon": isRtl.value ? props.prevIcon : props.nextIcon
        }, null)]
      })])]
    }));
    return {
      selected: group.selected,
      scrollTo,
      scrollOffset,
      focus,
      hasPrev,
      hasNext
    };
  }
});

const VChipGroupSymbol = Symbol.for('vuetify:v-chip-group');
const makeVChipGroupProps = propsFactory({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeVSlideGroupProps(),
  ...makeComponentProps(),
  ...makeGroupProps({
    selectedClass: 'v-chip--selected'
  }),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'tonal'
  })
}, 'VChipGroup');
const VChipGroup = genericComponent()({
  name: 'VChipGroup',
  props: makeVChipGroupProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      isSelected,
      select,
      next,
      prev,
      selected
    } = useGroup(props, VChipGroupSymbol);
    provideDefaults({
      VChip: {
        color: toRef(props, 'color'),
        disabled: toRef(props, 'disabled'),
        filter: toRef(props, 'filter'),
        variant: toRef(props, 'variant')
      }
    });
    useRender(() => {
      const slideGroupProps = VSlideGroup.filterProps(props);
      return createVNode(VSlideGroup, mergeProps(slideGroupProps, {
        "class": ['v-chip-group', {
          'v-chip-group--column': props.column
        }, themeClasses.value, props.class],
        "style": props.style
      }), {
        default: () => [slots.default?.({
          isSelected,
          select,
          next,
          prev,
          selected: selected.value
        })]
      });
    });
    return {};
  }
});

const makeVChipProps = propsFactory({
  activeClass: String,
  appendAvatar: String,
  appendIcon: IconValue,
  closable: Boolean,
  closeIcon: {
    type: IconValue,
    default: '$delete'
  },
  closeLabel: {
    type: String,
    default: '$vuetify.close'
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: IconValue,
    default: '$complete'
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: undefined
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: true
  },
  onClick: EventProp(),
  onClickOnce: EventProp(),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: 'span'
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'tonal'
  })
}, 'VChip');
const VChip = genericComponent()({
  name: 'VChip',
  directives: {
    Ripple
  },
  props: makeVChipProps(),
  emits: {
    'click:close': e => true,
    'update:modelValue': value => true,
    'group:selected': val => true,
    click: e => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const {
      borderClasses
    } = useBorder(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      sizeClasses
    } = useSize(props);
    const {
      themeClasses
    } = provideTheme(props);
    const isActive = useProxiedModel(props, 'modelValue');
    const group = useGroupItem(props, VChipGroupSymbol, false);
    const link = useLink(props, attrs);
    const isLink = computed(() => props.link !== false && link.isLink.value);
    const isClickable = computed(() => !props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value));
    const closeProps = computed(() => ({
      'aria-label': t(props.closeLabel),
      onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        isActive.value = false;
        emit('click:close', e);
      }
    }));
    function onClick(e) {
      emit('click', e);
      if (!isClickable.value) return;
      link.navigate?.(e);
      group?.toggle();
    }
    function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    }
    return () => {
      const Tag = link.isLink.value ? 'a' : props.tag;
      const hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
      const hasAppend = !!(hasAppendMedia || slots.append);
      const hasClose = !!(slots.close || props.closable);
      const hasFilter = !!(slots.filter || props.filter) && group;
      const hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
      const hasPrepend = !!(hasPrependMedia || slots.prepend);
      const hasColor = !group || group.isSelected.value;
      return isActive.value && withDirectives(createVNode(Tag, mergeProps({
        "class": ['v-chip', {
          'v-chip--disabled': props.disabled,
          'v-chip--label': props.label,
          'v-chip--link': isClickable.value,
          'v-chip--filter': hasFilter,
          'v-chip--pill': props.pill,
          [`${props.activeClass}`]: props.activeClass && link.isActive?.value
        }, themeClasses.value, borderClasses.value, hasColor ? colorClasses.value : undefined, densityClasses.value, elevationClasses.value, roundedClasses.value, sizeClasses.value, variantClasses.value, group?.selectedClass.value, props.class],
        "style": [hasColor ? colorStyles.value : undefined, props.style],
        "disabled": props.disabled || undefined,
        "draggable": props.draggable,
        "tabindex": isClickable.value ? 0 : undefined,
        "onClick": onClick,
        "onKeydown": isClickable.value && !isLink.value && onKeyDown
      }, link.linkProps), {
        default: () => [genOverlays(isClickable.value, 'v-chip'), hasFilter && createVNode(VExpandXTransition, {
          "key": "filter"
        }, {
          default: () => [withDirectives(createVNode("div", {
            "class": "v-chip__filter"
          }, [!slots.filter ? createVNode(VIcon, {
            "key": "filter-icon",
            "icon": props.filterIcon
          }, null) : createVNode(VDefaultsProvider, {
            "key": "filter-defaults",
            "disabled": !props.filterIcon,
            "defaults": {
              VIcon: {
                icon: props.filterIcon
              }
            }
          }, slots.filter)]), [[vShow, group.isSelected.value]])]
        }), hasPrepend && createVNode("div", {
          "key": "prepend",
          "class": "v-chip__prepend"
        }, [!slots.prepend ? createVNode(Fragment, null, [props.prependIcon && createVNode(VIcon, {
          "key": "prepend-icon",
          "icon": props.prependIcon,
          "start": true
        }, null), props.prependAvatar && createVNode(VAvatar, {
          "key": "prepend-avatar",
          "image": props.prependAvatar,
          "start": true
        }, null)]) : createVNode(VDefaultsProvider, {
          "key": "prepend-defaults",
          "disabled": !hasPrependMedia,
          "defaults": {
            VAvatar: {
              image: props.prependAvatar,
              start: true
            },
            VIcon: {
              icon: props.prependIcon,
              start: true
            }
          }
        }, slots.prepend)]), createVNode("div", {
          "class": "v-chip__content",
          "data-no-activator": ""
        }, [slots.default?.({
          isSelected: group?.isSelected.value,
          selectedClass: group?.selectedClass.value,
          select: group?.select,
          toggle: group?.toggle,
          value: group?.value.value,
          disabled: props.disabled
        }) ?? props.text]), hasAppend && createVNode("div", {
          "key": "append",
          "class": "v-chip__append"
        }, [!slots.append ? createVNode(Fragment, null, [props.appendIcon && createVNode(VIcon, {
          "key": "append-icon",
          "end": true,
          "icon": props.appendIcon
        }, null), props.appendAvatar && createVNode(VAvatar, {
          "key": "append-avatar",
          "end": true,
          "image": props.appendAvatar
        }, null)]) : createVNode(VDefaultsProvider, {
          "key": "append-defaults",
          "disabled": !hasAppendMedia,
          "defaults": {
            VAvatar: {
              end: true,
              image: props.appendAvatar
            },
            VIcon: {
              end: true,
              icon: props.appendIcon
            }
          }
        }, slots.append)]), hasClose && createVNode("button", mergeProps({
          "key": "close",
          "class": "v-chip__close",
          "type": "button",
          "data-testid": "close-chip"
        }, closeProps.value), [!slots.close ? createVNode(VIcon, {
          "key": "close-icon",
          "icon": props.closeIcon,
          "size": "x-small"
        }, null) : createVNode(VDefaultsProvider, {
          "key": "close-defaults",
          "defaults": {
            VIcon: {
              icon: props.closeIcon,
              size: 'x-small'
            }
          }
        }, slots.close)])]
      }), [[resolveDirective("ripple"), isClickable.value && props.ripple, null]]);
    };
  }
});

// Utilities

// List
const ListKey = Symbol.for('vuetify:list');
function createList() {
  const parent = inject$2(ListKey, {
    hasPrepend: shallowRef(false),
    updateHasPrepend: () => null
  });
  const data = {
    hasPrepend: shallowRef(false),
    updateHasPrepend: value => {
      if (value) data.hasPrepend.value = value;
    }
  };
  provide(ListKey, data);
  return parent;
}
function useList() {
  return inject$2(ListKey, null);
}

/* eslint-disable sonarjs/no-identical-functions */
// Utilities
const independentActiveStrategy = mandatory => {
  const strategy = {
    activate: _ref => {
      let {
        id,
        value,
        activated
      } = _ref;
      id = toRaw(id);

      // When mandatory and we're trying to deselect when id
      // is the only currently selected item then do nothing
      if (mandatory && !value && activated.size === 1 && activated.has(id)) return activated;
      if (value) {
        activated.add(id);
      } else {
        activated.delete(id);
      }
      return activated;
    },
    in: (v, children, parents) => {
      let set = new Set();
      if (v != null) {
        for (const id of wrapInArray(v)) {
          set = strategy.activate({
            id,
            value: true,
            activated: new Set(set),
            children,
            parents
          });
        }
      }
      return set;
    },
    out: v => {
      return Array.from(v);
    }
  };
  return strategy;
};
const independentSingleActiveStrategy = mandatory => {
  const parentStrategy = independentActiveStrategy(mandatory);
  const strategy = {
    activate: _ref2 => {
      let {
        activated,
        id,
        ...rest
      } = _ref2;
      id = toRaw(id);
      const singleSelected = activated.has(id) ? new Set([id]) : new Set();
      return parentStrategy.activate({
        ...rest,
        id,
        activated: singleSelected
      });
    },
    in: (v, children, parents) => {
      let set = new Set();
      if (v != null) {
        const arr = wrapInArray(v);
        if (arr.length) {
          set = parentStrategy.in(arr.slice(0, 1), children, parents);
        }
      }
      return set;
    },
    out: (v, children, parents) => {
      return parentStrategy.out(v, children, parents);
    }
  };
  return strategy;
};
const leafActiveStrategy = mandatory => {
  const parentStrategy = independentActiveStrategy(mandatory);
  const strategy = {
    activate: _ref3 => {
      let {
        id,
        activated,
        children,
        ...rest
      } = _ref3;
      id = toRaw(id);
      if (children.has(id)) return activated;
      return parentStrategy.activate({
        id,
        activated,
        children,
        ...rest
      });
    },
    in: parentStrategy.in,
    out: parentStrategy.out
  };
  return strategy;
};
const leafSingleActiveStrategy = mandatory => {
  const parentStrategy = independentSingleActiveStrategy(mandatory);
  const strategy = {
    activate: _ref4 => {
      let {
        id,
        activated,
        children,
        ...rest
      } = _ref4;
      id = toRaw(id);
      if (children.has(id)) return activated;
      return parentStrategy.activate({
        id,
        activated,
        children,
        ...rest
      });
    },
    in: parentStrategy.in,
    out: parentStrategy.out
  };
  return strategy;
};

const singleOpenStrategy = {
  open: _ref => {
    let {
      id,
      value,
      opened,
      parents
    } = _ref;
    if (value) {
      const newOpened = new Set();
      newOpened.add(id);
      let parent = parents.get(id);
      while (parent != null) {
        newOpened.add(parent);
        parent = parents.get(parent);
      }
      return newOpened;
    } else {
      opened.delete(id);
      return opened;
    }
  },
  select: () => null
};
const multipleOpenStrategy = {
  open: _ref2 => {
    let {
      id,
      value,
      opened,
      parents
    } = _ref2;
    if (value) {
      let parent = parents.get(id);
      opened.add(id);
      while (parent != null && parent !== id) {
        opened.add(parent);
        parent = parents.get(parent);
      }
      return opened;
    } else {
      opened.delete(id);
    }
    return opened;
  },
  select: () => null
};
const listOpenStrategy = {
  open: multipleOpenStrategy.open,
  select: _ref3 => {
    let {
      id,
      value,
      opened,
      parents
    } = _ref3;
    if (!value) return opened;
    const path = [];
    let parent = parents.get(id);
    while (parent != null) {
      path.push(parent);
      parent = parents.get(parent);
    }
    return new Set(path);
  }
};

/* eslint-disable sonarjs/no-identical-functions */
// Utilities
const independentSelectStrategy = mandatory => {
  const strategy = {
    select: _ref => {
      let {
        id,
        value,
        selected
      } = _ref;
      id = toRaw(id);

      // When mandatory and we're trying to deselect when id
      // is the only currently selected item then do nothing
      if (mandatory && !value) {
        const on = Array.from(selected.entries()).reduce((arr, _ref2) => {
          let [key, value] = _ref2;
          if (value === 'on') arr.push(key);
          return arr;
        }, []);
        if (on.length === 1 && on[0] === id) return selected;
      }
      selected.set(id, value ? 'on' : 'off');
      return selected;
    },
    in: (v, children, parents) => {
      let map = new Map();
      for (const id of v || []) {
        map = strategy.select({
          id,
          value: true,
          selected: new Map(map),
          children,
          parents
        });
      }
      return map;
    },
    out: v => {
      const arr = [];
      for (const [key, value] of v.entries()) {
        if (value === 'on') arr.push(key);
      }
      return arr;
    }
  };
  return strategy;
};
const independentSingleSelectStrategy = mandatory => {
  const parentStrategy = independentSelectStrategy(mandatory);
  const strategy = {
    select: _ref3 => {
      let {
        selected,
        id,
        ...rest
      } = _ref3;
      id = toRaw(id);
      const singleSelected = selected.has(id) ? new Map([[id, selected.get(id)]]) : new Map();
      return parentStrategy.select({
        ...rest,
        id,
        selected: singleSelected
      });
    },
    in: (v, children, parents) => {
      let map = new Map();
      if (v?.length) {
        map = parentStrategy.in(v.slice(0, 1), children, parents);
      }
      return map;
    },
    out: (v, children, parents) => {
      return parentStrategy.out(v, children, parents);
    }
  };
  return strategy;
};
const leafSelectStrategy = mandatory => {
  const parentStrategy = independentSelectStrategy(mandatory);
  const strategy = {
    select: _ref4 => {
      let {
        id,
        selected,
        children,
        ...rest
      } = _ref4;
      id = toRaw(id);
      if (children.has(id)) return selected;
      return parentStrategy.select({
        id,
        selected,
        children,
        ...rest
      });
    },
    in: parentStrategy.in,
    out: parentStrategy.out
  };
  return strategy;
};
const leafSingleSelectStrategy = mandatory => {
  const parentStrategy = independentSingleSelectStrategy(mandatory);
  const strategy = {
    select: _ref5 => {
      let {
        id,
        selected,
        children,
        ...rest
      } = _ref5;
      id = toRaw(id);
      if (children.has(id)) return selected;
      return parentStrategy.select({
        id,
        selected,
        children,
        ...rest
      });
    },
    in: parentStrategy.in,
    out: parentStrategy.out
  };
  return strategy;
};
const classicSelectStrategy = mandatory => {
  const strategy = {
    select: _ref6 => {
      let {
        id,
        value,
        selected,
        children,
        parents
      } = _ref6;
      id = toRaw(id);
      const original = new Map(selected);
      const items = [id];
      while (items.length) {
        const item = items.shift();
        selected.set(toRaw(item), value ? 'on' : 'off');
        if (children.has(item)) {
          items.push(...children.get(item));
        }
      }
      let parent = toRaw(parents.get(id));
      while (parent) {
        const childrenIds = children.get(parent);
        const everySelected = childrenIds.every(cid => selected.get(toRaw(cid)) === 'on');
        const noneSelected = childrenIds.every(cid => !selected.has(toRaw(cid)) || selected.get(toRaw(cid)) === 'off');
        selected.set(parent, everySelected ? 'on' : noneSelected ? 'off' : 'indeterminate');
        parent = toRaw(parents.get(parent));
      }

      // If mandatory and planned deselect results in no selected
      // items then we can't do it, so return original state
      if (mandatory && !value) {
        const on = Array.from(selected.entries()).reduce((arr, _ref7) => {
          let [key, value] = _ref7;
          if (value === 'on') arr.push(key);
          return arr;
        }, []);
        if (on.length === 0) return original;
      }
      return selected;
    },
    in: (v, children, parents) => {
      let map = new Map();
      for (const id of v || []) {
        map = strategy.select({
          id,
          value: true,
          selected: new Map(map),
          children,
          parents
        });
      }
      return map;
    },
    out: (v, children) => {
      const arr = [];
      for (const [key, value] of v.entries()) {
        if (value === 'on' && !children.has(key)) arr.push(key);
      }
      return arr;
    }
  };
  return strategy;
};

// Composables
const VNestedSymbol = Symbol.for('vuetify:nested');
const emptyNested = {
  id: shallowRef(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: ref(new Map()),
    children: ref(new Map()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: ref(false),
    selectable: ref(false),
    opened: ref(new Set()),
    activated: ref(new Set()),
    selected: ref(new Map()),
    selectedValues: ref([]),
    getPath: () => []
  }
};
const makeNestedProps = propsFactory({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean
}, 'nested');
const useNested = props => {
  let isUnmounted = false;
  const children = ref(new Map());
  const parents = ref(new Map());
  const opened = useProxiedModel(props, 'opened', props.opened, v => new Set(v), v => [...v.values()]);
  const activeStrategy = computed(() => {
    if (typeof props.activeStrategy === 'object') return props.activeStrategy;
    if (typeof props.activeStrategy === 'function') return props.activeStrategy(props.mandatory);
    switch (props.activeStrategy) {
      case 'leaf':
        return leafActiveStrategy(props.mandatory);
      case 'single-leaf':
        return leafSingleActiveStrategy(props.mandatory);
      case 'independent':
        return independentActiveStrategy(props.mandatory);
      case 'single-independent':
      default:
        return independentSingleActiveStrategy(props.mandatory);
    }
  });
  const selectStrategy = computed(() => {
    if (typeof props.selectStrategy === 'object') return props.selectStrategy;
    if (typeof props.selectStrategy === 'function') return props.selectStrategy(props.mandatory);
    switch (props.selectStrategy) {
      case 'single-leaf':
        return leafSingleSelectStrategy(props.mandatory);
      case 'leaf':
        return leafSelectStrategy(props.mandatory);
      case 'independent':
        return independentSelectStrategy(props.mandatory);
      case 'single-independent':
        return independentSingleSelectStrategy(props.mandatory);
      case 'classic':
      default:
        return classicSelectStrategy(props.mandatory);
    }
  });
  const openStrategy = computed(() => {
    if (typeof props.openStrategy === 'object') return props.openStrategy;
    switch (props.openStrategy) {
      case 'list':
        return listOpenStrategy;
      case 'single':
        return singleOpenStrategy;
      case 'multiple':
      default:
        return multipleOpenStrategy;
    }
  });
  const activated = useProxiedModel(props, 'activated', props.activated, v => activeStrategy.value.in(v, children.value, parents.value), v => activeStrategy.value.out(v, children.value, parents.value));
  const selected = useProxiedModel(props, 'selected', props.selected, v => selectStrategy.value.in(v, children.value, parents.value), v => selectStrategy.value.out(v, children.value, parents.value));
  onBeforeUnmount(() => {
    isUnmounted = true;
  });
  function getPath(id) {
    const path = [];
    let parent = id;
    while (parent != null) {
      path.unshift(parent);
      parent = parents.value.get(parent);
    }
    return path;
  }
  const vm = getCurrentInstance('nested');
  const nodeIds = new Set();
  const nested = {
    id: shallowRef(),
    root: {
      opened,
      activatable: toRef(props, 'activatable'),
      selectable: toRef(props, 'selectable'),
      activated,
      selected,
      selectedValues: computed(() => {
        const arr = [];
        for (const [key, value] of selected.value.entries()) {
          if (value === 'on') arr.push(key);
        }
        return arr;
      }),
      register: (id, parentId, isGroup) => {
        if (nodeIds.has(id)) {
          const path = getPath(id).map(String).join(' -> ');
          const newPath = getPath(parentId).concat(id).map(String).join(' -> ');
          consoleError(`Multiple nodes with the same ID\n\t${path}\n\t${newPath}`);
          return;
        } else {
          nodeIds.add(id);
        }
        parentId && id !== parentId && parents.value.set(id, parentId);
        isGroup && children.value.set(id, []);
        if (parentId != null) {
          children.value.set(parentId, [...(children.value.get(parentId) || []), id]);
        }
      },
      unregister: id => {
        if (isUnmounted) return;
        nodeIds.delete(id);
        children.value.delete(id);
        const parent = parents.value.get(id);
        if (parent) {
          const list = children.value.get(parent) ?? [];
          children.value.set(parent, list.filter(child => child !== id));
        }
        parents.value.delete(id);
      },
      open: (id, value, event) => {
        vm.emit('click:open', {
          id,
          value,
          path: getPath(id),
          event
        });
        const newOpened = openStrategy.value.open({
          id,
          value,
          opened: new Set(opened.value),
          children: children.value,
          parents: parents.value,
          event
        });
        newOpened && (opened.value = newOpened);
      },
      openOnSelect: (id, value, event) => {
        const newOpened = openStrategy.value.select({
          id,
          value,
          selected: new Map(selected.value),
          opened: new Set(opened.value),
          children: children.value,
          parents: parents.value,
          event
        });
        newOpened && (opened.value = newOpened);
      },
      select: (id, value, event) => {
        vm.emit('click:select', {
          id,
          value,
          path: getPath(id),
          event
        });
        const newSelected = selectStrategy.value.select({
          id,
          value,
          selected: new Map(selected.value),
          children: children.value,
          parents: parents.value,
          event
        });
        newSelected && (selected.value = newSelected);
        nested.root.openOnSelect(id, value, event);
      },
      activate: (id, value, event) => {
        if (!props.activatable) {
          return nested.root.select(id, true, event);
        }
        vm.emit('click:activate', {
          id,
          value,
          path: getPath(id),
          event
        });
        const newActivated = activeStrategy.value.activate({
          id,
          value,
          activated: new Set(activated.value),
          children: children.value,
          parents: parents.value,
          event
        });
        newActivated && (activated.value = newActivated);
      },
      children,
      parents,
      getPath
    }
  };
  provide(VNestedSymbol, nested);
  return nested.root;
};
const useNestedItem = (id, isGroup) => {
  const parent = inject$2(VNestedSymbol, emptyNested);
  const uidSymbol = Symbol(getUid());
  const computedId = computed(() => id.value !== undefined ? id.value : uidSymbol);
  const item = {
    ...parent,
    id: computedId,
    open: (open, e) => parent.root.open(computedId.value, open, e),
    openOnSelect: (open, e) => parent.root.openOnSelect(computedId.value, open, e),
    isOpen: computed(() => parent.root.opened.value.has(computedId.value)),
    parent: computed(() => parent.root.parents.value.get(computedId.value)),
    activate: (activated, e) => parent.root.activate(computedId.value, activated, e),
    isActivated: computed(() => parent.root.activated.value.has(toRaw(computedId.value))),
    select: (selected, e) => parent.root.select(computedId.value, selected, e),
    isSelected: computed(() => parent.root.selected.value.get(toRaw(computedId.value)) === 'on'),
    isIndeterminate: computed(() => parent.root.selected.value.get(computedId.value) === 'indeterminate'),
    isLeaf: computed(() => !parent.root.children.value.get(computedId.value)),
    isGroupActivator: parent.isGroupActivator
  };
  onBeforeMount(() => {
    !parent.isGroupActivator && parent.root.register(computedId.value, parent.id.value, isGroup);
  });
  onBeforeUnmount(() => {
    !parent.isGroupActivator && parent.root.unregister(computedId.value);
  });
  isGroup && provide(VNestedSymbol, item);
  return item;
};
const useNestedGroupActivator = () => {
  const parent = inject$2(VNestedSymbol, emptyNested);
  provide(VNestedSymbol, {
    ...parent,
    isGroupActivator: true
  });
};

const VListGroupActivator = defineComponent({
  name: 'VListGroupActivator',
  setup(_, _ref) {
    let {
      slots
    } = _ref;
    useNestedGroupActivator();
    return () => slots.default?.();
  }
});
const makeVListGroupProps = propsFactory({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: IconValue,
    default: '$collapse'
  },
  expandIcon: {
    type: IconValue,
    default: '$expand'
  },
  prependIcon: IconValue,
  appendIcon: IconValue,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VListGroup');
const VListGroup = genericComponent()({
  name: 'VListGroup',
  props: makeVListGroupProps(),
  setup(props, _ref2) {
    let {
      slots
    } = _ref2;
    const {
      isOpen,
      open,
      id: _id
    } = useNestedItem(toRef(props, 'value'), true);
    const id = computed(() => `v-list-group--id-${String(_id.value)}`);
    const list = useList();
    const {
      isBooted
    } = useSsrBoot();
    function onClick(e) {
      e.stopPropagation();
      open(!isOpen.value, e);
    }
    const activatorProps = computed(() => ({
      onClick,
      class: 'v-list-group__header',
      id: id.value
    }));
    const toggleIcon = computed(() => isOpen.value ? props.collapseIcon : props.expandIcon);
    const activatorDefaults = computed(() => ({
      VListItem: {
        active: isOpen.value,
        activeColor: props.activeColor,
        baseColor: props.baseColor,
        color: props.color,
        prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
        appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
        title: props.title,
        value: props.value
      }
    }));
    useRender(() => createVNode(props.tag, {
      "class": ['v-list-group', {
        'v-list-group--prepend': list?.hasPrepend.value,
        'v-list-group--fluid': props.fluid,
        'v-list-group--subgroup': props.subgroup,
        'v-list-group--open': isOpen.value
      }, props.class],
      "style": props.style
    }, {
      default: () => [slots.activator && createVNode(VDefaultsProvider, {
        "defaults": activatorDefaults.value
      }, {
        default: () => [createVNode(VListGroupActivator, null, {
          default: () => [slots.activator({
            props: activatorProps.value,
            isOpen: isOpen.value
          })]
        })]
      }), createVNode(MaybeTransition, {
        "transition": {
          component: VExpandTransition
        },
        "disabled": !isBooted.value
      }, {
        default: () => [withDirectives(createVNode("div", {
          "class": "v-list-group__items",
          "role": "group",
          "aria-labelledby": id.value
        }, [slots.default?.()]), [[vShow, isOpen.value]])]
      })]
    }));
    return {
      isOpen
    };
  }
});

const makeVListItemSubtitleProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VListItemSubtitle');
const VListItemSubtitle = genericComponent()({
  name: 'VListItemSubtitle',
  props: makeVListItemSubtitleProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(props.tag, {
      "class": ['v-list-item-subtitle', props.class],
      "style": [{
        '--v-list-item-subtitle-opacity': props.opacity
      }, props.style]
    }, slots));
    return {};
  }
});

// Utilities
const VListItemTitle = createSimpleFunctional('v-list-item-title');

const makeVListItemProps = propsFactory({
  active: {
    type: Boolean,
    default: undefined
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: IconValue,
  baseColor: String,
  disabled: Boolean,
  disableKeyboardSelection: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: undefined
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  slim: Boolean,
  subtitle: [String, Number],
  title: [String, Number],
  value: null,
  onClick: EventProp(),
  onClickOnce: EventProp(),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'text'
  })
}, 'VListItem');
const VListItem = genericComponent()({
  name: 'VListItem',
  directives: {
    Ripple
  },
  props: makeVListItemProps(),
  emits: {
    click: e => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots,
      emit
    } = _ref;
    const link = useLink(props, attrs);
    const id = computed(() => props.value === undefined ? link.href.value : props.value);
    const {
      activate,
      isActivated,
      select,
      isOpen,
      isSelected,
      isIndeterminate,
      isGroupActivator,
      root,
      parent,
      openOnSelect,
      id: uid
    } = useNestedItem(id, false);
    const list = useList();
    const isActive = computed(() => props.active !== false && (props.active || link.isActive?.value || (root.activatable.value ? isActivated.value : isSelected.value)));
    const isLink = computed(() => props.link !== false && link.isLink.value);
    const isSelectable = computed(() => !!list && (root.selectable.value || root.activatable.value || props.value != null));
    const isClickable = computed(() => !props.disabled && props.link !== false && (props.link || link.isClickable.value || isSelectable.value));
    const roundedProps = computed(() => props.rounded || props.nav);
    const color = computed(() => props.color ?? props.activeColor);
    const variantProps = computed(() => ({
      color: isActive.value ? color.value ?? props.baseColor : props.baseColor,
      variant: props.variant
    }));

    // useNestedItem doesn't call register until beforeMount,
    // so this can't be an immediate watcher as we don't know parent yet
    watch(() => link.isActive?.value, val => {
      if (!val) return;
      handleActiveLink();
    });
    onBeforeMount(() => {
      if (link.isActive?.value) handleActiveLink();
    });
    function handleActiveLink() {
      if (parent.value != null) {
        root.open(parent.value, true);
      }
      openOnSelect(true);
    }
    const {
      themeClasses
    } = provideTheme(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(variantProps);
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(roundedProps);
    const lineClasses = computed(() => props.lines ? `v-list-item--${props.lines}-line` : undefined);
    const slotProps = computed(() => ({
      isActive: isActive.value,
      select,
      isOpen: isOpen.value,
      isSelected: isSelected.value,
      isIndeterminate: isIndeterminate.value
    }));
    function onClick(e) {
      emit('click', e);
      if (!isClickable.value) return;
      link.navigate?.(e);
      if (isGroupActivator) return;
      if (root.activatable.value) {
        activate(!isActivated.value, e);
      } else if (root.selectable.value) {
        select(!isSelected.value, e);
      } else if (props.value != null) {
        select(!isSelected.value, e);
      }
    }
    function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.target.dispatchEvent(new MouseEvent('click', e));
      }
    }
    useRender(() => {
      const Tag = isLink.value ? 'a' : props.tag;
      const hasTitle = slots.title || props.title != null;
      const hasSubtitle = slots.subtitle || props.subtitle != null;
      const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
      const hasAppend = !!(hasAppendMedia || slots.append);
      const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
      const hasPrepend = !!(hasPrependMedia || slots.prepend);
      list?.updateHasPrepend(hasPrepend);
      if (props.activeColor) {
        deprecate('active-color', ['color', 'base-color']);
      }
      return withDirectives(createVNode(Tag, mergeProps({
        "class": ['v-list-item', {
          'v-list-item--active': isActive.value,
          'v-list-item--disabled': props.disabled,
          'v-list-item--link': isClickable.value,
          'v-list-item--nav': props.nav,
          'v-list-item--prepend': !hasPrepend && list?.hasPrepend.value,
          'v-list-item--slim': props.slim,
          [`${props.activeClass}`]: props.activeClass && isActive.value
        }, themeClasses.value, borderClasses.value, colorClasses.value, densityClasses.value, elevationClasses.value, lineClasses.value, roundedClasses.value, variantClasses.value, props.class],
        "style": [colorStyles.value, dimensionStyles.value, props.style],
        "tabindex": isClickable.value ? list ? -2 : 0 : undefined,
        "aria-selected": isSelectable.value ? root.activatable.value ? isActivated.value : root.selectable.value ? isSelected.value : isActive.value : undefined,
        "onClick": onClick,
        "onKeydown": isClickable.value && !isLink.value && !props.disableKeyboardSelection && onKeyDown
      }, link.linkProps), {
        default: () => [genOverlays(isClickable.value || isActive.value, 'v-list-item'), hasPrepend && createVNode("div", {
          "key": "prepend",
          "class": "v-list-item__prepend"
        }, [!slots.prepend ? createVNode(Fragment, null, [props.prependAvatar && createVNode(VAvatar, {
          "key": "prepend-avatar",
          "density": props.density,
          "image": props.prependAvatar
        }, null), props.prependIcon && createVNode(VIcon, {
          "key": "prepend-icon",
          "density": props.density,
          "icon": props.prependIcon
        }, null)]) : createVNode(VDefaultsProvider, {
          "key": "prepend-defaults",
          "disabled": !hasPrependMedia,
          "defaults": {
            VAvatar: {
              density: props.density,
              image: props.prependAvatar
            },
            VIcon: {
              density: props.density,
              icon: props.prependIcon
            },
            VListItemAction: {
              start: true
            }
          }
        }, {
          default: () => [slots.prepend?.(slotProps.value)]
        }), createVNode("div", {
          "class": "v-list-item__spacer"
        }, null)]), createVNode("div", {
          "class": "v-list-item__content",
          "data-no-activator": ""
        }, [hasTitle && createVNode(VListItemTitle, {
          "key": "title"
        }, {
          default: () => [slots.title?.({
            title: props.title
          }) ?? props.title]
        }), hasSubtitle && createVNode(VListItemSubtitle, {
          "key": "subtitle"
        }, {
          default: () => [slots.subtitle?.({
            subtitle: props.subtitle
          }) ?? props.subtitle]
        }), slots.default?.(slotProps.value)]), hasAppend && createVNode("div", {
          "key": "append",
          "class": "v-list-item__append"
        }, [!slots.append ? createVNode(Fragment, null, [props.appendIcon && createVNode(VIcon, {
          "key": "append-icon",
          "density": props.density,
          "icon": props.appendIcon
        }, null), props.appendAvatar && createVNode(VAvatar, {
          "key": "append-avatar",
          "density": props.density,
          "image": props.appendAvatar
        }, null)]) : createVNode(VDefaultsProvider, {
          "key": "append-defaults",
          "disabled": !hasAppendMedia,
          "defaults": {
            VAvatar: {
              density: props.density,
              image: props.appendAvatar
            },
            VIcon: {
              density: props.density,
              icon: props.appendIcon
            },
            VListItemAction: {
              end: true
            }
          }
        }, {
          default: () => [slots.append?.(slotProps.value)]
        }), createVNode("div", {
          "class": "v-list-item__spacer"
        }, null)])]
      }), [[resolveDirective("ripple"), isClickable.value && props.ripple]]);
    });
    return {
      activate,
      isActivated,
      isGroupActivator,
      isSelected,
      list,
      select,
      root,
      id: uid
    };
  }
});

const makeVListSubheaderProps = propsFactory({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VListSubheader');
const VListSubheader = genericComponent()({
  name: 'VListSubheader',
  props: makeVListSubheaderProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'color'));
    useRender(() => {
      const hasText = !!(slots.default || props.title);
      return createVNode(props.tag, {
        "class": ['v-list-subheader', {
          'v-list-subheader--inset': props.inset,
          'v-list-subheader--sticky': props.sticky
        }, textColorClasses.value, props.class],
        "style": [{
          textColorStyles
        }, props.style]
      }, {
        default: () => [hasText && createVNode("div", {
          "class": "v-list-subheader__text"
        }, [slots.default?.() ?? props.title])]
      });
    });
    return {};
  }
});

const makeVDividerProps = propsFactory({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...makeComponentProps(),
  ...makeThemeProps()
}, 'VDivider');
const VDivider = genericComponent()({
  name: 'VDivider',
  props: makeVDividerProps(),
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'color'));
    const dividerStyles = computed(() => {
      const styles = {};
      if (props.length) {
        styles[props.vertical ? 'height' : 'width'] = convertToUnit(props.length);
      }
      if (props.thickness) {
        styles[props.vertical ? 'borderRightWidth' : 'borderTopWidth'] = convertToUnit(props.thickness);
      }
      return styles;
    });
    useRender(() => {
      const divider = createVNode("hr", {
        "class": [{
          'v-divider': true,
          'v-divider--inset': props.inset,
          'v-divider--vertical': props.vertical
        }, themeClasses.value, textColorClasses.value, props.class],
        "style": [dividerStyles.value, textColorStyles.value, {
          '--v-border-opacity': props.opacity
        }, props.style],
        "aria-orientation": !attrs.role || attrs.role === 'separator' ? props.vertical ? 'vertical' : 'horizontal' : undefined,
        "role": `${attrs.role || 'separator'}`
      }, null);
      if (!slots.default) return divider;
      return createVNode("div", {
        "class": ['v-divider__wrapper', {
          'v-divider__wrapper--vertical': props.vertical,
          'v-divider__wrapper--inset': props.inset
        }]
      }, [divider, createVNode("div", {
        "class": "v-divider__content"
      }, [slots.default()]), divider]);
    });
    return {};
  }
});

const makeVListChildrenProps = propsFactory({
  items: Array,
  returnObject: Boolean
}, 'VListChildren');
const VListChildren = genericComponent()({
  name: 'VListChildren',
  props: makeVListChildrenProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    createList();
    return () => slots.default?.() ?? props.items?.map(_ref2 => {
      let {
        children,
        props: itemProps,
        type,
        raw: item
      } = _ref2;
      if (type === 'divider') {
        return slots.divider?.({
          props: itemProps
        }) ?? createVNode(VDivider, itemProps, null);
      }
      if (type === 'subheader') {
        return slots.subheader?.({
          props: itemProps
        }) ?? createVNode(VListSubheader, itemProps, null);
      }
      const slotsWithItem = {
        subtitle: slots.subtitle ? slotProps => slots.subtitle?.({
          ...slotProps,
          item
        }) : undefined,
        prepend: slots.prepend ? slotProps => slots.prepend?.({
          ...slotProps,
          item
        }) : undefined,
        append: slots.append ? slotProps => slots.append?.({
          ...slotProps,
          item
        }) : undefined,
        title: slots.title ? slotProps => slots.title?.({
          ...slotProps,
          item
        }) : undefined
      };
      const listGroupProps = VListGroup.filterProps(itemProps);
      return children ? createVNode(VListGroup, mergeProps({
        "value": itemProps?.value
      }, listGroupProps), {
        activator: _ref3 => {
          let {
            props: activatorProps
          } = _ref3;
          const listItemProps = {
            ...itemProps,
            ...activatorProps,
            value: props.returnObject ? item : itemProps.value
          };
          return slots.header ? slots.header({
            props: listItemProps
          }) : createVNode(VListItem, listItemProps, slotsWithItem);
        },
        default: () => createVNode(VListChildren, {
          "items": children,
          "returnObject": props.returnObject
        }, slots)
      }) : slots.item ? slots.item({
        props: itemProps
      }) : createVNode(VListItem, mergeProps(itemProps, {
        "value": props.returnObject ? item : itemProps.value
      }), slotsWithItem);
    });
  }
});

// Utilities
// Composables
const makeItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: 'title'
  },
  itemValue: {
    type: [String, Array, Function],
    default: 'value'
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: 'children'
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: 'props'
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: deepEqual
  }
}, 'list-items');
function transformItem$2(props, item) {
  const title = getPropertyFromItem(item, props.itemTitle, item);
  const value = getPropertyFromItem(item, props.itemValue, title);
  const children = getPropertyFromItem(item, props.itemChildren);
  const itemProps = props.itemProps === true ? typeof item === 'object' && item != null && !Array.isArray(item) ? 'children' in item ? omit(item, ['children']) : item : undefined : getPropertyFromItem(item, props.itemProps);
  const _props = {
    title,
    value,
    ...itemProps
  };
  return {
    title: String(_props.title ?? ''),
    value: _props.value,
    props: _props,
    children: Array.isArray(children) ? transformItems$2(props, children) : undefined,
    raw: item
  };
}
function transformItems$2(props, items) {
  const array = [];
  for (const item of items) {
    array.push(transformItem$2(props, item));
  }
  return array;
}
function useItems(props) {
  const items = computed(() => transformItems$2(props, props.items));
  const hasNullItem = computed(() => items.value.some(item => item.value === null));
  function transformIn(value) {
    if (!hasNullItem.value) {
      // When the model value is null, return an InternalItem
      // based on null only if null is one of the items
      value = value.filter(v => v !== null);
    }
    return value.map(v => {
      if (props.returnObject && typeof v === 'string') {
        // String model value means value is a custom input value from combobox
        // Don't look up existing items if the model value is a string
        return transformItem$2(props, v);
      }
      return items.value.find(item => props.valueComparator(v, item.value)) || transformItem$2(props, v);
    });
  }
  function transformOut(value) {
    return props.returnObject ? value.map(_ref => {
      let {
        raw
      } = _ref;
      return raw;
    }) : value.map(_ref2 => {
      let {
        value
      } = _ref2;
      return value;
    });
  }
  return {
    items,
    transformIn,
    transformOut
  };
}

function isPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}
function transformItem$1(props, item) {
  const type = getPropertyFromItem(item, props.itemType, 'item');
  const title = isPrimitive(item) ? item : getPropertyFromItem(item, props.itemTitle);
  const value = getPropertyFromItem(item, props.itemValue, undefined);
  const children = getPropertyFromItem(item, props.itemChildren);
  const itemProps = props.itemProps === true ? omit(item, ['children']) : getPropertyFromItem(item, props.itemProps);
  const _props = {
    title,
    value,
    ...itemProps
  };
  return {
    type,
    title: _props.title,
    value: _props.value,
    props: _props,
    children: type === 'item' && children ? transformItems$1(props, children) : undefined,
    raw: item
  };
}
function transformItems$1(props, items) {
  const array = [];
  for (const item of items) {
    array.push(transformItem$1(props, item));
  }
  return array;
}
function useListItems(props) {
  const items = computed(() => transformItems$1(props, props.items));
  return {
    items
  };
}
const makeVListProps = propsFactory({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: IconValue,
  collapseIcon: IconValue,
  lines: {
    type: [Boolean, String],
    default: 'one'
  },
  slim: Boolean,
  nav: Boolean,
  'onClick:open': EventProp(),
  'onClick:select': EventProp(),
  'onUpdate:opened': EventProp(),
  ...makeNestedProps({
    selectStrategy: 'single-leaf',
    openStrategy: 'list'
  }),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  itemType: {
    type: String,
    default: 'type'
  },
  ...makeItemsProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'text'
  })
}, 'VList');
const VList = genericComponent()({
  name: 'VList',
  props: makeVListProps(),
  emits: {
    'update:selected': value => true,
    'update:activated': value => true,
    'update:opened': value => true,
    'click:open': value => true,
    'click:activate': value => true,
    'click:select': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      items
    } = useListItems(props);
    const {
      themeClasses
    } = provideTheme(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'bgColor'));
    const {
      borderClasses
    } = useBorder(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      children,
      open,
      parents,
      select,
      getPath
    } = useNested(props);
    const lineClasses = computed(() => props.lines ? `v-list--${props.lines}-line` : undefined);
    const activeColor = toRef(props, 'activeColor');
    const baseColor = toRef(props, 'baseColor');
    const color = toRef(props, 'color');
    createList();
    provideDefaults({
      VListGroup: {
        activeColor,
        baseColor,
        color,
        expandIcon: toRef(props, 'expandIcon'),
        collapseIcon: toRef(props, 'collapseIcon')
      },
      VListItem: {
        activeClass: toRef(props, 'activeClass'),
        activeColor,
        baseColor,
        color,
        density: toRef(props, 'density'),
        disabled: toRef(props, 'disabled'),
        lines: toRef(props, 'lines'),
        nav: toRef(props, 'nav'),
        slim: toRef(props, 'slim'),
        variant: toRef(props, 'variant')
      }
    });
    const isFocused = shallowRef(false);
    const contentRef = ref();
    function onFocusin(e) {
      isFocused.value = true;
    }
    function onFocusout(e) {
      isFocused.value = false;
    }
    function onFocus(e) {
      if (!isFocused.value && !(e.relatedTarget && contentRef.value?.contains(e.relatedTarget))) focus();
    }
    function onKeydown(e) {
      const target = e.target;
      if (!contentRef.value || ['INPUT', 'TEXTAREA'].includes(target.tagName)) return;
      if (e.key === 'ArrowDown') {
        focus('next');
      } else if (e.key === 'ArrowUp') {
        focus('prev');
      } else if (e.key === 'Home') {
        focus('first');
      } else if (e.key === 'End') {
        focus('last');
      } else {
        return;
      }
      e.preventDefault();
    }
    function onMousedown(e) {
      isFocused.value = true;
    }
    function focus(location) {
      if (contentRef.value) {
        return focusChild(contentRef.value, location);
      }
    }
    useRender(() => {
      return createVNode(props.tag, {
        "ref": contentRef,
        "class": ['v-list', {
          'v-list--disabled': props.disabled,
          'v-list--nav': props.nav,
          'v-list--slim': props.slim
        }, themeClasses.value, backgroundColorClasses.value, borderClasses.value, densityClasses.value, elevationClasses.value, lineClasses.value, roundedClasses.value, props.class],
        "style": [backgroundColorStyles.value, dimensionStyles.value, props.style],
        "tabindex": props.disabled || isFocused.value ? -1 : 0,
        "role": "listbox",
        "aria-activedescendant": undefined,
        "onFocusin": onFocusin,
        "onFocusout": onFocusout,
        "onFocus": onFocus,
        "onKeydown": onKeydown,
        "onMousedown": onMousedown
      }, {
        default: () => [createVNode(VListChildren, {
          "items": items.value,
          "returnObject": props.returnObject
        }, slots)]
      });
    });
    return {
      open,
      select,
      focus,
      children,
      parents,
      getPath
    };
  }
});

const makeVListItemActionProps = propsFactory({
  start: Boolean,
  end: Boolean,
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VListItemAction');
const VListItemAction = genericComponent()({
  name: 'VListItemAction',
  props: makeVListItemActionProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(props.tag, {
      "class": ['v-list-item-action', {
        'v-list-item-action--start': props.start,
        'v-list-item-action--end': props.end
      }, props.class],
      "style": props.style
    }, slots));
    return {};
  }
});

// Types

/** Convert a point in local space to viewport space */
function elementToViewport(point, offset) {
  return {
    x: point.x + offset.x,
    y: point.y + offset.y
  };
}

/** Get the difference between two points */
function getOffset(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}

/** Convert an anchor object to a point in local space */
function anchorToPoint(anchor, box) {
  if (anchor.side === 'top' || anchor.side === 'bottom') {
    const {
      side,
      align
    } = anchor;
    const x = align === 'left' ? 0 : align === 'center' ? box.width / 2 : align === 'right' ? box.width : align;
    const y = side === 'top' ? 0 : side === 'bottom' ? box.height : side;
    return elementToViewport({
      x,
      y
    }, box);
  } else if (anchor.side === 'left' || anchor.side === 'right') {
    const {
      side,
      align
    } = anchor;
    const x = side === 'left' ? 0 : side === 'right' ? box.width : side;
    const y = align === 'top' ? 0 : align === 'center' ? box.height / 2 : align === 'bottom' ? box.height : align;
    return elementToViewport({
      x,
      y
    }, box);
  }
  return elementToViewport({
    x: box.width / 2,
    y: box.height / 2
  }, box);
}

// Composables
const locationStrategies = {
  static: staticLocationStrategy,
  // specific viewport position, usually centered
  connected: connectedLocationStrategy // connected to a certain element
};
const makeLocationStrategyProps = propsFactory({
  locationStrategy: {
    type: [String, Function],
    default: 'static',
    validator: val => typeof val === 'function' || val in locationStrategies
  },
  location: {
    type: String,
    default: 'bottom'
  },
  origin: {
    type: String,
    default: 'auto'
  },
  offset: [Number, String, Array]
}, 'VOverlay-location-strategies');
function useLocationStrategies(props, data) {
  const contentStyles = ref({});
  const updateLocation = ref();
  if (IN_BROWSER) {
    useToggleScope(() => !!(data.isActive.value && props.locationStrategy), reset => {
      watch(() => props.locationStrategy, reset);
      onScopeDispose(() => {
        window.removeEventListener('resize', onResize);
        updateLocation.value = undefined;
      });
      window.addEventListener('resize', onResize, {
        passive: true
      });
      if (typeof props.locationStrategy === 'function') {
        updateLocation.value = props.locationStrategy(data, props, contentStyles)?.updateLocation;
      } else {
        updateLocation.value = locationStrategies[props.locationStrategy](data, props, contentStyles)?.updateLocation;
      }
    });
  }
  function onResize(e) {
    updateLocation.value?.(e);
  }
  return {
    contentStyles,
    updateLocation
  };
}
function staticLocationStrategy() {
  // TODO
}

/** Get size of element ignoring max-width/max-height */
function getIntrinsicSize(el, isRtl) {
  // const scrollables = new Map<Element, [number, number]>()
  // el.querySelectorAll('*').forEach(el => {
  //   const x = el.scrollLeft
  //   const y = el.scrollTop
  //   if (x || y) {
  //     scrollables.set(el, [x, y])
  //   }
  // })

  // const initialMaxWidth = el.style.maxWidth
  // const initialMaxHeight = el.style.maxHeight
  // el.style.removeProperty('max-width')
  // el.style.removeProperty('max-height')

  /* eslint-disable-next-line sonarjs/prefer-immediate-return */
  const contentBox = nullifyTransforms(el);
  if (isRtl) {
    contentBox.x += parseFloat(el.style.right || 0);
  } else {
    contentBox.x -= parseFloat(el.style.left || 0);
  }
  contentBox.y -= parseFloat(el.style.top || 0);

  // el.style.maxWidth = initialMaxWidth
  // el.style.maxHeight = initialMaxHeight
  // scrollables.forEach((position, el) => {
  //   el.scrollTo(...position)
  // })

  return contentBox;
}
function connectedLocationStrategy(data, props, contentStyles) {
  const activatorFixed = Array.isArray(data.target.value) || isFixedPosition(data.target.value);
  if (activatorFixed) {
    Object.assign(contentStyles.value, {
      position: 'fixed',
      top: 0,
      [data.isRtl.value ? 'right' : 'left']: 0
    });
  }
  const {
    preferredAnchor,
    preferredOrigin
  } = destructComputed(() => {
    const parsedAnchor = parseAnchor(props.location, data.isRtl.value);
    const parsedOrigin = props.origin === 'overlap' ? parsedAnchor : props.origin === 'auto' ? flipSide(parsedAnchor) : parseAnchor(props.origin, data.isRtl.value);

    // Some combinations of props may produce an invalid origin
    if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === flipAlign(parsedOrigin).align) {
      return {
        preferredAnchor: flipCorner(parsedAnchor),
        preferredOrigin: flipCorner(parsedOrigin)
      };
    } else {
      return {
        preferredAnchor: parsedAnchor,
        preferredOrigin: parsedOrigin
      };
    }
  });
  const [minWidth, minHeight, maxWidth, maxHeight] = ['minWidth', 'minHeight', 'maxWidth', 'maxHeight'].map(key => {
    return computed(() => {
      const val = parseFloat(props[key]);
      return isNaN(val) ? Infinity : val;
    });
  });
  const offset = computed(() => {
    if (Array.isArray(props.offset)) {
      return props.offset;
    }
    if (typeof props.offset === 'string') {
      const offset = props.offset.split(' ').map(parseFloat);
      if (offset.length < 2) offset.push(0);
      return offset;
    }
    return typeof props.offset === 'number' ? [props.offset, 0] : [0, 0];
  });
  let observe = false;
  const observer = new ResizeObserver(() => {
    if (observe) updateLocation();
  });
  watch([data.target, data.contentEl], (_ref, _ref2) => {
    let [newTarget, newContentEl] = _ref;
    let [oldTarget, oldContentEl] = _ref2;
    if (oldTarget && !Array.isArray(oldTarget)) observer.unobserve(oldTarget);
    if (newTarget && !Array.isArray(newTarget)) observer.observe(newTarget);
    if (oldContentEl) observer.unobserve(oldContentEl);
    if (newContentEl) observer.observe(newContentEl);
  }, {
    immediate: true
  });
  onScopeDispose(() => {
    observer.disconnect();
  });

  // eslint-disable-next-line max-statements
  function updateLocation() {
    observe = false;
    requestAnimationFrame(() => observe = true);
    if (!data.target.value || !data.contentEl.value) return;
    const targetBox = getTargetBox(data.target.value);
    const contentBox = getIntrinsicSize(data.contentEl.value, data.isRtl.value);
    const scrollParents = getScrollParents(data.contentEl.value);
    const viewportMargin = 12;
    if (!scrollParents.length) {
      scrollParents.push(document.documentElement);
      if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
        contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-x') || 0);
        contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-y') || 0);
      }
    }
    const viewport = scrollParents.reduce((box, el) => {
      const rect = el.getBoundingClientRect();
      const scrollBox = new Box({
        x: el === document.documentElement ? 0 : rect.x,
        y: el === document.documentElement ? 0 : rect.y,
        width: el.clientWidth,
        height: el.clientHeight
      });
      if (box) {
        return new Box({
          x: Math.max(box.left, scrollBox.left),
          y: Math.max(box.top, scrollBox.top),
          width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
          height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
        });
      }
      return scrollBox;
    }, undefined);
    viewport.x += viewportMargin;
    viewport.y += viewportMargin;
    viewport.width -= viewportMargin * 2;
    viewport.height -= viewportMargin * 2;
    let placement = {
      anchor: preferredAnchor.value,
      origin: preferredOrigin.value
    };
    function checkOverflow(_placement) {
      const box = new Box(contentBox);
      const targetPoint = anchorToPoint(_placement.anchor, targetBox);
      const contentPoint = anchorToPoint(_placement.origin, box);
      let {
        x,
        y
      } = getOffset(targetPoint, contentPoint);
      switch (_placement.anchor.side) {
        case 'top':
          y -= offset.value[0];
          break;
        case 'bottom':
          y += offset.value[0];
          break;
        case 'left':
          x -= offset.value[0];
          break;
        case 'right':
          x += offset.value[0];
          break;
      }
      switch (_placement.anchor.align) {
        case 'top':
          y -= offset.value[1];
          break;
        case 'bottom':
          y += offset.value[1];
          break;
        case 'left':
          x -= offset.value[1];
          break;
        case 'right':
          x += offset.value[1];
          break;
      }
      box.x += x;
      box.y += y;
      box.width = Math.min(box.width, maxWidth.value);
      box.height = Math.min(box.height, maxHeight.value);
      const overflows = getOverflow(box, viewport);
      return {
        overflows,
        x,
        y
      };
    }
    let x = 0;
    let y = 0;
    const available = {
      x: 0,
      y: 0
    };
    const flipped = {
      x: false,
      y: false
    };
    let resets = -1;
    while (true) {
      if (resets++ > 10) {
        consoleError('Infinite loop detected in connectedLocationStrategy');
        break;
      }
      const {
        x: _x,
        y: _y,
        overflows
      } = checkOverflow(placement);
      x += _x;
      y += _y;
      contentBox.x += _x;
      contentBox.y += _y;

      // flip
      {
        const axis = getAxis(placement.anchor);
        const hasOverflowX = overflows.x.before || overflows.x.after;
        const hasOverflowY = overflows.y.before || overflows.y.after;
        let reset = false;
        ['x', 'y'].forEach(key => {
          if (key === 'x' && hasOverflowX && !flipped.x || key === 'y' && hasOverflowY && !flipped.y) {
            const newPlacement = {
              anchor: {
                ...placement.anchor
              },
              origin: {
                ...placement.origin
              }
            };
            const flip = key === 'x' ? axis === 'y' ? flipAlign : flipSide : axis === 'y' ? flipSide : flipAlign;
            newPlacement.anchor = flip(newPlacement.anchor);
            newPlacement.origin = flip(newPlacement.origin);
            const {
              overflows: newOverflows
            } = checkOverflow(newPlacement);
            if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
              placement = newPlacement;
              reset = flipped[key] = true;
            }
          }
        });
        if (reset) continue;
      }

      // shift
      if (overflows.x.before) {
        x += overflows.x.before;
        contentBox.x += overflows.x.before;
      }
      if (overflows.x.after) {
        x -= overflows.x.after;
        contentBox.x -= overflows.x.after;
      }
      if (overflows.y.before) {
        y += overflows.y.before;
        contentBox.y += overflows.y.before;
      }
      if (overflows.y.after) {
        y -= overflows.y.after;
        contentBox.y -= overflows.y.after;
      }

      // size
      {
        const overflows = getOverflow(contentBox, viewport);
        available.x = viewport.width - overflows.x.before - overflows.x.after;
        available.y = viewport.height - overflows.y.before - overflows.y.after;
        x += overflows.x.before;
        contentBox.x += overflows.x.before;
        y += overflows.y.before;
        contentBox.y += overflows.y.before;
      }
      break;
    }
    const axis = getAxis(placement.anchor);
    Object.assign(contentStyles.value, {
      '--v-overlay-anchor-origin': `${placement.anchor.side} ${placement.anchor.align}`,
      transformOrigin: `${placement.origin.side} ${placement.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: convertToUnit(pixelRound(y)),
      left: data.isRtl.value ? undefined : convertToUnit(pixelRound(x)),
      right: data.isRtl.value ? convertToUnit(pixelRound(-x)) : undefined,
      minWidth: convertToUnit(axis === 'y' ? Math.min(minWidth.value, targetBox.width) : minWidth.value),
      maxWidth: convertToUnit(pixelCeil(clamp(available.x, minWidth.value === Infinity ? 0 : minWidth.value, maxWidth.value))),
      maxHeight: convertToUnit(pixelCeil(clamp(available.y, minHeight.value === Infinity ? 0 : minHeight.value, maxHeight.value)))
    });
    return {
      available,
      contentBox
    };
  }
  watch(() => [preferredAnchor.value, preferredOrigin.value, props.offset, props.minWidth, props.minHeight, props.maxWidth, props.maxHeight], () => updateLocation());
  nextTick(() => {
    const result = updateLocation();

    // TODO: overflowing content should only require a single updateLocation call
    // Icky hack to make sure the content is positioned consistently
    if (!result) return;
    const {
      available,
      contentBox
    } = result;
    if (contentBox.height > available.y) {
      requestAnimationFrame(() => {
        updateLocation();
        requestAnimationFrame(() => {
          updateLocation();
        });
      });
    }
  });
  return {
    updateLocation
  };
}
function pixelRound(val) {
  return Math.round(val * devicePixelRatio) / devicePixelRatio;
}
function pixelCeil(val) {
  return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
}

let clean = true;
const frames = [];

/**
 * Schedule a task to run in an animation frame on its own
 * This is useful for heavy tasks that may cause jank if all ran together
 */
function requestNewFrame(cb) {
  if (!clean || frames.length) {
    frames.push(cb);
    run();
  } else {
    clean = false;
    cb();
    run();
  }
}
let raf = -1;
function run() {
  cancelAnimationFrame(raf);
  raf = requestAnimationFrame(() => {
    const frame = frames.shift();
    if (frame) frame();
    if (frames.length) run();else clean = true;
  });
}

// Utilities
const scrollStrategies = {
  none: null,
  close: closeScrollStrategy,
  block: blockScrollStrategy,
  reposition: repositionScrollStrategy
};
const makeScrollStrategyProps = propsFactory({
  scrollStrategy: {
    type: [String, Function],
    default: 'block',
    validator: val => typeof val === 'function' || val in scrollStrategies
  }
}, 'VOverlay-scroll-strategies');
function useScrollStrategies(props, data) {
  if (!IN_BROWSER) return;
  let scope;
  watchEffect(async () => {
    scope?.stop();
    if (!(data.isActive.value && props.scrollStrategy)) return;
    scope = effectScope();
    await new Promise(resolve => setTimeout(resolve));
    scope.active && scope.run(() => {
      if (typeof props.scrollStrategy === 'function') {
        props.scrollStrategy(data, props, scope);
      } else {
        scrollStrategies[props.scrollStrategy]?.(data, props, scope);
      }
    });
  });
  onScopeDispose(() => {
    scope?.stop();
  });
}
function closeScrollStrategy(data) {
  function onScroll(e) {
    data.isActive.value = false;
  }
  bindScroll(data.targetEl.value ?? data.contentEl.value, onScroll);
}
function blockScrollStrategy(data, props) {
  const offsetParent = data.root.value?.offsetParent;
  const scrollElements = [...new Set([...getScrollParents(data.targetEl.value, props.contained ? offsetParent : undefined), ...getScrollParents(data.contentEl.value, props.contained ? offsetParent : undefined)])].filter(el => !el.classList.contains('v-overlay-scroll-blocked'));
  const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
  const scrollableParent = (el => hasScrollbar(el) && el)(offsetParent || document.documentElement);
  if (scrollableParent) {
    data.root.value.classList.add('v-overlay--scroll-blocked');
  }
  scrollElements.forEach((el, i) => {
    el.style.setProperty('--v-body-scroll-x', convertToUnit(-el.scrollLeft));
    el.style.setProperty('--v-body-scroll-y', convertToUnit(-el.scrollTop));
    if (el !== document.documentElement) {
      el.style.setProperty('--v-scrollbar-offset', convertToUnit(scrollbarWidth));
    }
    el.classList.add('v-overlay-scroll-blocked');
  });
  onScopeDispose(() => {
    scrollElements.forEach((el, i) => {
      const x = parseFloat(el.style.getPropertyValue('--v-body-scroll-x'));
      const y = parseFloat(el.style.getPropertyValue('--v-body-scroll-y'));
      const scrollBehavior = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.style.removeProperty('--v-body-scroll-x');
      el.style.removeProperty('--v-body-scroll-y');
      el.style.removeProperty('--v-scrollbar-offset');
      el.classList.remove('v-overlay-scroll-blocked');
      el.scrollLeft = -x;
      el.scrollTop = -y;
      el.style.scrollBehavior = scrollBehavior;
    });
    if (scrollableParent) {
      data.root.value.classList.remove('v-overlay--scroll-blocked');
    }
  });
}
function repositionScrollStrategy(data, props, scope) {
  let slow = false;
  let raf = -1;
  let ric = -1;
  function update(e) {
    requestNewFrame(() => {
      const start = performance.now();
      data.updateLocation.value?.(e);
      const time = performance.now() - start;
      slow = time / (1000 / 60) > 2;
    });
  }
  ric = (typeof requestIdleCallback === 'undefined' ? cb => cb() : requestIdleCallback)(() => {
    scope.run(() => {
      bindScroll(data.targetEl.value ?? data.contentEl.value, e => {
        if (slow) {
          // If the position calculation is slow,
          // defer updates until scrolling is finished.
          // Browsers usually fire one scroll event per frame so
          // we just wait until we've got two frames without an event
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            raf = requestAnimationFrame(() => {
              update(e);
            });
          });
        } else {
          update(e);
        }
      });
    });
  });
  onScopeDispose(() => {
    typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(ric);
    cancelAnimationFrame(raf);
  });
}

/** @private */
function bindScroll(el, onScroll) {
  const scrollElements = [document, ...getScrollParents(el)];
  scrollElements.forEach(el => {
    el.addEventListener('scroll', onScroll, {
      passive: true
    });
  });
  onScopeDispose(() => {
    scrollElements.forEach(el => {
      el.removeEventListener('scroll', onScroll);
    });
  });
}

// Types

const VMenuSymbol = Symbol.for('vuetify:v-menu');

// Utilities
// Composables
const makeDelayProps = propsFactory({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, 'delay');
function useDelay(props, cb) {
  let clearDelay = () => {};
  function runDelay(isOpening) {
    clearDelay?.();
    const delay = Number(isOpening ? props.openDelay : props.closeDelay);
    return new Promise(resolve => {
      clearDelay = defer(delay, () => {
        cb?.(isOpening);
        resolve(isOpening);
      });
    });
  }
  function runOpenDelay() {
    return runDelay(true);
  }
  function runCloseDelay() {
    return runDelay(false);
  }
  return {
    clearDelay,
    runOpenDelay,
    runCloseDelay
  };
}

// Components
const makeActivatorProps = propsFactory({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: undefined
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: undefined
  },
  closeOnContentClick: Boolean,
  ...makeDelayProps()
}, 'VOverlay-activator');
function useActivator(props, _ref) {
  let {
    isActive,
    isTop,
    contentEl
  } = _ref;
  const vm = getCurrentInstance('useActivator');
  const activatorEl = ref();
  let isHovered = false;
  let isFocused = false;
  let firstEnter = true;
  const openOnFocus = computed(() => props.openOnFocus || props.openOnFocus == null && props.openOnHover);
  const openOnClick = computed(() => props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value);
  const {
    runOpenDelay,
    runCloseDelay
  } = useDelay(props, value => {
    if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
      if (isActive.value !== value) {
        firstEnter = true;
      }
      isActive.value = value;
    }
  });
  const cursorTarget = ref();
  const availableEvents = {
    onClick: e => {
      e.stopPropagation();
      activatorEl.value = e.currentTarget || e.target;
      if (!isActive.value) {
        cursorTarget.value = [e.clientX, e.clientY];
      }
      isActive.value = !isActive.value;
    },
    onMouseenter: e => {
      if (e.sourceCapabilities?.firesTouchEvents) return;
      isHovered = true;
      activatorEl.value = e.currentTarget || e.target;
      runOpenDelay();
    },
    onMouseleave: e => {
      isHovered = false;
      runCloseDelay();
    },
    onFocus: e => {
      if (matchesSelector(e.target, ':focus-visible') === false) return;
      isFocused = true;
      e.stopPropagation();
      activatorEl.value = e.currentTarget || e.target;
      runOpenDelay();
    },
    onBlur: e => {
      isFocused = false;
      e.stopPropagation();
      runCloseDelay();
    }
  };
  const activatorEvents = computed(() => {
    const events = {};
    if (openOnClick.value) {
      events.onClick = availableEvents.onClick;
    }
    if (props.openOnHover) {
      events.onMouseenter = availableEvents.onMouseenter;
      events.onMouseleave = availableEvents.onMouseleave;
    }
    if (openOnFocus.value) {
      events.onFocus = availableEvents.onFocus;
      events.onBlur = availableEvents.onBlur;
    }
    return events;
  });
  const contentEvents = computed(() => {
    const events = {};
    if (props.openOnHover) {
      events.onMouseenter = () => {
        isHovered = true;
        runOpenDelay();
      };
      events.onMouseleave = () => {
        isHovered = false;
        runCloseDelay();
      };
    }
    if (openOnFocus.value) {
      events.onFocusin = () => {
        isFocused = true;
        runOpenDelay();
      };
      events.onFocusout = () => {
        isFocused = false;
        runCloseDelay();
      };
    }
    if (props.closeOnContentClick) {
      const menu = inject$2(VMenuSymbol, null);
      events.onClick = () => {
        isActive.value = false;
        menu?.closeParents();
      };
    }
    return events;
  });
  const scrimEvents = computed(() => {
    const events = {};
    if (props.openOnHover) {
      events.onMouseenter = () => {
        if (firstEnter) {
          isHovered = true;
          firstEnter = false;
          runOpenDelay();
        }
      };
      events.onMouseleave = () => {
        isHovered = false;
        runCloseDelay();
      };
    }
    return events;
  });
  watch(isTop, val => {
    if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered)) && !contentEl.value?.contains(document.activeElement)) {
      isActive.value = false;
    }
  });
  watch(isActive, val => {
    if (!val) {
      setTimeout(() => {
        cursorTarget.value = undefined;
      });
    }
  }, {
    flush: 'post'
  });
  const activatorRef = templateRef();
  watchEffect(() => {
    if (!activatorRef.value) return;
    nextTick(() => {
      activatorEl.value = activatorRef.el;
    });
  });
  const targetRef = templateRef();
  const target = computed(() => {
    if (props.target === 'cursor' && cursorTarget.value) return cursorTarget.value;
    if (targetRef.value) return targetRef.el;
    return getTarget(props.target, vm) || activatorEl.value;
  });
  const targetEl = computed(() => {
    return Array.isArray(target.value) ? undefined : target.value;
  });
  let scope;
  watch(() => !!props.activator, val => {
    if (val && IN_BROWSER) {
      scope = effectScope();
      scope.run(() => {
        _useActivator(props, vm, {
          activatorEl,
          activatorEvents
        });
      });
    } else if (scope) {
      scope.stop();
    }
  }, {
    flush: 'post',
    immediate: true
  });
  onScopeDispose(() => {
    scope?.stop();
  });
  return {
    activatorEl,
    activatorRef,
    target,
    targetEl,
    targetRef,
    activatorEvents,
    contentEvents,
    scrimEvents
  };
}
function _useActivator(props, vm, _ref2) {
  let {
    activatorEl,
    activatorEvents
  } = _ref2;
  watch(() => props.activator, (val, oldVal) => {
    if (oldVal && val !== oldVal) {
      const activator = getActivator(oldVal);
      activator && unbindActivatorProps(activator);
    }
    if (val) {
      nextTick(() => bindActivatorProps());
    }
  }, {
    immediate: true
  });
  watch(() => props.activatorProps, () => {
    bindActivatorProps();
  });
  onScopeDispose(() => {
    unbindActivatorProps();
  });
  function bindActivatorProps() {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
    let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
    if (!el) return;
    bindProps(el, mergeProps(activatorEvents.value, _props));
  }
  function unbindActivatorProps() {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
    let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
    if (!el) return;
    unbindProps(el, mergeProps(activatorEvents.value, _props));
  }
  function getActivator() {
    let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props.activator;
    const activator = getTarget(selector, vm);

    // The activator should only be a valid element (Ignore comments and text nodes)
    activatorEl.value = activator?.nodeType === Node.ELEMENT_NODE ? activator : undefined;
    return activatorEl.value;
  }
}
function getTarget(selector, vm) {
  if (!selector) return;
  let target;
  if (selector === 'parent') {
    let el = vm?.proxy?.$el?.parentNode;
    while (el?.hasAttribute('data-no-activator')) {
      el = el.parentNode;
    }
    target = el;
  } else if (typeof selector === 'string') {
    // Selector
    target = document.querySelector(selector);
  } else if ('$el' in selector) {
    // Component (ref)
    target = selector.$el;
  } else {
    // HTMLElement | Element | [x, y]
    target = selector;
  }
  return target;
}

// Composables
function useHydration() {
  if (!IN_BROWSER) return shallowRef(false);
  const {
    ssr
  } = useDisplay();
  if (ssr) {
    const isMounted = shallowRef(false);
    onMounted(() => {
      isMounted.value = true;
    });
    return isMounted;
  } else {
    return shallowRef(true);
  }
}

// Utilities
const makeLazyProps = propsFactory({
  eager: Boolean
}, 'lazy');
function useLazy(props, active) {
  const isBooted = shallowRef(false);
  const hasContent = computed(() => isBooted.value || props.eager || active.value);
  watch(active, () => isBooted.value = true);
  function onAfterLeave() {
    if (!props.eager) isBooted.value = false;
  }
  return {
    isBooted,
    hasContent,
    onAfterLeave
  };
}

// Utilities
function useScopeId() {
  const vm = getCurrentInstance('useScopeId');
  const scopeId = vm.vnode.scopeId;
  return {
    scopeId: scopeId ? {
      [scopeId]: ''
    } : undefined
  };
}

// Composables
const StackSymbol = Symbol.for('vuetify:stack');
const globalStack = reactive([]);
function useStack(isActive, zIndex, disableGlobalStack) {
  const vm = getCurrentInstance('useStack');
  const createStackEntry = !disableGlobalStack;
  const parent = inject$2(StackSymbol, undefined);
  const stack = reactive({
    activeChildren: new Set()
  });
  provide(StackSymbol, stack);
  const _zIndex = shallowRef(+zIndex.value);
  useToggleScope(isActive, () => {
    const lastZIndex = globalStack.at(-1)?.[1];
    _zIndex.value = lastZIndex ? lastZIndex + 10 : +zIndex.value;
    if (createStackEntry) {
      globalStack.push([vm.uid, _zIndex.value]);
    }
    parent?.activeChildren.add(vm.uid);
    onScopeDispose(() => {
      if (createStackEntry) {
        const idx = toRaw(globalStack).findIndex(v => v[0] === vm.uid);
        globalStack.splice(idx, 1);
      }
      parent?.activeChildren.delete(vm.uid);
    });
  });
  const globalTop = shallowRef(true);
  if (createStackEntry) {
    watchEffect(() => {
      const _isTop = globalStack.at(-1)?.[0] === vm.uid;
      setTimeout(() => globalTop.value = _isTop);
    });
  }
  const localTop = computed(() => !stack.activeChildren.size);
  return {
    globalTop: readonly(globalTop),
    localTop,
    stackStyles: computed(() => ({
      zIndex: _zIndex.value
    }))
  };
}

// Utilities
function useTeleport(target) {
  const teleportTarget = computed(() => {
    const _target = target();
    if (_target === true || !IN_BROWSER) return undefined;
    const targetElement = _target === false ? document.body : typeof _target === 'string' ? document.querySelector(_target) : _target;
    if (targetElement == null) {
      warn(`Unable to locate target ${_target}`);
      return undefined;
    }
    let container = [...targetElement.children].find(el => el.matches('.v-overlay-container'));
    if (!container) {
      container = document.createElement('div');
      container.className = 'v-overlay-container';
      targetElement.appendChild(container);
    }
    return container;
  });
  return {
    teleportTarget
  };
}

// Utilities
function defaultConditional() {
  return true;
}
function checkEvent(e, el, binding) {
  // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components
  if (!e || checkIsActive(e, binding) === false) return false;

  // If we're clicking inside the shadowroot, then the app root doesn't get the same
  // level of introspection as to _what_ we're clicking. We want to check to see if
  // our target is the shadowroot parent container, and if it is, ignore.
  const root = attachedRoot(el);
  if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false;

  // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)
  const elements = (typeof binding.value === 'object' && binding.value.include || (() => []))();
  // Add the root element for the component this directive was defined on
  elements.push(el);

  // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occur before
  // the bubbling click event on any outside elements.
  return !elements.some(el => el?.contains(e.target));
}
function checkIsActive(e, binding) {
  const isActive = typeof binding.value === 'object' && binding.value.closeConditional || defaultConditional;
  return isActive(e);
}
function directive(e, el, binding) {
  const handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;

  // Clicks in the Shadow DOM change their target while using setTimeout, so the original target is saved here
  e.shadowTarget = e.target;
  el._clickOutside.lastMousedownWasOutside && checkEvent(e, el, binding) && setTimeout(() => {
    checkIsActive(e, binding) && handler && handler(e);
  }, 0);
}
function handleShadow(el, callback) {
  const root = attachedRoot(el);
  callback(document);
  if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) {
    callback(root);
  }
}
const ClickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(el, binding) {
    const onClick = e => directive(e, el, binding);
    const onMousedown = e => {
      el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
    };
    handleShadow(el, app => {
      app.addEventListener('click', onClick, true);
      app.addEventListener('mousedown', onMousedown, true);
    });
    if (!el._clickOutside) {
      el._clickOutside = {
        lastMousedownWasOutside: false
      };
    }
    el._clickOutside[binding.instance.$.uid] = {
      onClick,
      onMousedown
    };
  },
  beforeUnmount(el, binding) {
    if (!el._clickOutside) return;
    handleShadow(el, app => {
      if (!app || !el._clickOutside?.[binding.instance.$.uid]) return;
      const {
        onClick,
        onMousedown
      } = el._clickOutside[binding.instance.$.uid];
      app.removeEventListener('click', onClick, true);
      app.removeEventListener('mousedown', onMousedown, true);
    });
    delete el._clickOutside[binding.instance.$.uid];
  }
};

function Scrim(props) {
  const {
    modelValue,
    color,
    ...rest
  } = props;
  return createVNode(Transition, {
    "name": "fade-transition",
    "appear": true
  }, {
    default: () => [props.modelValue && createVNode("div", mergeProps({
      "class": ['v-overlay__scrim', props.color.backgroundColorClasses.value],
      "style": props.color.backgroundColorStyles.value
    }, rest), null)]
  });
}
const makeVOverlayProps = propsFactory({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: true
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: true
  },
  zIndex: {
    type: [Number, String],
    default: 2000
  },
  ...makeActivatorProps(),
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeLazyProps(),
  ...makeLocationStrategyProps(),
  ...makeScrollStrategyProps(),
  ...makeThemeProps(),
  ...makeTransitionProps()
}, 'VOverlay');
const VOverlay = genericComponent()({
  name: 'VOverlay',
  directives: {
    ClickOutside
  },
  inheritAttrs: false,
  props: {
    _disableGlobalStack: Boolean,
    ...makeVOverlayProps()
  },
  emits: {
    'click:outside': e => true,
    'update:modelValue': value => true,
    afterEnter: () => true,
    afterLeave: () => true
  },
  setup(props, _ref) {
    let {
      slots,
      attrs,
      emit
    } = _ref;
    const vm = getCurrentInstance('VOverlay');
    const root = ref();
    const scrimEl = ref();
    const contentEl = ref();
    const model = useProxiedModel(props, 'modelValue');
    const isActive = computed({
      get: () => model.value,
      set: v => {
        if (!(v && props.disabled)) model.value = v;
      }
    });
    const {
      themeClasses
    } = provideTheme(props);
    const {
      rtlClasses,
      isRtl
    } = useRtl();
    const {
      hasContent,
      onAfterLeave: _onAfterLeave
    } = useLazy(props, isActive);
    const scrimColor = useBackgroundColor(computed(() => {
      return typeof props.scrim === 'string' ? props.scrim : null;
    }));
    const {
      globalTop,
      localTop,
      stackStyles
    } = useStack(isActive, toRef(props, 'zIndex'), props._disableGlobalStack);
    const {
      activatorEl,
      activatorRef,
      target,
      targetEl,
      targetRef,
      activatorEvents,
      contentEvents,
      scrimEvents
    } = useActivator(props, {
      isActive,
      isTop: localTop,
      contentEl
    });
    const {
      teleportTarget
    } = useTeleport(() => {
      const target = props.attach || props.contained;
      if (target) return target;
      const rootNode = activatorEl?.value?.getRootNode() || vm.proxy?.$el?.getRootNode();
      if (rootNode instanceof ShadowRoot) return rootNode;
      return false;
    });
    const {
      dimensionStyles
    } = useDimension(props);
    const isMounted = useHydration();
    const {
      scopeId
    } = useScopeId();
    watch(() => props.disabled, v => {
      if (v) isActive.value = false;
    });
    const {
      contentStyles,
      updateLocation
    } = useLocationStrategies(props, {
      isRtl,
      contentEl,
      target,
      isActive
    });
    useScrollStrategies(props, {
      root,
      contentEl,
      targetEl,
      isActive,
      updateLocation
    });
    function onClickOutside(e) {
      emit('click:outside', e);
      if (!props.persistent) isActive.value = false;else animateClick();
    }
    function closeConditional(e) {
      return isActive.value && globalTop.value && (
      // If using scrim, only close if clicking on it rather than anything opened on top
      !props.scrim || e.target === scrimEl.value || e instanceof MouseEvent && e.shadowTarget === scrimEl.value);
    }
    IN_BROWSER && watch(isActive, val => {
      if (val) {
        window.addEventListener('keydown', onKeydown);
      } else {
        window.removeEventListener('keydown', onKeydown);
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      if (!IN_BROWSER) return;
      window.removeEventListener('keydown', onKeydown);
    });
    function onKeydown(e) {
      if (e.key === 'Escape' && globalTop.value) {
        if (!props.persistent) {
          isActive.value = false;
          if (contentEl.value?.contains(document.activeElement)) {
            activatorEl.value?.focus();
          }
        } else animateClick();
      }
    }
    const router = useRouter();
    useToggleScope(() => props.closeOnBack, () => {
      useBackButton(router, next => {
        if (globalTop.value && isActive.value) {
          next(false);
          if (!props.persistent) isActive.value = false;else animateClick();
        } else {
          next();
        }
      });
    });
    const top = ref();
    watch(() => isActive.value && (props.absolute || props.contained) && teleportTarget.value == null, val => {
      if (val) {
        const scrollParent = getScrollParent(root.value);
        if (scrollParent && scrollParent !== document.scrollingElement) {
          top.value = scrollParent.scrollTop;
        }
      }
    });

    // Add a quick "bounce" animation to the content
    function animateClick() {
      if (props.noClickAnimation) return;
      contentEl.value && animate(contentEl.value, [{
        transformOrigin: 'center'
      }, {
        transform: 'scale(1.03)'
      }, {
        transformOrigin: 'center'
      }], {
        duration: 150,
        easing: standardEasing
      });
    }
    function onAfterEnter() {
      emit('afterEnter');
    }
    function onAfterLeave() {
      _onAfterLeave();
      emit('afterLeave');
    }
    useRender(() => createVNode(Fragment, null, [slots.activator?.({
      isActive: isActive.value,
      targetRef,
      props: mergeProps({
        ref: activatorRef
      }, activatorEvents.value, props.activatorProps)
    }), isMounted.value && hasContent.value && createVNode(Teleport, {
      "disabled": !teleportTarget.value,
      "to": teleportTarget.value
    }, {
      default: () => [createVNode("div", mergeProps({
        "class": ['v-overlay', {
          'v-overlay--absolute': props.absolute || props.contained,
          'v-overlay--active': isActive.value,
          'v-overlay--contained': props.contained
        }, themeClasses.value, rtlClasses.value, props.class],
        "style": [stackStyles.value, {
          '--v-overlay-opacity': props.opacity,
          top: convertToUnit(top.value)
        }, props.style],
        "ref": root
      }, scopeId, attrs), [createVNode(Scrim, mergeProps({
        "color": scrimColor,
        "modelValue": isActive.value && !!props.scrim,
        "ref": scrimEl
      }, scrimEvents.value), null), createVNode(MaybeTransition, {
        "appear": true,
        "persisted": true,
        "transition": props.transition,
        "target": target.value,
        "onAfterEnter": onAfterEnter,
        "onAfterLeave": onAfterLeave
      }, {
        default: () => [withDirectives(createVNode("div", mergeProps({
          "ref": contentEl,
          "class": ['v-overlay__content', props.contentClass],
          "style": [dimensionStyles.value, contentStyles.value]
        }, contentEvents.value, props.contentProps), [slots.default?.({
          isActive
        })]), [[vShow, isActive.value], [resolveDirective("click-outside"), {
          handler: onClickOutside,
          closeConditional,
          include: () => [activatorEl.value]
        }]])]
      })])]
    })]));
    return {
      activatorEl,
      scrimEl,
      target,
      animateClick,
      contentEl,
      globalTop,
      localTop,
      updateLocation
    };
  }
});

// Types

const Refs = Symbol('Forwarded refs');

/** Omit properties starting with P */

/** Omit keyof $props from T */

function getDescriptor(obj, key) {
  let currentObj = obj;
  while (currentObj) {
    const descriptor = Reflect.getOwnPropertyDescriptor(currentObj, key);
    if (descriptor) return descriptor;
    currentObj = Object.getPrototypeOf(currentObj);
  }
  return undefined;
}
function forwardRefs(target) {
  for (var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    refs[_key - 1] = arguments[_key];
  }
  target[Refs] = refs;
  return new Proxy(target, {
    get(target, key) {
      if (Reflect.has(target, key)) {
        return Reflect.get(target, key);
      }

      // Skip internal properties
      if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
      for (const ref of refs) {
        if (ref.value && Reflect.has(ref.value, key)) {
          const val = Reflect.get(ref.value, key);
          return typeof val === 'function' ? val.bind(ref.value) : val;
        }
      }
    },
    has(target, key) {
      if (Reflect.has(target, key)) {
        return true;
      }

      // Skip internal properties
      if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
      for (const ref of refs) {
        if (ref.value && Reflect.has(ref.value, key)) {
          return true;
        }
      }
      return false;
    },
    set(target, key, value) {
      if (Reflect.has(target, key)) {
        return Reflect.set(target, key, value);
      }

      // Skip internal properties
      if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
      for (const ref of refs) {
        if (ref.value && Reflect.has(ref.value, key)) {
          return Reflect.set(ref.value, key, value);
        }
      }
      return false;
    },
    getOwnPropertyDescriptor(target, key) {
      const descriptor = Reflect.getOwnPropertyDescriptor(target, key);
      if (descriptor) return descriptor;

      // Skip internal properties
      if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;

      // Check each ref's own properties
      for (const ref of refs) {
        if (!ref.value) continue;
        const descriptor = getDescriptor(ref.value, key) ?? ('_' in ref.value ? getDescriptor(ref.value._?.setupState, key) : undefined);
        if (descriptor) return descriptor;
      }

      // Recursive search up each ref's prototype
      for (const ref of refs) {
        const childRefs = ref.value && ref.value[Refs];
        if (!childRefs) continue;
        const queue = childRefs.slice();
        while (queue.length) {
          const ref = queue.shift();
          const descriptor = getDescriptor(ref.value, key);
          if (descriptor) return descriptor;
          const childRefs = ref.value && ref.value[Refs];
          if (childRefs) queue.push(...childRefs);
        }
      }
      return undefined;
    }
  });
}

const makeVMenuProps = propsFactory({
  // TODO
  // disableKeys: Boolean,
  id: String,
  submenu: Boolean,
  ...omit(makeVOverlayProps({
    closeDelay: 250,
    closeOnContentClick: true,
    locationStrategy: 'connected',
    location: undefined,
    openDelay: 300,
    scrim: false,
    scrollStrategy: 'reposition',
    transition: {
      component: VDialogTransition
    }
  }), ['absolute'])
}, 'VMenu');
const VMenu = genericComponent()({
  name: 'VMenu',
  props: makeVMenuProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const isActive = useProxiedModel(props, 'modelValue');
    const {
      scopeId
    } = useScopeId();
    const {
      isRtl
    } = useRtl();
    const uid = getUid();
    const id = computed(() => props.id || `v-menu-${uid}`);
    const overlay = ref();
    const parent = inject$2(VMenuSymbol, null);
    const openChildren = shallowRef(new Set());
    provide(VMenuSymbol, {
      register() {
        openChildren.value.add(uid);
      },
      unregister() {
        openChildren.value.delete(uid);
      },
      closeParents(e) {
        setTimeout(() => {
          if (!openChildren.value.size && !props.persistent && (e == null || overlay.value?.contentEl && !isClickInsideElement(e, overlay.value.contentEl))) {
            isActive.value = false;
            parent?.closeParents();
          }
        }, 40);
      }
    });
    onBeforeUnmount(() => {
      parent?.unregister();
      document.removeEventListener('focusin', onFocusIn);
    });
    onDeactivated(() => isActive.value = false);
    async function onFocusIn(e) {
      const before = e.relatedTarget;
      const after = e.target;
      await nextTick();
      if (isActive.value && before !== after && overlay.value?.contentEl &&
      // We're the topmost menu
      overlay.value?.globalTop &&
      // It isn't the document or the menu body
      ![document, overlay.value.contentEl].includes(after) &&
      // It isn't inside the menu body
      !overlay.value.contentEl.contains(after)) {
        const focusable = focusableChildren(overlay.value.contentEl);
        focusable[0]?.focus();
      }
    }
    watch(isActive, val => {
      if (val) {
        parent?.register();
        if (IN_BROWSER) {
          document.addEventListener('focusin', onFocusIn, {
            once: true
          });
        }
      } else {
        parent?.unregister();
        if (IN_BROWSER) {
          document.removeEventListener('focusin', onFocusIn);
        }
      }
    }, {
      immediate: true
    });
    function onClickOutside(e) {
      parent?.closeParents(e);
    }
    function onKeydown(e) {
      if (props.disabled) return;
      if (e.key === 'Tab' || e.key === 'Enter' && !props.closeOnContentClick) {
        if (e.key === 'Enter' && (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement && !!e.target.closest('form'))) return;
        if (e.key === 'Enter') e.preventDefault();
        const nextElement = getNextElement(focusableChildren(overlay.value?.contentEl, false), e.shiftKey ? 'prev' : 'next', el => el.tabIndex >= 0);
        if (!nextElement) {
          isActive.value = false;
          overlay.value?.activatorEl?.focus();
        }
      } else if (props.submenu && e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) {
        isActive.value = false;
        overlay.value?.activatorEl?.focus();
      }
    }
    function onActivatorKeydown(e) {
      if (props.disabled) return;
      const el = overlay.value?.contentEl;
      if (el && isActive.value) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          e.stopImmediatePropagation();
          focusChild(el, 'next');
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          e.stopImmediatePropagation();
          focusChild(el, 'prev');
        } else if (props.submenu) {
          if (e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) {
            isActive.value = false;
          } else if (e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight')) {
            e.preventDefault();
            focusChild(el, 'first');
          }
        }
      } else if (props.submenu ? e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight') : ['ArrowDown', 'ArrowUp'].includes(e.key)) {
        isActive.value = true;
        e.preventDefault();
        setTimeout(() => setTimeout(() => onActivatorKeydown(e)));
      }
    }
    const activatorProps = computed(() => mergeProps({
      'aria-haspopup': 'menu',
      'aria-expanded': String(isActive.value),
      'aria-owns': id.value,
      onKeydown: onActivatorKeydown
    }, props.activatorProps));
    useRender(() => {
      const overlayProps = VOverlay.filterProps(props);
      return createVNode(VOverlay, mergeProps({
        "ref": overlay,
        "id": id.value,
        "class": ['v-menu', props.class],
        "style": props.style
      }, overlayProps, {
        "modelValue": isActive.value,
        "onUpdate:modelValue": $event => isActive.value = $event,
        "absolute": true,
        "activatorProps": activatorProps.value,
        "location": props.location ?? (props.submenu ? 'end' : 'bottom'),
        "onClick:outside": onClickOutside,
        "onKeydown": onKeydown
      }, scopeId), {
        activator: slots.activator,
        default: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(VDefaultsProvider, {
            "root": "VMenu"
          }, {
            default: () => [slots.default?.(...args)]
          });
        }
      });
    });
    return forwardRefs({
      id,
      ΨopenChildren: openChildren
    }, overlay);
  }
});

const makeVCounterProps = propsFactory({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...makeComponentProps(),
  ...makeTransitionProps({
    transition: {
      component: VSlideYTransition
    }
  })
}, 'VCounter');
const VCounter = genericComponent()({
  name: 'VCounter',
  functional: true,
  props: makeVCounterProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const counter = computed(() => {
      return props.max ? `${props.value} / ${props.max}` : String(props.value);
    });
    useRender(() => createVNode(MaybeTransition, {
      "transition": props.transition
    }, {
      default: () => [withDirectives(createVNode("div", {
        "class": ['v-counter', {
          'text-error': props.max && !props.disabled && parseFloat(props.value) > parseFloat(props.max)
        }, props.class],
        "style": props.style
      }, [slots.default ? slots.default({
        counter: counter.value,
        max: props.max,
        value: props.value
      }) : counter.value]), [[vShow, props.active]])]
    }));
    return {};
  }
});

const makeVFieldLabelProps = propsFactory({
  floating: Boolean,
  ...makeComponentProps()
}, 'VFieldLabel');
const VFieldLabel = genericComponent()({
  name: 'VFieldLabel',
  props: makeVFieldLabelProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(VLabel, {
      "class": ['v-field-label', {
        'v-field-label--floating': props.floating
      }, props.class],
      "style": props.style,
      "aria-hidden": props.floating || undefined
    }, slots));
    return {};
  }
});

const allowedVariants$1 = ['underlined', 'outlined', 'filled', 'solo', 'solo-inverted', 'solo-filled', 'plain'];
const makeVFieldProps = propsFactory({
  appendInnerIcon: IconValue,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: IconValue,
    default: '$clear'
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: undefined
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: IconValue,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: 'filled',
    validator: v => allowedVariants$1.includes(v)
  },
  'onClick:clear': EventProp(),
  'onClick:appendInner': EventProp(),
  'onClick:prependInner': EventProp(),
  ...makeComponentProps(),
  ...makeLoaderProps(),
  ...makeRoundedProps(),
  ...makeThemeProps()
}, 'VField');
const VField = genericComponent()({
  name: 'VField',
  inheritAttrs: false,
  props: {
    id: String,
    ...makeFocusProps(),
    ...makeVFieldProps()
  },
  emits: {
    'update:focused': focused => true,
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      loaderClasses
    } = useLoader(props);
    const {
      focusClasses,
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const {
      InputIcon
    } = useInputIcon(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      rtlClasses
    } = useRtl();
    const isActive = computed(() => props.dirty || props.active);
    const hasLabel = computed(() => !props.singleLine && !!(props.label || slots.label));
    const uid = getUid();
    const id = computed(() => props.id || `input-${uid}`);
    const messagesId = computed(() => `${id.value}-messages`);
    const labelRef = ref();
    const floatingLabelRef = ref();
    const controlRef = ref();
    const isPlainOrUnderlined = computed(() => ['plain', 'underlined'].includes(props.variant));
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'bgColor'));
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(computed(() => {
      return props.error || props.disabled ? undefined : isActive.value && isFocused.value ? props.color : props.baseColor;
    }));
    watch(isActive, val => {
      if (hasLabel.value) {
        const el = labelRef.value.$el;
        const targetEl = floatingLabelRef.value.$el;
        requestAnimationFrame(() => {
          const rect = nullifyTransforms(el);
          const targetRect = targetEl.getBoundingClientRect();
          const x = targetRect.x - rect.x;
          const y = targetRect.y - rect.y - (rect.height / 2 - targetRect.height / 2);
          const targetWidth = targetRect.width / 0.75;
          const width = Math.abs(targetWidth - rect.width) > 1 ? {
            maxWidth: convertToUnit(targetWidth)
          } : undefined;
          const style = getComputedStyle(el);
          const targetStyle = getComputedStyle(targetEl);
          const duration = parseFloat(style.transitionDuration) * 1000 || 150;
          const scale = parseFloat(targetStyle.getPropertyValue('--v-field-label-scale'));
          const color = targetStyle.getPropertyValue('color');
          el.style.visibility = 'visible';
          targetEl.style.visibility = 'hidden';
          animate(el, {
            transform: `translate(${x}px, ${y}px) scale(${scale})`,
            color,
            ...width
          }, {
            duration,
            easing: standardEasing,
            direction: val ? 'normal' : 'reverse'
          }).finished.then(() => {
            el.style.removeProperty('visibility');
            targetEl.style.removeProperty('visibility');
          });
        });
      }
    }, {
      flush: 'post'
    });
    const slotProps = computed(() => ({
      isActive,
      isFocused,
      controlRef,
      blur,
      focus
    }));
    function onClick(e) {
      if (e.target !== document.activeElement) {
        e.preventDefault();
      }
    }
    function onKeydownClear(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      props['onClick:clear']?.(new MouseEvent('click'));
    }
    useRender(() => {
      const isOutlined = props.variant === 'outlined';
      const hasPrepend = !!(slots['prepend-inner'] || props.prependInnerIcon);
      const hasClear = !!(props.clearable || slots.clear);
      const hasAppend = !!(slots['append-inner'] || props.appendInnerIcon || hasClear);
      const label = () => slots.label ? slots.label({
        ...slotProps.value,
        label: props.label,
        props: {
          for: id.value
        }
      }) : props.label;
      return createVNode("div", mergeProps({
        "class": ['v-field', {
          'v-field--active': isActive.value,
          'v-field--appended': hasAppend,
          'v-field--center-affix': props.centerAffix ?? !isPlainOrUnderlined.value,
          'v-field--disabled': props.disabled,
          'v-field--dirty': props.dirty,
          'v-field--error': props.error,
          'v-field--flat': props.flat,
          'v-field--has-background': !!props.bgColor,
          'v-field--persistent-clear': props.persistentClear,
          'v-field--prepended': hasPrepend,
          'v-field--reverse': props.reverse,
          'v-field--single-line': props.singleLine,
          'v-field--no-label': !label(),
          [`v-field--variant-${props.variant}`]: true
        }, themeClasses.value, backgroundColorClasses.value, focusClasses.value, loaderClasses.value, roundedClasses.value, rtlClasses.value, props.class],
        "style": [backgroundColorStyles.value, props.style],
        "onClick": onClick
      }, attrs), [createVNode("div", {
        "class": "v-field__overlay"
      }, null), createVNode(LoaderSlot, {
        "name": "v-field",
        "active": !!props.loading,
        "color": props.error ? 'error' : typeof props.loading === 'string' ? props.loading : props.color
      }, {
        default: slots.loader
      }), hasPrepend && createVNode("div", {
        "key": "prepend",
        "class": "v-field__prepend-inner"
      }, [props.prependInnerIcon && createVNode(InputIcon, {
        "key": "prepend-icon",
        "name": "prependInner"
      }, null), slots['prepend-inner']?.(slotProps.value)]), createVNode("div", {
        "class": "v-field__field",
        "data-no-activator": ""
      }, [['filled', 'solo', 'solo-inverted', 'solo-filled'].includes(props.variant) && hasLabel.value && createVNode(VFieldLabel, {
        "key": "floating-label",
        "ref": floatingLabelRef,
        "class": [textColorClasses.value],
        "floating": true,
        "for": id.value,
        "style": textColorStyles.value
      }, {
        default: () => [label()]
      }), hasLabel.value && createVNode(VFieldLabel, {
        "key": "label",
        "ref": labelRef,
        "for": id.value
      }, {
        default: () => [label()]
      }), slots.default?.({
        ...slotProps.value,
        props: {
          id: id.value,
          class: 'v-field__input',
          'aria-describedby': messagesId.value
        },
        focus,
        blur
      })]), hasClear && createVNode(VExpandXTransition, {
        "key": "clear"
      }, {
        default: () => [withDirectives(createVNode("div", {
          "class": "v-field__clearable",
          "onMousedown": e => {
            e.preventDefault();
            e.stopPropagation();
          }
        }, [createVNode(VDefaultsProvider, {
          "defaults": {
            VIcon: {
              icon: props.clearIcon
            }
          }
        }, {
          default: () => [slots.clear ? slots.clear({
            ...slotProps.value,
            props: {
              onKeydown: onKeydownClear,
              onFocus: focus,
              onBlur: blur,
              onClick: props['onClick:clear']
            }
          }) : createVNode(InputIcon, {
            "name": "clear",
            "onKeydown": onKeydownClear,
            "onFocus": focus,
            "onBlur": blur
          }, null)]
        })]), [[vShow, props.dirty]])]
      }), hasAppend && createVNode("div", {
        "key": "append",
        "class": "v-field__append-inner"
      }, [slots['append-inner']?.(slotProps.value), props.appendInnerIcon && createVNode(InputIcon, {
        "key": "append-icon",
        "name": "appendInner"
      }, null)]), createVNode("div", {
        "class": ['v-field__outline', textColorClasses.value],
        "style": textColorStyles.value
      }, [isOutlined && createVNode(Fragment, null, [createVNode("div", {
        "class": "v-field__outline__start"
      }, null), hasLabel.value && createVNode("div", {
        "class": "v-field__outline__notch"
      }, [createVNode(VFieldLabel, {
        "ref": floatingLabelRef,
        "floating": true,
        "for": id.value
      }, {
        default: () => [label()]
      })]), createVNode("div", {
        "class": "v-field__outline__end"
      }, null)]), isPlainOrUnderlined.value && hasLabel.value && createVNode(VFieldLabel, {
        "ref": floatingLabelRef,
        "floating": true,
        "for": id.value
      }, {
        default: () => [label()]
      })])]);
    });
    return {
      controlRef
    };
  }
});
// TODO: this is kinda slow, might be better to implicitly inherit props instead
function filterFieldProps(attrs) {
  const keys = Object.keys(VField.props).filter(k => !isOn(k) && k !== 'class' && k !== 'style');
  return pick(attrs, keys);
}

const activeTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];
const makeVTextFieldProps = propsFactory({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: 'text'
  },
  modelModifiers: Object,
  ...makeVInputProps(),
  ...makeVFieldProps()
}, 'VTextField');
const VTextField = genericComponent()({
  name: 'VTextField',
  directives: {
    Intersect
  },
  inheritAttrs: false,
  props: makeVTextFieldProps(),
  emits: {
    'click:control': e => true,
    'mousedown:control': e => true,
    'update:focused': focused => true,
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const {
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const counterValue = computed(() => {
      return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : (model.value ?? '').toString().length;
    });
    const max = computed(() => {
      if (attrs.maxlength) return attrs.maxlength;
      if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
      return props.counter;
    });
    const isPlainOrUnderlined = computed(() => ['plain', 'underlined'].includes(props.variant));
    function onIntersect(isIntersecting, entries) {
      if (!props.autofocus || !isIntersecting) return;
      entries[0].target?.focus?.();
    }
    const vInputRef = ref();
    const vFieldRef = ref();
    const inputRef = ref();
    const isActive = computed(() => activeTypes.includes(props.type) || props.persistentPlaceholder || isFocused.value || props.active);
    function onFocus() {
      if (inputRef.value !== document.activeElement) {
        inputRef.value?.focus();
      }
      if (!isFocused.value) focus();
    }
    function onControlMousedown(e) {
      emit('mousedown:control', e);
      if (e.target === inputRef.value) return;
      onFocus();
      e.preventDefault();
    }
    function onControlClick(e) {
      onFocus();
      emit('click:control', e);
    }
    function onClear(e) {
      e.stopPropagation();
      onFocus();
      nextTick(() => {
        model.value = null;
        callEvent(props['onClick:clear'], e);
      });
    }
    function onInput(e) {
      const el = e.target;
      model.value = el.value;
      if (props.modelModifiers?.trim && ['text', 'search', 'password', 'tel', 'url'].includes(props.type)) {
        const caretPosition = [el.selectionStart, el.selectionEnd];
        nextTick(() => {
          el.selectionStart = caretPosition[0];
          el.selectionEnd = caretPosition[1];
        });
      }
    }
    useRender(() => {
      const hasCounter = !!(slots.counter || props.counter !== false && props.counter != null);
      const hasDetails = !!(hasCounter || slots.details);
      const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
      const {
        modelValue: _,
        ...inputProps
      } = VInput.filterProps(props);
      const fieldProps = filterFieldProps(props);
      return createVNode(VInput, mergeProps({
        "ref": vInputRef,
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "class": ['v-text-field', {
          'v-text-field--prefixed': props.prefix,
          'v-text-field--suffixed': props.suffix,
          'v-input--plain-underlined': isPlainOrUnderlined.value
        }, props.class],
        "style": props.style
      }, rootAttrs, inputProps, {
        "centerAffix": !isPlainOrUnderlined.value,
        "focused": isFocused.value
      }), {
        ...slots,
        default: _ref2 => {
          let {
            id,
            isDisabled,
            isDirty,
            isReadonly,
            isValid
          } = _ref2;
          return createVNode(VField, mergeProps({
            "ref": vFieldRef,
            "onMousedown": onControlMousedown,
            "onClick": onControlClick,
            "onClick:clear": onClear,
            "onClick:prependInner": props['onClick:prependInner'],
            "onClick:appendInner": props['onClick:appendInner'],
            "role": props.role
          }, fieldProps, {
            "id": id.value,
            "active": isActive.value || isDirty.value,
            "dirty": isDirty.value || props.dirty,
            "disabled": isDisabled.value,
            "focused": isFocused.value,
            "error": isValid.value === false
          }), {
            ...slots,
            default: _ref3 => {
              let {
                props: {
                  class: fieldClass,
                  ...slotProps
                }
              } = _ref3;
              const inputNode = withDirectives(createVNode("input", mergeProps({
                "ref": inputRef,
                "value": model.value,
                "onInput": onInput,
                "autofocus": props.autofocus,
                "readonly": isReadonly.value,
                "disabled": isDisabled.value,
                "name": props.name,
                "placeholder": props.placeholder,
                "size": 1,
                "type": props.type,
                "onFocus": onFocus,
                "onBlur": blur
              }, slotProps, inputAttrs), null), [[resolveDirective("intersect"), {
                handler: onIntersect
              }, null, {
                once: true
              }]]);
              return createVNode(Fragment, null, [props.prefix && createVNode("span", {
                "class": "v-text-field__prefix"
              }, [createVNode("span", {
                "class": "v-text-field__prefix__text"
              }, [props.prefix])]), slots.default ? createVNode("div", {
                "class": fieldClass,
                "data-no-activator": ""
              }, [slots.default(), inputNode]) : cloneVNode(inputNode, {
                class: fieldClass
              }), props.suffix && createVNode("span", {
                "class": "v-text-field__suffix"
              }, [createVNode("span", {
                "class": "v-text-field__suffix__text"
              }, [props.suffix])])]);
            }
          });
        },
        details: hasDetails ? slotProps => createVNode(Fragment, null, [slots.details?.(slotProps), hasCounter && createVNode(Fragment, null, [createVNode("span", null, null), createVNode(VCounter, {
          "active": props.persistentCounter || isFocused.value,
          "value": counterValue.value,
          "max": max.value,
          "disabled": props.disabled
        }, slots.counter)])]) : undefined
      });
    });
    return forwardRefs({}, vInputRef, vFieldRef, inputRef);
  }
});

const makeVVirtualScrollItemProps = propsFactory({
  renderless: Boolean,
  ...makeComponentProps()
}, 'VVirtualScrollItem');
const VVirtualScrollItem = genericComponent()({
  name: 'VVirtualScrollItem',
  inheritAttrs: false,
  props: makeVVirtualScrollItemProps(),
  emits: {
    'update:height': height => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const {
      resizeRef,
      contentRect
    } = useResizeObserver(undefined, 'border');
    watch(() => contentRect.value?.height, height => {
      if (height != null) emit('update:height', height);
    });
    useRender(() => props.renderless ? createVNode(Fragment, null, [slots.default?.({
      itemRef: resizeRef
    })]) : createVNode("div", mergeProps({
      "ref": resizeRef,
      "class": ['v-virtual-scroll__item', props.class],
      "style": props.style
    }, attrs), [slots.default?.()]));
  }
});

// Composables
const UP = -1;
const DOWN = 1;

/** Determines how large each batch of items should be */
const BUFFER_PX = 100;
const makeVirtualProps = propsFactory({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, 'virtual');
function useVirtual(props, items) {
  const display = useDisplay();
  const itemHeight = shallowRef(0);
  watchEffect(() => {
    itemHeight.value = parseFloat(props.itemHeight || 0);
  });
  const first = shallowRef(0);
  const last = shallowRef(Math.ceil(
  // Assume 16px items filling the entire screen height if
  // not provided. This is probably incorrect but it minimises
  // the chance of ending up with empty space at the bottom.
  // The default value is set here to avoid poisoning getSize()
  (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)) || 1);
  const paddingTop = shallowRef(0);
  const paddingBottom = shallowRef(0);

  /** The scrollable element */
  const containerRef = ref();
  /** An element marking the top of the scrollable area,
   * used to add an offset if there's padding or other elements above the virtual list */
  const markerRef = ref();
  /** markerRef's offsetTop, lazily evaluated */
  let markerOffset = 0;
  const {
    resizeRef,
    contentRect
  } = useResizeObserver();
  watchEffect(() => {
    resizeRef.value = containerRef.value;
  });
  const viewportHeight = computed(() => {
    return containerRef.value === document.documentElement ? display.height.value : contentRect.value?.height || parseInt(props.height) || 0;
  });
  /** All static elements have been rendered and we have an assumed item height */
  const hasInitialRender = computed(() => {
    return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
  });
  let sizes = Array.from({
    length: items.value.length
  });
  let offsets = Array.from({
    length: items.value.length
  });
  const updateTime = shallowRef(0);
  let targetScrollIndex = -1;
  function getSize(index) {
    return sizes[index] || itemHeight.value;
  }
  const updateOffsets = debounce(() => {
    const start = performance.now();
    offsets[0] = 0;
    const length = items.value.length;
    for (let i = 1; i <= length - 1; i++) {
      offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
    }
    updateTime.value = Math.max(updateTime.value, performance.now() - start);
  }, updateTime);
  const unwatch = watch(hasInitialRender, v => {
    if (!v) return;
    // First render is complete, update offsets and visible
    // items in case our assumed item height was incorrect

    unwatch();
    markerOffset = markerRef.value.offsetTop;
    updateOffsets.immediate();
    calculateVisibleItems();
    if (!~targetScrollIndex) return;
    nextTick(() => {
      IN_BROWSER && window.requestAnimationFrame(() => {
        scrollToIndex(targetScrollIndex);
        targetScrollIndex = -1;
      });
    });
  });
  onScopeDispose(() => {
    updateOffsets.clear();
  });
  function handleItemResize(index, height) {
    const prevHeight = sizes[index];
    const prevMinHeight = itemHeight.value;
    itemHeight.value = prevMinHeight ? Math.min(itemHeight.value, height) : height;
    if (prevHeight !== height || prevMinHeight !== itemHeight.value) {
      sizes[index] = height;
      updateOffsets();
    }
  }
  function calculateOffset(index) {
    index = clamp(index, 0, items.value.length - 1);
    return offsets[index] || 0;
  }
  function calculateIndex(scrollTop) {
    return binaryClosest(offsets, scrollTop);
  }
  let lastScrollTop = 0;
  let scrollVelocity = 0;
  let lastScrollTime = 0;
  watch(viewportHeight, (val, oldVal) => {
    if (oldVal) {
      calculateVisibleItems();
      if (val < oldVal) {
        requestAnimationFrame(() => {
          scrollVelocity = 0;
          calculateVisibleItems();
        });
      }
    }
  });
  let scrollTimeout = -1;
  function handleScroll() {
    if (!containerRef.value || !markerRef.value) return;
    const scrollTop = containerRef.value.scrollTop;
    const scrollTime = performance.now();
    const scrollDeltaT = scrollTime - lastScrollTime;
    if (scrollDeltaT > 500) {
      scrollVelocity = Math.sign(scrollTop - lastScrollTop);

      // Not super important, only update at the
      // start of a scroll sequence to avoid reflows
      markerOffset = markerRef.value.offsetTop;
    } else {
      scrollVelocity = scrollTop - lastScrollTop;
    }
    lastScrollTop = scrollTop;
    lastScrollTime = scrollTime;
    window.clearTimeout(scrollTimeout);
    scrollTimeout = window.setTimeout(handleScrollend, 500);
    calculateVisibleItems();
  }
  function handleScrollend() {
    if (!containerRef.value || !markerRef.value) return;
    scrollVelocity = 0;
    lastScrollTime = 0;
    window.clearTimeout(scrollTimeout);
    calculateVisibleItems();
  }
  let raf = -1;
  function calculateVisibleItems() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(_calculateVisibleItems);
  }
  function _calculateVisibleItems() {
    if (!containerRef.value || !viewportHeight.value) return;
    const scrollTop = lastScrollTop - markerOffset;
    const direction = Math.sign(scrollVelocity);
    const startPx = Math.max(0, scrollTop - BUFFER_PX);
    const start = clamp(calculateIndex(startPx), 0, items.value.length);
    const endPx = scrollTop + viewportHeight.value + BUFFER_PX;
    const end = clamp(calculateIndex(endPx) + 1, start + 1, items.value.length);
    if (
    // Only update the side we're scrolling towards,
    // the other side will be updated incidentally
    (direction !== UP || start < first.value) && (direction !== DOWN || end > last.value)) {
      const topOverflow = calculateOffset(first.value) - calculateOffset(start);
      const bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
      const bufferOverflow = Math.max(topOverflow, bottomOverflow);
      if (bufferOverflow > BUFFER_PX) {
        first.value = start;
        last.value = end;
      } else {
        // Only update the side that's reached its limit if there's still buffer left
        if (start <= 0) first.value = start;
        if (end >= items.value.length) last.value = end;
      }
    }
    paddingTop.value = calculateOffset(first.value);
    paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
  }
  function scrollToIndex(index) {
    const offset = calculateOffset(index);
    if (!containerRef.value || index && !offset) {
      targetScrollIndex = index;
    } else {
      containerRef.value.scrollTop = offset;
    }
  }
  const computedItems = computed(() => {
    return items.value.slice(first.value, last.value).map((item, index) => ({
      raw: item,
      index: index + first.value,
      key: isObject$1(item) && 'value' in item ? item.value : index + first.value
    }));
  });
  watch(items, () => {
    sizes = Array.from({
      length: items.value.length
    });
    offsets = Array.from({
      length: items.value.length
    });
    updateOffsets.immediate();
    calculateVisibleItems();
  }, {
    deep: true
  });
  return {
    calculateVisibleItems,
    containerRef,
    markerRef,
    computedItems,
    paddingTop,
    paddingBottom,
    scrollToIndex,
    handleScroll,
    handleScrollend,
    handleItemResize
  };
}

// https://gist.github.com/robertleeplummerjr/1cc657191d34ecd0a324
function binaryClosest(arr, val) {
  let high = arr.length - 1;
  let low = 0;
  let mid = 0;
  let item = null;
  let target = -1;
  if (arr[high] < val) {
    return high;
  }
  while (low <= high) {
    mid = low + high >> 1;
    item = arr[mid];
    if (item > val) {
      high = mid - 1;
    } else if (item < val) {
      target = mid;
      low = mid + 1;
    } else if (item === val) {
      return mid;
    } else {
      return low;
    }
  }
  return target;
}

const makeVVirtualScrollProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...makeVirtualProps(),
  ...makeComponentProps(),
  ...makeDimensionProps()
}, 'VVirtualScroll');
const VVirtualScroll = genericComponent()({
  name: 'VVirtualScroll',
  props: makeVVirtualScrollProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const vm = getCurrentInstance('VVirtualScroll');
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      calculateVisibleItems,
      containerRef,
      markerRef,
      handleScroll,
      handleScrollend,
      handleItemResize,
      scrollToIndex,
      paddingTop,
      paddingBottom,
      computedItems
    } = useVirtual(props, toRef(props, 'items'));
    useToggleScope(() => props.renderless, () => {
      function handleListeners() {
        let add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        const method = add ? 'addEventListener' : 'removeEventListener';
        if (containerRef.value === document.documentElement) {
          document[method]('scroll', handleScroll, {
            passive: true
          });
          document[method]('scrollend', handleScrollend);
        } else {
          containerRef.value?.[method]('scroll', handleScroll, {
            passive: true
          });
          containerRef.value?.[method]('scrollend', handleScrollend);
        }
      }
      onMounted(() => {
        containerRef.value = getScrollParent(vm.vnode.el, true);
        handleListeners(true);
      });
      onScopeDispose(handleListeners);
    });
    useRender(() => {
      const children = computedItems.value.map(item => createVNode(VVirtualScrollItem, {
        "key": item.key,
        "renderless": props.renderless,
        "onUpdate:height": height => handleItemResize(item.index, height)
      }, {
        default: slotProps => slots.default?.({
          item: item.raw,
          index: item.index,
          ...slotProps
        })
      }));
      return props.renderless ? createVNode(Fragment, null, [createVNode("div", {
        "ref": markerRef,
        "class": "v-virtual-scroll__spacer",
        "style": {
          paddingTop: convertToUnit(paddingTop.value)
        }
      }, null), children, createVNode("div", {
        "class": "v-virtual-scroll__spacer",
        "style": {
          paddingBottom: convertToUnit(paddingBottom.value)
        }
      }, null)]) : createVNode("div", {
        "ref": containerRef,
        "class": ['v-virtual-scroll', props.class],
        "onScrollPassive": handleScroll,
        "onScrollend": handleScrollend,
        "style": [dimensionStyles.value, props.style]
      }, [createVNode("div", {
        "ref": markerRef,
        "class": "v-virtual-scroll__container",
        "style": {
          paddingTop: convertToUnit(paddingTop.value),
          paddingBottom: convertToUnit(paddingBottom.value)
        }
      }, [children])]);
    });
    return {
      calculateVisibleItems,
      scrollToIndex
    };
  }
});

// Utilities

// Types

function useScrolling(listRef, textFieldRef) {
  const isScrolling = shallowRef(false);
  let scrollTimeout;
  function onListScroll(e) {
    cancelAnimationFrame(scrollTimeout);
    isScrolling.value = true;
    scrollTimeout = requestAnimationFrame(() => {
      scrollTimeout = requestAnimationFrame(() => {
        isScrolling.value = false;
      });
    });
  }
  async function finishScrolling() {
    await new Promise(resolve => requestAnimationFrame(resolve));
    await new Promise(resolve => requestAnimationFrame(resolve));
    await new Promise(resolve => requestAnimationFrame(resolve));
    await new Promise(resolve => {
      if (isScrolling.value) {
        const stop = watch(isScrolling, () => {
          stop();
          resolve();
        });
      } else resolve();
    });
  }
  async function onListKeydown(e) {
    if (e.key === 'Tab') {
      textFieldRef.value?.focus();
    }
    if (!['PageDown', 'PageUp', 'Home', 'End'].includes(e.key)) return;
    const el = listRef.value?.$el;
    if (!el) return;
    if (e.key === 'Home' || e.key === 'End') {
      el.scrollTo({
        top: e.key === 'Home' ? 0 : el.scrollHeight,
        behavior: 'smooth'
      });
    }
    await finishScrolling();
    const children = el.querySelectorAll(':scope > :not(.v-virtual-scroll__spacer)');
    if (e.key === 'PageDown' || e.key === 'Home') {
      const top = el.getBoundingClientRect().top;
      for (const child of children) {
        if (child.getBoundingClientRect().top >= top) {
          child.focus();
          break;
        }
      }
    } else {
      const bottom = el.getBoundingClientRect().bottom;
      for (const child of [...children].reverse()) {
        if (child.getBoundingClientRect().bottom <= bottom) {
          child.focus();
          break;
        }
      }
    }
  }
  return {
    onScrollPassive: onListScroll,
    onKeydown: onListKeydown
  }; // typescript doesn't know about vue's event merging
}

const makeSelectProps = propsFactory({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: '$vuetify.close'
  },
  openText: {
    type: String,
    default: '$vuetify.open'
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: IconValue,
    default: '$dropdown'
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: '$vuetify.noDataText'
  },
  openOnClear: Boolean,
  itemColor: String,
  ...makeItemsProps({
    itemChildren: false
  })
}, 'Select');
const makeVSelectProps = propsFactory({
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: 'combobox'
  }), ['validationValue', 'dirty', 'appendInnerIcon']),
  ...makeTransitionProps({
    transition: {
      component: VDialogTransition
    }
  })
}, 'VSelect');
const VSelect = genericComponent()({
  name: 'VSelect',
  props: makeVSelectProps(),
  emits: {
    'update:focused': focused => true,
    'update:modelValue': value => true,
    'update:menu': ue => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const vTextFieldRef = ref();
    const vMenuRef = ref();
    const vVirtualScrollRef = ref();
    const _menu = useProxiedModel(props, 'menu');
    const menu = computed({
      get: () => _menu.value,
      set: v => {
        if (_menu.value && !v && vMenuRef.value?.ΨopenChildren.size) return;
        _menu.value = v;
      }
    });
    const {
      items,
      transformIn,
      transformOut
    } = useItems(props);
    const model = useProxiedModel(props, 'modelValue', [], v => transformIn(v === null ? [null] : wrapInArray(v)), v => {
      const transformed = transformOut(v);
      return props.multiple ? transformed : transformed[0] ?? null;
    });
    const counterValue = computed(() => {
      return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
    });
    const form = useForm(props);
    const selectedValues = computed(() => model.value.map(selection => selection.value));
    const isFocused = shallowRef(false);
    const label = computed(() => menu.value ? props.closeText : props.openText);
    let keyboardLookupPrefix = '';
    let keyboardLookupLastTime;
    const displayItems = computed(() => {
      if (props.hideSelected) {
        return items.value.filter(item => !model.value.some(s => props.valueComparator(s, item)));
      }
      return items.value;
    });
    const menuDisabled = computed(() => props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
    const computedMenuProps = computed(() => {
      return {
        ...props.menuProps,
        activatorProps: {
          ...(props.menuProps?.activatorProps || {}),
          'aria-haspopup': 'listbox' // Set aria-haspopup to 'listbox'
        }
      };
    });
    const listRef = ref();
    const listEvents = useScrolling(listRef, vTextFieldRef);
    function onClear(e) {
      if (props.openOnClear) {
        menu.value = true;
      }
    }
    function onMousedownControl() {
      if (menuDisabled.value) return;
      menu.value = !menu.value;
    }
    function onListKeydown(e) {
      if (checkPrintable(e)) {
        onKeydown(e);
      }
    }
    function onKeydown(e) {
      if (!e.key || form.isReadonly.value) return;
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) {
        e.preventDefault();
      }
      if (['Enter', 'ArrowDown', ' '].includes(e.key)) {
        menu.value = true;
      }
      if (['Escape', 'Tab'].includes(e.key)) {
        menu.value = false;
      }
      if (e.key === 'Home') {
        listRef.value?.focus('first');
      } else if (e.key === 'End') {
        listRef.value?.focus('last');
      }

      // html select hotkeys
      const KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds

      if (props.multiple || !checkPrintable(e)) return;
      const now = performance.now();
      if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
        keyboardLookupPrefix = '';
      }
      keyboardLookupPrefix += e.key.toLowerCase();
      keyboardLookupLastTime = now;
      const item = items.value.find(item => item.title.toLowerCase().startsWith(keyboardLookupPrefix));
      if (item !== undefined) {
        model.value = [item];
        const index = displayItems.value.indexOf(item);
        IN_BROWSER && window.requestAnimationFrame(() => {
          index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
        });
      }
    }

    /** @param set - null means toggle */
    function select(item) {
      let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (item.props.disabled) return;
      if (props.multiple) {
        const index = model.value.findIndex(selection => props.valueComparator(selection.value, item.value));
        const add = set == null ? !~index : set;
        if (~index) {
          const value = add ? [...model.value, item] : [...model.value];
          value.splice(index, 1);
          model.value = value;
        } else if (add) {
          model.value = [...model.value, item];
        }
      } else {
        const add = set !== false;
        model.value = add ? [item] : [];
        nextTick(() => {
          menu.value = false;
        });
      }
    }
    function onBlur(e) {
      if (!listRef.value?.$el.contains(e.relatedTarget)) {
        menu.value = false;
      }
    }
    function onAfterEnter() {
      if (props.eager) {
        vVirtualScrollRef.value?.calculateVisibleItems();
      }
    }
    function onAfterLeave() {
      if (isFocused.value) {
        vTextFieldRef.value?.focus();
      }
    }
    function onFocusin(e) {
      isFocused.value = true;
    }
    function onModelUpdate(v) {
      if (v == null) model.value = [];else if (matchesSelector(vTextFieldRef.value, ':autofill') || matchesSelector(vTextFieldRef.value, ':-webkit-autofill')) {
        const item = items.value.find(item => item.title === v);
        if (item) {
          select(item);
        }
      } else if (vTextFieldRef.value) {
        vTextFieldRef.value.value = '';
      }
    }
    watch(menu, () => {
      if (!props.hideSelected && menu.value && model.value.length) {
        const index = displayItems.value.findIndex(item => model.value.some(s => props.valueComparator(s.value, item.value)));
        IN_BROWSER && window.requestAnimationFrame(() => {
          index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
        });
      }
    });
    watch(() => props.items, (newVal, oldVal) => {
      if (menu.value) return;
      if (isFocused.value && !oldVal.length && newVal.length) {
        menu.value = true;
      }
    });
    useRender(() => {
      const hasChips = !!(props.chips || slots.chip);
      const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
      const isDirty = model.value.length > 0;
      const textFieldProps = VTextField.filterProps(props);
      const placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? undefined : props.placeholder;
      return createVNode(VTextField, mergeProps({
        "ref": vTextFieldRef
      }, textFieldProps, {
        "modelValue": model.value.map(v => v.props.value).join(', '),
        "onUpdate:modelValue": onModelUpdate,
        "focused": isFocused.value,
        "onUpdate:focused": $event => isFocused.value = $event,
        "validationValue": model.externalValue,
        "counterValue": counterValue.value,
        "dirty": isDirty,
        "class": ['v-select', {
          'v-select--active-menu': menu.value,
          'v-select--chips': !!props.chips,
          [`v-select--${props.multiple ? 'multiple' : 'single'}`]: true,
          'v-select--selected': model.value.length,
          'v-select--selection-slot': !!slots.selection
        }, props.class],
        "style": props.style,
        "inputmode": "none",
        "placeholder": placeholder,
        "onClick:clear": onClear,
        "onMousedown:control": onMousedownControl,
        "onBlur": onBlur,
        "onKeydown": onKeydown,
        "aria-label": t(label.value),
        "title": t(label.value)
      }), {
        ...slots,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          "ref": vMenuRef,
          "modelValue": menu.value,
          "onUpdate:modelValue": $event => menu.value = $event,
          "activator": "parent",
          "contentClass": "v-select__content",
          "disabled": menuDisabled.value,
          "eager": props.eager,
          "maxHeight": 310,
          "openOnClick": false,
          "closeOnContentClick": false,
          "transition": props.transition,
          "onAfterEnter": onAfterEnter,
          "onAfterLeave": onAfterLeave
        }, computedMenuProps.value), {
          default: () => [hasList && createVNode(VList, mergeProps({
            "ref": listRef,
            "selected": selectedValues.value,
            "selectStrategy": props.multiple ? 'independent' : 'single-independent',
            "onMousedown": e => e.preventDefault(),
            "onKeydown": onListKeydown,
            "onFocusin": onFocusin,
            "tabindex": "-1",
            "aria-live": "polite",
            "color": props.itemColor ?? props.color
          }, listEvents, props.listProps), {
            default: () => [slots['prepend-item']?.(), !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? createVNode(VListItem, {
              "key": "no-data",
              "title": t(props.noDataText)
            }, null)), createVNode(VVirtualScroll, {
              "ref": vVirtualScrollRef,
              "renderless": true,
              "items": displayItems.value
            }, {
              default: _ref2 => {
                let {
                  item,
                  index,
                  itemRef
                } = _ref2;
                const itemProps = mergeProps(item.props, {
                  ref: itemRef,
                  key: item.value,
                  onClick: () => select(item, null)
                });
                return slots.item?.({
                  item,
                  index,
                  props: itemProps
                }) ?? createVNode(VListItem, mergeProps(itemProps, {
                  "role": "option"
                }), {
                  prepend: _ref3 => {
                    let {
                      isSelected
                    } = _ref3;
                    return createVNode(Fragment, null, [props.multiple && !props.hideSelected ? createVNode(VCheckboxBtn, {
                      "key": item.value,
                      "modelValue": isSelected,
                      "ripple": false,
                      "tabindex": "-1"
                    }, null) : undefined, item.props.prependAvatar && createVNode(VAvatar, {
                      "image": item.props.prependAvatar
                    }, null), item.props.prependIcon && createVNode(VIcon, {
                      "icon": item.props.prependIcon
                    }, null)]);
                  }
                });
              }
            }), slots['append-item']?.()]
          })]
        }), model.value.map((item, index) => {
          function onChipClose(e) {
            e.stopPropagation();
            e.preventDefault();
            select(item, false);
          }
          const slotProps = {
            'onClick:close': onChipClose,
            onKeydown(e) {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              e.preventDefault();
              e.stopPropagation();
              onChipClose(e);
            },
            onMousedown(e) {
              e.preventDefault();
              e.stopPropagation();
            },
            modelValue: true,
            'onUpdate:modelValue': undefined
          };
          const hasSlot = hasChips ? !!slots.chip : !!slots.selection;
          const slotContent = hasSlot ? ensureValidVNode(hasChips ? slots.chip({
            item,
            index,
            props: slotProps
          }) : slots.selection({
            item,
            index
          })) : undefined;
          if (hasSlot && !slotContent) return undefined;
          return createVNode("div", {
            "key": item.value,
            "class": "v-select__selection"
          }, [hasChips ? !slots.chip ? createVNode(VChip, mergeProps({
            "key": "chip",
            "closable": props.closableChips,
            "size": "small",
            "text": item.title,
            "disabled": item.props.disabled
          }, slotProps), null) : createVNode(VDefaultsProvider, {
            "key": "chip-defaults",
            "defaults": {
              VChip: {
                closable: props.closableChips,
                size: 'small',
                text: item.title
              }
            }
          }, {
            default: () => [slotContent]
          }) : slotContent ?? createVNode("span", {
            "class": "v-select__selection-text"
          }, [item.title, props.multiple && index < model.value.length - 1 && createVNode("span", {
            "class": "v-select__selection-comma"
          }, [createTextVNode(",")])])]);
        })]),
        'append-inner': function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(Fragment, null, [slots['append-inner']?.(...args), props.menuIcon ? createVNode(VIcon, {
            "class": "v-select__menu-icon",
            "icon": props.menuIcon
          }, null) : undefined]);
        }
      });
    });
    return forwardRefs({
      isFocused,
      menu,
      select
    }, vTextFieldRef);
  }
});

/* eslint-disable max-statements */
/* eslint-disable no-labels */

/**
 * - match without highlight
 * - single match (index), length already known
 * - single match (start, end)
 * - multiple matches (start, end), probably shouldn't overlap
 */
// Composables
const defaultFilter = (value, query, item) => {
  if (value == null || query == null) return -1;
  return value.toString().toLocaleLowerCase().indexOf(query.toString().toLocaleLowerCase());
};
const makeFilterProps = propsFactory({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: 'intersection'
  },
  noFilter: Boolean
}, 'filter');
function filterItems(items, query, options) {
  const array = [];
  // always ensure we fall back to a functioning filter
  const filter = options?.default ?? defaultFilter;
  const keys = options?.filterKeys ? wrapInArray(options.filterKeys) : false;
  const customFiltersLength = Object.keys(options?.customKeyFilter ?? {}).length;
  if (!items?.length) return array;
  loop: for (let i = 0; i < items.length; i++) {
    const [item, transformed = item] = wrapInArray(items[i]);
    const customMatches = {};
    const defaultMatches = {};
    let match = -1;
    if ((query || customFiltersLength > 0) && !options?.noFilter) {
      if (typeof item === 'object') {
        const filterKeys = keys || Object.keys(transformed);
        for (const key of filterKeys) {
          const value = getPropertyFromItem(transformed, key);
          const keyFilter = options?.customKeyFilter?.[key];
          match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
          if (match !== -1 && match !== false) {
            if (keyFilter) customMatches[key] = match;else defaultMatches[key] = match;
          } else if (options?.filterMode === 'every') {
            continue loop;
          }
        }
      } else {
        match = filter(item, query, item);
        if (match !== -1 && match !== false) {
          defaultMatches.title = match;
        }
      }
      const defaultMatchesLength = Object.keys(defaultMatches).length;
      const customMatchesLength = Object.keys(customMatches).length;
      if (!defaultMatchesLength && !customMatchesLength) continue;
      if (options?.filterMode === 'union' && customMatchesLength !== customFiltersLength && !defaultMatchesLength) continue;
      if (options?.filterMode === 'intersection' && (customMatchesLength !== customFiltersLength || !defaultMatchesLength)) continue;
    }
    array.push({
      index: i,
      matches: {
        ...defaultMatches,
        ...customMatches
      }
    });
  }
  return array;
}
function useFilter(props, items, query, options) {
  const filteredItems = ref([]);
  const filteredMatches = ref(new Map());
  const transformedItems = computed(() => options?.transform ? unref(items).map(item => [item, options.transform(item)]) : unref(items));
  watchEffect(() => {
    const _query = typeof query === 'function' ? query() : unref(query);
    const strQuery = typeof _query !== 'string' && typeof _query !== 'number' ? '' : String(_query);
    const results = filterItems(transformedItems.value, strQuery, {
      customKeyFilter: {
        ...props.customKeyFilter,
        ...unref(options?.customKeyFilter)
      },
      default: props.customFilter,
      filterKeys: props.filterKeys,
      filterMode: props.filterMode,
      noFilter: props.noFilter
    });
    const originalItems = unref(items);
    const _filteredItems = [];
    const _filteredMatches = new Map();
    results.forEach(_ref => {
      let {
        index,
        matches
      } = _ref;
      const item = originalItems[index];
      _filteredItems.push(item);
      _filteredMatches.set(item.value, matches);
    });
    filteredItems.value = _filteredItems;
    filteredMatches.value = _filteredMatches;
  });
  function getMatches(item) {
    return filteredMatches.value.get(item.value);
  }
  return {
    filteredItems,
    filteredMatches,
    getMatches
  };
}

function highlightResult$1(text, matches, length) {
  if (matches == null) return text;
  if (Array.isArray(matches)) throw new Error('Multiple matches is not implemented');
  return typeof matches === 'number' && ~matches ? createVNode(Fragment, null, [createVNode("span", {
    "class": "v-autocomplete__unmask"
  }, [text.substr(0, matches)]), createVNode("span", {
    "class": "v-autocomplete__mask"
  }, [text.substr(matches, length)]), createVNode("span", {
    "class": "v-autocomplete__unmask"
  }, [text.substr(matches + length)])]) : text;
}
const makeVAutocompleteProps = propsFactory({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: Boolean,
  search: String,
  ...makeFilterProps({
    filterKeys: ['title']
  }),
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: 'combobox'
  }), ['validationValue', 'dirty', 'appendInnerIcon']),
  ...makeTransitionProps({
    transition: false
  })
}, 'VAutocomplete');
const VAutocomplete = genericComponent()({
  name: 'VAutocomplete',
  props: makeVAutocompleteProps(),
  emits: {
    'update:focused': focused => true,
    'update:search': value => true,
    'update:modelValue': value => true,
    'update:menu': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const vTextFieldRef = ref();
    const isFocused = shallowRef(false);
    const isPristine = shallowRef(true);
    const listHasFocus = shallowRef(false);
    const vMenuRef = ref();
    const vVirtualScrollRef = ref();
    const _menu = useProxiedModel(props, 'menu');
    const menu = computed({
      get: () => _menu.value,
      set: v => {
        if (_menu.value && !v && vMenuRef.value?.ΨopenChildren.size) return;
        _menu.value = v;
      }
    });
    const selectionIndex = shallowRef(-1);
    const color = computed(() => vTextFieldRef.value?.color);
    const label = computed(() => menu.value ? props.closeText : props.openText);
    const {
      items,
      transformIn,
      transformOut
    } = useItems(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(color);
    const search = useProxiedModel(props, 'search', '');
    const model = useProxiedModel(props, 'modelValue', [], v => transformIn(v === null ? [null] : wrapInArray(v)), v => {
      const transformed = transformOut(v);
      return props.multiple ? transformed : transformed[0] ?? null;
    });
    const counterValue = computed(() => {
      return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
    });
    const form = useForm(props);
    const {
      filteredItems,
      getMatches
    } = useFilter(props, items, () => isPristine.value ? '' : search.value);
    const displayItems = computed(() => {
      if (props.hideSelected) {
        return filteredItems.value.filter(filteredItem => !model.value.some(s => s.value === filteredItem.value));
      }
      return filteredItems.value;
    });
    const hasChips = computed(() => !!(props.chips || slots.chip));
    const hasSelectionSlot = computed(() => hasChips.value || !!slots.selection);
    const selectedValues = computed(() => model.value.map(selection => selection.props.value));
    const highlightFirst = computed(() => {
      const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === displayItems.value[0]?.title;
      return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
    });
    const menuDisabled = computed(() => props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
    const listRef = ref();
    const listEvents = useScrolling(listRef, vTextFieldRef);
    function onClear(e) {
      if (props.openOnClear) {
        menu.value = true;
      }
      search.value = '';
    }
    function onMousedownControl() {
      if (menuDisabled.value) return;
      menu.value = true;
    }
    function onMousedownMenuIcon(e) {
      if (menuDisabled.value) return;
      if (isFocused.value) {
        e.preventDefault();
        e.stopPropagation();
      }
      menu.value = !menu.value;
    }
    function onListKeydown(e) {
      if (checkPrintable(e)) {
        vTextFieldRef.value?.focus();
      }
    }
    function onKeydown(e) {
      if (form.isReadonly.value) return;
      const selectionStart = vTextFieldRef.value.selectionStart;
      const length = model.value.length;
      if (selectionIndex.value > -1 || ['Enter', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
        e.preventDefault();
      }
      if (['Enter', 'ArrowDown'].includes(e.key)) {
        menu.value = true;
      }
      if (['Escape'].includes(e.key)) {
        menu.value = false;
      }
      if (highlightFirst.value && ['Enter', 'Tab'].includes(e.key) && !model.value.some(_ref2 => {
        let {
          value
        } = _ref2;
        return value === displayItems.value[0].value;
      })) {
        select(displayItems.value[0]);
      }
      if (e.key === 'ArrowDown' && highlightFirst.value) {
        listRef.value?.focus('next');
      }
      if (['Backspace', 'Delete'].includes(e.key)) {
        if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
        if (~selectionIndex.value) {
          const originalSelectionIndex = selectionIndex.value;
          select(model.value[selectionIndex.value], false);
          selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
        } else if (e.key === 'Backspace' && !search.value) {
          selectionIndex.value = length - 1;
        }
      }
      if (!props.multiple) return;
      if (e.key === 'ArrowLeft') {
        if (selectionIndex.value < 0 && selectionStart > 0) return;
        const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
        if (model.value[prev]) {
          selectionIndex.value = prev;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange(search.value?.length, search.value?.length);
        }
      }
      if (e.key === 'ArrowRight') {
        if (selectionIndex.value < 0) return;
        const next = selectionIndex.value + 1;
        if (model.value[next]) {
          selectionIndex.value = next;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange(0, 0);
        }
      }
    }
    function onChange(e) {
      if (matchesSelector(vTextFieldRef.value, ':autofill') || matchesSelector(vTextFieldRef.value, ':-webkit-autofill')) {
        const item = items.value.find(item => item.title === e.target.value);
        if (item) {
          select(item);
        }
      }
    }
    function onAfterEnter() {
      if (props.eager) {
        vVirtualScrollRef.value?.calculateVisibleItems();
      }
    }
    function onAfterLeave() {
      if (isFocused.value) {
        isPristine.value = true;
        vTextFieldRef.value?.focus();
      }
    }
    function onFocusin(e) {
      isFocused.value = true;
      setTimeout(() => {
        listHasFocus.value = true;
      });
    }
    function onFocusout(e) {
      listHasFocus.value = false;
    }
    function onUpdateModelValue(v) {
      if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
    }
    const isSelecting = shallowRef(false);

    /** @param set - null means toggle */
    function select(item) {
      let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!item || item.props.disabled) return;
      if (props.multiple) {
        const index = model.value.findIndex(selection => props.valueComparator(selection.value, item.value));
        const add = set == null ? !~index : set;
        if (~index) {
          const value = add ? [...model.value, item] : [...model.value];
          value.splice(index, 1);
          model.value = value;
        } else if (add) {
          model.value = [...model.value, item];
        }
        if (props.clearOnSelect) {
          search.value = '';
        }
      } else {
        const add = set !== false;
        model.value = add ? [item] : [];
        search.value = add && !hasSelectionSlot.value ? item.title : '';

        // watch for search watcher to trigger
        nextTick(() => {
          menu.value = false;
          isPristine.value = true;
        });
      }
    }
    watch(isFocused, (val, oldVal) => {
      if (val === oldVal) return;
      if (val) {
        isSelecting.value = true;
        search.value = props.multiple || hasSelectionSlot.value ? '' : String(model.value.at(-1)?.props.title ?? '');
        isPristine.value = true;
        nextTick(() => isSelecting.value = false);
      } else {
        if (!props.multiple && search.value == null) model.value = [];
        menu.value = false;
        if (!model.value.some(_ref3 => {
          let {
            title
          } = _ref3;
          return title === search.value;
        })) search.value = '';
        selectionIndex.value = -1;
      }
    });
    watch(search, val => {
      if (!isFocused.value || isSelecting.value) return;
      if (val) menu.value = true;
      isPristine.value = !val;
    });
    watch(menu, () => {
      if (!props.hideSelected && menu.value && model.value.length) {
        const index = displayItems.value.findIndex(item => model.value.some(s => item.value === s.value));
        IN_BROWSER && window.requestAnimationFrame(() => {
          index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
        });
      }
    });
    watch(() => props.items, (newVal, oldVal) => {
      if (menu.value) return;
      if (isFocused.value && !oldVal.length && newVal.length) {
        menu.value = true;
      }
    });
    useRender(() => {
      const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
      const isDirty = model.value.length > 0;
      const textFieldProps = VTextField.filterProps(props);
      return createVNode(VTextField, mergeProps({
        "ref": vTextFieldRef
      }, textFieldProps, {
        "modelValue": search.value,
        "onUpdate:modelValue": [$event => search.value = $event, onUpdateModelValue],
        "focused": isFocused.value,
        "onUpdate:focused": $event => isFocused.value = $event,
        "validationValue": model.externalValue,
        "counterValue": counterValue.value,
        "dirty": isDirty,
        "onChange": onChange,
        "class": ['v-autocomplete', `v-autocomplete--${props.multiple ? 'multiple' : 'single'}`, {
          'v-autocomplete--active-menu': menu.value,
          'v-autocomplete--chips': !!props.chips,
          'v-autocomplete--selection-slot': !!hasSelectionSlot.value,
          'v-autocomplete--selecting-index': selectionIndex.value > -1
        }, props.class],
        "style": props.style,
        "readonly": form.isReadonly.value,
        "placeholder": isDirty ? undefined : props.placeholder,
        "onClick:clear": onClear,
        "onMousedown:control": onMousedownControl,
        "onKeydown": onKeydown
      }), {
        ...slots,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          "ref": vMenuRef,
          "modelValue": menu.value,
          "onUpdate:modelValue": $event => menu.value = $event,
          "activator": "parent",
          "contentClass": "v-autocomplete__content",
          "disabled": menuDisabled.value,
          "eager": props.eager,
          "maxHeight": 310,
          "openOnClick": false,
          "closeOnContentClick": false,
          "transition": props.transition,
          "onAfterEnter": onAfterEnter,
          "onAfterLeave": onAfterLeave
        }, props.menuProps), {
          default: () => [hasList && createVNode(VList, mergeProps({
            "ref": listRef,
            "selected": selectedValues.value,
            "selectStrategy": props.multiple ? 'independent' : 'single-independent',
            "onMousedown": e => e.preventDefault(),
            "onKeydown": onListKeydown,
            "onFocusin": onFocusin,
            "onFocusout": onFocusout,
            "tabindex": "-1",
            "aria-live": "polite",
            "color": props.itemColor ?? props.color
          }, listEvents, props.listProps), {
            default: () => [slots['prepend-item']?.(), !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? createVNode(VListItem, {
              "key": "no-data",
              "title": t(props.noDataText)
            }, null)), createVNode(VVirtualScroll, {
              "ref": vVirtualScrollRef,
              "renderless": true,
              "items": displayItems.value
            }, {
              default: _ref4 => {
                let {
                  item,
                  index,
                  itemRef
                } = _ref4;
                const itemProps = mergeProps(item.props, {
                  ref: itemRef,
                  key: item.value,
                  active: highlightFirst.value && index === 0 ? true : undefined,
                  onClick: () => select(item, null)
                });
                return slots.item?.({
                  item,
                  index,
                  props: itemProps
                }) ?? createVNode(VListItem, mergeProps(itemProps, {
                  "role": "option"
                }), {
                  prepend: _ref5 => {
                    let {
                      isSelected
                    } = _ref5;
                    return createVNode(Fragment, null, [props.multiple && !props.hideSelected ? createVNode(VCheckboxBtn, {
                      "key": item.value,
                      "modelValue": isSelected,
                      "ripple": false,
                      "tabindex": "-1"
                    }, null) : undefined, item.props.prependAvatar && createVNode(VAvatar, {
                      "image": item.props.prependAvatar
                    }, null), item.props.prependIcon && createVNode(VIcon, {
                      "icon": item.props.prependIcon
                    }, null)]);
                  },
                  title: () => {
                    return isPristine.value ? item.title : highlightResult$1(item.title, getMatches(item)?.title, search.value?.length ?? 0);
                  }
                });
              }
            }), slots['append-item']?.()]
          })]
        }), model.value.map((item, index) => {
          function onChipClose(e) {
            e.stopPropagation();
            e.preventDefault();
            select(item, false);
          }
          const slotProps = {
            'onClick:close': onChipClose,
            onKeydown(e) {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              e.preventDefault();
              e.stopPropagation();
              onChipClose(e);
            },
            onMousedown(e) {
              e.preventDefault();
              e.stopPropagation();
            },
            modelValue: true,
            'onUpdate:modelValue': undefined
          };
          const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
          const slotContent = hasSlot ? ensureValidVNode(hasChips.value ? slots.chip({
            item,
            index,
            props: slotProps
          }) : slots.selection({
            item,
            index
          })) : undefined;
          if (hasSlot && !slotContent) return undefined;
          return createVNode("div", {
            "key": item.value,
            "class": ['v-autocomplete__selection', index === selectionIndex.value && ['v-autocomplete__selection--selected', textColorClasses.value]],
            "style": index === selectionIndex.value ? textColorStyles.value : {}
          }, [hasChips.value ? !slots.chip ? createVNode(VChip, mergeProps({
            "key": "chip",
            "closable": props.closableChips,
            "size": "small",
            "text": item.title,
            "disabled": item.props.disabled
          }, slotProps), null) : createVNode(VDefaultsProvider, {
            "key": "chip-defaults",
            "defaults": {
              VChip: {
                closable: props.closableChips,
                size: 'small',
                text: item.title
              }
            }
          }, {
            default: () => [slotContent]
          }) : slotContent ?? createVNode("span", {
            "class": "v-autocomplete__selection-text"
          }, [item.title, props.multiple && index < model.value.length - 1 && createVNode("span", {
            "class": "v-autocomplete__selection-comma"
          }, [createTextVNode(",")])])]);
        })]),
        'append-inner': function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(Fragment, null, [slots['append-inner']?.(...args), props.menuIcon ? createVNode(VIcon, {
            "class": "v-autocomplete__menu-icon",
            "icon": props.menuIcon,
            "onMousedown": onMousedownMenuIcon,
            "onClick": noop,
            "aria-label": t(label.value),
            "title": t(label.value),
            "tabindex": "-1"
          }, null) : undefined]);
        }
      });
    });
    return forwardRefs({
      isFocused,
      isPristine,
      menu,
      search,
      filteredItems,
      select
    }, vTextFieldRef);
  }
});

const makeVBadgeProps = propsFactory({
  bordered: Boolean,
  color: String,
  content: [Number, String],
  dot: Boolean,
  floating: Boolean,
  icon: IconValue,
  inline: Boolean,
  label: {
    type: String,
    default: '$vuetify.badge'
  },
  max: [Number, String],
  modelValue: {
    type: Boolean,
    default: true
  },
  offsetX: [Number, String],
  offsetY: [Number, String],
  textColor: String,
  ...makeComponentProps(),
  ...makeLocationProps({
    location: 'top end'
  }),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeTransitionProps({
    transition: 'scale-rotate-transition'
  })
}, 'VBadge');
const VBadge = genericComponent()({
  name: 'VBadge',
  inheritAttrs: false,
  props: makeVBadgeProps(),
  setup(props, ctx) {
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      roundedClasses
    } = useRounded(props);
    const {
      t
    } = useLocale();
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'textColor'));
    const {
      themeClasses
    } = useTheme();
    const {
      locationStyles
    } = useLocation(props, true, side => {
      const base = props.floating ? props.dot ? 2 : 4 : props.dot ? 8 : 12;
      return base + (['top', 'bottom'].includes(side) ? +(props.offsetY ?? 0) : ['left', 'right'].includes(side) ? +(props.offsetX ?? 0) : 0);
    });
    useRender(() => {
      const value = Number(props.content);
      const content = !props.max || isNaN(value) ? props.content : value <= +props.max ? value : `${props.max}+`;
      const [badgeAttrs, attrs] = pickWithRest(ctx.attrs, ['aria-atomic', 'aria-label', 'aria-live', 'role', 'title']);
      return createVNode(props.tag, mergeProps({
        "class": ['v-badge', {
          'v-badge--bordered': props.bordered,
          'v-badge--dot': props.dot,
          'v-badge--floating': props.floating,
          'v-badge--inline': props.inline
        }, props.class]
      }, attrs, {
        "style": props.style
      }), {
        default: () => [createVNode("div", {
          "class": "v-badge__wrapper"
        }, [ctx.slots.default?.(), createVNode(MaybeTransition, {
          "transition": props.transition
        }, {
          default: () => [withDirectives(createVNode("span", mergeProps({
            "class": ['v-badge__badge', themeClasses.value, backgroundColorClasses.value, roundedClasses.value, textColorClasses.value],
            "style": [backgroundColorStyles.value, textColorStyles.value, props.inline ? {} : locationStyles.value],
            "aria-atomic": "true",
            "aria-label": t(props.label, value),
            "aria-live": "polite",
            "role": "status"
          }, badgeAttrs), [props.dot ? undefined : ctx.slots.badge ? ctx.slots.badge?.() : props.icon ? createVNode(VIcon, {
            "icon": props.icon
          }, null) : content]), [[vShow, props.modelValue]])]
        })])]
      });
    });
    return {};
  }
});

const makeVBottomNavigationProps = propsFactory({
  baseColor: String,
  bgColor: String,
  color: String,
  grow: Boolean,
  mode: {
    type: String,
    validator: v => !v || ['horizontal', 'shift'].includes(v)
  },
  height: {
    type: [Number, String],
    default: 56
  },
  active: {
    type: Boolean,
    default: true
  },
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeLayoutItemProps({
    name: 'bottom-navigation'
  }),
  ...makeTagProps({
    tag: 'header'
  }),
  ...makeGroupProps({
    selectedClass: 'v-btn--selected'
  }),
  ...makeThemeProps()
}, 'VBottomNavigation');
const VBottomNavigation = genericComponent()({
  name: 'VBottomNavigation',
  props: makeVBottomNavigationProps(),
  emits: {
    'update:active': value => true,
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = useTheme();
    const {
      borderClasses
    } = useBorder(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'bgColor'));
    const {
      densityClasses
    } = useDensity(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    const {
      ssrBootStyles
    } = useSsrBoot();
    const height = computed(() => Number(props.height) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0));
    const isActive = useProxiedModel(props, 'active', props.active);
    const {
      layoutItemStyles
    } = useLayoutItem({
      id: props.name,
      order: computed(() => parseInt(props.order, 10)),
      position: computed(() => 'bottom'),
      layoutSize: computed(() => isActive.value ? height.value : 0),
      elementSize: height,
      active: isActive,
      absolute: toRef(props, 'absolute')
    });
    useGroup(props, VBtnToggleSymbol);
    provideDefaults({
      VBtn: {
        baseColor: toRef(props, 'baseColor'),
        color: toRef(props, 'color'),
        density: toRef(props, 'density'),
        stacked: computed(() => props.mode !== 'horizontal'),
        variant: 'text'
      }
    }, {
      scoped: true
    });
    useRender(() => {
      return createVNode(props.tag, {
        "class": ['v-bottom-navigation', {
          'v-bottom-navigation--active': isActive.value,
          'v-bottom-navigation--grow': props.grow,
          'v-bottom-navigation--shift': props.mode === 'shift'
        }, themeClasses.value, backgroundColorClasses.value, borderClasses.value, densityClasses.value, elevationClasses.value, roundedClasses.value, props.class],
        "style": [backgroundColorStyles.value, layoutItemStyles.value, {
          height: convertToUnit(height.value)
        }, ssrBootStyles.value, props.style]
      }, {
        default: () => [slots.default && createVNode("div", {
          "class": "v-bottom-navigation__content"
        }, [slots.default()])]
      });
    });
    return {};
  }
});

const makeVDialogProps = propsFactory({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: true
  },
  scrollable: Boolean,
  ...makeVOverlayProps({
    origin: 'center center',
    scrollStrategy: 'block',
    transition: {
      component: VDialogTransition
    },
    zIndex: 2400
  })
}, 'VDialog');
const VDialog = genericComponent()({
  name: 'VDialog',
  props: makeVDialogProps(),
  emits: {
    'update:modelValue': value => true,
    afterEnter: () => true,
    afterLeave: () => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const isActive = useProxiedModel(props, 'modelValue');
    const {
      scopeId
    } = useScopeId();
    const overlay = ref();
    function onFocusin(e) {
      const before = e.relatedTarget;
      const after = e.target;
      if (before !== after && overlay.value?.contentEl &&
      // We're the topmost dialog
      overlay.value?.globalTop &&
      // It isn't the document or the dialog body
      ![document, overlay.value.contentEl].includes(after) &&
      // It isn't inside the dialog body
      !overlay.value.contentEl.contains(after)) {
        const focusable = focusableChildren(overlay.value.contentEl);
        if (!focusable.length) return;
        const firstElement = focusable[0];
        const lastElement = focusable[focusable.length - 1];
        if (before === firstElement) {
          lastElement.focus();
        } else {
          firstElement.focus();
        }
      }
    }
    onBeforeUnmount(() => {
      document.removeEventListener('focusin', onFocusin);
    });
    if (IN_BROWSER) {
      watch(() => isActive.value && props.retainFocus, val => {
        val ? document.addEventListener('focusin', onFocusin) : document.removeEventListener('focusin', onFocusin);
      }, {
        immediate: true
      });
    }
    function onAfterEnter() {
      emit('afterEnter');
      if (overlay.value?.contentEl && !overlay.value.contentEl.contains(document.activeElement)) {
        overlay.value.contentEl.focus({
          preventScroll: true
        });
      }
    }
    function onAfterLeave() {
      emit('afterLeave');
    }
    watch(isActive, async val => {
      if (!val) {
        await nextTick();
        overlay.value.activatorEl?.focus({
          preventScroll: true
        });
      }
    });
    useRender(() => {
      const overlayProps = VOverlay.filterProps(props);
      const activatorProps = mergeProps({
        'aria-haspopup': 'dialog'
      }, props.activatorProps);
      const contentProps = mergeProps({
        tabindex: -1
      }, props.contentProps);
      return createVNode(VOverlay, mergeProps({
        "ref": overlay,
        "class": ['v-dialog', {
          'v-dialog--fullscreen': props.fullscreen,
          'v-dialog--scrollable': props.scrollable
        }, props.class],
        "style": props.style
      }, overlayProps, {
        "modelValue": isActive.value,
        "onUpdate:modelValue": $event => isActive.value = $event,
        "aria-modal": "true",
        "activatorProps": activatorProps,
        "contentProps": contentProps,
        "height": !props.fullscreen ? props.height : undefined,
        "width": !props.fullscreen ? props.width : undefined,
        "maxHeight": !props.fullscreen ? props.maxHeight : undefined,
        "maxWidth": !props.fullscreen ? props.maxWidth : undefined,
        "role": "dialog",
        "onAfterEnter": onAfterEnter,
        "onAfterLeave": onAfterLeave
      }, scopeId), {
        activator: slots.activator,
        default: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(VDefaultsProvider, {
            "root": "VDialog"
          }, {
            default: () => [slots.default?.(...args)]
          });
        }
      });
    });
    return forwardRefs({}, overlay);
  }
});

const VCardActions = genericComponent()({
  name: 'VCardActions',
  props: makeComponentProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    provideDefaults({
      VBtn: {
        slim: true,
        variant: 'text'
      }
    });
    useRender(() => createVNode("div", {
      "class": ['v-card-actions', props.class],
      "style": props.style
    }, [slots.default?.()]));
    return {};
  }
});

const makeVCardSubtitleProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VCardSubtitle');
const VCardSubtitle = genericComponent()({
  name: 'VCardSubtitle',
  props: makeVCardSubtitleProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(props.tag, {
      "class": ['v-card-subtitle', props.class],
      "style": [{
        '--v-card-subtitle-opacity': props.opacity
      }, props.style]
    }, slots));
    return {};
  }
});

// Utilities
const VCardTitle = createSimpleFunctional('v-card-title');

const makeCardItemProps = propsFactory({
  appendAvatar: String,
  appendIcon: IconValue,
  prependAvatar: String,
  prependIcon: IconValue,
  subtitle: [String, Number],
  title: [String, Number],
  ...makeComponentProps(),
  ...makeDensityProps()
}, 'VCardItem');
const VCardItem = genericComponent()({
  name: 'VCardItem',
  props: makeCardItemProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => {
      const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
      const hasPrepend = !!(hasPrependMedia || slots.prepend);
      const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
      const hasAppend = !!(hasAppendMedia || slots.append);
      const hasTitle = !!(props.title != null || slots.title);
      const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
      return createVNode("div", {
        "class": ['v-card-item', props.class],
        "style": props.style
      }, [hasPrepend && createVNode("div", {
        "key": "prepend",
        "class": "v-card-item__prepend"
      }, [!slots.prepend ? createVNode(Fragment, null, [props.prependAvatar && createVNode(VAvatar, {
        "key": "prepend-avatar",
        "density": props.density,
        "image": props.prependAvatar
      }, null), props.prependIcon && createVNode(VIcon, {
        "key": "prepend-icon",
        "density": props.density,
        "icon": props.prependIcon
      }, null)]) : createVNode(VDefaultsProvider, {
        "key": "prepend-defaults",
        "disabled": !hasPrependMedia,
        "defaults": {
          VAvatar: {
            density: props.density,
            image: props.prependAvatar
          },
          VIcon: {
            density: props.density,
            icon: props.prependIcon
          }
        }
      }, slots.prepend)]), createVNode("div", {
        "class": "v-card-item__content"
      }, [hasTitle && createVNode(VCardTitle, {
        "key": "title"
      }, {
        default: () => [slots.title?.() ?? props.title]
      }), hasSubtitle && createVNode(VCardSubtitle, {
        "key": "subtitle"
      }, {
        default: () => [slots.subtitle?.() ?? props.subtitle]
      }), slots.default?.()]), hasAppend && createVNode("div", {
        "key": "append",
        "class": "v-card-item__append"
      }, [!slots.append ? createVNode(Fragment, null, [props.appendIcon && createVNode(VIcon, {
        "key": "append-icon",
        "density": props.density,
        "icon": props.appendIcon
      }, null), props.appendAvatar && createVNode(VAvatar, {
        "key": "append-avatar",
        "density": props.density,
        "image": props.appendAvatar
      }, null)]) : createVNode(VDefaultsProvider, {
        "key": "append-defaults",
        "disabled": !hasAppendMedia,
        "defaults": {
          VAvatar: {
            density: props.density,
            image: props.appendAvatar
          },
          VIcon: {
            density: props.density,
            icon: props.appendIcon
          }
        }
      }, slots.append)])]);
    });
    return {};
  }
});

const makeVCardTextProps = propsFactory({
  opacity: [Number, String],
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VCardText');
const VCardText = genericComponent()({
  name: 'VCardText',
  props: makeVCardTextProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => createVNode(props.tag, {
      "class": ['v-card-text', props.class],
      "style": [{
        '--v-card-text-opacity': props.opacity
      }, props.style]
    }, slots));
    return {};
  }
});

const makeVCardProps = propsFactory({
  appendAvatar: String,
  appendIcon: IconValue,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: undefined
  },
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  subtitle: [String, Number],
  text: [String, Number],
  title: [String, Number],
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLoaderProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'elevated'
  })
}, 'VCard');
const VCard = genericComponent()({
  name: 'VCard',
  directives: {
    Ripple
  },
  props: makeVCardProps(),
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(props);
    const {
      densityClasses
    } = useDensity(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      loaderClasses
    } = useLoader(props);
    const {
      locationStyles
    } = useLocation(props);
    const {
      positionClasses
    } = usePosition(props);
    const {
      roundedClasses
    } = useRounded(props);
    const link = useLink(props, attrs);
    const isLink = computed(() => props.link !== false && link.isLink.value);
    const isClickable = computed(() => !props.disabled && props.link !== false && (props.link || link.isClickable.value));
    useRender(() => {
      const Tag = isLink.value ? 'a' : props.tag;
      const hasTitle = !!(slots.title || props.title != null);
      const hasSubtitle = !!(slots.subtitle || props.subtitle != null);
      const hasHeader = hasTitle || hasSubtitle;
      const hasAppend = !!(slots.append || props.appendAvatar || props.appendIcon);
      const hasPrepend = !!(slots.prepend || props.prependAvatar || props.prependIcon);
      const hasImage = !!(slots.image || props.image);
      const hasCardItem = hasHeader || hasPrepend || hasAppend;
      const hasText = !!(slots.text || props.text != null);
      return withDirectives(createVNode(Tag, mergeProps({
        "class": ['v-card', {
          'v-card--disabled': props.disabled,
          'v-card--flat': props.flat,
          'v-card--hover': props.hover && !(props.disabled || props.flat),
          'v-card--link': isClickable.value
        }, themeClasses.value, borderClasses.value, colorClasses.value, densityClasses.value, elevationClasses.value, loaderClasses.value, positionClasses.value, roundedClasses.value, variantClasses.value, props.class],
        "style": [colorStyles.value, dimensionStyles.value, locationStyles.value, props.style],
        "onClick": isClickable.value && link.navigate,
        "tabindex": props.disabled ? -1 : undefined
      }, link.linkProps), {
        default: () => [hasImage && createVNode("div", {
          "key": "image",
          "class": "v-card__image"
        }, [!slots.image ? createVNode(VImg, {
          "key": "image-img",
          "cover": true,
          "src": props.image
        }, null) : createVNode(VDefaultsProvider, {
          "key": "image-defaults",
          "disabled": !props.image,
          "defaults": {
            VImg: {
              cover: true,
              src: props.image
            }
          }
        }, slots.image)]), createVNode(LoaderSlot, {
          "name": "v-card",
          "active": !!props.loading,
          "color": typeof props.loading === 'boolean' ? undefined : props.loading
        }, {
          default: slots.loader
        }), hasCardItem && createVNode(VCardItem, {
          "key": "item",
          "prependAvatar": props.prependAvatar,
          "prependIcon": props.prependIcon,
          "title": props.title,
          "subtitle": props.subtitle,
          "appendAvatar": props.appendAvatar,
          "appendIcon": props.appendIcon
        }, {
          default: slots.item,
          prepend: slots.prepend,
          title: slots.title,
          subtitle: slots.subtitle,
          append: slots.append
        }), hasText && createVNode(VCardText, {
          "key": "text"
        }, {
          default: () => [slots.text?.() ?? props.text]
        }), slots.default?.(), slots.actions && createVNode(VCardActions, null, {
          default: slots.actions
        }), genOverlays(isClickable.value, 'v-card')]
      }), [[resolveDirective("ripple"), isClickable.value && props.ripple]]);
    });
    return {};
  }
});

// Utilities
const handleGesture = wrapper => {
  const {
    touchstartX,
    touchendX,
    touchstartY,
    touchendY
  } = wrapper;
  const dirRatio = 0.5;
  const minDistance = 16;
  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;
  if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
    wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
    wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
  }
  if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
    wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
    wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
  }
};
function touchstart(event, wrapper) {
  const touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;
  wrapper.start?.({
    originalEvent: event,
    ...wrapper
  });
}
function touchend(event, wrapper) {
  const touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;
  wrapper.end?.({
    originalEvent: event,
    ...wrapper
  });
  handleGesture(wrapper);
}
function touchmove(event, wrapper) {
  const touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;
  wrapper.move?.({
    originalEvent: event,
    ...wrapper
  });
}
function createHandlers() {
  let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };
  return {
    touchstart: e => touchstart(e, wrapper),
    touchend: e => touchend(e, wrapper),
    touchmove: e => touchmove(e, wrapper)
  };
}
function mounted$1(el, binding) {
  const value = binding.value;
  const target = value?.parent ? el.parentElement : el;
  const options = value?.options ?? {
    passive: true
  };
  const uid = binding.instance?.$.uid; // TODO: use custom uid generator

  if (!target || !uid) return;
  const handlers = createHandlers(binding.value);
  target._touchHandlers = target._touchHandlers ?? Object.create(null);
  target._touchHandlers[uid] = handlers;
  keys(handlers).forEach(eventName => {
    target.addEventListener(eventName, handlers[eventName], options);
  });
}
function unmounted$1(el, binding) {
  const target = binding.value?.parent ? el.parentElement : el;
  const uid = binding.instance?.$.uid;
  if (!target?._touchHandlers || !uid) return;
  const handlers = target._touchHandlers[uid];
  keys(handlers).forEach(eventName => {
    target.removeEventListener(eventName, handlers[eventName]);
  });
  delete target._touchHandlers[uid];
}
const Touch = {
  mounted: mounted$1,
  unmounted: unmounted$1
};

const VWindowSymbol = Symbol.for('vuetify:v-window');
const VWindowGroupSymbol = Symbol.for('vuetify:v-window-group');
const makeVWindowProps = propsFactory({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: '$next'
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: '$prev'
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: v => typeof v === 'boolean' || v === 'hover'
  },
  touch: {
    type: [Object, Boolean],
    default: undefined
  },
  direction: {
    type: String,
    default: 'horizontal'
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: 'v-window-item--active'
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: 'force'
  },
  ...makeComponentProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, 'VWindow');
const VWindow = genericComponent()({
  name: 'VWindow',
  directives: {
    Touch
  },
  props: makeVWindowProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      isRtl
    } = useRtl();
    const {
      t
    } = useLocale();
    const group = useGroup(props, VWindowGroupSymbol);
    const rootRef = ref();
    const isRtlReverse = computed(() => isRtl.value ? !props.reverse : props.reverse);
    const isReversed = shallowRef(false);
    const transition = computed(() => {
      const axis = props.direction === 'vertical' ? 'y' : 'x';
      const reverse = isRtlReverse.value ? !isReversed.value : isReversed.value;
      const direction = reverse ? '-reverse' : '';
      return `v-window-${axis}${direction}-transition`;
    });
    const transitionCount = shallowRef(0);
    const transitionHeight = ref(undefined);
    const activeIndex = computed(() => {
      return group.items.value.findIndex(item => group.selected.value.includes(item.id));
    });
    watch(activeIndex, (newVal, oldVal) => {
      const itemsLength = group.items.value.length;
      const lastIndex = itemsLength - 1;
      if (itemsLength <= 2) {
        isReversed.value = newVal < oldVal;
      } else if (newVal === lastIndex && oldVal === 0) {
        isReversed.value = true;
      } else if (newVal === 0 && oldVal === lastIndex) {
        isReversed.value = false;
      } else {
        isReversed.value = newVal < oldVal;
      }
    });
    provide(VWindowSymbol, {
      transition,
      isReversed,
      transitionCount,
      transitionHeight,
      rootRef
    });
    const canMoveBack = computed(() => props.continuous || activeIndex.value !== 0);
    const canMoveForward = computed(() => props.continuous || activeIndex.value !== group.items.value.length - 1);
    function prev() {
      canMoveBack.value && group.prev();
    }
    function next() {
      canMoveForward.value && group.next();
    }
    const arrows = computed(() => {
      const arrows = [];
      const prevProps = {
        icon: isRtl.value ? props.nextIcon : props.prevIcon,
        class: `v-window__${isRtlReverse.value ? 'right' : 'left'}`,
        onClick: group.prev,
        'aria-label': t('$vuetify.carousel.prev')
      };
      arrows.push(canMoveBack.value ? slots.prev ? slots.prev({
        props: prevProps
      }) : createVNode(VBtn, prevProps, null) : createVNode("div", null, null));
      const nextProps = {
        icon: isRtl.value ? props.prevIcon : props.nextIcon,
        class: `v-window__${isRtlReverse.value ? 'left' : 'right'}`,
        onClick: group.next,
        'aria-label': t('$vuetify.carousel.next')
      };
      arrows.push(canMoveForward.value ? slots.next ? slots.next({
        props: nextProps
      }) : createVNode(VBtn, nextProps, null) : createVNode("div", null, null));
      return arrows;
    });
    const touchOptions = computed(() => {
      if (props.touch === false) return props.touch;
      const options = {
        left: () => {
          isRtlReverse.value ? prev() : next();
        },
        right: () => {
          isRtlReverse.value ? next() : prev();
        },
        start: _ref2 => {
          let {
            originalEvent
          } = _ref2;
          originalEvent.stopPropagation();
        }
      };
      return {
        ...options,
        ...(props.touch === true ? {} : props.touch)
      };
    });
    useRender(() => withDirectives(createVNode(props.tag, {
      "ref": rootRef,
      "class": ['v-window', {
        'v-window--show-arrows-on-hover': props.showArrows === 'hover'
      }, themeClasses.value, props.class],
      "style": props.style
    }, {
      default: () => [createVNode("div", {
        "class": "v-window__container",
        "style": {
          height: transitionHeight.value
        }
      }, [slots.default?.({
        group
      }), props.showArrows !== false && createVNode("div", {
        "class": "v-window__controls"
      }, [arrows.value])]), slots.additional?.({
        group
      })]
    }), [[resolveDirective("touch"), touchOptions.value]]));
    return {
      group
    };
  }
});

const makeVWindowItemProps = propsFactory({
  reverseTransition: {
    type: [Boolean, String],
    default: undefined
  },
  transition: {
    type: [Boolean, String],
    default: undefined
  },
  ...makeComponentProps(),
  ...makeGroupItemProps(),
  ...makeLazyProps()
}, 'VWindowItem');
const VWindowItem = genericComponent()({
  name: 'VWindowItem',
  directives: {
    Touch
  },
  props: makeVWindowItemProps(),
  emits: {
    'group:selected': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const window = inject$2(VWindowSymbol);
    const groupItem = useGroupItem(props, VWindowGroupSymbol);
    const {
      isBooted
    } = useSsrBoot();
    if (!window || !groupItem) throw new Error('[Vuetify] VWindowItem must be used inside VWindow');
    const isTransitioning = shallowRef(false);
    const hasTransition = computed(() => isBooted.value && (window.isReversed.value ? props.reverseTransition !== false : props.transition !== false));
    function onAfterTransition() {
      if (!isTransitioning.value || !window) {
        return;
      }

      // Finalize transition state.
      isTransitioning.value = false;
      if (window.transitionCount.value > 0) {
        window.transitionCount.value -= 1;

        // Remove container height if we are out of transition.
        if (window.transitionCount.value === 0) {
          window.transitionHeight.value = undefined;
        }
      }
    }
    function onBeforeTransition() {
      if (isTransitioning.value || !window) {
        return;
      }

      // Initialize transition state here.
      isTransitioning.value = true;
      if (window.transitionCount.value === 0) {
        // Set initial height for height transition.
        window.transitionHeight.value = convertToUnit(window.rootRef.value?.clientHeight);
      }
      window.transitionCount.value += 1;
    }
    function onTransitionCancelled() {
      onAfterTransition(); // This should have the same path as normal transition end.
    }
    function onEnterTransition(el) {
      if (!isTransitioning.value) {
        return;
      }
      nextTick(() => {
        // Do not set height if no transition or cancelled.
        if (!hasTransition.value || !isTransitioning.value || !window) {
          return;
        }

        // Set transition target height.
        window.transitionHeight.value = convertToUnit(el.clientHeight);
      });
    }
    const transition = computed(() => {
      const name = window.isReversed.value ? props.reverseTransition : props.transition;
      return !hasTransition.value ? false : {
        name: typeof name !== 'string' ? window.transition.value : name,
        onBeforeEnter: onBeforeTransition,
        onAfterEnter: onAfterTransition,
        onEnterCancelled: onTransitionCancelled,
        onBeforeLeave: onBeforeTransition,
        onAfterLeave: onAfterTransition,
        onLeaveCancelled: onTransitionCancelled,
        onEnter: onEnterTransition
      };
    });
    const {
      hasContent
    } = useLazy(props, groupItem.isSelected);
    useRender(() => createVNode(MaybeTransition, {
      "transition": transition.value,
      "disabled": !isBooted.value
    }, {
      default: () => [withDirectives(createVNode("div", {
        "class": ['v-window-item', groupItem.selectedClass.value, props.class],
        "style": props.style
      }, [hasContent.value && slots.default?.()]), [[vShow, groupItem.isSelected.value]])]
    }));
    return {
      groupItem
    };
  }
});

const makeVSheetProps = propsFactory({
  color: String,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeLocationProps(),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, 'VSheet');
const VSheet = genericComponent()({
  name: 'VSheet',
  props: makeVSheetProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      borderClasses
    } = useBorder(props);
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      locationStyles
    } = useLocation(props);
    const {
      positionClasses
    } = usePosition(props);
    const {
      roundedClasses
    } = useRounded(props);
    useRender(() => createVNode(props.tag, {
      "class": ['v-sheet', themeClasses.value, backgroundColorClasses.value, borderClasses.value, elevationClasses.value, positionClasses.value, roundedClasses.value, props.class],
      "style": [backgroundColorStyles.value, dimensionStyles.value, locationStyles.value, props.style]
    }, slots));
    return {};
  }
});

function highlightResult(text, matches, length) {
  if (matches == null) return text;
  if (Array.isArray(matches)) throw new Error('Multiple matches is not implemented');
  return typeof matches === 'number' && ~matches ? createVNode(Fragment, null, [createVNode("span", {
    "class": "v-combobox__unmask"
  }, [text.substr(0, matches)]), createVNode("span", {
    "class": "v-combobox__mask"
  }, [text.substr(matches, length)]), createVNode("span", {
    "class": "v-combobox__unmask"
  }, [text.substr(matches + length)])]) : text;
}
const makeVComboboxProps = propsFactory({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: {
    type: Boolean,
    default: true
  },
  delimiters: Array,
  ...makeFilterProps({
    filterKeys: ['title']
  }),
  ...makeSelectProps({
    hideNoData: true,
    returnObject: true
  }),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: 'combobox'
  }), ['validationValue', 'dirty', 'appendInnerIcon']),
  ...makeTransitionProps({
    transition: false
  })
}, 'VCombobox');
const VCombobox = genericComponent()({
  name: 'VCombobox',
  props: makeVComboboxProps(),
  emits: {
    'update:focused': focused => true,
    'update:modelValue': value => true,
    'update:search': value => true,
    'update:menu': value => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const vTextFieldRef = ref();
    const isFocused = shallowRef(false);
    const isPristine = shallowRef(true);
    const listHasFocus = shallowRef(false);
    const vMenuRef = ref();
    const vVirtualScrollRef = ref();
    const _menu = useProxiedModel(props, 'menu');
    const menu = computed({
      get: () => _menu.value,
      set: v => {
        if (_menu.value && !v && vMenuRef.value?.ΨopenChildren.size) return;
        _menu.value = v;
      }
    });
    const selectionIndex = shallowRef(-1);
    let cleared = false;
    const color = computed(() => vTextFieldRef.value?.color);
    const label = computed(() => menu.value ? props.closeText : props.openText);
    const {
      items,
      transformIn,
      transformOut
    } = useItems(props);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(color);
    const model = useProxiedModel(props, 'modelValue', [], v => transformIn(wrapInArray(v)), v => {
      const transformed = transformOut(v);
      return props.multiple ? transformed : transformed[0] ?? null;
    });
    const form = useForm(props);
    const hasChips = computed(() => !!(props.chips || slots.chip));
    const hasSelectionSlot = computed(() => hasChips.value || !!slots.selection);
    const _search = shallowRef(!props.multiple && !hasSelectionSlot.value ? model.value[0]?.title ?? '' : '');
    const search = computed({
      get: () => {
        return _search.value;
      },
      set: val => {
        _search.value = val ?? '';
        if (!props.multiple && !hasSelectionSlot.value) {
          model.value = [transformItem$2(props, val)];
        }
        if (val && props.multiple && props.delimiters?.length) {
          const values = val.split(new RegExp(`(?:${props.delimiters.join('|')})+`));
          if (values.length > 1) {
            values.forEach(v => {
              v = v.trim();
              if (v) select(transformItem$2(props, v));
            });
            _search.value = '';
          }
        }
        if (!val) selectionIndex.value = -1;
        isPristine.value = !val;
      }
    });
    const counterValue = computed(() => {
      return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : props.multiple ? model.value.length : search.value.length;
    });
    watch(_search, value => {
      if (cleared) {
        // wait for clear to finish, VTextField sets _search to null
        // then search computed triggers and updates _search to ''
        nextTick(() => cleared = false);
      } else if (isFocused.value && !menu.value) {
        menu.value = true;
      }
      emit('update:search', value);
    });
    watch(model, value => {
      if (!props.multiple && !hasSelectionSlot.value) {
        _search.value = value[0]?.title ?? '';
      }
    });
    const {
      filteredItems,
      getMatches
    } = useFilter(props, items, () => isPristine.value ? '' : search.value);
    const displayItems = computed(() => {
      if (props.hideSelected) {
        return filteredItems.value.filter(filteredItem => !model.value.some(s => s.value === filteredItem.value));
      }
      return filteredItems.value;
    });
    const selectedValues = computed(() => model.value.map(selection => selection.value));
    const highlightFirst = computed(() => {
      const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === displayItems.value[0]?.title;
      return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
    });
    const menuDisabled = computed(() => props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
    const listRef = ref();
    const listEvents = useScrolling(listRef, vTextFieldRef);
    function onClear(e) {
      cleared = true;
      if (props.openOnClear) {
        menu.value = true;
      }
    }
    function onMousedownControl() {
      if (menuDisabled.value) return;
      menu.value = true;
    }
    function onMousedownMenuIcon(e) {
      if (menuDisabled.value) return;
      if (isFocused.value) {
        e.preventDefault();
        e.stopPropagation();
      }
      menu.value = !menu.value;
    }
    function onListKeydown(e) {
      if (checkPrintable(e)) {
        vTextFieldRef.value?.focus();
      }
    }
    // eslint-disable-next-line complexity
    function onKeydown(e) {
      if (isComposingIgnoreKey(e) || form.isReadonly.value) return;
      const selectionStart = vTextFieldRef.value.selectionStart;
      const length = model.value.length;
      if (selectionIndex.value > -1 || ['Enter', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
        e.preventDefault();
      }
      if (['Enter', 'ArrowDown'].includes(e.key)) {
        menu.value = true;
      }
      if (['Escape'].includes(e.key)) {
        menu.value = false;
      }
      if (['Enter', 'Escape', 'Tab'].includes(e.key)) {
        if (highlightFirst.value && ['Enter', 'Tab'].includes(e.key) && !model.value.some(_ref2 => {
          let {
            value
          } = _ref2;
          return value === displayItems.value[0].value;
        })) {
          select(filteredItems.value[0]);
        }
        isPristine.value = true;
      }
      if (e.key === 'ArrowDown' && highlightFirst.value) {
        listRef.value?.focus('next');
      }
      if (e.key === 'Enter' && search.value) {
        select(transformItem$2(props, search.value));
        if (hasSelectionSlot.value) _search.value = '';
      }
      if (['Backspace', 'Delete'].includes(e.key)) {
        if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
        if (~selectionIndex.value) {
          const originalSelectionIndex = selectionIndex.value;
          select(model.value[selectionIndex.value], false);
          selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
        } else if (e.key === 'Backspace' && !search.value) {
          selectionIndex.value = length - 1;
        }
      }
      if (!props.multiple) return;
      if (e.key === 'ArrowLeft') {
        if (selectionIndex.value < 0 && selectionStart > 0) return;
        const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
        if (model.value[prev]) {
          selectionIndex.value = prev;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange(search.value.length, search.value.length);
        }
      }
      if (e.key === 'ArrowRight') {
        if (selectionIndex.value < 0) return;
        const next = selectionIndex.value + 1;
        if (model.value[next]) {
          selectionIndex.value = next;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange(0, 0);
        }
      }
    }
    function onAfterEnter() {
      if (props.eager) {
        vVirtualScrollRef.value?.calculateVisibleItems();
      }
    }
    function onAfterLeave() {
      if (isFocused.value) {
        isPristine.value = true;
        vTextFieldRef.value?.focus();
      }
    }
    /** @param set - null means toggle */
    function select(item) {
      let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!item || item.props.disabled) return;
      if (props.multiple) {
        const index = model.value.findIndex(selection => props.valueComparator(selection.value, item.value));
        const add = set == null ? !~index : set;
        if (~index) {
          const value = add ? [...model.value, item] : [...model.value];
          value.splice(index, 1);
          model.value = value;
        } else if (add) {
          model.value = [...model.value, item];
        }
        if (props.clearOnSelect) {
          search.value = '';
        }
      } else {
        const add = set !== false;
        model.value = add ? [item] : [];
        _search.value = add && !hasSelectionSlot.value ? item.title : '';

        // watch for search watcher to trigger
        nextTick(() => {
          menu.value = false;
          isPristine.value = true;
        });
      }
    }
    function onFocusin(e) {
      isFocused.value = true;
      setTimeout(() => {
        listHasFocus.value = true;
      });
    }
    function onFocusout(e) {
      listHasFocus.value = false;
    }
    function onUpdateModelValue(v) {
      if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
    }
    watch(isFocused, (val, oldVal) => {
      if (val || val === oldVal) return;
      selectionIndex.value = -1;
      menu.value = false;
      if (search.value) {
        if (props.multiple) {
          select(transformItem$2(props, search.value));
          return;
        }
        if (!hasSelectionSlot.value) return;
        if (model.value.some(_ref3 => {
          let {
            title
          } = _ref3;
          return title === search.value;
        })) {
          _search.value = '';
        } else {
          select(transformItem$2(props, search.value));
        }
      }
    });
    watch(menu, () => {
      if (!props.hideSelected && menu.value && model.value.length) {
        const index = displayItems.value.findIndex(item => model.value.some(s => props.valueComparator(s.value, item.value)));
        IN_BROWSER && window.requestAnimationFrame(() => {
          index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
        });
      }
    });
    watch(() => props.items, (newVal, oldVal) => {
      if (menu.value) return;
      if (isFocused.value && !oldVal.length && newVal.length) {
        menu.value = true;
      }
    });
    useRender(() => {
      const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
      const isDirty = model.value.length > 0;
      const textFieldProps = VTextField.filterProps(props);
      return createVNode(VTextField, mergeProps({
        "ref": vTextFieldRef
      }, textFieldProps, {
        "modelValue": search.value,
        "onUpdate:modelValue": [$event => search.value = $event, onUpdateModelValue],
        "focused": isFocused.value,
        "onUpdate:focused": $event => isFocused.value = $event,
        "validationValue": model.externalValue,
        "counterValue": counterValue.value,
        "dirty": isDirty,
        "class": ['v-combobox', {
          'v-combobox--active-menu': menu.value,
          'v-combobox--chips': !!props.chips,
          'v-combobox--selection-slot': !!hasSelectionSlot.value,
          'v-combobox--selecting-index': selectionIndex.value > -1,
          [`v-combobox--${props.multiple ? 'multiple' : 'single'}`]: true
        }, props.class],
        "style": props.style,
        "readonly": form.isReadonly.value,
        "placeholder": isDirty ? undefined : props.placeholder,
        "onClick:clear": onClear,
        "onMousedown:control": onMousedownControl,
        "onKeydown": onKeydown
      }), {
        ...slots,
        default: () => createVNode(Fragment, null, [createVNode(VMenu, mergeProps({
          "ref": vMenuRef,
          "modelValue": menu.value,
          "onUpdate:modelValue": $event => menu.value = $event,
          "activator": "parent",
          "contentClass": "v-combobox__content",
          "disabled": menuDisabled.value,
          "eager": props.eager,
          "maxHeight": 310,
          "openOnClick": false,
          "closeOnContentClick": false,
          "transition": props.transition,
          "onAfterEnter": onAfterEnter,
          "onAfterLeave": onAfterLeave
        }, props.menuProps), {
          default: () => [hasList && createVNode(VList, mergeProps({
            "ref": listRef,
            "selected": selectedValues.value,
            "selectStrategy": props.multiple ? 'independent' : 'single-independent',
            "onMousedown": e => e.preventDefault(),
            "onKeydown": onListKeydown,
            "onFocusin": onFocusin,
            "onFocusout": onFocusout,
            "tabindex": "-1",
            "aria-live": "polite",
            "color": props.itemColor ?? props.color
          }, listEvents, props.listProps), {
            default: () => [slots['prepend-item']?.(), !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? createVNode(VListItem, {
              "key": "no-data",
              "title": t(props.noDataText)
            }, null)), createVNode(VVirtualScroll, {
              "ref": vVirtualScrollRef,
              "renderless": true,
              "items": displayItems.value
            }, {
              default: _ref4 => {
                let {
                  item,
                  index,
                  itemRef
                } = _ref4;
                const itemProps = mergeProps(item.props, {
                  ref: itemRef,
                  key: item.value,
                  active: highlightFirst.value && index === 0 ? true : undefined,
                  onClick: () => select(item, null)
                });
                return slots.item?.({
                  item,
                  index,
                  props: itemProps
                }) ?? createVNode(VListItem, mergeProps(itemProps, {
                  "role": "option"
                }), {
                  prepend: _ref5 => {
                    let {
                      isSelected
                    } = _ref5;
                    return createVNode(Fragment, null, [props.multiple && !props.hideSelected ? createVNode(VCheckboxBtn, {
                      "key": item.value,
                      "modelValue": isSelected,
                      "ripple": false,
                      "tabindex": "-1"
                    }, null) : undefined, item.props.prependAvatar && createVNode(VAvatar, {
                      "image": item.props.prependAvatar
                    }, null), item.props.prependIcon && createVNode(VIcon, {
                      "icon": item.props.prependIcon
                    }, null)]);
                  },
                  title: () => {
                    return isPristine.value ? item.title : highlightResult(item.title, getMatches(item)?.title, search.value?.length ?? 0);
                  }
                });
              }
            }), slots['append-item']?.()]
          })]
        }), model.value.map((item, index) => {
          function onChipClose(e) {
            e.stopPropagation();
            e.preventDefault();
            select(item, false);
          }
          const slotProps = {
            'onClick:close': onChipClose,
            onKeydown(e) {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              e.preventDefault();
              e.stopPropagation();
              onChipClose(e);
            },
            onMousedown(e) {
              e.preventDefault();
              e.stopPropagation();
            },
            modelValue: true,
            'onUpdate:modelValue': undefined
          };
          const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
          const slotContent = hasSlot ? ensureValidVNode(hasChips.value ? slots.chip({
            item,
            index,
            props: slotProps
          }) : slots.selection({
            item,
            index
          })) : undefined;
          if (hasSlot && !slotContent) return undefined;
          return createVNode("div", {
            "key": item.value,
            "class": ['v-combobox__selection', index === selectionIndex.value && ['v-combobox__selection--selected', textColorClasses.value]],
            "style": index === selectionIndex.value ? textColorStyles.value : {}
          }, [hasChips.value ? !slots.chip ? createVNode(VChip, mergeProps({
            "key": "chip",
            "closable": props.closableChips,
            "size": "small",
            "text": item.title,
            "disabled": item.props.disabled
          }, slotProps), null) : createVNode(VDefaultsProvider, {
            "key": "chip-defaults",
            "defaults": {
              VChip: {
                closable: props.closableChips,
                size: 'small',
                text: item.title
              }
            }
          }, {
            default: () => [slotContent]
          }) : slotContent ?? createVNode("span", {
            "class": "v-combobox__selection-text"
          }, [item.title, props.multiple && index < model.value.length - 1 && createVNode("span", {
            "class": "v-combobox__selection-comma"
          }, [createTextVNode(",")])])]);
        })]),
        'append-inner': function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(Fragment, null, [slots['append-inner']?.(...args), (!props.hideNoData || props.items.length) && props.menuIcon ? createVNode(VIcon, {
            "class": "v-combobox__menu-icon",
            "icon": props.menuIcon,
            "onMousedown": onMousedownMenuIcon,
            "onClick": noop,
            "aria-label": t(label.value),
            "title": t(label.value),
            "tabindex": "-1"
          }, null) : undefined]);
        }
      });
    });
    return forwardRefs({
      isFocused,
      isPristine,
      menu,
      search,
      selectionIndex,
      filteredItems,
      select
    }, vTextFieldRef);
  }
});

const makeVConfirmEditProps = propsFactory({
  modelValue: null,
  color: String,
  cancelText: {
    type: String,
    default: '$vuetify.confirmEdit.cancel'
  },
  okText: {
    type: String,
    default: '$vuetify.confirmEdit.ok'
  }
}, 'VConfirmEdit');
const VConfirmEdit = genericComponent()({
  name: 'VConfirmEdit',
  props: makeVConfirmEditProps(),
  emits: {
    cancel: () => true,
    save: value => true,
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const internalModel = ref();
    watchEffect(() => {
      internalModel.value = structuredClone(toRaw(model.value));
    });
    const {
      t
    } = useLocale();
    const isPristine = computed(() => {
      return deepEqual(model.value, internalModel.value);
    });
    function save() {
      model.value = internalModel.value;
      emit('save', internalModel.value);
    }
    function cancel() {
      internalModel.value = structuredClone(toRaw(model.value));
      emit('cancel');
    }
    function actions(actionsProps) {
      return createVNode(Fragment, null, [createVNode(VBtn, mergeProps({
        "disabled": isPristine.value,
        "variant": "text",
        "color": props.color,
        "onClick": cancel,
        "text": t(props.cancelText)
      }, actionsProps), null), createVNode(VBtn, mergeProps({
        "disabled": isPristine.value,
        "variant": "text",
        "color": props.color,
        "onClick": save,
        "text": t(props.okText)
      }, actionsProps), null)]);
    }
    let actionsUsed = false;
    useRender(() => {
      return createVNode(Fragment, null, [slots.default?.({
        model: internalModel,
        save,
        cancel,
        isPristine: isPristine.value,
        get actions() {
          actionsUsed = true;
          return actions;
        }
      }), !actionsUsed && actions()]);
    });
    return {
      save,
      cancel,
      isPristine
    };
  }
});

// Composables
const makeDataTableExpandProps = propsFactory({
  expandOnClick: Boolean,
  showExpand: Boolean,
  expanded: {
    type: Array,
    default: () => []
  }
}, 'DataTable-expand');
const VDataTableExpandedKey = Symbol.for('vuetify:datatable:expanded');
function provideExpanded(props) {
  const expandOnClick = toRef(props, 'expandOnClick');
  const expanded = useProxiedModel(props, 'expanded', props.expanded, v => {
    return new Set(v);
  }, v => {
    return [...v.values()];
  });
  function expand(item, value) {
    const newExpanded = new Set(expanded.value);
    if (!value) {
      newExpanded.delete(item.value);
    } else {
      newExpanded.add(item.value);
    }
    expanded.value = newExpanded;
  }
  function isExpanded(item) {
    return expanded.value.has(item.value);
  }
  function toggleExpand(item) {
    expand(item, !isExpanded(item));
  }
  const data = {
    expand,
    expanded,
    expandOnClick,
    isExpanded,
    toggleExpand
  };
  provide(VDataTableExpandedKey, data);
  return data;
}
function useExpanded() {
  const data = inject$2(VDataTableExpandedKey);
  if (!data) throw new Error('foo');
  return data;
}

// Composables
const makeDataTableGroupProps = propsFactory({
  groupBy: {
    type: Array,
    default: () => []
  }
}, 'DataTable-group');
const VDataTableGroupSymbol = Symbol.for('vuetify:data-table-group');
function createGroupBy(props) {
  const groupBy = useProxiedModel(props, 'groupBy');
  return {
    groupBy
  };
}
function provideGroupBy(options) {
  const {
    disableSort,
    groupBy,
    sortBy
  } = options;
  const opened = ref(new Set());
  const sortByWithGroups = computed(() => {
    return groupBy.value.map(val => ({
      ...val,
      order: val.order ?? false
    })).concat(disableSort?.value ? [] : sortBy.value);
  });
  function isGroupOpen(group) {
    return opened.value.has(group.id);
  }
  function toggleGroup(group) {
    const newOpened = new Set(opened.value);
    if (!isGroupOpen(group)) newOpened.add(group.id);else newOpened.delete(group.id);
    opened.value = newOpened;
  }
  function extractRows(items) {
    function dive(group) {
      const arr = [];
      for (const item of group.items) {
        if ('type' in item && item.type === 'group') {
          arr.push(...dive(item));
        } else {
          arr.push(item);
        }
      }
      return arr;
    }
    return dive({
      type: 'group',
      items,
      id: 'dummy',
      key: 'dummy',
      value: 'dummy',
      depth: 0
    });
  }

  // onBeforeMount(() => {
  //   for (const key of groupedItems.value.keys()) {
  //     opened.value.add(key)
  //   }
  // })

  const data = {
    sortByWithGroups,
    toggleGroup,
    opened,
    groupBy,
    extractRows,
    isGroupOpen
  };
  provide(VDataTableGroupSymbol, data);
  return data;
}
function useGroupBy() {
  const data = inject$2(VDataTableGroupSymbol);
  if (!data) throw new Error('Missing group!');
  return data;
}
function groupItemsByProperty(items, groupBy) {
  if (!items.length) return [];
  const groups = new Map();
  for (const item of items) {
    const value = getObjectValueByPath(item.raw, groupBy);
    if (!groups.has(value)) {
      groups.set(value, []);
    }
    groups.get(value).push(item);
  }
  return groups;
}
function groupItems(items, groupBy) {
  let depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root';
  if (!groupBy.length) return [];
  const groupedItems = groupItemsByProperty(items, groupBy[0]);
  const groups = [];
  const rest = groupBy.slice(1);
  groupedItems.forEach((items, value) => {
    const key = groupBy[0];
    const id = `${prefix}_${key}_${value}`;
    groups.push({
      depth,
      id,
      key,
      value,
      items: rest.length ? groupItems(items, rest, depth + 1, id) : items,
      type: 'group'
    });
  });
  return groups;
}
function flattenItems(items, opened) {
  const flatItems = [];
  for (const item of items) {
    // TODO: make this better
    if ('type' in item && item.type === 'group') {
      if (item.value != null) {
        flatItems.push(item);
      }
      if (opened.has(item.id) || item.value == null) {
        flatItems.push(...flattenItems(item.items, opened));
      }
    } else {
      flatItems.push(item);
    }
  }
  return flatItems;
}
function useGroupedItems(items, groupBy, opened) {
  const flatItems = computed(() => {
    if (!groupBy.value.length) return items.value;
    const groupedItems = groupItems(items.value, groupBy.value.map(item => item.key));
    return flattenItems(groupedItems, opened.value);
  });
  return {
    flatItems
  };
}

// Utilities
function useOptions(_ref) {
  let {
    page,
    itemsPerPage,
    sortBy,
    groupBy,
    search
  } = _ref;
  const vm = getCurrentInstance('VDataTable');
  const options = computed(() => ({
    page: page.value,
    itemsPerPage: itemsPerPage.value,
    sortBy: sortBy.value,
    groupBy: groupBy.value,
    search: search.value
  }));
  let oldOptions = null;
  watch(options, () => {
    if (deepEqual(oldOptions, options.value)) return;

    // Reset page when searching
    if (oldOptions && oldOptions.search !== options.value.search) {
      page.value = 1;
    }
    vm.emit('update:options', options.value);
    oldOptions = options.value;
  }, {
    deep: true,
    immediate: true
  });
}

// Composables
const makeDataTablePaginateProps = propsFactory({
  page: {
    type: [Number, String],
    default: 1
  },
  itemsPerPage: {
    type: [Number, String],
    default: 10
  }
}, 'DataTable-paginate');
const VDataTablePaginationSymbol = Symbol.for('vuetify:data-table-pagination');
function createPagination(props) {
  const page = useProxiedModel(props, 'page', undefined, value => +(value ?? 1));
  const itemsPerPage = useProxiedModel(props, 'itemsPerPage', undefined, value => +(value ?? 10));
  return {
    page,
    itemsPerPage
  };
}
function providePagination(options) {
  const {
    page,
    itemsPerPage,
    itemsLength
  } = options;
  const startIndex = computed(() => {
    if (itemsPerPage.value === -1) return 0;
    return itemsPerPage.value * (page.value - 1);
  });
  const stopIndex = computed(() => {
    if (itemsPerPage.value === -1) return itemsLength.value;
    return Math.min(itemsLength.value, startIndex.value + itemsPerPage.value);
  });
  const pageCount = computed(() => {
    if (itemsPerPage.value === -1 || itemsLength.value === 0) return 1;
    return Math.ceil(itemsLength.value / itemsPerPage.value);
  });

  // Don't run immediately, items may not have been loaded yet: #17966
  watch([page, pageCount], () => {
    if (page.value > pageCount.value) {
      page.value = pageCount.value;
    }
  });
  function setItemsPerPage(value) {
    itemsPerPage.value = value;
    page.value = 1;
  }
  function nextPage() {
    page.value = clamp(page.value + 1, 1, pageCount.value);
  }
  function prevPage() {
    page.value = clamp(page.value - 1, 1, pageCount.value);
  }
  function setPage(value) {
    page.value = clamp(value, 1, pageCount.value);
  }
  const data = {
    page,
    itemsPerPage,
    startIndex,
    stopIndex,
    pageCount,
    itemsLength,
    nextPage,
    prevPage,
    setPage,
    setItemsPerPage
  };
  provide(VDataTablePaginationSymbol, data);
  return data;
}
function usePagination() {
  const data = inject$2(VDataTablePaginationSymbol);
  if (!data) throw new Error('Missing pagination!');
  return data;
}
function usePaginatedItems(options) {
  const vm = getCurrentInstance('usePaginatedItems');
  const {
    items,
    startIndex,
    stopIndex,
    itemsPerPage
  } = options;
  const paginatedItems = computed(() => {
    if (itemsPerPage.value <= 0) return items.value;
    return items.value.slice(startIndex.value, stopIndex.value);
  });
  watch(paginatedItems, val => {
    vm.emit('update:currentItems', val);
  });
  return {
    paginatedItems
  };
}

// Composables
const singleSelectStrategy = {
  showSelectAll: false,
  allSelected: () => [],
  select: _ref => {
    let {
      items,
      value
    } = _ref;
    return new Set(value ? [items[0]?.value] : []);
  },
  selectAll: _ref2 => {
    let {
      selected
    } = _ref2;
    return selected;
  }
};
const pageSelectStrategy = {
  showSelectAll: true,
  allSelected: _ref3 => {
    let {
      currentPage
    } = _ref3;
    return currentPage;
  },
  select: _ref4 => {
    let {
      items,
      value,
      selected
    } = _ref4;
    for (const item of items) {
      if (value) selected.add(item.value);else selected.delete(item.value);
    }
    return selected;
  },
  selectAll: _ref5 => {
    let {
      value,
      currentPage,
      selected
    } = _ref5;
    return pageSelectStrategy.select({
      items: currentPage,
      value,
      selected
    });
  }
};
const allSelectStrategy = {
  showSelectAll: true,
  allSelected: _ref6 => {
    let {
      allItems
    } = _ref6;
    return allItems;
  },
  select: _ref7 => {
    let {
      items,
      value,
      selected
    } = _ref7;
    for (const item of items) {
      if (value) selected.add(item.value);else selected.delete(item.value);
    }
    return selected;
  },
  selectAll: _ref8 => {
    let {
      value,
      allItems,
      selected
    } = _ref8;
    return allSelectStrategy.select({
      items: allItems,
      value,
      selected
    });
  }
};
const makeDataTableSelectProps = propsFactory({
  showSelect: Boolean,
  selectStrategy: {
    type: [String, Object],
    default: 'page'
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  valueComparator: {
    type: Function,
    default: deepEqual
  }
}, 'DataTable-select');
const VDataTableSelectionSymbol = Symbol.for('vuetify:data-table-selection');
function provideSelection(props, _ref9) {
  let {
    allItems,
    currentPage
  } = _ref9;
  const selected = useProxiedModel(props, 'modelValue', props.modelValue, v => {
    return new Set(wrapInArray(v).map(v => {
      return allItems.value.find(item => props.valueComparator(v, item.value))?.value ?? v;
    }));
  }, v => {
    return [...v.values()];
  });
  const allSelectable = computed(() => allItems.value.filter(item => item.selectable));
  const currentPageSelectable = computed(() => currentPage.value.filter(item => item.selectable));
  const selectStrategy = computed(() => {
    if (typeof props.selectStrategy === 'object') return props.selectStrategy;
    switch (props.selectStrategy) {
      case 'single':
        return singleSelectStrategy;
      case 'all':
        return allSelectStrategy;
      case 'page':
      default:
        return pageSelectStrategy;
    }
  });
  function isSelected(items) {
    return wrapInArray(items).every(item => selected.value.has(item.value));
  }
  function isSomeSelected(items) {
    return wrapInArray(items).some(item => selected.value.has(item.value));
  }
  function select(items, value) {
    const newSelected = selectStrategy.value.select({
      items,
      value,
      selected: new Set(selected.value)
    });
    selected.value = newSelected;
  }
  function toggleSelect(item) {
    select([item], !isSelected([item]));
  }
  function selectAll(value) {
    const newSelected = selectStrategy.value.selectAll({
      value,
      allItems: allSelectable.value,
      currentPage: currentPageSelectable.value,
      selected: new Set(selected.value)
    });
    selected.value = newSelected;
  }
  const someSelected = computed(() => selected.value.size > 0);
  const allSelected = computed(() => {
    const items = selectStrategy.value.allSelected({
      allItems: allSelectable.value,
      currentPage: currentPageSelectable.value
    });
    return !!items.length && isSelected(items);
  });
  const showSelectAll = computed(() => selectStrategy.value.showSelectAll);
  const data = {
    toggleSelect,
    select,
    selectAll,
    isSelected,
    isSomeSelected,
    someSelected,
    allSelected,
    showSelectAll
  };
  provide(VDataTableSelectionSymbol, data);
  return data;
}
function useSelection() {
  const data = inject$2(VDataTableSelectionSymbol);
  if (!data) throw new Error('Missing selection!');
  return data;
}

// Composables
const makeDataTableSortProps = propsFactory({
  sortBy: {
    type: Array,
    default: () => []
  },
  customKeySort: Object,
  multiSort: Boolean,
  mustSort: Boolean
}, 'DataTable-sort');
const VDataTableSortSymbol = Symbol.for('vuetify:data-table-sort');
function createSort(props) {
  const sortBy = useProxiedModel(props, 'sortBy');
  const mustSort = toRef(props, 'mustSort');
  const multiSort = toRef(props, 'multiSort');
  return {
    sortBy,
    mustSort,
    multiSort
  };
}
function provideSort(options) {
  const {
    sortBy,
    mustSort,
    multiSort,
    page
  } = options;
  const toggleSort = column => {
    if (column.key == null) return;
    let newSortBy = sortBy.value.map(x => ({
      ...x
    })) ?? [];
    const item = newSortBy.find(x => x.key === column.key);
    if (!item) {
      if (multiSort.value) newSortBy = [...newSortBy, {
        key: column.key,
        order: 'asc'
      }];else newSortBy = [{
        key: column.key,
        order: 'asc'
      }];
    } else if (item.order === 'desc') {
      if (mustSort.value) {
        item.order = 'asc';
      } else {
        newSortBy = newSortBy.filter(x => x.key !== column.key);
      }
    } else {
      item.order = 'desc';
    }
    sortBy.value = newSortBy;
    if (page) page.value = 1;
  };
  function isSorted(column) {
    return !!sortBy.value.find(item => item.key === column.key);
  }
  const data = {
    sortBy,
    toggleSort,
    isSorted
  };
  provide(VDataTableSortSymbol, data);
  return data;
}
function useSort() {
  const data = inject$2(VDataTableSortSymbol);
  if (!data) throw new Error('Missing sort!');
  return data;
}

// TODO: abstract into project composable
function useSortedItems(props, items, sortBy, options) {
  const locale = useLocale();
  const sortedItems = computed(() => {
    if (!sortBy.value.length) return items.value;
    return sortItems(items.value, sortBy.value, locale.current.value, {
      transform: options?.transform,
      sortFunctions: {
        ...props.customKeySort,
        ...options?.sortFunctions?.value
      },
      sortRawFunctions: options?.sortRawFunctions?.value
    });
  });
  return {
    sortedItems
  };
}
function sortItems(items, sortByItems, locale, options) {
  const stringCollator = new Intl.Collator(locale, {
    sensitivity: 'accent',
    usage: 'sort'
  });
  const transformedItems = items.map(item => [item, options?.transform ? options.transform(item) : item]);
  return transformedItems.sort((a, b) => {
    for (let i = 0; i < sortByItems.length; i++) {
      let hasCustomResult = false;
      const sortKey = sortByItems[i].key;
      const sortOrder = sortByItems[i].order ?? 'asc';
      if (sortOrder === false) continue;
      let sortA = getObjectValueByPath(a[1], sortKey);
      let sortB = getObjectValueByPath(b[1], sortKey);
      let sortARaw = a[0].raw;
      let sortBRaw = b[0].raw;
      if (sortOrder === 'desc') {
        [sortA, sortB] = [sortB, sortA];
        [sortARaw, sortBRaw] = [sortBRaw, sortARaw];
      }
      if (options?.sortRawFunctions?.[sortKey]) {
        const customResult = options.sortRawFunctions[sortKey](sortARaw, sortBRaw);
        if (customResult == null) continue;
        hasCustomResult = true;
        if (customResult) return customResult;
      }
      if (options?.sortFunctions?.[sortKey]) {
        const customResult = options.sortFunctions[sortKey](sortA, sortB);
        if (customResult == null) continue;
        hasCustomResult = true;
        if (customResult) return customResult;
      }
      if (hasCustomResult) continue;

      // Dates should be compared numerically
      if (sortA instanceof Date && sortB instanceof Date) {
        return sortA.getTime() - sortB.getTime();
      }
      [sortA, sortB] = [sortA, sortB].map(s => s != null ? s.toString().toLocaleLowerCase() : s);
      if (sortA !== sortB) {
        if (isEmpty(sortA) && isEmpty(sortB)) return 0;
        if (isEmpty(sortA)) return -1;
        if (isEmpty(sortB)) return 1;
        if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
        return stringCollator.compare(sortA, sortB);
      }
    }
    return 0;
  }).map(_ref => {
    let [item] = _ref;
    return item;
  });
}

// Utilities

// Types

function useRefs() {
  const refs = ref([]);
  onBeforeUpdate(() => refs.value = []);
  function updateRef(e, i) {
    refs.value[i] = e;
  }
  return {
    refs,
    updateRef
  };
}

const makeVPaginationProps = propsFactory({
  activeColor: String,
  start: {
    type: [Number, String],
    default: 1
  },
  modelValue: {
    type: Number,
    default: props => props.start
  },
  disabled: Boolean,
  length: {
    type: [Number, String],
    default: 1,
    validator: val => val % 1 === 0
  },
  totalVisible: [Number, String],
  firstIcon: {
    type: IconValue,
    default: '$first'
  },
  prevIcon: {
    type: IconValue,
    default: '$prev'
  },
  nextIcon: {
    type: IconValue,
    default: '$next'
  },
  lastIcon: {
    type: IconValue,
    default: '$last'
  },
  ariaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.root'
  },
  pageAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.page'
  },
  currentPageAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.currentPage'
  },
  firstAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.first'
  },
  previousAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.previous'
  },
  nextAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.next'
  },
  lastAriaLabel: {
    type: String,
    default: '$vuetify.pagination.ariaLabel.last'
  },
  ellipsis: {
    type: String,
    default: '...'
  },
  showFirstLastPage: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeRoundedProps(),
  ...makeSizeProps(),
  ...makeTagProps({
    tag: 'nav'
  }),
  ...makeThemeProps(),
  ...makeVariantProps({
    variant: 'text'
  })
}, 'VPagination');
const VPagination = genericComponent()({
  name: 'VPagination',
  props: makeVPaginationProps(),
  emits: {
    'update:modelValue': value => true,
    first: value => true,
    prev: value => true,
    next: value => true,
    last: value => true
  },
  setup(props, _ref) {
    let {
      slots,
      emit
    } = _ref;
    const page = useProxiedModel(props, 'modelValue');
    const {
      t,
      n
    } = useLocale();
    const {
      isRtl
    } = useRtl();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      width
    } = useDisplay();
    const maxButtons = shallowRef(-1);
    provideDefaults(undefined, {
      scoped: true
    });
    const {
      resizeRef
    } = useResizeObserver(entries => {
      if (!entries.length) return;
      const {
        target,
        contentRect
      } = entries[0];
      const firstItem = target.querySelector('.v-pagination__list > *');
      if (!firstItem) return;
      const totalWidth = contentRect.width;
      const itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(firstItem).marginRight) * 2;
      maxButtons.value = getMax(totalWidth, itemWidth);
    });
    const length = computed(() => parseInt(props.length, 10));
    const start = computed(() => parseInt(props.start, 10));
    const totalVisible = computed(() => {
      if (props.totalVisible != null) return parseInt(props.totalVisible, 10);else if (maxButtons.value >= 0) return maxButtons.value;
      return getMax(width.value, 58);
    });
    function getMax(totalWidth, itemWidth) {
      const minButtons = props.showFirstLastPage ? 5 : 3;
      return Math.max(0, Math.floor(
      // Round to two decimal places to avoid floating point errors
      +((totalWidth - itemWidth * minButtons) / itemWidth).toFixed(2)));
    }
    const range = computed(() => {
      if (length.value <= 0 || isNaN(length.value) || length.value > Number.MAX_SAFE_INTEGER) return [];
      if (totalVisible.value <= 0) return [];else if (totalVisible.value === 1) return [page.value];
      if (length.value <= totalVisible.value) {
        return createRange(length.value, start.value);
      }
      const even = totalVisible.value % 2 === 0;
      const middle = even ? totalVisible.value / 2 : Math.floor(totalVisible.value / 2);
      const left = even ? middle : middle + 1;
      const right = length.value - middle;
      if (left - page.value >= 0) {
        return [...createRange(Math.max(1, totalVisible.value - 1), start.value), props.ellipsis, length.value];
      } else if (page.value - right >= (even ? 1 : 0)) {
        const rangeLength = totalVisible.value - 1;
        const rangeStart = length.value - rangeLength + start.value;
        return [start.value, props.ellipsis, ...createRange(rangeLength, rangeStart)];
      } else {
        const rangeLength = Math.max(1, totalVisible.value - 3);
        const rangeStart = rangeLength === 1 ? page.value : page.value - Math.ceil(rangeLength / 2) + start.value;
        return [start.value, props.ellipsis, ...createRange(rangeLength, rangeStart), props.ellipsis, length.value];
      }
    });

    // TODO: 'first' | 'prev' | 'next' | 'last' does not work here?
    function setValue(e, value, event) {
      e.preventDefault();
      page.value = value;
      event && emit(event, value);
    }
    const {
      refs,
      updateRef
    } = useRefs();
    provideDefaults({
      VPaginationBtn: {
        color: toRef(props, 'color'),
        border: toRef(props, 'border'),
        density: toRef(props, 'density'),
        size: toRef(props, 'size'),
        variant: toRef(props, 'variant'),
        rounded: toRef(props, 'rounded'),
        elevation: toRef(props, 'elevation')
      }
    });
    const items = computed(() => {
      return range.value.map((item, index) => {
        const ref = e => updateRef(e, index);
        if (typeof item === 'string') {
          return {
            isActive: false,
            key: `ellipsis-${index}`,
            page: item,
            props: {
              ref,
              ellipsis: true,
              icon: true,
              disabled: true
            }
          };
        } else {
          const isActive = item === page.value;
          return {
            isActive,
            key: item,
            page: n(item),
            props: {
              ref,
              ellipsis: false,
              icon: true,
              disabled: !!props.disabled || +props.length < 2,
              color: isActive ? props.activeColor : props.color,
              'aria-current': isActive,
              'aria-label': t(isActive ? props.currentPageAriaLabel : props.pageAriaLabel, item),
              onClick: e => setValue(e, item)
            }
          };
        }
      });
    });
    const controls = computed(() => {
      const prevDisabled = !!props.disabled || page.value <= start.value;
      const nextDisabled = !!props.disabled || page.value >= start.value + length.value - 1;
      return {
        first: props.showFirstLastPage ? {
          icon: isRtl.value ? props.lastIcon : props.firstIcon,
          onClick: e => setValue(e, start.value, 'first'),
          disabled: prevDisabled,
          'aria-label': t(props.firstAriaLabel),
          'aria-disabled': prevDisabled
        } : undefined,
        prev: {
          icon: isRtl.value ? props.nextIcon : props.prevIcon,
          onClick: e => setValue(e, page.value - 1, 'prev'),
          disabled: prevDisabled,
          'aria-label': t(props.previousAriaLabel),
          'aria-disabled': prevDisabled
        },
        next: {
          icon: isRtl.value ? props.prevIcon : props.nextIcon,
          onClick: e => setValue(e, page.value + 1, 'next'),
          disabled: nextDisabled,
          'aria-label': t(props.nextAriaLabel),
          'aria-disabled': nextDisabled
        },
        last: props.showFirstLastPage ? {
          icon: isRtl.value ? props.firstIcon : props.lastIcon,
          onClick: e => setValue(e, start.value + length.value - 1, 'last'),
          disabled: nextDisabled,
          'aria-label': t(props.lastAriaLabel),
          'aria-disabled': nextDisabled
        } : undefined
      };
    });
    function updateFocus() {
      const currentIndex = page.value - start.value;
      refs.value[currentIndex]?.$el.focus();
    }
    function onKeydown(e) {
      if (e.key === keyValues.left && !props.disabled && page.value > +props.start) {
        page.value = page.value - 1;
        nextTick(updateFocus);
      } else if (e.key === keyValues.right && !props.disabled && page.value < start.value + length.value - 1) {
        page.value = page.value + 1;
        nextTick(updateFocus);
      }
    }
    useRender(() => createVNode(props.tag, {
      "ref": resizeRef,
      "class": ['v-pagination', themeClasses.value, props.class],
      "style": props.style,
      "role": "navigation",
      "aria-label": t(props.ariaLabel),
      "onKeydown": onKeydown,
      "data-test": "v-pagination-root"
    }, {
      default: () => [createVNode("ul", {
        "class": "v-pagination__list"
      }, [props.showFirstLastPage && createVNode("li", {
        "key": "first",
        "class": "v-pagination__first",
        "data-test": "v-pagination-first"
      }, [slots.first ? slots.first(controls.value.first) : createVNode(VBtn, mergeProps({
        "_as": "VPaginationBtn"
      }, controls.value.first), null)]), createVNode("li", {
        "key": "prev",
        "class": "v-pagination__prev",
        "data-test": "v-pagination-prev"
      }, [slots.prev ? slots.prev(controls.value.prev) : createVNode(VBtn, mergeProps({
        "_as": "VPaginationBtn"
      }, controls.value.prev), null)]), items.value.map((item, index) => createVNode("li", {
        "key": item.key,
        "class": ['v-pagination__item', {
          'v-pagination__item--is-active': item.isActive
        }],
        "data-test": "v-pagination-item"
      }, [slots.item ? slots.item(item) : createVNode(VBtn, mergeProps({
        "_as": "VPaginationBtn"
      }, item.props), {
        default: () => [item.page]
      })])), createVNode("li", {
        "key": "next",
        "class": "v-pagination__next",
        "data-test": "v-pagination-next"
      }, [slots.next ? slots.next(controls.value.next) : createVNode(VBtn, mergeProps({
        "_as": "VPaginationBtn"
      }, controls.value.next), null)]), props.showFirstLastPage && createVNode("li", {
        "key": "last",
        "class": "v-pagination__last",
        "data-test": "v-pagination-last"
      }, [slots.last ? slots.last(controls.value.last) : createVNode(VBtn, mergeProps({
        "_as": "VPaginationBtn"
      }, controls.value.last), null)])])]
    }));
    return {};
  }
});

const makeVDataTableFooterProps = propsFactory({
  prevIcon: {
    type: IconValue,
    default: '$prev'
  },
  nextIcon: {
    type: IconValue,
    default: '$next'
  },
  firstIcon: {
    type: IconValue,
    default: '$first'
  },
  lastIcon: {
    type: IconValue,
    default: '$last'
  },
  itemsPerPageText: {
    type: String,
    default: '$vuetify.dataFooter.itemsPerPageText'
  },
  pageText: {
    type: String,
    default: '$vuetify.dataFooter.pageText'
  },
  firstPageLabel: {
    type: String,
    default: '$vuetify.dataFooter.firstPage'
  },
  prevPageLabel: {
    type: String,
    default: '$vuetify.dataFooter.prevPage'
  },
  nextPageLabel: {
    type: String,
    default: '$vuetify.dataFooter.nextPage'
  },
  lastPageLabel: {
    type: String,
    default: '$vuetify.dataFooter.lastPage'
  },
  itemsPerPageOptions: {
    type: Array,
    default: () => [{
      value: 10,
      title: '10'
    }, {
      value: 25,
      title: '25'
    }, {
      value: 50,
      title: '50'
    }, {
      value: 100,
      title: '100'
    }, {
      value: -1,
      title: '$vuetify.dataFooter.itemsPerPageAll'
    }]
  },
  showCurrentPage: Boolean
}, 'VDataTableFooter');
const VDataTableFooter = genericComponent()({
  name: 'VDataTableFooter',
  props: makeVDataTableFooterProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const {
      page,
      pageCount,
      startIndex,
      stopIndex,
      itemsLength,
      itemsPerPage,
      setItemsPerPage
    } = usePagination();
    const itemsPerPageOptions = computed(() => props.itemsPerPageOptions.map(option => {
      if (typeof option === 'number') {
        return {
          value: option,
          title: option === -1 ? t('$vuetify.dataFooter.itemsPerPageAll') : String(option)
        };
      }
      return {
        ...option,
        title: !isNaN(Number(option.title)) ? option.title : t(option.title)
      };
    }));
    useRender(() => {
      const paginationProps = VPagination.filterProps(props);
      return createVNode("div", {
        "class": "v-data-table-footer"
      }, [slots.prepend?.(), createVNode("div", {
        "class": "v-data-table-footer__items-per-page"
      }, [createVNode("span", null, [t(props.itemsPerPageText)]), createVNode(VSelect, {
        "items": itemsPerPageOptions.value,
        "modelValue": itemsPerPage.value,
        "onUpdate:modelValue": v => setItemsPerPage(Number(v)),
        "density": "compact",
        "variant": "outlined",
        "hide-details": true
      }, null)]), createVNode("div", {
        "class": "v-data-table-footer__info"
      }, [createVNode("div", null, [t(props.pageText, !itemsLength.value ? 0 : startIndex.value + 1, stopIndex.value, itemsLength.value)])]), createVNode("div", {
        "class": "v-data-table-footer__pagination"
      }, [createVNode(VPagination, mergeProps({
        "modelValue": page.value,
        "onUpdate:modelValue": $event => page.value = $event,
        "density": "comfortable",
        "first-aria-label": props.firstPageLabel,
        "last-aria-label": props.lastPageLabel,
        "length": pageCount.value,
        "next-aria-label": props.nextPageLabel,
        "previous-aria-label": props.prevPageLabel,
        "rounded": true,
        "show-first-last-page": true,
        "total-visible": props.showCurrentPage ? 1 : 0,
        "variant": "plain"
      }, paginationProps), null)])]);
    });
    return {};
  }
});

const VDataTableColumn = defineFunctionalComponent({
  align: {
    type: String,
    default: 'start'
  },
  fixed: Boolean,
  fixedOffset: [Number, String],
  height: [Number, String],
  lastFixed: Boolean,
  noPadding: Boolean,
  tag: String,
  width: [Number, String],
  maxWidth: [Number, String],
  nowrap: Boolean
}, (props, _ref) => {
  let {
    slots
  } = _ref;
  const Tag = props.tag ?? 'td';
  return createVNode(Tag, {
    "class": ['v-data-table__td', {
      'v-data-table-column--fixed': props.fixed,
      'v-data-table-column--last-fixed': props.lastFixed,
      'v-data-table-column--no-padding': props.noPadding,
      'v-data-table-column--nowrap': props.nowrap
    }, `v-data-table-column--align-${props.align}`],
    "style": {
      height: convertToUnit(props.height),
      width: convertToUnit(props.width),
      maxWidth: convertToUnit(props.maxWidth),
      left: convertToUnit(props.fixedOffset || null)
    }
  }, {
    default: () => [slots.default?.()]
  });
});

// Utilities
const makeDataTableHeaderProps = propsFactory({
  headers: Array
}, 'DataTable-header');
const VDataTableHeadersSymbol = Symbol.for('vuetify:data-table-headers');
const defaultHeader = {
  title: '',
  sortable: false
};
const defaultActionHeader = {
  ...defaultHeader,
  width: 48
};
function priorityQueue() {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const queue = arr.map(element => ({
    element,
    priority: 0
  }));
  return {
    enqueue: (element, priority) => {
      let added = false;
      for (let i = 0; i < queue.length; i++) {
        const item = queue[i];
        if (item.priority > priority) {
          queue.splice(i, 0, {
            element,
            priority
          });
          added = true;
          break;
        }
      }
      if (!added) queue.push({
        element,
        priority
      });
    },
    size: () => queue.length,
    count: () => {
      let count = 0;
      if (!queue.length) return 0;
      const whole = Math.floor(queue[0].priority);
      for (let i = 0; i < queue.length; i++) {
        if (Math.floor(queue[i].priority) === whole) count += 1;
      }
      return count;
    },
    dequeue: () => {
      return queue.shift();
    }
  };
}
function extractLeaves(item) {
  let columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!item.children) {
    columns.push(item);
  } else {
    for (const child of item.children) {
      extractLeaves(child, columns);
    }
  }
  return columns;
}
function extractKeys(headers) {
  let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  for (const item of headers) {
    if (item.key) keys.add(item.key);
    if (item.children) {
      extractKeys(item.children, keys);
    }
  }
  return keys;
}
function getDefaultItem(item) {
  if (!item.key) return undefined;
  if (item.key === 'data-table-group') return defaultHeader;
  if (['data-table-expand', 'data-table-select'].includes(item.key)) return defaultActionHeader;
  return undefined;
}
function getDepth(item) {
  let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!item.children) return depth;
  return Math.max(depth, ...item.children.map(child => getDepth(child, depth + 1)));
}
function parseFixedColumns(items) {
  let seenFixed = false;
  function setFixed(item) {
    let parentFixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!item) return;
    if (parentFixed) {
      item.fixed = true;
    }
    if (item.fixed) {
      if (item.children) {
        for (let i = item.children.length - 1; i >= 0; i--) {
          setFixed(item.children[i], true);
        }
      } else {
        if (!seenFixed) {
          item.lastFixed = true;
        } else if (isNaN(+item.width)) {
          consoleError(`Multiple fixed columns should have a static width (key: ${item.key})`);
        }
        seenFixed = true;
      }
    } else {
      if (item.children) {
        for (let i = item.children.length - 1; i >= 0; i--) {
          setFixed(item.children[i]);
        }
      } else {
        seenFixed = false;
      }
    }
  }
  for (let i = items.length - 1; i >= 0; i--) {
    setFixed(items[i]);
  }
  function setFixedOffset(item) {
    let fixedOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item) return fixedOffset;
    if (item.children) {
      item.fixedOffset = fixedOffset;
      for (const child of item.children) {
        fixedOffset = setFixedOffset(child, fixedOffset);
      }
    } else if (item.fixed) {
      item.fixedOffset = fixedOffset;
      fixedOffset += parseFloat(item.width || '0') || 0;
    }
    return fixedOffset;
  }
  let fixedOffset = 0;
  for (const item of items) {
    fixedOffset = setFixedOffset(item, fixedOffset);
  }
}
function parse(items, maxDepth) {
  const headers = [];
  let currentDepth = 0;
  const queue = priorityQueue(items);
  while (queue.size() > 0) {
    let rowSize = queue.count();
    const row = [];
    let fraction = 1;
    while (rowSize > 0) {
      const {
        element: item,
        priority
      } = queue.dequeue();
      const diff = maxDepth - currentDepth - getDepth(item);
      row.push({
        ...item,
        rowspan: diff ?? 1,
        colspan: item.children ? extractLeaves(item).length : 1
      });
      if (item.children) {
        for (const child of item.children) {
          // This internally sorts items that are on the same priority "row"
          const sort = priority % 1 + fraction / Math.pow(10, currentDepth + 2);
          queue.enqueue(child, currentDepth + diff + sort);
        }
      }
      fraction += 1;
      rowSize -= 1;
    }
    currentDepth += 1;
    headers.push(row);
  }
  const columns = items.map(item => extractLeaves(item)).flat();
  return {
    columns,
    headers
  };
}
function convertToInternalHeaders(items) {
  const internalHeaders = [];
  for (const item of items) {
    const defaultItem = {
      ...getDefaultItem(item),
      ...item
    };
    const key = defaultItem.key ?? (typeof defaultItem.value === 'string' ? defaultItem.value : null);
    const value = defaultItem.value ?? key ?? null;
    const internalItem = {
      ...defaultItem,
      key,
      value,
      sortable: defaultItem.sortable ?? (defaultItem.key != null || !!defaultItem.sort),
      children: defaultItem.children ? convertToInternalHeaders(defaultItem.children) : undefined
    };
    internalHeaders.push(internalItem);
  }
  return internalHeaders;
}
function createHeaders(props, options) {
  const headers = ref([]);
  const columns = ref([]);
  const sortFunctions = ref({});
  const sortRawFunctions = ref({});
  const filterFunctions = ref({});
  watchEffect(() => {
    const _headers = props.headers || Object.keys(props.items[0] ?? {}).map(key => ({
      key,
      title: capitalize(key)
    }));
    const items = _headers.slice();
    const keys = extractKeys(items);
    if (options?.groupBy?.value.length && !keys.has('data-table-group')) {
      items.unshift({
        key: 'data-table-group',
        title: 'Group'
      });
    }
    if (options?.showSelect?.value && !keys.has('data-table-select')) {
      items.unshift({
        key: 'data-table-select'
      });
    }
    if (options?.showExpand?.value && !keys.has('data-table-expand')) {
      items.push({
        key: 'data-table-expand'
      });
    }
    const internalHeaders = convertToInternalHeaders(items);
    parseFixedColumns(internalHeaders);
    const maxDepth = Math.max(...internalHeaders.map(item => getDepth(item))) + 1;
    const parsed = parse(internalHeaders, maxDepth);
    headers.value = parsed.headers;
    columns.value = parsed.columns;
    const flatHeaders = parsed.headers.flat(1);
    for (const header of flatHeaders) {
      if (!header.key) continue;
      if (header.sortable) {
        if (header.sort) {
          sortFunctions.value[header.key] = header.sort;
        }
        if (header.sortRaw) {
          sortRawFunctions.value[header.key] = header.sortRaw;
        }
      }
      if (header.filter) {
        filterFunctions.value[header.key] = header.filter;
      }
    }
  });
  const data = {
    headers,
    columns,
    sortFunctions,
    sortRawFunctions,
    filterFunctions
  };
  provide(VDataTableHeadersSymbol, data);
  return data;
}
function useHeaders() {
  const data = inject$2(VDataTableHeadersSymbol);
  if (!data) throw new Error('Missing headers!');
  return data;
}

const makeVDataTableHeadersProps = propsFactory({
  color: String,
  sticky: Boolean,
  disableSort: Boolean,
  multiSort: Boolean,
  sortAscIcon: {
    type: IconValue,
    default: '$sortAsc'
  },
  sortDescIcon: {
    type: IconValue,
    default: '$sortDesc'
  },
  headerProps: {
    type: Object
  },
  ...makeDisplayProps(),
  ...makeLoaderProps()
}, 'VDataTableHeaders');
const VDataTableHeaders = genericComponent()({
  name: 'VDataTableHeaders',
  props: makeVDataTableHeadersProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const {
      toggleSort,
      sortBy,
      isSorted
    } = useSort();
    const {
      someSelected,
      allSelected,
      selectAll,
      showSelectAll
    } = useSelection();
    const {
      columns,
      headers
    } = useHeaders();
    const {
      loaderClasses
    } = useLoader(props);
    function getFixedStyles(column, y) {
      if (!props.sticky && !column.fixed) return undefined;
      return {
        position: 'sticky',
        left: column.fixed ? convertToUnit(column.fixedOffset) : undefined,
        top: props.sticky ? `calc(var(--v-table-header-height) * ${y})` : undefined
      };
    }
    function getSortIcon(column) {
      const item = sortBy.value.find(item => item.key === column.key);
      if (!item) return props.sortAscIcon;
      return item.order === 'asc' ? props.sortAscIcon : props.sortDescIcon;
    }
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(props, 'color');
    const {
      displayClasses,
      mobile
    } = useDisplay(props);
    const slotProps = computed(() => ({
      headers: headers.value,
      columns: columns.value,
      toggleSort,
      isSorted,
      sortBy: sortBy.value,
      someSelected: someSelected.value,
      allSelected: allSelected.value,
      selectAll,
      getSortIcon
    }));
    const headerCellClasses = computed(() => ['v-data-table__th', {
      'v-data-table__th--sticky': props.sticky
    }, displayClasses.value, loaderClasses.value]);
    const VDataTableHeaderCell = _ref2 => {
      let {
        column,
        x,
        y
      } = _ref2;
      const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
      const headerProps = mergeProps(props.headerProps ?? {}, column.headerProps ?? {});
      return createVNode(VDataTableColumn, mergeProps({
        "tag": "th",
        "align": column.align,
        "class": [{
          'v-data-table__th--sortable': column.sortable && !props.disableSort,
          'v-data-table__th--sorted': isSorted(column),
          'v-data-table__th--fixed': column.fixed
        }, ...headerCellClasses.value],
        "style": {
          width: convertToUnit(column.width),
          minWidth: convertToUnit(column.minWidth),
          maxWidth: convertToUnit(column.maxWidth),
          ...getFixedStyles(column, y)
        },
        "colspan": column.colspan,
        "rowspan": column.rowspan,
        "onClick": column.sortable ? () => toggleSort(column) : undefined,
        "fixed": column.fixed,
        "nowrap": column.nowrap,
        "lastFixed": column.lastFixed,
        "noPadding": noPadding
      }, headerProps), {
        default: () => {
          const columnSlotName = `header.${column.key}`;
          const columnSlotProps = {
            column,
            selectAll,
            isSorted,
            toggleSort,
            sortBy: sortBy.value,
            someSelected: someSelected.value,
            allSelected: allSelected.value,
            getSortIcon
          };
          if (slots[columnSlotName]) return slots[columnSlotName](columnSlotProps);
          if (column.key === 'data-table-select') {
            return slots['header.data-table-select']?.(columnSlotProps) ?? (showSelectAll.value && createVNode(VCheckboxBtn, {
              "modelValue": allSelected.value,
              "indeterminate": someSelected.value && !allSelected.value,
              "onUpdate:modelValue": selectAll
            }, null));
          }
          return createVNode("div", {
            "class": "v-data-table-header__content"
          }, [createVNode("span", null, [column.title]), column.sortable && !props.disableSort && createVNode(VIcon, {
            "key": "icon",
            "class": "v-data-table-header__sort-icon",
            "icon": getSortIcon(column)
          }, null), props.multiSort && isSorted(column) && createVNode("div", {
            "key": "badge",
            "class": ['v-data-table-header__sort-badge', ...backgroundColorClasses.value],
            "style": backgroundColorStyles.value
          }, [sortBy.value.findIndex(x => x.key === column.key) + 1])]);
        }
      });
    };
    const VDataTableMobileHeaderCell = () => {
      const headerProps = mergeProps(props.headerProps ?? {} ?? {});
      const displayItems = computed(() => {
        return columns.value.filter(column => column?.sortable && !props.disableSort);
      });
      const appendIcon = computed(() => {
        const showSelectColumn = columns.value.find(column => column.key === 'data-table-select');
        if (showSelectColumn == null) return;
        return allSelected.value ? '$checkboxOn' : someSelected.value ? '$checkboxIndeterminate' : '$checkboxOff';
      });
      return createVNode(VDataTableColumn, mergeProps({
        "tag": "th",
        "class": [...headerCellClasses.value],
        "colspan": headers.value.length + 1
      }, headerProps), {
        default: () => [createVNode("div", {
          "class": "v-data-table-header__content"
        }, [createVNode(VSelect, {
          "chips": true,
          "class": "v-data-table__td-sort-select",
          "clearable": true,
          "density": "default",
          "items": displayItems.value,
          "label": t('$vuetify.dataTable.sortBy'),
          "multiple": props.multiSort,
          "variant": "underlined",
          "onClick:clear": () => sortBy.value = [],
          "appendIcon": appendIcon.value,
          "onClick:append": () => selectAll(!allSelected.value)
        }, {
          ...slots,
          chip: props => createVNode(VChip, {
            "onClick": props.item.raw?.sortable ? () => toggleSort(props.item.raw) : undefined,
            "onMousedown": e => {
              e.preventDefault();
              e.stopPropagation();
            }
          }, {
            default: () => [props.item.title, createVNode(VIcon, {
              "class": ['v-data-table__td-sort-icon', isSorted(props.item.raw) && 'v-data-table__td-sort-icon-active'],
              "icon": getSortIcon(props.item.raw),
              "size": "small"
            }, null)]
          })
        })])]
      });
    };
    useRender(() => {
      return mobile.value ? createVNode("tr", null, [createVNode(VDataTableMobileHeaderCell, null, null)]) : createVNode(Fragment, null, [slots.headers ? slots.headers(slotProps.value) : headers.value.map((row, y) => createVNode("tr", null, [row.map((column, x) => createVNode(VDataTableHeaderCell, {
        "column": column,
        "x": x,
        "y": y
      }, null))])), props.loading && createVNode("tr", {
        "class": "v-data-table-progress"
      }, [createVNode("th", {
        "colspan": columns.value.length
      }, [createVNode(LoaderSlot, {
        "name": "v-data-table-progress",
        "absolute": true,
        "active": true,
        "color": typeof props.loading === 'boolean' ? undefined : props.loading,
        "indeterminate": true
      }, {
        default: slots.loader
      })])])]);
    });
  }
});

const makeVDataTableGroupHeaderRowProps = propsFactory({
  item: {
    type: Object,
    required: true
  }
}, 'VDataTableGroupHeaderRow');
const VDataTableGroupHeaderRow = genericComponent()({
  name: 'VDataTableGroupHeaderRow',
  props: makeVDataTableGroupHeaderRowProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      isGroupOpen,
      toggleGroup,
      extractRows
    } = useGroupBy();
    const {
      isSelected,
      isSomeSelected,
      select
    } = useSelection();
    const {
      columns
    } = useHeaders();
    const rows = computed(() => {
      return extractRows([props.item]);
    });
    return () => createVNode("tr", {
      "class": "v-data-table-group-header-row",
      "style": {
        '--v-data-table-group-header-row-depth': props.item.depth
      }
    }, [columns.value.map(column => {
      if (column.key === 'data-table-group') {
        const icon = isGroupOpen(props.item) ? '$expand' : '$next';
        const onClick = () => toggleGroup(props.item);
        return slots['data-table-group']?.({
          item: props.item,
          count: rows.value.length,
          props: {
            icon,
            onClick
          }
        }) ?? createVNode(VDataTableColumn, {
          "class": "v-data-table-group-header-row__column"
        }, {
          default: () => [createVNode(VBtn, {
            "size": "small",
            "variant": "text",
            "icon": icon,
            "onClick": onClick
          }, null), createVNode("span", null, [props.item.value]), createVNode("span", null, [createTextVNode("("), rows.value.length, createTextVNode(")")])]
        });
      }
      if (column.key === 'data-table-select') {
        const modelValue = isSelected(rows.value);
        const indeterminate = isSomeSelected(rows.value) && !modelValue;
        const selectGroup = v => select(rows.value, v);
        return slots['data-table-select']?.({
          props: {
            modelValue,
            indeterminate,
            'onUpdate:modelValue': selectGroup
          }
        }) ?? createVNode("td", null, [createVNode(VCheckboxBtn, {
          "modelValue": modelValue,
          "indeterminate": indeterminate,
          "onUpdate:modelValue": selectGroup
        }, null)]);
      }
      return createVNode("td", null, null);
    })]);
  }
});

const makeVDataTableRowProps = propsFactory({
  index: Number,
  item: Object,
  cellProps: [Object, Function],
  onClick: EventProp(),
  onContextmenu: EventProp(),
  onDblclick: EventProp(),
  ...makeDisplayProps()
}, 'VDataTableRow');
const VDataTableRow = genericComponent()({
  name: 'VDataTableRow',
  props: makeVDataTableRowProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      displayClasses,
      mobile
    } = useDisplay(props, 'v-data-table__tr');
    const {
      isSelected,
      toggleSelect,
      someSelected,
      allSelected,
      selectAll
    } = useSelection();
    const {
      isExpanded,
      toggleExpand
    } = useExpanded();
    const {
      toggleSort,
      sortBy,
      isSorted
    } = useSort();
    const {
      columns
    } = useHeaders();
    useRender(() => createVNode("tr", {
      "class": ['v-data-table__tr', {
        'v-data-table__tr--clickable': !!(props.onClick || props.onContextmenu || props.onDblclick)
      }, displayClasses.value],
      "onClick": props.onClick,
      "onContextmenu": props.onContextmenu,
      "onDblclick": props.onDblclick
    }, [props.item && columns.value.map((column, i) => {
      const item = props.item;
      const slotName = `item.${column.key}`;
      const headerSlotName = `header.${column.key}`;
      const slotProps = {
        index: props.index,
        item: item.raw,
        internalItem: item,
        value: getObjectValueByPath(item.columns, column.key),
        column,
        isSelected,
        toggleSelect,
        isExpanded,
        toggleExpand
      };
      const columnSlotProps = {
        column,
        selectAll,
        isSorted,
        toggleSort,
        sortBy: sortBy.value,
        someSelected: someSelected.value,
        allSelected: allSelected.value,
        getSortIcon: () => ''
      };
      const cellProps = typeof props.cellProps === 'function' ? props.cellProps({
        index: slotProps.index,
        item: slotProps.item,
        internalItem: slotProps.internalItem,
        value: slotProps.value,
        column
      }) : props.cellProps;
      const columnCellProps = typeof column.cellProps === 'function' ? column.cellProps({
        index: slotProps.index,
        item: slotProps.item,
        internalItem: slotProps.internalItem,
        value: slotProps.value
      }) : column.cellProps;
      return createVNode(VDataTableColumn, mergeProps({
        "align": column.align,
        "class": {
          'v-data-table__td--expanded-row': column.key === 'data-table-expand',
          'v-data-table__td--select-row': column.key === 'data-table-select'
        },
        "fixed": column.fixed,
        "fixedOffset": column.fixedOffset,
        "lastFixed": column.lastFixed,
        "maxWidth": !mobile.value ? column.maxWidth : undefined,
        "noPadding": column.key === 'data-table-select' || column.key === 'data-table-expand',
        "nowrap": column.nowrap,
        "width": !mobile.value ? column.width : undefined
      }, cellProps, columnCellProps), {
        default: () => {
          if (slots[slotName] && !mobile.value) return slots[slotName]?.(slotProps);
          if (column.key === 'data-table-select') {
            return slots['item.data-table-select']?.(slotProps) ?? createVNode(VCheckboxBtn, {
              "disabled": !item.selectable,
              "modelValue": isSelected([item]),
              "onClick": withModifiers(() => toggleSelect(item), ['stop'])
            }, null);
          }
          if (column.key === 'data-table-expand') {
            return slots['item.data-table-expand']?.(slotProps) ?? createVNode(VBtn, {
              "icon": isExpanded(item) ? '$collapse' : '$expand',
              "size": "small",
              "variant": "text",
              "onClick": withModifiers(() => toggleExpand(item), ['stop'])
            }, null);
          }
          const displayValue = toDisplayString(slotProps.value);
          return !mobile.value ? displayValue : createVNode(Fragment, null, [createVNode("div", {
            "class": "v-data-table__td-title"
          }, [slots[headerSlotName]?.(columnSlotProps) ?? column.title]), createVNode("div", {
            "class": "v-data-table__td-value"
          }, [slots[slotName]?.(slotProps) ?? displayValue])]);
        }
      });
    })]));
  }
});

const makeVDataTableRowsProps = propsFactory({
  loading: [Boolean, String],
  loadingText: {
    type: String,
    default: '$vuetify.dataIterator.loadingText'
  },
  hideNoData: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  noDataText: {
    type: String,
    default: '$vuetify.noDataText'
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  ...makeDisplayProps()
}, 'VDataTableRows');
const VDataTableRows = genericComponent()({
  name: 'VDataTableRows',
  inheritAttrs: false,
  props: makeVDataTableRowsProps(),
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      columns
    } = useHeaders();
    const {
      expandOnClick,
      toggleExpand,
      isExpanded
    } = useExpanded();
    const {
      isSelected,
      toggleSelect
    } = useSelection();
    const {
      toggleGroup,
      isGroupOpen
    } = useGroupBy();
    const {
      t
    } = useLocale();
    const {
      mobile
    } = useDisplay(props);
    useRender(() => {
      if (props.loading && (!props.items.length || slots.loading)) {
        return createVNode("tr", {
          "class": "v-data-table-rows-loading",
          "key": "loading"
        }, [createVNode("td", {
          "colspan": columns.value.length
        }, [slots.loading?.() ?? t(props.loadingText)])]);
      }
      if (!props.loading && !props.items.length && !props.hideNoData) {
        return createVNode("tr", {
          "class": "v-data-table-rows-no-data",
          "key": "no-data"
        }, [createVNode("td", {
          "colspan": columns.value.length
        }, [slots['no-data']?.() ?? t(props.noDataText)])]);
      }
      return createVNode(Fragment, null, [props.items.map((item, index) => {
        if (item.type === 'group') {
          const slotProps = {
            index,
            item,
            columns: columns.value,
            isExpanded,
            toggleExpand,
            isSelected,
            toggleSelect,
            toggleGroup,
            isGroupOpen
          };
          return slots['group-header'] ? slots['group-header'](slotProps) : createVNode(VDataTableGroupHeaderRow, mergeProps({
            "key": `group-header_${item.id}`,
            "item": item
          }, getPrefixedEventHandlers(attrs, ':group-header', () => slotProps)), slots);
        }
        const slotProps = {
          index,
          item: item.raw,
          internalItem: item,
          columns: columns.value,
          isExpanded,
          toggleExpand,
          isSelected,
          toggleSelect
        };
        const itemSlotProps = {
          ...slotProps,
          props: mergeProps({
            key: `item_${item.key ?? item.index}`,
            onClick: expandOnClick.value ? () => {
              toggleExpand(item);
            } : undefined,
            index,
            item,
            cellProps: props.cellProps,
            mobile: mobile.value
          }, getPrefixedEventHandlers(attrs, ':row', () => slotProps), typeof props.rowProps === 'function' ? props.rowProps({
            item: slotProps.item,
            index: slotProps.index,
            internalItem: slotProps.internalItem
          }) : props.rowProps)
        };
        return createVNode(Fragment, {
          "key": itemSlotProps.props.key
        }, [slots.item ? slots.item(itemSlotProps) : createVNode(VDataTableRow, itemSlotProps.props, slots), isExpanded(item) && slots['expanded-row']?.(slotProps)]);
      })]);
    });
    return {};
  }
});

const makeVTableProps = propsFactory({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeTagProps(),
  ...makeThemeProps()
}, 'VTable');
const VTable = genericComponent()({
  name: 'VTable',
  props: makeVTableProps(),
  setup(props, _ref) {
    let {
      slots,
      emit
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      densityClasses
    } = useDensity(props);
    useRender(() => createVNode(props.tag, {
      "class": ['v-table', {
        'v-table--fixed-height': !!props.height,
        'v-table--fixed-header': props.fixedHeader,
        'v-table--fixed-footer': props.fixedFooter,
        'v-table--has-top': !!slots.top,
        'v-table--has-bottom': !!slots.bottom,
        'v-table--hover': props.hover
      }, themeClasses.value, densityClasses.value, props.class],
      "style": props.style
    }, {
      default: () => [slots.top?.(), slots.default ? createVNode("div", {
        "class": "v-table__wrapper",
        "style": {
          height: convertToUnit(props.height)
        }
      }, [createVNode("table", null, [slots.default()])]) : slots.wrapper?.(), slots.bottom?.()]
    }));
    return {};
  }
});

// Utilities
// Composables
const makeDataTableItemsProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  itemValue: {
    type: [String, Array, Function],
    default: 'id'
  },
  itemSelectable: {
    type: [String, Array, Function],
    default: null
  },
  rowProps: [Object, Function],
  cellProps: [Object, Function],
  returnObject: Boolean
}, 'DataTable-items');
function transformItem(props, item, index, columns) {
  const value = props.returnObject ? item : getPropertyFromItem(item, props.itemValue);
  const selectable = getPropertyFromItem(item, props.itemSelectable, true);
  const itemColumns = columns.reduce((obj, column) => {
    if (column.key != null) obj[column.key] = getPropertyFromItem(item, column.value);
    return obj;
  }, {});
  return {
    type: 'item',
    key: props.returnObject ? getPropertyFromItem(item, props.itemValue) : value,
    index,
    value,
    selectable,
    columns: itemColumns,
    raw: item
  };
}
function transformItems(props, items, columns) {
  return items.map((item, index) => transformItem(props, item, index, columns));
}
function useDataTableItems(props, columns) {
  const items = computed(() => transformItems(props, props.items, columns.value));
  return {
    items
  };
}

const makeDataTableProps = propsFactory({
  ...makeVDataTableRowsProps(),
  hideDefaultBody: Boolean,
  hideDefaultFooter: Boolean,
  hideDefaultHeader: Boolean,
  width: [String, Number],
  search: String,
  ...makeDataTableExpandProps(),
  ...makeDataTableGroupProps(),
  ...makeDataTableHeaderProps(),
  ...makeDataTableItemsProps(),
  ...makeDataTableSelectProps(),
  ...makeDataTableSortProps(),
  ...makeVDataTableHeadersProps(),
  ...makeVTableProps()
}, 'DataTable');
const makeVDataTableProps = propsFactory({
  ...makeDataTablePaginateProps(),
  ...makeDataTableProps(),
  ...makeFilterProps(),
  ...makeVDataTableFooterProps()
}, 'VDataTable');
const VDataTable = genericComponent()({
  name: 'VDataTable',
  props: makeVDataTableProps(),
  emits: {
    'update:modelValue': value => true,
    'update:page': value => true,
    'update:itemsPerPage': value => true,
    'update:sortBy': value => true,
    'update:options': value => true,
    'update:groupBy': value => true,
    'update:expanded': value => true,
    'update:currentItems': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const {
      groupBy
    } = createGroupBy(props);
    const {
      sortBy,
      multiSort,
      mustSort
    } = createSort(props);
    const {
      page,
      itemsPerPage
    } = createPagination(props);
    const {
      disableSort
    } = toRefs(props);
    const {
      columns,
      headers,
      sortFunctions,
      sortRawFunctions,
      filterFunctions
    } = createHeaders(props, {
      groupBy,
      showSelect: toRef(props, 'showSelect'),
      showExpand: toRef(props, 'showExpand')
    });
    const {
      items
    } = useDataTableItems(props, columns);
    const search = toRef(props, 'search');
    const {
      filteredItems
    } = useFilter(props, items, search, {
      transform: item => item.columns,
      customKeyFilter: filterFunctions
    });
    const {
      toggleSort
    } = provideSort({
      sortBy,
      multiSort,
      mustSort,
      page
    });
    const {
      sortByWithGroups,
      opened,
      extractRows,
      isGroupOpen,
      toggleGroup
    } = provideGroupBy({
      groupBy,
      sortBy,
      disableSort
    });
    const {
      sortedItems
    } = useSortedItems(props, filteredItems, sortByWithGroups, {
      transform: item => ({
        ...item.raw,
        ...item.columns
      }),
      sortFunctions,
      sortRawFunctions
    });
    const {
      flatItems
    } = useGroupedItems(sortedItems, groupBy, opened);
    const itemsLength = computed(() => flatItems.value.length);
    const {
      startIndex,
      stopIndex,
      pageCount,
      setItemsPerPage
    } = providePagination({
      page,
      itemsPerPage,
      itemsLength
    });
    const {
      paginatedItems
    } = usePaginatedItems({
      items: flatItems,
      startIndex,
      stopIndex,
      itemsPerPage
    });
    const paginatedItemsWithoutGroups = computed(() => extractRows(paginatedItems.value));
    const {
      isSelected,
      select,
      selectAll,
      toggleSelect,
      someSelected,
      allSelected
    } = provideSelection(props, {
      allItems: items,
      currentPage: paginatedItemsWithoutGroups
    });
    const {
      isExpanded,
      toggleExpand
    } = provideExpanded(props);
    useOptions({
      page,
      itemsPerPage,
      sortBy,
      groupBy,
      search
    });
    provideDefaults({
      VDataTableRows: {
        hideNoData: toRef(props, 'hideNoData'),
        noDataText: toRef(props, 'noDataText'),
        loading: toRef(props, 'loading'),
        loadingText: toRef(props, 'loadingText')
      }
    });
    const slotProps = computed(() => ({
      page: page.value,
      itemsPerPage: itemsPerPage.value,
      sortBy: sortBy.value,
      pageCount: pageCount.value,
      toggleSort,
      setItemsPerPage,
      someSelected: someSelected.value,
      allSelected: allSelected.value,
      isSelected,
      select,
      selectAll,
      toggleSelect,
      isExpanded,
      toggleExpand,
      isGroupOpen,
      toggleGroup,
      items: paginatedItemsWithoutGroups.value.map(item => item.raw),
      internalItems: paginatedItemsWithoutGroups.value,
      groupedItems: paginatedItems.value,
      columns: columns.value,
      headers: headers.value
    }));
    useRender(() => {
      const dataTableFooterProps = VDataTableFooter.filterProps(props);
      const dataTableHeadersProps = VDataTableHeaders.filterProps(props);
      const dataTableRowsProps = VDataTableRows.filterProps(props);
      const tableProps = VTable.filterProps(props);
      return createVNode(VTable, mergeProps({
        "class": ['v-data-table', {
          'v-data-table--show-select': props.showSelect,
          'v-data-table--loading': props.loading
        }, props.class],
        "style": props.style
      }, tableProps), {
        top: () => slots.top?.(slotProps.value),
        default: () => slots.default ? slots.default(slotProps.value) : createVNode(Fragment, null, [slots.colgroup?.(slotProps.value), !props.hideDefaultHeader && createVNode("thead", {
          "key": "thead"
        }, [createVNode(VDataTableHeaders, dataTableHeadersProps, slots)]), slots.thead?.(slotProps.value), !props.hideDefaultBody && createVNode("tbody", null, [slots['body.prepend']?.(slotProps.value), slots.body ? slots.body(slotProps.value) : createVNode(VDataTableRows, mergeProps(attrs, dataTableRowsProps, {
          "items": paginatedItems.value
        }), slots), slots['body.append']?.(slotProps.value)]), slots.tbody?.(slotProps.value), slots.tfoot?.(slotProps.value)]),
        bottom: () => slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && createVNode(Fragment, null, [createVNode(VDivider, null, null), createVNode(VDataTableFooter, dataTableFooterProps, {
          prepend: slots['footer.prepend']
        })])
      });
    });
    return {};
  }
});

const makeVContainerProps = propsFactory({
  fluid: {
    type: Boolean,
    default: false
  },
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeTagProps()
}, 'VContainer');
const VContainer = genericComponent()({
  name: 'VContainer',
  props: makeVContainerProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      rtlClasses
    } = useRtl();
    const {
      dimensionStyles
    } = useDimension(props);
    useRender(() => createVNode(props.tag, {
      "class": ['v-container', {
        'v-container--fluid': props.fluid
      }, rtlClasses.value, props.class],
      "style": [dimensionStyles.value, props.style]
    }, slots));
    return {};
  }
});

// Styles
const breakpointProps = (() => {
  return breakpoints.reduce((props, val) => {
    props[val] = {
      type: [Boolean, String, Number],
      default: false
    };
    return props;
  }, {});
})();
const offsetProps = (() => {
  return breakpoints.reduce((props, val) => {
    const offsetKey = 'offset' + capitalize(val);
    props[offsetKey] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
})();
const orderProps = (() => {
  return breakpoints.reduce((props, val) => {
    const orderKey = 'order' + capitalize(val);
    props[orderKey] = {
      type: [String, Number],
      default: null
    };
    return props;
  }, {});
})();
const propMap$1 = {
  col: Object.keys(breakpointProps),
  offset: Object.keys(offsetProps),
  order: Object.keys(orderProps)
};
function breakpointClass$1(type, prop, val) {
  let className = type;
  if (val == null || val === false) {
    return undefined;
  }
  if (prop) {
    const breakpoint = prop.replace(type, '');
    className += `-${breakpoint}`;
  }
  if (type === 'col') {
    className = 'v-' + className;
  }
  // Handling the boolean style prop when accepting [Boolean, String, Number]
  // means Vue will not convert <v-col sm></v-col> to sm: true for us.
  // Since the default is false, an empty string indicates the prop's presence.
  if (type === 'col' && (val === '' || val === true)) {
    // .v-col-md
    return className.toLowerCase();
  }
  // .order-md-6
  className += `-${val}`;
  return className.toLowerCase();
}
const ALIGN_SELF_VALUES = ['auto', 'start', 'end', 'center', 'baseline', 'stretch'];
const makeVColProps = propsFactory({
  cols: {
    type: [Boolean, String, Number],
    default: false
  },
  ...breakpointProps,
  offset: {
    type: [String, Number],
    default: null
  },
  ...offsetProps,
  order: {
    type: [String, Number],
    default: null
  },
  ...orderProps,
  alignSelf: {
    type: String,
    default: null,
    validator: str => ALIGN_SELF_VALUES.includes(str)
  },
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VCol');
const VCol = genericComponent()({
  name: 'VCol',
  props: makeVColProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const classes = computed(() => {
      const classList = [];

      // Loop through `col`, `offset`, `order` breakpoint props
      let type;
      for (type in propMap$1) {
        propMap$1[type].forEach(prop => {
          const value = props[prop];
          const className = breakpointClass$1(type, prop, value);
          if (className) classList.push(className);
        });
      }
      const hasColClasses = classList.some(className => className.startsWith('v-col-'));
      classList.push({
        // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
        'v-col': !hasColClasses || !props.cols,
        [`v-col-${props.cols}`]: props.cols,
        [`offset-${props.offset}`]: props.offset,
        [`order-${props.order}`]: props.order,
        [`align-self-${props.alignSelf}`]: props.alignSelf
      });
      return classList;
    });
    return () => h(props.tag, {
      class: [classes.value, props.class],
      style: props.style
    }, slots.default?.());
  }
});

// Styles
const ALIGNMENT = ['start', 'end', 'center'];
const SPACE = ['space-between', 'space-around', 'space-evenly'];
function makeRowProps(prefix, def) {
  return breakpoints.reduce((props, val) => {
    const prefixKey = prefix + capitalize(val);
    props[prefixKey] = def();
    return props;
  }, {});
}
const ALIGN_VALUES = [...ALIGNMENT, 'baseline', 'stretch'];
const alignValidator = str => ALIGN_VALUES.includes(str);
const alignProps = makeRowProps('align', () => ({
  type: String,
  default: null,
  validator: alignValidator
}));
const JUSTIFY_VALUES = [...ALIGNMENT, ...SPACE];
const justifyValidator = str => JUSTIFY_VALUES.includes(str);
const justifyProps = makeRowProps('justify', () => ({
  type: String,
  default: null,
  validator: justifyValidator
}));
const ALIGN_CONTENT_VALUES = [...ALIGNMENT, ...SPACE, 'stretch'];
const alignContentValidator = str => ALIGN_CONTENT_VALUES.includes(str);
const alignContentProps = makeRowProps('alignContent', () => ({
  type: String,
  default: null,
  validator: alignContentValidator
}));
const propMap = {
  align: Object.keys(alignProps),
  justify: Object.keys(justifyProps),
  alignContent: Object.keys(alignContentProps)
};
const classMap = {
  align: 'align',
  justify: 'justify',
  alignContent: 'align-content'
};
function breakpointClass(type, prop, val) {
  let className = classMap[type];
  if (val == null) {
    return undefined;
  }
  if (prop) {
    // alignSm -> Sm
    const breakpoint = prop.replace(type, '');
    className += `-${breakpoint}`;
  }
  // .align-items-sm-center
  className += `-${val}`;
  return className.toLowerCase();
}
const makeVRowProps = propsFactory({
  dense: Boolean,
  noGutters: Boolean,
  align: {
    type: String,
    default: null,
    validator: alignValidator
  },
  ...alignProps,
  justify: {
    type: String,
    default: null,
    validator: justifyValidator
  },
  ...justifyProps,
  alignContent: {
    type: String,
    default: null,
    validator: alignContentValidator
  },
  ...alignContentProps,
  ...makeComponentProps(),
  ...makeTagProps()
}, 'VRow');
const VRow = genericComponent()({
  name: 'VRow',
  props: makeVRowProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const classes = computed(() => {
      const classList = [];

      // Loop through `align`, `justify`, `alignContent` breakpoint props
      let type;
      for (type in propMap) {
        propMap[type].forEach(prop => {
          const value = props[prop];
          const className = breakpointClass(type, prop, value);
          if (className) classList.push(className);
        });
      }
      classList.push({
        'v-row--no-gutters': props.noGutters,
        'v-row--dense': props.dense,
        [`align-${props.align}`]: props.align,
        [`justify-${props.justify}`]: props.justify,
        [`align-content-${props.alignContent}`]: props.alignContent
      });
      return classList;
    });
    return () => h(props.tag, {
      class: ['v-row', classes.value, props.class],
      style: props.style
    }, slots.default?.());
  }
});

// Styles
const VSpacer = createSimpleFunctional('v-spacer', 'div', 'VSpacer');

const makeVDatePickerControlsProps = propsFactory({
  active: {
    type: [String, Array],
    default: undefined
  },
  disabled: {
    type: [Boolean, String, Array],
    default: false
  },
  nextIcon: {
    type: IconValue,
    default: '$next'
  },
  prevIcon: {
    type: IconValue,
    default: '$prev'
  },
  modeIcon: {
    type: IconValue,
    default: '$subgroup'
  },
  text: String,
  viewMode: {
    type: String,
    default: 'month'
  }
}, 'VDatePickerControls');
const VDatePickerControls = genericComponent()({
  name: 'VDatePickerControls',
  props: makeVDatePickerControlsProps(),
  emits: {
    'click:year': () => true,
    'click:month': () => true,
    'click:prev': () => true,
    'click:next': () => true,
    'click:text': () => true
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const disableMonth = computed(() => {
      return Array.isArray(props.disabled) ? props.disabled.includes('text') : !!props.disabled;
    });
    const disableYear = computed(() => {
      return Array.isArray(props.disabled) ? props.disabled.includes('mode') : !!props.disabled;
    });
    const disablePrev = computed(() => {
      return Array.isArray(props.disabled) ? props.disabled.includes('prev') : !!props.disabled;
    });
    const disableNext = computed(() => {
      return Array.isArray(props.disabled) ? props.disabled.includes('next') : !!props.disabled;
    });
    function onClickPrev() {
      emit('click:prev');
    }
    function onClickNext() {
      emit('click:next');
    }
    function onClickYear() {
      emit('click:year');
    }
    function onClickMonth() {
      emit('click:month');
    }
    useRender(() => {
      // TODO: add slot support and scope defaults
      return createVNode("div", {
        "class": ['v-date-picker-controls']
      }, [createVNode(VBtn, {
        "class": "v-date-picker-controls__month-btn",
        "disabled": disableMonth.value,
        "text": props.text,
        "variant": "text",
        "rounded": true,
        "onClick": onClickMonth
      }, null), createVNode(VBtn, {
        "key": "mode-btn",
        "class": "v-date-picker-controls__mode-btn",
        "disabled": disableYear.value,
        "density": "comfortable",
        "icon": props.modeIcon,
        "variant": "text",
        "onClick": onClickYear
      }, null), createVNode(VSpacer, {
        "key": "mode-spacer"
      }, null), createVNode("div", {
        "key": "month-buttons",
        "class": "v-date-picker-controls__month"
      }, [createVNode(VBtn, {
        "disabled": disablePrev.value,
        "icon": props.prevIcon,
        "variant": "text",
        "onClick": onClickPrev
      }, null), createVNode(VBtn, {
        "disabled": disableNext.value,
        "icon": props.nextIcon,
        "variant": "text",
        "onClick": onClickNext
      }, null)])]);
    });
    return {};
  }
});

const makeVDatePickerHeaderProps = propsFactory({
  appendIcon: IconValue,
  color: String,
  header: String,
  transition: String,
  onClick: EventProp()
}, 'VDatePickerHeader');
const VDatePickerHeader = genericComponent()({
  name: 'VDatePickerHeader',
  props: makeVDatePickerHeaderProps(),
  emits: {
    click: () => true,
    'click:append': () => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(props, 'color');
    function onClick() {
      emit('click');
    }
    function onClickAppend() {
      emit('click:append');
    }
    useRender(() => {
      const hasContent = !!(slots.default || props.header);
      const hasAppend = !!(slots.append || props.appendIcon);
      return createVNode("div", {
        "class": ['v-date-picker-header', {
          'v-date-picker-header--clickable': !!props.onClick
        }, backgroundColorClasses.value],
        "style": backgroundColorStyles.value,
        "onClick": onClick
      }, [slots.prepend && createVNode("div", {
        "key": "prepend",
        "class": "v-date-picker-header__prepend"
      }, [slots.prepend()]), hasContent && createVNode(MaybeTransition, {
        "key": "content",
        "name": props.transition
      }, {
        default: () => [createVNode("div", {
          "key": props.header,
          "class": "v-date-picker-header__content"
        }, [slots.default?.() ?? props.header])]
      }), hasAppend && createVNode("div", {
        "class": "v-date-picker-header__append"
      }, [!slots.append ? createVNode(VBtn, {
        "key": "append-btn",
        "icon": props.appendIcon,
        "variant": "text",
        "onClick": onClickAppend
      }, null) : createVNode(VDefaultsProvider, {
        "key": "append-defaults",
        "disabled": !props.appendIcon,
        "defaults": {
          VBtn: {
            icon: props.appendIcon,
            variant: 'text'
          }
        }
      }, {
        default: () => [slots.append?.()]
      })])]);
    });
    return {};
  }
});

// Composables
// Types
// Composables
const makeCalendarProps = propsFactory({
  allowedDates: [Array, Function],
  disabled: Boolean,
  displayValue: null,
  modelValue: Array,
  month: [Number, String],
  max: null,
  min: null,
  showAdjacentMonths: Boolean,
  year: [Number, String],
  weekdays: {
    type: Array,
    default: () => [0, 1, 2, 3, 4, 5, 6]
  },
  weeksInMonth: {
    type: String,
    default: 'dynamic'
  },
  firstDayOfWeek: [Number, String]
}, 'calendar');
function useCalendar(props) {
  const adapter = useDate();
  const model = useProxiedModel(props, 'modelValue', [], v => wrapInArray(v));
  const displayValue = computed(() => {
    if (props.displayValue) return adapter.date(props.displayValue);
    if (model.value.length > 0) return adapter.date(model.value[0]);
    if (props.min) return adapter.date(props.min);
    if (Array.isArray(props.allowedDates)) return adapter.date(props.allowedDates[0]);
    return adapter.date();
  });
  const year = useProxiedModel(props, 'year', undefined, v => {
    const value = v != null ? Number(v) : adapter.getYear(displayValue.value);
    return adapter.startOfYear(adapter.setYear(adapter.date(), value));
  }, v => adapter.getYear(v));
  const month = useProxiedModel(props, 'month', undefined, v => {
    const value = v != null ? Number(v) : adapter.getMonth(displayValue.value);
    const date = adapter.setYear(adapter.startOfMonth(adapter.date()), adapter.getYear(year.value));
    return adapter.setMonth(date, value);
  }, v => adapter.getMonth(v));
  const weekDays = computed(() => {
    const firstDayOfWeek = Number(props.firstDayOfWeek ?? 0);
    return props.weekdays.map(day => (day + firstDayOfWeek) % 7);
  });
  const weeksInMonth = computed(() => {
    const weeks = adapter.getWeekArray(month.value, props.firstDayOfWeek);
    const days = weeks.flat();

    // Make sure there's always 6 weeks in month (6 * 7 days)
    // if weeksInMonth is 'static'
    const daysInMonth = 6 * 7;
    if (props.weeksInMonth === 'static' && days.length < daysInMonth) {
      const lastDay = days[days.length - 1];
      let week = [];
      for (let day = 1; day <= daysInMonth - days.length; day++) {
        week.push(adapter.addDays(lastDay, day));
        if (day % 7 === 0) {
          weeks.push(week);
          week = [];
        }
      }
    }
    return weeks;
  });
  function genDays(days, today) {
    return days.filter(date => {
      return weekDays.value.includes(adapter.toJsDate(date).getDay());
    }).map((date, index) => {
      const isoDate = adapter.toISO(date);
      const isAdjacent = !adapter.isSameMonth(date, month.value);
      const isStart = adapter.isSameDay(date, adapter.startOfMonth(month.value));
      const isEnd = adapter.isSameDay(date, adapter.endOfMonth(month.value));
      const isSame = adapter.isSameDay(date, month.value);
      return {
        date,
        isoDate,
        formatted: adapter.format(date, 'keyboardDate'),
        year: adapter.getYear(date),
        month: adapter.getMonth(date),
        isDisabled: isDisabled(date),
        isWeekStart: index % 7 === 0,
        isWeekEnd: index % 7 === 6,
        isToday: adapter.isSameDay(date, today),
        isAdjacent,
        isHidden: isAdjacent && !props.showAdjacentMonths,
        isStart,
        isSelected: model.value.some(value => adapter.isSameDay(date, value)),
        isEnd,
        isSame,
        localized: adapter.format(date, 'dayOfMonth')
      };
    });
  }
  const daysInWeek = computed(() => {
    const lastDay = adapter.startOfWeek(displayValue.value, props.firstDayOfWeek);
    const week = [];
    for (let day = 0; day <= 6; day++) {
      week.push(adapter.addDays(lastDay, day));
    }
    const today = adapter.date();
    return genDays(week, today);
  });
  const daysInMonth = computed(() => {
    const days = weeksInMonth.value.flat();
    const today = adapter.date();
    return genDays(days, today);
  });
  const weekNumbers = computed(() => {
    return weeksInMonth.value.map(week => {
      return week.length ? getWeek(adapter, week[0]) : null;
    });
  });
  function isDisabled(value) {
    if (props.disabled) return true;
    const date = adapter.date(value);
    if (props.min && adapter.isAfter(adapter.date(props.min), date)) return true;
    if (props.max && adapter.isAfter(date, adapter.date(props.max))) return true;
    if (Array.isArray(props.allowedDates) && props.allowedDates.length > 0) {
      return !props.allowedDates.some(d => adapter.isSameDay(adapter.date(d), date));
    }
    if (typeof props.allowedDates === 'function') {
      return !props.allowedDates(date);
    }
    return false;
  }
  return {
    displayValue,
    daysInMonth,
    daysInWeek,
    genDays,
    model,
    weeksInMonth,
    weekDays,
    weekNumbers
  };
}

const makeVDatePickerMonthProps = propsFactory({
  color: String,
  hideWeekdays: Boolean,
  multiple: [Boolean, Number, String],
  showWeek: Boolean,
  transition: {
    type: String,
    default: 'picker-transition'
  },
  reverseTransition: {
    type: String,
    default: 'picker-reverse-transition'
  },
  ...makeCalendarProps()
}, 'VDatePickerMonth');
const VDatePickerMonth = genericComponent()({
  name: 'VDatePickerMonth',
  props: makeVDatePickerMonthProps(),
  emits: {
    'update:modelValue': date => true,
    'update:month': date => true,
    'update:year': date => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const daysRef = ref();
    const {
      daysInMonth,
      model,
      weekNumbers
    } = useCalendar(props);
    const adapter = useDate();
    const rangeStart = shallowRef();
    const rangeStop = shallowRef();
    const isReverse = shallowRef(false);
    const transition = computed(() => {
      return !isReverse.value ? props.transition : props.reverseTransition;
    });
    if (props.multiple === 'range' && model.value.length > 0) {
      rangeStart.value = model.value[0];
      if (model.value.length > 1) {
        rangeStop.value = model.value[model.value.length - 1];
      }
    }
    const atMax = computed(() => {
      const max = ['number', 'string'].includes(typeof props.multiple) ? Number(props.multiple) : Infinity;
      return model.value.length >= max;
    });
    watch(daysInMonth, (val, oldVal) => {
      if (!oldVal) return;
      isReverse.value = adapter.isBefore(val[0].date, oldVal[0].date);
    });
    function onRangeClick(value) {
      const _value = adapter.startOfDay(value);
      if (model.value.length === 0) {
        rangeStart.value = undefined;
      } else if (model.value.length === 1) {
        rangeStart.value = model.value[0];
        rangeStop.value = undefined;
      }
      if (!rangeStart.value) {
        rangeStart.value = _value;
        model.value = [rangeStart.value];
      } else if (!rangeStop.value) {
        if (adapter.isSameDay(_value, rangeStart.value)) {
          rangeStart.value = undefined;
          model.value = [];
          return;
        } else if (adapter.isBefore(_value, rangeStart.value)) {
          rangeStop.value = adapter.endOfDay(rangeStart.value);
          rangeStart.value = _value;
        } else {
          rangeStop.value = adapter.endOfDay(_value);
        }
        const diff = adapter.getDiff(rangeStop.value, rangeStart.value, 'days');
        const datesInRange = [rangeStart.value];
        for (let i = 1; i < diff; i++) {
          const nextDate = adapter.addDays(rangeStart.value, i);
          datesInRange.push(nextDate);
        }
        datesInRange.push(rangeStop.value);
        model.value = datesInRange;
      } else {
        rangeStart.value = value;
        rangeStop.value = undefined;
        model.value = [rangeStart.value];
      }
    }
    function onMultipleClick(value) {
      const index = model.value.findIndex(selection => adapter.isSameDay(selection, value));
      if (index === -1) {
        model.value = [...model.value, value];
      } else {
        const value = [...model.value];
        value.splice(index, 1);
        model.value = value;
      }
    }
    function onClick(value) {
      if (props.multiple === 'range') {
        onRangeClick(value);
      } else if (props.multiple) {
        onMultipleClick(value);
      } else {
        model.value = [value];
      }
    }
    return () => createVNode("div", {
      "class": "v-date-picker-month"
    }, [props.showWeek && createVNode("div", {
      "key": "weeks",
      "class": "v-date-picker-month__weeks"
    }, [!props.hideWeekdays && createVNode("div", {
      "key": "hide-week-days",
      "class": "v-date-picker-month__day"
    }, [createTextVNode("\xA0")]), weekNumbers.value.map(week => createVNode("div", {
      "class": ['v-date-picker-month__day', 'v-date-picker-month__day--adjacent']
    }, [week]))]), createVNode(MaybeTransition, {
      "name": transition.value
    }, {
      default: () => [createVNode("div", {
        "ref": daysRef,
        "key": daysInMonth.value[0].date?.toString(),
        "class": "v-date-picker-month__days"
      }, [!props.hideWeekdays && adapter.getWeekdays(props.firstDayOfWeek).map(weekDay => createVNode("div", {
        "class": ['v-date-picker-month__day', 'v-date-picker-month__weekday']
      }, [weekDay])), daysInMonth.value.map((item, i) => {
        const slotProps = {
          props: {
            onClick: () => onClick(item.date)
          },
          item,
          i
        };
        if (atMax.value && !item.isSelected) {
          item.isDisabled = true;
        }
        return createVNode("div", {
          "class": ['v-date-picker-month__day', {
            'v-date-picker-month__day--adjacent': item.isAdjacent,
            'v-date-picker-month__day--hide-adjacent': item.isHidden,
            'v-date-picker-month__day--selected': item.isSelected,
            'v-date-picker-month__day--week-end': item.isWeekEnd,
            'v-date-picker-month__day--week-start': item.isWeekStart
          }],
          "data-v-date": !item.isDisabled ? item.isoDate : undefined
        }, [(props.showAdjacentMonths || !item.isAdjacent) && createVNode(VDefaultsProvider, {
          "defaults": {
            VBtn: {
              class: 'v-date-picker-month__day-btn',
              color: (item.isSelected || item.isToday) && !item.isDisabled ? props.color : undefined,
              disabled: item.isDisabled,
              icon: true,
              ripple: false,
              text: item.localized,
              variant: item.isDisabled ? item.isToday ? 'outlined' : 'text' : item.isToday && !item.isSelected ? 'outlined' : 'flat',
              onClick: () => onClick(item.date)
            }
          }
        }, {
          default: () => [slots.day?.(slotProps) ?? createVNode(VBtn, slotProps.props, null)]
        })]);
      })])]
    })]);
  }
});

const makeVDatePickerMonthsProps = propsFactory({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number,
  year: Number
}, 'VDatePickerMonths');
const VDatePickerMonths = genericComponent()({
  name: 'VDatePickerMonths',
  props: makeVDatePickerMonthsProps(),
  emits: {
    'update:modelValue': date => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const adapter = useDate();
    const model = useProxiedModel(props, 'modelValue');
    const months = computed(() => {
      let date = adapter.startOfYear(adapter.date());
      if (props.year) {
        date = adapter.setYear(date, props.year);
      }
      return createRange(12).map(i => {
        const text = adapter.format(date, 'monthShort');
        const isDisabled = !!(props.min && adapter.isAfter(adapter.startOfMonth(adapter.date(props.min)), date) || props.max && adapter.isAfter(date, adapter.startOfMonth(adapter.date(props.max))));
        date = adapter.getNextMonth(date);
        return {
          isDisabled,
          text,
          value: i
        };
      });
    });
    watchEffect(() => {
      model.value = model.value ?? adapter.getMonth(adapter.date());
    });
    useRender(() => createVNode("div", {
      "class": "v-date-picker-months",
      "style": {
        height: convertToUnit(props.height)
      }
    }, [createVNode("div", {
      "class": "v-date-picker-months__content"
    }, [months.value.map((month, i) => {
      const btnProps = {
        active: model.value === i,
        color: model.value === i ? props.color : undefined,
        disabled: month.isDisabled,
        rounded: true,
        text: month.text,
        variant: model.value === month.value ? 'flat' : 'text',
        onClick: () => onClick(i)
      };
      function onClick(i) {
        if (model.value === i) {
          emit('update:modelValue', model.value);
          return;
        }
        model.value = i;
      }
      return slots.month?.({
        month,
        i,
        props: btnProps
      }) ?? createVNode(VBtn, mergeProps({
        "key": "month"
      }, btnProps), null);
    })])]));
    return {};
  }
});

// Types
const makeVDatePickerYearsProps = propsFactory({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number
}, 'VDatePickerYears');
const VDatePickerYears = genericComponent()({
  name: 'VDatePickerYears',
  props: makeVDatePickerYearsProps(),
  emits: {
    'update:modelValue': year => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const adapter = useDate();
    const model = useProxiedModel(props, 'modelValue');
    const years = computed(() => {
      const year = adapter.getYear(adapter.date());
      let min = year - 100;
      let max = year + 52;
      if (props.min) {
        min = adapter.getYear(adapter.date(props.min));
      }
      if (props.max) {
        max = adapter.getYear(adapter.date(props.max));
      }
      let date = adapter.startOfYear(adapter.date());
      date = adapter.setYear(date, min);
      return createRange(max - min + 1, min).map(i => {
        const text = adapter.format(date, 'year');
        date = adapter.setYear(date, adapter.getYear(date) + 1);
        return {
          text,
          value: i
        };
      });
    });
    watchEffect(() => {
      model.value = model.value ?? adapter.getYear(adapter.date());
    });
    const yearRef = templateRef();
    onMounted(async () => {
      await nextTick();
      yearRef.el?.scrollIntoView({
        block: 'center'
      });
    });
    useRender(() => createVNode("div", {
      "class": "v-date-picker-years",
      "style": {
        height: convertToUnit(props.height)
      }
    }, [createVNode("div", {
      "class": "v-date-picker-years__content"
    }, [years.value.map((year, i) => {
      const btnProps = {
        ref: model.value === year.value ? yearRef : undefined,
        active: model.value === year.value,
        color: model.value === year.value ? props.color : undefined,
        rounded: true,
        text: year.text,
        variant: model.value === year.value ? 'flat' : 'text',
        onClick: () => {
          if (model.value === year.value) {
            emit('update:modelValue', model.value);
            return;
          }
          model.value = year.value;
        }
      };
      return slots.year?.({
        year,
        i,
        props: btnProps
      }) ?? createVNode(VBtn, mergeProps({
        "key": "month"
      }, btnProps), null);
    })])]));
    return {};
  }
});

// Utilities
const VPickerTitle = createSimpleFunctional('v-picker-title');

const makeVPickerProps = propsFactory({
  bgColor: String,
  landscape: Boolean,
  title: String,
  hideHeader: Boolean,
  ...makeVSheetProps()
}, 'VPicker');
const VPicker = genericComponent()({
  name: 'VPicker',
  props: makeVPickerProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    useRender(() => {
      const sheetProps = VSheet.filterProps(props);
      const hasTitle = !!(props.title || slots.title);
      return createVNode(VSheet, mergeProps(sheetProps, {
        "color": props.bgColor,
        "class": ['v-picker', {
          'v-picker--landscape': props.landscape,
          'v-picker--with-actions': !!slots.actions
        }, props.class],
        "style": props.style
      }), {
        default: () => [!props.hideHeader && createVNode("div", {
          "key": "header",
          "class": [backgroundColorClasses.value],
          "style": [backgroundColorStyles.value]
        }, [hasTitle && createVNode(VPickerTitle, {
          "key": "picker-title"
        }, {
          default: () => [slots.title?.() ?? props.title]
        }), slots.header && createVNode("div", {
          "class": "v-picker__header"
        }, [slots.header()])]), createVNode("div", {
          "class": "v-picker__body"
        }, [slots.default?.()]), slots.actions && createVNode(VDefaultsProvider, {
          "defaults": {
            VBtn: {
              slim: true,
              variant: 'text'
            }
          }
        }, {
          default: () => [createVNode("div", {
            "class": "v-picker__actions"
          }, [slots.actions()])]
        })]
      });
    });
    return {};
  }
});

// Types
const makeVDatePickerProps = propsFactory({
  // TODO: implement in v3.5
  // calendarIcon: {
  //   type: String,
  //   default: '$calendar',
  // },
  // keyboardIcon: {
  //   type: String,
  //   default: '$edit',
  // },
  // inputMode: {
  //   type: String as PropType<'calendar' | 'keyboard'>,
  //   default: 'calendar',
  // },
  // inputText: {
  //   type: String,
  //   default: '$vuetify.datePicker.input.placeholder',
  // },
  // inputPlaceholder: {
  //   type: String,
  //   default: 'dd/mm/yyyy',
  // },
  header: {
    type: String,
    default: '$vuetify.datePicker.header'
  },
  ...makeVDatePickerControlsProps(),
  ...makeVDatePickerMonthProps({
    weeksInMonth: 'static'
  }),
  ...omit(makeVDatePickerMonthsProps(), ['modelValue']),
  ...omit(makeVDatePickerYearsProps(), ['modelValue']),
  ...makeVPickerProps({
    title: '$vuetify.datePicker.title'
  }),
  modelValue: null
}, 'VDatePicker');
const VDatePicker = genericComponent()({
  name: 'VDatePicker',
  props: makeVDatePickerProps(),
  emits: {
    'update:modelValue': date => true,
    'update:month': date => true,
    'update:year': date => true,
    // 'update:inputMode': (date: any) => true,
    'update:viewMode': date => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const adapter = useDate();
    const {
      t
    } = useLocale();
    const model = useProxiedModel(props, 'modelValue', undefined, v => wrapInArray(v), v => props.multiple ? v : v[0]);
    const viewMode = useProxiedModel(props, 'viewMode');
    // const inputMode = useProxiedModel(props, 'inputMode')
    const internal = computed(() => {
      const value = adapter.date(model.value?.[0]);
      return value && adapter.isValid(value) ? value : adapter.date();
    });
    const month = ref(Number(props.month ?? adapter.getMonth(adapter.startOfMonth(internal.value))));
    const year = ref(Number(props.year ?? adapter.getYear(adapter.startOfYear(adapter.setMonth(internal.value, month.value)))));
    const isReversing = shallowRef(false);
    const header = computed(() => {
      if (props.multiple && model.value.length > 1) {
        return t('$vuetify.datePicker.itemsSelected', model.value.length);
      }
      return model.value[0] && adapter.isValid(model.value[0]) ? adapter.format(adapter.date(model.value[0]), 'normalDateWithWeekday') : t(props.header);
    });
    const text = computed(() => {
      let date = adapter.date();
      date = adapter.setDate(date, 1);
      date = adapter.setMonth(date, month.value);
      date = adapter.setYear(date, year.value);
      return adapter.format(date, 'monthAndYear');
    });
    // const headerIcon = computed(() => props.inputMode === 'calendar' ? props.keyboardIcon : props.calendarIcon)
    const headerTransition = computed(() => `date-picker-header${isReversing.value ? '-reverse' : ''}-transition`);
    const minDate = computed(() => {
      const date = adapter.date(props.min);
      return props.min && adapter.isValid(date) ? date : null;
    });
    const maxDate = computed(() => {
      const date = adapter.date(props.max);
      return props.max && adapter.isValid(date) ? date : null;
    });
    const disabled = computed(() => {
      if (props.disabled) return true;
      const targets = [];
      if (viewMode.value !== 'month') {
        targets.push(...['prev', 'next']);
      } else {
        let _date = adapter.date();
        _date = adapter.setYear(_date, year.value);
        _date = adapter.setMonth(_date, month.value);
        if (minDate.value) {
          const date = adapter.addDays(adapter.startOfMonth(_date), -1);
          adapter.isAfter(minDate.value, date) && targets.push('prev');
        }
        if (maxDate.value) {
          const date = adapter.addDays(adapter.endOfMonth(_date), 1);
          adapter.isAfter(date, maxDate.value) && targets.push('next');
        }
      }
      return targets;
    });

    // function onClickAppend () {
    //   inputMode.value = inputMode.value === 'calendar' ? 'keyboard' : 'calendar'
    // }

    function onClickNext() {
      if (month.value < 11) {
        month.value++;
      } else {
        year.value++;
        month.value = 0;
        onUpdateYear(year.value);
      }
      onUpdateMonth(month.value);
    }
    function onClickPrev() {
      if (month.value > 0) {
        month.value--;
      } else {
        year.value--;
        month.value = 11;
        onUpdateYear(year.value);
      }
      onUpdateMonth(month.value);
    }
    function onClickDate() {
      viewMode.value = 'month';
    }
    function onClickMonth() {
      viewMode.value = viewMode.value === 'months' ? 'month' : 'months';
    }
    function onClickYear() {
      viewMode.value = viewMode.value === 'year' ? 'month' : 'year';
    }
    function onUpdateMonth(value) {
      if (viewMode.value === 'months') onClickMonth();
      emit('update:month', value);
    }
    function onUpdateYear(value) {
      if (viewMode.value === 'year') onClickYear();
      emit('update:year', value);
    }
    watch(model, (val, oldVal) => {
      const arrBefore = wrapInArray(oldVal);
      const arrAfter = wrapInArray(val);
      if (!arrAfter.length) return;
      const before = adapter.date(arrBefore[arrBefore.length - 1]);
      const after = adapter.date(arrAfter[arrAfter.length - 1]);
      const newMonth = adapter.getMonth(after);
      const newYear = adapter.getYear(after);
      if (newMonth !== month.value) {
        month.value = newMonth;
        onUpdateMonth(month.value);
      }
      if (newYear !== year.value) {
        year.value = newYear;
        onUpdateYear(year.value);
      }
      isReversing.value = adapter.isBefore(before, after);
    });
    useRender(() => {
      const pickerProps = VPicker.filterProps(props);
      const datePickerControlsProps = VDatePickerControls.filterProps(props);
      const datePickerHeaderProps = VDatePickerHeader.filterProps(props);
      const datePickerMonthProps = VDatePickerMonth.filterProps(props);
      const datePickerMonthsProps = omit(VDatePickerMonths.filterProps(props), ['modelValue']);
      const datePickerYearsProps = omit(VDatePickerYears.filterProps(props), ['modelValue']);
      const headerProps = {
        header: header.value,
        transition: headerTransition.value
      };
      return createVNode(VPicker, mergeProps(pickerProps, {
        "class": ['v-date-picker', `v-date-picker--${viewMode.value}`, {
          'v-date-picker--show-week': props.showWeek
        }, props.class],
        "style": props.style
      }), {
        title: () => slots.title?.() ?? createVNode("div", {
          "class": "v-date-picker__title"
        }, [t(props.title)]),
        header: () => slots.header ? createVNode(VDefaultsProvider, {
          "defaults": {
            VDatePickerHeader: {
              ...headerProps
            }
          }
        }, {
          default: () => [slots.header?.(headerProps)]
        }) : createVNode(VDatePickerHeader, mergeProps({
          "key": "header"
        }, datePickerHeaderProps, headerProps, {
          "onClick": viewMode.value !== 'month' ? onClickDate : undefined
        }), {
          ...slots,
          default: undefined
        }),
        default: () => createVNode(Fragment, null, [createVNode(VDatePickerControls, mergeProps(datePickerControlsProps, {
          "disabled": disabled.value,
          "text": text.value,
          "onClick:next": onClickNext,
          "onClick:prev": onClickPrev,
          "onClick:month": onClickMonth,
          "onClick:year": onClickYear
        }), null), createVNode(VFadeTransition, {
          "hideOnLeave": true
        }, {
          default: () => [viewMode.value === 'months' ? createVNode(VDatePickerMonths, mergeProps({
            "key": "date-picker-months"
          }, datePickerMonthsProps, {
            "modelValue": month.value,
            "onUpdate:modelValue": [$event => month.value = $event, onUpdateMonth],
            "min": minDate.value,
            "max": maxDate.value,
            "year": year.value
          }), null) : viewMode.value === 'year' ? createVNode(VDatePickerYears, mergeProps({
            "key": "date-picker-years"
          }, datePickerYearsProps, {
            "modelValue": year.value,
            "onUpdate:modelValue": [$event => year.value = $event, onUpdateYear],
            "min": minDate.value,
            "max": maxDate.value
          }), null) : createVNode(VDatePickerMonth, mergeProps({
            "key": "date-picker-month"
          }, datePickerMonthProps, {
            "modelValue": model.value,
            "onUpdate:modelValue": $event => model.value = $event,
            "month": month.value,
            "onUpdate:month": [$event => month.value = $event, onUpdateMonth],
            "year": year.value,
            "onUpdate:year": [$event => year.value = $event, onUpdateYear],
            "min": minDate.value,
            "max": maxDate.value
          }), null)]
        })]),
        actions: slots.actions
      });
    });
    return {};
  }
});

// Types
const makeVEmptyStateProps = propsFactory({
  actionText: String,
  bgColor: String,
  color: String,
  icon: IconValue,
  image: String,
  justify: {
    type: String,
    default: 'center'
  },
  headline: String,
  title: String,
  text: String,
  textWidth: {
    type: [Number, String],
    default: 500
  },
  href: String,
  to: String,
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeSizeProps({
    size: undefined
  }),
  ...makeThemeProps()
}, 'VEmptyState');
const VEmptyState = genericComponent()({
  name: 'VEmptyState',
  props: makeVEmptyStateProps(),
  emits: {
    'click:action': e => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'bgColor'));
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      displayClasses
    } = useDisplay();
    function onClickAction(e) {
      emit('click:action', e);
    }
    useRender(() => {
      const hasActions = !!(slots.actions || props.actionText);
      const hasHeadline = !!(slots.headline || props.headline);
      const hasTitle = !!(slots.title || props.title);
      const hasText = !!(slots.text || props.text);
      const hasMedia = !!(slots.media || props.image || props.icon);
      const size = props.size || (props.image ? 200 : 96);
      return createVNode("div", {
        "class": ['v-empty-state', {
          [`v-empty-state--${props.justify}`]: true
        }, themeClasses.value, backgroundColorClasses.value, displayClasses.value, props.class],
        "style": [backgroundColorStyles.value, dimensionStyles.value, props.style]
      }, [hasMedia && createVNode("div", {
        "key": "media",
        "class": "v-empty-state__media"
      }, [!slots.media ? createVNode(Fragment, null, [props.image ? createVNode(VImg, {
        "key": "image",
        "src": props.image,
        "height": size
      }, null) : props.icon ? createVNode(VIcon, {
        "key": "icon",
        "color": props.color,
        "size": size,
        "icon": props.icon
      }, null) : undefined]) : createVNode(VDefaultsProvider, {
        "key": "media-defaults",
        "defaults": {
          VImg: {
            src: props.image,
            height: size
          },
          VIcon: {
            size,
            icon: props.icon
          }
        }
      }, {
        default: () => [slots.media()]
      })]), hasHeadline && createVNode("div", {
        "key": "headline",
        "class": "v-empty-state__headline"
      }, [slots.headline?.() ?? props.headline]), hasTitle && createVNode("div", {
        "key": "title",
        "class": "v-empty-state__title"
      }, [slots.title?.() ?? props.title]), hasText && createVNode("div", {
        "key": "text",
        "class": "v-empty-state__text",
        "style": {
          maxWidth: convertToUnit(props.textWidth)
        }
      }, [slots.text?.() ?? props.text]), slots.default && createVNode("div", {
        "key": "content",
        "class": "v-empty-state__content"
      }, [slots.default()]), hasActions && createVNode("div", {
        "key": "actions",
        "class": "v-empty-state__actions"
      }, [createVNode(VDefaultsProvider, {
        "defaults": {
          VBtn: {
            class: 'v-empty-state__action-btn',
            color: props.color ?? 'surface-variant',
            text: props.actionText
          }
        }
      }, {
        default: () => [slots.actions?.({
          props: {
            onClick: onClickAction
          }
        }) ?? createVNode(VBtn, {
          "onClick": onClickAction
        }, null)]
      })])]);
    });
    return {};
  }
});

// Types

const VExpansionPanelSymbol = Symbol.for('vuetify:v-expansion-panel');

const makeVExpansionPanelTextProps = propsFactory({
  ...makeComponentProps(),
  ...makeLazyProps()
}, 'VExpansionPanelText');
const VExpansionPanelText = genericComponent()({
  name: 'VExpansionPanelText',
  props: makeVExpansionPanelTextProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const expansionPanel = inject$2(VExpansionPanelSymbol);
    if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
    const {
      hasContent,
      onAfterLeave
    } = useLazy(props, expansionPanel.isSelected);
    useRender(() => createVNode(VExpandTransition, {
      "onAfterLeave": onAfterLeave
    }, {
      default: () => [withDirectives(createVNode("div", {
        "class": ['v-expansion-panel-text', props.class],
        "style": props.style
      }, [slots.default && hasContent.value && createVNode("div", {
        "class": "v-expansion-panel-text__wrapper"
      }, [slots.default?.()])]), [[vShow, expansionPanel.isSelected.value]])]
    }));
    return {};
  }
});

const makeVExpansionPanelTitleProps = propsFactory({
  color: String,
  expandIcon: {
    type: IconValue,
    default: '$expand'
  },
  collapseIcon: {
    type: IconValue,
    default: '$collapse'
  },
  hideActions: Boolean,
  focusable: Boolean,
  static: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: false
  },
  readonly: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps()
}, 'VExpansionPanelTitle');
const VExpansionPanelTitle = genericComponent()({
  name: 'VExpansionPanelTitle',
  directives: {
    Ripple
  },
  props: makeVExpansionPanelTitleProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const expansionPanel = inject$2(VExpansionPanelSymbol);
    if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(props, 'color');
    const {
      dimensionStyles
    } = useDimension(props);
    const slotProps = computed(() => ({
      collapseIcon: props.collapseIcon,
      disabled: expansionPanel.disabled.value,
      expanded: expansionPanel.isSelected.value,
      expandIcon: props.expandIcon,
      readonly: props.readonly
    }));
    const icon = computed(() => expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon);
    useRender(() => withDirectives(createVNode("button", {
      "class": ['v-expansion-panel-title', {
        'v-expansion-panel-title--active': expansionPanel.isSelected.value,
        'v-expansion-panel-title--focusable': props.focusable,
        'v-expansion-panel-title--static': props.static
      }, backgroundColorClasses.value, props.class],
      "style": [backgroundColorStyles.value, dimensionStyles.value, props.style],
      "type": "button",
      "tabindex": expansionPanel.disabled.value ? -1 : undefined,
      "disabled": expansionPanel.disabled.value,
      "aria-expanded": expansionPanel.isSelected.value,
      "onClick": !props.readonly ? expansionPanel.toggle : undefined
    }, [createVNode("span", {
      "class": "v-expansion-panel-title__overlay"
    }, null), slots.default?.(slotProps.value), !props.hideActions && createVNode(VDefaultsProvider, {
      "defaults": {
        VIcon: {
          icon: icon.value
        }
      }
    }, {
      default: () => [createVNode("span", {
        "class": "v-expansion-panel-title__icon"
      }, [slots.actions?.(slotProps.value) ?? createVNode(VIcon, null, null)])]
    })]), [[resolveDirective("ripple"), props.ripple]]));
    return {};
  }
});

const makeVExpansionPanelProps = propsFactory({
  title: String,
  text: String,
  bgColor: String,
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps(),
  ...makeVExpansionPanelTitleProps(),
  ...makeVExpansionPanelTextProps()
}, 'VExpansionPanel');
const VExpansionPanel = genericComponent()({
  name: 'VExpansionPanel',
  props: makeVExpansionPanelProps(),
  emits: {
    'group:selected': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const groupItem = useGroupItem(props, VExpansionPanelSymbol);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(props, 'bgColor');
    const {
      elevationClasses
    } = useElevation(props);
    const {
      roundedClasses
    } = useRounded(props);
    const isDisabled = computed(() => groupItem?.disabled.value || props.disabled);
    const selectedIndices = computed(() => groupItem.group.items.value.reduce((arr, item, index) => {
      if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
      return arr;
    }, []));
    const isBeforeSelected = computed(() => {
      const index = groupItem.group.items.value.findIndex(item => item.id === groupItem.id);
      return !groupItem.isSelected.value && selectedIndices.value.some(selectedIndex => selectedIndex - index === 1);
    });
    const isAfterSelected = computed(() => {
      const index = groupItem.group.items.value.findIndex(item => item.id === groupItem.id);
      return !groupItem.isSelected.value && selectedIndices.value.some(selectedIndex => selectedIndex - index === -1);
    });
    provide(VExpansionPanelSymbol, groupItem);
    useRender(() => {
      const hasText = !!(slots.text || props.text);
      const hasTitle = !!(slots.title || props.title);
      const expansionPanelTitleProps = VExpansionPanelTitle.filterProps(props);
      const expansionPanelTextProps = VExpansionPanelText.filterProps(props);
      return createVNode(props.tag, {
        "class": ['v-expansion-panel', {
          'v-expansion-panel--active': groupItem.isSelected.value,
          'v-expansion-panel--before-active': isBeforeSelected.value,
          'v-expansion-panel--after-active': isAfterSelected.value,
          'v-expansion-panel--disabled': isDisabled.value
        }, roundedClasses.value, backgroundColorClasses.value, props.class],
        "style": [backgroundColorStyles.value, props.style]
      }, {
        default: () => [createVNode("div", {
          "class": ['v-expansion-panel__shadow', ...elevationClasses.value]
        }, null), createVNode(VDefaultsProvider, {
          "defaults": {
            VExpansionPanelTitle: {
              ...expansionPanelTitleProps
            },
            VExpansionPanelText: {
              ...expansionPanelTextProps
            }
          }
        }, {
          default: () => [hasTitle && createVNode(VExpansionPanelTitle, {
            "key": "title"
          }, {
            default: () => [slots.title ? slots.title() : props.title]
          }), hasText && createVNode(VExpansionPanelText, {
            "key": "text"
          }, {
            default: () => [slots.text ? slots.text() : props.text]
          }), slots.default?.()]
        })]
      });
    });
    return {
      groupItem
    };
  }
});

const allowedVariants = ['default', 'accordion', 'inset', 'popout'];
const makeVExpansionPanelsProps = propsFactory({
  flat: Boolean,
  ...makeGroupProps(),
  ...pick(makeVExpansionPanelProps(), ['bgColor', 'collapseIcon', 'color', 'eager', 'elevation', 'expandIcon', 'focusable', 'hideActions', 'readonly', 'ripple', 'rounded', 'tile', 'static']),
  ...makeThemeProps(),
  ...makeComponentProps(),
  ...makeTagProps(),
  variant: {
    type: String,
    default: 'default',
    validator: v => allowedVariants.includes(v)
  }
}, 'VExpansionPanels');
const VExpansionPanels = genericComponent()({
  name: 'VExpansionPanels',
  props: makeVExpansionPanelsProps(),
  emits: {
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      next,
      prev
    } = useGroup(props, VExpansionPanelSymbol);
    const {
      themeClasses
    } = provideTheme(props);
    const variantClass = computed(() => props.variant && `v-expansion-panels--variant-${props.variant}`);
    provideDefaults({
      VExpansionPanel: {
        bgColor: toRef(props, 'bgColor'),
        collapseIcon: toRef(props, 'collapseIcon'),
        color: toRef(props, 'color'),
        eager: toRef(props, 'eager'),
        elevation: toRef(props, 'elevation'),
        expandIcon: toRef(props, 'expandIcon'),
        focusable: toRef(props, 'focusable'),
        hideActions: toRef(props, 'hideActions'),
        readonly: toRef(props, 'readonly'),
        ripple: toRef(props, 'ripple'),
        rounded: toRef(props, 'rounded'),
        static: toRef(props, 'static')
      }
    });
    useRender(() => createVNode(props.tag, {
      "class": ['v-expansion-panels', {
        'v-expansion-panels--flat': props.flat,
        'v-expansion-panels--tile': props.tile
      }, themeClasses.value, variantClass.value, props.class],
      "style": props.style
    }, {
      default: () => [slots.default?.({
        prev,
        next
      })]
    }));
    return {
      next,
      prev
    };
  }
});

const makeVFabProps = propsFactory({
  app: Boolean,
  appear: Boolean,
  extended: Boolean,
  layout: Boolean,
  offset: Boolean,
  modelValue: {
    type: Boolean,
    default: true
  },
  ...omit(makeVBtnProps({
    active: true
  }), ['location']),
  ...makeLayoutItemProps(),
  ...makeLocationProps(),
  ...makeTransitionProps({
    transition: 'fab-transition'
  })
}, 'VFab');
const VFab = genericComponent()({
  name: 'VFab',
  props: makeVFabProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const height = shallowRef(56);
    const layoutItemStyles = ref();
    const {
      resizeRef
    } = useResizeObserver(entries => {
      if (!entries.length) return;
      height.value = entries[0].target.clientHeight;
    });
    const hasPosition = computed(() => props.app || props.absolute);
    const position = computed(() => {
      if (!hasPosition.value) return false;
      return props.location?.split(' ').shift() ?? 'bottom';
    });
    const orientation = computed(() => {
      if (!hasPosition.value) return false;
      return props.location?.split(' ')[1] ?? 'end';
    });
    useToggleScope(() => props.app, () => {
      const layout = useLayoutItem({
        id: props.name,
        order: computed(() => parseInt(props.order, 10)),
        position,
        layoutSize: computed(() => props.layout ? height.value + 24 : 0),
        elementSize: computed(() => height.value + 24),
        active: computed(() => props.app && model.value),
        absolute: toRef(props, 'absolute')
      });
      watchEffect(() => {
        layoutItemStyles.value = layout.layoutItemStyles.value;
      });
    });
    const vFabRef = ref();
    useRender(() => {
      const btnProps = VBtn.filterProps(props);
      return createVNode("div", {
        "ref": vFabRef,
        "class": ['v-fab', {
          'v-fab--absolute': props.absolute,
          'v-fab--app': !!props.app,
          'v-fab--extended': props.extended,
          'v-fab--offset': props.offset,
          [`v-fab--${position.value}`]: hasPosition.value,
          [`v-fab--${orientation.value}`]: hasPosition.value
        }, props.class],
        "style": [props.app ? {
          ...layoutItemStyles.value
        } : {
          height: 'inherit',
          width: undefined
        }, props.style]
      }, [createVNode("div", {
        "class": "v-fab__container"
      }, [createVNode(MaybeTransition, {
        "appear": props.appear,
        "transition": props.transition
      }, {
        default: () => [withDirectives(createVNode(VBtn, mergeProps({
          "ref": resizeRef
        }, btnProps, {
          "active": undefined,
          "location": undefined
        }), slots), [[vShow, props.active]])]
      })])]);
    });
    return {};
  }
});

// Composables
const makeVHoverProps = propsFactory({
  disabled: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  ...makeDelayProps()
}, 'VHover');
const VHover = genericComponent()({
  name: 'VHover',
  props: makeVHoverProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const isHovering = useProxiedModel(props, 'modelValue');
    const {
      runOpenDelay,
      runCloseDelay
    } = useDelay(props, value => !props.disabled && (isHovering.value = value));
    return () => slots.default?.({
      isHovering: isHovering.value,
      props: {
        onMouseenter: runOpenDelay,
        onMouseleave: runCloseDelay
      }
    });
  }
});

const VItemGroupSymbol = Symbol.for('vuetify:v-item-group');
const makeVItemGroupProps = propsFactory({
  ...makeComponentProps(),
  ...makeGroupProps({
    selectedClass: 'v-item--selected'
  }),
  ...makeTagProps(),
  ...makeThemeProps()
}, 'VItemGroup');
const VItemGroup = genericComponent()({
  name: 'VItemGroup',
  props: makeVItemGroupProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      themeClasses
    } = provideTheme(props);
    const {
      isSelected,
      select,
      next,
      prev,
      selected
    } = useGroup(props, VItemGroupSymbol);
    return () => createVNode(props.tag, {
      "class": ['v-item-group', themeClasses.value, props.class],
      "style": props.style
    }, {
      default: () => [slots.default?.({
        isSelected,
        select,
        next,
        prev,
        selected: selected.value
      })]
    });
  }
});

// Composables
const VItem = genericComponent()({
  name: 'VItem',
  props: makeGroupItemProps(),
  emits: {
    'group:selected': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      isSelected,
      select,
      toggle,
      selectedClass,
      value,
      disabled
    } = useGroupItem(props, VItemGroupSymbol);
    return () => slots.default?.({
      isSelected: isSelected.value,
      selectedClass: selectedClass.value,
      select,
      toggle,
      value: value.value,
      disabled: disabled.value
    });
  }
});

const makeVLayoutProps = propsFactory({
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeLayoutProps()
}, 'VLayout');
const VLayout = genericComponent()({
  name: 'VLayout',
  props: makeVLayoutProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      layoutClasses,
      layoutStyles,
      getLayoutItem,
      items,
      layoutRef
    } = createLayout(props);
    const {
      dimensionStyles
    } = useDimension(props);
    useRender(() => createVNode("div", {
      "ref": layoutRef,
      "class": [layoutClasses.value, props.class],
      "style": [dimensionStyles.value, layoutStyles.value, props.style]
    }, [slots.default?.()]));
    return {
      getLayoutItem,
      items
    };
  }
});

const makeVMainProps = propsFactory({
  scrollable: Boolean,
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeTagProps({
    tag: 'main'
  })
}, 'VMain');
const VMain = genericComponent()({
  name: 'VMain',
  props: makeVMainProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      mainStyles
    } = useLayout();
    const {
      ssrBootStyles
    } = useSsrBoot();
    useRender(() => createVNode(props.tag, {
      "class": ['v-main', {
        'v-main--scrollable': props.scrollable
      }, props.class],
      "style": [mainStyles.value, ssrBootStyles.value, dimensionStyles.value, props.style]
    }, {
      default: () => [props.scrollable ? createVNode("div", {
        "class": "v-main__scroller"
      }, [slots.default?.()]) : slots.default?.()]
    }));
    return {};
  }
});

// Utilities
function useSticky(_ref) {
  let {
    rootEl,
    isSticky,
    layoutItemStyles
  } = _ref;
  const isStuck = shallowRef(false);
  const stuckPosition = shallowRef(0);
  const stickyStyles = computed(() => {
    const side = typeof isStuck.value === 'boolean' ? 'top' : isStuck.value;
    return [isSticky.value ? {
      top: 'auto',
      bottom: 'auto',
      height: undefined
    } : undefined, isStuck.value ? {
      [side]: convertToUnit(stuckPosition.value)
    } : {
      top: layoutItemStyles.value.top
    }];
  });
  onMounted(() => {
    watch(isSticky, val => {
      if (val) {
        window.addEventListener('scroll', onScroll, {
          passive: true
        });
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    }, {
      immediate: true
    });
  });
  onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll);
  });
  let lastScrollTop = 0;
  function onScroll() {
    const direction = lastScrollTop > window.scrollY ? 'up' : 'down';
    const rect = rootEl.value.getBoundingClientRect();
    const layoutTop = parseFloat(layoutItemStyles.value.top ?? 0);
    const top = window.scrollY - Math.max(0, stuckPosition.value - layoutTop);
    const bottom = rect.height + Math.max(stuckPosition.value, layoutTop) - window.scrollY - window.innerHeight;
    const bodyScroll = parseFloat(getComputedStyle(rootEl.value).getPropertyValue('--v-body-scroll-y')) || 0;
    if (rect.height < window.innerHeight - layoutTop) {
      isStuck.value = 'top';
      stuckPosition.value = layoutTop;
    } else if (direction === 'up' && isStuck.value === 'bottom' || direction === 'down' && isStuck.value === 'top') {
      stuckPosition.value = window.scrollY + rect.top - bodyScroll;
      isStuck.value = true;
    } else if (direction === 'down' && bottom <= 0) {
      stuckPosition.value = 0;
      isStuck.value = 'bottom';
    } else if (direction === 'up' && top <= 0) {
      if (!bodyScroll) {
        stuckPosition.value = rect.top + top;
        isStuck.value = 'top';
      } else if (isStuck.value !== 'top') {
        stuckPosition.value = -top + bodyScroll + layoutTop;
        isStuck.value = 'top';
      }
    }
    lastScrollTop = window.scrollY;
  }
  return {
    isStuck,
    stickyStyles
  };
}

// Utilities
const HORIZON = 100; // ms
const HISTORY = 20; // number of samples to keep

/** @see https://android.googlesource.com/platform/frameworks/native/+/master/libs/input/VelocityTracker.cpp */
function kineticEnergyToVelocity(work) {
  const sqrt2 = 1.41421356237;
  return (work < 0 ? -1.0 : 1.0) * Math.sqrt(Math.abs(work)) * sqrt2;
}

/**
 * Returns pointer velocity in px/s
 */
function calculateImpulseVelocity(samples) {
  // The input should be in reversed time order (most recent sample at index i=0)
  if (samples.length < 2) {
    // if 0 or 1 points, velocity is zero
    return 0;
  }
  // if (samples[1].t > samples[0].t) {
  //   // Algorithm will still work, but not perfectly
  //   consoleWarn('Samples provided to calculateImpulseVelocity in the wrong order')
  // }
  if (samples.length === 2) {
    // if 2 points, basic linear calculation
    if (samples[1].t === samples[0].t) {
      // consoleWarn(`Events have identical time stamps t=${samples[0].t}, setting velocity = 0`)
      return 0;
    }
    return (samples[1].d - samples[0].d) / (samples[1].t - samples[0].t);
  }
  // Guaranteed to have at least 3 points here
  // start with the oldest sample and go forward in time
  let work = 0;
  for (let i = samples.length - 1; i > 0; i--) {
    if (samples[i].t === samples[i - 1].t) {
      // consoleWarn(`Events have identical time stamps t=${samples[i].t}, skipping sample`)
      continue;
    }
    const vprev = kineticEnergyToVelocity(work); // v[i-1]
    const vcurr = (samples[i].d - samples[i - 1].d) / (samples[i].t - samples[i - 1].t); // v[i]
    work += (vcurr - vprev) * Math.abs(vcurr);
    if (i === samples.length - 1) {
      work *= 0.5;
    }
  }
  return kineticEnergyToVelocity(work) * 1000;
}
function useVelocity() {
  const touches = {};
  function addMovement(e) {
    Array.from(e.changedTouches).forEach(touch => {
      const samples = touches[touch.identifier] ?? (touches[touch.identifier] = new CircularBuffer(HISTORY));
      samples.push([e.timeStamp, touch]);
    });
  }
  function endTouch(e) {
    Array.from(e.changedTouches).forEach(touch => {
      delete touches[touch.identifier];
    });
  }
  function getVelocity(id) {
    const samples = touches[id]?.values().reverse();
    if (!samples) {
      throw new Error(`No samples for touch id ${id}`);
    }
    const newest = samples[0];
    const x = [];
    const y = [];
    for (const val of samples) {
      if (newest[0] - val[0] > HORIZON) break;
      x.push({
        t: val[0],
        d: val[1].clientX
      });
      y.push({
        t: val[0],
        d: val[1].clientY
      });
    }
    return {
      x: calculateImpulseVelocity(x),
      y: calculateImpulseVelocity(y),
      get direction() {
        const {
          x,
          y
        } = this;
        const [absX, absY] = [Math.abs(x), Math.abs(y)];
        return absX > absY && x >= 0 ? 'right' : absX > absY && x <= 0 ? 'left' : absY > absX && y >= 0 ? 'down' : absY > absX && y <= 0 ? 'up' : oops$1();
      }
    };
  }
  return {
    addMovement,
    endTouch,
    getVelocity
  };
}
function oops$1() {
  throw new Error();
}

// Composables

// Types

function useTouch(_ref) {
  let {
    el,
    isActive,
    isTemporary,
    width,
    touchless,
    position
  } = _ref;
  onMounted(() => {
    window.addEventListener('touchstart', onTouchstart, {
      passive: true
    });
    window.addEventListener('touchmove', onTouchmove, {
      passive: false
    });
    window.addEventListener('touchend', onTouchend, {
      passive: true
    });
  });
  onBeforeUnmount(() => {
    window.removeEventListener('touchstart', onTouchstart);
    window.removeEventListener('touchmove', onTouchmove);
    window.removeEventListener('touchend', onTouchend);
  });
  const isHorizontal = computed(() => ['left', 'right'].includes(position.value));
  const {
    addMovement,
    endTouch,
    getVelocity
  } = useVelocity();
  let maybeDragging = false;
  const isDragging = shallowRef(false);
  const dragProgress = shallowRef(0);
  const offset = shallowRef(0);
  let start;
  function getOffset(pos, active) {
    return (position.value === 'left' ? pos : position.value === 'right' ? document.documentElement.clientWidth - pos : position.value === 'top' ? pos : position.value === 'bottom' ? document.documentElement.clientHeight - pos : oops()) - (active ? width.value : 0);
  }
  function getProgress(pos) {
    let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const progress = position.value === 'left' ? (pos - offset.value) / width.value : position.value === 'right' ? (document.documentElement.clientWidth - pos - offset.value) / width.value : position.value === 'top' ? (pos - offset.value) / width.value : position.value === 'bottom' ? (document.documentElement.clientHeight - pos - offset.value) / width.value : oops();
    return limit ? Math.max(0, Math.min(1, progress)) : progress;
  }
  function onTouchstart(e) {
    if (touchless.value) return;
    const touchX = e.changedTouches[0].clientX;
    const touchY = e.changedTouches[0].clientY;
    const touchZone = 25;
    const inTouchZone = position.value === 'left' ? touchX < touchZone : position.value === 'right' ? touchX > document.documentElement.clientWidth - touchZone : position.value === 'top' ? touchY < touchZone : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - touchZone : oops();
    const inElement = isActive.value && (position.value === 'left' ? touchX < width.value : position.value === 'right' ? touchX > document.documentElement.clientWidth - width.value : position.value === 'top' ? touchY < width.value : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - width.value : oops());
    if (inTouchZone || inElement || isActive.value && isTemporary.value) {
      start = [touchX, touchY];
      offset.value = getOffset(isHorizontal.value ? touchX : touchY, isActive.value);
      dragProgress.value = getProgress(isHorizontal.value ? touchX : touchY);
      maybeDragging = offset.value > -20 && offset.value < 80;
      endTouch(e);
      addMovement(e);
    }
  }
  function onTouchmove(e) {
    const touchX = e.changedTouches[0].clientX;
    const touchY = e.changedTouches[0].clientY;
    if (maybeDragging) {
      if (!e.cancelable) {
        maybeDragging = false;
        return;
      }
      const dx = Math.abs(touchX - start[0]);
      const dy = Math.abs(touchY - start[1]);
      const thresholdMet = isHorizontal.value ? dx > dy && dx > 3 : dy > dx && dy > 3;
      if (thresholdMet) {
        isDragging.value = true;
        maybeDragging = false;
      } else if ((isHorizontal.value ? dy : dx) > 3) {
        maybeDragging = false;
      }
    }
    if (!isDragging.value) return;
    e.preventDefault();
    addMovement(e);
    const progress = getProgress(isHorizontal.value ? touchX : touchY, false);
    dragProgress.value = Math.max(0, Math.min(1, progress));
    if (progress > 1) {
      offset.value = getOffset(isHorizontal.value ? touchX : touchY, true);
    } else if (progress < 0) {
      offset.value = getOffset(isHorizontal.value ? touchX : touchY, false);
    }
  }
  function onTouchend(e) {
    maybeDragging = false;
    if (!isDragging.value) return;
    addMovement(e);
    isDragging.value = false;
    const velocity = getVelocity(e.changedTouches[0].identifier);
    const vx = Math.abs(velocity.x);
    const vy = Math.abs(velocity.y);
    const thresholdMet = isHorizontal.value ? vx > vy && vx > 400 : vy > vx && vy > 3;
    if (thresholdMet) {
      isActive.value = velocity.direction === ({
        left: 'right',
        right: 'left',
        top: 'down',
        bottom: 'up'
      }[position.value] || oops());
    } else {
      isActive.value = dragProgress.value > 0.5;
    }
  }
  const dragStyles = computed(() => {
    return isDragging.value ? {
      transform: position.value === 'left' ? `translateX(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'right' ? `translateX(calc(100% - ${dragProgress.value * width.value}px))` : position.value === 'top' ? `translateY(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'bottom' ? `translateY(calc(100% - ${dragProgress.value * width.value}px))` : oops(),
      transition: 'none'
    } : undefined;
  });
  useToggleScope(isDragging, () => {
    const transform = el.value?.style.transform ?? null;
    const transition = el.value?.style.transition ?? null;
    watchEffect(() => {
      el.value?.style.setProperty('transform', dragStyles.value?.transform || 'none');
      el.value?.style.setProperty('transition', dragStyles.value?.transition || null);
    });
    onScopeDispose(() => {
      el.value?.style.setProperty('transform', transform);
      el.value?.style.setProperty('transition', transition);
    });
  });
  return {
    isDragging,
    dragProgress,
    dragStyles
  };
}
function oops() {
  throw new Error();
}

const locations = ['start', 'end', 'left', 'right', 'top', 'bottom'];
const makeVNavigationDrawerProps = propsFactory({
  color: String,
  disableResizeWatcher: Boolean,
  disableRouteWatcher: Boolean,
  expandOnHover: Boolean,
  floating: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  permanent: Boolean,
  rail: {
    type: Boolean,
    default: null
  },
  railWidth: {
    type: [Number, String],
    default: 56
  },
  scrim: {
    type: [Boolean, String],
    default: true
  },
  image: String,
  temporary: Boolean,
  persistent: Boolean,
  touchless: Boolean,
  width: {
    type: [Number, String],
    default: 256
  },
  location: {
    type: String,
    default: 'start',
    validator: value => locations.includes(value)
  },
  sticky: Boolean,
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDelayProps(),
  ...makeDisplayProps({
    mobile: null
  }),
  ...makeElevationProps(),
  ...makeLayoutItemProps(),
  ...makeRoundedProps(),
  ...makeTagProps({
    tag: 'nav'
  }),
  ...makeThemeProps()
}, 'VNavigationDrawer');
const VNavigationDrawer = genericComponent()({
  name: 'VNavigationDrawer',
  props: makeVNavigationDrawerProps(),
  emits: {
    'update:modelValue': val => true,
    'update:rail': val => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const {
      isRtl
    } = useRtl();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      borderClasses
    } = useBorder(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      elevationClasses
    } = useElevation(props);
    const {
      displayClasses,
      mobile
    } = useDisplay(props);
    const {
      roundedClasses
    } = useRounded(props);
    const router = useRouter();
    const isActive = useProxiedModel(props, 'modelValue', null, v => !!v);
    const {
      ssrBootStyles
    } = useSsrBoot();
    const {
      scopeId
    } = useScopeId();
    const rootEl = ref();
    const isHovering = shallowRef(false);
    const {
      runOpenDelay,
      runCloseDelay
    } = useDelay(props, value => {
      isHovering.value = value;
    });
    const width = computed(() => {
      return props.rail && props.expandOnHover && isHovering.value ? Number(props.width) : Number(props.rail ? props.railWidth : props.width);
    });
    const location = computed(() => {
      return toPhysical(props.location, isRtl.value);
    });
    const isPersistent = computed(() => props.persistent);
    const isTemporary = computed(() => !props.permanent && (mobile.value || props.temporary));
    const isSticky = computed(() => props.sticky && !isTemporary.value && location.value !== 'bottom');
    useToggleScope(() => props.expandOnHover && props.rail != null, () => {
      watch(isHovering, val => emit('update:rail', !val));
    });
    useToggleScope(() => !props.disableResizeWatcher, () => {
      watch(isTemporary, val => !props.permanent && nextTick(() => isActive.value = !val));
    });
    useToggleScope(() => !props.disableRouteWatcher && !!router, () => {
      watch(router.currentRoute, () => isTemporary.value && (isActive.value = false));
    });
    watch(() => props.permanent, val => {
      if (val) isActive.value = true;
    });
    if (props.modelValue == null && !isTemporary.value) {
      isActive.value = props.permanent || !mobile.value;
    }
    const {
      isDragging,
      dragProgress
    } = useTouch({
      el: rootEl,
      isActive,
      isTemporary,
      width,
      touchless: toRef(props, 'touchless'),
      position: location
    });
    const layoutSize = computed(() => {
      const size = isTemporary.value ? 0 : props.rail && props.expandOnHover ? Number(props.railWidth) : width.value;
      return isDragging.value ? size * dragProgress.value : size;
    });
    const elementSize = computed(() => ['top', 'bottom'].includes(props.location) ? 0 : width.value);
    const {
      layoutItemStyles,
      layoutItemScrimStyles
    } = useLayoutItem({
      id: props.name,
      order: computed(() => parseInt(props.order, 10)),
      position: location,
      layoutSize,
      elementSize,
      active: computed(() => isActive.value || isDragging.value),
      disableTransitions: computed(() => isDragging.value),
      absolute: computed(() =>
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      props.absolute || isSticky.value && typeof isStuck.value !== 'string')
    });
    const {
      isStuck,
      stickyStyles
    } = useSticky({
      rootEl,
      isSticky,
      layoutItemStyles
    });
    const scrimColor = useBackgroundColor(computed(() => {
      return typeof props.scrim === 'string' ? props.scrim : null;
    }));
    const scrimStyles = computed(() => ({
      ...(isDragging.value ? {
        opacity: dragProgress.value * 0.2,
        transition: 'none'
      } : undefined),
      ...layoutItemScrimStyles.value
    }));
    provideDefaults({
      VList: {
        bgColor: 'transparent'
      }
    });
    useRender(() => {
      const hasImage = slots.image || props.image;
      return createVNode(Fragment, null, [createVNode(props.tag, mergeProps({
        "ref": rootEl,
        "onMouseenter": runOpenDelay,
        "onMouseleave": runCloseDelay,
        "class": ['v-navigation-drawer', `v-navigation-drawer--${location.value}`, {
          'v-navigation-drawer--expand-on-hover': props.expandOnHover,
          'v-navigation-drawer--floating': props.floating,
          'v-navigation-drawer--is-hovering': isHovering.value,
          'v-navigation-drawer--rail': props.rail,
          'v-navigation-drawer--temporary': isTemporary.value,
          'v-navigation-drawer--persistent': isPersistent.value,
          'v-navigation-drawer--active': isActive.value,
          'v-navigation-drawer--sticky': isSticky.value
        }, themeClasses.value, backgroundColorClasses.value, borderClasses.value, displayClasses.value, elevationClasses.value, roundedClasses.value, props.class],
        "style": [backgroundColorStyles.value, layoutItemStyles.value, ssrBootStyles.value, stickyStyles.value, props.style, ['top', 'bottom'].includes(location.value) ? {
          height: 'auto'
        } : {}]
      }, scopeId, attrs), {
        default: () => [hasImage && createVNode("div", {
          "key": "image",
          "class": "v-navigation-drawer__img"
        }, [!slots.image ? createVNode(VImg, {
          "key": "image-img",
          "alt": "",
          "cover": true,
          "height": "inherit",
          "src": props.image
        }, null) : createVNode(VDefaultsProvider, {
          "key": "image-defaults",
          "disabled": !props.image,
          "defaults": {
            VImg: {
              alt: '',
              cover: true,
              height: 'inherit',
              src: props.image
            }
          }
        }, slots.image)]), slots.prepend && createVNode("div", {
          "class": "v-navigation-drawer__prepend"
        }, [slots.prepend?.()]), createVNode("div", {
          "class": "v-navigation-drawer__content"
        }, [slots.default?.()]), slots.append && createVNode("div", {
          "class": "v-navigation-drawer__append"
        }, [slots.append?.()])]
      }), createVNode(Transition, {
        "name": "fade-transition"
      }, {
        default: () => [isTemporary.value && (isDragging.value || isActive.value) && !!props.scrim && createVNode("div", mergeProps({
          "class": ['v-navigation-drawer__scrim', scrimColor.backgroundColorClasses.value],
          "style": [scrimStyles.value, scrimColor.backgroundColorStyles.value],
          "onClick": () => {
            if (isPersistent.value) return;
            isActive.value = false;
          }
        }, scopeId), null)]
      })]);
    });
    return {
      isStuck
    };
  }
});

const makeVRadioProps = propsFactory({
  ...makeVSelectionControlProps({
    falseIcon: '$radioOff',
    trueIcon: '$radioOn'
  })
}, 'VRadio');
const VRadio = genericComponent()({
  name: 'VRadio',
  props: makeVRadioProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => {
      const controlProps = VSelectionControl.filterProps(props);
      return createVNode(VSelectionControl, mergeProps(controlProps, {
        "class": ['v-radio', props.class],
        "style": props.style,
        "type": "radio"
      }), slots);
    });
    return {};
  }
});

const makeVRadioGroupProps = propsFactory({
  height: {
    type: [Number, String],
    default: 'auto'
  },
  ...makeVInputProps(),
  ...omit(makeSelectionControlGroupProps(), ['multiple']),
  trueIcon: {
    type: IconValue,
    default: '$radioOn'
  },
  falseIcon: {
    type: IconValue,
    default: '$radioOff'
  },
  type: {
    type: String,
    default: 'radio'
  }
}, 'VRadioGroup');
const VRadioGroup = genericComponent()({
  name: 'VRadioGroup',
  inheritAttrs: false,
  props: makeVRadioGroupProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const uid = getUid();
    const id = computed(() => props.id || `radio-group-${uid}`);
    const model = useProxiedModel(props, 'modelValue');
    useRender(() => {
      const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
      const inputProps = VInput.filterProps(props);
      const controlProps = VSelectionControl.filterProps(props);
      const label = slots.label ? slots.label({
        label: props.label,
        props: {
          for: id.value
        }
      }) : props.label;
      return createVNode(VInput, mergeProps({
        "class": ['v-radio-group', props.class],
        "style": props.style
      }, rootAttrs, inputProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "id": id.value
      }), {
        ...slots,
        default: _ref2 => {
          let {
            id,
            messagesId,
            isDisabled,
            isReadonly
          } = _ref2;
          return createVNode(Fragment, null, [label && createVNode(VLabel, {
            "id": id.value
          }, {
            default: () => [label]
          }), createVNode(VSelectionControlGroup, mergeProps(controlProps, {
            "id": id.value,
            "aria-describedby": messagesId.value,
            "defaultsTarget": "VRadio",
            "trueIcon": props.trueIcon,
            "falseIcon": props.falseIcon,
            "type": props.type,
            "disabled": isDisabled.value,
            "readonly": isReadonly.value,
            "aria-labelledby": label ? id.value : undefined,
            "multiple": false
          }, controlAttrs, {
            "modelValue": model.value,
            "onUpdate:modelValue": $event => model.value = $event
          }), slots)]);
        }
      });
    });
    return {};
  }
});

const rootTypes = {
  actions: 'button@2',
  article: 'heading, paragraph',
  avatar: 'avatar',
  button: 'button',
  card: 'image, heading',
  'card-avatar': 'image, list-item-avatar',
  chip: 'chip',
  'date-picker': 'list-item, heading, divider, date-picker-options, date-picker-days, actions',
  'date-picker-options': 'text, avatar@2',
  'date-picker-days': 'avatar@28',
  divider: 'divider',
  heading: 'heading',
  image: 'image',
  'list-item': 'text',
  'list-item-avatar': 'avatar, text',
  'list-item-two-line': 'sentences',
  'list-item-avatar-two-line': 'avatar, sentences',
  'list-item-three-line': 'paragraph',
  'list-item-avatar-three-line': 'avatar, paragraph',
  ossein: 'ossein',
  paragraph: 'text@3',
  sentences: 'text@2',
  subtitle: 'text',
  table: 'table-heading, table-thead, table-tbody, table-tfoot',
  'table-heading': 'chip, text',
  'table-thead': 'heading@6',
  'table-tbody': 'table-row-divider@6',
  'table-row-divider': 'table-row, divider',
  'table-row': 'text@6',
  'table-tfoot': 'text@2, avatar@2',
  text: 'text'
};
function genBone(type) {
  let children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return createVNode("div", {
    "class": ['v-skeleton-loader__bone', `v-skeleton-loader__${type}`]
  }, [children]);
}
function genBones(bone) {
  // e.g. 'text@3'
  const [type, length] = bone.split('@');

  // Generate a length array based upon
  // value after @ in the bone string
  return Array.from({
    length
  }).map(() => genStructure(type));
}
function genStructure(type) {
  let children = [];
  if (!type) return children;

  // TODO: figure out a better way to type this
  const bone = rootTypes[type];

  // End of recursion, do nothing
  /* eslint-disable-next-line no-empty, brace-style */
  if (type === bone) ;
  // Array of values - e.g. 'heading, paragraph, text@2'
  else if (type.includes(',')) return mapBones(type);
  // Array of values - e.g. 'paragraph@4'
  else if (type.includes('@')) return genBones(type);
  // Array of values - e.g. 'card@2'
  else if (bone.includes(',')) children = mapBones(bone);
  // Array of values - e.g. 'list-item@2'
  else if (bone.includes('@')) children = genBones(bone);
  // Single value - e.g. 'card-heading'
  else if (bone) children.push(genStructure(bone));
  return [genBone(type, children)];
}
function mapBones(bones) {
  // Remove spaces and return array of structures
  return bones.replace(/\s/g, '').split(',').map(genStructure);
}
const makeVSkeletonLoaderProps = propsFactory({
  boilerplate: Boolean,
  color: String,
  loading: Boolean,
  loadingText: {
    type: String,
    default: '$vuetify.loading'
  },
  type: {
    type: [String, Array],
    default: 'ossein'
  },
  ...makeDimensionProps(),
  ...makeElevationProps(),
  ...makeThemeProps()
}, 'VSkeletonLoader');
const VSkeletonLoader = genericComponent()({
  name: 'VSkeletonLoader',
  props: makeVSkeletonLoaderProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const {
      dimensionStyles
    } = useDimension(props);
    const {
      elevationClasses
    } = useElevation(props);
    const {
      themeClasses
    } = provideTheme(props);
    const {
      t
    } = useLocale();
    const items = computed(() => genStructure(wrapInArray(props.type).join(',')));
    useRender(() => {
      const isLoading = !slots.default || props.loading;
      const loadingProps = props.boilerplate || !isLoading ? {} : {
        ariaLive: 'polite',
        ariaLabel: t(props.loadingText),
        role: 'alert'
      };
      return createVNode("div", mergeProps({
        "class": ['v-skeleton-loader', {
          'v-skeleton-loader--boilerplate': props.boilerplate
        }, themeClasses.value, backgroundColorClasses.value, elevationClasses.value],
        "style": [backgroundColorStyles.value, isLoading ? dimensionStyles.value : {}]
      }, loadingProps), [isLoading ? items.value : slots.default?.()]);
    });
    return {};
  }
});

function useCountdown(milliseconds) {
  const time = shallowRef(milliseconds());
  let timer = -1;
  function clear() {
    clearInterval(timer);
  }
  function reset() {
    clear();
    nextTick(() => time.value = milliseconds());
  }
  function start(el) {
    const style = el ? getComputedStyle(el) : {
      transitionDuration: 0.2
    };
    const interval = parseFloat(style.transitionDuration) * 1000 || 200;
    clear();
    if (time.value <= 0) return;
    const startTime = performance.now();
    timer = window.setInterval(() => {
      const elapsed = performance.now() - startTime + interval;
      time.value = Math.max(milliseconds() - elapsed, 0);
      if (time.value <= 0) clear();
    }, interval);
  }
  onScopeDispose(clear);
  return {
    clear,
    time,
    start,
    reset
  };
}
const makeVSnackbarProps = propsFactory({
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5000
  },
  vertical: Boolean,
  ...makeLocationProps({
    location: 'bottom'
  }),
  ...makePositionProps(),
  ...makeRoundedProps(),
  ...makeVariantProps(),
  ...makeThemeProps(),
  ...omit(makeVOverlayProps({
    transition: 'v-snackbar-transition'
  }), ['persistent', 'noClickAnimation', 'scrim', 'scrollStrategy'])
}, 'VSnackbar');
const VSnackbar = genericComponent()({
  name: 'VSnackbar',
  props: makeVSnackbarProps(),
  emits: {
    'update:modelValue': v => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const isActive = useProxiedModel(props, 'modelValue');
    const {
      positionClasses
    } = usePosition(props);
    const {
      scopeId
    } = useScopeId();
    const {
      themeClasses
    } = provideTheme(props);
    const {
      colorClasses,
      colorStyles,
      variantClasses
    } = useVariant(props);
    const {
      roundedClasses
    } = useRounded(props);
    const countdown = useCountdown(() => Number(props.timeout));
    const overlay = ref();
    const timerRef = ref();
    const isHovering = shallowRef(false);
    const startY = shallowRef(0);
    const mainStyles = ref();
    const hasLayout = inject$2(VuetifyLayoutKey, undefined);
    useToggleScope(() => !!hasLayout, () => {
      const layout = useLayout();
      watchEffect(() => {
        mainStyles.value = layout.mainStyles.value;
      });
    });
    watch(isActive, startTimeout);
    watch(() => props.timeout, startTimeout);
    onMounted(() => {
      if (isActive.value) startTimeout();
    });
    let activeTimeout = -1;
    function startTimeout() {
      countdown.reset();
      window.clearTimeout(activeTimeout);
      const timeout = Number(props.timeout);
      if (!isActive.value || timeout === -1) return;
      const element = refElement(timerRef.value);
      countdown.start(element);
      activeTimeout = window.setTimeout(() => {
        isActive.value = false;
      }, timeout);
    }
    function clearTimeout() {
      countdown.reset();
      window.clearTimeout(activeTimeout);
    }
    function onPointerenter() {
      isHovering.value = true;
      clearTimeout();
    }
    function onPointerleave() {
      isHovering.value = false;
      startTimeout();
    }
    function onTouchstart(event) {
      startY.value = event.touches[0].clientY;
    }
    function onTouchend(event) {
      if (Math.abs(startY.value - event.changedTouches[0].clientY) > 50) {
        isActive.value = false;
      }
    }
    function onAfterLeave() {
      if (isHovering.value) onPointerleave();
    }
    const locationClasses = computed(() => {
      return props.location.split(' ').reduce((acc, loc) => {
        acc[`v-snackbar--${loc}`] = true;
        return acc;
      }, {});
    });
    useRender(() => {
      const overlayProps = VOverlay.filterProps(props);
      const hasContent = !!(slots.default || slots.text || props.text);
      return createVNode(VOverlay, mergeProps({
        "ref": overlay,
        "class": ['v-snackbar', {
          'v-snackbar--active': isActive.value,
          'v-snackbar--multi-line': props.multiLine && !props.vertical,
          'v-snackbar--timer': !!props.timer,
          'v-snackbar--vertical': props.vertical
        }, locationClasses.value, positionClasses.value, props.class],
        "style": [mainStyles.value, props.style]
      }, overlayProps, {
        "modelValue": isActive.value,
        "onUpdate:modelValue": $event => isActive.value = $event,
        "contentProps": mergeProps({
          class: ['v-snackbar__wrapper', themeClasses.value, colorClasses.value, roundedClasses.value, variantClasses.value],
          style: [colorStyles.value],
          onPointerenter,
          onPointerleave
        }, overlayProps.contentProps),
        "persistent": true,
        "noClickAnimation": true,
        "scrim": false,
        "scrollStrategy": "none",
        "_disableGlobalStack": true,
        "onTouchstartPassive": onTouchstart,
        "onTouchend": onTouchend,
        "onAfterLeave": onAfterLeave
      }, scopeId), {
        default: () => [genOverlays(false, 'v-snackbar'), props.timer && !isHovering.value && createVNode("div", {
          "key": "timer",
          "class": "v-snackbar__timer"
        }, [createVNode(VProgressLinear, {
          "ref": timerRef,
          "color": typeof props.timer === 'string' ? props.timer : 'info',
          "max": props.timeout,
          "model-value": countdown.time.value
        }, null)]), hasContent && createVNode("div", {
          "key": "content",
          "class": "v-snackbar__content",
          "role": "status",
          "aria-live": "polite"
        }, [slots.text?.() ?? props.text, slots.default?.()]), slots.actions && createVNode(VDefaultsProvider, {
          "defaults": {
            VBtn: {
              variant: 'text',
              ripple: false,
              slim: true
            }
          }
        }, {
          default: () => [createVNode("div", {
            "class": "v-snackbar__actions"
          }, [slots.actions({
            isActive
          })])]
        })],
        activator: slots.activator
      });
    });
    return forwardRefs({}, overlay);
  }
});

const makeVSwitchProps = propsFactory({
  indeterminate: Boolean,
  inset: Boolean,
  flat: Boolean,
  loading: {
    type: [Boolean, String],
    default: false
  },
  ...makeVInputProps(),
  ...makeVSelectionControlProps()
}, 'VSwitch');
const VSwitch = genericComponent()({
  name: 'VSwitch',
  inheritAttrs: false,
  props: makeVSwitchProps(),
  emits: {
    'update:focused': focused => true,
    'update:modelValue': value => true,
    'update:indeterminate': value => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const indeterminate = useProxiedModel(props, 'indeterminate');
    const model = useProxiedModel(props, 'modelValue');
    const {
      loaderClasses
    } = useLoader(props);
    const {
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const control = ref();
    const isForcedColorsModeActive = IN_BROWSER && window.matchMedia('(forced-colors: active)').matches;
    const loaderColor = computed(() => {
      return typeof props.loading === 'string' && props.loading !== '' ? props.loading : props.color;
    });
    const uid = getUid();
    const id = computed(() => props.id || `switch-${uid}`);
    function onChange() {
      if (indeterminate.value) {
        indeterminate.value = false;
      }
    }
    function onTrackClick(e) {
      e.stopPropagation();
      e.preventDefault();
      control.value?.input?.click();
    }
    useRender(() => {
      const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
      const inputProps = VInput.filterProps(props);
      const controlProps = VSelectionControl.filterProps(props);
      return createVNode(VInput, mergeProps({
        "class": ['v-switch', {
          'v-switch--flat': props.flat
        }, {
          'v-switch--inset': props.inset
        }, {
          'v-switch--indeterminate': indeterminate.value
        }, loaderClasses.value, props.class]
      }, rootAttrs, inputProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "id": id.value,
        "focused": isFocused.value,
        "style": props.style
      }), {
        ...slots,
        default: _ref2 => {
          let {
            id,
            messagesId,
            isDisabled,
            isReadonly,
            isValid
          } = _ref2;
          const slotProps = {
            model,
            isValid
          };
          return createVNode(VSelectionControl, mergeProps({
            "ref": control
          }, controlProps, {
            "modelValue": model.value,
            "onUpdate:modelValue": [$event => model.value = $event, onChange],
            "id": id.value,
            "aria-describedby": messagesId.value,
            "type": "checkbox",
            "aria-checked": indeterminate.value ? 'mixed' : undefined,
            "disabled": isDisabled.value,
            "readonly": isReadonly.value,
            "onFocus": focus,
            "onBlur": blur
          }, controlAttrs), {
            ...slots,
            default: _ref3 => {
              let {
                backgroundColorClasses,
                backgroundColorStyles
              } = _ref3;
              return createVNode("div", {
                "class": ['v-switch__track', !isForcedColorsModeActive ? backgroundColorClasses.value : undefined],
                "style": backgroundColorStyles.value,
                "onClick": onTrackClick
              }, [slots['track-true'] && createVNode("div", {
                "key": "prepend",
                "class": "v-switch__track-true"
              }, [slots['track-true'](slotProps)]), slots['track-false'] && createVNode("div", {
                "key": "append",
                "class": "v-switch__track-false"
              }, [slots['track-false'](slotProps)])]);
            },
            input: _ref4 => {
              let {
                inputNode,
                icon,
                backgroundColorClasses,
                backgroundColorStyles
              } = _ref4;
              return createVNode(Fragment, null, [inputNode, createVNode("div", {
                "class": ['v-switch__thumb', {
                  'v-switch__thumb--filled': icon || props.loading
                }, props.inset || isForcedColorsModeActive ? undefined : backgroundColorClasses.value],
                "style": props.inset ? undefined : backgroundColorStyles.value
              }, [slots.thumb ? createVNode(VDefaultsProvider, {
                "defaults": {
                  VIcon: {
                    icon,
                    size: 'x-small'
                  }
                }
              }, {
                default: () => [slots.thumb({
                  ...slotProps,
                  icon
                })]
              }) : createVNode(VScaleTransition, null, {
                default: () => [!props.loading ? icon && createVNode(VIcon, {
                  "key": String(icon),
                  "icon": icon,
                  "size": "x-small"
                }, null) : createVNode(LoaderSlot, {
                  "name": "v-switch",
                  "active": true,
                  "color": isValid.value === false ? undefined : loaderColor.value
                }, {
                  default: slotProps => slots.loader ? slots.loader(slotProps) : createVNode(VProgressCircular, {
                    "active": slotProps.isActive,
                    "color": slotProps.color,
                    "indeterminate": true,
                    "size": "16",
                    "width": "2"
                  }, null)
                })]
              })])]);
            }
          });
        }
      });
    });
    return {};
  }
});

// Types

const VTabsSymbol = Symbol.for('vuetify:v-tabs');

const makeVTabProps = propsFactory({
  fixed: Boolean,
  sliderColor: String,
  hideSlider: Boolean,
  direction: {
    type: String,
    default: 'horizontal'
  },
  ...omit(makeVBtnProps({
    selectedClass: 'v-tab--selected',
    variant: 'text'
  }), ['active', 'block', 'flat', 'location', 'position', 'symbol'])
}, 'VTab');
const VTab = genericComponent()({
  name: 'VTab',
  props: makeVTabProps(),
  setup(props, _ref) {
    let {
      slots,
      attrs
    } = _ref;
    const {
      textColorClasses: sliderColorClasses,
      textColorStyles: sliderColorStyles
    } = useTextColor(props, 'sliderColor');
    const rootEl = ref();
    const sliderEl = ref();
    const isHorizontal = computed(() => props.direction === 'horizontal');
    const isSelected = computed(() => rootEl.value?.group?.isSelected.value ?? false);
    function updateSlider(_ref2) {
      let {
        value
      } = _ref2;
      if (value) {
        const prevEl = rootEl.value?.$el.parentElement?.querySelector('.v-tab--selected .v-tab__slider');
        const nextEl = sliderEl.value;
        if (!prevEl || !nextEl) return;
        const color = getComputedStyle(prevEl).color;
        const prevBox = prevEl.getBoundingClientRect();
        const nextBox = nextEl.getBoundingClientRect();
        const xy = isHorizontal.value ? 'x' : 'y';
        const XY = isHorizontal.value ? 'X' : 'Y';
        const rightBottom = isHorizontal.value ? 'right' : 'bottom';
        const widthHeight = isHorizontal.value ? 'width' : 'height';
        const prevPos = prevBox[xy];
        const nextPos = nextBox[xy];
        const delta = prevPos > nextPos ? prevBox[rightBottom] - nextBox[rightBottom] : prevBox[xy] - nextBox[xy];
        const origin = Math.sign(delta) > 0 ? isHorizontal.value ? 'right' : 'bottom' : Math.sign(delta) < 0 ? isHorizontal.value ? 'left' : 'top' : 'center';
        const size = Math.abs(delta) + (Math.sign(delta) < 0 ? prevBox[widthHeight] : nextBox[widthHeight]);
        const scale = size / Math.max(prevBox[widthHeight], nextBox[widthHeight]) || 0;
        const initialScale = prevBox[widthHeight] / nextBox[widthHeight] || 0;
        const sigma = 1.5;
        animate(nextEl, {
          backgroundColor: [color, 'currentcolor'],
          transform: [`translate${XY}(${delta}px) scale${XY}(${initialScale})`, `translate${XY}(${delta / sigma}px) scale${XY}(${(scale - 1) / sigma + 1})`, 'none'],
          transformOrigin: Array(3).fill(origin)
        }, {
          duration: 225,
          easing: standardEasing
        });
      }
    }
    useRender(() => {
      const btnProps = VBtn.filterProps(props);
      return createVNode(VBtn, mergeProps({
        "symbol": VTabsSymbol,
        "ref": rootEl,
        "class": ['v-tab', props.class],
        "style": props.style,
        "tabindex": isSelected.value ? 0 : -1,
        "role": "tab",
        "aria-selected": String(isSelected.value),
        "active": false
      }, btnProps, attrs, {
        "block": props.fixed,
        "maxWidth": props.fixed ? 300 : undefined,
        "onGroup:selected": updateSlider
      }), {
        ...slots,
        default: () => createVNode(Fragment, null, [slots.default?.() ?? props.text, !props.hideSlider && createVNode("div", {
          "ref": sliderEl,
          "class": ['v-tab__slider', sliderColorClasses.value],
          "style": sliderColorStyles.value
        }, null)])
      });
    });
    return forwardRefs({}, rootEl);
  }
});

const makeVTabsWindowProps = propsFactory({
  ...omit(makeVWindowProps(), ['continuous', 'nextIcon', 'prevIcon', 'showArrows', 'touch', 'mandatory'])
}, 'VTabsWindow');
const VTabsWindow = genericComponent()({
  name: 'VTabsWindow',
  props: makeVTabsWindowProps(),
  emits: {
    'update:modelValue': v => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const group = inject$2(VTabsSymbol, null);
    const _model = useProxiedModel(props, 'modelValue');
    const model = computed({
      get() {
        // Always return modelValue if defined
        // or if not within a VTabs group
        if (_model.value != null || !group) return _model.value;

        // If inside of a VTabs, find the currently selected
        // item by id. Item value may be assigned by its index
        return group.items.value.find(item => group.selected.value.includes(item.id))?.value;
      },
      set(val) {
        _model.value = val;
      }
    });
    useRender(() => {
      const windowProps = VWindow.filterProps(props);
      return createVNode(VWindow, mergeProps({
        "_as": "VTabsWindow"
      }, windowProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "class": ['v-tabs-window', props.class],
        "style": props.style,
        "mandatory": false,
        "touch": false
      }), slots);
    });
    return {};
  }
});

const makeVTabsWindowItemProps = propsFactory({
  ...makeVWindowItemProps()
}, 'VTabsWindowItem');
const VTabsWindowItem = genericComponent()({
  name: 'VTabsWindowItem',
  props: makeVTabsWindowItemProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    useRender(() => {
      const windowItemProps = VWindowItem.filterProps(props);
      return createVNode(VWindowItem, mergeProps({
        "_as": "VTabsWindowItem"
      }, windowItemProps, {
        "class": ['v-tabs-window-item', props.class],
        "style": props.style
      }), slots);
    });
    return {};
  }
});

function parseItems(items) {
  if (!items) return [];
  return items.map(item => {
    if (!isObject$1(item)) return {
      text: item,
      value: item
    };
    return item;
  });
}
const makeVTabsProps = propsFactory({
  alignTabs: {
    type: String,
    default: 'start'
  },
  color: String,
  fixedTabs: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  stacked: Boolean,
  bgColor: String,
  grow: Boolean,
  height: {
    type: [Number, String],
    default: undefined
  },
  hideSlider: Boolean,
  sliderColor: String,
  ...makeVSlideGroupProps({
    mandatory: 'force',
    selectedClass: 'v-tab-item--selected'
  }),
  ...makeDensityProps(),
  ...makeTagProps()
}, 'VTabs');
const VTabs = genericComponent()({
  name: 'VTabs',
  props: makeVTabsProps(),
  emits: {
    'update:modelValue': v => true
  },
  setup(props, _ref) {
    let {
      attrs,
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const items = computed(() => parseItems(props.items));
    const {
      densityClasses
    } = useDensity(props);
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'bgColor'));
    const {
      scopeId
    } = useScopeId();
    provideDefaults({
      VTab: {
        color: toRef(props, 'color'),
        direction: toRef(props, 'direction'),
        stacked: toRef(props, 'stacked'),
        fixed: toRef(props, 'fixedTabs'),
        sliderColor: toRef(props, 'sliderColor'),
        hideSlider: toRef(props, 'hideSlider')
      }
    });
    useRender(() => {
      const slideGroupProps = VSlideGroup.filterProps(props);
      const hasWindow = !!(slots.window || props.items.length > 0);
      return createVNode(Fragment, null, [createVNode(VSlideGroup, mergeProps(slideGroupProps, {
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "class": ['v-tabs', `v-tabs--${props.direction}`, `v-tabs--align-tabs-${props.alignTabs}`, {
          'v-tabs--fixed-tabs': props.fixedTabs,
          'v-tabs--grow': props.grow,
          'v-tabs--stacked': props.stacked
        }, densityClasses.value, backgroundColorClasses.value, props.class],
        "style": [{
          '--v-tabs-height': convertToUnit(props.height)
        }, backgroundColorStyles.value, props.style],
        "role": "tablist",
        "symbol": VTabsSymbol
      }, scopeId, attrs), {
        default: () => [slots.default?.() ?? items.value.map(item => slots.tab?.({
          item
        }) ?? createVNode(VTab, mergeProps(item, {
          "key": item.text,
          "value": item.value
        }), {
          default: slots[`tab.${item.value}`] ? () => slots[`tab.${item.value}`]?.({
            item
          }) : undefined
        }))]
      }), hasWindow && createVNode(VTabsWindow, mergeProps({
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "key": "tabs-window"
      }, scopeId), {
        default: () => [items.value.map(item => slots.item?.({
          item
        }) ?? createVNode(VTabsWindowItem, {
          "value": item.value
        }, {
          default: () => slots[`item.${item.value}`]?.({
            item
          })
        })), slots.window?.()]
      })]);
    });
    return {};
  }
});

const makeVTextareaProps = propsFactory({
  autoGrow: Boolean,
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  noResize: Boolean,
  rows: {
    type: [Number, String],
    default: 5,
    validator: v => !isNaN(parseFloat(v))
  },
  maxRows: {
    type: [Number, String],
    validator: v => !isNaN(parseFloat(v))
  },
  suffix: String,
  modelModifiers: Object,
  ...makeVInputProps(),
  ...makeVFieldProps()
}, 'VTextarea');
const VTextarea = genericComponent()({
  name: 'VTextarea',
  directives: {
    Intersect
  },
  inheritAttrs: false,
  props: makeVTextareaProps(),
  emits: {
    'click:control': e => true,
    'mousedown:control': e => true,
    'update:focused': focused => true,
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      attrs,
      emit,
      slots
    } = _ref;
    const model = useProxiedModel(props, 'modelValue');
    const {
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const counterValue = computed(() => {
      return typeof props.counterValue === 'function' ? props.counterValue(model.value) : (model.value || '').toString().length;
    });
    const max = computed(() => {
      if (attrs.maxlength) return attrs.maxlength;
      if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
      return props.counter;
    });
    function onIntersect(isIntersecting, entries) {
      if (!props.autofocus || !isIntersecting) return;
      entries[0].target?.focus?.();
    }
    const vInputRef = ref();
    const vFieldRef = ref();
    const controlHeight = shallowRef('');
    const textareaRef = ref();
    const isActive = computed(() => props.persistentPlaceholder || isFocused.value || props.active);
    function onFocus() {
      if (textareaRef.value !== document.activeElement) {
        textareaRef.value?.focus();
      }
      if (!isFocused.value) focus();
    }
    function onControlClick(e) {
      onFocus();
      emit('click:control', e);
    }
    function onControlMousedown(e) {
      emit('mousedown:control', e);
    }
    function onClear(e) {
      e.stopPropagation();
      onFocus();
      nextTick(() => {
        model.value = '';
        callEvent(props['onClick:clear'], e);
      });
    }
    function onInput(e) {
      const el = e.target;
      model.value = el.value;
      if (props.modelModifiers?.trim) {
        const caretPosition = [el.selectionStart, el.selectionEnd];
        nextTick(() => {
          el.selectionStart = caretPosition[0];
          el.selectionEnd = caretPosition[1];
        });
      }
    }
    const sizerRef = ref();
    const rows = ref(+props.rows);
    const isPlainOrUnderlined = computed(() => ['plain', 'underlined'].includes(props.variant));
    watchEffect(() => {
      if (!props.autoGrow) rows.value = +props.rows;
    });
    function calculateInputHeight() {
      if (!props.autoGrow) return;
      nextTick(() => {
        if (!sizerRef.value || !vFieldRef.value) return;
        const style = getComputedStyle(sizerRef.value);
        const fieldStyle = getComputedStyle(vFieldRef.value.$el);
        const padding = parseFloat(style.getPropertyValue('--v-field-padding-top')) + parseFloat(style.getPropertyValue('--v-input-padding-top')) + parseFloat(style.getPropertyValue('--v-field-padding-bottom'));
        const height = sizerRef.value.scrollHeight;
        const lineHeight = parseFloat(style.lineHeight);
        const minHeight = Math.max(parseFloat(props.rows) * lineHeight + padding, parseFloat(fieldStyle.getPropertyValue('--v-input-control-height')));
        const maxHeight = parseFloat(props.maxRows) * lineHeight + padding || Infinity;
        const newHeight = clamp(height ?? 0, minHeight, maxHeight);
        rows.value = Math.floor((newHeight - padding) / lineHeight);
        controlHeight.value = convertToUnit(newHeight);
      });
    }
    onMounted(calculateInputHeight);
    watch(model, calculateInputHeight);
    watch(() => props.rows, calculateInputHeight);
    watch(() => props.maxRows, calculateInputHeight);
    watch(() => props.density, calculateInputHeight);
    let observer;
    watch(sizerRef, val => {
      if (val) {
        observer = new ResizeObserver(calculateInputHeight);
        observer.observe(sizerRef.value);
      } else {
        observer?.disconnect();
      }
    });
    onBeforeUnmount(() => {
      observer?.disconnect();
    });
    useRender(() => {
      const hasCounter = !!(slots.counter || props.counter || props.counterValue);
      const hasDetails = !!(hasCounter || slots.details);
      const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
      const {
        modelValue: _,
        ...inputProps
      } = VInput.filterProps(props);
      const fieldProps = filterFieldProps(props);
      return createVNode(VInput, mergeProps({
        "ref": vInputRef,
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "class": ['v-textarea v-text-field', {
          'v-textarea--prefixed': props.prefix,
          'v-textarea--suffixed': props.suffix,
          'v-text-field--prefixed': props.prefix,
          'v-text-field--suffixed': props.suffix,
          'v-textarea--auto-grow': props.autoGrow,
          'v-textarea--no-resize': props.noResize || props.autoGrow,
          'v-input--plain-underlined': isPlainOrUnderlined.value
        }, props.class],
        "style": props.style
      }, rootAttrs, inputProps, {
        "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
        "focused": isFocused.value
      }), {
        ...slots,
        default: _ref2 => {
          let {
            id,
            isDisabled,
            isDirty,
            isReadonly,
            isValid
          } = _ref2;
          return createVNode(VField, mergeProps({
            "ref": vFieldRef,
            "style": {
              '--v-textarea-control-height': controlHeight.value
            },
            "onClick": onControlClick,
            "onMousedown": onControlMousedown,
            "onClick:clear": onClear,
            "onClick:prependInner": props['onClick:prependInner'],
            "onClick:appendInner": props['onClick:appendInner']
          }, fieldProps, {
            "id": id.value,
            "active": isActive.value || isDirty.value,
            "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
            "dirty": isDirty.value || props.dirty,
            "disabled": isDisabled.value,
            "focused": isFocused.value,
            "error": isValid.value === false
          }), {
            ...slots,
            default: _ref3 => {
              let {
                props: {
                  class: fieldClass,
                  ...slotProps
                }
              } = _ref3;
              return createVNode(Fragment, null, [props.prefix && createVNode("span", {
                "class": "v-text-field__prefix"
              }, [props.prefix]), withDirectives(createVNode("textarea", mergeProps({
                "ref": textareaRef,
                "class": fieldClass,
                "value": model.value,
                "onInput": onInput,
                "autofocus": props.autofocus,
                "readonly": isReadonly.value,
                "disabled": isDisabled.value,
                "placeholder": props.placeholder,
                "rows": props.rows,
                "name": props.name,
                "onFocus": onFocus,
                "onBlur": blur
              }, slotProps, inputAttrs), null), [[resolveDirective("intersect"), {
                handler: onIntersect
              }, null, {
                once: true
              }]]), props.autoGrow && withDirectives(createVNode("textarea", {
                "class": [fieldClass, 'v-textarea__sizer'],
                "id": `${slotProps.id}-sizer`,
                "onUpdate:modelValue": $event => model.value = $event,
                "ref": sizerRef,
                "readonly": true,
                "aria-hidden": "true"
              }, null), [[vModelText, model.value]]), props.suffix && createVNode("span", {
                "class": "v-text-field__suffix"
              }, [props.suffix])]);
            }
          });
        },
        details: hasDetails ? slotProps => createVNode(Fragment, null, [slots.details?.(slotProps), hasCounter && createVNode(Fragment, null, [createVNode("span", null, null), createVNode(VCounter, {
          "active": props.persistentCounter || isFocused.value,
          "value": counterValue.value,
          "max": max.value,
          "disabled": props.disabled
        }, slots.counter)])]) : undefined
      });
    });
    return forwardRefs({}, vInputRef, vFieldRef, textareaRef);
  }
});

const makeVToolbarItemsProps = propsFactory({
  ...makeComponentProps(),
  ...makeVariantProps({
    variant: 'text'
  })
}, 'VToolbarItems');
const VToolbarItems = genericComponent()({
  name: 'VToolbarItems',
  props: makeVToolbarItemsProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    provideDefaults({
      VBtn: {
        color: toRef(props, 'color'),
        height: 'inherit',
        variant: toRef(props, 'variant')
      }
    });
    useRender(() => createVNode("div", {
      "class": ['v-toolbar-items', props.class],
      "style": props.style
    }, [slots.default?.()]));
    return {};
  }
});

const makeVTooltipProps = propsFactory({
  id: String,
  text: String,
  ...omit(makeVOverlayProps({
    closeOnBack: false,
    location: 'end',
    locationStrategy: 'connected',
    eager: true,
    minWidth: 0,
    offset: 10,
    openOnClick: false,
    openOnHover: true,
    origin: 'auto',
    scrim: false,
    scrollStrategy: 'reposition',
    transition: false
  }), ['absolute', 'persistent'])
}, 'VTooltip');
const VTooltip = genericComponent()({
  name: 'VTooltip',
  props: makeVTooltipProps(),
  emits: {
    'update:modelValue': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const isActive = useProxiedModel(props, 'modelValue');
    const {
      scopeId
    } = useScopeId();
    const uid = getUid();
    const id = computed(() => props.id || `v-tooltip-${uid}`);
    const overlay = ref();
    const location = computed(() => {
      return props.location.split(' ').length > 1 ? props.location : props.location + ' center';
    });
    const origin = computed(() => {
      return props.origin === 'auto' || props.origin === 'overlap' || props.origin.split(' ').length > 1 || props.location.split(' ').length > 1 ? props.origin : props.origin + ' center';
    });
    const transition = computed(() => {
      if (props.transition) return props.transition;
      return isActive.value ? 'scale-transition' : 'fade-transition';
    });
    const activatorProps = computed(() => mergeProps({
      'aria-describedby': id.value
    }, props.activatorProps));
    useRender(() => {
      const overlayProps = VOverlay.filterProps(props);
      return createVNode(VOverlay, mergeProps({
        "ref": overlay,
        "class": ['v-tooltip', props.class],
        "style": props.style,
        "id": id.value
      }, overlayProps, {
        "modelValue": isActive.value,
        "onUpdate:modelValue": $event => isActive.value = $event,
        "transition": transition.value,
        "absolute": true,
        "location": location.value,
        "origin": origin.value,
        "persistent": true,
        "role": "tooltip",
        "activatorProps": activatorProps.value,
        "_disableGlobalStack": true
      }, scopeId), {
        activator: slots.activator,
        default: function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return slots.default?.(...args) ?? props.text;
        }
      });
    });
    return forwardRefs({}, overlay);
  }
});

// Types

function mounted(el, binding) {
  const handler = binding.value;
  const options = {
    passive: !binding.modifiers?.active
  };
  window.addEventListener('resize', handler, options);
  el._onResize = Object(el._onResize);
  el._onResize[binding.instance.$.uid] = {
    handler,
    options
  };
  if (!binding.modifiers?.quiet) {
    handler();
  }
}
function unmounted(el, binding) {
  if (!el._onResize?.[binding.instance.$.uid]) return;
  const {
    handler,
    options
  } = el._onResize[binding.instance.$.uid];
  window.removeEventListener('resize', handler, options);
  delete el._onResize[binding.instance.$.uid];
}
const Resize = {
  mounted,
  unmounted
};

// Utilities
function useDirectiveComponent(component, props) {
  const concreteComponent = typeof component === 'string' ? resolveComponent(component) : component;
  const hook = mountComponent(concreteComponent, props);
  return {
    mounted: hook,
    updated: hook,
    unmounted(el) {
      render$1c(null, el);
    }
  };
}
function mountComponent(component, props) {
  return function (el, binding, vnode) {
    const _props = typeof props === 'function' ? props(binding) : props;
    const text = binding.value?.text ?? binding.value ?? _props?.text;
    const value = isObject$1(binding.value) ? binding.value : {};

    // Get the children from the props or directive value, or the element's children
    const children = () => text ?? el.textContent;

    // If vnode.ctx is the same as the instance, then we're bound to a plain element
    // and need to find the nearest parent component instance to inherit provides from
    const provides = (vnode.ctx === binding.instance.$ ? findComponentParent(vnode, binding.instance.$)?.provides : vnode.ctx?.provides) ?? binding.instance.$.provides;
    const node = h(component, mergeProps(_props, value), children);
    node.appContext = Object.assign(Object.create(null), binding.instance.$.appContext, {
      provides
    });
    render$1c(node, el);
  };
}
function findComponentParent(vnode, root) {
  // Walk the tree from root until we find the child vnode
  const stack = new Set();
  const walk = children => {
    for (const child of children) {
      if (!child) continue;
      if (child === vnode || child.el && vnode.el && child.el === vnode.el) {
        return true;
      }
      stack.add(child);
      let result;
      if (child.suspense) {
        result = walk([child.ssContent]);
      } else if (Array.isArray(child.children)) {
        result = walk(child.children);
      } else if (child.component?.vnode) {
        result = walk([child.component?.subTree]);
      }
      if (result) {
        return result;
      }
      stack.delete(child);
    }
    return false;
  };
  if (!walk([root.subTree])) {
    consoleError('Could not find original vnode, component will not inherit provides');
    return root;
  }

  // Return the first component parent
  const result = Array.from(stack).reverse();
  for (const child of result) {
    if (child.component) {
      return child.component;
    }
  }
  return root;
}

// Components
const Tooltip = useDirectiveComponent(VTooltip, binding => {
  return {
    activator: 'parent',
    location: binding.arg?.replace('-', ' '),
    text: typeof binding.value === 'boolean' ? undefined : binding.value
  };
});

/* eslint-disable max-len */
// Composables
const aliases = {
  collapse: 'svg:M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z',
  complete: 'svg:M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z',
  cancel: 'svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  close: 'svg:M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z',
  delete: 'svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  // delete (e.g. v-chip close)
  clear: 'svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  success: 'svg:M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z',
  info: 'svg:M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  warning: 'svg:M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z',
  error: 'svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z',
  prev: 'svg:M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z',
  next: 'svg:M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z',
  checkboxOn: 'svg:M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  checkboxOff: 'svg:M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z',
  checkboxIndeterminate: 'svg:M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z',
  delimiter: 'svg:M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  // for carousel
  sortAsc: 'svg:M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z',
  sortDesc: 'svg:M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z',
  expand: 'svg:M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z',
  menu: 'svg:M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z',
  subgroup: 'svg:M7,10L12,15L17,10H7Z',
  dropdown: 'svg:M7,10L12,15L17,10H7Z',
  radioOn: 'svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z',
  radioOff: 'svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z',
  edit: 'svg:M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z',
  ratingEmpty: 'svg:M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  ratingFull: 'svg:M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z',
  ratingHalf: 'svg:M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z',
  loading: 'svg:M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12',
  first: 'svg:M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z',
  last: 'svg:M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z',
  unfold: 'svg:M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z',
  file: 'svg:M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z',
  plus: 'svg:M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z',
  minus: 'svg:M19,13H5V11H19V13Z',
  calendar: 'svg:M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z',
  treeviewCollapse: 'svg:M7,10L12,15L17,10H7Z',
  treeviewExpand: 'svg:M10,17L15,12L10,7V17Z',
  eyeDropper: 'svg:M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z'
};
const mdi = {
  component: VSvgIcon
};

// Icons
const md3 = {
  defaults: {
    VAppBar: {
      flat: true
    },
    VAutocomplete: {
      variant: 'filled'
    },
    VBanner: {
      color: 'primary'
    },
    VBottomSheet: {
      contentClass: 'rounded-t-xl overflow-hidden'
    },
    VBtn: {
      color: 'primary',
      rounded: 'xl'
    },
    VBtnGroup: {
      rounded: 'xl',
      VBtn: {
        rounded: null
      }
    },
    VCard: {
      rounded: 'lg'
    },
    VCheckbox: {
      color: 'secondary',
      inset: true
    },
    VChip: {
      rounded: 'sm'
    },
    VCombobox: {
      variant: 'filled'
    },
    VNavigationDrawer: {
      // VList: {
      //   nav: true,
      //   VListItem: {
      //     rounded: 'xl',
      //   },
      // },
    },
    VSelect: {
      variant: 'filled'
    },
    VSlider: {
      color: 'primary'
    },
    VTabs: {
      color: 'primary'
    },
    VTextarea: {
      variant: 'filled'
    },
    VTextField: {
      variant: 'filled'
    },
    VToolbar: {
      VBtn: {
        color: null
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    sets: {
      mdi: mdi$1
    }
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#6750a4',
          secondary: '#b4b0bb',
          tertiary: '#7d5260',
          error: '#b3261e',
          surface: '#fffbfe'
        }
      }
    }
  }
};

const makeVDateInputProps = propsFactory({
  hideActions: Boolean,
  ...makeFocusProps(),
  ...makeVConfirmEditProps(),
  ...makeVTextFieldProps({
    placeholder: 'mm/dd/yyyy',
    prependIcon: '$calendar'
  }),
  ...omit(makeVDatePickerProps({
    weeksInMonth: 'dynamic',
    hideHeader: true
  }), ['active'])
}, 'VDateInput');
const VDateInput = genericComponent()({
  name: 'VDateInput',
  props: makeVDateInputProps(),
  emits: {
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const adapter = useDate();
    const {
      isFocused,
      focus,
      blur
    } = useFocus(props);
    const model = useProxiedModel(props, 'modelValue', props.multiple ? [] : null);
    const menu = shallowRef(false);
    const display = computed(() => {
      const value = wrapInArray(model.value);
      if (!value.length) return null;
      if (props.multiple === true) {
        return t('$vuetify.datePicker.itemsSelected', value.length);
      }
      if (props.multiple === 'range') {
        const start = value[0];
        const end = value[value.length - 1];
        return adapter.isValid(start) && adapter.isValid(end) ? `${adapter.format(start, 'keyboardDate')} - ${adapter.format(end, 'keyboardDate')}` : '';
      }
      return adapter.isValid(model.value) ? adapter.format(model.value, 'keyboardDate') : '';
    });
    const isInteractive = computed(() => !props.disabled && !props.readonly);
    function onKeydown(e) {
      if (e.key !== 'Enter') return;
      if (!menu.value || !isFocused.value) {
        menu.value = true;
        return;
      }
      const target = e.target;
      model.value = adapter.date(target.value);
    }
    function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      menu.value = true;
    }
    function onSave() {
      menu.value = false;
    }
    useRender(() => {
      const confirmEditProps = VConfirmEdit.filterProps(props);
      const datePickerProps = VDatePicker.filterProps(omit(props, ['active']));
      const textFieldProps = VTextField.filterProps(props);
      return createVNode(VTextField, mergeProps(textFieldProps, {
        "class": props.class,
        "style": props.style,
        "modelValue": display.value,
        "onKeydown": isInteractive.value ? onKeydown : undefined,
        "focused": menu.value || isFocused.value,
        "onFocus": focus,
        "onBlur": blur,
        "onClick:control": isInteractive.value ? onClick : undefined,
        "onClick:prepend": isInteractive.value ? onClick : undefined
      }), {
        default: () => [createVNode(VMenu, {
          "modelValue": menu.value,
          "onUpdate:modelValue": $event => menu.value = $event,
          "activator": "parent",
          "min-width": "0",
          "closeOnContentClick": false,
          "openOnClick": false
        }, {
          default: () => [createVNode(VConfirmEdit, mergeProps(confirmEditProps, {
            "modelValue": model.value,
            "onUpdate:modelValue": $event => model.value = $event,
            "onSave": onSave
          }), {
            default: _ref2 => {
              let {
                actions,
                model: proxyModel
              } = _ref2;
              return createVNode(VDatePicker, mergeProps(datePickerProps, {
                "modelValue": props.hideActions ? model.value : proxyModel.value,
                "onUpdate:modelValue": val => {
                  if (!props.hideActions) {
                    proxyModel.value = val;
                  } else {
                    model.value = val;
                    if (!props.multiple) menu.value = false;
                  }
                },
                "onMousedown": e => e.preventDefault()
              }), {
                actions: !props.hideActions ? actions : undefined
              });
            }
          })]
        }), slots.default?.()]
      });
    });
  }
});

const makeVNumberInputProps = propsFactory({
  controlVariant: {
    type: String,
    default: 'default'
  },
  inset: Boolean,
  hideInput: Boolean,
  modelValue: {
    type: Number,
    default: null
  },
  min: {
    type: Number,
    default: Number.MIN_SAFE_INTEGER
  },
  max: {
    type: Number,
    default: Number.MAX_SAFE_INTEGER
  },
  step: {
    type: Number,
    default: 1
  },
  ...omit(makeVTextFieldProps({}), ['appendInnerIcon', 'modelValue', 'prependInnerIcon'])
}, 'VNumberInput');
const VNumberInput = genericComponent()({
  name: 'VNumberInput',
  props: {
    ...makeVNumberInputProps()
  },
  emits: {
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const _model = useProxiedModel(props, 'modelValue');
    const model = computed({
      get: () => _model.value,
      // model.value could be empty string from VTextField
      // but _model.value should be eventually kept in type Number | null
      set(val) {
        if (val === null || val === '') {
          _model.value = null;
          return;
        }
        const value = Number(val);
        if (!isNaN(value) && value <= props.max && value >= props.min) {
          _model.value = value;
        }
      }
    });
    const vTextFieldRef = ref();
    const stepDecimals = computed(() => getDecimals(props.step));
    const modelDecimals = computed(() => typeof model.value === 'number' ? getDecimals(model.value) : 0);
    const form = useForm(props);
    const controlsDisabled = computed(() => form.isDisabled.value || form.isReadonly.value);
    const canIncrease = computed(() => {
      if (controlsDisabled.value) return false;
      return (model.value ?? 0) + props.step <= props.max;
    });
    const canDecrease = computed(() => {
      if (controlsDisabled.value) return false;
      return (model.value ?? 0) - props.step >= props.min;
    });
    const controlVariant = computed(() => {
      return props.hideInput ? 'stacked' : props.controlVariant;
    });
    const incrementIcon = computed(() => controlVariant.value === 'split' ? '$plus' : '$collapse');
    const decrementIcon = computed(() => controlVariant.value === 'split' ? '$minus' : '$expand');
    const controlNodeSize = computed(() => controlVariant.value === 'split' ? 'default' : 'small');
    const controlNodeDefaultHeight = computed(() => controlVariant.value === 'stacked' ? 'auto' : '100%');
    const incrementSlotProps = computed(() => ({
      click: onClickUp
    }));
    const decrementSlotProps = computed(() => ({
      click: onClickDown
    }));
    onMounted(() => {
      if (!controlsDisabled.value) {
        clampModel();
      }
    });
    function toggleUpDown() {
      let increment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (controlsDisabled.value) return;
      if (model.value == null) {
        model.value = clamp(0, props.min, props.max);
        return;
      }
      const decimals = Math.max(modelDecimals.value, stepDecimals.value);
      if (increment) {
        if (canIncrease.value) model.value = +(model.value + props.step).toFixed(decimals);
      } else {
        if (canDecrease.value) model.value = +(model.value - props.step).toFixed(decimals);
      }
    }
    function onClickUp(e) {
      e.stopPropagation();
      toggleUpDown();
    }
    function onClickDown(e) {
      e.stopPropagation();
      toggleUpDown(false);
    }
    function onBeforeinput(e) {
      if (!e.data) return;
      const existingTxt = e.target?.value;
      const selectionStart = e.target?.selectionStart;
      const selectionEnd = e.target?.selectionEnd;
      const potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
      // Only numbers, "-", "." are allowed
      // AND "-", "." are allowed only once
      // AND "-" is only allowed at the start
      if (!/^-?(\d+(\.\d*)?|(\.\d+)|\d*|\.)$/.test(potentialNewInputVal)) {
        e.preventDefault();
      }
    }
    async function onKeydown(e) {
      if (['Enter', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'].includes(e.key) || e.ctrlKey) return;
      if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
        e.preventDefault();
        clampModel();
        // _model is controlled, so need to wait until props['modelValue'] is updated
        await nextTick();
        if (e.key === 'ArrowDown') {
          toggleUpDown(false);
        } else {
          toggleUpDown();
        }
      }
    }
    function onControlMousedown(e) {
      e.stopPropagation();
    }
    function clampModel() {
      if (!vTextFieldRef.value) return;
      const inputText = vTextFieldRef.value.value;
      if (inputText && !isNaN(+inputText)) {
        model.value = clamp(+inputText, props.min, props.max);
      } else {
        model.value = null;
      }
    }
    useRender(() => {
      const {
        modelValue: _,
        ...textFieldProps
      } = VTextField.filterProps(props);
      function incrementControlNode() {
        return !slots.increment ? createVNode(VBtn, {
          "disabled": !canIncrease.value,
          "flat": true,
          "key": "increment-btn",
          "height": controlNodeDefaultHeight.value,
          "data-testid": "increment",
          "aria-hidden": "true",
          "icon": incrementIcon.value,
          "onClick": onClickUp,
          "onMousedown": onControlMousedown,
          "size": controlNodeSize.value,
          "tabindex": "-1"
        }, null) : createVNode(VDefaultsProvider, {
          "key": "increment-defaults",
          "defaults": {
            VBtn: {
              disabled: !canIncrease.value,
              flat: true,
              height: controlNodeDefaultHeight.value,
              size: controlNodeSize.value,
              icon: incrementIcon.value
            }
          }
        }, {
          default: () => [slots.increment(incrementSlotProps.value)]
        });
      }
      function decrementControlNode() {
        return !slots.decrement ? createVNode(VBtn, {
          "disabled": !canDecrease.value,
          "flat": true,
          "key": "decrement-btn",
          "height": controlNodeDefaultHeight.value,
          "data-testid": "decrement",
          "aria-hidden": "true",
          "icon": decrementIcon.value,
          "size": controlNodeSize.value,
          "tabindex": "-1",
          "onClick": onClickDown,
          "onMousedown": onControlMousedown
        }, null) : createVNode(VDefaultsProvider, {
          "key": "decrement-defaults",
          "defaults": {
            VBtn: {
              disabled: !canDecrease.value,
              flat: true,
              height: controlNodeDefaultHeight.value,
              size: controlNodeSize.value,
              icon: decrementIcon.value
            }
          }
        }, {
          default: () => [slots.decrement(decrementSlotProps.value)]
        });
      }
      function controlNode() {
        return createVNode("div", {
          "class": "v-number-input__control"
        }, [decrementControlNode(), createVNode(VDivider, {
          "vertical": controlVariant.value !== 'stacked'
        }, null), incrementControlNode()]);
      }
      function dividerNode() {
        return !props.hideInput && !props.inset ? createVNode(VDivider, {
          "vertical": true
        }, null) : undefined;
      }
      const appendInnerControl = controlVariant.value === 'split' ? createVNode("div", {
        "class": "v-number-input__control"
      }, [createVNode(VDivider, {
        "vertical": true
      }, null), incrementControlNode()]) : props.reverse ? undefined : createVNode(Fragment, null, [dividerNode(), controlNode()]);
      const hasAppendInner = slots['append-inner'] || appendInnerControl;
      const prependInnerControl = controlVariant.value === 'split' ? createVNode("div", {
        "class": "v-number-input__control"
      }, [decrementControlNode(), createVNode(VDivider, {
        "vertical": true
      }, null)]) : props.reverse ? createVNode(Fragment, null, [controlNode(), dividerNode()]) : undefined;
      const hasPrependInner = slots['prepend-inner'] || prependInnerControl;
      return createVNode(VTextField, mergeProps({
        "ref": vTextFieldRef,
        "modelValue": model.value,
        "onUpdate:modelValue": $event => model.value = $event,
        "onBeforeinput": onBeforeinput,
        "onChange": clampModel,
        "onKeydown": onKeydown,
        "class": ['v-number-input', {
          'v-number-input--default': controlVariant.value === 'default',
          'v-number-input--hide-input': props.hideInput,
          'v-number-input--inset': props.inset,
          'v-number-input--reverse': props.reverse,
          'v-number-input--split': controlVariant.value === 'split',
          'v-number-input--stacked': controlVariant.value === 'stacked'
        }, props.class]
      }, textFieldProps, {
        "style": props.style,
        "inputmode": "decimal"
      }), {
        ...slots,
        'append-inner': hasAppendInner ? function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          return createVNode(Fragment, null, [slots['append-inner']?.(...args), appendInnerControl]);
        } : undefined,
        'prepend-inner': hasPrependInner ? function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return createVNode(Fragment, null, [prependInnerControl, slots['prepend-inner']?.(...args)]);
        } : undefined
      });
    });
    return forwardRefs({}, vTextFieldRef);
  }
});

const makeVSnackbarQueueProps = propsFactory({
  // TODO: Port this to Snackbar on dev
  closable: [Boolean, String],
  closeText: {
    type: String,
    default: '$vuetify.dismiss'
  },
  modelValue: {
    type: Array,
    default: () => []
  },
  ...omit(makeVSnackbarProps(), ['modelValue'])
}, 'VSnackbarQueue');
const VSnackbarQueue = genericComponent()({
  name: 'VSnackbarQueue',
  props: makeVSnackbarQueueProps(),
  emits: {
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const isActive = shallowRef(false);
    const isVisible = shallowRef(false);
    const current = shallowRef();
    watch(() => props.modelValue.length, (val, oldVal) => {
      if (!isVisible.value && val > oldVal) {
        showNext();
      }
    });
    watch(isActive, val => {
      if (val) isVisible.value = true;
    });
    function onAfterLeave() {
      if (props.modelValue.length) {
        showNext();
      } else {
        current.value = undefined;
        isVisible.value = false;
      }
    }
    function showNext() {
      const [next, ...rest] = props.modelValue;
      emit('update:modelValue', rest);
      current.value = typeof next === 'string' ? {
        text: next
      } : next;
      nextTick(() => {
        isActive.value = true;
      });
    }
    function onClickClose() {
      isActive.value = false;
    }
    const btnProps = computed(() => ({
      color: typeof props.closable === 'string' ? props.closable : undefined,
      text: t(props.closeText)
    }));
    useRender(() => {
      const hasActions = !!(props.closable || slots.actions);
      const {
        modelValue: _,
        ...snackbarProps
      } = VSnackbar.filterProps(props);
      return createVNode(Fragment, null, [isVisible.value && !!current.value && (slots.default ? createVNode(VDefaultsProvider, {
        "defaults": {
          VSnackbar: current.value
        }
      }, {
        default: () => [slots.default({
          item: current.value
        })]
      }) : createVNode(VSnackbar, mergeProps(snackbarProps, current.value, {
        "modelValue": isActive.value,
        "onUpdate:modelValue": $event => isActive.value = $event,
        "onAfterLeave": onAfterLeave
      }), {
        text: slots.text ? () => slots.text?.({
          item: current.value
        }) : undefined,
        actions: hasActions ? () => createVNode(Fragment, null, [!slots.actions ? createVNode(VBtn, mergeProps(btnProps.value, {
          "onClick": onClickClose
        }), null) : createVNode(VDefaultsProvider, {
          "defaults": {
            VBtn: btnProps.value
          }
        }, {
          default: () => [slots.actions({
            item: current.value,
            props: {
              onClick: onClickClose
            }
          })]
        })]) : undefined
      }))]);
    });
  }
});

function pad(n) {
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return String(n).padStart(length, '0');
}

const makeVTimePickerClockProps = propsFactory({
  allowedValues: Function,
  ampm: Boolean,
  color: String,
  disabled: Boolean,
  displayedValue: null,
  double: Boolean,
  format: {
    type: Function,
    default: val => val
  },
  max: {
    type: Number,
    required: true
  },
  min: {
    type: Number,
    required: true
  },
  scrollable: Boolean,
  readonly: Boolean,
  rotate: {
    type: Number,
    default: 0
  },
  step: {
    type: Number,
    default: 1
  },
  modelValue: {
    type: Number
  }
}, 'VTimePickerClock');
const VTimePickerClock = genericComponent()({
  name: 'VTimePickerClock',
  props: makeVTimePickerClockProps(),
  emits: {
    change: val => true,
    input: val => true
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const clockRef = ref(null);
    const innerClockRef = ref(null);
    const inputValue = ref(undefined);
    const isDragging = ref(false);
    const valueOnMouseDown = ref(null);
    const valueOnMouseUp = ref(null);
    const {
      textColorClasses,
      textColorStyles
    } = useTextColor(toRef(props, 'color'));
    const {
      backgroundColorClasses,
      backgroundColorStyles
    } = useBackgroundColor(toRef(props, 'color'));
    const count = computed(() => props.max - props.min + 1);
    const roundCount = computed(() => props.double ? count.value / 2 : count.value);
    const degreesPerUnit = computed(() => 360 / roundCount.value);
    const degrees = computed(() => degreesPerUnit.value * Math.PI / 180);
    const displayedValue = computed(() => props.modelValue == null ? props.min : props.modelValue);
    const innerRadiusScale = computed(() => 0.62);
    const genChildren = computed(() => {
      const children = [];
      for (let value = props.min; value <= props.max; value = value + props.step) {
        children.push(value);
      }
      return children;
    });
    watch(() => props.modelValue, val => {
      inputValue.value = val;
    });
    function update(value) {
      if (inputValue.value !== value) {
        inputValue.value = value;
      }
      emit('input', value);
    }
    function isAllowed(value) {
      return !props.allowedValues || props.allowedValues(value);
    }
    function wheel(e) {
      if (!props.scrollable || props.disabled) return;
      e.preventDefault();
      const delta = Math.sign(-e.deltaY || 1);
      let value = displayedValue.value;
      do {
        value = value + delta;
        value = (value - props.min + count.value) % count.value + props.min;
      } while (!isAllowed(value) && value !== displayedValue.value);
      if (value !== props.displayedValue) {
        update(value);
      }
    }
    function isInner(value) {
      return props.double && value - props.min >= roundCount.value;
    }
    function handScale(value) {
      return isInner(value) ? innerRadiusScale.value : 1;
    }
    function getPosition(value) {
      const rotateRadians = props.rotate * Math.PI / 180;
      return {
        x: Math.sin((value - props.min) * degrees.value + rotateRadians) * handScale(value),
        y: -Math.cos((value - props.min) * degrees.value + rotateRadians) * handScale(value)
      };
    }
    function angleToValue(angle, insideClick) {
      const value = (Math.round(angle / degreesPerUnit.value) + (insideClick ? roundCount.value : 0)) % count.value + props.min;

      // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
      if (angle < 360 - degreesPerUnit.value / 2) return value;
      return insideClick ? props.max - roundCount.value + 1 : props.min;
    }
    function getTransform(i) {
      const {
        x,
        y
      } = getPosition(i);
      return {
        left: `${50 + x * 50}%`,
        top: `${50 + y * 50}%`
      };
    }
    function euclidean(p0, p1) {
      const dx = p1.x - p0.x;
      const dy = p1.y - p0.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function angle(center, p1) {
      const value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    }
    function setMouseDownValue(value) {
      if (valueOnMouseDown.value === null) {
        valueOnMouseDown.value = value;
      }
      valueOnMouseUp.value = value;
      update(value);
    }
    function onDragMove(e) {
      e.preventDefault();
      if (!isDragging.value && e.type !== 'click' || !clockRef.value) return;
      const {
        width,
        top,
        left
      } = clockRef.value?.getBoundingClientRect();
      const {
        width: innerWidth
      } = innerClockRef.value?.getBoundingClientRect() ?? {
        width: 0
      };
      const {
        clientX,
        clientY
      } = 'touches' in e ? e.touches[0] : e;
      const center = {
        x: width / 2,
        y: -width / 2
      };
      const coords = {
        x: clientX - left,
        y: top - clientY
      };
      const handAngle = Math.round(angle(center, coords) - props.rotate + 360) % 360;
      const insideClick = props.double && euclidean(center, coords) < (innerWidth + innerWidth * innerRadiusScale.value) / 4;
      const checksCount = Math.ceil(15 / degreesPerUnit.value);
      let value;
      for (let i = 0; i < checksCount; i++) {
        value = angleToValue(handAngle + i * degreesPerUnit.value, insideClick);
        if (isAllowed(value)) return setMouseDownValue(value);
        value = angleToValue(handAngle - i * degreesPerUnit.value, insideClick);
        if (isAllowed(value)) return setMouseDownValue(value);
      }
    }
    function onMouseDown(e) {
      if (props.disabled) return;
      e.preventDefault();
      window.addEventListener('mousemove', onDragMove);
      window.addEventListener('touchmove', onDragMove);
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('touchend', onMouseUp);
      valueOnMouseDown.value = null;
      valueOnMouseUp.value = null;
      isDragging.value = true;
      onDragMove(e);
    }
    function onMouseUp(e) {
      e.stopPropagation();
      window.removeEventListener('mousemove', onDragMove);
      window.removeEventListener('touchmove', onDragMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('touchend', onMouseUp);
      isDragging.value = false;
      if (valueOnMouseUp.value !== null && isAllowed(valueOnMouseUp.value)) {
        emit('change', valueOnMouseUp.value);
      }
    }
    useRender(() => {
      return createVNode("div", {
        "class": [{
          'v-time-picker-clock': true,
          'v-time-picker-clock--indeterminate': props.modelValue == null,
          'v-time-picker-clock--readonly': props.readonly
        }],
        "onMousedown": onMouseDown,
        "onTouchstart": onMouseDown,
        "onWheel": wheel,
        "ref": clockRef
      }, [createVNode("div", {
        "class": "v-time-picker-clock__inner",
        "ref": innerClockRef
      }, [createVNode("div", {
        "class": [{
          'v-time-picker-clock__hand': true,
          'v-time-picker-clock__hand--inner': isInner(props.modelValue)
        }, textColorClasses.value],
        "style": [{
          transform: `rotate(${props.rotate + degreesPerUnit.value * (displayedValue.value - props.min)}deg) scaleY(${handScale(displayedValue.value)})`
        }, textColorStyles.value]
      }, null), genChildren.value.map(value => {
        const isActive = value === displayedValue.value;
        return createVNode("div", {
          "class": [{
            'v-time-picker-clock__item': true,
            'v-time-picker-clock__item--active': isActive,
            'v-time-picker-clock__item--disabled': props.disabled || !isAllowed(value)
          }, isActive && backgroundColorClasses.value],
          "style": [getTransform(value), isActive && backgroundColorStyles.value]
        }, [createVNode("span", null, [props.format(value)])]);
      })])]);
    });
  }
});

// @ts-nocheck
/* eslint-disable */
var SelectingTimes = /*#__PURE__*/function (SelectingTimes) {
  SelectingTimes[SelectingTimes["Hour"] = 1] = "Hour";
  SelectingTimes[SelectingTimes["Minute"] = 2] = "Minute";
  SelectingTimes[SelectingTimes["Second"] = 3] = "Second";
  return SelectingTimes;
}(SelectingTimes || {});

const makeVTimePickerControlsProps = propsFactory({
  ampm: Boolean,
  ampmInTitle: Boolean,
  ampmReadonly: Boolean,
  color: String,
  disabled: Boolean,
  hour: Number,
  minute: Number,
  second: Number,
  period: String,
  readonly: Boolean,
  useSeconds: Boolean,
  selecting: Number,
  value: Number
}, 'VTimePickerControls');
const VTimePickerControls = genericComponent()({
  name: 'VTimePickerControls',
  props: makeVTimePickerControlsProps(),
  emits: {
    'update:period': data => true,
    'update:selecting': data => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    useRender(() => {
      let hour = props.hour;
      if (props.ampm) {
        hour = hour ? (hour - 1) % 12 + 1 : 12;
      }
      return createVNode("div", {
        "class": "v-time-picker-controls"
      }, [createVNode("div", {
        "class": {
          'v-time-picker-controls__time': true,
          'v-time-picker-controls__time--with-seconds': props.useSeconds
        }
      }, [createVNode(VBtn, {
        "active": props.selecting === 1,
        "color": props.selecting === 1 ? props.color : undefined,
        "disabled": props.disabled,
        "variant": "tonal",
        "class": {
          'v-time-picker-controls__time__btn': true,
          'v-time-picker-controls__time--with-ampm__btn': props.ampm,
          'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
        },
        "text": props.hour == null ? '--' : pad(`${hour}`),
        "onClick": () => emit('update:selecting', SelectingTimes.Hour)
      }, null), createVNode("span", {
        "class": ['v-time-picker-controls__time__separator', {
          'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
        }]
      }, [createTextVNode(":")]), createVNode(VBtn, {
        "active": props.selecting === 2,
        "color": props.selecting === 2 ? props.color : undefined,
        "class": {
          'v-time-picker-controls__time__btn': true,
          'v-time-picker-controls__time__btn__active': props.selecting === 2,
          'v-time-picker-controls__time--with-ampm__btn': props.ampm,
          'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
        },
        "disabled": props.disabled,
        "variant": "tonal",
        "text": props.minute == null ? '--' : pad(props.minute),
        "onClick": () => emit('update:selecting', SelectingTimes.Minute)
      }, null), props.useSeconds && createVNode("span", {
        "class": ['v-time-picker-controls__time__separator', {
          'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
        }],
        "key": "secondsDivider"
      }, [createTextVNode(":")]), props.useSeconds && createVNode(VBtn, {
        "key": "secondsVal",
        "variant": "tonal",
        "onClick": () => emit('update:selecting', SelectingTimes.Second),
        "class": {
          'v-time-picker-controls__time__btn': true,
          'v-time-picker-controls__time__btn__active': props.selecting === 3,
          'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
        },
        "disabled": props.disabled,
        "text": props.second == null ? '--' : pad(props.second)
      }, null), props.ampm && props.ampmInTitle && createVNode("div", {
        "class": ['v-time-picker-controls__ampm', {
          'v-time-picker-controls__ampm--readonly': props.ampmReadonly
        }]
      }, [createVNode(VBtn, {
        "active": props.period === 'am',
        "color": props.period === 'am' ? props.color : undefined,
        "class": {
          'v-time-picker-controls__ampm__am': true,
          'v-time-picker-controls__ampm__btn': true,
          'v-time-picker-controls__ampm__btn__active': props.period === 'am'
        },
        "disabled": props.disabled,
        "text": t('$vuetify.timePicker.am'),
        "variant": props.disabled && props.period === 'am' ? 'elevated' : 'tonal',
        "onClick": () => props.period !== 'am' ? emit('update:period', 'am') : null
      }, null), createVNode(VBtn, {
        "active": props.period === 'pm',
        "color": props.period === 'pm' ? props.color : undefined,
        "class": {
          'v-time-picker-controls__ampm__pm': true,
          'v-time-picker-controls__ampm__btn': true,
          'v-time-picker-controls__ampm__btn__active': props.period === 'pm'
        },
        "disabled": props.disabled,
        "text": t('$vuetify.timePicker.pm'),
        "variant": props.disabled && props.period === 'pm' ? 'elevated' : 'tonal',
        "onClick": () => props.period !== 'pm' ? emit('update:period', 'pm') : null
      }, null)])])]);
    });
    return {};
  }
});

const rangeHours24 = createRange(24);
const rangeHours12am = createRange(12);
const rangeHours12pm = rangeHours12am.map(v => v + 12);
createRange(60);
const selectingNames = {
  1: 'hour',
  2: 'minute',
  3: 'second'
};
const makeVTimePickerProps = propsFactory({
  allowedHours: [Function, Array],
  allowedMinutes: [Function, Array],
  allowedSeconds: [Function, Array],
  ampmInTitle: Boolean,
  disabled: Boolean,
  format: {
    type: String,
    default: 'ampm'
  },
  max: String,
  min: String,
  modelValue: null,
  readonly: Boolean,
  scrollable: Boolean,
  useSeconds: Boolean,
  ...omit(makeVPickerProps({
    title: '$vuetify.timePicker.title'
  }), ['landscape'])
}, 'VTimePicker');
const VTimePicker = genericComponent()({
  name: 'VTimePicker',
  props: makeVTimePickerProps(),
  emits: {
    'update:hour': val => true,
    'update:minute': val => true,
    'update:period': val => true,
    'update:second': val => true,
    'update:modelValue': val => true
  },
  setup(props, _ref) {
    let {
      emit,
      slots
    } = _ref;
    const {
      t
    } = useLocale();
    const inputHour = ref(null);
    const inputMinute = ref(null);
    const inputSecond = ref(null);
    const lazyInputHour = ref(null);
    const lazyInputMinute = ref(null);
    const lazyInputSecond = ref(null);
    const period = ref('am');
    const selecting = ref(SelectingTimes.Hour);
    const controlsRef = ref(null);
    const clockRef = ref(null);
    const isAllowedHourCb = computed(() => {
      let cb;
      if (props.allowedHours instanceof Array) {
        cb = val => props.allowedHours.includes(val);
      } else {
        cb = props.allowedHours;
      }
      if (!props.min && !props.max) return cb;
      const minHour = props.min ? Number(props.min.split(':')[0]) : 0;
      const maxHour = props.max ? Number(props.max.split(':')[0]) : 23;
      return val => {
        return val >= minHour * 1 && val <= maxHour * 1 && (!cb || cb(val));
      };
    });
    const isAllowedMinuteCb = computed(() => {
      let cb;
      const isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
      if (props.allowedMinutes instanceof Array) {
        cb = val => props.allowedMinutes.includes(val);
      } else {
        cb = props.allowedMinutes;
      }
      if (!props.min && !props.max) {
        return isHourAllowed ? cb : () => false;
      }
      const [minHour, minMinute] = props.min ? props.min.split(':').map(Number) : [0, 0];
      const [maxHour, maxMinute] = props.max ? props.max.split(':').map(Number) : [23, 59];
      const minTime = minHour * 60 + minMinute * 1;
      const maxTime = maxHour * 60 + maxMinute * 1;
      return val => {
        const time = 60 * inputHour.value + val;
        return time >= minTime && time <= maxTime && isHourAllowed && (!cb || cb(val));
      };
    });
    const isAllowedSecondCb = computed(() => {
      let cb;
      const isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
      const isMinuteAllowed = isHourAllowed && (!isAllowedMinuteCb.value || inputMinute.value === null || isAllowedMinuteCb.value(inputMinute.value));
      if (props.allowedSeconds instanceof Array) {
        cb = val => props.allowedSeconds.includes(val);
      } else {
        cb = props.allowedSeconds;
      }
      if (!props.min && !props.max) {
        return isMinuteAllowed ? cb : () => false;
      }
      const [minHour, minMinute, minSecond] = props.min ? props.min.split(':').map(Number) : [0, 0, 0];
      const [maxHour, maxMinute, maxSecond] = props.max ? props.max.split(':').map(Number) : [23, 59, 59];
      const minTime = minHour * 3600 + minMinute * 60 + (minSecond || 0) * 1;
      const maxTime = maxHour * 3600 + maxMinute * 60 + (maxSecond || 0) * 1;
      return val => {
        const time = 3600 * inputHour.value + 60 * inputMinute.value + val;
        return time >= minTime && time <= maxTime && isMinuteAllowed && (!cb || cb(val));
      };
    });
    const isAmPm = computed(() => {
      return props.format === 'ampm';
    });
    watch(() => props.modelValue, val => setInputData(val));
    onMounted(() => {
      setInputData(props.modelValue);
    });
    function genValue() {
      if (inputHour.value != null && inputMinute.value != null && (!props.useSeconds || inputSecond.value != null)) {
        return `${pad(inputHour.value)}:${pad(inputMinute.value)}` + (props.useSeconds ? `:${pad(inputSecond.value)}` : '');
      }
      return null;
    }
    function emitValue() {
      const value = genValue();
      if (value !== null) emit('update:modelValue', value);
    }
    function convert24to12(hour) {
      return hour ? (hour - 1) % 12 + 1 : 12;
    }
    function convert12to24(hour, period) {
      return hour % 12 + (period === 'pm' ? 12 : 0);
    }
    function setInputData(value) {
      if (value == null || value === '') {
        inputHour.value = null;
        inputMinute.value = null;
        inputSecond.value = null;
      } else if (value instanceof Date) {
        inputHour.value = value.getHours();
        inputMinute.value = value.getMinutes();
        inputSecond.value = value.getSeconds();
      } else {
        const [hour,, minute,, second, period] = value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6);
        inputHour.value = period ? convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
        inputMinute.value = parseInt(minute, 10);
        inputSecond.value = parseInt(second || 0, 10);
      }
      period.value = inputHour.value == null || inputHour.value < 12 ? 'am' : 'pm';
    }
    function firstAllowed(type, value) {
      const allowedFn = isAllowedHourCb.value ;
      if (!allowedFn) return value;

      // TODO: clean up (Note from V2 code)
      const range = isAmPm.value ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
      const first = range.find(v => allowedFn((v + value) % range.length + range[0]));
      return ((first || 0) + value) % range.length + range[0];
    }
    function setPeriod(val) {
      period.value = val;
      if (inputHour.value != null) {
        const newHour = inputHour.value + (period.value === 'am' ? -12 : 12);
        inputHour.value = firstAllowed('hour', newHour);
      }
      emit('update:period', val);
      emitValue();
      return true;
    }
    function onInput(value) {
      if (selecting.value === SelectingTimes.Hour) {
        inputHour.value = isAmPm.value ? convert12to24(value, period.value) : value;
      } else if (selecting.value === SelectingTimes.Minute) {
        inputMinute.value = value;
      } else {
        inputSecond.value = value;
      }
    }
    function onChange(value) {
      switch (selectingNames[selecting.value]) {
        case 'hour':
          emit('update:hour', value);
          break;
        case 'minute':
          emit('update:minute', value);
          break;
        case 'second':
          emit('update:second', value);
          break;
      }
      const emitChange = selecting.value === (props.useSeconds ? SelectingTimes.Second : SelectingTimes.Minute);
      if (selecting.value === SelectingTimes.Hour) {
        selecting.value = SelectingTimes.Minute;
      } else if (props.useSeconds && selecting.value === SelectingTimes.Minute) {
        selecting.value = SelectingTimes.Second;
      }
      if (inputHour.value === lazyInputHour.value && inputMinute.value === lazyInputMinute.value && (!props.useSeconds || inputSecond.value === lazyInputSecond.value)) return;
      const time = genValue();
      if (time === null) return;
      lazyInputHour.value = inputHour.value;
      lazyInputMinute.value = inputMinute.value;
      props.useSeconds && (lazyInputSecond.value = inputSecond.value);
      emitChange && emitValue();
    }
    useRender(() => {
      const pickerProps = VPicker.filterProps(props);
      const timePickerControlsProps = VTimePickerControls.filterProps(props);
      const timePickerClockProps = VTimePickerClock.filterProps(omit(props, ['format', 'modelValue', 'min', 'max']));
      return createVNode(VPicker, mergeProps(pickerProps, {
        "color": undefined,
        "class": ['v-time-picker', props.class],
        "style": props.style
      }), {
        title: () => slots.title?.() ?? createVNode("div", {
          "class": "v-time-picker__title"
        }, [t(props.title)]),
        header: () => createVNode(VTimePickerControls, mergeProps(timePickerControlsProps, {
          "ampm": isAmPm.value || props.ampmInTitle,
          "ampmReadonly": isAmPm.value && !props.ampmInTitle,
          "hour": inputHour.value,
          "minute": inputMinute.value,
          "period": period.value,
          "second": inputSecond.value,
          "selecting": selecting.value,
          "onUpdate:period": val => setPeriod(val),
          "onUpdate:selecting": value => selecting.value = value,
          "ref": controlsRef
        }), null),
        default: () => createVNode(VTimePickerClock, mergeProps(timePickerClockProps, {
          "allowedValues": selecting.value === SelectingTimes.Hour ? isAllowedHourCb.value : selecting.value === SelectingTimes.Minute ? isAllowedMinuteCb.value : isAllowedSecondCb.value,
          "double": selecting.value === SelectingTimes.Hour && !isAmPm.value,
          "format": selecting.value === SelectingTimes.Hour ? isAmPm.value ? convert24to12 : val => val : val => pad(val, 2),
          "max": selecting.value === SelectingTimes.Hour ? isAmPm.value && period.value === 'am' ? 11 : 23 : 59,
          "min": selecting.value === SelectingTimes.Hour && isAmPm.value && period.value === 'pm' ? 12 : 0,
          "size": 20,
          "step": selecting.value === SelectingTimes.Hour ? 1 : 5,
          "modelValue": selecting.value === SelectingTimes.Hour ? inputHour.value : selecting.value === SelectingTimes.Minute ? inputMinute.value : inputSecond.value,
          "onChange": onChange,
          "onInput": onInput,
          "ref": clockRef
        }), null),
        actions: slots.actions
      });
    });
  }
});

const makeVTreeviewGroupProps = propsFactory({
  ...omit(makeVListGroupProps({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand'
  }), ['subgroup'])
}, 'VTreeviewGroup');
const VTreeviewGroup = genericComponent()({
  name: 'VTreeviewGroup',
  props: makeVTreeviewGroupProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const vListGroupRef = ref();
    const toggleIcon = computed(() => vListGroupRef.value?.isOpen ? props.collapseIcon : props.expandIcon);
    const activatorDefaults = computed(() => ({
      VTreeviewItem: {
        prependIcon: undefined,
        appendIcon: undefined,
        active: vListGroupRef.value?.isOpen,
        toggleIcon: toggleIcon.value
      }
    }));
    useRender(() => {
      const listGroupProps = VListGroup.filterProps(props);
      return createVNode(VListGroup, mergeProps(listGroupProps, {
        "ref": vListGroupRef,
        "class": ['v-treeview-group', props.class],
        "subgroup": true
      }), {
        ...slots,
        activator: slots.activator ? slotProps => createVNode(Fragment, null, [createVNode(VDefaultsProvider, {
          "defaults": activatorDefaults.value
        }, {
          default: () => [slots.activator?.(slotProps)]
        })]) : undefined
      });
    });
    return {};
  }
});

// Types

const VTreeviewSymbol = Symbol.for('vuetify:v-treeview');

const makeVTreeviewItemProps = propsFactory({
  loading: Boolean,
  onToggleExpand: EventProp(),
  toggleIcon: IconValue,
  ...makeVListItemProps({
    slim: true
  })
}, 'VTreeviewItem');
const VTreeviewItem = genericComponent()({
  name: 'VTreeviewItem',
  props: makeVTreeviewItemProps(),
  setup(props, _ref) {
    let {
      attrs,
      slots,
      emit
    } = _ref;
    const link = useLink(props, attrs);
    const vListItemRef = ref();
    const isActivatableGroupActivator = computed(() => vListItemRef.value?.root.activatable.value && vListItemRef.value?.isGroupActivator);
    const isClickable = computed(() => !props.disabled && props.link !== false && (props.link || link.isClickable.value || props.value != null && !!vListItemRef.value?.list || isActivatableGroupActivator.value));
    function activateGroupActivator(e) {
      if (isClickable.value && isActivatableGroupActivator.value) {
        vListItemRef.value?.activate(!vListItemRef.value?.isActivated, e);
      }
    }
    const visibleIds = inject$2(VTreeviewSymbol, {
      visibleIds: ref()
    }).visibleIds;
    useRender(() => {
      const listItemProps = omit(VListItem.filterProps(props), ['onClick']);
      const hasPrepend = slots.prepend || props.toggleIcon;
      return createVNode(VListItem, mergeProps({
        "ref": vListItemRef
      }, listItemProps, {
        "active": vListItemRef.value?.isActivated,
        "class": ['v-treeview-item', {
          'v-treeview-item--activatable-group-activator': isActivatableGroupActivator.value,
          'v-treeview-item--filtered': visibleIds.value && !visibleIds.value.has(vListItemRef.value?.id)
        }, props.class],
        "ripple": false,
        "onClick": props.onClick ?? activateGroupActivator
      }), {
        ...slots,
        prepend: hasPrepend ? slotProps => {
          return createVNode(Fragment, null, [props.toggleIcon && createVNode(VListItemAction, {
            "start": false
          }, {
            default: () => [createVNode(VBtn, {
              "density": "compact",
              "icon": props.toggleIcon,
              "loading": props.loading,
              "variant": "text",
              "onClick": props.onToggleExpand
            }, {
              loader() {
                return createVNode(VProgressCircular, {
                  "indeterminate": "disable-shrink",
                  "size": "20",
                  "width": "2"
                }, null);
              }
            })]
          }), slots.prepend?.(slotProps)]);
        } : undefined
      });
    });
    return {};
  }
});

const makeVTreeviewChildrenProps = propsFactory({
  loadChildren: Function,
  loadingIcon: {
    type: String,
    default: '$loading'
  },
  items: Array,
  openOnClick: {
    type: Boolean,
    default: undefined
  },
  indeterminateIcon: {
    type: IconValue,
    default: '$checkboxIndeterminate'
  },
  falseIcon: IconValue,
  trueIcon: IconValue,
  returnObject: Boolean,
  selectable: Boolean,
  selectedColor: String,
  selectStrategy: [String, Function, Object]
}, 'VTreeviewChildren');
const VTreeviewChildren = genericComponent()({
  name: 'VTreeviewChildren',
  props: makeVTreeviewChildrenProps(),
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const isLoading = reactive(new Set());
    const isClickOnOpen = computed(() => props.openOnClick != null ? props.openOnClick : props.selectable);
    async function checkChildren(item) {
      try {
        if (!props.items?.length || !props.loadChildren) return;
        if (item?.children?.length === 0) {
          isLoading.add(item.value);
          await props.loadChildren(item.raw);
        }
      } finally {
        isLoading.delete(item.value);
      }
    }
    function selectItem(select, isSelected) {
      if (props.selectable) {
        select(!isSelected);
      }
    }
    return () => slots.default?.() ?? props.items?.map(item => {
      const {
        children,
        props: itemProps
      } = item;
      const loading = isLoading.has(item.value);
      const slotsWithItem = {
        prepend: slotProps => createVNode(Fragment, null, [props.selectable && (!children || children && !['leaf', 'single-leaf'].includes(props.selectStrategy)) && createVNode("div", null, [createVNode(VCheckboxBtn, {
          "key": item.value,
          "modelValue": slotProps.isSelected,
          "loading": loading,
          "color": props.selectedColor,
          "indeterminate": slotProps.isIndeterminate,
          "indeterminateIcon": props.indeterminateIcon,
          "falseIcon": props.falseIcon,
          "trueIcon": props.trueIcon,
          "onClick": withModifiers(() => selectItem(slotProps.select, slotProps.isSelected), ['stop']),
          "onKeydown": e => {
            if (!['Enter', 'Space'].includes(e.key)) return;
            e.stopPropagation();
            selectItem(slotProps.select, slotProps.isSelected);
          }
        }, null)]), slots.prepend?.({
          ...slotProps,
          item: item.raw,
          internalItem: item
        })]),
        append: slots.append ? slotProps => slots.append?.({
          ...slotProps,
          item: item.raw,
          internalItem: item
        }) : undefined,
        title: slots.title ? slotProps => slots.title?.({
          ...slotProps,
          item: item.raw,
          internalItem: item
        }) : undefined
      };
      const treeviewGroupProps = VTreeviewGroup.filterProps(itemProps);
      const treeviewChildrenProps = VTreeviewChildren.filterProps(props);
      return children ? createVNode(VTreeviewGroup, mergeProps(treeviewGroupProps, {
        "value": props.returnObject ? item.raw : treeviewGroupProps?.value
      }), {
        activator: _ref2 => {
          let {
            props: activatorProps
          } = _ref2;
          const listItemProps = {
            ...itemProps,
            ...activatorProps,
            value: itemProps?.value,
            onToggleExpand: [() => checkChildren(item), activatorProps.onClick],
            onClick: isClickOnOpen.value ? [() => checkChildren(item), activatorProps.onClick] : undefined
          };
          return createVNode(VTreeviewItem, mergeProps(listItemProps, {
            "value": props.returnObject ? toRaw(item.raw) : itemProps.value,
            "loading": loading
          }), slotsWithItem);
        },
        default: () => createVNode(VTreeviewChildren, mergeProps(treeviewChildrenProps, {
          "items": children,
          "returnObject": props.returnObject
        }), slots)
      }) : slots.item?.({
        props: itemProps,
        item: item.raw,
        internalItem: item
      }) ?? createVNode(VTreeviewItem, mergeProps(itemProps, {
        "value": props.returnObject ? toRaw(item.raw) : itemProps.value
      }), slotsWithItem);
    });
  }
});

function flatten(items) {
  let flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  for (const item of items) {
    flat.push(item);
    if (item.children) flatten(item.children, flat);
  }
  return flat;
}
const makeVTreeviewProps = propsFactory({
  openAll: Boolean,
  search: String,
  ...makeFilterProps({
    filterKeys: ['title']
  }),
  ...makeVTreeviewChildrenProps(),
  ...omit(makeVListProps({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand',
    slim: true
  }), ['itemType', 'nav', 'openStrategy']),
  modelValue: {
    type: Array,
    default: () => []
  }
}, 'VTreeview');
const VTreeview = genericComponent()({
  name: 'VTreeview',
  props: makeVTreeviewProps(),
  emits: {
    'update:opened': val => true,
    'update:activated': val => true,
    'update:selected': val => true,
    'update:modelValue': val => true,
    'click:open': value => true,
    'click:select': value => true
  },
  setup(props, _ref) {
    let {
      slots
    } = _ref;
    const {
      items
    } = useListItems(props);
    const activeColor = toRef(props, 'activeColor');
    const baseColor = toRef(props, 'baseColor');
    const color = toRef(props, 'color');
    const activated = useProxiedModel(props, 'activated');
    const model = useProxiedModel(props, 'modelValue');
    const _selected = useProxiedModel(props, 'selected', props.modelValue);
    const selected = computed({
      get: () => _selected.value,
      set(val) {
        _selected.value = val;
        model.value = val;
      }
    });
    const vListRef = ref();
    const opened = computed(() => props.openAll ? openAll(items.value) : props.opened);
    const flatItems = computed(() => flatten(items.value));
    const search = toRef(props, 'search');
    const {
      filteredItems
    } = useFilter(props, flatItems, search);
    const visibleIds = computed(() => {
      if (!search.value) return null;
      const getPath = vListRef.value?.getPath;
      if (!getPath) return null;
      return new Set(filteredItems.value.flatMap(item => {
        const itemVal = props.returnObject ? item.raw : item.props.value;
        return [...getPath(itemVal), ...getChildren(itemVal)].map(toRaw);
      }));
    });
    function getChildren(id) {
      const arr = [];
      const queue = (vListRef.value?.children.get(id) ?? []).slice();
      while (queue.length) {
        const child = queue.shift();
        if (!child) continue;
        arr.push(child);
        queue.push(...(vListRef.value?.children.get(child) ?? []).slice());
      }
      return arr;
    }
    function openAll(items) {
      let ids = [];
      for (const i of items) {
        if (!i.children) continue;
        ids.push(props.returnObject ? toRaw(i.raw) : i.value);
        if (i.children) {
          ids = ids.concat(openAll(i.children));
        }
      }
      return ids;
    }
    provide(VTreeviewSymbol, {
      visibleIds
    });
    provideDefaults({
      VTreeviewGroup: {
        activeColor,
        baseColor,
        color,
        collapseIcon: toRef(props, 'collapseIcon'),
        expandIcon: toRef(props, 'expandIcon')
      },
      VTreeviewItem: {
        activeClass: toRef(props, 'activeClass'),
        activeColor,
        baseColor,
        color,
        density: toRef(props, 'density'),
        disabled: toRef(props, 'disabled'),
        lines: toRef(props, 'lines'),
        variant: toRef(props, 'variant')
      }
    });
    useRender(() => {
      const listProps = VList.filterProps(props);
      const treeviewChildrenProps = VTreeviewChildren.filterProps(props);
      return createVNode(VList, mergeProps({
        "ref": vListRef
      }, listProps, {
        "class": ['v-treeview', props.class],
        "open-strategy": "multiple",
        "style": props.style,
        "opened": opened.value,
        "activated": activated.value,
        "onUpdate:activated": $event => activated.value = $event,
        "selected": selected.value,
        "onUpdate:selected": $event => selected.value = $event
      }), {
        default: () => [createVNode(VTreeviewChildren, mergeProps(treeviewChildrenProps, {
          "returnObject": props.returnObject,
          "items": items.value
        }), slots)]
      });
    });
    return {};
  }
});

const vuetify = createVuetify({
    blueprint: md3,
    components: {
        VApp,
        VContainer,
        VMain,
        VLayout,
        VDivider,
        VSpacer,
        VSheet,
        VWindow,
        VWindowItem,
        VItemGroup,
        VItem,
        VSlideGroup,
        /*VSlideItem,*/ VRow,
        VCol,
        VHover,
        VImg,
        VResponsive,
        VOverlay,
        VAvatar,
        VList,
        VListGroup,
        VListSubheader,
        /*VListItemGroup,*/ VListItem,
        VListItemTitle,
        VListItemSubtitle,
        VListItemAction,
        /*VListItemActionText, VListItemAvatar, VListItemContent, VListItemIcon, */ VTabs,
        VTab,
        VTabsWindow,
        VTabsWindowItem,
        VNavigationDrawer,
        VBottomNavigation,
        VCard,
        VCardText,
        VCardTitle,
        VCardSubtitle,
        VCardActions,
        VBtn,
        VBtnToggle,
        VFab,
        /*VOverflowBtn,*/ VTextField,
        VTextarea,
        VAutocomplete,
        VCombobox,
        VSelect,
        VCheckbox,
        VCheckboxBtn,
        VRadio,
        VRadioGroup,
        VSwitch,
        VInput,
        VNumberInput,
        VMenu,
        VIcon,
        VChipGroup,
        VChip,
        VBadge,
        VTooltip,
        VDatePicker,
        VTimePicker,
        VDateInput,
        VSnackbar,
        VAppBar,
        VAppBarNavIcon,
        VAppBarTitle,
        VToolbar,
        VToolbarTitle,
        VToolbarItems,
        VFadeTransition,
        VSlideYTransition,
        VSlideXReverseTransition,
        VExpandTransition,
        VScaleTransition,
        VProgressLinear,
        VProgressCircular,
        VAlert,
        VDialog,
        VDialogTransition,
        VDialogBottomTransition,
        VDataTable,
        /*VDataTableHeader,*/ VExpansionPanels,
        VExpansionPanel,
        /*VExpansionPanelHeader, VExpansionPanelContent,*/ VSkeletonLoader,
        VVirtualScroll,
        VEmptyState,
        VTreeview,
        VTreeviewGroup,
        VTreeviewItem,
        VDefaultsProvider,
        VSnackbarQueue
    },
    directives: {
        ClickOutside,
        Ripple,
        Tooltip,
        Resize
    },
    locale: {
        locale: "de",
        messages: {
            de
        }
    },
    icons: {
        defaultSet: "mdi",
        aliases,
        sets: {
            mdi
        }
    },
    theme: {
        defaultTheme: "bluc",
        variations: false,
        themes: {
            bluc: {
                dark: false,
                colors: {
                    "success": "#5DA271",
                    "primary": "#00517E",
                    "surfaceTint": "#006399",
                    "onPrimary": "#FFFFFF",
                    "primaryContainer": "#0077B6",
                    "onPrimaryContainer": "#FFFFFF",
                    "secondary": "#45617B",
                    "onSecondary": "#FFFFFF",
                    "secondaryContainer": "#CBE4FF",
                    "onSecondaryContainer": "#2E4A62",
                    "tertiary": "#6B3683",
                    "onTertiary": "#FFFFFF",
                    "tertiaryContainer": "#935BAB",
                    "onTertiaryContainer": "#FFFFFF",
                    "error": "#BA1A1A",
                    "onError": "#FFFFFF",
                    "errorContainer": "#FFDAD6",
                    "onErrorContainer": "#410002",
                    "background": "#F0F0F4",
                    "onBackground": "#181C20",
                    "surface": "#F7F9FF",
                    "onSurface": "#181C20",
                    "surfaceVariant": "#DCE3EE",
                    "onSurfaceVariant": "#404850",
                    "outline": "#707881",
                    "outlineVariant": "#BFC7D1",
                    "shadow": "#000000",
                    "scrim": "#000000",
                    "inverseSurface": "#2D3135",
                    "inverseOnSurface": "#EEF1F6",
                    "inversePrimary": "#94CCFF",
                    "primaryFixed": "#CDE5FF",
                    "onPrimaryFixed": "#001D32",
                    "primaryFixedDim": "#94CCFF",
                    "onPrimaryFixedVariant": "#004B74",
                    "secondaryFixed": "#CDE5FF",
                    "onSecondaryFixed": "#001D32",
                    "secondaryFixedDim": "#ADCAE7",
                    "onSecondaryFixedVariant": "#2D4962",
                    "tertiaryFixed": "#F7D8FF",
                    "onTertiaryFixed": "#320047",
                    "tertiaryFixedDim": "#EAB2FF",
                    "onTertiaryFixedVariant": "#642F7C",
                    "surfaceDim": "#D7DAE0",
                    "surfaceBright": "#F7F9FF",
                    "surfaceContainerLowest": "#FFFFFF",
                    "surfaceContainerLow": "#F1F4F9",
                    "surfaceContainer": "#EBEEF4",
                    "surfaceContainerHigh": "#E6E8EE",
                    "surfaceContainerHighest": "#E0E2E8"
                }
            }
        }
    }
});

class EditorModule extends Pinia {
    constructor(...args){
        super(...args), this.activeLanguage = "de";
    }
}
EditorModule = _([
    Store
], EditorModule);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function isNil(value) {
  return value == null;
}
var lodash_isnil = isNil;
var INFINITY$1 = 1 / 0, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
var symbolTag$1 = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var objectProto$1 = Object.prototype;
var objectToString$1 = objectProto$1.toString;
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike$1(value) {
  return !!value && typeof value == "object";
}
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_tointeger = toInteger;
const defaultSize = 8;
const defaultDisabledClass = "disabled";
const defaultFocusClass = "focused";
const defaultDragClass = "draggable";
const defaultDropClass = "droppable";
const defaultOverClass = "node-over";
const defaultInClass = "node-in";
const defaultUnderClass = "node-under";
const defaultViewBox = "0 0 123.958 123.959";
const defaultOpenDraw = `M117.979,28.017h-112c-5.3,0-8,6.4-4.2,10.2l56,56c2.3,2.3,6.1,2.3,8.401,0l56-56C125.979,34.417,123.279,28.017,117.979,28.017z`;
const defaultCloseDraw = `M38.217,1.779c-3.8-3.8-10.2-1.1-10.2,4.2v112c0,5.3,6.4,8,10.2,4.2l56-56c2.3-2.301,2.3-6.101,0-8.401L38.217,1.779z`;
const defaultColor = "black";
function createDefaultIcon(draw) {
  return {
    type: "shape",
    width: defaultSize,
    height: defaultSize,
    viewBox: defaultViewBox,
    stroke: defaultColor,
    fill: defaultColor,
    draw,
    name: null,
    src: null,
    alt: null,
    style: null,
    class: null
  };
}
const defaultConfig = {
  roots: [],
  padding: 16,
  editable: false,
  editing: null,
  checkboxes: false,
  dragAndDrop: false,
  keyboardNavigation: false,
  openedIcon: createDefaultIcon(defaultOpenDraw),
  closedIcon: createDefaultIcon(defaultCloseDraw)
};
function useLevel(props) {
  const state = inject$2("state");
  const config = state.config;
  const nodes = state.nodes;
  const depth = ref(props.depth);
  const parent = ref(props.parentId);
  const level = computed(() => {
    const res = [];
    if (lodash_isnil(parent.value) && config.value.roots && depth.value === 0) {
      for (const id2 of config.value.roots) {
        addNode(id2, res);
      }
      return res;
    }
    if (!lodash_isnil(parent.value)) {
      const node = nodes.value[parent.value];
      if (node && node.children && node.children.length > 0) {
        for (const id2 of node.children) {
          addNode(id2, res);
        }
      }
      return res;
    }
    return [];
  });
  const addNode = (id2, a) => {
    if (nodes.value[id2]) {
      nodes.value[id2].id = id2;
      nodes.value[id2].parent = parent.value;
      a.push(nodes.value[id2]);
    }
  };
  const id = computed(() => {
    return new Date().valueOf();
  });
  const padding = computed(() => {
    if (depth.value === 0) {
      return 0;
    }
    if (lodash_isnil(config.value.padding)) {
      return defaultConfig.padding;
    }
    const p = lodash_tointeger(config.value.padding);
    return p >= 0 ? p : 0;
  });
  const style = computed(() => {
    return {
      "padding-left": `${padding.value}px`,
      "list-style": "none"
    };
  });
  return {
    id,
    level,
    padding,
    style
  };
}
var _export_sfc = (sfc, props) => {
  for (const [key, val] of props) {
    sfc[key] = val;
  }
  return sfc;
};
const _sfc_main$4 = {
  components: {
    TreeNode: defineAsyncComponent(() => Promise.resolve().then(function() {
      return TreeNode$1;
    }))
  },
  props: {
    depth: {
      required: true,
      type: Number,
      default: null
    },
    parentId: {
      type: String,
      default: null
    }
  },
  setup(props) {
    return __spreadValues({}, useLevel(props));
  }
};
const _hoisted_1$2$1 = ["id"];
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TreeNode = resolveComponent("TreeNode");
  return openBlock(), createElementBlock("ul", {
    class: "tree-level",
    id: _ctx.id,
    style: normalizeStyle(_ctx.style)
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.level, (item, index) => {
      return openBlock(), createBlock(_component_TreeNode, {
        key: item.id,
        node: item,
        depth: $props.depth,
        index,
        "parent-id": $props.parentId
      }, {
        "loading-slot": withCtx((props) => [
          renderSlot(_ctx.$slots, "loading-slot", {
            node: props.node
          })
        ]),
        "before-input": withCtx((props) => [
          renderSlot(_ctx.$slots, "before-input", {
            node: props.node
          })
        ]),
        "after-input": withCtx((props) => [
          renderSlot(_ctx.$slots, "after-input", {
            node: props.node
          })
        ]),
        _: 2
      }, 1032, ["node", "depth", "index", "parent-id"]);
    }), 128))
  ], 12, _hoisted_1$2$1);
}
var TreeLevel = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
var TreeLevel$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": TreeLevel
});
var INFINITY = 1 / 0;
var symbolTag = "[object Symbol]";
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var idCounter = 0;
var objectToString = objectProto.toString;
var Symbol$1 = root.Symbol;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}
var lodash_uniqueid = uniqueId;
const states = new Map();
function createState(props) {
  const { nodes, config } = toRefs(props);
  const state = {
    id: lodash_uniqueid(),
    nodes: computed(() => nodes.value),
    config: computed(() => config.value),
    focusable: ref(null),
    focusFunc: new Map(),
    dragged: ref({
      node: null,
      element: null,
      wrapper: null,
      parentId: null
    })
  };
  states.set(state.id, state);
  return state.id;
}
function useTree(props, emit) {
  const element = ref(null);
  const id = createState(props);
  const state = states.get(id);
  provide("emitter", emit);
  provide("state", state);
  const style = computed(() => {
    return {
      "display": "flex",
      "align-items": "center"
    };
  });
  onUnmounted(() => {
    states.delete(id);
  });
  return {
    element,
    style
  };
}
const _sfc_main$3 = {
  components: {
    TreeLevel
  },
  props: {
    nodes: {
      required: true,
      type: Object,
      default: () => {
      }
    },
    config: {
      required: true,
      type: Object,
      default: () => {
      }
    }
  },
  setup(props, { emit }) {
    return __spreadValues({}, useTree(props, emit));
  },
  methods: {
    setElementRef(elt) {
      this.element = elt;
    }
  }
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TreeLevel = resolveComponent("TreeLevel");
  return openBlock(), createElementBlock("div", {
    class: "tree",
    ref: $options.setElementRef,
    style: normalizeStyle(_ctx.style)
  }, [
    createVNode(_component_TreeLevel, mergeProps({
      depth: 0,
      "parent-id": null
    }, _ctx.$attrs), {
      "loading-slot": withCtx((props) => [
        renderSlot(_ctx.$slots, "loading-slot", {
          node: props.node
        })
      ]),
      "before-input": withCtx((props) => [
        renderSlot(_ctx.$slots, "before-input", {
          node: props.node
        })
      ]),
      "after-input": withCtx((props) => [
        renderSlot(_ctx.$slots, "after-input", {
          node: props.node
        })
      ]),
      _: 3
    }, 16)
  ], 4);
}
var Tree = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var lodash_eq = eq;
const nodeEvents = {
  opened: "nodeOpened",
  closed: "nodeClosed",
  focus: "nodeFocus",
  toggle: "nodeToggle",
  blur: "nodeBlur",
  edit: "nodeEdit"
};
const checkboxEvents = {
  checked: "nodeChecked",
  unchecked: "nodeUnchecked"
};
const dragEvents = {
  start: "nodeDragstart",
  end: "nodeDragend",
  enter: "nodeDragenter",
  leave: "nodeDragleave",
  over: "nodeOver",
  drop: "nodeDrop"
};
function useInput(cmn) {
  const node = cmn.node;
  const config = cmn.config;
  const wrapper = cmn.wrapper;
  const editable = cmn.editable;
  const editing = cmn.editing;
  const input = ref(null);
  const text = computed({
    get: () => node.value.text,
    set: (val) => node.value.text = val
  });
  const editableClass = computed(() => {
    if (!cmn.editable.value) {
      return null;
    }
    return config.value.editableClass ? config.value.editableClass : "editable";
  });
  watch(editing, (nv, ov) => {
    if (!lodash_eq(nv, ov) && nv) {
      nextTick(() => {
        input.value.focus();
      });
    }
  });
  const focusInput = () => {
    if (editable.value && !cmn.disabled.value) {
      config.value.editing = node.value.id;
      cmn.root.emit(nodeEvents.edit, node.value);
    }
  };
  const esc = (event) => {
    if (editable.value && config.value.keyboardNavigation) {
      cmn.blur(event);
      wrapper.value.focus();
    }
  };
  const enter = () => {
    if (editable.value && !cmn.disabled.value && config.value.keyboardNavigation) {
      focusInput();
    }
  };
  return {
    text,
    input,
    editing,
    editable,
    editableClass,
    focusInput,
    esc,
    enter
  };
}
function useIcon(props) {
  const { isLeaf } = toRefs(props);
  const state = inject$2("state");
  const config = state.config;
  const openedIcon = computed(() => {
    return config.value.openedIcon || defaultConfig.openedIcon;
  });
  const closedIcon = computed(() => {
    return config.value.closedIcon || defaultConfig.closedIcon;
  });
  const hasIcons = computed(() => {
    return !lodash_isnil(closedIcon.value) && !lodash_isnil(openedIcon.value);
  });
  const useIcons = computed(() => {
    return !isLeaf.value && hasIcons.value;
  });
  const fakeNodeStyle = computed(() => {
    return {
      width: `${defaultSize}px`,
      height: `${defaultSize}px`
    };
  });
  return {
    hasIcons,
    openedIcon,
    closedIcon,
    useIcons,
    fakeNodeStyle
  };
}
const _sfc_main$2 = {
  props: {
    icon: {
      required: true,
      type: Object
    }
  }
};
const _hoisted_1$1$1 = ["width", "height", "viewBox"];
const _hoisted_2$1$1 = ["d", "fill", "stroke", "stroke-width"];
const _hoisted_3$1$1 = ["src", "alt", "width", "height"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.icon.type === "shape" ? (openBlock(), createElementBlock("svg", {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.icon.width,
    height: $props.icon.height,
    class: normalizeClass($props.icon.class),
    style: normalizeStyle($props.icon.style),
    viewBox: $props.icon.viewBox
  }, [
    createElementVNode("path", {
      d: $props.icon.draw,
      fill: $props.icon.fill,
      stroke: $props.icon.stroke,
      "stroke-width": $props.icon.strokeWidth
    }, null, 8, _hoisted_2$1$1)
  ], 14, _hoisted_1$1$1)) : $props.icon.type === "class" ? (openBlock(), createElementBlock("i", {
    key: 1,
    class: normalizeClass($props.icon.class),
    style: normalizeStyle($props.icon.style)
  }, null, 6)) : $props.icon.type === "img" ? (openBlock(), createElementBlock("img", {
    key: 2,
    src: $props.icon.src,
    alt: $props.icon.alt,
    width: $props.icon.width,
    height: $props.icon.height,
    class: normalizeClass($props.icon.class),
    style: normalizeStyle($props.icon.style)
  }, null, 14, _hoisted_3$1$1)) : createCommentVNode("", true);
}
var Icon = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = {
  components: {
    Icon
  },
  props: {
    isLeaf: {
      type: Boolean
    },
    opened: {
      type: Boolean
    }
  },
  setup(props) {
    return useIcon(props);
  },
  computed: {
    fakeIcon() {
      return createDefaultIcon(null);
    }
  }
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = resolveComponent("Icon");
  return _ctx.useIcons ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
    $props.opened ? (openBlock(), createBlock(_component_Icon, {
      key: 0,
      icon: _ctx.openedIcon
    }, null, 8, ["icon"])) : (openBlock(), createBlock(_component_Icon, {
      key: 1,
      icon: _ctx.closedIcon
    }, null, 8, ["icon"]))
  ], 64)) : (openBlock(), createBlock(_component_Icon, {
    key: 1,
    icon: $options.fakeIcon
  }, null, 8, ["icon"]));
}
var TreeIcons = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
function useNode(cmn, props) {
  const state = cmn.state;
  const node = cmn.node;
  const config = cmn.config;
  const wrapper = cmn.wrapper;
  const editing = cmn.editing;
  const level = ref(null);
  const depth = ref(props.depth);
  const index = ref(props.index);
  if (!node.value.children) {
    node.value.children = ref([]).value;
  }
  const id = computed(() => {
    return hasNode.value && node.value.id;
  });
  const hasNode = computed(() => {
    return !lodash_isnil(node);
  });
  const hasState = computed(() => {
    return hasNode.value && !lodash_isnil(node.value.state);
  });
  const roots = computed(() => {
    return config.value.roots || [];
  });
  const children = computed(() => {
    return lodash_isnil(node.value.children) ? [] : node.value.children;
  });
  const nbChildren = computed(() => {
    return children.value.length;
  });
  const hasChildren = computed(() => {
    return nbChildren.value > 0;
  });
  const opened = computed(() => {
    return hasState.value && node.value.state.opened || false;
  });
  const isLoading = computed(() => {
    return hasState.value && node.value.state.isLoading || false;
  });
  const displayLoading = computed(() => {
    return isLoading.value && !hasChildren.value && opened.value;
  });
  const displayLevel = computed(() => {
    return !isLoading.value && hasChildren.value && opened.value;
  });
  const style = computed(() => {
    return {
      display: "flex"
    };
  });
  const disabledClass = computed(() => {
    if (!cmn.disabled.value) {
      return null;
    }
    return config.value.disabledClass ? config.value.disabledClass : defaultDisabledClass;
  });
  const hideIcons = computed(() => {
    for (const id2 of roots.value) {
      const node2 = state.nodes.value[id2];
      if (node2.children && node2.children.length > 0) {
        return false;
      }
    }
    return true;
  });
  const isLeaf = computed(() => {
    if (config.value.leaves instanceof Array) {
      const arr = config.value.leaves;
      const idx = arr.indexOf(id.value);
      return Number.isFinite(idx) && idx >= 0;
    }
    return !hasChildren.value;
  });
  const isFocusable = computed(() => {
    return state.focusable.value === node.value.id;
  });
  const tabIndex = computed(() => {
    if (depth.value === 0 && index.value === 0 && lodash_isnil(state.focusable.value)) {
      return 0;
    }
    return isFocusable.value ? 0 : -1;
  });
  const focusClass = computed(() => {
    if (!cmn.focused.value) {
      return null;
    }
    return config.value.focusClass ? config.value.focusClass : defaultFocusClass;
  });
  watch(opened, (nv) => {
    nv ? cmn.root.emit(nodeEvents.opened, node.value) : cmn.root.emit(nodeEvents.closed, node.value);
  });
  const focus = () => {
    state.focusable.value = node.value.id;
    nextTick(() => {
      if (wrapper.value) {
        wrapper.value.focus();
      }
      cmn.focused.value = true;
      cmn.root.emit(nodeEvents.focus, node.value);
    });
  };
  const toggle = () => {
    node.value.state.opened = !node.value.state.opened;
    cmn.root.emit(nodeEvents.toggle, node.value);
  };
  const right = () => {
    if (!editing.value && config.value.keyboardNavigation) {
      node.value.state.opened = true;
    }
  };
  const left = () => {
    if (!editing.value && config.value.keyboardNavigation) {
      node.value.state.opened = false;
    }
  };
  const move = (getFunc) => {
    const id2 = getFunc(node.value.id);
    if (!lodash_isnil(id2) && config.value.keyboardNavigation) {
      const f = state.focusFunc.get(id2);
      if (f) {
        f();
      }
    }
  };
  const up = () => move(prevVisible);
  const prev = (id2) => {
    const n = state.nodes.value[id2];
    if (n.children && n.children.length > 0) {
      const idx = n.children.indexOf(node.value.id);
      const prev2 = n.children[idx - 1];
      if (!lodash_isnil(prev2)) {
        return lastChild(prev2);
      }
    }
    return n.id;
  };
  const prevVisible = (id2) => {
    const n = state.nodes.value[id2];
    const p = state.nodes.value[n.parent];
    if (!p) {
      const idx = roots.value.indexOf(id2);
      return lastChild(roots.value[idx - 1]) || null;
    }
    return prev(p.id);
  };
  const lastChild = (id2) => {
    const n = state.nodes.value[id2];
    if (!n) {
      return null;
    }
    if (n.children && n.children.length > 0 && n.state.opened) {
      const last = n.children[n.children.length - 1];
      if (!lodash_isnil(last)) {
        return lastChild(last);
      }
    }
    return n.id;
  };
  const down = () => move(nextVisible);
  const nextRoot = (id2) => {
    const idx = roots.value.indexOf(id2);
    return roots.value[idx + 1] || null;
  };
  const next = (p, id2) => {
    const idx = p.children.indexOf(id2);
    if (p.children[idx + 1]) {
      return p.children[idx + 1];
    }
    if (p.parent) {
      return next(state.nodes.value[p.parent], p.id);
    }
    return nextRoot(p.id);
  };
  const nextVisible = (id2) => {
    const n = state.nodes.value[id2];
    if (n.children && n.children.length > 0 && n.state.opened) {
      return n.children[0];
    }
    const p = state.nodes.value[n.parent];
    return p ? next(p, id2) : nextRoot(id2);
  };
  onMounted(() => {
    state.focusFunc.set(node.value.id, focus);
  });
  onUnmounted(() => {
    state.focusFunc.delete(node.value.id);
  });
  return {
    id,
    level,
    style,
    opened,
    hasNode,
    hideIcons,
    hasChildren,
    tabIndex,
    focusClass,
    disabledClass,
    isLeaf,
    isLoading,
    displayLoading,
    displayLevel,
    right,
    left,
    up,
    down,
    toggle,
    focus,
    prevVisible,
    nextVisible
  };
}
function ensureState(node) {
  if (lodash_isnil(node.state)) {
    node.state = {};
    node.state.checked = false;
  }
}
function auto(node, nodes) {
  const check = (v) => {
    node.value.state.checked = v;
  };
  const setIndeterminate = (v) => {
    node.value.state.indeterminate = v;
  };
  const ensureCheck = () => {
    ensureState(node.value);
    if (node.value.state.checked || !hasChildren.value) {
      setIndeterminate(false);
    }
  };
  const children = computed(() => {
    return node.value.children;
  });
  const hasChildren = computed(() => {
    return !lodash_isnil(children.value) && children.value.length > 0 || false;
  });
  const states2 = computed(() => {
    if (!hasChildren.value) {
      return [];
    }
    const res = [];
    for (const c of children.value) {
      const child = nodes.value[c];
      if (!lodash_isnil(child)) {
        ensureState(child);
        res.push(child.state);
      }
    }
    return res;
  });
  const checked = computed(() => {
    return node.value.state.checked;
  });
  const indeterminate = computed(() => {
    return node.value.state.indeterminate;
  });
  const allChecked = computed(() => {
    return states2.value.every((x) => x.checked);
  });
  const noneChecked = computed(() => {
    return states2.value.every((x) => !x.checked);
  });
  const someChecked = computed(() => {
    return !allChecked.value && !noneChecked.value;
  });
  const someIndeterminate = computed(() => {
    return states2.value.some((x) => x.indeterminate);
  });
  const recurseDown = (n) => {
    if (!lodash_isnil(n.state) && !lodash_isnil(n.children)) {
      for (const id of n.children) {
        const child = nodes.value[id];
        if (!lodash_isnil(child)) {
          ensureState(child);
          child.state.indeterminate = false;
          child.state.checked = n.state.checked;
          recurseDown(child);
        }
      }
    }
  };
  const updateState = () => {
    if (!hasChildren.value) {
      return;
    }
    if (noneChecked.value && !someIndeterminate.value) {
      setIndeterminate(false);
      check(false);
      return;
    }
    if (allChecked.value) {
      setIndeterminate(false);
      check(true);
      return;
    }
    setIndeterminate(true);
    check(false);
  };
  const rebuild = () => {
    ensureCheck();
    recurseDown(node.value);
    updateState();
  };
  const click = () => {
    setIndeterminate(false);
    check(!node.value.state.checked);
  };
  return {
    checked,
    indeterminate,
    noneChecked,
    someChecked,
    allChecked,
    someIndeterminate,
    click,
    rebuild,
    updateState,
    recurseDown
  };
}
function manual(node) {
  const checked = computed(() => {
    return node.value.state.checked;
  });
  const indeterminate = computed(() => {
    return node.value.state.indeterminate || false;
  });
  const noneChecked = computed(() => {
    return false;
  });
  const someChecked = computed(() => {
    return false;
  });
  const allChecked = computed(() => {
    return false;
  });
  const someIndeterminate = computed(() => {
    return false;
  });
  const click = () => {
    node.value.state.checked = !node.value.state.checked;
  };
  const rebuild = () => {
  };
  const updateState = () => {
  };
  const recurseDown = () => {
  };
  return {
    checked,
    indeterminate,
    noneChecked,
    someChecked,
    allChecked,
    someIndeterminate,
    click,
    rebuild,
    updateState,
    recurseDown
  };
}
var checkMode;
(function(checkMode2) {
  checkMode2[checkMode2["auto"] = 0] = "auto";
  checkMode2[checkMode2["manual"] = 1] = "manual";
})(checkMode || (checkMode = {}));
function useCheckBox(cmn) {
  const node = cmn.node;
  const config = cmn.config;
  const nodes = cmn.state.nodes;
  const mode = computed(() => {
    return config.value.checkMode === checkMode.auto ? checkMode.auto : checkMode.manual;
  });
  const factory = computed(() => {
    return mode.value === checkMode.auto ? auto(node, nodes) : manual(node);
  });
  watch(mode, (nv, ov) => {
    if (!lodash_eq(nv, ov)) {
      factory.value.rebuild();
    }
  });
  const checked = computed(() => {
    return factory.value.checked.value;
  });
  const indeterminate = computed(() => {
    return factory.value.indeterminate.value;
  });
  const hasCheckbox = computed(() => {
    return config.value.checkboxes || defaultConfig.checkboxes;
  });
  const checkedClass = computed(() => {
    return [
      factory.value.checked.value ? config.value.checkedClass ? config.value.checkedClass : "checked" : null,
      factory.value.indeterminate.value ? config.value.indeterminateClass ? config.value.indeterminateClass : "indeterminate" : null
    ];
  });
  const allChecked = computed(() => {
    return factory.value.allChecked.value;
  });
  const noneChecked = computed(() => {
    return factory.value.noneChecked.value;
  });
  const someChecked = computed(() => {
    return factory.value.someChecked.value;
  });
  const someIndeterminate = computed(() => {
    return factory.value.someIndeterminate.value;
  });
  watch([allChecked, noneChecked, someChecked], ([ov1, ov2, ov3]) => {
    if (ov1 || ov2 || ov3) {
      factory.value.updateState();
    }
  }, { deep: true });
  watch(someIndeterminate, (nv, ov) => {
    if (!lodash_eq(nv, ov)) {
      factory.value.updateState();
    }
  }, { deep: true });
  const clickCheckbox = () => {
    if (!cmn.disabled.value) {
      factory.value.click();
      factory.value.recurseDown(node.value);
      cmn.root.emit(checked.value ? checkboxEvents.checked : checkboxEvents.unchecked, node.value);
    }
  };
  const space = () => {
    if (!cmn.editing.value && config.value.checkboxes && config.value.keyboardNavigation) {
      clickCheckbox();
    }
  };
  return {
    checked,
    hasCheckbox,
    indeterminate,
    checkedClass,
    space,
    clickCheckbox
  };
}
var DragPosition;
(function(DragPosition2) {
  DragPosition2[DragPosition2["over"] = 0] = "over";
  DragPosition2[DragPosition2["in"] = 1] = "in";
  DragPosition2[DragPosition2["under"] = 2] = "under";
})(DragPosition || (DragPosition = {}));
function useDragAndDrop(cmn, props) {
  const node = cmn.node;
  const state = cmn.state;
  const parentId = ref(props.parentId);
  const config = cmn.config;
  const nodes = state.nodes;
  const dragged = ref(state.dragged);
  const wrapper = cmn.wrapper;
  const element = ref(null);
  const pos = ref(null);
  const draggable = computed(() => {
    return !cmn.disabled.value && config.value.dragAndDrop && node.value.state.draggable !== false;
  });
  const droppable = computed(() => {
    return config.value.dragAndDrop && node.value.state.droppable !== false;
  });
  const isDragging = computed(() => {
    return !lodash_isnil(dragged.value) && !lodash_isnil(dragged.value.node);
  });
  const isSameNode = computed(() => {
    return isDragging.value && dragged.value.node.id === node.value.id;
  });
  const isSameParent = computed(() => {
    return targetParent.value === draggedParent.value;
  });
  const draggedParent = computed(() => {
    return !isDragging.value || !dragged.value.parentId ? null : getParent(dragged.value.parentId);
  });
  const draggedLvl = computed(() => {
    return getLevel(draggedParent.value);
  });
  const targetParent = computed(() => {
    return !lodash_isnil(parentId.value) ? getParent(parentId.value) : null;
  });
  const targetLvl = computed(() => {
    return getLevel(targetParent.value);
  });
  const dragContain = computed(() => {
    if (!isDragging.value || !dragged.value.wrapper) {
      return false;
    }
    return dragged.value.element.contains(element.value);
  });
  const context = computed(() => {
    return {
      dragged: dragged.value,
      target: {
        node: node.value.id,
        element: element.value,
        wrapper: wrapper.value,
        parentId: parentId.value
      }
    };
  });
  const dragClass = computed(() => {
    return [
      draggable.value ? defaultDragClass : null,
      droppable.value ? defaultDropClass : null,
      pos.value === 0 ? defaultOverClass : null,
      pos.value === 1 ? defaultInClass : null,
      pos.value === 2 ? defaultUnderClass : null
    ];
  });
  const getParent = (id) => {
    return !lodash_isnil(id) ? nodes.value[id] : null;
  };
  const getLevel = (node2) => {
    return !lodash_isnil(node2) ? node2.children : config.value.roots;
  };
  const getDataTransfer = (evt) => {
    if (!evt || !evt.dataTransfer)
      return null;
    const jsonPayload = evt.dataTransfer.getData("application/json");
    if (jsonPayload)
      return JSON.parse(jsonPayload);
    return evt.dataTransfer.getData("text/plain");
  };
  const isExternalSrc = (evt) => {
    var _a, _b;
    return ((_b = (_a = evt == null ? void 0 : evt.dataTransfer) == null ? void 0 : _a.items) == null ? void 0 : _b.length) > 0;
  };
  const dragstart = (evt) => {
    if (draggable.value) {
      dragged.value = {
        node: node.value,
        element: element.value,
        wrapper: wrapper.value,
        parentId: parentId.value
      };
      cmn.root.emit(dragEvents.start, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
    }
  };
  const eventContext = (evt) => {
    return {
      evt,
      external: isExternalSrc(evt),
      dataTransfer: getDataTransfer(evt)
    };
  };
  const dragend = (evt) => {
    cmn.root.emit(dragEvents.end, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
    dragged.value = null;
  };
  const dragenter = (evt) => {
    cmn.root.emit(dragEvents.enter, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
  };
  const dragleave = (evt) => {
    cmn.root.emit(dragEvents.leave, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
    pos.value = null;
  };
  const dragover = (evt) => {
    if (!isSameNode.value && !dragContain.value) {
      const external = isExternalSrc(evt);
      if (!isDragging.value && !external)
        return;
      cmn.root.emit(dragEvents.over, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
      if (!external && wrapper.value) {
        const factor = 0.3;
        const y = evt.pageY;
        const r = wrapper.value.getBoundingClientRect();
        const midPoint = r.top + r.height / 2;
        const midRange = [
          midPoint - r.height * factor,
          midPoint + r.height * factor
        ];
        const idx = draggedLvl.value.indexOf(node.value.id);
        const idxDrag = draggedLvl.value.indexOf(dragged.value.node.id);
        if (y < midRange[0] && (!isSameParent.value || isSameParent.value && idx !== idxDrag + 1)) {
          pos.value = 0;
        } else if (y > midRange[1] && (!isSameParent.value || isSameParent.value && idx !== idxDrag - 1)) {
          pos.value = 2;
        } else {
          pos.value = 1;
        }
      }
    }
  };
  const drop = (evt) => {
    if (!isSameNode.value && !dragContain.value) {
      switch (pos.value) {
        case 0: {
          insertAt(0);
          break;
        }
        case 2: {
          insertAt(1);
          break;
        }
        case 1: {
          insertIn();
        }
      }
    }
    cmn.root.emit(dragEvents.drop, __spreadValues(__spreadValues({}, context.value), eventContext(evt)));
    pos.value = null;
  };
  const insertAt = (i) => {
    if (isDragging.value) {
      const dragId = dragged.value.node.id;
      const dragIdx = draggedLvl.value.indexOf(dragId);
      draggedLvl.value.splice(dragIdx, 1);
      const targetId = node.value.id;
      const idx = targetLvl.value.indexOf(targetId);
      targetLvl.value.splice(idx + i, 0, dragId);
    }
  };
  const insertIn = () => {
    if (isDragging.value && droppable.value) {
      const dragId = dragged.value.node.id;
      if (draggedLvl.value) {
        const idx = draggedLvl.value.indexOf(dragId);
        draggedLvl.value.splice(idx, 1);
      }
      node.value.children.unshift(dragId);
    }
  };
  return {
    pos,
    element,
    dragClass,
    draggable,
    droppable,
    dragstart,
    dragend,
    dragenter,
    dragleave,
    dragover,
    drop
  };
}
function useCommon(props) {
  const { node } = toRefs(props);
  const state = inject$2("state");
  const config = state.config;
  const wrapper = ref(null);
  const focused = ref(false);
  const root2 = {
    emit: inject$2("emitter")
  };
  ensureState(node.value);
  const hasNode = computed(() => {
    return !lodash_isnil(node);
  });
  const hasConfig = computed(() => {
    return !lodash_isnil(config.value);
  });
  const hasState = computed(() => {
    return hasNode.value && !lodash_isnil(node.value.state);
  });
  const disabled = computed(() => {
    return config.value.disabled || node.value.state.disabled;
  });
  const editable = computed(() => {
    return config.value.editable && (!lodash_isnil(node.value.state.editable) ? node.value.state.editable : true) || defaultConfig.editable;
  });
  const editing = computed(() => {
    return editable.value && config.value.editing === node.value.id;
  });
  const blur = (e) => {
    if (e.type === "blur") {
      const current = e.currentTarget;
      const related = e.relatedTarget;
      if (!current.contains(related)) {
        config.value.editing = null;
        focused.value = false;
        root2.emit(nodeEvents.blur, e, node.value);
      }
    }
  };
  return {
    state,
    node,
    config,
    hasNode,
    hasState,
    hasConfig,
    disabled,
    wrapper,
    editable,
    editing,
    focused,
    blur,
    root: root2
  };
}
const _sfc_main = {
  components: {
    TreeLevel: defineAsyncComponent(() => Promise.resolve().then(function() {
      return TreeLevel$1;
    })),
    TreeIcons
  },
  emits: [
    ...Object.values(nodeEvents),
    ...Object.values(checkboxEvents),
    ...Object.values(dragEvents)
  ],
  props: {
    depth: {
      required: true,
      type: Number
    },
    index: {
      required: true,
      type: Number
    },
    node: {
      required: true,
      type: Object
    },
    parentId: {
      default: null,
      type: String
    }
  },
  setup(props) {
    const cmn = useCommon(props);
    return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, cmn), useInput(cmn)), useCheckBox(cmn)), useNode(cmn, props)), useDragAndDrop(cmn, props));
  },
  computed: {
    nodeClass() {
      return [
        this.focusClass,
        this.disabledClass,
        this.checkedClass,
        this.editableClass,
        this.dragClass
      ];
    }
  },
  methods: {
    setWrapperRef(e) {
      this.wrapper = e;
    },
    setLevelRef(e) {
      this.level = e;
    },
    setElementRef(e) {
      this.element = e;
    },
    setInputRef(e) {
      this.input = e;
    }
  }
};
const _hoisted_1$a = ["aria-expanded"];
const _hoisted_2$5 = ["draggable", "tabindex"];
const _hoisted_3$5 = ["checked", "disabled", ".indeterminate"];
const _hoisted_4$3 = { class: "input-wrapper" };
const _hoisted_5$3 = ["disabled"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TreeIcons = resolveComponent("TreeIcons");
  const _component_TreeLevel = resolveComponent("TreeLevel");
  return _ctx.hasNode ? (openBlock(), createElementBlock("li", {
    key: 0,
    class: "tree-node",
    ref: $options.setElementRef,
    "aria-expanded": _ctx.opened,
    onKeydown: [
      _cache[13] || (_cache[13] = withKeys(withModifiers((...args) => _ctx.enter && _ctx.enter(...args), ["stop"]), ["enter"])),
      _cache[14] || (_cache[14] = withKeys(withModifiers((...args) => _ctx.esc && _ctx.esc(...args), ["stop"]), ["esc"])),
      _cache[15] || (_cache[15] = withKeys(withModifiers((...args) => _ctx.space && _ctx.space(...args), ["stop"]), ["space"])),
      _cache[16] || (_cache[16] = withKeys(withModifiers((...args) => _ctx.left && _ctx.left(...args), ["stop"]), ["left"])),
      _cache[17] || (_cache[17] = withKeys(withModifiers((...args) => _ctx.right && _ctx.right(...args), ["stop"]), ["right"])),
      _cache[18] || (_cache[18] = withKeys(withModifiers((...args) => _ctx.up && _ctx.up(...args), ["stop"]), ["up"])),
      _cache[19] || (_cache[19] = withKeys(withModifiers((...args) => _ctx.down && _ctx.down(...args), ["stop"]), ["down"]))
    ]
  }, [
    createElementVNode("div", {
      class: normalizeClass(["node-wrapper", $options.nodeClass]),
      style: normalizeStyle(_ctx.style),
      ref: $options.setWrapperRef,
      draggable: _ctx.draggable,
      tabindex: _ctx.tabIndex,
      onBlur: _cache[5] || (_cache[5] = (...args) => _ctx.blur && _ctx.blur(...args)),
      onClick: _cache[6] || (_cache[6] = withModifiers((...args) => _ctx.focus && _ctx.focus(...args), ["stop"])),
      onDragstart: _cache[7] || (_cache[7] = withModifiers((...args) => _ctx.dragstart && _ctx.dragstart(...args), ["stop"])),
      onDragend: _cache[8] || (_cache[8] = withModifiers((...args) => _ctx.dragend && _ctx.dragend(...args), ["stop"])),
      onDragenter: _cache[9] || (_cache[9] = withModifiers((...args) => _ctx.dragenter && _ctx.dragenter(...args), ["prevent", "stop"])),
      onDragleave: _cache[10] || (_cache[10] = withModifiers((...args) => _ctx.dragleave && _ctx.dragleave(...args), ["prevent", "stop"])),
      onDragover: _cache[11] || (_cache[11] = withModifiers((...args) => _ctx.dragover && _ctx.dragover(...args), ["prevent", "stop"])),
      onDrop: _cache[12] || (_cache[12] = withModifiers((...args) => _ctx.drop && _ctx.drop(...args), ["prevent", "stop"]))
    }, [
      !_ctx.hideIcons ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "icon-wrapper",
        onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["stop"]))
      }, [
        createVNode(_component_TreeIcons, {
          "is-leaf": _ctx.isLeaf,
          opened: _ctx.opened
        }, null, 8, ["is-leaf", "opened"])
      ])) : createCommentVNode("", true),
      _ctx.hasCheckbox ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["checkbox-wrapper", _ctx.checkedClass]),
        onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.clickCheckbox && _ctx.clickCheckbox(...args), ["stop"]))
      }, [
        createElementVNode("input", {
          type: "checkbox",
          tabindex: "-1",
          class: "node-checkbox",
          checked: _ctx.checked,
          disabled: _ctx.disabled,
          ".indeterminate": _ctx.indeterminate
        }, null, 40, _hoisted_3$5)
      ], 2)) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "before-input", { node: $props.node }),
      createElementVNode("div", _hoisted_4$3, [
        _ctx.editing ? withDirectives((openBlock(), createElementBlock("input", {
          key: 0,
          type: "text",
          tabindex: "0",
          class: "node-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.text = $event),
          ref: $options.setInputRef,
          disabled: _ctx.disabled,
          onBlur: _cache[3] || (_cache[3] = (...args) => _ctx.blur && _ctx.blur(...args))
        }, null, 40, _hoisted_5$3)), [
          [vModelText, _ctx.text]
        ]) : (openBlock(), createElementBlock("span", {
          key: 1,
          class: "node-text",
          onDblclick: _cache[4] || (_cache[4] = (...args) => _ctx.focusInput && _ctx.focusInput(...args))
        }, toDisplayString(_ctx.text), 33))
      ]),
      renderSlot(_ctx.$slots, "after-input", { node: $props.node })
    ], 46, _hoisted_2$5),
    _ctx.displayLoading ? renderSlot(_ctx.$slots, "loading-slot", {
      key: 0,
      node: $props.node
    }) : createCommentVNode("", true),
    createVNode(Transition, { name: "level" }, {
      default: withCtx(() => [
        _ctx.displayLevel ? (openBlock(), createBlock(_component_TreeLevel, {
          key: 0,
          "parent-id": _ctx.id,
          depth: $props.depth + 1,
          ref: $options.setLevelRef
        }, {
          "loading-slot": withCtx((props) => [
            renderSlot(_ctx.$slots, "loading-slot", {
              node: props.node
            })
          ]),
          "before-input": withCtx((props) => [
            renderSlot(_ctx.$slots, "before-input", {
              node: props.node
            })
          ]),
          "after-input": withCtx((props) => [
            renderSlot(_ctx.$slots, "after-input", {
              node: props.node
            })
          ]),
          _: 3
        }, 8, ["parent-id", "depth"])) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 40, _hoisted_1$a)) : createCommentVNode("", true);
}
var TreeNode = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
var TreeNode$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": TreeNode
});

function render$j(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_treeview = resolveComponent("treeview");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_col = resolveComponent("v-col");
  const _component_entity_editor = resolveComponent("entity-editor");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_container = resolveComponent("v-container");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_toolbar_items, { class: "v-toolbar__items--back" }, {
          default: withCtx(() => [
            createVNode(_component_v_tooltip, { location: "bottom" }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_btn, mergeProps(props, {
                  icon: "",
                  onClick: _ctx.goBack
                }), {
                  default: withCtx(() => [
                    createVNode(_component_v_icon, null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiArrowLeft), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1040, ["onClick"])
              ]),
              default: withCtx(() => [
                _cache[0] || (_cache[0] = createElementVNode("span", null, "Zurück", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_toolbar_title, null, {
          default: withCtx(() => [
            _cache[1] || (_cache[1] = createElementVNode("div", { class: "text-overline text-dense mb-0" }, "Menu", -1)),
            createTextVNode(" " + toDisplayString(_ctx.menu?.displayName), 1)
          ]),
          _: 1
        }),
        createVNode(_component_v_tooltip, { location: "bottom" }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_fab, mergeProps({
              absolute: "",
              offset: "",
              class: ["flex-grow-0", "mr-4"],
              location: "bottom right",
              color: "primary",
              size: "large",
              icon: _ctx.$icons.mdiCloudUpload,
              onClick: _ctx.publish,
              loading: _ctx.isPublishing
            }, props), null, 16, ["icon", "onClick", "loading"])
          ]),
          default: withCtx(() => [
            _cache[2] || (_cache[2] = createElementVNode("span", null, "Publizieren", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_v_container, {
      fluid: "",
      class: "py-0 menu-editor fill-height"
    }, {
      default: withCtx(() => [
        createVNode(_component_v_row, { class: "fill-height" }, {
          default: withCtx(() => [
            createVNode(_component_v_col, {
              cols: "4",
              class: "p-relative fill-height"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_card, {
                  flat: "",
                  class: "fill-height scroll-panel"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_treeview, {
                      class: "menu-editor__tree",
                      nodes: _ctx.nodes,
                      config: _ctx.treeviewConfig,
                      onNodeFocus: _ctx.onNodeFocused,
                      onNodeDragend: _ctx.onNodeDragend,
                      onNodeDragstart: _ctx.onNodeDragstart
                    }, {
                      "before-input": withCtx(({ node }) => [
                        createVNode(_component_v_badge, {
                          location: "bottom right",
                          color: "white",
                          "text-color": "grey-darken-2",
                          label: "Versteckt",
                          icon: _ctx.$icons.mdiGhostOutline,
                          modelValue: node.data.isHidden
                        }, {
                          default: withCtx(() => [
                            (node.data.isHome)
                              ? (openBlock(), createBlock(_component_v_icon, {
                                  key: 0,
                                  icon: _ctx.$icons.mdiHome
                                }, null, 8, ["icon"]))
                              : (node.data.target == null || node.data.target.length === 0)
                                ? (openBlock(), createBlock(_component_v_icon, {
                                    key: 1,
                                    icon: _ctx.$icons.mdiFileOutline
                                  }, null, 8, ["icon"]))
                                : (openBlock(), createBlock(_component_v_icon, {
                                    key: 2,
                                    icon: _ctx.$icons.mdiFileLink
                                  }, null, 8, ["icon"]))
                          ]),
                          _: 2
                        }, 1032, ["icon", "modelValue"])
                      ]),
                      "after-input": withCtx(({ node }) => [
                        (!node.data.isReadOnly && !node.data.isHome)
                          ? (openBlock(), createBlock(_component_v_btn, {
                              key: 0,
                              class: "mx-3",
                              variant: "tonal",
                              size: "small",
                              icon: _ctx.$icons.mdiDelete,
                              color: "warning",
                              onClick: withModifiers($event => (_ctx.deleteNode(node)), ["stop"])
                            }, null, 8, ["icon", "onClick"]))
                          : createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["nodes", "config", "onNodeFocus", "onNodeDragend", "onNodeDragstart"])
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tooltip, { text: "Neuer Menupunkt" }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_fab, mergeProps({
                      absolute: "",
                      class: "p-absolute mr-4",
                      style: {"bottom":"24px","right":"8px"},
                      color: "success",
                      icon: _ctx.$icons.mdiPlus,
                      onClick: _ctx.createNode
                    }, props), null, 16, ["icon", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_col, { class: "h-100" }, {
              default: withCtx(() => [
                (_ctx.editor != null)
                  ? (openBlock(), createBlock(_component_v_card, {
                      key: 0,
                      color: "surface-light",
                      class: "h-100"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_entity_editor, {
                          "disable-grouping": "",
                          "hide-appbar": "",
                          modelValue: _ctx.editor,
                          "validation-schema": _ctx.nodeSchema
                        }, null, 8, ["modelValue", "validation-schema"])
                      ]),
                      _: 1
                    }))
                  : (openBlock(), createBlock(_component_v_empty_state, {
                      key: 1,
                      class: "pb-16",
                      title: "Wähle einen Menupunkt aus um ihn zu bearbeiten",
                      icon: _ctx.$icons.mdiCursorDefaultClick
                    }, null, 8, ["icon"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}

class MenuService {
    constructor(middlewareFactory, notificationService, options){
        this.baseUrl = urljoin(options.apiBaseUrl, "menus");
        this.notificationService = notificationService;
        this.client = ky.create({
            prefixUrl: this.baseUrl,
            hooks: {
                beforeRequest: [
                    middlewareFactory.createAuthMiddleware()
                ]
            }
        });
    }
    async list() {
        let data = await this.client.get("").json();
        return data.menus;
    }
    async get(name) {
        let data = await this.client.get(name).json();
        return data;
    }
    async create(createRequest) {
        let data = await this.client.post("", {
            json: createRequest
        }).json();
        return data;
    }
    async delete(name) {
        await this.client.delete(name);
    }
    async createNode(createRequest) {
        let data = await this.client.post(createRequest.menuName, {
            json: createRequest
        }).json();
        return data;
    }
    async save(menu) {
        await this.client.put(menu.name, {
            json: menu
        });
    }
}
MenuService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], MenuService);

IconRegistry.add({
    mdiPlus,
    mdiCloudUpload,
    mdiMenuDown,
    mdiMenuRight,
    mdiHome,
    mdiDelete,
    mdiFileLink,
    mdiFileOutline,
    mdiGhostOutline,
    mdiCursorDefaultClick
});
class MenuEditor extends Vue {
    get rootNodeIds() {
        return this.treeviewConfig.roots;
    }
    set rootNodeIds(value) {
        this.treeviewConfig.roots = value;
    }
    onNameChanged() {
        this.load();
    }
    onEditorChanged(value) {
        this.hasPendingChanges = true;
        if (value == null) {
            return;
        }
        let treeviewNode = this.nodes[value.model.id];
        if (treeviewNode == null) {
            return;
        }
        treeviewNode.text = Multilingual.getValue(value.model.title);
    }
    async onSelectedNodeChanged(newNode, previousNode) {
        if (previousNode?.state != null) {
            previousNode.state.checked = false;
        }
        if (newNode != null) {
            newNode.state = {
                ...newNode.state,
                checked: true
            };
            this.editor = await this.editorFactory.createRoot(this.nodeSchema, newNode.data);
        } else {
            this.editor = null;
        }
    }
    beforeRouteLeave(to, from, next) {
        if (!this.hasPendingChanges) {
            next();
            return;
        }
        this.$confirm({
            title: "Änderungen publizieren?",
            textHtml: `Möchten Sie die Änderungen am Menu publizieren?<br />Wenn das Menu nicht publiziert wird, gehen die Änderungen verloren.`,
            confirmLabel: "Publizieren",
            cancelLabel: "Änderungen verwerfen"
        }).then((save)=>{
            if (save) {
                this.publish().then((_)=>{
                    next();
                });
            } else {
                next();
            }
        });
    }
    mounted() {
        this.load();
    }
    async load() {
        if (isNullOrEmpty(this.name)) {
            return;
        }
        this.state = LoadingState.Loading;
        try {
            let data = await this.menuService.get(this.name);
            this.menu = data.menu;
            this.nodeSchema = data.nodeSchema;
            this.editorFactory = new EditorFactory();
            this.nodes = this.createTreeviewNodes(this.menu);
            this.treeviewConfig.roots = this.menu.nodes.map((n)=>n.id);
            this.state = LoadingState.Results;
        } catch (e) {
            this.notificationService.showError(`Das Menu "${this.name}" konnte nicht geladen werden.`, e);
            this.state = LoadingState.Error;
        }
    }
    async publish() {
        if (this.menu == null) {
            return;
        }
        this.isPublishing = true;
        try {
            this.menu.nodes = this.createMenuNodes(this.nodes, this.rootNodeIds);
            await this.menuService.save(this.menu);
            this.notificationService.showSuccess(`Das Menu "${this.menu.displayName}" wurde erfolgreich publiziert.`);
            this.hasPendingChanges = false;
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError(`Das Menu "${this.menu.displayName}" konnte nicht gespeichert werden.`, e);
            } else {
                throw e;
            }
        } finally{
            this.isPublishing = false;
        }
    }
    async createNode() {
        if (this.menu == null) {
            return;
        }
        let newNode = await this.menuService.createNode({
            menuName: this.menu?.name
        });
        this.nodes[newNode.id] = {
            text: Multilingual.getValue(newNode.title),
            children: [],
            data: newNode
        };
        if (this.selectedNode != null && this.selectedNode.parent != null) {
            let parent = this.nodes[this.selectedNode.parent];
            let index = parent.children.indexOf(this.selectedNode.data.id) + 1;
            parent.children.splice(index, 0, newNode.id);
        } else {
            this.rootNodeIds.push(newNode.id);
        }
        this.hasPendingChanges = true;
        await this.$nextTick();
        this.selectedNode = this.nodes[newNode.id];
    }
    async deleteNode(node) {
        if (this.selectedNode?.id == node.id) {
            this.selectedNode = null;
        }
        await this.$nextTick();
        if (this.rootNodeIds.includes(node.data.id)) {
            this.rootNodeIds = this.rootNodeIds.filter((id)=>id !== node.data.id);
        }
        if (node.parent != null) {
            let parent = this.nodes[node.parent];
            parent.children = parent.children?.filter((id)=>id !== node.data.id);
        }
        delete this.nodes[node.data.id];
        this.hasPendingChanges = true;
    }
    onNodeFocused(node) {
        this.selectedNode = node;
    }
    onNodeDragend(args) {
        args.dragged.node.state.checked = false;
        this.hasPendingChanges = true;
    }
    onNodeDragstart(args) {
        if (args.dragged.node.data.isHome === true) {
            args.evt.preventDefault();
        }
    }
    createTreeviewNodes(menu) {
        let nodes = {};
        convertTreeviewNodesRecursive(menu.nodes, nodes);
        return nodes;
        function convertTreeviewNodesRecursive(menuNodes, nodes) {
            for (let menuNode of menuNodes){
                nodes[menuNode.id] = {
                    text: Multilingual.getValue(menuNode.title),
                    children: menuNode.children.map((n)=>n.id),
                    data: menuNode
                };
                convertTreeviewNodesRecursive(menuNode.children, nodes);
            }
        }
    }
    createMenuNodes(treeviewNodes, rootIds) {
        return rootIds.map((id)=>createMenuNode(treeviewNodes[id]));
        function createMenuNode(treeviewNode) {
            return {
                ...treeviewNode.data,
                children: treeviewNode.children?.map((childId)=>createMenuNode(treeviewNodes[childId])) ?? []
            };
        }
    }
    goBack() {
        this.$router.back();
    }
    constructor(...args){
        super(...args), this.isPublishing = false, this.state = LoadingState.Empty, this.menu = null, this.hasPendingChanges = false, this.treeviewConfig = {
            roots: [],
            dragAndDrop: true,
            closedIcon: {
                type: "shape",
                width: 24,
                height: 24,
                viewBox: "0 0 24 24",
                draw: mdiMenuRight
            },
            openedIcon: {
                type: "shape",
                width: 24,
                height: 24,
                viewBox: "0 0 24 24",
                draw: mdiMenuDown
            }
        }, this.nodes = {}, this.selectedNode = null, this.nodeSchema = null, this.editor = null;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof MenuService === "undefined" ? Object : MenuService)
], MenuEditor.prototype, "menuService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], MenuEditor.prototype, "notificationService", void 0);
_([
    NonReactive,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], MenuEditor.prototype, "editorFactory", void 0);
_([
    Prop(),
    _$1("design:type", String)
], MenuEditor.prototype, "name", void 0);
_([
    Watch(nameof("name")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], MenuEditor.prototype, "onNameChanged", null);
_([
    Watch(nameof("editor"), {
        deep: true
    }),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof EditorNode === "undefined" ? Object : EditorNode
    ]),
    _$1("design:returntype", void 0)
], MenuEditor.prototype, "onEditorChanged", null);
_([
    Watch(nameof("selectedNode")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof ExtendedTreeviewNode === "undefined" ? Object : ExtendedTreeviewNode,
        Object
    ]),
    _$1("design:returntype", Promise)
], MenuEditor.prototype, "onSelectedNodeChanged", null);
_([
    Hook("beforeRouteLeave"),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof RouteLocationNormalized === "undefined" ? Object : RouteLocationNormalized,
        typeof RouteLocationNormalizedLoaded === "undefined" ? Object : RouteLocationNormalizedLoaded,
        typeof NavigationGuardNext === "undefined" ? Object : NavigationGuardNext
    ]),
    _$1("design:returntype", void 0)
], MenuEditor.prototype, "beforeRouteLeave", null);
MenuEditor = _([
    Component({
        render: render$j,
        components: {
            Treeview: Tree,
            EntityEditor
        }
    })
], MenuEditor);

const _hoisted_1$9 = {
  key: 0,
  class: "d-flex flex-column align-center"
};

function render$i(_ctx, _cache) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_alert = resolveComponent("v-alert");
  const _component_v_main = resolveComponent("v-main");
  const _component_v_app = resolveComponent("v-app");

  return (openBlock(), createBlock(_component_v_app, null, {
    default: withCtx(() => [
      createVNode(_component_v_main, { class: "d-flex align-center justify-center pb-16" }, {
        default: withCtx(() => [
          (_ctx.state === 'loading')
            ? (openBlock(), createElementBlock("div", _hoisted_1$9, [
                createVNode(_component_v_progress_circular, {
                  size: 64,
                  color: "primary",
                  indeterminate: ""
                }),
                _cache[0] || (_cache[0] = createElementVNode("p", { class: "text-h6 mt-4" }, "Bitte warten …", -1))
              ]))
            : createCommentVNode("", true),
          (_ctx.state === 'error')
            ? (openBlock(), createBlock(_component_v_alert, {
                key: 1,
                type: "error",
                prominent: "",
                "max-width": "42em"
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_row, { align: "center" }, {
                    default: withCtx(() => [
                      createVNode(_component_v_col, { class: "px-4" }, {
                        default: withCtx(() => [
                          _cache[1] || (_cache[1] = createElementVNode("div", { class: "text-h6" }, "Beim Login ist ein Fehler aufgetreten", -1)),
                          createElementVNode("div", null, toDisplayString(_ctx.errorMessage), 1)
                        ]),
                        _: 1
                      }),
                      createVNode(_component_v_col, { cols: "auto" }, {
                        default: withCtx(() => [
                          createVNode(_component_v_btn, { to: "/" }, {
                            default: withCtx(() => _cache[2] || (_cache[2] = [
                              createTextVNode("Zurück zur App")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

class SigninCallback extends Vue {
    async mounted() {
        try {
            await this.userManager.signinRedirectCallback();
            this.authStore.setCurrentUser(await this.userManager.getUser());
        } catch (e) {
            if (e instanceof Error) {
                // intercept errors most likely caused by stale login urls and retry
                if (e.message === "No state in response" || e.message === "No matching state found in storage") {
                    this.authStore.signin();
                    return;
                }
                this.errorMessage = e.toString();
                this.state = LoadingState.Error;
            }
        }
        this.$router.push({
            name: RouteNames.Root
        });
    }
    constructor(...args){
        super(...args), this.authStore = new AuthenticationModule(), this.state = LoadingState.Loading, this.errorMessage = "";
    }
}
_([
    AutoInject,
    _$1("design:type", typeof UserManager === "undefined" ? Object : UserManager)
], SigninCallback.prototype, "userManager", void 0);
SigninCallback = _([
    Component({
        render: render$i
    })
], SigninCallback);

function render$h(_ctx, _cache) {
  return (openBlock(), createElementBlock("div"))
}

class SilentRenewCallback extends Vue {
    async mounted() {
        await this.userManager.signinSilentCallback();
    }
}
_([
    AutoInject,
    _$1("design:type", typeof UserManager === "undefined" ? Object : UserManager)
], SilentRenewCallback.prototype, "userManager", void 0);
SilentRenewCallback = _([
    Component({
        render: render$h
    })
], SilentRenewCallback);

class SettingsStore extends Pinia {
    constructor(...args){
        super(...args), this.defaultDocumentListView = DocumentListView.Search, this.defaultAssetListView = AssetListView.Search, this.defaultAssetListDisplayMode = AssetDisplayMode.Thumbnails, this.defaultAssetThumbnailResizeMode = ThumbnailResizeMode.Crop;
    }
}
SettingsStore = _([
    Store({
        persist: true
    })
], SettingsStore);

const _hoisted_1$8 = { class: "pt-3 pr-4" };
const _hoisted_2$4 = { class: "scroll-panel pl-4" };
const _hoisted_3$4 = {
  key: 0,
  class: "mr-1"
};
const _hoisted_4$2 = { key: 0 };
const _hoisted_5$2 = { key: 1 };
const _hoisted_6$2 = {
  key: 0,
  class: "mr-1"
};
const _hoisted_7$2 = {
  key: 1,
  class: "mr-1"
};
const _hoisted_8$1 = { key: 0 };

function render$g(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_tag_editor_component = resolveComponent("tag-editor-component");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_define_batch_selection = resolveComponent("define-batch-selection");
  const _component_v_app_bar_title = resolveComponent("v-app-bar-title");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_select = resolveComponent("v-select");
  const _component_tag_list = resolveComponent("tag-list");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_avatar = resolveComponent("v-avatar");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_use_batch_selection = resolveComponent("use-batch-selection");
  const _component_v_chip_group = resolveComponent("v-chip-group");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_document_list_item = resolveComponent("document-list-item");
  const _component_v_virtual_scroll = resolveComponent("v-virtual-scroll");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_router_link = resolveComponent("router-link");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_define_batch_selection, null, {
      default: withCtx(({ entities }) => [
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            withDirectives(createVNode(_component_v_btn, {
              icon: _ctx.$icons.mdiClose,
              onClick: _ctx.selectNone
            }, null, 8, ["icon", "onClick"]), [
              [_directive_tooltip, 'Nichts auswählen', "bottom"]
            ])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_toolbar_title, { class: "ml-0 mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.selectedEntities.size) + " Dokument" + toDisplayString(_ctx.selectedEntities.size > 1 ? "e" : "") + " ausgewählt", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_btn, {
              "prepend-icon": _ctx.$icons.mdiTagMultiple,
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.isBatchTagPaneOpen = true))
            }, {
              default: withCtx(() => _cache[12] || (_cache[12] = [
                createTextVNode("Tags anpassen")
              ])),
              _: 1
            }, 8, ["prepend-icon"]),
            (_ctx.isBatchTagPaneOpen)
              ? (openBlock(), createBlock(_component_property_pane, {
                  key: 0,
                  title: `Tags für ${_ctx.selectedEntities.size} Dokument(e) anpassen`,
                  "is-active": "",
                  onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isBatchTagPaneOpen = false)),
                  "initial-value": { tagsToAdd: [], tagsToRemove: [] },
                  onOk: _cache[2] || (_cache[2] = $event => {_ctx.isBatchTagPaneOpen = false;_ctx.tagSelected($event);})
                }, {
                  default: withCtx(({ value, setValue, ok, cancel }) => [
                    (value != null)
                      ? (openBlock(), createBlock(_component_tag_editor_component, {
                          key: 0,
                          kind: "document",
                          modelValue: value.tagsToAdd,
                          "onUpdate:modelValue": $event => ((value.tagsToAdd) = $event),
                          label: "Diese Tags hinzufügen"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : createCommentVNode("", true),
                    (value != null)
                      ? (openBlock(), createBlock(_component_tag_editor_component, {
                          key: 1,
                          kind: "document",
                          modelValue: value.tagsToRemove,
                          "onUpdate:modelValue": $event => ((value.tagsToRemove) = $event),
                          label: "Diese Tags entfernen"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : createCommentVNode("", true)
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_btn, {
              "prepend-icon": _ctx.$icons.mdiCloudUpload,
              color: "primary",
              onClick: _ctx.publishSelected
            }, {
              default: withCtx(() => _cache[13] || (_cache[13] = [
                createTextVNode("Publizieren")
              ])),
              _: 1
            }, 8, ["prepend-icon", "onClick"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_inline_confirm, {
              component: "v-btn",
              class: "v-btn--contained",
              color: "error",
              onConfirmed: _ctx.deleteSelected
            }, {
              confirm: withCtx(() => _cache[14] || (_cache[14] = [
                createElementVNode("span", null, "Bestätigen", -1)
              ])),
              default: withCtx(() => [
                createVNode(_component_v_icon, { start: "" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.$icons.mdiDelete), 1)
                  ]),
                  _: 1
                }),
                _cache[15] || (_cache[15] = createElementVNode("span", null, "Löschen", -1))
              ]),
              _: 1
            }, 8, ["onConfirmed"])
          ]),
          _: 1
        }),
        createVNode(_component_v_spacer),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            withDirectives(createVNode(_component_v_btn, {
              icon: _ctx.$icons.mdiSelectAll,
              onClick: $event => (_ctx.selectAll(entities))
            }, null, 8, ["icon", "onClick"]), [
              [_directive_tooltip, 'Alle auswählen', "bottom"]
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_app_bar_title, null, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              class: "mr-3",
              icon: _ctx.$icons.mdiTextBoxMultiple
            }, null, 8, ["icon"]),
            _cache[16] || (_cache[16] = createTextVNode("Dokumente"))
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs, null, {
          default: withCtx(() => [
            createVNode(_component_v_tab, {
              exact: "",
              replace: "",
              to: { params: { view: 'search' } }
            }, {
              default: withCtx(() => _cache[17] || (_cache[17] = [
                createTextVNode("Suche")
              ])),
              _: 1
            }),
            createVNode(_component_v_tab, {
              exact: "",
              replace: "",
              to: { params: { view: 'drafts' } }
            }, {
              default: withCtx(() => [
                createVNode(_component_v_badge, {
                  inline: "",
                  content: _ctx.drafts.length
                }, {
                  default: withCtx(() => _cache[18] || (_cache[18] = [
                    createTextVNode("Entwürfe ")
                  ])),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }),
            createVNode(_component_v_tab, {
              exact: "",
              replace: "",
              to: { params: { view: 'recently-changed' } }
            }, {
              default: withCtx(() => [
                createVNode(_component_v_badge, {
                  inline: "",
                  content: _ctx.recentlyChanged.length
                }, {
                  default: withCtx(() => _cache[19] || (_cache[19] = [
                    createTextVNode("Zuletzt geändert ")
                  ])),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    createVNode(_component_v_tabs_window, {
      class: "px-4 fill-height",
      modelValue: _ctx.view,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.view) = $event))
    }, {
      default: withCtx(() => [
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "search"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_row, { class: "fill-height" }, {
              default: withCtx(() => [
                createVNode(_component_v_col, {
                  cols: "5",
                  md: "4",
                  lg: "3",
                  class: "fill-height"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "d-flex flex-column h-100" }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_1$8, [
                          createVNode(_component_v_text_field, {
                            autofocus: "",
                            "hide-details": "",
                            clearable: "",
                            class: "ml-4",
                            placeholder: "Suchen nach…",
                            autocomplete: "off",
                            "onUpdate:modelValue": [
                              _ctx.updateQueryDebounced,
                              _cache[3] || (_cache[3] = $event => ((_ctx.searchText) = $event))
                            ],
                            modelValue: _ctx.searchText
                          }, null, 8, ["onUpdate:modelValue", "modelValue"]),
                          createVNode(_component_v_select, {
                            class: "ml-4 mt-5 document-type-select",
                            label: "Dokument-Typ",
                            items: _ctx.types,
                            modelValue: _ctx.selectedType,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = $event => ((_ctx.selectedType) = $event)),
                              _ctx.updateQuery
                            ]
                          }, {
                            item: withCtx(({ props, item }) => [
                              createVNode(_component_v_list_item, mergeProps(props, {
                                "prepend-avatar": item.value !== null ? _ctx.getIconUrl(item.value) : null,
                                title: item.title
                              }), null, 16, ["prepend-avatar", "title"])
                            ]),
                            selection: withCtx(({ item }) => [
                              createVNode(_component_v_row, {
                                "no-gutters": "",
                                align: "center"
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_v_col, { cols: "auto" }, {
                                    default: withCtx(() => [
                                      (item.value !== null)
                                        ? (openBlock(), createBlock(_component_v_img, {
                                            key: 0,
                                            width: 32,
                                            height: 32,
                                            class: "mr-2",
                                            src: _ctx.getIconUrl(item.value)
                                          }, null, 8, ["src"]))
                                        : (openBlock(), createBlock(_component_v_img, {
                                            key: 1,
                                            width: 1,
                                            height: 32
                                          }))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  createVNode(_component_v_col, null, {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 1
                          }, 8, ["items", "modelValue", "onUpdate:modelValue"])
                        ]),
                        createElementVNode("div", _hoisted_2$4, [
                          createVNode(_component_tag_list, {
                            class: "pr-6",
                            tags: _ctx.tags,
                            modelValue: _ctx.selectedTags,
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = $event => ((_ctx.selectedTags) = $event)),
                              _ctx.updateQuery
                            ]
                          }, null, 8, ["tags", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_col, { class: "h-100 flex-dummy-width w-min-0" }, {
                  default: withCtx(() => [
                    createVNode(_component_loader_wrapper, {
                      state: _ctx.searchState,
                      class: "h-100"
                    }, {
                      empty: withCtx(() => [
                        createVNode(_component_v_row, { class: "pb-16" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { "align-self": "start" }, {
                              default: withCtx(() => [
                                createVNode(_component_v_empty_state, {
                                  size: "192",
                                  title: "Suche ein bestehendes Dokument",
                                  text: "Gib einen Suchbegriff ein oder wähle Tags aus um alle passenden Dokumente zu sehen",
                                  icon: _ctx.$icons.mdiMagnify
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }),
                            (_ctx.canCreate)
                              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                  createVNode(_component_v_col, { cols: "auto" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_divider, {
                                        vertical: "",
                                        class: "h-100"
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  createVNode(_component_v_col, { "align-self": "start" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_empty_state, {
                                        size: "192",
                                        title: "Erstelle ein neues Dokument",
                                        icon: _ctx.$icons.mdiTextBoxPlusOutline
                                      }, {
                                        actions: withCtx(() => [
                                          createVNode(_component_v_btn, {
                                            color: "primary",
                                            "prepend-icon": _ctx.$icons.mdiPlus,
                                            to: "/documents/create"
                                          }, {
                                            default: withCtx(() => _cache[20] || (_cache[20] = [
                                              createTextVNode("Neues Dokument")
                                            ])),
                                            _: 1
                                          }, 8, ["prepend-icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["icon"])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      noresults: withCtx(() => [
                        createVNode(_component_v_empty_state, {
                          size: "192",
                          title: "Keine Resultate",
                          icon: _ctx.$icons.mdiTextBoxSearch,
                          class: "mb-16"
                        }, {
                          text: withCtx(() => [
                            (_ctx.searchText)
                              ? (openBlock(), createElementBlock("span", _hoisted_3$4, [
                                  _cache[21] || (_cache[21] = createTextVNode("Mit dem Suchtext ")),
                                  createElementVNode("strong", null, toDisplayString(_ctx.searchText), 1)
                                ]))
                              : createCommentVNode("", true),
                            (_ctx.selectedType)
                              ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                  (!_ctx.searchText)
                                    ? (openBlock(), createElementBlock("span", _hoisted_4$2, "Mit dem Dokument-Typ "))
                                    : (openBlock(), createElementBlock("span", _hoisted_5$2, "und dem Dokument-Typ ")),
                                  createVNode(_component_v_avatar, {
                                    tile: "",
                                    size: "32"
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_img, {
                                        src: _ctx.getIconUrl(_ctx.selectedType)
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 1
                                  }),
                                  createElementVNode("strong", null, toDisplayString(_ctx.getFriendlyDocumentType(_ctx.selectedType)), 1)
                                ], 64))
                              : createCommentVNode("", true),
                            (_ctx.selectedTags.length)
                              ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                                  (_ctx.searchText || _ctx.selectedType)
                                    ? (openBlock(), createElementBlock("span", _hoisted_6$2, "in Kombination mit den Tags"))
                                    : (openBlock(), createElementBlock("span", _hoisted_7$2, "Mit den Tags")),
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedTags, (tag) => {
                                    return (openBlock(), createBlock(_component_v_chip, {
                                      label: "",
                                      small: "",
                                      class: "mr-1"
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(tag), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 256))
                                ], 64))
                              : createCommentVNode("", true),
                            _cache[22] || (_cache[22] = createElementVNode("span", null, "wurden keine Dokumente gefunden.", -1))
                          ]),
                          actions: withCtx(() => [
                            createVNode(_component_v_btn, {
                              class: "mt-3",
                              color: "primary",
                              "prepend-icon": _ctx.$icons.mdiFilterRemove,
                              onClick: _ctx.clearFilter
                            }, {
                              default: withCtx(() => _cache[23] || (_cache[23] = [
                                createTextVNode("Filter löschen")
                              ])),
                              _: 1
                            }, 8, ["prepend-icon", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["icon"])
                      ]),
                      default: withCtx(() => [
                        createVNode(_component_v_card, { class: "d-flex flex-column h-max-100" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_toolbar, {
                              density: "comfortable",
                              color: "surface"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: withCtx(() => [
                                    (_ctx.batchSelectionActive)
                                      ? (openBlock(), createBlock(_component_use_batch_selection, {
                                          key: 0,
                                          entities: _ctx.documents
                                        }, null, 8, ["entities"]))
                                      : (_ctx.searchState === 'results')
                                        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                createVNode(_component_v_toolbar_title, null, {
                                                  default: withCtx(() => [
                                                    _cache[24] || (_cache[24] = createElementVNode("span", { class: "font-weight-regular" }, "Suche nach", -1)),
                                                    _cache[25] || (_cache[25] = createTextVNode()),
                                                    (_ctx.searchText != '')
                                                      ? (openBlock(), createElementBlock("strong", _hoisted_8$1, "«" + toDisplayString(_ctx.searchText) + "»", 1))
                                                      : createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                createVNode(_component_v_chip_group, {
                                                  multiple: "",
                                                  class: "ml-3"
                                                }, {
                                                  default: withCtx(() => [
                                                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedTags, (tag) => {
                                                      return (openBlock(), createBlock(_component_v_chip, {
                                                        label: "",
                                                        closable: "",
                                                        "onClick:close": $event => (_ctx.deselectTag(tag))
                                                      }, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(tag), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick:close"]))
                                                    }), 256))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.selectedType != null)
                                              ? (openBlock(), createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "auto"
                                                }, {
                                                  default: withCtx(() => [
                                                    createVNode(_component_v_avatar, {
                                                      tile: "",
                                                      size: "32"
                                                    }, {
                                                      default: withCtx(() => [
                                                        createVNode(_component_v_img, {
                                                          src: _ctx.getIconUrl(_ctx.selectedType)
                                                        }, null, 8, ["src"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    createTextVNode(" " + toDisplayString(_ctx.getFriendlyDocumentType(_ctx.selectedType)), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : createCommentVNode("", true),
                                            createVNode(_component_v_spacer),
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                withDirectives(createVNode(_component_v_btn, {
                                                  icon: _ctx.$icons.mdiSelectAll,
                                                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.selectAll(_ctx.documents)))
                                                }, null, 8, ["icon"]), [
                                                  [_directive_tooltip, 'Alle auswählen', "bottom"]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_divider),
                            createVNode(_component_v_virtual_scroll, {
                              class: "entity-list__virtual-scroll",
                              items: _ctx.documents,
                              "item-height": 88,
                              bench: "2"
                            }, {
                              default: withCtx(({ item: document, index }) => [
                                (index > 0)
                                  ? (openBlock(), createBlock(_component_v_divider, {
                                      key: 0,
                                      inset: ""
                                    }))
                                  : createCommentVNode("", true),
                                createVNode(_component_document_list_item, {
                                  "show-publish-status": "",
                                  document: document,
                                  isSelected: _ctx.isSelected(document.id),
                                  onDelete: _ctx.deleteDocument,
                                  onDuplicate: _ctx.duplicateDocument,
                                  onPublish: _ctx.publishDocument,
                                  onUnpublish: _ctx.unpublishDocument,
                                  onDiscardDraft: _ctx.discardDraft,
                                  onOpenEditor: _ctx.openEditor,
                                  onToggleSelection: _ctx.toggleSelection
                                }, null, 8, ["document", "isSelected", "onDelete", "onDuplicate", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                              ]),
                              _: 1
                            }, 8, ["items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["state"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "drafts"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_container, { class: "h-100 v-container--limited-width" }, {
              default: withCtx(() => [
                createVNode(_component_loader_wrapper, {
                  state: _ctx.draftsState,
                  class: "h-100"
                }, {
                  empty: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Entwürfe vorhanden",
                      text: "Es gibt keine Dokumente mit Entwurf-Status.",
                      icon: _ctx.$icons.mdiTextBoxSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  noresults: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Entwürfe vorhanden",
                      text: "Es gibt keine Dokumente mit Entwurf-Status.",
                      icon: _ctx.$icons.mdiTextBoxSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "d-flex flex-column h-max-100 rounded-b-0" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_toolbar, {
                          density: "comfortable",
                          color: "surface"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_row, {
                              "no-gutters": "",
                              align: "center"
                            }, {
                              default: withCtx(() => [
                                (_ctx.batchSelectionActive)
                                  ? (openBlock(), createBlock(_component_use_batch_selection, {
                                      key: 0,
                                      entities: _ctx.drafts
                                    }, null, 8, ["entities"]))
                                  : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                      createVNode(_component_v_spacer),
                                      createVNode(_component_v_col, { cols: "auto" }, {
                                        default: withCtx(() => [
                                          withDirectives(createVNode(_component_v_btn, {
                                            icon: _ctx.$icons.mdiSelectAll,
                                            onClick: _cache[7] || (_cache[7] = $event => (_ctx.selectAll(_ctx.drafts)))
                                          }, null, 8, ["icon"]), [
                                            [_directive_tooltip, 'Alle auswählen', "bottom"]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        createVNode(_component_v_divider),
                        createVNode(_component_v_virtual_scroll, {
                          class: "entity-list__virtual-scroll",
                          items: _ctx.drafts,
                          "item-height": 88,
                          bench: "2"
                        }, {
                          default: withCtx(({ item: document, index }) => [
                            (index > 0)
                              ? (openBlock(), createBlock(_component_v_divider, {
                                  key: 0,
                                  inset: ""
                                }))
                              : createCommentVNode("", true),
                            createVNode(_component_document_list_item, {
                              "show-publish-status": "",
                              document: document,
                              isSelected: _ctx.isSelected(document.id),
                              onDelete: _ctx.deleteDocument,
                              onDuplicate: _ctx.duplicateDocument,
                              onPublish: _ctx.publishDocument,
                              onUnpublish: _ctx.unpublishDocument,
                              onDiscardDraft: _ctx.discardDraft,
                              onOpenEditor: _ctx.openEditor,
                              onToggleSelection: _ctx.toggleSelection
                            }, null, 8, ["document", "isSelected", "onDelete", "onDuplicate", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                          ]),
                          _: 1
                        }, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "recently-changed"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_container, { class: "h-100 v-container--limited-width" }, {
              default: withCtx(() => [
                createVNode(_component_loader_wrapper, {
                  state: _ctx.recentlyChangedState,
                  class: "h-100"
                }, {
                  empty: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Dokumente vorhanden",
                      icon: _ctx.$icons.mdiTextBoxSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  noresults: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Dokumente vorhanden",
                      icon: _ctx.$icons.mdiTextBoxSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "d-flex flex-column h-max-100 rounded-b-0" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_toolbar, {
                          density: "comfortable",
                          color: "surface"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_row, {
                              "no-gutters": "",
                              align: "center"
                            }, {
                              default: withCtx(() => [
                                (_ctx.batchSelectionActive)
                                  ? (openBlock(), createBlock(_component_use_batch_selection, {
                                      key: 0,
                                      entities: _ctx.recentlyChanged
                                    }, null, 8, ["entities"]))
                                  : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                      createVNode(_component_v_spacer),
                                      createVNode(_component_v_col, { cols: "auto" }, {
                                        default: withCtx(() => [
                                          withDirectives(createVNode(_component_v_btn, {
                                            icon: _ctx.$icons.mdiSelectAll,
                                            onClick: _cache[8] || (_cache[8] = $event => (_ctx.selectAll(_ctx.recentlyChanged)))
                                          }, null, 8, ["icon"]), [
                                            [_directive_tooltip, 'Alle auswählen', "bottom"]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        createVNode(_component_v_divider),
                        createVNode(_component_v_virtual_scroll, {
                          class: "entity-list__virtual-scroll",
                          items: _ctx.recentlyChanged,
                          "item-height": 88,
                          bench: "2"
                        }, {
                          default: withCtx(({ item: document, index }) => [
                            (index > 0)
                              ? (openBlock(), createBlock(_component_v_divider, {
                                  key: 0,
                                  inset: ""
                                }))
                              : createCommentVNode("", true),
                            createVNode(_component_document_list_item, {
                              "show-publish-status": "",
                              document: document,
                              isSelected: _ctx.isSelected(document.id),
                              onDelete: _ctx.deleteDocument,
                              onDuplicate: _ctx.duplicateDocument,
                              onPublish: _ctx.publishDocument,
                              onUnpublish: _ctx.unpublishDocument,
                              onDiscardDraft: _ctx.discardDraft,
                              onOpenEditor: _ctx.openEditor,
                              onToggleSelection: _ctx.toggleSelection
                            }, null, 8, ["document", "isSelected", "onDelete", "onDuplicate", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                          ]),
                          _: 1
                        }, 8, ["items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.canCreate)
      ? (openBlock(), createBlock(_component_v_fab, {
          key: 0,
          app: "",
          location: "bottom right",
          color: "primary",
          size: "x-large",
          icon: _ctx.$icons.mdiPlus,
          to: "/documents/create"
        }, null, 8, ["icon"]))
      : createCommentVNode("", true),
    createVNode(_component_v_dialog, {
      persistent: "",
      "max-width": 480,
      modelValue: _ctx.deleteInUseConfirmationDialogCallback != null
    }, {
      default: withCtx(() => [
        createVNode(_component_v_card, null, {
          default: withCtx(() => [
            createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: withCtx(() => _cache[26] || (_cache[26] = [
                createTextVNode("Dieses Dokument ist in Benutzung")
              ])),
              _: 1
            }),
            createVNode(_component_v_card_text, null, {
              default: withCtx(() => [
                _cache[27] || (_cache[27] = createElementVNode("p", null, "Dieses Dokument wird aus folgenden Dokument referenziert:", -1)),
                createElementVNode("ul", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.deleteInUseReferences, (item) => {
                    return (openBlock(), createElementBlock("li", null, [
                      createVNode(_component_router_link, {
                        to: { name: _ctx.routeNames.Documents.Edit, params: { id: item.id }},
                        target: "_blank"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$formatters.multilingual(item.displayName)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            createVNode(_component_v_card_actions, null, {
              default: withCtx(() => [
                createVNode(_component_v_spacer),
                createVNode(_component_v_btn, {
                  text: "",
                  onClick: _cache[10] || (_cache[10] = $event => (_ctx.deleteInUseConfirmationDialogCallback(false)))
                }, {
                  default: withCtx(() => _cache[28] || (_cache[28] = [
                    createTextVNode("Abbrechen")
                  ])),
                  _: 1
                }),
                createVNode(_component_v_btn, {
                  color: "warning",
                  onClick: _cache[11] || (_cache[11] = $event => (_ctx.deleteInUseConfirmationDialogCallback(true)))
                }, {
                  default: withCtx(() => _cache[29] || (_cache[29] = [
                    createTextVNode("Trotzdem löschen")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}

IconRegistry.add({
    mdiPlus,
    mdiMagnify,
    mdiTextBoxPlusOutline,
    mdiTextBoxMultiple,
    mdiFilterRemove,
    mdiTextBoxSearch,
    mdiClose
});
const [DefineBatchSelection$1, UseBatchSelection$1] = createReusableTemplate();
class DocumentList extends Vue {
    get routeNames() {
        return RouteNames;
    }
    get canCreate() {
        return this.configStore.configuration.permissions.documents.canCreateAny;
    }
    get tags() {
        return this.documentStore.tags;
    }
    get types() {
        let all = {
            title: "Alle",
            value: null
        };
        let readableTypes = this.documentStore.types.filter((t)=>t.canRead);
        return [
            all
        ].concat(readableTypes.map((t)=>({
                title: t.title,
                value: t.type
            })));
    }
    get hasQuery() {
        return !isNullOrEmpty(this.searchText) || this.selectedTags.length !== 0 || !isNullOrEmpty(this.selectedType);
    }
    get batchSelectionActive() {
        return this.selectionChangeTrackingProxy > 0 && this.selectedEntities.size > 0;
    }
    created() {
        this.onRouteChanged();
        this.documentStore.loadTags();
        this.documentStore.loadTypes();
        this.loadDrafts();
        this.loadRecentlyChanged();
    }
    onRouteChanged() {
        this.selectedTags = parseArrayFromQuery(this.$route.query["tags"]);
        this.searchText = this.$route.query["q"] || "";
        this.selectedType = this.$route.query["type"] || null;
        this.search();
    }
    async onViewChanged() {
        this.selectNone();
        switch(this.view){
            case "drafts":
                await this.loadDrafts();
                break;
            case "recently-changed":
                await this.loadRecentlyChanged();
                break;
        }
    }
    async refresh() {
        this.selectNone();
        await this.loadDrafts();
        await this.loadRecentlyChanged();
        await this.search();
    }
    updateQuery() {
        let query = {
            tags: this.selectedTags
        };
        if (!isNullOrEmpty(this.selectedType)) {
            query.type = this.selectedType;
        }
        if (!isNullOrEmpty(this.searchText)) {
            query.q = this.searchText;
        }
        this.$router.replace({
            query
        });
    }
    clearFilter() {
        this.$router.replace({
            query: undefined
        });
    }
    deselectTag(tag) {
        let index = this.selectedTags.indexOf(tag);
        if (index > -1) {
            this.selectedTags.splice(index, 1);
            this.updateQuery();
        }
    }
    async search() {
        let params = {
            query: this.searchText,
            tags: this.selectedTags,
            type: this.selectedType || undefined,
            includeDrafts: true
        };
        if (!this.hasQuery) {
            this.documents = [];
            this.searchState = LoadingState.Empty;
            return;
        }
        try {
            this.searchState = LoadingState.Loading;
            this.documents = await this.documentService.search(params);
            if (this.documents.length === 0) {
                this.searchState = LoadingState.NoResults;
            } else {
                this.searchState = LoadingState.Results;
            }
        } catch (e) {
            this.notificationService.showError(`Die Liste der Dokumente konnte nicht geladen werden.`, e);
            this.searchState = LoadingState.Error;
        }
    }
    async loadDrafts() {
        try {
            this.draftsState = LoadingState.Loading;
            this.drafts = await this.documentService.getDrafts(25);
            this.draftsState = this.drafts.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } catch (e) {
            this.notificationService.showError("Die Entwürfe konnten nicht geladen werden.", e);
            this.draftsState = LoadingState.Error;
        }
    }
    async loadRecentlyChanged() {
        try {
            this.recentlyChangedState = LoadingState.Loading;
            this.recentlyChanged = await this.documentService.getRecent(DateTime.now().minus({
                days: 90
            }), 25);
            this.recentlyChangedState = this.recentlyChanged.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } catch (e) {
            this.notificationService.showError("Die zuletzt geänderten Dokumente konnten nicht geladen werden.", e);
            this.recentlyChangedState = LoadingState.Error;
        }
    }
    openEditor(args) {
        if (this.batchSelectionActive) {
            let document = this.documents.find((d)=>d.id === args.id);
            if (document != null) {
                this.toggleSelection({
                    id: args.id,
                    isDraft: document.isDraft
                });
            }
        } else {
            this.$router.push({
                name: RouteNames.Documents.Edit,
                params: {
                    id: args.id
                }
            });
        }
    }
    async discardDraft(args) {
        try {
            await this.documentService.discardDraft(args.id);
            if (typeof args.callback === "function") {
                args.callback();
            }
        } catch (e) {
            this.notificationService.showError(`Der Entwurf <em>${args.name}</em> konnte nicht verworfen werden.`, e);
        }
        await this.refresh();
    }
    async deleteDocument(args) {
        try {
            this.deleteInUseReferences = await this.documentService.getReferences(args.id);
            if (this.deleteInUseReferences.length > 0) {
                let dialogPromise = await new Promise((resolve)=>{
                    this.deleteInUseConfirmationDialogCallback = resolve;
                });
                if (!dialogPromise) {
                    this.deleteInUseConfirmationDialogCallback = null;
                    return;
                }
            }
            await this.documentService.delete(args.id);
            this.notificationService.showSuccess(`Das Dokument <em>${args.name}</em> wurde gelöscht.`);
        } catch (e) {
            this.notificationService.showError(`Das Dokument <em>${args.name}</em> konnte nicht gelöscht werden.`, e);
        } finally{
            this.deleteInUseConfirmationDialogCallback = null;
        }
        await this.refresh();
    }
    async publishDocument(args) {
        try {
            await this.documentService.publish(args.id);
            this.notificationService.showSuccess(`Das Dokument <em>${args.name}</em> wurde publiziert.`);
        } catch (e) {
            this.notificationService.showError(`Das Dokument <em>${args.name}</em> konnte nicht publiziert werden.`, e);
        }
        await this.refresh();
    }
    async unpublishDocument(args) {
        try {
            await this.documentService.unpublish(args.id);
            this.notificationService.showSuccess(`Das Dokument <em>${args.name}</em> wurde unpubliziert.`);
        } catch (e) {
            this.notificationService.showError(`Das Dokument <em>${args.name}</em> konnte nicht unpubliziert werden.`, e);
        }
        await this.refresh();
    }
    async duplicateDocument(args) {
        try {
            let response = await this.documentService.createDuplicate(args.id);
            let targetUrl = this.$router.resolve({
                name: RouteNames.Documents.Edit,
                params: {
                    id: response.id
                }
            }).href;
            this.notificationService.showSuccess(`Das Dokument <em>${args.name}</em> wurde dupliziert. <a class="white--text" href="${targetUrl}">Neues Dokument öffnen</a>`);
        } catch (e) {
            this.notificationService.showError(`Das Dokument <em>${args.name}</em> konnte nicht dupliziert werden.`, e);
        }
        await this.refresh();
    }
    toggleSelection(args) {
        if (this.selectedEntities.has(args.id)) {
            this.selectedEntities.delete(args.id);
        } else {
            this.selectedEntities.set(args.id, args);
        }
        this.selectionChangeTrackingProxy++;
    }
    selectAll(entities) {
        for (let document of entities){
            this.selectedEntities.set(document.id, {
                id: document.id,
                isDraft: document.isDraft
            });
        }
        this.selectionChangeTrackingProxy++;
    }
    selectNone() {
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
    }
    isSelected(id) {
        return this.selectionChangeTrackingProxy > 0 && this.selectedEntities.has(id);
    }
    async tagSelected(args) {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.documentService.batchUpdateTags(ids, args.tagsToAdd, args.tagsToRemove);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Dokumente wurden getaggt.");
            } else {
                this.notificationService.showError("Einige Dokumente konnten nicht getaggt werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Taggen der Dokumente ist ein Fehler aufgetreten.", e);
            this.searchState = LoadingState.Error;
        }
        await this.documentStore.loadTags();
        await this.refresh();
    }
    async deleteSelected() {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.documentService.batchDelete(ids);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Dokumente wurden gelöscht.");
            } else {
                this.notificationService.showError("Einige Dokumente konnten nicht gelöscht werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Löschen der Dokumente ist ein Fehler aufgetreten.", e);
            this.searchState = LoadingState.Error;
        }
        await this.documentStore.loadTags();
        await this.refresh();
    }
    async publishSelected() {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.documentService.batchPublish(ids);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Dokumente wurden publiziert.");
            } else {
                this.notificationService.showError("Einige Dokumente konnten nicht publiziert werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Publizieren der Dokumente ist ein Fehler aufgetreten.", e);
            this.searchState = LoadingState.Error;
        }
        await this.refresh();
    }
    getIconUrl(type) {
        return getDocumentTypeIconSvg(type, 32);
    }
    getFriendlyDocumentType(type) {
        return this.documentStore.types?.find((t)=>t.type === type)?.title ?? "";
    }
    constructor(...args){
        super(...args), this.documentStore = new DocumentModule(), this.configStore = new ConfigurationModule(), this.settingsStore = new SettingsStore(), this.searchState = LoadingState.Empty, this.selectedTags = [], this.selectedType = null, this.searchText = "", this.documents = [], this.draftsState = LoadingState.Empty, this.drafts = [], this.recentlyChangedState = LoadingState.Empty, this.recentlyChanged = [], this.selectionChangeTrackingProxy = 1, this.selectedEntities = new Map(), this.batchUpdateTagsToAdd = [], this.batchUpdateTagsToRemove = [], this.isBatchTagPaneOpen = false, this.deleteInUseReferences = [], this.deleteInUseConfirmationDialogCallback = null, this.updateQueryDebounced = debounce$1(this.updateQuery, 500);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], DocumentList.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], DocumentList.prototype, "documentService", void 0);
_([
    Prop({
        type: String
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.DocumentListView === "undefined" ? Object : Models.DocumentListView)
], DocumentList.prototype, "view", void 0);
_([
    Watch(nameof("$route")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], DocumentList.prototype, "onRouteChanged", null);
_([
    Watch(nameof("view")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", Promise)
], DocumentList.prototype, "onViewChanged", null);
DocumentList = _([
    Component({
        render: render$g,
        components: {
            DocumentListItem,
            DefineBatchSelection: DefineBatchSelection$1,
            UseBatchSelection: UseBatchSelection$1
        }
    })
], DocumentList);

const _hoisted_1$7 = { class: "h-100 scroll-panel" };
const _hoisted_2$3 = { class: "px-4" };
const _hoisted_3$3 = { key: 0 };

function render$f(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_app_bar_title = resolveComponent("v-app-bar-title");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_tooltip, {
          location: "bottom",
          text: "Zurück"
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_btn, mergeProps(props, {
              icon: "",
              onClick: _ctx.back
            }), {
              default: withCtx(() => [
                createVNode(_component_v_icon, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.$icons.mdiArrowLeft), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040, ["onClick"])
          ]),
          _: 1
        }),
        createVNode(_component_v_app_bar_title, null, {
          default: withCtx(() => _cache[0] || (_cache[0] = [
            createTextVNode("Neues Dokument erstellen")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_loader_wrapper, {
      class: "h-100",
      state: _ctx.state
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$7, [
          createElementVNode("div", _hoisted_2$3, [
            createVNode(_component_v_row, null, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.types, (item) => {
                  return (openBlock(), createBlock(_component_v_col, {
                    cols: "6",
                    md: "4",
                    lg: "2",
                    key: item.type
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_card, {
                        class: "d-flex flex-column justify-space-between",
                        onClick: $event => (_ctx.create(item)),
                        disabled: item.isSingleton && item.singletonExists
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_v_img, {
                            src: _ctx.getIconUrl(item),
                            "aspect-ratio": "2",
                            contain: "",
                            class: "mt-3"
                          }, null, 8, ["src"]),
                          createVNode(_component_v_card_title, {
                            class: normalizeClass({'text-align-center': item.description == '' })
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          createVNode(_component_v_card_text, null, {
                            default: withCtx(() => [
                              createElementVNode("div", null, toDisplayString(item.description), 1),
                              (item.singletonExists && item.isSingleton)
                                ? (openBlock(), createElementBlock("div", _hoisted_3$3, "Dieser Dokumenttyp kann nur einmal erstellt werden. Ein Dokument dieses Typs existiert bereits."))
                                : createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ], 64))
}

IconRegistry.add({
    mdiArrowLeft
});
class DocumentCreate extends Vue {
    created() {
        this.loadTypes();
    }
    back() {
        this.$router.back();
    }
    async loadTypes() {
        this.state = LoadingState.Loading;
        try {
            let types = await this.documentService.loadTypes();
            this.types = orderBy(types.filter((t)=>t.canCreate), [
                "isSingleton",
                "title"
            ]);
            this.state = LoadingState.Results;
        } catch (ex) {
            this.state = LoadingState.Error;
        }
    }
    async create(item) {
        this.state = LoadingState.Loading;
        try {
            let { id } = await this.documentService.create(item.type);
            this.$router.replace({
                name: RouteNames.Documents.Edit,
                params: {
                    id,
                    isDraft: true.toString()
                }
            });
        } catch (e) {
            this.state = LoadingState.Error;
            if (e instanceof HTTPError) {
                this.notificationService.showError("Das Dokument konnte nicht erstellt werden.");
            } else {
                throw e;
            }
        }
    }
    getIconUrl(item) {
        return getDocumentTypeIconSvg(item.type, 64);
    }
    constructor(...args){
        super(...args), this.state = LoadingState.Empty, this.types = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], DocumentCreate.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], DocumentCreate.prototype, "documentService", void 0);
DocumentCreate = _([
    Component({
        render: render$f,
        components: {
            LoaderWrapper
        }
    })
], DocumentCreate);

const _hoisted_1$6 = { class: "text--black" };

function render$e(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_list_item_title = resolveComponent("v-list-item-title");
  const _component_v_list_item_subtitle = resolveComponent("v-list-item-subtitle");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_entity_editor = resolveComponent("entity-editor");

  return (openBlock(), createBlock(_component_entity_editor, {
    "active-group": _ctx.activeGroup,
    title: _ctx.title,
    modelValue: _ctx.rootNode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.hasPendingChanges = true))
  }, {
    toolbar: withCtx(({ editor }) => [
      createVNode(_component_v_menu, {
        left: "",
        "offset-y": "",
        "close-on-content-click": false,
        "nudge-width": 200
      }, {
        activator: withCtx(({ on: menu }) => [
          createVNode(_component_v_tooltip, { location: "bottom" }, {
            activator: withCtx(({ on: tooltip }) => [
              createVNode(_component_v_btn, mergeProps({
                icon: "",
                color: editor.hasErrors ? 'warning' : 'default',
                disabled: !editor.hasErrors
              }, toHandlers({ ...tooltip, ...menu })), {
                default: withCtx(() => [
                  createVNode(_component_v_badge, { overlap: "" }, {
                    badge: withCtx(() => [
                      createElementVNode("span", _hoisted_1$6, toDisplayString(editor.errors.length), 1)
                    ]),
                    default: withCtx(() => [
                      createVNode(_component_v_icon, null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$icons.mdiAlert), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1040, ["color", "disabled"])
            ]),
            default: withCtx(() => [
              _cache[1] || (_cache[1] = createElementVNode("span", null, "Fehler", -1))
            ]),
            _: 2
          }, 1024)
        ]),
        default: withCtx(() => [
          createVNode(_component_v_list, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(editor.errors, (item) => {
                return (openBlock(), createBlock(_component_v_list_item, {
                  onClick: $event => (editor.activateNode(item.node))
                }, {
                  prepend: withCtx(() => [
                    createVNode(_component_v_icon, { color: "warning" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(_ctx.$icons.mdiAlert), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_list_item_title, null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(item.node.schema.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(_component_v_list_item_subtitle, null, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(item.error.message), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 256))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024),
      createVNode(_component_v_divider, {
        vertical: "",
        inset: "",
        class: "mx-2"
      }),
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: $event => (editor.undo()),
            disabled: !editor.canUndo
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiUndo), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["onClick", "disabled"])
        ]),
        default: withCtx(() => [
          _cache[2] || (_cache[2] = createElementVNode("span", null, "Rückgängig", -1))
        ]),
        _: 2
      }, 1024),
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: $event => (editor.redo()),
            disabled: !editor.canRedo
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiRedo), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["onClick", "disabled"])
        ]),
        default: withCtx(() => [
          _cache[3] || (_cache[3] = createElementVNode("span", null, "Wiederholen", -1))
        ]),
        _: 2
      }, 1024),
      createVNode(_component_v_divider, {
        vertical: "",
        inset: "",
        class: "mx-2"
      }),
      (_ctx.showSaveAndPublish)
        ? (openBlock(), createBlock(_component_v_tooltip, {
            key: 0,
            location: "bottom"
          }, {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_btn, mergeProps({
                icon: "",
                onClick: _ctx.saveDraft,
                loading: _ctx.isSaving
              }, props), {
                default: withCtx(() => [
                  createVNode(_component_v_icon, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$icons.mdiContentSave), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040, ["onClick", "loading"])
            ]),
            default: withCtx(() => [
              _cache[4] || (_cache[4] = createElementVNode("span", null, "Entwurf speichern", -1))
            ]),
            _: 1
          }))
        : createCommentVNode("", true)
    ]),
    fab: withCtx((editor) => [
      (_ctx.showSaveAndPublish)
        ? (openBlock(), createBlock(_component_v_tooltip, {
            key: 0,
            location: "bottom"
          }, {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_fab, mergeProps({
                absolute: "",
                offset: "",
                class: ["flex-grow-0", "mr-4"],
                location: "bottom right",
                color: "primary",
                size: "large",
                icon: _ctx.$icons.mdiCloudUpload,
                onClick: _ctx.publish,
                loading: _ctx.isPublishing
              }, props), null, 16, ["icon", "onClick", "loading"])
            ]),
            default: withCtx(() => [
              _cache[5] || (_cache[5] = createElementVNode("span", null, "Publizieren", -1))
            ]),
            _: 1
          }))
        : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["active-group", "title", "modelValue"]))
}

IconRegistry.add({
    mdiAlert,
    mdiUndo,
    mdiRedo,
    mdiContentSave,
    mdiCloudUpload
});
class DocumentEditor extends Vue {
    onIdChanged() {
        this.load();
    }
    beforeRouteLeave(to, from, next) {
        if (!this.hasPendingChanges) {
            next();
            return;
        }
        if (this.isDraft) {
            this.saveDraft().then((saved)=>{
                if (saved) {
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$confirm({
                title: "Änderungen speichern?",
                textHtml: "Möchten Sie die Änderungen am Dokument in einem neuen Entwurf speichern?",
                confirmLabel: "Speichern",
                cancelLabel: "Änderungen verwerfen"
            }).then((save)=>{
                if (save) {
                    this.saveDraft().then((saved)=>{
                        if (saved) {
                            next();
                        } else {
                            next(false);
                        }
                    });
                } else {
                    next();
                }
            });
        }
    }
    mounted() {
        this.load();
    }
    async load() {
        this.loadingState = LoadingState.Loading;
        try {
            let response = await this.service.getDraftOrPublished(this.id);
            this.isDraft = response.document.isDraft;
            await this.setDocument(response);
            this.showSaveAndPublish = response.canUpdate;
            this.showDelete = response.canDelete;
            this.loadingState = LoadingState.Results;
        } catch (e) {
            this.loadingState = LoadingState.Error;
            this.notificationService.showError("Das Dokument konnte nicht geöffnet werden.", e);
        }
    }
    async saveDraft() {
        if (this.rootNode == null) {
            return true;
        }
        this.isSaving = true;
        try {
            if (!this.isDraft) {
                // if this is not a draft, we need to create one before saving.
                // we shouldn't get 409 Conflict because we handled the scenario of "draft 
                // already exists but we opened the published doc" before opening the editor
                await this.service.createDraft(this.id);
                this.isDraft = true;
            }
            let response = await this.service.saveDraft(this.id, this.rootNode.model);
            await this.setDocument(response);
            this.hasPendingChanges = false;
            return true;
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError("Das Dokument konnte nicht gespeichert werden.", e);
            } else {
                throw e;
            }
            return false;
        } finally{
            this.isSaving = false;
        }
    }
    async publish() {
        if (this.rootNode == null) {
            return;
        }
        this.isPublishing = true;
        try {
            await this.saveDraft();
            await this.service.publish(this.id);
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError("Das Dokument konnte nicht publiziert werden.", e);
            } else {
                throw e;
            }
        } finally{
            this.isPublishing = false;
        }
    }
    async setDocument(response) {
        if (this.rootNode != null) {
            // TODO: implement editor re-initialization properly
            // we just deactivate this functionality for now
            return;
        }
        this.rootNode = await this.editorFactory.createRoot(response.schema, response.document);
        this.title = Multilingual.getValue(response.document.displayName);
    }
    constructor(...args){
        super(...args), this.editorFactory = new EditorFactory(), this.loadingState = LoadingState.Empty, this.isDraft = true, this.isSaving = false, this.isPublishing = false, this.hasPendingChanges = false, this.title = "", this.rootNode = null, this.showDelete = false, this.showSaveAndPublish = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof DocumentService === "undefined" ? Object : DocumentService)
], DocumentEditor.prototype, "service", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], DocumentEditor.prototype, "notificationService", void 0);
_([
    Prop({
        required: true
    }),
    _$1("design:type", typeof Id === "undefined" ? Object : Id)
], DocumentEditor.prototype, "id", void 0);
_([
    Prop(),
    _$1("design:type", String)
], DocumentEditor.prototype, "activeGroup", void 0);
_([
    Watch(nameof("id")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], DocumentEditor.prototype, "onIdChanged", null);
_([
    Hook("beforeRouteLeave"),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof RouteLocationNormalized === "undefined" ? Object : RouteLocationNormalized,
        typeof RouteLocationNormalizedLoaded === "undefined" ? Object : RouteLocationNormalizedLoaded,
        typeof NavigationGuardNext === "undefined" ? Object : NavigationGuardNext
    ]),
    _$1("design:returntype", void 0)
], DocumentEditor.prototype, "beforeRouteLeave", null);
DocumentEditor = _([
    Component({
        render: render$e,
        components: {
            EntityEditor
        }
    })
], DocumentEditor);

const _hoisted_1$5 = { class: "pt-3 pr-4" };
const _hoisted_2$2 = { class: "scroll-panel pl-4" };
const _hoisted_3$2 = {
  key: 0,
  class: "mr-1"
};
const _hoisted_4$1 = {
  key: 1,
  class: "mr-1"
};
const _hoisted_5$1 = {
  key: 2,
  class: "mr-1"
};
const _hoisted_6$1 = {
  key: 0,
  class: "mr-1"
};
const _hoisted_7$1 = {
  key: 1,
  class: "mr-1"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "overflow-clip mb-1" };
const _hoisted_10 = { class: "flex-grow-1 scroll-panel" };
const _hoisted_11 = { class: "flex-grow-1 scroll-panel" };
const _hoisted_12 = { class: "h-100 pa-2 scroll-panel" };

function render$d(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_tag_editor_component = resolveComponent("tag-editor-component");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_define_batch_selection = resolveComponent("define-batch-selection");
  const _component_v_app_bar_title = resolveComponent("v-app-bar-title");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_btn_toggle = resolveComponent("v-btn-toggle");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_select = resolveComponent("v-select");
  const _component_tag_list = resolveComponent("tag-list");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_use_batch_selection = resolveComponent("use-batch-selection");
  const _component_v_chip_group = resolveComponent("v-chip-group");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_asset_list_item_thumbnail = resolveComponent("asset-list-item-thumbnail");
  const _component_asset_list_item_detail = resolveComponent("asset-list-item-detail");
  const _component_v_virtual_scroll = resolveComponent("v-virtual-scroll");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_container = resolveComponent("v-container");
  const _component_asset_upload_item = resolveComponent("asset-upload-item");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_router_link = resolveComponent("router-link");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_dialog = resolveComponent("v-dialog");
  const _directive_tooltip = resolveDirective("tooltip");
  const _directive_resize = resolveDirective("resize");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_define_batch_selection, null, {
      default: withCtx(({ entities }) => [
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            withDirectives(createVNode(_component_v_btn, {
              icon: _ctx.$icons.mdiClose,
              onClick: _ctx.selectNone
            }, null, 8, ["icon", "onClick"]), [
              [_directive_tooltip, 'Nichts auswählen', "bottom"]
            ])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_toolbar_title, { class: "ml-0 mr-2" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.selectedEntities.size) + " Asset" + toDisplayString(_ctx.selectedEntities.size > 1 ? "s" : "") + " ausgewählt", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_btn, {
              "prepend-icon": _ctx.$icons.mdiTagMultiple,
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.isBatchTagPaneOpen = true))
            }, {
              default: withCtx(() => _cache[14] || (_cache[14] = [
                createTextVNode("Tags anpassen")
              ])),
              _: 1
            }, 8, ["prepend-icon"]),
            (_ctx.isBatchTagPaneOpen)
              ? (openBlock(), createBlock(_component_property_pane, {
                  key: 0,
                  title: `Tags für ${_ctx.selectedEntities.size} Assets anpassen`,
                  "is-active": "",
                  onCancel: _cache[1] || (_cache[1] = $event => (_ctx.isBatchTagPaneOpen = false)),
                  "initial-value": { tagsToAdd: [], tagsToRemove: [] },
                  onOk: _cache[2] || (_cache[2] = $event => {_ctx.isBatchTagPaneOpen = false;_ctx.tagSelected($event);})
                }, {
                  default: withCtx(({ value, setValue, ok, cancel }) => [
                    (value != null)
                      ? (openBlock(), createBlock(_component_tag_editor_component, {
                          key: 0,
                          kind: "asset",
                          modelValue: value.tagsToAdd,
                          "onUpdate:modelValue": $event => ((value.tagsToAdd) = $event),
                          label: "Diese Tags hinzufügen"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : createCommentVNode("", true),
                    (value != null)
                      ? (openBlock(), createBlock(_component_tag_editor_component, {
                          key: 1,
                          kind: "asset",
                          modelValue: value.tagsToRemove,
                          "onUpdate:modelValue": $event => ((value.tagsToRemove) = $event),
                          label: "Diese Tags entfernen"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : createCommentVNode("", true)
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_v_btn, {
              "prepend-icon": _ctx.$icons.mdiCloudUpload,
              color: "primary",
              onClick: _ctx.publishSelected
            }, {
              default: withCtx(() => _cache[15] || (_cache[15] = [
                createTextVNode("Publizieren")
              ])),
              _: 1
            }, 8, ["prepend-icon", "onClick"])
          ]),
          _: 1
        }),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            createVNode(_component_inline_confirm, {
              component: "v-btn",
              class: "v-btn--contained",
              color: "error",
              onConfirmed: _ctx.deleteSelected
            }, {
              confirm: withCtx(() => _cache[16] || (_cache[16] = [
                createElementVNode("span", null, "Bestätigen", -1)
              ])),
              default: withCtx(() => [
                createVNode(_component_v_icon, { start: "" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.$icons.mdiDelete), 1)
                  ]),
                  _: 1
                }),
                _cache[17] || (_cache[17] = createElementVNode("span", null, "Löschen", -1))
              ]),
              _: 1
            }, 8, ["onConfirmed"])
          ]),
          _: 1
        }),
        createVNode(_component_v_spacer),
        createVNode(_component_v_col, { cols: "auto" }, {
          default: withCtx(() => [
            withDirectives(createVNode(_component_v_btn, {
              icon: _ctx.$icons.mdiSelectAll,
              onClick: $event => (_ctx.selectAll(entities))
            }, null, 8, ["icon", "onClick"]), [
              [_directive_tooltip, 'Alle auswählen', "bottom"]
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_row, {
          "no-gutters": "",
          align: "center",
          justify: "space-between"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_app_bar_title, null, {
              default: withCtx(() => [
                createVNode(_component_v_icon, {
                  class: "mr-3",
                  icon: _ctx.$icons.mdiFolderImage
                }, null, 8, ["icon"]),
                _cache[18] || (_cache[18] = createTextVNode("Assets"))
              ]),
              _: 1
            }),
            createVNode(_component_v_tabs, null, {
              default: withCtx(() => [
                createVNode(_component_v_tab, {
                  exact: "",
                  replace: "",
                  to: { params: { view: 'search' } }
                }, {
                  default: withCtx(() => _cache[19] || (_cache[19] = [
                    createTextVNode("Suche")
                  ])),
                  _: 1
                }),
                createVNode(_component_v_tab, {
                  exact: "",
                  replace: "",
                  to: { params: { view: 'drafts' } }
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_badge, {
                      inline: "",
                      content: _ctx.drafts.length
                    }, {
                      default: withCtx(() => _cache[20] || (_cache[20] = [
                        createTextVNode("Entwürfe ")
                      ])),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tab, {
                  exact: "",
                  replace: "",
                  to: { params: { view: 'recently-changed' } }
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_badge, {
                      inline: "",
                      content: _ctx.recentlyChanged.length
                    }, {
                      default: withCtx(() => _cache[21] || (_cache[21] = [
                        createTextVNode("Zuletzt geändert ")
                      ])),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tab, {
                  exact: "",
                  replace: "",
                  to: { params: { view: 'uploads' } }
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_badge, {
                      inline: "",
                      content: _ctx.uploads.length
                    }, {
                      default: withCtx(() => _cache[22] || (_cache[22] = [
                        createTextVNode("Uploads ")
                      ])),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            createVNode(_component_v_spacer),
            createVNode(_component_v_col, {
              cols: "auto",
              class: "mr-2"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_btn_toggle, {
                  variant: "outlined",
                  modelValue: _ctx.assetStore.listDisplayMode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.assetStore.listDisplayMode) = $event))
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(_component_v_btn, {
                      size: "small",
                      icon: _ctx.$icons.mdiViewGrid,
                      value: "thumbnails"
                    }, null, 8, ["icon"]), [
                      [_directive_tooltip, 'Raster', "bottom"]
                    ]),
                    withDirectives(createVNode(_component_v_btn, {
                      size: "small",
                      icon: _ctx.$icons.mdiViewList,
                      value: "details"
                    }, null, 8, ["icon"]), [
                      [_directive_tooltip, 'Liste', "bottom"]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                createVNode(_component_v_divider, {
                  vertical: "",
                  class: "mr-2"
                }),
                createVNode(_component_v_btn_toggle, {
                  variant: "outlined",
                  modelValue: _ctx.assetStore.thumbnailResizeMode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.assetStore.thumbnailResizeMode) = $event))
                }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(_component_v_btn, {
                      size: "small",
                      icon: _ctx.$icons.mdiCrop,
                      value: "crop"
                    }, null, 8, ["icon"]), [
                      [_directive_tooltip, 'Zugeschnitten', "bottom"]
                    ]),
                    withDirectives(createVNode(_component_v_btn, {
                      size: "small",
                      icon: _ctx.$icons.mdiCropFree,
                      value: "max"
                    }, null, 8, ["icon"]), [
                      [_directive_tooltip, 'Original', "bottom"]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_v_tabs_window, {
      class: "px-4 fill-height",
      onDrop: _ctx.onDrop,
      onDragover: withModifiers(_ctx.onDragOver, ["prevent"]),
      modelValue: _ctx.view,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.view) = $event))
    }, {
      default: withCtx(() => [
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "search"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_row, { class: "h-100" }, {
              default: withCtx(() => [
                createVNode(_component_v_col, {
                  cols: "5",
                  md: "4",
                  lg: "3",
                  class: "fill-height"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "entity-list__filter d-flex flex-column h-100" }, {
                      default: withCtx(() => [
                        createElementVNode("div", _hoisted_1$5, [
                          createVNode(_component_v_text_field, {
                            autofocus: "",
                            "hide-details": "",
                            clearable: "",
                            class: "ml-4",
                            placeholder: "Suchen nach…",
                            autocomplete: "off",
                            "onUpdate:modelValue": [
                              _ctx.updateQueryDebounced,
                              _cache[5] || (_cache[5] = $event => ((_ctx.searchText) = $event))
                            ],
                            modelValue: _ctx.searchText
                          }, null, 8, ["onUpdate:modelValue", "modelValue"]),
                          createVNode(_component_v_select, {
                            class: "ml-4 mt-5",
                            label: "Asset-Typ",
                            "return-object": "",
                            items: _ctx.contentTypeFilters,
                            modelValue: _ctx.selectedContentTypeFilter,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = $event => ((_ctx.selectedContentTypeFilter) = $event)),
                              _ctx.updateQuery
                            ]
                          }, {
                            selection: withCtx(({ item }) => [
                              createTextVNode(toDisplayString(item.title), 1)
                            ]),
                            _: 1
                          }, 8, ["items", "modelValue", "onUpdate:modelValue"])
                        ]),
                        createElementVNode("div", _hoisted_2$2, [
                          createVNode(_component_tag_list, {
                            class: "pr-6",
                            tags: _ctx.tags,
                            modelValue: _ctx.selectedTags,
                            "onUpdate:modelValue": [
                              _cache[7] || (_cache[7] = $event => ((_ctx.selectedTags) = $event)),
                              _ctx.updateQuery
                            ]
                          }, null, 8, ["tags", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                withDirectives((openBlock(), createBlock(_component_v_col, {
                  class: "h-100 flex-dummy-width w-min-0",
                  ref: "scrollContainer"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_loader_wrapper, {
                      state: _ctx.searchState,
                      class: "h-100"
                    }, {
                      empty: withCtx(() => [
                        createVNode(_component_v_row, { class: "pb-16" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, { "align-self": "start" }, {
                              default: withCtx(() => [
                                createVNode(_component_v_empty_state, {
                                  size: "192",
                                  title: "Suche ein bestehendes Asset",
                                  text: "Gib einen Suchbegriff ein oder wähle Tags aus um alle passenden Assets zu sehen",
                                  icon: _ctx.$icons.mdiMagnify
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }),
                            (_ctx.canCreate)
                              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                  createVNode(_component_v_col, { cols: "auto" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_divider, {
                                        vertical: "",
                                        class: "h-100"
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  createVNode(_component_v_col, { "align-self": "start" }, {
                                    default: withCtx(() => [
                                      createVNode(_component_v_empty_state, {
                                        size: "192",
                                        title: "Erstelle ein neues Asset",
                                        text: "Ziehe eine odere mehrere Dateien hierher, um sie hochzuladen.",
                                        icon: _ctx.$icons.mdiImagePlus
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                              : createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      noresults: withCtx(() => [
                        createVNode(_component_v_empty_state, {
                          size: "192",
                          title: "Keine Resultate",
                          icon: _ctx.$icons.mdiDatabaseSearch,
                          class: "mb-16"
                        }, {
                          text: withCtx(() => [
                            (_ctx.searchText)
                              ? (openBlock(), createElementBlock("span", _hoisted_3$2, [
                                  _cache[23] || (_cache[23] = createTextVNode("Mit dem Suchtext ")),
                                  createElementVNode("strong", null, "«" + toDisplayString(_ctx.searchText) + "»", 1)
                                ]))
                              : createCommentVNode("", true),
                            (_ctx.searchText && _ctx.selectedTags.length)
                              ? (openBlock(), createElementBlock("span", _hoisted_4$1, "in Kombination mit den Tags"))
                              : createCommentVNode("", true),
                            (!_ctx.searchText && _ctx.selectedTags.length)
                              ? (openBlock(), createElementBlock("span", _hoisted_5$1, "Mit den Tags"))
                              : createCommentVNode("", true),
                            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedTags, (tag) => {
                              return (openBlock(), createBlock(_component_v_chip, {
                                label: "",
                                density: "compact",
                                class: "mr-1"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(tag), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 256)),
                            (_ctx.selectedContentTypeFilter?.contentTypes.length > 0)
                              ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                                  (!_ctx.searchText && _ctx.selectedTags.length === 0)
                                    ? (openBlock(), createElementBlock("span", _hoisted_6$1, "Mit dem Typ"))
                                    : (openBlock(), createElementBlock("span", _hoisted_7$1, "und dem Typ")),
                                  createVNode(_component_v_chip, {
                                    density: "compact",
                                    variant: "outlined",
                                    "prepend-icon": _ctx.$icons.mdiFileImageOutline,
                                    class: "mr-1"
                                  }, {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString(_ctx.selectedContentTypeFilter.title), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["prepend-icon"])
                                ], 64))
                              : createCommentVNode("", true),
                            _cache[24] || (_cache[24] = createElementVNode("span", null, "wurden keine Assets gefunden.", -1))
                          ]),
                          actions: withCtx(() => [
                            createVNode(_component_v_btn, {
                              class: "mt-3",
                              color: "primary",
                              "prepend-icon": _ctx.$icons.mdiFilterRemove,
                              onClick: _ctx.clearFilter
                            }, {
                              default: withCtx(() => _cache[25] || (_cache[25] = [
                                createTextVNode("Filter löschen")
                              ])),
                              _: 1
                            }, 8, ["prepend-icon", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["icon"])
                      ]),
                      default: withCtx(() => [
                        createVNode(_component_v_card, { class: "d-flex flex-column h-max-100" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_toolbar, {
                              density: "comfortable",
                              color: "surface"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: withCtx(() => [
                                    (_ctx.batchSelectionActive)
                                      ? (openBlock(), createBlock(_component_use_batch_selection, {
                                          key: 0,
                                          entities: _ctx.assets
                                        }, null, 8, ["entities"]))
                                      : (_ctx.searchState === 'results')
                                        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                createVNode(_component_v_toolbar_title, null, {
                                                  default: withCtx(() => [
                                                    _cache[26] || (_cache[26] = createElementVNode("span", { class: "font-weight-regular" }, "Suche nach", -1)),
                                                    _cache[27] || (_cache[27] = createTextVNode()),
                                                    (_ctx.searchText != '')
                                                      ? (openBlock(), createElementBlock("strong", _hoisted_8, "«" + toDisplayString(_ctx.searchText) + "»", 1))
                                                      : createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            (_ctx.selectedContentTypeFilter?.contentTypes.length > 0)
                                              ? (openBlock(), createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "auto"
                                                }, {
                                                  default: withCtx(() => [
                                                    createVNode(_component_v_chip, {
                                                      label: "",
                                                      density: "compact",
                                                      variant: "outlined",
                                                      "prepend-icon": _ctx.$icons.mdiFileImageOutline,
                                                      class: "ml-2"
                                                    }, {
                                                      default: withCtx(() => [
                                                        createTextVNode(toDisplayString(_ctx.selectedContentTypeFilter.title), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["prepend-icon"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : createCommentVNode("", true),
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                createVNode(_component_v_chip_group, {
                                                  multiple: "",
                                                  class: "ml-2"
                                                }, {
                                                  default: withCtx(() => [
                                                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.selectedTags, (tag) => {
                                                      return (openBlock(), createBlock(_component_v_chip, {
                                                        label: "",
                                                        closable: "",
                                                        "onClick:close": $event => (_ctx.deselectTag(tag))
                                                      }, {
                                                        default: withCtx(() => [
                                                          createTextVNode(toDisplayString(tag), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick:close"]))
                                                    }), 256))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            createVNode(_component_v_spacer),
                                            createVNode(_component_v_col, { cols: "auto" }, {
                                              default: withCtx(() => [
                                                withDirectives(createVNode(_component_v_btn, {
                                                  icon: _ctx.$icons.mdiSelectAll,
                                                  onClick: _cache[8] || (_cache[8] = $event => (_ctx.selectAll(_ctx.assets)))
                                                }, null, 8, ["icon"]), [
                                                  [_directive_tooltip, 'Alle auswählen', "bottom"]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ], 64))
                                        : createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_divider),
                            createVNode(_component_v_virtual_scroll, {
                              items: _ctx.virtualScrollItems,
                              "item-height": _ctx.virtualScrollItemHeight,
                              bench: "2",
                              class: normalizeClass(_ctx.assetStore.listDisplayMode === 'thumbnails' ? 'pa-4' : '')
                            }, createSlots({ _: 2 }, [
                              (_ctx.assetStore.listDisplayMode === 'thumbnails')
                                ? {
                                    name: "default",
                                    fn: withCtx(({ item: row }) => [
                                      createElementVNode("div", _hoisted_9, [
                                        createVNode(_component_v_row, { dense: "" }, {
                                          default: withCtx(() => [
                                            (openBlock(true), createElementBlock(Fragment, null, renderList(row, (item) => {
                                              return (openBlock(), createBlock(_component_v_col, { cols: "2" }, {
                                                default: withCtx(() => [
                                                  createVNode(_component_asset_list_item_thumbnail, {
                                                    asset: item,
                                                    showPublishStatus: true,
                                                    isSelected: _ctx.isSelected(item.id),
                                                    onDelete: _ctx.deleteAsset,
                                                    onDuplicate: _ctx.duplicateAsset,
                                                    onReplace: _ctx.replaceAsset,
                                                    onPublish: _ctx.publishAsset,
                                                    onUnpublish: _ctx.unpublishAsset,
                                                    onDiscardDraft: _ctx.discardDraft,
                                                    onOpenEditor: _ctx.openEditor,
                                                    onToggleSelection: _ctx.toggleSelection
                                                  }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 256))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]),
                                    key: "0"
                                  }
                                : undefined,
                              (_ctx.assetStore.listDisplayMode === 'details')
                                ? {
                                    name: "default",
                                    fn: withCtx(({ item, index }) => [
                                      (index > 0)
                                        ? (openBlock(), createBlock(_component_v_divider, {
                                            key: 0,
                                            inset: ""
                                          }))
                                        : createCommentVNode("", true),
                                      createVNode(_component_asset_list_item_detail, {
                                        asset: item,
                                        showPublishStatus: true,
                                        isSelected: _ctx.isSelected(item.id),
                                        onDelete: _ctx.deleteAsset,
                                        onDuplicate: _ctx.duplicateAsset,
                                        onReplace: _ctx.replaceAsset,
                                        onPublish: _ctx.publishAsset,
                                        onUnpublish: _ctx.unpublishAsset,
                                        onDiscardDraft: _ctx.discardDraft,
                                        onOpenEditor: _ctx.openEditor,
                                        onToggleSelection: _ctx.toggleSelection
                                      }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                    ]),
                                    key: "1"
                                  }
                                : undefined
                            ]), 1032, ["items", "item-height", "class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["state"])
                  ]),
                  _: 1
                })), [
                  [_directive_resize, _ctx.onResize]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "drafts"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_container, { class: "h-100 v-container--limited-width" }, {
              default: withCtx(() => [
                createVNode(_component_loader_wrapper, {
                  state: _ctx.draftsState,
                  class: "h-100"
                }, {
                  empty: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Entwürfe vorhanden",
                      text: "Es gibt keine Assets mit Entwurf-Status.",
                      icon: _ctx.$icons.mdiDatabaseSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  noresults: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Entwürfe vorhanden",
                      text: "Es gibt keine Assets mit Entwurf-Status.",
                      icon: _ctx.$icons.mdiDatabaseSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "d-flex flex-column h-max-100" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_toolbar, {
                          density: "comfortable",
                          color: "surface"
                        }, {
                          default: withCtx(() => [
                            (_ctx.batchSelectionActive)
                              ? (openBlock(), createBlock(_component_use_batch_selection, {
                                  key: 0,
                                  entities: _ctx.drafts
                                }, null, 8, ["entities"]))
                              : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                  createVNode(_component_v_spacer),
                                  createVNode(_component_v_col, { cols: "auto" }, {
                                    default: withCtx(() => [
                                      withDirectives(createVNode(_component_v_btn, {
                                        icon: _ctx.$icons.mdiSelectAll,
                                        onClick: _cache[9] || (_cache[9] = $event => (_ctx.selectAll(_ctx.drafts)))
                                      }, null, 8, ["icon"]), [
                                        [_directive_tooltip, 'Alle auswählen', "bottom"]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                          ]),
                          _: 1
                        }),
                        createVNode(_component_v_divider),
                        createElementVNode("div", _hoisted_10, [
                          (_ctx.assetStore.listDisplayMode === 'thumbnails')
                            ? (openBlock(), createBlock(_component_v_row, {
                                key: 0,
                                dense: "",
                                class: "ma-4 align-content-start"
                              }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.drafts, (item) => {
                                    return (openBlock(), createBlock(_component_v_col, { cols: "2" }, {
                                      default: withCtx(() => [
                                        createVNode(_component_asset_list_item_thumbnail, {
                                          asset: item,
                                          showPublishStatus: true,
                                          isSelected: _ctx.isSelected(item.id),
                                          onDelete: _ctx.deleteAsset,
                                          onDuplicate: _ctx.duplicateAsset,
                                          onReplace: _ctx.replaceAsset,
                                          onPublish: _ctx.publishAsset,
                                          onUnpublish: _ctx.unpublishAsset,
                                          onDiscardDraft: _ctx.discardDraft,
                                          onOpenEditor: _ctx.openEditor,
                                          onToggleSelection: _ctx.toggleSelection
                                        }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 256))
                                ]),
                                _: 1
                              }))
                            : createCommentVNode("", true),
                          (_ctx.assetStore.listDisplayMode === 'details')
                            ? (openBlock(), createBlock(_component_v_list, { key: 1 }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.drafts, (item, index) => {
                                    return (openBlock(), createElementBlock(Fragment, null, [
                                      (index > 0)
                                        ? (openBlock(), createBlock(_component_v_divider, {
                                            key: 0,
                                            inset: ""
                                          }))
                                        : createCommentVNode("", true),
                                      createVNode(_component_asset_list_item_detail, {
                                        asset: item,
                                        showPublishStatus: true,
                                        isSelected: _ctx.isSelected(item.id),
                                        onDelete: _ctx.deleteAsset,
                                        onDuplicate: _ctx.duplicateAsset,
                                        onReplace: _ctx.replaceAsset,
                                        onPublish: _ctx.publishAsset,
                                        onUnpublish: _ctx.unpublishAsset,
                                        onDiscardDraft: _ctx.discardDraft,
                                        onOpenEditor: _ctx.openEditor,
                                        onToggleSelection: _ctx.toggleSelection
                                      }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                    ], 64))
                                  }), 256))
                                ]),
                                _: 1
                              }))
                            : createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "recently-changed"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_container, { class: "h-100 v-container--limited-width" }, {
              default: withCtx(() => [
                createVNode(_component_loader_wrapper, {
                  state: _ctx.recentlyChangedState,
                  class: "h-100"
                }, {
                  empty: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Assets vorhanden",
                      icon: _ctx.$icons.mdiDatabaseSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  noresults: withCtx(() => [
                    createVNode(_component_v_empty_state, {
                      size: "192",
                      title: "Keine Assets vorhanden",
                      icon: _ctx.$icons.mdiDatabaseSearch,
                      class: "mb-16"
                    }, null, 8, ["icon"])
                  ]),
                  default: withCtx(() => [
                    createVNode(_component_v_card, { class: "d-flex flex-column h-max-100" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_toolbar, {
                          density: "comfortable",
                          color: "surface"
                        }, {
                          default: withCtx(() => [
                            (_ctx.batchSelectionActive)
                              ? (openBlock(), createBlock(_component_use_batch_selection, {
                                  key: 0,
                                  entities: _ctx.recentlyChanged
                                }, null, 8, ["entities"]))
                              : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                  createVNode(_component_v_spacer),
                                  createVNode(_component_v_col, { cols: "auto" }, {
                                    default: withCtx(() => [
                                      withDirectives(createVNode(_component_v_btn, {
                                        icon: _ctx.$icons.mdiSelectAll,
                                        onClick: _cache[10] || (_cache[10] = $event => (_ctx.selectAll(_ctx.recentlyChanged)))
                                      }, null, 8, ["icon"]), [
                                        [_directive_tooltip, 'Alle auswählen', "bottom"]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ], 64))
                          ]),
                          _: 1
                        }),
                        createVNode(_component_v_divider),
                        createElementVNode("div", _hoisted_11, [
                          (_ctx.assetStore.listDisplayMode === 'thumbnails')
                            ? (openBlock(), createBlock(_component_v_row, {
                                key: 0,
                                dense: "",
                                class: "ma-4 align-content-start"
                              }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.recentlyChanged, (item) => {
                                    return (openBlock(), createBlock(_component_v_col, { cols: "2" }, {
                                      default: withCtx(() => [
                                        createVNode(_component_asset_list_item_thumbnail, {
                                          asset: item,
                                          showPublishStatus: true,
                                          isSelected: _ctx.isSelected(item.id),
                                          onDelete: _ctx.deleteAsset,
                                          onDuplicate: _ctx.duplicateAsset,
                                          onReplace: _ctx.replaceAsset,
                                          onPublish: _ctx.publishAsset,
                                          onUnpublish: _ctx.unpublishAsset,
                                          onDiscardDraft: _ctx.discardDraft,
                                          onOpenEditor: _ctx.openEditor,
                                          onToggleSelection: _ctx.toggleSelection
                                        }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 256))
                                ]),
                                _: 1
                              }))
                            : createCommentVNode("", true),
                          (_ctx.assetStore.listDisplayMode === 'details')
                            ? (openBlock(), createBlock(_component_v_list, { key: 1 }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.recentlyChanged, (item, index) => {
                                    return (openBlock(), createElementBlock(Fragment, null, [
                                      (index > 0)
                                        ? (openBlock(), createBlock(_component_v_divider, {
                                            key: 0,
                                            inset: ""
                                          }))
                                        : createCommentVNode("", true),
                                      createVNode(_component_asset_list_item_detail, {
                                        asset: item,
                                        showPublishStatus: true,
                                        isSelected: _ctx.isSelected(item.id),
                                        onDelete: _ctx.deleteAsset,
                                        onDuplicate: _ctx.duplicateAsset,
                                        onReplace: _ctx.replaceAsset,
                                        onPublish: _ctx.publishAsset,
                                        onUnpublish: _ctx.unpublishAsset,
                                        onDiscardDraft: _ctx.discardDraft,
                                        onOpenEditor: _ctx.openEditor,
                                        onToggleSelection: _ctx.toggleSelection
                                      }, null, 8, ["asset", "isSelected", "onDelete", "onDuplicate", "onReplace", "onPublish", "onUnpublish", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                                    ], 64))
                                  }), 256))
                                ]),
                                _: 1
                              }))
                            : createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["state"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        createVNode(_component_v_tabs_window_item, {
          class: "fill-height",
          value: "uploads"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_12, [
              (_ctx.uploads.length > 0)
                ? (openBlock(), createBlock(_component_v_row, {
                    key: 0,
                    class: "pa-2 ma-0"
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.uploads, (item, index) => {
                        return (openBlock(), createBlock(_component_v_col, {
                          cols: "6",
                          sm: "4",
                          lg: "3",
                          xl: "2"
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_asset_upload_item, {
                              upload: item,
                              isSelected: _ctx.isSelected(item.id),
                              onDiscardDraft: _ctx.discardDraft,
                              onOpenEditor: _ctx.openEditor,
                              onToggleSelection: _ctx.toggleSelection
                            }, null, 8, ["upload", "isSelected", "onDiscardDraft", "onOpenEditor", "onToggleSelection"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 256))
                    ]),
                    _: 1
                  }))
                : (openBlock(), createBlock(_component_v_empty_state, {
                    key: 1,
                    size: "192",
                    title: "Erstelle ein neues Asset",
                    text: "Ziehe eine odere mehrere Dateien hierher, um sie hochzuladen.",
                    icon: _ctx.$icons.mdiImagePlus,
                    class: "pb-16"
                  }, null, 8, ["icon"]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onDrop", "onDragover", "modelValue"]),
    (_ctx.canCreate)
      ? (openBlock(), createBlock(_component_v_fab, {
          key: 0,
          app: "",
          location: "bottom right",
          color: "primary",
          size: "x-large",
          icon: _ctx.$icons.mdiPlus,
          onClick: _ctx.create
        }, null, 8, ["icon", "onClick"]))
      : createCommentVNode("", true),
    createVNode(_component_v_dialog, {
      persistent: "",
      "max-width": 480,
      modelValue: _ctx.deleteInUseConfirmationDialogCallback != null
    }, {
      default: withCtx(() => [
        createVNode(_component_v_card, null, {
          default: withCtx(() => [
            createVNode(_component_v_card_title, { class: "text-h5" }, {
              default: withCtx(() => _cache[28] || (_cache[28] = [
                createTextVNode("Dieses Asset ist in Benutzung")
              ])),
              _: 1
            }),
            createVNode(_component_v_card_text, null, {
              default: withCtx(() => [
                _cache[29] || (_cache[29] = createElementVNode("p", null, "Dieses Asset wird in folgenden Dokumenten verwendet:", -1)),
                createElementVNode("ul", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.deleteInUseReferences, (item) => {
                    return (openBlock(), createElementBlock("li", null, [
                      createVNode(_component_router_link, {
                        to: { name: _ctx.routeNames.Documents.Edit, params: { id: item.id }},
                        target: "_blank"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$formatters.multilingual(item.displayName)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            createVNode(_component_v_card_actions, null, {
              default: withCtx(() => [
                createVNode(_component_v_spacer),
                createVNode(_component_v_btn, {
                  text: "",
                  onClick: _cache[12] || (_cache[12] = $event => (_ctx.deleteInUseConfirmationDialogCallback(false)))
                }, {
                  default: withCtx(() => _cache[30] || (_cache[30] = [
                    createTextVNode("Abbrechen")
                  ])),
                  _: 1
                }),
                createVNode(_component_v_btn, {
                  color: "warning",
                  onClick: _cache[13] || (_cache[13] = $event => (_ctx.deleteInUseConfirmationDialogCallback(true)))
                }, {
                  default: withCtx(() => _cache[31] || (_cache[31] = [
                    createTextVNode("Trotzdem löschen")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}

const _hoisted_1$4 = { class: "d-flex flex-column align-center pb-2" };
const _hoisted_2$1 = { class: "asset-list-item__thumbnail" };
const _hoisted_3$1 = { class: "asset-list-item__companions pa-2" };
const _hoisted_4 = { class: "text-truncate body-2" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "entity-properties" };

function render$c(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_checkbox_btn = resolveComponent("v-checkbox-btn");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_asset_thumbnail = resolveComponent("asset-thumbnail");
  const _component_v_chip = resolveComponent("v-chip");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_hover = resolveComponent("v-hover");
  const _component_v_data_table = resolveComponent("v-data-table");
  const _component_property_pane = resolveComponent("property-pane");
  const _component_entity_references = resolveComponent("entity-references");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_hover, null, {
      default: withCtx(({ isHovering }) => [
        createVNode(_component_v_card, {
          variant: "flat",
          color: "surfaceContainer",
          class: "asset-list-item asset-list-item--thumbnail",
          onClick: _ctx.open,
          onContextmenu: _ctx.onContextMenu,
          onDrop: _ctx.onDrop,
          onDragover: _ctx.onDragOver,
          onDragleave: _ctx.onDragLeave
        }, {
          default: withCtx(() => [
            createVNode(_component_v_overlay, {
              contained: "",
              class: "asset-list-item__drop-overlay align-center justify-center",
              scrim: "primary",
              opacity: 0.85,
              modelValue: _ctx.isDragging
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_1$4, [
                  createVNode(_component_v_icon, {
                    class: "text-onPrimary",
                    size: "64"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$icons.mdiCloudUploadOutline), 1)
                    ]),
                    _: 1
                  }),
                  _cache[12] || (_cache[12] = createElementVNode("div", { class: "text-onPrimary text-h6" }, "Asset ersetzen", -1))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            createVNode(_component_v_sheet, {
              rounded: "lg",
              class: "asset-list-item__batch-selection"
            }, {
              default: withCtx(() => [
                createVNode(_component_v_checkbox_btn, {
                  onClick: withModifiers(_ctx.toggleSelection, ["stop"]),
                  modelValue: _ctx.isSelected
                }, null, 8, ["onClick", "modelValue"])
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_2$1, [
              createVNode(_component_asset_thumbnail, {
                iconSize: 96,
                asset: _ctx.asset,
                showPublishStatus: _ctx.showPublishStatus
              }, null, 8, ["asset", "showPublishStatus"]),
              createElementVNode("div", _hoisted_3$1, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.asset.companions, (companion) => {
                  return (openBlock(), createBlock(_component_v_tooltip, { location: "bottom" }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_chip, mergeProps({
                        label: "",
                        "text-color": "white",
                        "prepend-icon": _ctx.$icons[_ctx.transformIconName(companion.icon)],
                        color: companion.color,
                        ref_for: true
                      }, props), {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(companion.label), 1)
                        ]),
                        _: 2
                      }, 1040, ["prepend-icon", "color"])
                    ]),
                    default: withCtx(() => [
                      createElementVNode("span", null, toDisplayString(companion.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ])
            ]),
            createVNode(_component_v_card_actions, null, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4, toDisplayString(_ctx.name), 1),
                createVNode(_component_v_spacer),
                (!_ctx.isPassive)
                  ? (openBlock(), createBlock(_component_v_menu, {
                      key: 0,
                      absolute: "",
                      target: _ctx.contextMenuX ? [_ctx.contextMenuX, _ctx.contextMenuY] : null,
                      modelValue: _ctx.isContextMenuOpen,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.isContextMenuOpen) = $event))
                    }, {
                      activator: withCtx(({ props }) => [
                        createVNode(_component_v_btn, mergeProps({
                          variant: "text",
                          icon: _ctx.$icons.mdiDotsHorizontal
                        }, props, {
                          onClick: withModifiers(_ctx.openContextMenu, ["stop","prevent"])
                        }), null, 16, ["icon", "onClick"])
                      ]),
                      default: withCtx(() => [
                        createVNode(_component_v_list, null, {
                          default: withCtx(() => [
                            (_ctx.canDelete)
                              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                  (_ctx.asset.hasDraft || _ctx.asset.isDraft)
                                    ? (openBlock(), createBlock(_component_inline_confirm, {
                                        key: 0,
                                        component: "v-list-item",
                                        onConfirmed: _cache[0] || (_cache[0] = $event => (_ctx.discardDraft())),
                                        ref: "discardDraftConfirm"
                                      }, {
                                        confirm: withCtx(() => [
                                          createVNode(_component_v_btn, {
                                            depressed: "",
                                            color: "warning"
                                          }, {
                                            default: withCtx(() => _cache[13] || (_cache[13] = [
                                              createTextVNode("Bestätigen")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        default: withCtx(() => [
                                          (_ctx.asset.hasPublished)
                                            ? (openBlock(), createElementBlock("span", _hoisted_5, "Entwurf verwerfen"))
                                            : (openBlock(), createElementBlock("span", _hoisted_6, "Löschen"))
                                        ]),
                                        _: 1
                                      }, 512))
                                    : createCommentVNode("", true),
                                  (_ctx.asset.hasPublished)
                                    ? (openBlock(), createBlock(_component_inline_confirm, {
                                        key: 1,
                                        component: "v-list-item",
                                        onConfirmed: _cache[1] || (_cache[1] = $event => (_ctx.deleteAsset())),
                                        ref: "deleteConfirm"
                                      }, {
                                        confirm: withCtx(() => [
                                          createVNode(_component_v_btn, {
                                            depressed: "",
                                            color: "warning"
                                          }, {
                                            default: withCtx(() => _cache[14] || (_cache[14] = [
                                              createTextVNode("Bestätigen")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        default: withCtx(() => [
                                          _cache[15] || (_cache[15] = createElementVNode("span", null, "Löschen", -1))
                                        ]),
                                        _: 1
                                      }, 512))
                                    : createCommentVNode("", true)
                                ], 64))
                              : createCommentVNode("", true),
                            (_ctx.canUpdate)
                              ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                  (_ctx.asset.isDraft)
                                    ? (openBlock(), createBlock(_component_v_list_item, {
                                        key: 0,
                                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.publish()))
                                      }, {
                                        default: withCtx(() => _cache[16] || (_cache[16] = [
                                          createTextVNode("Publizieren")
                                        ])),
                                        _: 1
                                      }))
                                    : createCommentVNode("", true),
                                  (!_ctx.asset.isDraft)
                                    ? (openBlock(), createBlock(_component_v_list_item, {
                                        key: 1,
                                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.unpublish()))
                                      }, {
                                        default: withCtx(() => _cache[17] || (_cache[17] = [
                                          createTextVNode("Unpublizieren")
                                        ])),
                                        _: 1
                                      }))
                                    : createCommentVNode("", true)
                                ], 64))
                              : createCommentVNode("", true),
                            (!_ctx.asset.isDraft && _ctx.canDuplicate)
                              ? (openBlock(), createBlock(_component_v_list_item, {
                                  key: 2,
                                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.duplicate()))
                                }, {
                                  default: withCtx(() => _cache[18] || (_cache[18] = [
                                    createTextVNode("Duplizieren")
                                  ])),
                                  _: 1
                                }))
                              : createCommentVNode("", true),
                            (_ctx.canUpdate)
                              ? (openBlock(), createBlock(_component_v_list_item, {
                                  key: 3,
                                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.replace()))
                                }, {
                                  default: withCtx(() => _cache[19] || (_cache[19] = [
                                    createTextVNode("Ersetzen")
                                  ])),
                                  _: 1
                                }))
                              : createCommentVNode("", true),
                            createVNode(_component_v_list_item, {
                              onClick: _cache[6] || (_cache[6] = $event => (_ctx.download()))
                            }, {
                              default: withCtx(() => _cache[20] || (_cache[20] = [
                                createTextVNode("Herunterladen")
                              ])),
                              _: 1
                            }),
                            createVNode(_component_v_list_item, {
                              onClick: _cache[7] || (_cache[7] = $event => (_ctx.showReferences()))
                            }, {
                              default: withCtx(() => _cache[21] || (_cache[21] = [
                                createTextVNode("Referenzen anzeigen")
                              ])),
                              _: 1
                            }),
                            createVNode(_component_v_list_item, {
                              onClick: _cache[8] || (_cache[8] = $event => (_ctx.showProperties()))
                            }, {
                              default: withCtx(() => _cache[22] || (_cache[22] = [
                                createTextVNode("Eigenschaften")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["target", "modelValue"]))
                  : createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick", "onContextmenu", "onDrop", "onDragover", "onDragleave"])
      ]),
      _: 1
    }),
    (_ctx.isPropertiesPanelOpen)
      ? (openBlock(), createBlock(_component_property_pane, {
          key: 0,
          title: "Eigenschaften",
          "is-active": "",
          onCancel: _cache[10] || (_cache[10] = $event => (_ctx.isPropertiesPanelOpen = false))
        }, {
          default: withCtx(({ value, setValue, ok, cancel }) => [
            createElementVNode("div", _hoisted_7, [
              createVNode(_component_v_data_table, {
                "hide-default-header": "",
                "hide-default-footer": "",
                "disable-pagination": "",
                headers: _ctx.propertyHeaders,
                items: _ctx.properties
              }, null, 8, ["headers", "items"])
            ])
          ]),
          actions: withCtx(({ cancel }) => [
            createVNode(_component_v_btn, {
              variant: "elevated",
              color: "primary",
              onClick: cancel
            }, {
              default: withCtx(() => _cache[23] || (_cache[23] = [
                createTextVNode("Schliessen")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }))
      : createCommentVNode("", true),
    (_ctx.isReferencesPanelOpen)
      ? (openBlock(), createBlock(_component_property_pane, {
          key: 1,
          title: "Verweise",
          "is-active": "",
          onCancel: _cache[11] || (_cache[11] = $event => (_ctx.isReferencesPanelOpen = false))
        }, {
          default: withCtx(({ value, setValue, ok, cancel }) => [
            createVNode(_component_entity_references, {
              kind: "asset",
              "entity-id": _ctx.asset.id
            }, null, 8, ["entity-id"])
          ]),
          actions: withCtx(({ cancel }) => [
            createVNode(_component_v_btn, {
              variant: "elevated",
              color: "primary",
              onClick: cancel
            }, {
              default: withCtx(() => _cache[24] || (_cache[24] = [
                createTextVNode("Schliessen")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }))
      : createCommentVNode("", true)
  ], 64))
}

IconRegistry.add({
    mdiCloudUploadOutline,
    mdiDotsHorizontal
});
class AssetListItemThumbnail extends AssetListItem {
}
AssetListItemThumbnail = _([
    Component({
        render: render$c,
        components: {
            AssetThumbnail
        }
    })
], AssetListItemThumbnail);

function render$b(_ctx, _cache) {
  const _component_v_checkbox_btn = resolveComponent("v-checkbox-btn");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_img = resolveComponent("v-img");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_responsive = resolveComponent("v-responsive");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_progress_linear = resolveComponent("v-progress-linear");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createBlock(_component_v_card, { class: "d-flex flex-column justify-space-between asset-upload-item" }, {
    default: withCtx(() => [
      createVNode(_component_v_sheet, {
        rounded: "lg",
        class: "asset-upload-item__batch-selection"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_checkbox_btn, {
            onClick: withModifiers(_ctx.toggleSelection, ["stop"]),
            modelValue: _ctx.isSelected
          }, null, 8, ["onClick", "modelValue"])
        ]),
        _: 1
      }),
      (_ctx.isImage && _ctx.hasPreviewUrl)
        ? (openBlock(), createBlock(_component_v_img, {
            key: 0,
            src: _ctx.upload.objectUrl,
            "aspect-ratio": 3 / 2,
            cover: ""
          }, {
            placeholder: withCtx(() => [
              createVNode(_component_v_row, {
                class: "fill-height ma-0",
                align: "center",
                justify: "center"
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_progress_circular, { indeterminate: "" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["src"]))
        : (openBlock(), createBlock(_component_v_responsive, {
            key: 1,
            "content-class": "p-relative d-flex align-center justify-center",
            "aspect-ratio": 3 / 2
          }, {
            default: withCtx(() => [
              createVNode(_component_v_icon, { size: 48 }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.contentTypeIcon), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      createVNode(_component_v_card_title, null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.upload.fileName), 1)
        ]),
        _: 1
      }),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          (_ctx.state === 'finished')
            ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createVNode(_component_v_btn, {
                  variant: "elevated",
                  "prepend-icon": _ctx.$icons.mdiCloudCheck,
                  color: "primary",
                  onClick: _ctx.openEditor
                }, {
                  default: withCtx(() => _cache[0] || (_cache[0] = [
                    createTextVNode("Titel & Beschreibung eingeben")
                  ])),
                  _: 1
                }, 8, ["prepend-icon", "onClick"]),
                createVNode(_component_v_spacer),
                withDirectives(createVNode(_component_v_btn, {
                  icon: _ctx.$icons.mdiDelete,
                  color: "warning",
                  variant: "tonal",
                  onClick: _ctx.deleteUploadAndAsset
                }, null, 8, ["icon", "onClick"]), [
                  [_directive_tooltip, 'Löschen', "bottom"]
                ])
              ], 64))
            : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createVNode(_component_v_progress_linear, {
                  rounded: "",
                  "rounded-bar": "",
                  class: "ml-2",
                  color: "primary",
                  height: 20,
                  indeterminate: _ctx.state === 'queued',
                  modelValue: _ctx.upload.progressPercentage * 100
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", {
                      class: "text-caption",
                      style: normalizeStyle({ color: `rgb(var(--v-theme-${_ctx.upload.progressPercentage >= 0.47 ? 'onPrimary' : 'onBackground'}))` })
                    }, [
                      (_ctx.state === 'queued')
                        ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                            createTextVNode("In der Warteschlange")
                          ], 64))
                        : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(Math.ceil(_ctx.upload.progressPercentage * 100)) + "%", 1)
                          ], 64))
                    ], 4)
                  ]),
                  _: 1
                }, 8, ["indeterminate", "modelValue"]),
                withDirectives(createVNode(_component_v_btn, {
                  color: "error",
                  icon: _ctx.$icons.mdiStopCircle,
                  disabled: _ctx.state !== 'uploading',
                  onClick: _ctx.cancelUpload
                }, null, 8, ["icon", "disabled", "onClick"]), [
                  [_directive_tooltip, 'Abbrechen', "bottom"]
                ])
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiStopCircle,
    mdiCloudCheck
});
class AssetUploadItem extends Vue {
    get state() {
        return this.upload.state;
    }
    get hasPreviewUrl() {
        return this.upload.objectUrl != null;
    }
    get isImage() {
        return isImageContentType(this.upload.contentType);
    }
    get contentTypeIcon() {
        return getContentTypeIcon(this.upload.contentType);
    }
    deleteUploadAndAsset() {
        let args = {
            id: this.upload.id,
            name: this.upload.fileName
        };
        this.$emit(DiscardDraftEvent, args);
        this.store.removeUpload(this.upload.id);
    }
    openEditor() {
        let args = {
            id: this.upload.id,
            openDraft: true
        };
        this.$emit(OpenEditorEvent, args);
        this.store.removeUpload(this.upload.id);
    }
    cancelUpload() {
        this.store.cancelUpload(this.upload.id);
    }
    toggleSelection() {
        let args = {
            id: this.upload.id,
            isDraft: true
        };
        this.$emit(ToggleSelectionEvent, args);
    }
    constructor(...args){
        super(...args), this.store = new AssetModule();
    }
}
_([
    Prop({
        required: true
    }),
    _$1("design:type", typeof Models === "undefined" || typeof Models.AssetUploadItem === "undefined" ? Object : Models.AssetUploadItem)
], AssetUploadItem.prototype, "upload", void 0);
_([
    Prop({
        default: false
    }),
    _$1("design:type", Boolean)
], AssetUploadItem.prototype, "isSelected", void 0);
AssetUploadItem = _([
    Component({
        render: render$b
    })
], AssetUploadItem);

IconRegistry.add({
    mdiTagMultiple,
    mdiCloudUpload,
    mdiDelete,
    mdiSelectAll,
    mdiSelectOff,
    mdiFileImageOutline,
    mdiViewGrid,
    mdiViewList,
    mdiPlus,
    mdiMagnify,
    mdiImagePlus,
    mdiDatabaseSearch,
    mdiCrop,
    mdiCropFree,
    mdiClose
});
const [DefineBatchSelection, UseBatchSelection] = createReusableTemplate();
const contentTypeFilters = [
    {
        title: "Alle",
        contentTypes: []
    },
    {
        title: "Bild",
        contentTypes: [
            "image/"
        ]
    },
    {
        title: "Video",
        contentTypes: [
            "video/"
        ]
    },
    {
        title: "Audio",
        contentTypes: [
            "audio/"
        ]
    },
    {
        title: "PDF",
        contentTypes: [
            "application/pdf"
        ]
    },
    {
        title: "Word",
        contentTypes: [
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml"
        ]
    },
    {
        title: "Excel",
        contentTypes: [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml"
        ]
    }
];
class AssetList extends Vue {
    get routeNames() {
        return RouteNames;
    }
    get canCreate() {
        return this.configStore.configuration.permissions.assets.canCreateAny;
    }
    get virtualScrollItems() {
        switch(this.assetStore.listDisplayMode){
            case AssetDisplayMode.Details:
                return this.assets;
            case AssetDisplayMode.Thumbnails:
                return Array.from(chunk$1(this.assets, 6));
            default:
                return [];
        }
    }
    get virtualScrollItemHeight() {
        switch(this.assetStore.listDisplayMode){
            case AssetDisplayMode.Details:
                return 108;
            case AssetDisplayMode.Thumbnails:
                let containerPadding = 2 * 16;
                let itemMargin = 2 * 4;
                let itemImageAspectRatio = 3 / 2;
                let itemTextHeight = 64;
                let itemWidth = (this.containerWidth - containerPadding) / 6 - itemMargin;
                return itemWidth / itemImageAspectRatio + itemTextHeight + itemMargin;
            default:
                return 0;
        }
    }
    get uploads() {
        return Object.values(this.assetStore.uploads);
    }
    get tags() {
        return this.assetStore.tags;
    }
    get contentTypeFilters() {
        return contentTypeFilters;
    }
    get selectedContentTypes() {
        return this.selectedContentTypeFilter?.contentTypes ?? [];
    }
    get hasQuery() {
        return !isNullOrEmpty(this.searchText) || this.selectedTags.length !== 0 || this.selectedContentTypes.length !== 0;
    }
    get batchSelectionActive() {
        return this.selectionChangeTrackingProxy > 0 && this.selectedEntities.size > 0;
    }
    created() {
        if (this.uploads.length === 0 && this.view === AssetListView.Uploads) {
            this.$router.replace({
                params: {
                    view: this.settingsStore.defaultAssetListView
                }
            });
        }
        this.onRouteChanged();
        this.assetStore.loadTags();
        this.loadDrafts();
        this.loadRecentlyChanged();
    }
    onResize() {
        this.containerWidth = this.scrollContainer?.$el.clientWidth;
    }
    onRouteChanged() {
        this.selectedTags = parseArrayFromQuery(this.$route.query["t"]);
        this.searchText = this.$route.query["q"] || "";
        let contentTypes = parseArrayFromQuery(this.$route.query["c"]);
        this.selectedContentTypeFilter = contentTypeFilters.find((f)=>contentTypes.every((x)=>f.contentTypes.includes(x))) ?? contentTypeFilters[0];
        this.search();
    }
    async onViewChanged() {
        this.selectNone();
        switch(this.view){
            case "drafts":
                await this.loadDrafts();
                break;
            case "recently-changed":
                await this.loadRecentlyChanged();
                break;
        }
    }
    updateQuery() {
        let query = {
            t: this.selectedTags,
            c: this.selectedContentTypes
        };
        if (!isNullOrEmpty(this.searchText)) {
            query.q = this.searchText;
        }
        this.$router.replace({
            query
        });
    }
    clearFilter() {
        this.$router.replace({
            query: undefined
        });
    }
    deselectTag(tag) {
        let index = this.selectedTags.indexOf(tag);
        if (index > -1) {
            this.selectedTags.splice(index, 1);
        }
        this.updateQuery();
    }
    async search() {
        this.selectNone();
        let params = {
            query: this.searchText,
            tags: this.selectedTags,
            contentTypes: this.selectedContentTypes,
            includeDrafts: true
        };
        if (!this.hasQuery) {
            this.assets = [];
            this.searchState = LoadingState.Empty;
            return;
        }
        try {
            this.searchState = LoadingState.Loading;
            this.assets = await this.service.search(params);
            if (this.assets.length === 0) {
                this.searchState = LoadingState.NoResults;
            } else {
                this.searchState = LoadingState.Results;
            }
        } catch (e) {
            this.notificationService.showError(`Die Liste der Assets konnte nicht geladen werden.`, e);
            this.searchState = LoadingState.Error;
        }
    }
    async loadDrafts() {
        try {
            this.draftsState = LoadingState.Loading;
            this.drafts = await this.service.getDrafts(25);
            this.draftsState = this.drafts.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } catch (e) {
            this.notificationService.showError("Die Entwürfe konnten nicht geladen werden.", e);
            this.draftsState = LoadingState.Error;
        }
    }
    async loadRecentlyChanged() {
        try {
            this.recentlyChangedState = LoadingState.Loading;
            this.recentlyChanged = await this.service.getRecent(DateTime.now().minus({
                days: 90
            }), 25);
            this.recentlyChangedState = this.recentlyChanged.length > 0 ? LoadingState.Results : LoadingState.NoResults;
        } catch (e) {
            this.notificationService.showError("Die zuletzt geänderten Assets konnten nicht geladen werden.", e);
            this.recentlyChangedState = LoadingState.Error;
        }
    }
    async refresh() {
        await this.search();
        await this.loadDrafts();
        await this.loadRecentlyChanged();
    }
    async create() {
        let files = await selectFiles();
        if (files.length > 0) {
            for (let file of files){
                try {
                    this.assetStore.createAndUpload(file);
                } catch (e) {
                    this.notificationService.showError("Das Asset konnte nicht erstellt werden.", e);
                }
            }
            this.$router.replace({
                params: {
                    view: AssetListView.Uploads
                }
            });
        } else {
            this.notificationService.showError("Keine Datei ausgewählt.");
        }
    }
    onDragOver(event) {
        if (!this.canCreate && event.dataTransfer != null) {
            event.dataTransfer.dropEffect = "none";
        }
    }
    async onDrop(event) {
        event.preventDefault();
        if (!this.canCreate) {
            return;
        }
        if (event.dataTransfer?.items != null) {
            let files = Array.from(event.dataTransfer.items).filter((x)=>x.kind === "file").map((x)=>x.getAsFile()).filter(notEmpty$1);
            for (let file of files){
                try {
                    this.assetStore.createAndUpload(file);
                } catch (e) {
                    this.notificationService.showError("Das Asset konnte nicht erstellt werden.", e);
                }
            }
            this.$router.replace({
                params: {
                    view: AssetListView.Uploads
                }
            });
        }
    }
    async openEditor(args) {
        if (this.batchSelectionActive) {
            let asset = this.assets.find((d)=>d.id === args.id);
            if (asset != null) {
                this.toggleSelection({
                    id: args.id,
                    isDraft: asset.isDraft
                });
            }
        } else {
            this.$router.push({
                name: RouteNames.Assets.Edit,
                params: {
                    id: args.id
                }
            });
        }
    }
    async discardDraft(args) {
        try {
            await this.service.discardDraft(args.id);
            if (typeof args.callback === "function") {
                args.callback();
            }
        } catch (e) {
            this.notificationService.showError(`Der Asset-Entwurf <em>${args.name}</em> konnte nicht gelöscht werden.`, e);
        }
        this.refresh();
    }
    async deleteAsset(args) {
        try {
            this.deleteInUseReferences = await this.service.getReferences(args.id);
            if (this.deleteInUseReferences.length > 0) {
                let dialogPromise = await new Promise((resolve)=>{
                    this.deleteInUseConfirmationDialogCallback = resolve;
                });
                if (!dialogPromise) {
                    this.deleteInUseConfirmationDialogCallback = null;
                    return;
                }
            }
            await this.service.delete(args.id);
            this.notificationService.showSuccess(`Das Asset <em>${args.name}</em> wurde gelöscht.`);
        } catch (e) {
            this.notificationService.showError(`Das Asset <em>${args.name}</em> konnte nicht gelöscht werden.`, e);
        } finally{
            this.deleteInUseConfirmationDialogCallback = null;
        }
        this.refresh();
    }
    async duplicateAsset(args) {
        try {
            let response = await this.service.createDuplicate(args.id);
            let targetUrl = this.$router.resolve({
                name: RouteNames.Assets.Edit,
                params: {
                    id: response.id
                }
            }).href;
            this.notificationService.showSuccess(`Das Asset <em>${args.name}</em> wurde dupliziert. <a class="white--text" href="${targetUrl}">Asset öffnen</a>`);
        } catch (e) {
            this.notificationService.showError(`Das Asset <em>${args.name}</em> konnte nicht dupliziert werden.`, e);
        }
        this.refresh();
    }
    async publishAsset(args) {
        try {
            await this.service.publish(args.id);
            this.notificationService.showSuccess(`Das Asset <em>${args.name}</em> wurde publiziert.`);
        } catch (e) {
            this.notificationService.showError(`Das Asset <em>${args.name}</em> konnte nicht publiziert werden.`, e);
        }
        this.refresh();
    }
    async unpublishAsset(args) {
        try {
            await this.service.unpublish(args.id);
            this.notificationService.showSuccess(`Das Asset <em>${args.name}</em> wurde unpubliziert.`);
        } catch (e) {
            this.notificationService.showError(`Das Asset <em>${args.name}</em> konnte nicht unpubliziert werden.`, e);
        }
        this.refresh();
    }
    async replaceAsset(args) {
        try {
            await this.assetStore.replace({
                id: args.id,
                isDraft: args.isDraft,
                file: args.file
            });
            this.notificationService.showSuccess(`Das Asset <em>${args.name}</em> wurde ersetzt.`);
        } catch (e) {
            this.notificationService.showError(`Das Asset <em>${args.name}</em> konnte nicht ersetzt werden.`, e);
        }
        this.refresh();
    }
    toggleSelection(args) {
        if (this.selectedEntities.has(args.id)) {
            this.selectedEntities.delete(args.id);
        } else {
            this.selectedEntities.set(args.id, args);
        }
        this.selectionChangeTrackingProxy++;
    }
    selectAll(entities) {
        for (let asset of entities){
            this.selectedEntities.set(asset.id, {
                id: asset.id,
                isDraft: asset.isDraft
            });
        }
        this.selectionChangeTrackingProxy++;
    }
    selectNone() {
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
    }
    selectAllUploads() {
        for (let upload of this.uploads){
            this.selectedEntities.set(upload.id, {
                id: upload.id,
                isDraft: true
            });
        }
        this.selectionChangeTrackingProxy++;
    }
    isSelected(id) {
        return this.selectionChangeTrackingProxy > 0 && this.selectedEntities.has(id);
    }
    async tagSelected(args) {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.service.batchUpdateTags(ids, args.tagsToAdd, args.tagsToRemove);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Assets wurden getaggt.");
            } else {
                this.notificationService.showError("Einige Assets konnten nicht getaggt werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Taggen der Assets ist ein Fehler aufgetreten.", e);
        }
        await this.assetStore.loadTags();
        this.refresh();
    }
    async deleteSelected() {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.service.batchDelete(ids);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Assets wurden gelöscht.");
                for (let id of this.selectedEntities.keys()){
                    if (this.assetStore.uploads[id] != null) {
                        this.assetStore.removeUpload(id);
                    }
                }
            } else {
                this.notificationService.showError("Einige Assets konnten nicht gelöscht werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Löschen der Assets ist ein Fehler aufgetreten.", e);
        }
        await this.assetStore.loadTags();
        this.refresh();
    }
    async publishSelected() {
        let ids = Array.from(this.selectedEntities.values());
        this.selectedEntities.clear();
        this.selectionChangeTrackingProxy++;
        try {
            this.searchState = LoadingState.Loading;
            let response = await this.service.batchPublish(ids);
            if (response.errors.length === 0) {
                this.notificationService.showSuccess("Alle ausgewählten Assets wurden publiziert.");
                for (let id of this.selectedEntities.keys()){
                    if (this.assetStore.uploads[id] != null) {
                        this.assetStore.removeUpload(id);
                    }
                }
            } else {
                this.notificationService.showError("Einige Assets konnten nicht publiziert werden.", response.errors.join("<br>"));
            }
        } catch (e) {
            this.notificationService.showError("Beim Publizieren der Assets ist ein Fehler aufgetreten.", e);
        }
        await this.assetStore.loadTags();
        this.refresh();
    }
    constructor(...args){
        super(...args), this.assetStore = new AssetModule(), this.configStore = new ConfigurationModule(), this.settingsStore = new SettingsStore(), this.assets = [], this.searchState = LoadingState.Empty, this.containerWidth = 0, this.searchText = "", this.selectedTags = [], this.selectedContentTypeFilter = contentTypeFilters[0], this.selectionChangeTrackingProxy = 1, this.selectedEntities = new Map(), this.batchUpdateTagsToAdd = [], this.batchUpdateTagsToRemove = [], this.isBatchTagPaneOpen = false, this.drafts = [], this.draftsState = LoadingState.Empty, this.recentlyChanged = [], this.recentlyChangedState = LoadingState.Empty, this.deleteInUseReferences = [], this.deleteInUseConfirmationDialogCallback = null, this.updateQueryDebounced = debounce$1(this.updateQuery, 500);
    }
}
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetList.prototype, "service", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetList.prototype, "notificationService", void 0);
_([
    Prop({
        type: String
    }),
    _$1("design:type", typeof Models$2 === "undefined" || typeof AssetListView === "undefined" ? Object : AssetListView)
], AssetList.prototype, "view", void 0);
_([
    Ref(),
    _$1("design:type", typeof ComponentPublicInstance === "undefined" ? Object : ComponentPublicInstance)
], AssetList.prototype, "scrollContainer", void 0);
_([
    Watch(nameof("$route")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], AssetList.prototype, "onRouteChanged", null);
_([
    Watch(nameof("view")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", Promise)
], AssetList.prototype, "onViewChanged", null);
AssetList = _([
    Component({
        render: render$d,
        components: {
            AssetListItemThumbnail,
            AssetListItemDetail,
            AssetUploadItem,
            DefineBatchSelection,
            UseBatchSelection
        }
    })
], AssetList);

function render$a(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_entity_editor = resolveComponent("entity-editor");

  return (openBlock(), createBlock(_component_entity_editor, {
    "active-group": _ctx.activeGroup,
    title: _ctx.title,
    modelValue: _ctx.rootNode,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.hasPendingChanges = true))
  }, createSlots({
    toolbar: withCtx((editor) => [
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.replace()))
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiCloudUpload), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: withCtx(() => [
          _cache[3] || (_cache[3] = createElementVNode("span", null, "Datei ersetzen", -1))
        ]),
        _: 1
      }),
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.download()))
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiCloudDownload), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        default: withCtx(() => [
          _cache[4] || (_cache[4] = createElementVNode("span", null, "Datei herunterladen", -1))
        ]),
        _: 1
      }),
      createVNode(_component_v_divider, {
        vertical: "",
        inset: ""
      }),
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: $event => (editor.undo()),
            disabled: !editor.canUndo
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiUndo), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["onClick", "disabled"])
        ]),
        default: withCtx(() => [
          _cache[5] || (_cache[5] = createElementVNode("span", null, "Rückgängig", -1))
        ]),
        _: 2
      }, 1024),
      createVNode(_component_v_tooltip, { location: "bottom" }, {
        activator: withCtx(({ props }) => [
          createVNode(_component_v_btn, mergeProps(props, {
            icon: "",
            onClick: $event => (editor.redo()),
            disabled: !editor.canRedo
          }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$icons.mdiRedo), 1)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["onClick", "disabled"])
        ]),
        default: withCtx(() => [
          _cache[6] || (_cache[6] = createElementVNode("span", null, "Wiederholen", -1))
        ]),
        _: 2
      }, 1024),
      createVNode(_component_v_divider, {
        vertical: "",
        inset: ""
      }),
      (_ctx.showSaveAndPublish)
        ? (openBlock(), createBlock(_component_v_tooltip, {
            key: 0,
            location: "bottom"
          }, {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_btn, mergeProps({
                icon: "",
                onClick: _ctx.saveDraft,
                loading: _ctx.isSaving
              }, props), {
                default: withCtx(() => [
                  createVNode(_component_v_icon, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$icons.mdiContentSave), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040, ["onClick", "loading"])
            ]),
            default: withCtx(() => [
              _cache[7] || (_cache[7] = createElementVNode("span", null, "Entwurf speichern", -1))
            ]),
            _: 1
          }))
        : createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.showSaveAndPublish)
      ? {
          name: "fab",
          fn: withCtx((editor) => [
            createVNode(_component_v_tooltip, { location: "bottom" }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_fab, mergeProps({
                  absolute: "",
                  offset: "",
                  class: ["flex-grow-0", "mr-4"],
                  location: "bottom right",
                  color: "primary",
                  size: "large",
                  icon: _ctx.$icons.mdiCloudUpload,
                  onClick: _ctx.publish,
                  loading: _ctx.isPublishing
                }, props), null, 16, ["icon", "onClick", "loading"])
              ]),
              default: withCtx(() => [
                _cache[8] || (_cache[8] = createElementVNode("span", null, "Publizieren", -1))
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["active-group", "title", "modelValue"]))
}

IconRegistry.add({
    mdiCloudUpload,
    mdiCloudDownload,
    mdiUndo,
    mdiRedo,
    mdiContentSave
});
class AssetEditor extends Vue {
    onIdChanged() {
        this.load();
    }
    beforeRouteLeave(to, from, next) {
        if (!this.hasPendingChanges) {
            next();
            return;
        }
        if (this.isDraft) {
            this.saveDraft().then((saved)=>{
                if (saved) {
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$confirm({
                title: "Änderungen speichern?",
                textHtml: "Möchten Sie die Änderungen am Asset in einem neuen Entwurf speichern?",
                confirmLabel: "Speichern",
                cancelLabel: "Änderungen verwerfen"
            }).then((save)=>{
                if (save) {
                    this.saveDraft().then((saved)=>{
                        if (saved) {
                            next();
                        } else {
                            next(false);
                        }
                    });
                } else {
                    next();
                }
            });
        }
    }
    mounted() {
        this.load();
    }
    async load() {
        this.loadingState = LoadingState.Loading;
        try {
            let response = await this.service.getDraftOrPublished(this.id);
            await this.setAsset(response);
            this.showSaveAndPublish = response.canUpdate;
            this.showDelete = response.canDelete;
            this.loadingState = LoadingState.Results;
        } catch (e) {
            this.loadingState = LoadingState.Error;
            this.notificationService.showError("Das Asset konnte nicht geöffnet werden.", e);
        }
    }
    async saveDraft() {
        if (this.rootNode == null) {
            return true;
        }
        this.isSaving = true;
        try {
            if (!this.isDraft) {
                // if this is not a draft, we need to create one before saving.
                // we shouldn't get 409 Conflict because we handled the scenario of "draft 
                // already exists but we opened the published doc" before opening the editor
                await this.service.createDraft(this.id);
                this.isDraft = true;
            }
            let response = await this.service.saveDraft(this.id, this.rootNode.model);
            await this.setAsset(response);
            this.hasPendingChanges = false;
            return true;
        } catch (e) {
            this.notificationService.showError("Das Asset konnte nicht gespeichert werden.", e);
            return false;
        } finally{
            this.isSaving = false;
        }
    }
    async publish() {
        if (this.rootNode == null) {
            return;
        }
        this.isPublishing = true;
        try {
            await this.saveDraft();
            await this.service.publish(this.id);
            this.isDraft = false;
        } catch (e) {
            this.notificationService.showError("Das Asset konnte nicht publiziert werden.", e);
        } finally{
            this.isPublishing = false;
        }
    }
    download() {
        if (this.downloadUrl == null) {
            return;
        }
        let anchor = document.createElement("a");
        anchor.href = this.downloadUrl;
        anchor.download = this.downloadFileName;
        anchor.target = "_blank";
        anchor.click();
    }
    async replace() {
        var file = await selectFile();
        if (file) {
            try {
                await this.store.replace({
                    id: this.id,
                    isDraft: this.isDraft,
                    file
                });
            } catch (e) {
                this.notificationService.showError("Das Asset konnte nicht ersetzt werden.", e);
            }
        }
    }
    async setAsset(response) {
        if (this.rootNode != null) {
            // TODO: implement editor re-initialization properly
            // we just deactivate this functionality for now
            return;
        }
        this.downloadUrl = response.url;
        this.downloadFileName = response.fileName;
        this.isDraft = response.asset.isDraft;
        this.rootNode = await this.editorFactory.createRoot(response.schema, response.asset, {
            url: response.url
        });
        this.title = Multilingual.getValue(response.asset.displayName);
    }
    constructor(...args){
        super(...args), this.editorFactory = new EditorFactory(), this.store = new AssetModule(), this.loadingState = LoadingState.Empty, this.hasPendingChanges = false, this.isDraft = true, this.isSaving = false, this.isPublishing = false, this.title = "", this.rootNode = null, this.showDelete = false, this.showSaveAndPublish = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], AssetEditor.prototype, "notificationService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof AssetService === "undefined" ? Object : AssetService)
], AssetEditor.prototype, "service", void 0);
_([
    NonReactive,
    _$1("design:type", typeof EditorFactory === "undefined" ? Object : EditorFactory)
], AssetEditor.prototype, "editorFactory", void 0);
_([
    NonReactive
], AssetEditor.prototype, "store", void 0);
_([
    NonReactive,
    _$1("design:type", String)
], AssetEditor.prototype, "downloadFileName", void 0);
_([
    NonReactive,
    _$1("design:type", String)
], AssetEditor.prototype, "downloadUrl", void 0);
_([
    Prop({
        required: true
    }),
    _$1("design:type", typeof Id === "undefined" ? Object : Id)
], AssetEditor.prototype, "id", void 0);
_([
    Prop(),
    _$1("design:type", String)
], AssetEditor.prototype, "activeGroup", void 0);
_([
    Watch(nameof("id")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], AssetEditor.prototype, "onIdChanged", null);
_([
    Hook("beforeRouteLeave"),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof RouteLocationNormalized === "undefined" ? Object : RouteLocationNormalized,
        typeof RouteLocationNormalizedLoaded === "undefined" ? Object : RouteLocationNormalizedLoaded,
        typeof NavigationGuardNext === "undefined" ? Object : NavigationGuardNext
    ]),
    _$1("design:returntype", void 0)
], AssetEditor.prototype, "beforeRouteLeave", null);
AssetEditor = _([
    Component({
        render: render$a,
        components: {
            EntityEditor
        }
    })
], AssetEditor);

const _hoisted_1$3 = { class: "h-100 pa-2 scroll-panel" };

function render$9(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_role_list_item = resolveComponent("role-list-item");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_create_role = resolveComponent("create-role");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_toolbar_title, { class: "mr-4" }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              class: "mr-3",
              icon: _ctx.$icons.mdiShieldAccount
            }, null, 8, ["icon"]),
            _cache[0] || (_cache[0] = createTextVNode("Rollen & Rechte"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_loader_wrapper, {
      class: "h-100",
      state: _ctx.state
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$3, [
          createVNode(_component_v_row, { class: "pa-2 ma-0" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.roles, (item) => {
                return (openBlock(), createBlock(_component_v_col, {
                  cols: "6",
                  sm: "4",
                  lg: "3",
                  xl: "2"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_role_list_item, {
                      modelValue: item,
                      onDelete: _ctx.deleteRole,
                      onOpenEditor: _ctx.openEditor
                    }, null, 8, ["modelValue", "onDelete", "onOpenEditor"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ]),
        (_ctx.canCreate)
          ? (openBlock(), createBlock(_component_v_menu, {
              key: 0,
              "min-width": 500,
              offset: [-16,-48],
              location: "start",
              activator: "#createRoleButton .v-fab__container",
              "close-on-content-click": false
            }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_fab, mergeProps({
                  app: "",
                  id: "createRoleButton",
                  color: "primary",
                  size: "x-large",
                  icon: _ctx.$icons.mdiPlus
                }, props), null, 16, ["icon"])
              ]),
              default: withCtx(() => [
                createVNode(_component_create_role, { onCreated: _ctx.roleCreated }, null, 8, ["onCreated"])
              ]),
              _: 1
            }))
          : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ], 64))
}

class RoleService extends EntityServiceBase {
    constructor(middlewareFactory, snackbarService, options){
        super(urljoin(options.apiBaseUrl, "roles"), middlewareFactory, snackbarService);
    }
    async getAll() {
        let data = await this.client.get("").json();
        return data.roles;
    }
    async get(roleId) {
        return await this.client.get(roleId).json();
    }
    async create(role) {
        return await this.client.put("", {
            json: role
        }).json();
    }
    async update(roleId, role) {
        return await this.client.post(roleId, {
            json: role
        }).json();
    }
    async invite(roleId, userEmail) {
        let createRequest = {
            userEmail: userEmail
        };
        return await this.client.put(urljoin(roleId, "invitations"), {
            json: createRequest
        }).json();
    }
    async deleteInvitation(roleId, userEmail) {
        await this.client.delete(urljoin(roleId, "invitations", userEmail));
    }
    async delete(roleId) {
        await this.client.delete(roleId);
    }
}
RoleService = _([
    injectable(),
    _$2(2, inject$1("BlucBackendAppOptions")),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof MiddlewareFactory === "undefined" ? Object : MiddlewareFactory,
        typeof NotificationService$1 === "undefined" ? Object : NotificationService$1,
        typeof BlucBackendAppOptions === "undefined" ? Object : BlucBackendAppOptions
    ])
], RoleService);

const _hoisted_1$2 = { class: "flex-grow-1" };

function render$8(_ctx, _cache) {
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_tab = resolveComponent("v-tab");
  const _component_v_tabs = resolveComponent("v-tabs");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_container = resolveComponent("v-container");
  const _component_v_tabs_window_item = resolveComponent("v-tabs-window-item");
  const _component_permission_editor = resolveComponent("permission-editor");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_empty_state = resolveComponent("v-empty-state");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_tabs_window = resolveComponent("v-tabs-window");
  const _component_v_sheet = resolveComponent("v-sheet");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");
  const _directive_tooltip = resolveDirective("tooltip");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      extension: withCtx(() => [
        createElementVNode("div", _hoisted_1$2, [
          createVNode(_component_v_tabs, { "align-tabs": "center" }, {
            default: withCtx(() => [
              createVNode(_component_v_tab, {
                replace: "",
                exact: "",
                value: "general",
                to: { query: { group: 'general' } }
              }, {
                default: withCtx(() => _cache[10] || (_cache[10] = [
                  createTextVNode("Allgemein")
                ])),
                _: 1
              }),
              createVNode(_component_v_tab, {
                replace: "",
                exact: "",
                value: "permissions",
                to: { query: { group: 'permissions' } }
              }, {
                default: withCtx(() => _cache[11] || (_cache[11] = [
                  createTextVNode("Berechtigungen")
                ])),
                _: 1
              }),
              createVNode(_component_v_tab, {
                replace: "",
                exact: "",
                value: "members",
                to: { query: { group: 'members' } }
              }, {
                default: withCtx(() => _cache[12] || (_cache[12] = [
                  createTextVNode("Mitglieder")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_v_divider)
        ]),
        createVNode(_component_v_tooltip, {
          location: "bottom",
          text: "Publizieren"
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_fab, mergeProps({
              absolute: "",
              offset: "",
              class: ["flex-grow-0", "mr-4"],
              location: "bottom right",
              color: "primary",
              size: "large",
              icon: _ctx.$icons.mdiCloudUpload,
              onClick: _ctx.publish,
              loading: _ctx.isPublishing
            }, props), null, 16, ["icon", "onClick", "loading"])
          ]),
          _: 1
        })
      ]),
      default: withCtx(() => [
        createVNode(_component_v_tooltip, {
          location: "bottom",
          text: "Zurück"
        }, {
          activator: withCtx(({ props }) => [
            createVNode(_component_v_btn, mergeProps(props, {
              icon: _ctx.$icons.mdiArrowLeft,
              onClick: _ctx.goBack
            }), null, 16, ["icon", "onClick"])
          ]),
          _: 1
        }),
        createVNode(_component_v_toolbar_title, null, {
          default: withCtx(() => [
            _cache[9] || (_cache[9] = createElementVNode("div", { class: "text-overline text-dense mb-0" }, "Rolle", -1)),
            createTextVNode(" " + toDisplayString(_ctx.role?.name), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_loader_wrapper, {
      class: "h-100",
      state: _ctx.state
    }, {
      default: withCtx(() => [
        createVNode(_component_v_sheet, {
          color: "surface-light",
          class: "h-100"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_tabs_window, {
              class: "h-100",
              modelValue: _ctx.activeGroup,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.activeGroup) = $event))
            }, {
              default: withCtx(() => [
                createVNode(_component_v_tabs_window_item, {
                  class: "h-100",
                  value: "general"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_container, { class: "h-100 v-container--limited-width" }, {
                      default: withCtx(() => [
                        _cache[13] || (_cache[13] = createElementVNode("h2", { class: "editor-base__title" }, "Rollenname", -1)),
                        createVNode(_component_v_text_field, {
                          variant: "solo",
                          modelValue: _ctx.role.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.role.name) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[14] || (_cache[14] = createElementVNode("h2", { class: "editor-base__title" }, "Beschreibung", -1)),
                        createVNode(_component_v_text_field, {
                          variant: "solo",
                          modelValue: _ctx.description,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.description) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tabs_window_item, {
                  class: "scroll-panel h-100",
                  value: "permissions"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_container, null, {
                      default: withCtx(() => [
                        (_ctx.role.permissions.length > 0)
                          ? (openBlock(), createBlock(_component_v_card, {
                              key: 0,
                              lines: "three"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_list, null, {
                                  default: withCtx(() => [
                                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.role.permissions, (permission, i) => {
                                      return (openBlock(), createBlock(_component_v_list_item, null, {
                                        append: withCtx(() => [
                                          createVNode(_component_v_btn, {
                                            class: "ml-4",
                                            variant: "tonal",
                                            icon: _ctx.$icons.mdiDelete,
                                            color: "warning",
                                            onClick: $event => (_ctx.removePermission(permission))
                                          }, null, 8, ["icon", "onClick"])
                                        ]),
                                        default: withCtx(() => [
                                          createVNode(_component_permission_editor, {
                                            modelValue: _ctx.role.permissions[i],
                                            "onUpdate:modelValue": $event => ((_ctx.role.permissions[i]) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 256))
                                  ]),
                                  _: 1
                                }),
                                createVNode(_component_v_card_actions, null, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_btn, {
                                      variant: "tonal",
                                      color: "success",
                                      "prepend-icon": _ctx.$icons.mdiShieldPlus,
                                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.addPermission()))
                                    }, {
                                      default: withCtx(() => _cache[15] || (_cache[15] = [
                                        createTextVNode("Berechtigung hinzufügen")
                                      ])),
                                      _: 1
                                    }, 8, ["prepend-icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (openBlock(), createBlock(_component_v_empty_state, {
                              key: 1,
                              icon: _ctx.$icons.mdiShieldOutline,
                              title: "Diese Rolle definiert noch keine Berechtigungen"
                            }, {
                              actions: withCtx(() => [
                                createVNode(_component_v_btn, {
                                  variant: "tonal",
                                  color: "success",
                                  "prepend-icon": _ctx.$icons.mdiShieldPlus,
                                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.addPermission()))
                                }, {
                                  default: withCtx(() => _cache[16] || (_cache[16] = [
                                    createTextVNode("Berechtigung hinzufügen")
                                  ])),
                                  _: 1
                                }, 8, ["prepend-icon"])
                              ]),
                              _: 1
                            }, 8, ["icon"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_tabs_window_item, {
                  class: "scroll-panel h-100",
                  value: "members"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_container, null, {
                      default: withCtx(() => [
                        createVNode(_component_v_row, null, {
                          default: withCtx(() => [
                            createVNode(_component_v_col, null, {
                              default: withCtx(() => [
                                (_ctx.role.users.length > 0)
                                  ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                      _cache[17] || (_cache[17] = createElementVNode("h2", { class: "ml-4 text-h6" }, "Rollenmitglieder", -1)),
                                      createVNode(_component_v_card, null, {
                                        default: withCtx(() => [
                                          createVNode(_component_v_list, {
                                            activatable: "",
                                            lines: "two"
                                          }, {
                                            default: withCtx(() => [
                                              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.role.users, (user) => {
                                                return (openBlock(), createBlock(_component_v_list_item, {
                                                  title: user.fullName,
                                                  subtitle: user.email
                                                }, {
                                                  append: withCtx(() => [
                                                    withDirectives(createVNode(_component_v_btn, {
                                                      variant: "tonal",
                                                      size: "small",
                                                      color: "warning",
                                                      icon: _ctx.$icons.mdiAccountMinus,
                                                      onClick: $event => (_ctx.removeUser(user))
                                                    }, null, 8, ["icon", "onClick"]), [
                                                      [_directive_tooltip, 'Aus dieser Rolle entfernen', "bottom"]
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["title", "subtitle"]))
                                              }), 256))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : (openBlock(), createBlock(_component_v_empty_state, {
                                      key: 1,
                                      icon: _ctx.$icons.mdiAccountOutline,
                                      title: "Keine Mitglieder in dieser Rolle"
                                    }, null, 8, ["icon"]))
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_col, { cols: "auto" }, {
                              default: withCtx(() => [
                                createVNode(_component_v_divider, {
                                  vertical: "",
                                  class: "h-100"
                                })
                              ]),
                              _: 1
                            }),
                            createVNode(_component_v_col, null, {
                              default: withCtx(() => [
                                (_ctx.role.invitations.length > 0)
                                  ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                      _cache[19] || (_cache[19] = createElementVNode("h2", { class: "ml-4 text-h6" }, "Pendente Einladungen", -1)),
                                      createVNode(_component_v_card, null, {
                                        default: withCtx(() => [
                                          createVNode(_component_v_list, {
                                            class: "mb-2",
                                            activatable: ""
                                          }, {
                                            default: withCtx(() => [
                                              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.role.invitations, (invitation) => {
                                                return (openBlock(), createBlock(_component_v_list_item, {
                                                  title: invitation.userEmail
                                                }, {
                                                  append: withCtx(() => [
                                                    withDirectives(createVNode(_component_v_btn, {
                                                      variant: "tonal",
                                                      size: "small",
                                                      color: "warning",
                                                      icon: _ctx.$icons.mdiDelete,
                                                      onClick: $event => (_ctx.deleteInvitation(invitation)),
                                                      loading: _ctx.isInvitationDeleting
                                                    }, null, 8, ["icon", "onClick", "loading"]), [
                                                      [_directive_tooltip, 'Einladung löschen', "bottom"]
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["title"]))
                                              }), 256))
                                            ]),
                                            _: 1
                                          }),
                                          createVNode(_component_v_card_actions, null, {
                                            default: withCtx(() => [
                                              createVNode(_component_v_text_field, {
                                                class: "mb-1",
                                                label: "E-Mail",
                                                "persistent-hint": "",
                                                hint: "Gib die E-Mail-Adresse der Person ein, die du einladen möchtest. Die Rolle wird ihr bei ihrem nächsten Login zugewiesen.",
                                                error: _ctx.invitationEmailHasError,
                                                loading: _ctx.isInvitationCreating,
                                                "onUpdate:modelValue": [
                                                  _cache[4] || (_cache[4] = $event => (_ctx.invitationEmailHasError = false)),
                                                  _cache[5] || (_cache[5] = $event => ((_ctx.invitationEmail) = $event))
                                                ],
                                                modelValue: _ctx.invitationEmail
                                              }, {
                                                "append-inner": withCtx(() => [
                                                  createVNode(_component_v_btn, {
                                                    variant: "tonal",
                                                    color: "primary",
                                                    "prepend-icon": _ctx.$icons.mdiAccountPlus,
                                                    disabled: _ctx.invitationEmailHasError,
                                                    loading: _ctx.isInvitationCreating,
                                                    onClick: _ctx.createInvitation
                                                  }, {
                                                    default: withCtx(() => _cache[18] || (_cache[18] = [
                                                      createTextVNode("Einladen")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["prepend-icon", "disabled", "loading", "onClick"])
                                                ]),
                                                _: 1
                                              }, 8, ["error", "loading", "modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 64))
                                  : (openBlock(), createBlock(_component_v_empty_state, {
                                      key: 1,
                                      icon: _ctx.$icons.mdiAccountPlusOutline,
                                      title: "Keine pendenten Einladungen"
                                    }, {
                                      actions: withCtx(() => [
                                        createVNode(_component_v_text_field, {
                                          variant: "solo",
                                          type: "email",
                                          label: "E-Mail",
                                          "persistent-hint": "",
                                          hint: "Gib die E-Mail-Adresse der Person ein, die du einladen möchtest. Die Rolle wird ihr bei ihrem nächsten Login zugewiesen.",
                                          error: _ctx.invitationEmailHasError,
                                          loading: _ctx.isInvitationCreating,
                                          "onUpdate:modelValue": [
                                            _cache[6] || (_cache[6] = $event => (_ctx.invitationEmailHasError = false)),
                                            _cache[7] || (_cache[7] = $event => ((_ctx.invitationEmail) = $event))
                                          ],
                                          modelValue: _ctx.invitationEmail
                                        }, {
                                          "append-inner": withCtx(() => [
                                            createVNode(_component_v_btn, {
                                              variant: "tonal",
                                              color: "primary",
                                              "prepend-icon": _ctx.$icons.mdiAccountPlus,
                                              disabled: _ctx.invitationEmailHasError,
                                              loading: _ctx.isInvitationCreating,
                                              onClick: _ctx.createInvitation
                                            }, {
                                              default: withCtx(() => _cache[20] || (_cache[20] = [
                                                createTextVNode("Einladen")
                                              ])),
                                              _: 1
                                            }, 8, ["prepend-icon", "disabled", "loading", "onClick"])
                                          ]),
                                          _: 1
                                        }, 8, ["error", "loading", "modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["icon"]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["state"])
  ], 64))
}

var PermissionMode = /*#__PURE__*/ function(PermissionMode) {
    PermissionMode["Allow"] = "allow";
    PermissionMode["Deny"] = "deny";
    return PermissionMode;
}({});
const ModelTypes = {
    DocumentBase: "Bluc.Models.DocumentBase, Bluc.Models",
    AssetBase: "Bluc.Models.AssetBase, Bluc.Models",
    Menu: "Bluc.Models.Menu, Bluc.Models"
};

function render$7(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_select = resolveComponent("v-select");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_list_subheader = resolveComponent("v-list-subheader");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_img = resolveComponent("v-img");
  const _component_tag_editor_component = resolveComponent("tag-editor-component");
  const _component_v_row = resolveComponent("v-row");

  return (openBlock(), createBlock(_component_v_row, { align: "center" }, {
    default: withCtx(() => [
      createVNode(_component_v_col, { cols: "2" }, {
        default: withCtx(() => [
          createVNode(_component_v_select, {
            "item-props": "",
            "hide-details": "",
            label: "Modus",
            height: 48,
            items: _ctx.modes,
            modelValue: _ctx.selectedMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedMode) = $event))
          }, {
            selection: withCtx(({ item }) => [
              createVNode(_component_v_icon, {
                icon: item.props.prependIcon,
                size: "20",
                class: "mr-2",
                color: item.props.baseColor
              }, null, 8, ["icon", "color"]),
              createElementVNode("span", {
                class: normalizeClass(`text-${item.props.baseColor}`)
              }, toDisplayString(item.props.title), 3)
            ]),
            _: 1
          }, 8, ["items", "modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_col, { cols: "3" }, {
        default: withCtx(() => [
          createVNode(_component_v_select, {
            multiple: "",
            "hide-details": "",
            label: "Aktionen",
            height: 48,
            items: _ctx.operations,
            modelValue: _ctx.selectedOperations,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedOperations) = $event))
          }, null, 8, ["items", "modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_col, { cols: "3" }, {
        default: withCtx(() => [
          createVNode(_component_v_select, {
            "item-props": "",
            "hide-details": "",
            label: "Objekt-Typ",
            height: 48,
            items: _ctx.entityTypes,
            modelValue: _ctx.selectedObjectType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.selectedObjectType) = $event))
          }, {
            item: withCtx(({ item, props }) => [
              (item.props.type === 'divider')
                ? (openBlock(), createBlock(_component_v_divider, normalizeProps(mergeProps({ key: 0 }, props)), null, 16))
                : (item.props.type === 'subheader')
                  ? (openBlock(), createBlock(_component_v_list_subheader, normalizeProps(mergeProps({ key: 1 }, props)), null, 16))
                  : (openBlock(), createBlock(_component_v_list_item, mergeProps({
                      key: 2,
                      "prepend-avatar": item.value.showIcon ? _ctx.getIconUrl(item.value.modelType) : undefined,
                      title: item.title,
                      value: item.value
                    }, props), null, 16, ["prepend-avatar", "title", "value"]))
            ]),
            selection: withCtx(({ item }) => [
              (item.props.value.showIcon)
                ? (openBlock(), createBlock(_component_v_img, {
                    key: 0,
                    class: "mr-2",
                    width: 20,
                    height: 20,
                    src: _ctx.getIconUrl(item.props.value.modelType)
                  }, null, 8, ["src"]))
                : (openBlock(), createBlock(_component_v_icon, {
                    key: 1,
                    class: "mr-2",
                    size: "20",
                    icon: item.props.prependIcon
                  }, null, 8, ["icon"])),
              createElementVNode("span", null, toDisplayString(item.title), 1)
            ]),
            _: 1
          }, 8, ["items", "modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_col, null, {
        default: withCtx(() => [
          createVNode(_component_tag_editor_component, {
            "hide-details": "",
            frameless: "",
            kind: _ctx.selectedEntityKind,
            disabled: _ctx.selectedObjectType == null || _ctx.selectedObjectType.enableTags !== true,
            modelValue: _ctx.tags,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.tags) = $event))
          }, null, 8, ["kind", "disabled", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiPlus,
    mdiDelete,
    mdiShieldPlus,
    mdiAlertCircleOutline,
    mdiDatabaseSearch,
    mdiShieldCheck,
    mdiCancel,
    mdiEyeOutline,
    mdiPencil,
    mdiPlusCircleOutline,
    mdiFolderImage,
    mdiFileTree,
    mdiShieldAccount,
    mdiTextBoxMultiple
});
const allDocuments = {
    title: "Alle Dokument-Typen",
    prependIcon: mdiTextBoxMultiple,
    value: {
        modelType: "Bluc.Models.DocumentBase, Bluc.Models",
        entityKind: EntityKind.Document,
        showIcon: false,
        enableTags: true
    }
};
const allAssets = {
    title: "Alle Asset-Typen",
    prependIcon: mdiFolderImage,
    value: {
        modelType: "Bluc.Models.AssetBase, Bluc.Models",
        entityKind: EntityKind.Asset,
        showIcon: false,
        enableTags: true
    }
};
const menus = {
    title: "Menus",
    prependIcon: mdiFileTree,
    value: {
        modelType: "Bluc.Models.Menu, Bluc.Models",
        showIcon: false
    }
};
const roles = {
    title: "Rollen",
    prependIcon: mdiShieldAccount,
    value: {
        modelType: "Bluc.Models.Authorization.Role, Bluc.Models",
        showIcon: false
    }
};
const operations = [
    {
        title: "Erstellen",
        prependIcon: mdiPlusCircleOutline,
        value: "Create"
    },
    {
        title: "Lesen",
        prependIcon: mdiEyeOutline,
        value: "Read"
    },
    {
        title: "Aktualisieren",
        prependIcon: mdiPencil,
        value: "Update"
    },
    {
        title: "Löschen",
        prependIcon: mdiDelete,
        value: "Delete"
    }
];
const modes = [
    {
        title: "Erlauben",
        prependIcon: mdiShieldPlus,
        baseColor: "success",
        value: PermissionMode.Allow
    },
    {
        title: "Verweigern",
        prependIcon: mdiCancel,
        baseColor: "error",
        value: PermissionMode.Deny
    }
];
class PermissionEditor extends Vue {
    get selectedMode() {
        return this.value.mode;
    }
    set selectedMode(value) {
        this.emitInput({
            mode: value
        });
    }
    get modes() {
        return modes;
    }
    get tags() {
        return this.value.tags ?? [];
    }
    set tags(value) {
        if (value.length === 0) {
            this.emitInput({
                tags: null
            });
        } else {
            this.emitInput({
                tags: value
            });
        }
    }
    get selectedOperations() {
        return this.value.operations;
    }
    set selectedOperations(values) {
        this.emitInput({
            operations: values
        });
    }
    get operations() {
        return operations;
    }
    get entityTypes() {
        let documentTypes = this.documentStore.types.map((t)=>{
            return {
                title: t.title,
                value: {
                    modelType: t.type,
                    entityKind: EntityKind.Document,
                    showIcon: true,
                    enableTags: true
                }
            };
        });
        return [
            {
                type: "subheader",
                title: "Dokumente"
            },
            allDocuments,
            ...documentTypes,
            {
                type: "divider"
            },
            {
                type: "subheader",
                title: "Assets"
            },
            allAssets,
            {
                type: "divider"
            },
            {
                type: "subheader",
                title: "Weitere Objekte"
            },
            menus,
            roles
        ];
    }
    get selectedEntityKind() {
        return this.selectedObjectType?.entityKind ?? EntityKind.Document;
    }
    async created() {
        await this.documentStore.loadTypes();
        this.onValueChanged();
    }
    onValueChanged() {
        let listItem = this.entityTypes.find((x)=>{
            if ("value" in x) {
                return x.value?.modelType === this.value.modelType;
            }
            return false;
        });
        if (listItem != null && "value" in listItem) {
            this.selectedObjectType = listItem.value;
        }
    }
    onSelectedObjectTypeChanged() {
        this.emitInput({
            modelType: this.selectedObjectType.modelType
        });
    }
    getIconUrl(modelType) {
        return getDocumentTypeIconSvg(modelType, 32);
    }
    emitInput(partial) {
        this.$emit("update:modelValue", {
            ...this.value,
            ...partial
        });
    }
    constructor(...args){
        super(...args), this.documentStore = new DocumentModule(), this.selectedObjectType = null;
    }
}
_([
    Model(),
    _$1("design:type", typeof Models === "undefined" || typeof Models.Permission === "undefined" ? Object : Models.Permission)
], PermissionEditor.prototype, "value", void 0);
_([
    Watch(nameof("value")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], PermissionEditor.prototype, "onValueChanged", null);
_([
    Watch(nameof("selectedObjectType")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], PermissionEditor.prototype, "onSelectedObjectTypeChanged", null);
PermissionEditor = _([
    Component({
        render: render$7,
        components: {}
    })
], PermissionEditor);

IconRegistry.add({
    mdiPlus,
    mdiDelete,
    mdiShieldOutline,
    mdiShieldPlus,
    mdiAlertCircleOutline,
    mdiDatabaseSearch,
    mdiShieldCheck,
    mdiCancel,
    mdiAccountMinus,
    mdiContentSave,
    mdiAccountPlus,
    mdiAccountPlusOutline,
    mdiAccountOutline,
    mdiShieldAccount
});
class RoleEditor extends Vue {
    get description() {
        return this.role?.description ?? "";
    }
    set description(value) {
        if (this.role == null) {
            return;
        }
        if (value.length === 0) {
            this.role.description = null;
        } else {
            this.role.description = value;
        }
    }
    onIdChanged() {
        this.load();
    }
    beforeRouteLeave(to, from, next) {
        if (!this.hasPendingChanges) {
            next();
            return;
        }
        this.$confirm({
            title: "Änderungen publizieren?",
            textHtml: `Möchten Sie die Änderungen an der Rolle publizieren?<br />Wenn die Rolle nicht publiziert wird, gehen die Änderungen verloren.`,
            confirmLabel: "Publizieren",
            cancelLabel: "Änderungen verwerfen"
        }).then((save)=>{
            if (save) {
                this.publish().then((_)=>{
                    next();
                });
            } else {
                next();
            }
        });
    }
    onRoleChanged(newValue, oldValue) {
        if (oldValue != null) {
            this.hasPendingChanges = !deepequals(newValue, this.roleInitial);
        }
    }
    async mounted() {
        if (this.activeGroup == null) {
            this.$router.replace({
                query: {
                    group: "general"
                }
            });
        }
        await this.documentStore.loadTypes();
        await this.documentStore.loadTags();
        await this.load();
    }
    async load() {
        if (this.id == null) {
            return;
        }
        this.state = LoadingState.Loading;
        try {
            this.role = await this.roleService.get(this.id);
            this.roleInitial = deepClone(this.role);
            this.state = LoadingState.Results;
        } catch (e) {
            this.notificationService.showError(`Die Rolle konnte nicht geladen werden.`, e);
            this.state = LoadingState.Error;
        }
    }
    async publish() {
        try {
            this.isPublishing = true;
            this.role = await this.roleService.update(this.role.id, {
                name: this.role.name,
                description: this.role.description,
                permissions: this.role.permissions,
                users: this.role.users
            });
        } catch (e) {
            this.notificationService.showError(`Die Rolle konnte nicht publiziert werden.`, e);
        } finally{
            this.isPublishing = false;
        }
    }
    addPermission() {
        this.role.permissions.push({
            mode: PermissionMode.Allow,
            operations: [],
            modelType: "",
            tags: null,
            databaseIds: null
        });
        this.activePermissionIndex = this.role.permissions.length - 1;
    }
    removePermission(permission) {
        let index = this.role.permissions.indexOf(permission);
        if (index === -1) {
            return;
        }
        this.role.permissions.splice(index, 1);
    }
    removeUser(user) {
        let index = this.role.users.indexOf(user);
        if (index === -1) {
            return;
        }
        this.role.users.splice(index, 1);
    }
    async createInvitation() {
        if (this.invitationEmail.length === 0 || !this.invitationEmail.match(/.+\@.+\..+/)) {
            this.invitationEmailHasError = true;
            return;
        }
        try {
            this.isInvitationCreating = true;
            let invitation = await this.roleService.invite(this.role.id, this.invitationEmail);
            this.role.invitations.push(invitation);
            this.invitationEmail = "";
        } catch (e) {
            this.notificationService.showError(`Die E-Mail konnte nicht eingeladen werden.`, e);
        } finally{
            this.isInvitationCreating = false;
        }
    }
    async deleteInvitation(invitation) {
        this.isInvitationDeleting = true;
        await this.roleService.deleteInvitation(this.role.id, invitation.userEmail);
        let index = this.role.invitations.indexOf(invitation);
        if (index !== -1) {
            this.role.invitations.splice(index, 1);
        }
        this.isInvitationDeleting = false;
    }
    getFriendlyModelTypeName(entityType) {
        switch(entityType){
            case ModelTypes.DocumentBase:
                return "alle Dokumente";
            case ModelTypes.AssetBase:
                return "alle Assets";
            case ModelTypes.Menu:
                return "alle Menus";
            default:
                return this.documentStore.types.find((t)=>t.type === entityType)?.title;
        }
    }
    goBack() {
        this.$router.back();
    }
    constructor(...args){
        super(...args), this.documentStore = new DocumentModule(), this.state = LoadingState.Loading, this.activePermissionIndex = -1, this.invitationEmail = "", this.isInvitationCreating = false, this.isInvitationDeleting = false, this.invitationEmailHasError = false, this.roleInitial = null, this.role = null, this.hasPendingChanges = false, this.isPublishing = false;
    }
}
_([
    AutoInject,
    _$1("design:type", typeof RoleService === "undefined" ? Object : RoleService)
], RoleEditor.prototype, "roleService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService === "undefined" ? Object : NotificationService)
], RoleEditor.prototype, "notificationService", void 0);
_([
    Prop(),
    _$1("design:type", String)
], RoleEditor.prototype, "activeGroup", void 0);
_([
    Prop(),
    _$1("design:type", typeof Id === "undefined" ? Object : Id)
], RoleEditor.prototype, "id", void 0);
_([
    Watch(nameof("id")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], RoleEditor.prototype, "onIdChanged", null);
_([
    Hook("beforeRouteLeave"),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof RouteLocationNormalized === "undefined" ? Object : RouteLocationNormalized,
        typeof RouteLocationNormalizedLoaded === "undefined" ? Object : RouteLocationNormalizedLoaded,
        typeof NavigationGuardNext === "undefined" ? Object : NavigationGuardNext
    ]),
    _$1("design:returntype", void 0)
], RoleEditor.prototype, "beforeRouteLeave", null);
_([
    Watch(nameof("role"), {
        deep: true
    }),
    _$1("design:type", Function),
    _$1("design:paramtypes", [
        typeof Models === "undefined" || typeof Models.RoleResponse === "undefined" ? Object : Models.RoleResponse,
        typeof Models === "undefined" || typeof Models.RoleResponse === "undefined" ? Object : Models.RoleResponse
    ]),
    _$1("design:returntype", void 0)
], RoleEditor.prototype, "onRoleChanged", null);
RoleEditor = _([
    Component({
        render: render$8,
        components: {
            PermissionEditor
        }
    })
], RoleEditor);

function render$6(_ctx, _cache) {
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, { class: "d-flex flex-column justify-space-between fill-height" }, {
    default: withCtx(() => [
      createVNode(_component_v_card_title, { class: "mb-2" }, {
        default: withCtx(() => _cache[4] || (_cache[4] = [
          createTextVNode("Neue Rolle")
        ])),
        _: 1
      }),
      createVNode(_component_v_card_text, null, {
        default: withCtx(() => [
          createVNode(_component_v_text_field, {
            class: "mb-4",
            label: "Name",
            "error-messages": _ctx.validator.getErrors('name'),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => (_ctx.validate('name'))),
              _cache[1] || (_cache[1] = $event => ((_ctx.name) = $event))
            ],
            modelValue: _ctx.name
          }, null, 8, ["error-messages", "modelValue"]),
          createVNode(_component_v_text_field, {
            label: "Beschreibung",
            "hide-details": "auto",
            "error-messages": _ctx.validator.getErrors('description'),
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => (_ctx.validate('description'))),
              _cache[3] || (_cache[3] = $event => ((_ctx.description) = $event))
            ],
            modelValue: _ctx.description
          }, null, 8, ["error-messages", "modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          createVNode(_component_v_btn, {
            color: "success",
            "prepend-icon": _ctx.$icons.mdiPlus,
            loading: _ctx.isLoading,
            onClick: _ctx.create
          }, {
            default: withCtx(() => _cache[5] || (_cache[5] = [
              createTextVNode("Erstellen")
            ])),
            _: 1
          }, 8, ["prepend-icon", "loading", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

const validation$1 = create((data, field)=>{
    only$1(field);
    test("name", "Bitte gib einen Namen für die Rolle ein.", ()=>{
        enforce(data.name).isNotEmpty();
    });
});
const RoleCreatedEvent = "created";
class CreateRole extends Vue {
    get createRequest() {
        return {
            name: this.name,
            description: this.description,
            permissions: []
        };
    }
    async create() {
        this.validator = validation$1(this.createRequest);
        if (!this.validator.isValid()) {
            return;
        }
        try {
            this.isLoading = true;
            let newRole = await this.roleService.create(this.createRequest);
            let args = {
                role: newRole
            };
            this.$emit(RoleCreatedEvent, args);
        } catch (e) {
            this.notificationService.showError(`Die Rolle konnte nicht erstellt werden.`, e);
        } finally{
            this.isLoading = false;
        }
    }
    validate(fieldName) {
        this.validator = validation$1(this.createRequest, fieldName);
    }
    constructor(...args){
        super(...args), this.isLoading = false, this.name = "", this.description = "", this.validator = validation$1.get();
    }
}
_([
    AutoInject,
    _$1("design:type", typeof RoleService === "undefined" ? Object : RoleService)
], CreateRole.prototype, "roleService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], CreateRole.prototype, "notificationService", void 0);
CreateRole = _([
    Component({
        render: render$6,
        emits: [
            RoleCreatedEvent
        ]
    })
], CreateRole);

function render$5(_ctx, _cache) {
  const _component_v_img = resolveComponent("v-img");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, {
    class: "d-flex flex-column justify-space-between",
    onClick: _ctx.openEditor
  }, {
    default: withCtx(() => [
      createVNode(_component_v_badge, {
        location: "bottom center",
        content: `${_ctx.value.userCount} Mitglieder`
      }, {
        default: withCtx(() => [
          createVNode(_component_v_img, {
            src: _ctx.getIconUrl(),
            "aspect-ratio": "2",
            contain: ""
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["content"]),
      createVNode(_component_v_card_title, { class: "mt-2 v-card-title--wrap" }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.value.name), 1)
        ]),
        _: 1
      }),
      (_ctx.value.description != null && _ctx.value.description.length > 0)
        ? (openBlock(), createBlock(_component_v_card_text, { key: 0 }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.value.description), 1)
            ]),
            _: 1
          }))
        : createCommentVNode("", true),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          createVNode(_component_v_spacer),
          createVNode(_component_v_menu, {
            "min-width": 150,
            location: "bottom right",
            modelValue: _ctx.isContextMenuOpen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isContextMenuOpen) = $event))
          }, {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_btn, mergeProps({
                icon: _ctx.$icons.mdiDotsHorizontal
              }, props, {
                onClick: withModifiers(_ctx.openContextMenu, ["stop","prevent"])
              }), null, 16, ["icon", "onClick"])
            ]),
            default: withCtx(() => [
              createVNode(_component_v_list, null, {
                default: withCtx(() => [
                  createVNode(_component_inline_confirm, {
                    component: "v-list-item",
                    onConfirmed: _cache[0] || (_cache[0] = $event => (_ctx.deleteMenu())),
                    ref: "deleteConfirm"
                  }, {
                    confirm: withCtx(() => [
                      createVNode(_component_v_btn, {
                        depressed: "",
                        color: "warning"
                      }, {
                        default: withCtx(() => _cache[2] || (_cache[2] = [
                          createTextVNode("Bestätigen")
                        ])),
                        _: 1
                      })
                    ]),
                    default: withCtx(() => [
                      _cache[3] || (_cache[3] = createElementVNode("span", null, "Löschen", -1))
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClick"]))
}

IconRegistry.add({
    mdiDotsHorizontal
});
class RoleListItem extends Vue {
    mounted() {
        eventBus.on(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    beforeDestroy() {
        eventBus.off(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    onEventBusContextMenuOpen(e) {
        if (e.sender !== this) {
            this.isContextMenuOpen = false;
        }
    }
    deleteMenu() {
        let args = {
            id: this.value.id,
            name: this.value.name
        };
        this.$emit(DeleteEvent, args);
    }
    openEditor() {
        let args = {
            id: this.value.id,
            openDraft: false
        };
        this.$emit(OpenEditorEvent, args);
    }
    getIconUrl() {
        return getMenuIconSvg(this.value.name, 128);
    }
    openContextMenu() {
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    onIsContextMenuOpenChanged() {
        if (!this.isContextMenuOpen) {
            this.deleteConfirm?.reset();
        }
    }
    constructor(...args){
        super(...args), this.isContextMenuOpen = false;
    }
}
_([
    Model(),
    _$1("design:type", typeof Models === "undefined" || typeof Models.RoleListItem === "undefined" ? Object : Models.RoleListItem)
], RoleListItem.prototype, "value", void 0);
_([
    Ref(),
    _$1("design:type", typeof InlineConfirm === "undefined" ? Object : InlineConfirm)
], RoleListItem.prototype, "deleteConfirm", void 0);
_([
    Watch(nameof("isContextMenuOpen")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], RoleListItem.prototype, "onIsContextMenuOpenChanged", null);
RoleListItem = _([
    Component({
        render: render$5,
        emits: [
            DeleteEvent,
            OpenEditorEvent,
            OpenContextMenuEvent
        ]
    })
], RoleListItem);

IconRegistry.add({
    mdiPlus,
    mdiDelete,
    mdiShieldPlus,
    mdiAlertCircleOutline,
    mdiDatabaseSearch,
    mdiShieldCheck,
    mdiCancel
});
class RoleList extends Vue {
    canCreate() {
        return this.configurationStore.configuration.permissions.roles.canCreateAny;
    }
    created() {
        this.load();
    }
    async load() {
        try {
            this.state = LoadingState.Loading;
            this.roles = await this.roleService.getAll();
            if (this.roles.length === 0) {
                this.state = LoadingState.Empty;
            } else {
                this.state = LoadingState.Results;
            }
        } catch (e) {
            this.state = LoadingState.Error;
        }
    }
    async deleteRole(args) {
        try {
            this.state = LoadingState.Loading;
            await this.roleService.delete(args.id);
        } catch (e) {
            this.notificationService.showError(`Die Rolle konnte nicht gelöscht werden.`, e);
        } finally{
            this.load();
        }
    }
    async roleCreated(args) {
        this.$router.push({
            name: RouteNames.Roles.Edit,
            params: {
                id: args.role.id
            }
        });
    }
    async openEditor(args) {
        this.$router.push({
            name: RouteNames.Roles.Edit,
            params: {
                id: args.id
            }
        });
    }
    constructor(...args){
        super(...args), this.configurationStore = new ConfigurationModule(), this.state = LoadingState.Loading, this.roles = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof RoleService === "undefined" ? Object : RoleService)
], RoleList.prototype, "roleService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], RoleList.prototype, "notificationService", void 0);
RoleList = _([
    Component({
        render: render$9,
        components: {
            RoleEditor,
            CreateRole,
            RoleListItem
        }
    })
], RoleList);

class ViewFormatters {
    date(value, format) {
        const [datetime, zone] = value.split(" ");
        if (!isNullOrEmpty(zone)) {
            return DateTime.fromISO(datetime, {
                locale: "de",
                zone: zone
            }).toFormat(format);
        } else {
            return DateTime.fromISO(datetime, {
                locale: "de"
            }).toFormat(format);
        }
    }
    round(value, fractionDigits) {
        return value.toFixed(fractionDigits);
    }
    bytes(bytes) {
        return prettyBytes(bytes, {
            locale: "de"
        });
    }
    multilingual(value) {
        return Multilingual.getValue(value);
    }
    expandIso639(value) {
        switch(value){
            case "de":
                return "Deutsch";
            case "en":
                return "Englisch";
            case "fr":
                return "Französisch";
            case "it":
                return "Italienisch";
            default:
                return value;
        }
    }
    entityNameSingular(kind) {
        switch(kind){
            case EntityKind.Document:
                return "Dokument";
            case EntityKind.Asset:
                return "Asset";
        }
    }
    entityNamePlural(kind) {
        switch(kind){
            case EntityKind.Document:
                return "Dokumente";
            case EntityKind.Asset:
                return "Assets";
        }
    }
    static createPlugin() {
        return {
            install: (app)=>{
                app.config.globalProperties.$formatters = new ViewFormatters();
            }
        };
    }
}

const _hoisted_1$1 = { class: "h-100 pa-2 scroll-panel" };

function render$4(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_app_bar_title = resolveComponent("v-app-bar-title");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_menu_list_item = resolveComponent("menu-list-item");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_fab = resolveComponent("v-fab");
  const _component_create_menu = resolveComponent("create-menu");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_loader_wrapper = resolveComponent("loader-wrapper");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_app_bar_title, { class: "mr-4" }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              class: "mr-3",
              icon: _ctx.$icons.mdiFileTree
            }, null, 8, ["icon"]),
            _cache[0] || (_cache[0] = createTextVNode("Menus"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_loader_wrapper, {
      class: "h-100",
      state: _ctx.state
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_1$1, [
          createVNode(_component_v_row, { class: "pa-2 ma-0" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.menus, (item) => {
                return (openBlock(), createBlock(_component_v_col, {
                  cols: "6",
                  sm: "4",
                  lg: "3",
                  xl: "2"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_menu_list_item, {
                      modelValue: item,
                      onDelete: _ctx.deleteMenu,
                      onOpenEditor: _ctx.openEditor
                    }, null, 8, ["modelValue", "onDelete", "onOpenEditor"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ]),
        (_ctx.canCreate)
          ? (openBlock(), createBlock(_component_v_menu, {
              key: 0,
              "min-width": 500,
              offset: [-16,-48],
              location: "start",
              activator: "#createMenuButton .v-fab__container",
              "close-on-content-click": false
            }, {
              activator: withCtx(({ props }) => [
                createVNode(_component_v_fab, mergeProps({
                  app: "",
                  id: "createMenuButton",
                  color: "primary",
                  size: "x-large",
                  icon: _ctx.$icons.mdiPlus
                }, props), null, 16, ["icon"])
              ]),
              default: withCtx(() => [
                createVNode(_component_create_menu, { onCreated: _ctx.menuCreated }, null, 8, ["onCreated"])
              ]),
              _: 1
            }))
          : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ], 64))
}

function render$3(_ctx, _cache) {
  const _component_v_img = resolveComponent("v-img");
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_spacer = resolveComponent("v-spacer");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_inline_confirm = resolveComponent("inline-confirm");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_menu = resolveComponent("v-menu");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, {
    class: "d-flex flex-column justify-space-between",
    onClick: _ctx.openEditor
  }, {
    default: withCtx(() => [
      createVNode(_component_v_img, {
        src: _ctx.getIconUrl(),
        "aspect-ratio": "2",
        contain: ""
      }, null, 8, ["src"]),
      createVNode(_component_v_card_title, null, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.value.displayName), 1)
        ]),
        _: 1
      }),
      createVNode(_component_v_card_text, null, {
        default: withCtx(() => [
          _cache[2] || (_cache[2] = createTextVNode("Systemname: ")),
          createElementVNode("em", null, toDisplayString(_ctx.value.name), 1)
        ]),
        _: 1
      }),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          createVNode(_component_v_spacer),
          createVNode(_component_v_menu, {
            "min-width": 150,
            location: "bottom right",
            modelValue: _ctx.isContextMenuOpen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.isContextMenuOpen) = $event))
          }, {
            activator: withCtx(({ props }) => [
              createVNode(_component_v_btn, mergeProps({
                icon: _ctx.$icons.mdiDotsHorizontal
              }, props, {
                onClick: withModifiers(_ctx.openContextMenu, ["stop","prevent"])
              }), null, 16, ["icon", "onClick"])
            ]),
            default: withCtx(() => [
              createVNode(_component_v_list, null, {
                default: withCtx(() => [
                  createVNode(_component_inline_confirm, {
                    component: "v-list-item",
                    onConfirmed: _cache[0] || (_cache[0] = $event => (_ctx.deleteMenu())),
                    ref: "deleteConfirm"
                  }, {
                    confirm: withCtx(() => [
                      createVNode(_component_v_btn, {
                        depressed: "",
                        color: "warning"
                      }, {
                        default: withCtx(() => _cache[3] || (_cache[3] = [
                          createTextVNode("Bestätigen")
                        ])),
                        _: 1
                      })
                    ]),
                    default: withCtx(() => [
                      _cache[4] || (_cache[4] = createElementVNode("span", null, "Löschen", -1))
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClick"]))
}

IconRegistry.add({
    mdiDotsHorizontal
});
class MenuListItem extends Vue {
    mounted() {
        eventBus.on(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    beforeDestroy() {
        eventBus.off(OpenContextMenuEvent, this.onEventBusContextMenuOpen);
    }
    onEventBusContextMenuOpen(e) {
        if (e.sender !== this) {
            this.isContextMenuOpen = false;
        }
    }
    deleteMenu() {
        let args = {
            id: this.value.name,
            name: this.value.displayName
        };
        this.$emit(DeleteEvent, args);
    }
    openEditor() {
        let args = {
            id: this.value.name,
            openDraft: false
        };
        this.$emit(OpenEditorEvent, args);
    }
    getIconUrl() {
        return getMenuIconSvg(this.value.name, 128);
    }
    openContextMenu() {
        eventBus.emit(OpenContextMenuEvent, {
            sender: this
        });
        this.$nextTick(()=>this.isContextMenuOpen = true);
    }
    onIsContextMenuOpenChanged() {
        if (!this.isContextMenuOpen) {
            this.deleteConfirm?.reset();
        }
    }
    constructor(...args){
        super(...args), this.isContextMenuOpen = false;
    }
}
_([
    Model(),
    _$1("design:type", typeof Models === "undefined" || typeof Models.MenuListItem === "undefined" ? Object : Models.MenuListItem)
], MenuListItem.prototype, "value", void 0);
_([
    Ref(),
    _$1("design:type", typeof InlineConfirm === "undefined" ? Object : InlineConfirm)
], MenuListItem.prototype, "deleteConfirm", void 0);
_([
    Watch(nameof("isContextMenuOpen")),
    _$1("design:type", Function),
    _$1("design:paramtypes", []),
    _$1("design:returntype", void 0)
], MenuListItem.prototype, "onIsContextMenuOpenChanged", null);
MenuListItem = _([
    Component({
        render: render$3,
        emits: [
            DeleteEvent,
            OpenEditorEvent,
            OpenContextMenuEvent
        ]
    })
], MenuListItem);

function render$2(_ctx, _cache) {
  const _component_v_card_title = resolveComponent("v-card-title");
  const _component_v_text_field = resolveComponent("v-text-field");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_card = resolveComponent("v-card");

  return (openBlock(), createBlock(_component_v_card, { class: "d-flex flex-column justify-space-between fill-height" }, {
    default: withCtx(() => [
      createVNode(_component_v_card_title, null, {
        default: withCtx(() => _cache[4] || (_cache[4] = [
          createTextVNode("Neues Menu")
        ])),
        _: 1
      }),
      createVNode(_component_v_card_text, null, {
        default: withCtx(() => [
          createVNode(_component_v_text_field, {
            class: "mb-4",
            label: "Systemname",
            hint: "Nur Buchstaben, Zahlen und -_ sind zulässig.",
            "error-messages": _ctx.validator.getErrors('name'),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => (_ctx.validate('name'))),
              _cache[1] || (_cache[1] = $event => ((_ctx.name) = $event))
            ],
            modelValue: _ctx.name
          }, null, 8, ["error-messages", "modelValue"]),
          createVNode(_component_v_text_field, {
            label: "Anzeigename",
            hint: "Alle Zeichen sind zulässig.",
            "error-messages": _ctx.validator.getErrors('displayName'),
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => (_ctx.validate('displayName'))),
              _cache[3] || (_cache[3] = $event => ((_ctx.displayName) = $event))
            ],
            modelValue: _ctx.displayName
          }, null, 8, ["error-messages", "modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          createVNode(_component_v_btn, {
            color: "success",
            "prepend-icon": _ctx.$icons.mdiPlus,
            loading: _ctx.isLoading,
            onClick: _ctx.create
          }, {
            default: withCtx(() => _cache[5] || (_cache[5] = [
              createTextVNode("Erstellen")
            ])),
            _: 1
          }, 8, ["prepend-icon", "loading", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}

const validation = create((data, field)=>{
    only$1(field);
    test("name", "Bitte gib einen gültigen Systemnamen ein. Nur Buchstaben, Zahlen und -_ sind zulässig.", ()=>{
        enforce(data.name).isNotEmpty().matches(/^[a-zA-Z0-9-_]+$/);
    });
    test("displayName", "Bitte gib einen Anzeigenamen ein.", ()=>{
        enforce(data.displayName).isNotEmpty();
    });
});
const MenuCreatedEvent = "created";
class CreateMenu extends Vue {
    get createRequest() {
        return {
            name: this.name,
            displayName: this.displayName
        };
    }
    async create() {
        this.validator = validation(this.createRequest);
        if (!this.validator.isValid()) {
            return;
        }
        try {
            this.isLoading = true;
            let newMenu = await this.menuService.create(this.createRequest);
            let args = {
                menu: newMenu
            };
            this.$emit(MenuCreatedEvent, args);
        } catch (e) {
            if (e instanceof HTTPError) {
                if (e.response.status === 409) {
                    this.notificationService.showError(`Es existiert bereits ein Menu mit dem Namen "${this.name}".`, e);
                } else {
                    this.notificationService.showError(`Das Menu "${this.name}" konnte nicht erstellt werden.`, e);
                }
            } else {
                throw e;
            }
        } finally{
            this.isLoading = false;
        }
    }
    validate(fieldName) {
        this.validator = validation(this.createRequest, fieldName);
    }
    constructor(...args){
        super(...args), this.isLoading = false, this.name = "", this.displayName = "", this.validator = validation.get();
    }
}
_([
    AutoInject,
    _$1("design:type", typeof MenuService === "undefined" ? Object : MenuService)
], CreateMenu.prototype, "menuService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], CreateMenu.prototype, "notificationService", void 0);
CreateMenu = _([
    Component({
        render: render$2,
        emits: [
            MenuCreatedEvent
        ]
    })
], CreateMenu);

IconRegistry.add({
    mdiPlus,
    mdiDelete,
    mdiFileTree,
    mdiFileTreeOutline,
    mdiPencil,
    mdiDotsHorizontal
});
class MenuList extends Vue {
    get canCreate() {
        return this.configStore.configuration.permissions.menus.canCreateAny;
    }
    mounted() {
        this.load();
    }
    async load() {
        this.state = LoadingState.Loading;
        try {
            this.menus = await this.menuService.list();
            this.state = LoadingState.Results;
        } catch (e) {
            this.state = LoadingState.Error;
            this.notificationService.showError(`Die Liste der Menus konnte nicht geladen werden.`, e);
        }
    }
    async deleteMenu(args) {
        try {
            this.state = LoadingState.Loading;
            await this.menuService.delete(args.id);
        } catch (e) {
            if (e instanceof HTTPError) {
                this.notificationService.showError(`Das Menu "${args.name}" konnte nicht gelöscht werden.`, e);
            } else {
                throw e;
            }
        } finally{
            this.load();
        }
    }
    menuCreated(args) {
        this.$router.push({
            name: RouteNames.Menus.Edit,
            params: {
                name: args.menu.name
            }
        });
    }
    openEditor(args) {
        this.$router.push({
            name: RouteNames.Menus.Edit,
            params: {
                name: args.id
            }
        });
    }
    constructor(...args){
        super(...args), this.configStore = new ConfigurationModule(), this.state = LoadingState.Empty, this.menus = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof MenuService === "undefined" ? Object : MenuService)
], MenuList.prototype, "menuService", void 0);
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], MenuList.prototype, "notificationService", void 0);
MenuList = _([
    Component({
        render: render$4,
        components: {
            MenuListItem,
            MenuEditor,
            CreateMenu
        }
    })
], MenuList);

function render$1(_ctx, _cache) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_app_bar = resolveComponent("v-app-bar");
  const _component_v_radio = resolveComponent("v-radio");
  const _component_v_radio_group = resolveComponent("v-radio-group");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card_text = resolveComponent("v-card-text");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_btn_toggle = resolveComponent("v-btn-toggle");
  const _component_v_container = resolveComponent("v-container");

  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_v_app_bar, { color: "background" }, {
      default: withCtx(() => [
        createVNode(_component_v_toolbar_title, null, {
          default: withCtx(() => [
            createVNode(_component_v_icon, {
              class: "mr-3",
              icon: _ctx.$icons.mdiCog
            }, null, 8, ["icon"]),
            _cache[4] || (_cache[4] = createTextVNode("Einstellungen"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_v_container, {
      fluid: "",
      class: "scroll-panel",
      "fill-height": ""
    }, {
      default: withCtx(() => [
        createVNode(_component_v_container, { class: "v-container--limited-width" }, {
          default: withCtx(() => [
            _cache[13] || (_cache[13] = createElementVNode("h2", { class: "text-h6 mb-2 ml-3" }, "Dokumente", -1)),
            createVNode(_component_v_card, { tile: "" }, {
              default: withCtx(() => [
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_row, { align: "center" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, null, {
                          default: withCtx(() => [
                            _cache[5] || (_cache[5] = createElementVNode("h3", { class: "text-subtitle-2" }, "Ansicht beim Öffnen", -1)),
                            createVNode(_component_v_radio_group, {
                              "hide-details": "",
                              modelValue: _ctx.settings.defaultDocumentListView,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.settings.defaultDocumentListView) = $event))
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_radio, {
                                  label: "Suche",
                                  value: "search"
                                }),
                                createVNode(_component_v_radio, {
                                  label: "Entwürfe",
                                  value: "drafts"
                                }),
                                createVNode(_component_v_radio, {
                                  label: "Zuletzt geändert",
                                  value: "recently-changed"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _cache[14] || (_cache[14] = createElementVNode("h2", { class: "text-h6 mt-8 mb-2 ml-3" }, "Assets", -1)),
            createVNode(_component_v_card, { tile: "" }, {
              default: withCtx(() => [
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_row, { align: "center" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, null, {
                          default: withCtx(() => [
                            _cache[6] || (_cache[6] = createElementVNode("h3", { class: "text-subtitle-2" }, "Ansicht beim Öffnen", -1)),
                            createVNode(_component_v_radio_group, {
                              "hide-details": "",
                              modelValue: _ctx.settings.defaultAssetListView,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.settings.defaultAssetListView) = $event))
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_radio, {
                                  label: "Suche",
                                  value: "search"
                                }),
                                createVNode(_component_v_radio, {
                                  label: "Entwürfe",
                                  value: "drafts"
                                }),
                                createVNode(_component_v_radio, {
                                  label: "Zuletzt geändert",
                                  value: "recently-changed"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_divider),
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_row, { align: "center" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, null, {
                          default: withCtx(() => _cache[7] || (_cache[7] = [
                            createElementVNode("h3", { class: "text-subtitle-2" }, "Ansichtsmodus", -1),
                            createElementVNode("p", null, "Bestimmt die Standardansicht in der Assetübersicht.", -1)
                          ])),
                          _: 1
                        }),
                        createVNode(_component_v_col, { cols: "auto" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_btn_toggle, {
                              variant: "outlined",
                              modelValue: _ctx.settings.defaultAssetListDisplayMode,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.settings.defaultAssetListDisplayMode) = $event))
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_btn, {
                                  "prepend-icon": _ctx.$icons.mdiViewGrid,
                                  value: "thumbnails"
                                }, {
                                  default: withCtx(() => _cache[8] || (_cache[8] = [
                                    createTextVNode("Raster")
                                  ])),
                                  _: 1
                                }, 8, ["prepend-icon"]),
                                createVNode(_component_v_btn, {
                                  "prepend-icon": _ctx.$icons.mdiViewList,
                                  value: "details"
                                }, {
                                  default: withCtx(() => _cache[9] || (_cache[9] = [
                                    createTextVNode("Liste")
                                  ])),
                                  _: 1
                                }, 8, ["prepend-icon"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_v_divider),
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_v_row, { align: "center" }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, null, {
                          default: withCtx(() => _cache[10] || (_cache[10] = [
                            createElementVNode("h3", { class: "text-subtitle-2" }, "Bildansicht", -1),
                            createElementVNode("p", null, "Bestimmt ob Bilder in Assetlisten standardmässig alle auf das gleiche Format (3:2 Quer) zugeschnitten werden.", -1)
                          ])),
                          _: 1
                        }),
                        createVNode(_component_v_col, { cols: "auto" }, {
                          default: withCtx(() => [
                            createVNode(_component_v_btn_toggle, {
                              variant: "outlined",
                              modelValue: _ctx.settings.defaultAssetThumbnailResizeMode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.settings.defaultAssetThumbnailResizeMode) = $event))
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_btn, {
                                  "prepend-icon": _ctx.$icons.mdiCrop,
                                  value: "crop"
                                }, {
                                  default: withCtx(() => _cache[11] || (_cache[11] = [
                                    createTextVNode("Zugeschnitten")
                                  ])),
                                  _: 1
                                }, 8, ["prepend-icon"]),
                                createVNode(_component_v_btn, {
                                  "prepend-icon": _ctx.$icons.mdiCropFree,
                                  value: "max"
                                }, {
                                  default: withCtx(() => _cache[12] || (_cache[12] = [
                                    createTextVNode("Original")
                                  ])),
                                  _: 1
                                }, 8, ["prepend-icon"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _cache[15] || (_cache[15] = createElementVNode("h2", { class: "text-h6 mt-8 mb-2 ml-3" }, "Version", -1)),
            createVNode(_component_v_card, { tile: "" }, {
              default: withCtx(() => [
                createVNode(_component_v_card_text, null, {
                  default: withCtx(() => [
                    createElementVNode("p", null, "Server: " + toDisplayString(_ctx.configurationStore.configuration.serverVersion), 1),
                    createElementVNode("p", null, "Client: " + toDisplayString(_ctx.configurationStore.configuration.clientVersion), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}

IconRegistry.add({
    mdiCog
});
class ConfigurationEditor extends Vue {
    triggererror() {
        this.notificationService.showError("Error", "This is an error message");
    }
    triggersuccess() {
        this.notificationService.showSuccess("Success", "This is a success message");
    }
    constructor(...args){
        super(...args), this.configurationStore = new ConfigurationModule(), this.settings = new SettingsStore();
    }
}
_([
    AutoInject,
    _$1("design:type", typeof NotificationService$1 === "undefined" ? Object : NotificationService$1)
], ConfigurationEditor.prototype, "notificationService", void 0);
ConfigurationEditor = _([
    Component({
        render: render$1
    })
], ConfigurationEditor);

const _hoisted_1 = { class: "d-flex flex-column justify-center align-center" };
const _hoisted_2 = { class: "d-flex flex-column fill-height" };
const _hoisted_3 = ["innerHTML"];

function render(_ctx, _cache) {
  const _component_v_progress_circular = resolveComponent("v-progress-circular");
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_overlay = resolveComponent("v-overlay");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_tooltip = resolveComponent("v-tooltip");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_navigation_drawer = resolveComponent("v-navigation-drawer");
  const _component_router_view = resolveComponent("router-view");
  const _component_v_main = resolveComponent("v-main");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_bottom_navigation = resolveComponent("v-bottom-navigation");
  const _component_portal_target = resolveComponent("portal-target");
  const _component_v_snackbar_queue = resolveComponent("v-snackbar-queue");
  const _component_v_app = resolveComponent("v-app");

  return (openBlock(), createBlock(_component_v_app, null, {
    default: withCtx(() => [
      createVNode(_component_v_overlay, {
        contained: "",
        persistent: "",
        "no-click-animation": "",
        class: "align-center justify-center",
        scrim: "background",
        modelValue: _ctx.state !== 'ready'
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            (_ctx.state === 'loading' || _ctx.state === 'signinPending')
              ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createVNode(_component_v_progress_circular, {
                    size: 50,
                    color: "primary",
                    indeterminate: ""
                  }),
                  _cache[1] || (_cache[1] = createElementVNode("p", { class: "text-h6 mt-4" }, "App wird geladen …", -1))
                ], 64))
              : createCommentVNode("", true),
            (_ctx.state === 'signinFailed')
              ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createVNode(_component_v_icon, {
                    size: "64",
                    color: "error"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$icons.mdiAlertCircleOutline), 1)
                    ]),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = createElementVNode("p", { class: "text-h6 mt-4" }, "Login fehlgeschlagen.", -1))
                ], 64))
              : createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      createVNode(_component_v_navigation_drawer, {
        floating: "",
        rail: "",
        "mobile-breakpoint": 960
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2, [
            createVNode(_component_v_list, { "bg-color": "background" }, {
              default: withCtx(() => [
                createVNode(_component_v_tooltip, {
                  location: "right",
                  text: `Eingeloggt als ${_ctx.authStore.currentUser?.profile.email}`,
                  disabled: _ctx.authStore.currentUser?.profile.email == null
                }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_list_item, mergeProps({
                      "prepend-avatar": _ctx.gravatarUrl,
                      title: _ctx.authStore.currentUser?.profile.email
                    }, props), null, 16, ["prepend-avatar", "title"])
                  ]),
                  _: 1
                }, 8, ["text", "disabled"])
              ]),
              _: 1
            }),
            createVNode(_component_v_list, {
              "bg-color": "background",
              nav: "",
              class: "flex-grow-1"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.routes.filter(r => r.meta.group == null), (route) => {
                  return (openBlock(), createBlock(_component_v_tooltip, {
                    location: "right",
                    text: route.meta.title
                  }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_list_item, mergeProps({
                        color: "white",
                        "prepend-icon": route.meta.iconSvg,
                        title: route.meta.title,
                        to: route.path,
                        ref_for: true
                      }, props), null, 16, ["prepend-icon", "title", "to"])
                    ]),
                    _: 2
                  }, 1032, ["text"]))
                }), 256))
              ]),
              _: 1
            }),
            createVNode(_component_v_list, {
              "bg-color": "background",
              nav: ""
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.routes.filter(r => r.meta.group == 'utils'), (route) => {
                  return (openBlock(), createBlock(_component_v_tooltip, {
                    location: "right",
                    text: route.meta.title
                  }, {
                    activator: withCtx(({ props }) => [
                      createVNode(_component_v_list_item, mergeProps({
                        color: "white",
                        "prepend-icon": route.meta.iconSvg,
                        title: route.meta.title,
                        to: route.path,
                        ref_for: true
                      }, props), null, 16, ["prepend-icon", "title", "to"])
                    ]),
                    _: 2
                  }, 1032, ["text"]))
                }), 256)),
                createVNode(_component_v_tooltip, {
                  location: "right",
                  text: "Logout"
                }, {
                  activator: withCtx(({ props }) => [
                    createVNode(_component_v_list_item, mergeProps({
                      "prepend-icon": _ctx.$icons.mdiLogout,
                      title: "Logout",
                      onClick: _ctx.signout
                    }, props), null, 16, ["prepend-icon", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (_ctx.state === 'ready')
        ? (openBlock(), createBlock(_component_v_main, { key: 0 }, {
            default: withCtx(() => [
              createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : createCommentVNode("", true),
      (_ctx.$vuetify.display.smAndDown)
        ? (openBlock(), createBlock(_component_v_bottom_navigation, {
            key: 1,
            app: ""
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.routes, (route) => {
                return (openBlock(), createBlock(_component_v_btn, {
                  "prepend-icon": route.meta.iconSvg,
                  to: route.path
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(route.meta.title), 1)
                  ]),
                  _: 2
                }, 1032, ["prepend-icon", "to"]))
              }), 256))
            ]),
            _: 1
          }))
        : createCommentVNode("", true),
      createVNode(_component_portal_target, {
        multiple: "",
        name: "property-pane"
      }),
      createVNode(_component_v_snackbar_queue, {
        modelValue: _ctx.notifications,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.notifications) = $event))
      }, {
        text: withCtx(({item}) => [
          createElementVNode("div", {
            innerHTML: item.text
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}

IconRegistry.add({
    mdiMenu,
    mdiTextBoxMultiple,
    mdiFolderMultipleImage,
    mdiFileTree,
    mdiCog,
    mdiPoll,
    mdiAlertCircleOutline,
    mdiLogout
});
const emptyGravatarUrl = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"%3E%3Ctitle%3Eaccount%3C/title%3E%3Cpath fill="%23333" d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" /%3E%3C/svg%3E`;
class App extends Vue {
    get routes() {
        return this.appRoute.children.filter((r)=>{
            if (!r.meta) {
                return false;
            }
            if (typeof r.meta.showInNavigationDrawer === "boolean") {
                return r.meta.showInNavigationDrawer;
            } else if (this.configStore.configuration != null && typeof r.meta.showInNavigationDrawer === "function") {
                return r.meta.showInNavigationDrawer(this.configStore.configuration);
            }
        });
    }
    async mounted() {
        window.addEventListener("beforeunload", this.beforeUnload);
        eventBus.on(ShowSnackbarEvent, this.onNotification);
        if (!this.authStore.isSignedin) {
            this.state = "signinPending";
            try {
                let user = await this.authStore.signinSilent();
                if (user == null) {
                    if (!await this.authStore.signin()) {
                        this.state = "signinFailed";
                    }
                } else {
                    this.state = "ready";
                    this.userManager.events.addUserLoaded((u)=>{
                        this.authStore.setCurrentUser(u);
                    });
                }
            } catch (e) {
                this.state = "signinFailed";
            }
        }
        this.gravatarUrl = await this.authStore.getGravatarUrl() ?? emptyGravatarUrl;
        await this.configStore.loadConfiguration();
    }
    beforeUnmount() {
        eventBus.off(ShowSnackbarEvent, this.onNotification);
        window.removeEventListener("beforeunload", this.beforeUnload);
    }
    beforeUnload(e) {
        if (this.assetStore.activeUploadCount > 0 || this.assetStore.pendingUploadCount > 0) {
            e.preventDefault();
            e.returnValue = true;
        }
    }
    onNotification(args) {
        this.notifications.push({
            color: args.type,
            text: `<p>${args.message}</p>${args.details != null ? `<p>${args.details}</p>` : ""}`,
            timeout: args.type === "error" ? 5000 : 3000,
            location: "left bottom",
            multiLine: args.details != null
        });
    }
    async signout() {
        await this.authStore.signout();
    }
    static create(options) {
        if (isNullOrEmpty(options.apiBaseUrl)) {
            options.apiBaseUrl = "/.bluc/cms-api/";
        }
        if (!options.apiBaseUrl.endsWith("/")) {
            options.apiBaseUrl += "/";
        }
        if (isNullOrEmpty(options.appBasePath)) {
            options.appBasePath = "/admin/";
        }
        if (!options.appBasePath.startsWith("/")) {
            options.appBasePath = "/" + options.appBasePath;
        }
        if (options.appBasePath.endsWith("/")) {
            options.appBasePath = options.appBasePath.slice(0, -1);
        }
        const app = createApp({
            render: ()=>h(RouterView),
            container: container,
            created () {
                EditorFactory.registerEditorsAsComponents(app);
            }
        });
        app.use(vuetify);
        app.use(PortalVue);
        app.use(IconRegistry.createPlugin());
        app.use(ViewFormatters.createPlugin());
        app.use(ConfirmDialog.createPlugin());
        // need to register component here because we're using it without registering it in the editor factory
        app.component(ObjectNullEditor.name, ObjectNullEditor);
        const componentFiles = /* #__PURE__ */ Object.assign({"/src/components/color-picker.ts": __vite_glob_0_0,"/src/components/confirm-dialog.ts": __vite_glob_0_1,"/src/components/entity-references.ts": __vite_glob_0_2,"/src/components/geojson-point-picker.ts": __vite_glob_0_3,"/src/components/id-selector-component.ts": __vite_glob_0_4,"/src/components/index.ts": __vite_glob_0_5,"/src/components/inline-confirm.ts": __vite_glob_0_6,"/src/components/loader-wrapper.ts": __vite_glob_0_7,"/src/components/property-pane.ts": __vite_glob_0_8,"/src/components/publish-status-icon.ts": __vite_glob_0_9,"/src/components/tag-editor-component.ts": __vite_glob_0_10,"/src/components/tag-list.ts": __vite_glob_0_11,"/src/components/tag-selector-component.ts": __vite_glob_0_12,"/src/components/url-picker.ts": __vite_glob_0_13

});
        for (let path of Object.keys(componentFiles)){
            if (path.endsWith("index.ts")) {
                continue;
            }
            let module = componentFiles[path];
            for(let componentName in module){
                app.component(componentName, module[componentName]);
            }
        }
        // we've initialized the members that we've made optional "apiBaseUrl" | "appBasePath" so we can cast safely
        container.bind("BlucBackendAppOptions").toConstantValue(options);
        // auth
        const resolvedBasePath = `${location.protocol}//${location.host}${options.appBasePath}`;
        let userManagerOptions = {
            authority: "",
            client_id: "",
            response_type: "code",
            scope: "openid profile bluc",
            automaticSilentRenew: true,
            filterProtocolClaims: true,
            redirect_uri: `${resolvedBasePath}/auth/signin`,
            silent_redirect_uri: `${resolvedBasePath}/auth/silent-renew`,
            post_logout_redirect_uri: resolvedBasePath
        };
        options.configureAuth(userManagerOptions);
        const userManager = new UserManager(userManagerOptions);
        userManager.events.addAccessTokenExpired(async ()=>{
            // Token can expire while the app is in background
            // -> try a silent renew in that case and otherwise redirect to home
            try {
                await userManager.signinSilent();
            } catch (e) {
                if (isError(e)) {
                    window.location.reload();
                } else {
                    throw e;
                }
            }
        });
        container.bind(UserManager).toConstantValue(userManager);
        // richtext
        const richtextOptions = {
            customElements: [],
            assetSizes: [],
            colors: [],
            formatItems: DefaultFormatItems
        };
        if (options.configureRichtext != null) {
            options.configureRichtext(richtextOptions);
        }
        container.bind("RichtextOptions").toConstantValue(richtextOptions);
        // menus
        const menuOptions = {
            controllers: []
        };
        if (options.configureMenu != null) {
            options.configureMenu(menuOptions);
        }
        container.bind("MenuOptions").toConstantValue(menuOptions);
        // pinia stores
        const pinia = createPinia();
        pinia.use(piniaPluginPersistedstate);
        app.use(pinia);
        const authStore = new AuthenticationModule();
        container.bind(AuthenticationModule).toConstantValue(authStore);
        const settingsStore = new SettingsStore();
        container.bind(SettingsStore).toConstantValue(settingsStore);
        const editorStore = new EditorModule();
        container.bind(EditorModule).toConstantValue(editorStore);
        const documentStore = new DocumentModule();
        container.bind(DocumentModule).toConstantValue(documentStore);
        const assetStore = new AssetModule();
        container.bind(AssetModule).toConstantValue(assetStore);
        assetStore.listDisplayMode = settingsStore.defaultAssetListDisplayMode;
        assetStore.thumbnailResizeMode = settingsStore.defaultAssetThumbnailResizeMode;
        const configStore = new ConfigurationModule();
        container.bind(ConfigurationModule).toConstantValue(configStore);
        const storeOptions = {
            stores: [
                authStore,
                editorStore,
                documentStore,
                assetStore,
                configStore
            ]
        };
        if (options.configureStore != null) {
            options.configureStore(storeOptions);
        }
        // routing
        const documentRoute = {
            path: "/documents",
            name: RouteNames.Documents.Root,
            meta: {
                showInNavigationDrawer: (config)=>config.permissions.documents.canReadSome,
                title: "Dokumente",
                iconSvg: mdiTextBoxMultiple
            },
            component: {
                render: ()=>h(RouterView)
            },
            children: [
                {
                    path: "",
                    name: RouteNames.Documents.ListRedirect,
                    redirect: (_)=>{
                        return {
                            name: RouteNames.Documents.List,
                            params: {
                                view: settingsStore.defaultDocumentListView
                            }
                        };
                    }
                },
                {
                    path: ":view(search|drafts|recently-changed)",
                    name: RouteNames.Documents.List,
                    component: DocumentList,
                    props: (route)=>{
                        return {
                            view: route.params["view"] ?? "search"
                        };
                    }
                },
                {
                    path: "create",
                    name: RouteNames.Documents.Create,
                    component: DocumentCreate
                },
                {
                    path: ":id",
                    name: RouteNames.Documents.Edit,
                    component: DocumentEditor,
                    props: (route)=>{
                        return {
                            id: route.params["id"],
                            activeGroup: route.query["group"]
                        };
                    }
                }
            ]
        };
        const assetRoute = {
            path: "/assets",
            name: RouteNames.Assets.Root,
            meta: {
                showInNavigationDrawer: (config)=>config.permissions.assets.canReadSome,
                title: "Assets",
                iconSvg: mdiFolderMultipleImage
            },
            component: {
                render: ()=>h(RouterView)
            },
            children: [
                {
                    path: "",
                    name: RouteNames.Assets.ListRedirect,
                    redirect: (_)=>{
                        return {
                            name: RouteNames.Assets.List,
                            params: {
                                view: settingsStore.defaultAssetListView
                            }
                        };
                    }
                },
                {
                    path: ":view(search|drafts|recently-changed|uploads)",
                    name: RouteNames.Assets.List,
                    component: AssetList,
                    props: (route)=>{
                        return {
                            view: route.params["view"] ?? "search"
                        };
                    }
                },
                {
                    path: ":id",
                    name: RouteNames.Assets.Edit,
                    component: AssetEditor,
                    props: (route)=>{
                        return {
                            id: route.params["id"],
                            activeGroup: route.query["group"]
                        };
                    }
                }
            ]
        };
        const menuRoute = {
            path: "/menus",
            name: RouteNames.Menus.Root,
            meta: {
                showInNavigationDrawer: (config)=>config.permissions.menus.canReadSome,
                title: "Menus",
                iconSvg: mdiFileTree
            },
            component: {
                render: ()=>h(RouterView)
            },
            children: [
                {
                    path: "",
                    name: RouteNames.Menus.List,
                    component: MenuList
                },
                {
                    path: ":name",
                    name: RouteNames.Menus.Edit,
                    component: MenuEditor,
                    props: true
                }
            ]
        };
        const roleRoute = {
            path: "/roles",
            name: RouteNames.Roles.Root,
            meta: {
                showInNavigationDrawer: (config)=>config.permissions.roles.canReadSome,
                title: "Rollen",
                iconSvg: mdiShieldAccount
            },
            component: {
                render: ()=>h(RouterView)
            },
            children: [
                {
                    path: "",
                    name: RouteNames.Roles.List,
                    component: RoleList
                },
                {
                    path: ":id",
                    name: RouteNames.Roles.Edit,
                    component: RoleEditor,
                    props: (route)=>{
                        return {
                            id: route.params["id"],
                            activeGroup: route.query["group"]
                        };
                    }
                }
            ]
        };
        const analyticsRoute = {
            path: "/analytics",
            name: RouteNames.Analytics.Root,
            meta: {
                showInNavigationDrawer: (config)=>config.appSettings["PlausibleAnalyticsDashboard"] != null,
                title: "Analytics",
                iconSvg: mdiPoll
            },
            component: PlausibleAnalyticsDashboard
        };
        const configRoute = {
            path: "/config",
            name: RouteNames.Config.Edit,
            meta: {
                showInNavigationDrawer: true,
                title: "Einstellungen",
                iconSvg: mdiCog,
                group: "utils"
            },
            component: ConfigurationEditor
        };
        const authRoute = {
            path: "/auth",
            component: {
                render: ()=>h(RouterView)
            },
            children: [
                {
                    path: "signin",
                    component: SigninCallback
                },
                {
                    path: "silent-renew",
                    component: SilentRenewCallback
                }
            ]
        };
        let appRoute = {
            path: "/",
            component: App,
            children: [
                {
                    path: "/",
                    name: RouteNames.Root,
                    redirect: "/documents"
                },
                documentRoute,
                assetRoute,
                menuRoute,
                roleRoute,
                analyticsRoute,
                configRoute
            ]
        };
        if (options.configureRoutes != null) {
            options.configureRoutes(appRoute);
        }
        const router = createRouter({
            history: createWebHistory(options.appBasePath + "/"),
            routes: [
                appRoute,
                authRoute
            ]
        });
        app.use(router);
        container.bind(AppRoute).toConstantValue(appRoute);
        container.bind(MiddlewareFactory).toSelf().inSingletonScope();
        container.bind(DocumentService).toSelf().inSingletonScope();
        container.bind(AssetService).toSelf().inSingletonScope();
        container.bind(MenuService).toSelf().inSingletonScope();
        container.bind(RoleService).toSelf().inSingletonScope();
        container.bind(ConfigurationService).toSelf().inSingletonScope();
        container.bind(NotificationService$1).toSelf().inSingletonScope();
        container.bind(GeocodeService).toSelf().inSingletonScope();
        container.bind(EmbedService).toSelf().inTransientScope();
        container.bind(ValuePoolService).toSelf().inTransientScope();
        container.bind(EditorFactory).toSelf().inTransientScope();
        if (options.configureContainer != null) {
            options.configureContainer(container);
        }
        return app;
    }
    constructor(...args){
        super(...args), this.assetStore = new AssetModule(), this.authStore = new AuthenticationModule(), this.configStore = new ConfigurationModule(), this.appRoute = container.get(AppRoute), this.state = this.authStore.isSignedin ? "ready" : "loading", this.gravatarUrl = emptyGravatarUrl, this.notifications = [];
    }
}
_([
    AutoInject,
    _$1("design:type", typeof UserManager === "undefined" ? Object : UserManager)
], App.prototype, "userManager", void 0);
App = _([
    Component({
        render
    })
], App);

export { App, AppRoute, ArrayEditor, AssetDisplayMode, AssetListView, AssetService, AuthenticationModule, AutoInject, BatchUpdateAction, BooleanEditor, ColorPicker, Configuration, ConfigurationModule, CountryEditor, CreateCustomRichtextNode, CustomElementChangedEvent, CustomNodeViewBase, DataType, DateEditor, DateTimeEditor, DeleteEvent, DiscardDraftEvent, DocumentListView, DocumentService, DuplicateEvent, EditorBase, EditorFactory, EntityEditor, EntityKind, EntityServiceBase, EnumEditor, ExtendedError, GeoJsonPointEditor, GeoJsonPointPicker, HttpHeader, HttpMethod, IconRegistry, IdSelector, IdSelectorComponent, IdSelectorEditor, ImageCropEditor, InlineConfirm$1 as InlineConfirm, IntegerEditor, KeyValueEditor, LoaderWrapper, LoadingState, MenuNodeControllerDataEditor, MiddlewareFactory, Multilingual, MultilingualEditor, NonReactive, NotificationService$1 as NotificationService, NumberEditor, ObjectEditor, ObjectNullEditor, OpenContextMenuEvent, OpenEditorEvent, OpenPaneEvent, PatchEvent, PlausibleAnalyticsDashboard, PropertyPane, PublishEvent, RichtextEditor, RichtextEditorComponent, RouteNames, ShowSnackbarEvent, StringEditor, TagEditor, TagEditorComponent, TagList, TagSelectorComponent, TagSelectorEditor, TextEditor, ThumbnailResizeMode, TimeEditor, TimespanEditor, ToggleSelectionEvent, UneditableNodeView, UnpublishEvent, UploadProgressEvent, UploadState, UrlEditor, UrlPicker, ValuePoolEditor, browserSupportedContentTypes, chunk$1 as chunk, container, delay, eventBus, flattenNodes, getContentTypeIcon, getDocumentTypeIconSvg, getEntityKindDisplayName, getHeadersFromXhr, getMenuIconSvg, getSchemaDescription, getSchemaTitle, isAsset, isAssetListItem, isDocument, isDocumentListItem, isEntityKind, isError, isImageContentType, isNullOrEmpty, isNumeric, isObjectEditorChildExpanded, isSchema, isSchemaArray, isXhrSuccessStatus, nameof, notEmpty$1 as notEmpty, nullWhenEmpty, nullWhenEmptyOrWhitespace, parseArrayFromQuery, selectFile, selectFiles, sha256, sortByOrderedIds, toDictionary };
